(function () {
  'use strict';

  angular
    .module('transacGeslocNet', [
      'LocalStorageModule',
      'ngAnimate',
      'ngTouch',
      'toastr',
      'ngResource',
      'ui.router',
      'angularXml2json',
      'ui.bootstrap',
      'ui.mask',
      'ui.sortable',
      'ui.validate',
      'ncy-angular-breadcrumb',
      'ui.select',
      'ngSanitize',
      'angular-timeline',
      'truncate',
      'uiGmapgoogle-maps',
      'angular.filter',
      'angularFileUpload',
      'sly',
      'textAngular',
      'mwl.calendar',
      'oc.lazyLoad',
      'highcharts-ng',
      'ngDialog',
      'cfp.hotkeys',
      'bootstrapLightbox',
      'wu.masonry',
      'ngCsv',
      'ngIdle'
    ]);
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('tantiemeLot', {
    templateUrl: 'app/components/main-content/modif-bien/lot/tantieme/tantiemeLot/tantiemeLot.html',
    controllerAs: 'tantiemelotctrl',
    bindings: {
      isOpen: '<',
      tantiemeLot: '='
    },
    controller: TantiemeLotController
  });

  /** @ngInject */
  function TantiemeLotController( globalService, $log, $timeout) {
    var ctrl = this;
    this.typeApplication = globalService.getTypeApplication();
    ctrl.ajout = {batiment:"",tantiemeBatiment:0, tantiemeBatimentTotal:0};
    ctrl.batiments = [];
    var initialisation = function() {
      if (ctrl.tantiemeLot) {
        initializeListe();
      } else {
        $timeout(initialisation, 200);
      }
    };
    var initializeListe = function() {
        ctrl.batiments = ctrl.tantiemeLot.batiments;
    };
    ctrl.addTantiemeBat = function() {
        var objectAdd = angular.copy(ctrl.ajout);
        if (!ctrl.tantiemeLot.batiments) {
          ctrl.tantiemeLot.batiments = [];
        }
        ctrl.tantiemeLot.batiments.push(objectAdd);
        initialisation();
        ctrl.ajout = {batiment:"",tantiemeBatiment:0, tantiemeBatimentTotal:0};
        
    };

    ctrl.deleteTantiemeBat = function(tantiemeBat) {
      var index = ctrl.tantiemeLot.batiments.indexOf(tantiemeBat);
      if (index >= 0) {
        ctrl.tantiemeLot.batiments.splice(index, 1);
      }
      initialisation();
    };
    initialisation();
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('tantieme', {
    templateUrl: 'app/components/main-content/modif-bien/lot/tantieme/tantieme.html',
    controllerAs: 'tantiemectrl',
    bindings: {
      lot: '=',
      isOpen: '<',
      tantiemesLot: '='
    },
    controller: TantiemeController
  });

  /** @ngInject */
  function TantiemeController( globalService, $log, $timeout) {
    var ctrl = this;
    this.typeApplication = globalService.getTypeApplication();
    ctrl.ajout = {numeroLot:"",designation:"",tantiemeCommun:0, tantiemeCommunTotal:0,batiments:[]};

    var initialisation = function() {
      if (ctrl.lot) {
        initializeListe();
      } else {
        $timeout(initialisation, 200);
      }
    };

    var initializeListe = function() {

    };

    ctrl.addTantieme = function() {
        var objectAdd = angular.copy(ctrl.ajout);
        if (!ctrl.tantiemesLot) {
          ctrl.tantiemesLot = [];
        }
        ctrl.tantiemesLot.push(objectAdd);
        initializeListe();
        $log.info(ctrl.tantiemesLot);
    };

    ctrl.deleteTantieme = function(cadastre) {
      var index = ctrl.tantiemesLot.indexOf(cadastre);
      if (index >= 0) {
        ctrl.tantiemesLot.splice(index, 1);
      }
      initializeListe();
    };

    initialisation();
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('piece', {
    templateUrl: 'app/components/main-content/modif-bien/lot/piece/piece.html',
    controllerAs: 'piecectrl',
    bindings: {
      lot: '=',
      isOpen: '<',
      pieces: '='
    },
    controller: PieceController
  });

  /** @ngInject */
  function PieceController(ReferencesService, globalService, $log, $timeout) {
    var ctrl = this;
    ctrl.typeApplication = globalService.getTypeApplication();
    ctrl.query = {
      typeBien: 'Appartement',
      typeApplication: ctrl.typeApplication
    };
    ctrl.ajout = { type: null };
    ctrl.modification = false;
    ctrl.parEtage = [];
    ctrl.refType = [];
    ctrl.queryReference = {
      classes: 'RefTypePiece',
      typeApplication: ctrl.typeApplication
    };

    var initialisation = function() {
      if (ctrl.lot) {
        getReference();
        initializeListe();
      } else {
        $timeout(initialisation, 200);
      }
    };

    var getReference = function() {
      ReferencesService.getReferences(ctrl.queryReference).then(function(json) {
        if (json.status === 'OK') {
          ctrl.references = json.list;
          ctrl.types = { liste: json.list.RefTypePiece };
        }
      });
    };

    var initializeListe = function() {
      ctrl.parEtage = [];
      var listePiece = {};
      angular.forEach(ctrl.pieces, function(p) {
        if (listePiece.hasOwnProperty(p.etage)) {
          var grPieceFind = listePiece[p.etage];
          grPieceFind.pieces.push(p);
        } else {
          var grPiece = {
            libelleEtage: 'Etage ' + p.etage,
            numeroEtage: p.etage,
            pieces: []
          };
          grPiece.pieces.push(p);
          listePiece[p.etage] = grPiece;
        }
      });
      angular.forEach(listePiece, function(eve) {
        ctrl.parEtage.push(eve);
      });
    };

    function verificationEnvoie(ajoutpiece) {
      $log.info(ajoutpiece);
      return !(
        angular.isDefined(ajoutpiece.$error) &&
        angular.isDefined(ajoutpiece.$error.required) &&
        ajoutpiece.$error.required.length > 0
      );
    }

    ctrl.addPiece = function(ajoutpiece) {
      if (verificationEnvoie(ajoutpiece)) {
        if (!ctrl.modification) {
          var objectAdd = angular.copy(ctrl.ajout);
          ctrl.pieces.push(objectAdd);
        }
        ctrl.ajout = { type: null };
        ctrl.modification = false;
        initializeListe();
        ajoutpiece.$setPristine();
      } else {
        $log.info('Non Valide');
      }
    };

    ctrl.deletePiece = function(piece) {
      var index = ctrl.pieces.indexOf(piece);
      if (index >= 0) {
        ctrl.pieces.splice(index, 1);
      }
      initializeListe();
    };
    ctrl.modifierPiece = function(piece) {
      ctrl.ajout = piece;
      ctrl.modification = true;
    };
    ctrl.calculSurface = function() {
      $log.info(ctrl.ajout);
      if (ctrl.ajout.longueur > 0 && ctrl.ajout.largeur > 0) {
        ctrl.ajout.surface = ctrl.ajout.longueur * ctrl.ajout.largeur;
      }
    };
    initialisation();
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('iteminfo', {
      templateUrl: 'app/components/main-content/modif-bien/lot/iteminfo/iteminfo.html',
      controllerAs: 'iteminfoctrl',
      bindings: {
        info: '<',
        lot: '='
      },
      controller: ItemInfoController
    });

  /** @ngInject */
  function ItemInfoController($timeout) {
    var ctrl = this;

    ctrl.valeur = null;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.info) {
        getValeur();

      } else {
        $timeout(initialisation, 200);
      }
    }

    function getValeur() {
      angular.forEach(ctrl.lot.infoSupplementaires, function (infosupp) {
        if (ctrl.info.data === infosupp.refInfoSupplementaire.data) {
          ctrl.valeur = infosupp;
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('localisation', {
    templateUrl: 'app/components/main-content/modif-bien/lot/localisation/localisation.html',
    controllerAs: 'localisationctrl',
    bindings: {
      lot: '=',
      validation: '=',
      paramsGestion: '<',
      visited: '<'
    },
    controller: LocalisationController
  });

  /** @ngInject */
  function LocalisationController(GeocoderService, $timeout) {
    var ctrl = this;

    ctrl.map = {
      center: {
        latitude: 46.227638,
        longitude: 2.213749000000007
      },
      zoom: 14,
      controller: {},
      marker: {
        options: {
          icon: {
            anchor: {
              x: 0,
              y: 0
            },
            path:
              'M 0.000 22.000 L 5.694 21.250 L 11.000 19.053 L 15.556 15.556 L 19.053 11.000 ' +
              'L 21.250 5.694 L 22.000 0.000 L 21.250 -5.694 L 19.053 -11.000 L 15.556 -15.556 ' +
              'L 11.000 -19.053 L 5.694 -21.250 L 0.000 -22.000 L -5.694 -21.250 ' +
              'L -11.000 -19.053 L -15.556 -15.556 L -19.053 -11.000 L -21.250 -5.694 ' +
              'L -22.000 0.000 L -21.250 5.694 L -19.053 11.000 L -15.556 15.556 ' +
              'L -11.000 19.053 L -5.694 21.250 L 0.000 22.000 z',
            fillColor: '#ff0000',
            fillOpacity: 1,
            scale: 0.4
          }
        },
        controller: {}
      },
      events: {
        click: mapClickEvent
      }
    };

    ctrl.manualLocalisation = {
      active: false,
      toggle: manualLocalisationToggle
    };

    ctrl.geolocaliser = geolocaliser;
    ctrl.onCopy = onCopy;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot && ctrl.lot.adresse) {
        ctrl.paramsGestion = angular.isDefined(ctrl.paramsGestion) ? ctrl.paramsGestion : false;
        ctrl.map.center.latitude = ctrl.lot.adresse.latitude ? ctrl.lot.adresse.latitude : ctrl.map.center.latitude;
        ctrl.map.center.longitude = ctrl.lot.adresse.longitude ? ctrl.lot.adresse.longitude : ctrl.map.center.longitude;
      } else {
        $timeout(initialisation, 200);
      }
    }

    function geolocaliser() {
      if (ctrl.lot.adresse.rue && (ctrl.lot.adresse.cp || ctrl.lot.adresse.ville)) {
        var adresse = '';

        if (ctrl.lot.adresse.rue) {
          adresse += ctrl.lot.adresse.rue + ' ';
        }
        if (ctrl.lot.adresse.cp) {
          adresse += ctrl.lot.adresse.cp + ' ';
        }
        if (ctrl.lot.adresse.ville) {
          adresse += ctrl.lot.adresse.ville + ' ';
        }
        if (ctrl.lot.adresse.pays) {
          adresse += ctrl.lot.adresse.pays + ' ';
        }

        adresse = adresse.substring(0, adresse.length - 1);

        GeocoderService.geocode(adresse).then(function(retour) {
          if (retour.status === 'OK') {
            ctrl.map.center.latitude = ctrl.lot.adresse.latitude = retour.lat;
            ctrl.map.center.longitude = ctrl.lot.adresse.longitude = retour.lng;
          }
        });
      } else {
        ctrl.visited = true;
      }
    }

    function onCopy() {
      ctrl.lot.adresse =
        angular.isArray(ctrl.lot.proprietaire.adresses) && ctrl.lot.proprietaire.adresses.length
          ? ctrl.lot.proprietaire.adresses[0]
          : ctrl.lot.adresse;
    }

    function manualLocalisationToggle() {
      ctrl.manualLocalisation.active = !ctrl.manualLocalisation.active;
    }

    //noinspection JSUnusedLocalSymbols,JSUnusedLocalSymbols
    function mapClickEvent(map, event, args) {
      if (ctrl.manualLocalisation.active) {
        ctrl.lot.adresse.latitude = args[0].latLng.lat();
        ctrl.lot.adresse.longitude = args[0].latLng.lng();

        $timeout(function() {
          ctrl.map.center = {
            latitude: ctrl.lot.adresse.latitude,
            longitude: ctrl.lot.adresse.longitude
          };
        }, 500);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('itemcritere', {
      templateUrl: 'app/components/main-content/modif-bien/lot/itemcritere/itemcritere.html',
      controllerAs: 'itemcriterectrl',
      bindings: {
        critere: '<',
        listereference: '<',
        valeur: '='
      },
      controller: ItemCritereController
    });

  /** @ngInject */
  function ItemCritereController() {
    var ctrl = this;

    ctrl.isOpen = false;

    ctrl.closeDatePicker = function () {
      ctrl.isOpen = false;
    };

    ctrl.$onInit = function () {
      switch (ctrl.critere.type) {
        case 'int':
          ctrl.valeur = parseInt(ctrl.valeur, 10);
          break;
        case 'float':
          ctrl.valeur = parseFloat(ctrl.valeur);
          break;
      }
    };
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('infolot', {
    templateUrl: 'app/components/main-content/modif-bien/lot/infolot/infolot.html',
    controllerAs: 'infolotctrl',
    bindings: {
      lot: '=',
      isOpen: '<',
      isLoading: '='
    },
    controller: InfoLotController
  });

  /** @ngInject */
  function InfoLotController(ReferencesService, globalService, $timeout, $log) {
    var ctrl = this;

    ctrl.query = {
      typeBien: null,
      afficher: true,
      typeApplication: globalService.getTypeApplication()
    };
    ctrl.infos = null;

    ctrl.getInfoSupplementaire = getInfoSupplementaire;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        ctrl.getInfoSupplementaire();
      } else {
        $timeout(initialisation, 200);
      }
    }

    function getInfoSupplementaire() {
      if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = true;
      ctrl.infos = null;

      ReferencesService.getReferences({
        classes: 'RefInfoSupplementaire',
        afficher: true,
        typeApplication: ctrl.query.typeApplication
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.infos = json.list.RefInfoSupplementaire;
            initialiseValeur();
          }
          if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') {
              $log.warn(error.message);
              ctrl.query.noResults = true;
            } else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
        });
    }

    function initialiseValeur() {
      if (angular.isUndefined(ctrl.lot.infoSupplementaires)) {
        ctrl.lot.infoSupplementaires = [];
      }

      angular.forEach(ctrl.infos, function(info) {
        var find = false;
        angular.forEach(ctrl.lot.infoSupplementaires, function(infosupp) {
          if (info.data === infosupp.refInfoSupplementaire.data) {
            find = true;
          }
        });
        if (!find) {
          $log.warn('Création item - lot - infos supplémentaires');
          var addItem = {
            lot: {
              id: ctrl.lot.id,
              type: ctrl.lot.type
            },
            refInfoSupplementaire: info,
            commentaire: ''
          };
          ctrl.lot.infoSupplementaires.push(addItem);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('criterelot', {
    templateUrl: 'app/components/main-content/modif-bien/lot/criterelot/criterelot.html',
    controllerAs: 'criterelotctrl',
    bindings: {
      lot: '=',
      isOpen: '<',
      isLoading: '='
    },
    controller: CritereLotController
  });

  /** @ngInject */
  function CritereLotController(PropertiesService, ReferencesService, globalService, $timeout, $log) {
    var ctrl = this;

    ctrl.query = {
      typeBien: null,
      afficher: true,
      typeApplication: globalService.getTypeApplication()
    };
    ctrl.criteres = null;
    ctrl.listRef = null;

    ctrl.orderByArray = [
      function (a) {
        return a['posPage' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posLigne' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posCol' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      }
    ];

    ctrl.criteresAAfficher = null;

    ctrl.getCritere = getCritere;
    ctrl.getReferences = getReferences;

    ctrl.getNomChamp = getNomChamp;
    ctrl.getListeReference = getListeReference;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        ctrl.query.typeBien = ctrl.lot.type;
        getCritere();
      } else {
        $timeout(initialisation, 200);
      }
    }

    function getCritere() {
      if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = true;
      ctrl.criteres = null;

      ReferencesService.getCritereListe(ctrl.query)
        .then(function(json) {
          if (json.list.length > 0) {
            ctrl.criteres = json.list;
            angular.forEach(ctrl.criteres, function(critere) {
              if (angular.isDefined(critere.classeValeurs)) {
                var classe = getNomClasse(critere);
                if (angular.isUndefined(ctrl.query.classes)) {
                  ctrl.query.classes = classe;
                } else {
                  ctrl.query.classes = ctrl.query.classes + ',' + classe;
                }
              }
            });
            ctrl.query.classes = ctrl.query.classes + ',RefAutreCritere';
            getReferences();
          } else {
            ctrl.criteres = [];
          }
          if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') {
              $log.warn(error.message);
              ctrl.query.noResults = true;
            } else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.criteres = [];
          if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
        });
    }

    function getReferences() {
      return ReferencesService.getReferences({
        classes: ctrl.query.classes,
        typeApplication: ctrl.query.typeApplication
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.listRef = json.list;
            ctrl.criteresAAfficher = ctrl.criteres;
          }
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });
    }

    function getNomChamp(critere) {
      return critere.nomChamp;
    }

    function getNomClasse(critere) {
      var Arrayclasses = critere.classeValeurs.split('.');
      return Arrayclasses[Arrayclasses.length - 1];
    }

    function getListeReference(critere) {
      if (angular.isDefined(critere.classeValeurs)) {
        var nomRef = getNomClasse(critere);
        //var nomRef = critere.classeValeurs.simpleName;
        return ctrl.listRef[nomRef];
      } else {
        return null;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('dpeGes', {
      templateUrl: 'app/components/main-content/modif-bien/lot/dpe-ges/dpe-ges.html',
      controllerAs: 'dpegesctrl',
      bindings: {
        lot: '=',
        isOpen: '<',
        isLoading: '='
      },
      controller: DpeGesController
    });

  /** @ngInject */
  function DpeGesController(ReferencesService, globalService, $log) {
    var ctrl = this;

    ctrl.list = [];

    ctrl.changed = changed;
    ctrl.verifier = verifier;
    
    ctrl.$onInit = function () {
      initialisation();
    };

    function changed(type) {
      if (type === 'dpe') {
        $log.info('DPE [avant] => ', ctrl.lot.dpe );
        switch (true) {
          case ctrl.lot.valeurDPE <= 50:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'A';
            })[0];
            break;

          case ctrl.lot.valeurDPE <= 90:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'B';
            })[0];
            break;

          case ctrl.lot.valeurDPE <= 150:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'C';
            })[0];
            break;

          case ctrl.lot.valeurDPE <= 230:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'D';
            })[0];
            break;

          case ctrl.lot.valeurDPE <= 330:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'E';
            })[0];
            break;

          case ctrl.lot.valeurDPE <= 450:
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'F';
            })[0];
            break;

          case isNaN(ctrl.lot.valeurDPE):
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'NS';
            })[0];
            break;

          default: // > 450
            ctrl.lot.dpe = ctrl.list.filter(function (dpe) {
              return dpe.label === 'G';
            })[0];
            break;
        }
        $log.info('DPE [après] => ', ctrl.lot.dpe);
      } else {
        switch (true) {
          case ctrl.lot.valeurGSE <= 5:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'A';
            })[0];
            break;

          case ctrl.lot.valeurGSE <= 10:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'B';
            })[0];
            break;

          case ctrl.lot.valeurGSE <= 20:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'C';
            })[0];
            break;

          case ctrl.lot.valeurGSE <= 35:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'D';
            })[0];
            break;

          case ctrl.lot.valeurGSE <= 55:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'E';
            })[0];
            break;

          case ctrl.lot.valeurGSE <= 80:
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'F';
            })[0];
            break;

          default: // > 450
            ctrl.lot.ges = ctrl.list.filter(function (ges) {
              return ges.label === 'G';
            })[0];
            break;
        }
      }
    }
    function verifier(type) {
      if (type === 'dpe') {
          if(!ctrl.lot.dpe && !isNaN(ctrl.lot.valeurDPE) ){
            ctrl.changed('dpe');
          }
      }else{
          if(!ctrl.lot.ges && !isNaN(ctrl.lot.valeurGSE) ){
            ctrl.changed('ges');
          }
      }
    }
    function initialisation() {
      if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = true;

      ReferencesService
        .getReferences({
          classes: 'RefTypeDPE',
          afficher: null,
          typeApplication: globalService.getTypeApplication()
        })

        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.list = retour.list.RefTypeDPE;
            verifier('dpe');
            verifier('ges');
            if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
          }
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('cadastre', {
    templateUrl: 'app/components/main-content/modif-bien/lot/cadastre/cadastre.html',
    controllerAs: 'cadastrectrl',
    bindings: {
      lot: '=',
      isOpen: '<',
      cadastres: '='
    },
    controller: CadastreController
  });

  /** @ngInject */
  function CadastreController( globalService, $log, $timeout) {
    var ctrl = this;
    this.typeApplication = globalService.getTypeApplication();

    ctrl.ajout = { };
    ctrl.modification = false;
    
    
    var initialisation = function() {
      if (ctrl.lot) {
        initializeListe();
      } else {
        $timeout(initialisation, 200);
      }
    };
    
    var initializeListe = function() {
        
    };
    
    function verificationEnvoie(ajoutcadastre) {
      $log.info(ajoutcadastre);
      return !(
        angular.isDefined(ajoutcadastre.$error) &&
        angular.isDefined(ajoutcadastre.$error.required) &&
        ajoutcadastre.$error.required.length > 0
      );
    }
    
    ctrl.addCadastre = function(ajoutcadastre) {
      if (verificationEnvoie(ajoutcadastre)) {
        if (!ctrl.modification) {
          var objectAdd = angular.copy(ctrl.ajout);
          ctrl.cadastres.push(objectAdd);
        }
        ctrl.ajout = { };
        ctrl.modification = false;
        initializeListe();
        ajoutcadastre.$setPristine();
      } else {
        $log.info('Non Valide');
      }
    };

    ctrl.deleteCadastre = function(cadastre) {
      var index = ctrl.cadastres.indexOf(cadastre);
      if (index >= 0) {
        ctrl.cadastres.splice(index, 1);
      }
      initializeListe();
    };
    ctrl.modifierCadastre = function(cadastre) {
      ctrl.ajout = cadastre;
      ctrl.modification = true;
    };

    initialisation();
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('complementInfo', {
      templateUrl: 'app/components/main-content/modif-bien/lot/complement-info/complement-info.html',
      controllerAs: 'complementinfoctrl',
      bindings: {
        lot: '='
      },
      controller: ComplementInfoController
    });

  /** @ngInject */
  function ComplementInfoController($window) {
    var ctrl = this;

    ctrl.table = {
      app: true,
      cave: true,
      parking: true,
      garage: true,
      box: true,
      jardin: true,
      terrasse: true,
      trigger: function (target) {
        if ($window.innerWidth < 768) {
          ctrl.table[target] = !ctrl.table[target];
        }
      }
    };

    ctrl.$onInit = function () {
      if ($window.innerWidth < 768) {
        ctrl.table.app = ctrl.table.cave = ctrl.table.parking = ctrl.table.garage = ctrl.table.box = ctrl.table.jardin = ctrl.table.terrasse = false;
      }

      angular.element($window).on('resize', function () {
        if ($window.innerWidth < 768) {
          ctrl.table.app = ctrl.table.cave = ctrl.table.parking = ctrl.table.garage = ctrl.table.box = ctrl.table.jardin = ctrl.table.terrasse = false;
        } else {
          ctrl.table.app = ctrl.table.cave = ctrl.table.parking = ctrl.table.garage = ctrl.table.box = ctrl.table.jardin = ctrl.table.terrasse = true;
        }
      });
    };
  }
})();
(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocAlerte', {
    templateUrl: 'app/components/main-content/accueil/actualites/blocalerte/blocalerte.html',
    controllerAs: 'blocalertectrl',
    controller: BlocAlerteController,
    bindings: {
      property: '<',
      isLast: '<',
      onAllReady: '&',
      blocBienHeight: '<',
      onViewDiffusion: '&',
      onShowFicheBien: '&',
      onShowFicheProspect: '&'
    }
  });

  /** @ngInject */
  function BlocAlerteController(CONSTANTS, globalService, $timeout, MailService, $uibModal) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    var monthNames = [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre'
    ];

    ctrl.showFicheBien = showFicheBien;
    ctrl.showFicheProspect = showFicheProspect;
    ctrl.getDayTitle = getDayTitle;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.viewDiffusion = viewDiffusion;

    //####################  Ouverture fiches  ####################
    function showFicheBien() {
      ctrl.onShowFicheBien({ refLot: ctrl.property.alerte.lot.referenceInterne });
    }

    function showFicheProspect() {
      ctrl.onShowFicheProspect({ refProspect: ctrl.property.alerte.prospect.referenceInterne });
    }

    function viewDiffusion() {
      ctrl.onViewDiffusion({ alerteId: ctrl.property.alerte.id });
    }

    //####################  Traitement des dates  ####################
    function getDayTitle() {
      var dayMonthYear = ctrl.property.alerte.dateCreation.split('/');
      var monthIndex = Number(dayMonthYear[1]) - 1;
      return dayMonthYear[0] + ' ' + monthNames[monthIndex] + ' ' + dayMonthYear[2];
    }

    function envoyerEmail(refLot) {
      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function(retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function() {
              return retour;
            }
          }
        });

        modalInstance.result.then(function(retour) {
          ctrl.message.open = true;
          ctrl.message.status = retour.status;
          ctrl.message.message = retour.message;

          $timeout(function() {
            ctrl.message.open = false;
          }, 8000);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('sbCriteres', {
    templateUrl: 'app/components/utils/search-box/sb-criteres/sb-criteres.html',
    controllerAs: 'sbcriteresctrl',
    bindings: {
      villesModel: '=',
      typesModel: '=',
      prixMinModel: '=',
      prixMaxModel: '=',
      criteresModel: '=',
      isLoading: '='
    },
    controller: sbCriteresController
  });

  /** @ngInject */
  function sbCriteresController(
    globalService,
    CustomUtils,
    LocalisationService,
    ReferencesService,
    $scope,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.transac = globalService.getTypeApplication();
    ctrl.employe = globalService.getEmploye();

    ctrl.focus = {
      target: null,
      value: null
    };

    ctrl.villes = {
      active: checkActive(ctrl.villesModel),
      open: true,
      loading: false,
      selected: [],
      list: [],
      getVilles: getVilles,
      setVilles: setVilles
    };

    ctrl.types = {
      active: checkActive(ctrl.typesModel),
      open: true,
      loading: false,
      list: [],
      getTypes: getTypes,
      setTypes: setTypes
    };

    ctrl.prix = {
      active: checkActive(ctrl.prixMinModel) && checkActive(ctrl.prixMaxModel),
      open: true,
      getLabel: getPrixLabel
    };

    ctrl.criteres = {
      active: checkActive(ctrl.criteresModel),
      show: false,
      open: true,
      loading: false,
      list: [],
      datepickers: {},
      closeDatepicker: closeDatepicker,
      getCriteres: getCriteres,
      setCriteres: setCriteres
    };

    ctrl.references = {
      loading: false,
      classes: '',
      list: [],
      checked: {},
      getCritRefs: getCritRefs
    };

    ctrl.orderByArray = [
      function (a) {
        return a['posPage' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posLigne' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posCol' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      }
    ];

    ctrl.onFocusListener = $scope.$on('focus', focusInput);

    ctrl.onResetListener = $scope.$on('resetCriteres', function () {
      initialisation();
    });

    // ---------------------------------------------------=[ INIT ]=---------------------------------------------------
    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.villes.active) {
        ctrl.villes.selected = angular.fromJson(ctrl.villesModel);
      }
      if (ctrl.types.active) {
        getTypes();
      }
    }

    ctrl.$onDestroy = function () {
      ctrl.onFocusListener();
      ctrl.onFocusListener = null;
      ctrl.onResetListener();
      ctrl.onResetListener = null;
      ctrl.isLoading = false;
    };

    function checkActive(model) {
      return angular.isDefined(model) && model !== 'NOT_ACTIVE';
    }

    function setLoading(critere, value) {
      if (angular.isDefined(critere) && angular.isDefined(value) && angular.isDefined(ctrl[critere])) {
        ctrl[critere].loading = value;
      }
      if (angular.isDefined(ctrl.isLoading)) {
        ctrl.isLoading =
          (ctrl.villes && ctrl.villes.loading) ||
          (ctrl.types && ctrl.types.loading) ||
          (ctrl.references && ctrl.references.loading) ||
          (ctrl.criteres && ctrl.criteres.loading) ||
          (ctrl.typeMandat && ctrl.typeMandat.loading) ||
          (ctrl.avancement && ctrl.avancement.loading);
      }
    }

    function focusInput(event, params) {
      if (params.target !== 'villes' && params.target !== 'types' && params.target !== 'prix') {
        angular.forEach(ctrl.criteres.list, function (critere) {
          if (critere.nom === params.target) critere.open = true;
        });
      }

      $timeout(function () {
        ctrl.focus.target = params.target;
        ctrl.focus.value = params.value;
      });
    }

    // --------------------------------------------------=[ VILLES ]=--------------------------------------------------
    function getVilles(input) {
      if (input && input.length) {
        setLoading('villes', true);
        ctrl.servletLastCall = ctrl.servletLastCall ? ctrl.servletLastCall + 1 : 1;

        var currentCall = ctrl.servletLastCall;

        ctrl.villes.list = [];

        LocalisationService.getVillesByQuery({
            recherche: input,
            typeMethode: 'complete',
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (json) {
            if (currentCall >= ctrl.servletLastCall) {
              if (json.status === 'OK') {
                ctrl.villes.list = json.list;
              }
              setLoading('villes', false);
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            setLoading('villes', false);
          });
      }
    }

    function setVilles() {
      ctrl.villesModel = angular.toJson(ctrl.villes.selected);
    }

    // ---------------------------------------------------=[ TYPES ]=--------------------------------------------------
    function getTypes() {
      setLoading('types', true);

      ReferencesService.getReferences({
          afficher: true,
          classes: 'RefTypeBien',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            var types = [];
            if (angular.isDefined(ctrl.typesModel) && angular.isString(ctrl.typesModel)) {
              types = ctrl.typesModel.split(',');
            }

            ctrl.types.list = retour.list.RefTypeBien.map(function (type) {
              type.checked = types.includes(type.simpleData);
              if (type.checked) {
                ctrl.criteres.show = true;
              }
              return type;
            });

            if (ctrl.criteres.active) {
              getCriteres();
            }
          }
          setLoading('types', false);
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('types', false);
        });
    }

    function setTypes() {
      $timeout(function () {
        var types = '',
          checked = false;

        angular.forEach(ctrl.types.list, function (type) {
          if (type.checked) {
            types += type.simpleData + ',';
            checked = true;
          }
        });

        if (checked) types = types.slice(0, -1);
        else types = null;

        ctrl.typesModel = types;
        ctrl.criteres.show = checked;
        if (ctrl.criteresModel !== 'NOT_ACTIVE') {
          if (checked) getCriteres();
          else {
            ctrl.criteresModel = null;
            ctrl.criteres.list = [];
          }
        }
      });
    }

    // ----------------------------------------------------=[ PRIX ]=--------------------------------------------------
    function getPrixLabel() {
      if (ctrl.transac === 'Transaction') {
        return 'Prix';
      } else if (ctrl.employe && ctrl.employe.societe.rapproLoyerTTC) {
        return 'Loyer <small>(TCC)</small>';
      } else {
        return 'Loyer <small>(HC)</small>';
      }
    }

    // -------------------------------------------------=[ REFERENCES ]=-----------------------------------------------
    function getCritRefs() {
      setLoading('references', true);
      if (ctrl.references.classes === '') {
        ctrl.references.classes = 'RefAutresCriteres';
      }
      ReferencesService.getReferences({
          classes: ctrl.references.classes,
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (json) {
          if (json.status === 'OK') {
            ctrl.references.list = json.list;

            angular.forEach(ctrl.criteres.list, function (critere) {
              if (critere.type === 'combo') {
                ctrl.references.checked[critere.classeValeursName] = [];
              }

              var searchCrit = false;

              if (
                angular.isDefined(ctrl.criteresModel) &&
                angular.isArray(ctrl.criteresModel) &&
                ctrl.criteresModel.length
              ) {
                var currentCrit = ctrl.criteresModel.filter(function (crit) {
                  return crit.critere.nomChamp === critere.nomChamp;
                });

                if (currentCrit.length) {
                  searchCrit = currentCrit[0];
                }
              }

              switch (critere.type) {
                case 'int':
                  critere.intMin = searchCrit && searchCrit.intMin ? searchCrit.intMin : null;
                  critere.intMax = searchCrit && searchCrit.intMax ? searchCrit.intMax : null;
                  break;

                case 'float':
                  critere.floatMin = searchCrit && searchCrit.floatMin ? searchCrit.floatMin : null;
                  critere.floatMax = searchCrit && searchCrit.floatMax ? searchCrit.floatMax : null;
                  break;

                case 'boolean':
                  critere.bool = searchCrit && angular.isDefined(searchCrit.bool) ? searchCrit.bool : null;
                  break;

                case 'date':
                  critere.dateMin = searchCrit.dateMin ? searchCrit.dateMin : null;
                  critere.dateMax = searchCrit.dateMax ? searchCrit.dateMax : null;
                  break;

                case 'combo':
                  if (searchCrit && angular.isArray(searchCrit.combo) && searchCrit.combo.length) {
                    angular.forEach(ctrl.references.list[critere.classeValeursName], function (reference) {
                      if (
                        searchCrit.combo.filter(function (ref) {
                          return reference.id === ref.id;
                        }).length
                      ) {
                        ctrl.references.checked[critere.classeValeursName].push(reference);
                      }
                    });
                  }
                  break;
              }
            });
            setCriteres();
          }
          setLoading('references', false);
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);

          setLoading('references', false);
        });
    }

    // --------------------------------------------------=[ CRITERES ]=------------------------------------------------
    function closeDatepicker(datepicker) {
      ctrl.criteres[datepicker] = false;
    }

    function getCriteres() {
      var params = {
        typeApplication: globalService.getTypeApplication()
      };
      if (angular.isDefined(ctrl.typesModel) && angular.isString(ctrl.typesModel)) {
        params.typeBien = ctrl.typesModel.indexOf(',') > 0 ? 'lot' : ctrl.typesModel;
        if (params.typeBien !== 'lot') {
          params.afficher = true;
        }

        ctrl.criteresModel = angular.fromJson(ctrl.criteresModel);
        setLoading('criteres', true);

        ReferencesService.getCritereListe(params)
          .then(function (json) {
            if (json.status === 'OK') {
              ctrl.criteres.list = json.list.filter(function (critere) {
                return critere['rapprocher' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
              });
              ctrl.criteres.list.push({
                classeValeurs: 'business.lot.references.RefAutreCritere',
                nom: 'Autres critères',
                nomChamp: 'autresCriteres',
                type: 'combo',
                afficher: true,
                afficherLoc: true,
                rapprocher: false,
                rapprocherLoc: false
              });

              ctrl.references.classes = '';
              angular.forEach(ctrl.criteres.list, function (critere, index) {
                if (angular.isDefined(critere.classeValeurs)) {
                  var splited = critere.classeValeurs.split('.');
                  critere.classeValeursName = splited[splited.length - 1];
                  ctrl.references.classes += critere.classeValeursName;

                  if (index < ctrl.criteres.list.length - 1) ctrl.references.classes += ',';
                }
              });
              getCritRefs();
            } else {
              ctrl.criteres.list = [];
            }
            setLoading('criteres', false);
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.criteres.list = [];
            setLoading('criteres', false);
          });
      } else {
        ctrl.criteres.list = [];
        ctrl.criteres.show = false;
        ctrl.criteresModel = null;
      }
    }

    function setCriteres() {
      var tmp = [];

      angular.forEach(ctrl.criteres.list, function (critere) {
        var current = {
          obligatoire: true,
          critere: {
            id: critere.id,
            nomChamp: critere.nomChamp,
            nom: critere.nom,
            type: critere.type
          }
        };

        switch (critere.type) {
          case 'int':
            if (critere.intMin || critere.intMax) {
              current.intMin = critere.intMin;
              current.intMax = critere.intMax;
              tmp.push(current);
            }
            break;

          case 'float':
            if (critere.floatMin || critere.floatMax) {
              current.floatMin = critere.floatMin;
              current.floatMax = critere.floatMax;
              tmp.push(current);
            }
            break;

          case 'boolean':
            if (angular.isDefined(critere.bool) && critere.bool !== null) {
              current.bool = critere.bool;
              tmp.push(current);
            }
            break;

          case 'date':
            if (critere.dateMin || critere.dateMax) {
              current.dateMin = critere.dateMin;
              current.dateMax = critere.dateMax;
              tmp.push(current);
            }
            break;

          case 'combo':
            current.combo = [];
            if (
              angular.isDefined(ctrl.references.checked[critere.classeValeursName]) &&
              ctrl.references.checked[critere.classeValeursName].length
            ) {
              current.combo = ctrl.references.checked[critere.classeValeursName];
              tmp.push(current);
            }
            break;
        }
      });

      ctrl.criteresModel = angular.toJson(tmp);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('sbPrestataires', {
      templateUrl: 'app/components/utils/search-box/sb-prestataires/sb-prestataires.html',
      controllerAs: 'sbprestatairesctrl',
      bindings: {
        prestataireModel: '=',
        isLoading: '=',
        onSelectPrestataire: '&'
      },
      controller: SbPrestatairesController
    });

  /** @ngInject */
  function SbPrestatairesController(globalService, CustomUtils, ReferencesService, $q) {
    var ctrl = this;

    ctrl.prestataires = {
      active: angular.isDefined(ctrl.prestataireModel) && ctrl.prestataireModel !== 'NOT_ACTIVE',
      open: true,
      loading: false,
      list: []
    };

    ctrl.onChangePrestataire = onChangePrestataire;

    // ---------------------------------------------------=[ INIT ]=---------------------------------------------------
    ctrl.$onInit = function () {
      getPrestataires();
    };

    ctrl.$onDestroy = function () {
      ctrl.isLoading = false;
    };

    function onChangePrestataire(prestataire, firstLoad) {
      ctrl.onSelectPrestataire({prestataire: prestataire, firstLoad: firstLoad});
    }

    // -----------------------------------------------=[ PRESTATAIRES ]=-----------------------------------------------
    function checkImgParution(prestataires) {
      var globalDefer = $q.defer(),
        promises = [],
        deferred;

      angular.forEach(prestataires, function (prestataire) {
        deferred = $q.defer();
        prestataire.hasImg = false;
        var imgSrc = 'assets/images/logos/' + prestataire.nom + '.png';
        CustomUtils.isImage(imgSrc)
          .then(function (image) {
            prestataire.hasImg = true;
            prestataire.imgSrc = image.src;
          })
          .finally(function () {
            deferred.resolve();
            promises.push(deferred.promise);
          });
      });

      $q.all(promises).then(function () {
        globalDefer.resolve(prestataires);
      });

      return globalDefer.promise;
    }

    function getPrestataires() {
      ctrl.isLoading = true;
      ReferencesService
        .getPrestataires({
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (prestaListe) {
          if (prestaListe.status === 'OK') {
            checkImgParution(prestaListe.list)
              .then(function (prestataires) {
                ctrl.prestataires.list = prestataires;
                if (ctrl.prestataireModel === null) {
                  ctrl.prestataireModel = ctrl.prestataires.list[0].id;
                }

                var currentPrestataire = null,
                  matchPrestataire = ctrl.prestataires.list.filter(function (prestataire) {
                    return prestataire.id === ctrl.prestataireModel;
                  });

                if (angular.isArray(matchPrestataire) && matchPrestataire.length) {
                  currentPrestataire = matchPrestataire[0];
                }

                onChangePrestataire(currentPrestataire, true);

                ctrl.isLoading = false;
              });
          }
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('sbFiltres', {
    templateUrl: 'app/components/utils/search-box/sb-filtres/sb-filtres.html',
    controllerAs: 'sbfiltresctrl',
    bindings: {
      isLoading: '=',
      geolocalisationModel: '=',
      societesModel: '=',
      negoModel: '=',
      mandatModel: '=',
      datedebModel: '=',
      datefinModel: '=',
      expireModel: '=',
      expirantModel: '=',
      datedebSaisieModel: '=',
      datefinSaisieModel: '=',
      datedebSignatureModel: '=',
      datefinSignatureModel: '=',
      archiveModel: '=',
      attenteModel: '=',
      optionModel: '=',
      typeContratModel: '=',
      typeMandatModel: '=',
      gestionAgenceModel: '=',
      avancementModel: '=',
      dureeVacanceModel: '=',
      parutionModel: '=',
      panneauxModel: '=',
      paruModel: '=',
      qualificationModel: '=',
      encaissementModel: '=',
      intraboxModel: '=',
      validerModel: '=',
      sansDpeModel: '='
    },
    controller: sbFiltresController
  });

  /** @ngInject */
  function sbFiltresController(
    CONSTANTS,
    globalService,
   
    CustomUtils,
    PropertiesService,
    ReferencesService,
    RepertoireService,
    moment,
    $scope,
    $stateParams,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.employe = globalService.getEmploye();
    ctrl.typeApplication = globalService.getTypeApplication();

    ctrl.filtres = {
      geolocalisation: {
        nom: 'geolocalisation',
        active: checkActive(ctrl.geolocalisationModel),
        open: false
      },
      societes: {
        nom: 'societes',
        active: checkActive(ctrl.societesModel),
        loading: false,
        query: [],
        list: [],
        currentList: [],
        groupChoices: societeGroupChoices,
        searchInSocietes: searchInSocietes,
        getSocietes: getSocietes,
        setSocietes: setSocietes
      },
      nego: {
        nom: 'nego',
        active: checkActive(ctrl.negoModel),
        open: false,
        loading: false,
        query: [],
        list: [],
        currentList: [],
        getNegos: getNegos,
        setNego: setNego
      },
      visibilite: {
        nom: 'visibilite',
        mandatActive: checkActive(ctrl.mandatModel),
        archiveActive: checkActive(ctrl.archiveModel),
        active: checkActive(ctrl.mandatModel) || checkActive(ctrl.archiveModel),
        open: false
      },
      etat: {
        nom: 'etat',
        attenteActive: checkActive(ctrl.attenteModel),
        optionActive: checkActive(ctrl.optionModel),
        active: checkActive(ctrl.attenteModel) || checkActive(ctrl.optionModel),
        open: false
      },
      typeContrat: {
        nom: 'typeContrat',
        active: checkActive(ctrl.typeContratModel),
        open: false
      },
      typeMandat: {
        nom: 'typeMandat',
        active: checkActive(ctrl.typeMandatModel),
        open: false,
        loading: false,
        list: [],
        getTypesMandat: getTypesMandat,
        isUndefined: checkTypeModelIsUndefined
      },
      dateMandat: {
        nom: 'dateMandat',
        datedebActive: checkActive(ctrl.datedebModel),
        datefinActive: checkActive(ctrl.datefinModel),
        active: checkActive(ctrl.datedebModel) || checkActive(ctrl.datefinModel),
        open: false,
        datedebOpen: false,
        datefinOpen: false,
        periode: null,
        setDates: setDatesMandat
      },
      expire: {
        nom: 'expire',
        active: checkActive(ctrl.expireModel),
        open: false,
        expire: null,
        setExpiration: setExpirationMandat
      },
      expirant: {
        nom: 'expirant',
        active: checkActive(ctrl.expirantModel),
        open: false,
        expirant: null,
        setExpirant: setExpirantMandat
      },
      dateSaisie: {
        nom: 'dateSaisie',
        datedebSaisieActive: checkActive(ctrl.datedebSaisieModel),
        datefinSaisieActive: checkActive(ctrl.datefinSaisieModel),
        active: checkActive(ctrl.datedebSaisieModel) || checkActive(ctrl.datefinSaisieModel),
        open: false,
        datedebSaisieOpen: false,
        datefinSaisieOpen: false
      },
      dateSignature: {
        nom: 'dateSignature',
        test: '',
        datedebSignatureActive: checkActive(ctrl.datedebSignatureModel),
        datefinSignatureActive: checkActive(ctrl.datefinSignatureModel),
        active: checkActive(ctrl.datedebSignatureModel) || checkActive(ctrl.datefinSignatureModel),
        open: false,
        datedebSignatureOpen: false,
        datefinOpen: false
      },
      gestionAgence: {
        nom: 'gestionAgence',
        active: checkActive(ctrl.gestionAgenceModel),
        open: false
      },
      avancement: {
        nom: 'avancement',
        active: checkActive(ctrl.avancementModel),
        open: false,
        loading: false,
        internalChange: false,
        query: [],
        list: [],
        currentList: [],
        getAvancement: getAvancement,
        setAvancement: setAvancement
      },
      dureeVacance: {
        nom: 'dureeVacance',
        active: checkActive(ctrl.dureeVacanceModel),
        open: false
      },
      qualification: {
        nom: 'qualification',
        active: checkActive(ctrl.qualificationModel),
        open: false,
        loading: false,
        internalChange: false,
        query: [],
        list: [],
        currentList: [],
        getQualification: getQualification,
        setQualification: setQualification
      },
      parution: {
        nom: 'parution',
        active: checkActive(ctrl.parutionModel),
        open: false
      },
      panneaux: {
        nom: 'panneaux',
        active: checkActive(ctrl.panneauxModel),
        open: false
      },
      paru: {
        nom: 'paru',
        active: checkActive(ctrl.paruModel),
        open: false
      },
      encaissement: {
        nom: 'encaissement',
        active: checkActive(ctrl.encaissementModel),
        open: false
      },
      intrabox: {
        nom: 'intrabox',
        active: checkActive(ctrl.intraboxModel),
        open: false
      },
      valider: {
        nom: 'valider',
        active: checkActive(ctrl.validerModel),
        open: false
      },
      sansDpe: {
        nom: 'sansDpe',
        active: checkActive(ctrl.sansDpeModel),
        open: false
      }
    };

    /* Initialiser des watcher sur les models de Références */
    ctrl.avancementListener = $scope.$watch(
      function() {
        return ctrl.avancementModel;
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal && !ctrl.filtres.avancement.internalChange) {
          initAvancements();
        } else if (ctrl.filtres.avancement.internalChange) {
          ctrl.filtres.avancement.internalChange = false;
        }
      }
    );
    ctrl.qualificationListener = $scope.$watch(
      function() {
        return ctrl.qualificationModel;
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal && !ctrl.filtres.qualification.internalChange) {
          initQualifications();
        } else if (ctrl.filtres.qualification.internalChange) {
          ctrl.filtres.qualification.internalChange = false;
        }
      }
    );

    ctrl.onResetListener = $scope.$on('resetFiltres', function() {
      initialisation();
    });

    // ---------------------------------------------------=[ INIT ]=---------------------------------------------------
    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.filtres.societes.active) {
        getSocietes();
      }
      if (ctrl.filtres.nego.active) {
        getNegos();
      }
      if (ctrl.filtres.typeMandat.active) {
        getTypesMandat();
      }
      if (ctrl.filtres.avancement.active) {
        getAvancement();
      }
      if (ctrl.filtres.qualification.active) {
        getQualification();
      }
      if (ctrl.filtres.dateMandat.active) {
        getDatesMandat();
      }
      if (ctrl.filtres.expire.active) {
        getExpireMandat();
      }
      if (ctrl.filtres.expirant.active) {
        getExpirantMandat();
      }

      if (ctrl.filtres.dateSignature.active) {
        ctrl.filtres.dateSignature.text = ctrl.typeApplication === 'Transaction' ? 'Compromis' : 'Réservation';
        if ($stateParams.type) {
          ctrl.filtres.dateSignature.text = CustomUtils.string.ucfirst($stateParams.type);
        }
      }
    }

    ctrl.$onDestroy = function() {
      ctrl.isLoading = false;

      ctrl.avancementListener();
      ctrl.avancementListener = null;
      ctrl.qualificationListener();
      ctrl.qualificationListener = null;
      ctrl.onResetListener();
      ctrl.onResetListener = null;
    };

    function checkActive(model) {
      return angular.isDefined(model) && model !== 'NOT_ACTIVE';
    }

    function setLoading(service, value) {
      if (angular.isDefined(service) && angular.isDefined(value) && angular.isDefined(ctrl.filtres[service])) {
        ctrl.filtres[service].loading = value;
      }
      if (angular.isDefined(ctrl.isLoading)) {
        ctrl.isLoading =
          (ctrl.filtres.societes && ctrl.filtres.societes.loading) ||
          (ctrl.nego && ctrl.filtres.nego.loading) ||
          (ctrl.filtres.typeMandat && ctrl.filtres.typeMandat.loading) ||
          (ctrl.avancement && ctrl.filtres.avancement.loading) ||
          (ctrl.filtres.qualification && ctrl.filtres.qualification.loading);
      }
    }

    // -------------------------------------------------=[ SOCIETES ]=-------------------------------------------------
    function societeGroupChoices(item) {
      return item.hasOwnProperty('pool') ? item.pool.nom : undefined;
    }

    function searchInSocietes(input) {
      if (ctrl.filtres.societes.list.length > 0) {
        ctrl.filtres.societes.currentList = ctrl.filtres.societes.list.filter(function(societe) {
          return societe.nom.indexOf(input) !== -1 || societe.nom.toLowerCase().indexOf(input) !== -1;
        });
      } else ctrl.filtres.societes.currentList = ctrl.filtres.societes.list;
    }

    function getSocietes() {
      setLoading('societes', true);

      PropertiesService.getSocietes({
        typeMethode: 'basic',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.filtres.societes.list = json.list;
            ctrl.filtres.societes.currentList = json.list;

            if (angular.isDefined(ctrl.societesModel) && ctrl.societesModel !== null) {
              var societes = ctrl.societesModel.toString().split(',');
              ctrl.filtres.societes.query = [];
              angular.forEach(ctrl.filtres.societes.list, function(societe) {
                if (!societe.pool) societe.pool = { nom: '-Hors groupement' };
                if (CustomUtils.collection.contains(societes, societe.id.toString()))
                  ctrl.filtres.societes.query.push(societe);
              });
            }
          }
          setLoading('societes', false);
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('societes', false);
        });
    }

    function setSocietes() {
      if (angular.isArray(ctrl.filtres.societes.query) && ctrl.filtres.societes.query.length > 0) {
        var query = '';
        angular.forEach(ctrl.filtres.societes.query, function(societe, index) {
          query += societe.id;
          if (index < ctrl.filtres.societes.query.length - 1) query += ',';
        });
        ctrl.societesModel = query;
      } else ctrl.societesModel = null;
    }

    // ---------------------------------------------------=[ NEGO ]=---------------------------------------------------
    function getNegos(input) {
      setLoading('nego', true);

      RepertoireService.getNegoList({
        recherche: angular.isDefined(input) ? input : null,
        societe: ctrl.societesModel ? ctrl.societesModel : null,
        numero: 0,
        pas: 20,
        typeMethode: 'basic',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.filtres.nego.list = json.list;
            ctrl.filtres.nego.currentList = json.list;

            if (angular.isDefined(ctrl.negoModel) && angular.isString(ctrl.negoModel)) {
              var negos = ctrl.negoModel.split(',');
              ctrl.filtres.nego.query = angular.isArray(ctrl.filtres.nego.query) ? ctrl.filtres.nego.query : [];
              angular.forEach(ctrl.filtres.nego.list, function(nego) {
                if (CustomUtils.collection.contains(negos, nego.id.toString())) ctrl.filtres.nego.query.push(nego);
              });
            }
          }
          setLoading('nego', false);
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('nego', false);
        });
    }

    function setNego() {
      if (angular.isArray(ctrl.filtres.nego.query) && ctrl.filtres.nego.query.length > 0) {
        var query = '';
        angular.forEach(ctrl.filtres.nego.query, function(nego, index) {
          query += nego.id;
          if (index < ctrl.filtres.nego.query.length - 1) query += ',';
        });
        ctrl.negoModel = query;
      } else ctrl.negoModel = null;
    }

    // -------------------------------------------------=[ TYPE MANDAT ]=-----------------------------------------------
    function getTypesMandat() {
      setLoading('typeMandat', true);

      ReferencesService.getReferences({
        classes: 'RefTypeMandat',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.filtres.typeMandat.list = json.list.RefTypeMandat;
          }
          setLoading('typeMandat', false);
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('typeMandat', false);
        });
    }

    function checkTypeModelIsUndefined() {
      if (angular.isUndefined(ctrl.typeMandatModel)) {
        ctrl.typeMandatModel = null;
      }
    }

    // --------------------------------------------------=[ DATE MANDAT ]=-----------------------------------------------
    function getDatesMandat() {
      ctrl.filtres.dateMandat.periode = ctrl.datefinModel
        ? moment().diff(moment(ctrl.datefinModel, CONSTANTS.short_date_format), 'months')
        : null;
    }

    function setDatesMandat() {
      if (ctrl.filtres.dateMandat.periode) {
        switch (ctrl.filtres.dateMandat.periode) {
          case 3:
            ctrl.datedebModel = moment()
              .subtract(6, 'months')
              .format(CONSTANTS.short_date_format);
            ctrl.datefinModel = moment()
              .subtract(3, 'months')
              .format(CONSTANTS.short_date_format);
            break;
          case 6:
            ctrl.datedebModel = moment()
              .subtract(9, 'months')
              .format(CONSTANTS.short_date_format);
            ctrl.datefinModel = moment()
              .subtract(6, 'months')
              .format(CONSTANTS.short_date_format);
            break;
          case 9:
            ctrl.datedebModel = moment()
              .subtract(15, 'months')
              .format(CONSTANTS.short_date_format);
            ctrl.datefinModel = moment()
              .subtract(9, 'months')
              .format(CONSTANTS.short_date_format);
            break;

          default:
            ctrl.datedebModel = null;
            ctrl.datefinModel = null;
            break;
        }
      }
    }

    // --------------------------------------------------=[ MANDAT EXPIRE ]=-----------------------------------------------
    function getExpireMandat() {
      ctrl.filtres.expire.expire = angular.isDefined(ctrl.expireModel) ? ctrl.expireModel : null;
    }
    function setExpirationMandat() {
      ctrl.expireModel = ctrl.filtres.expire.expire ? moment().format(CONSTANTS.short_date_format) : null;
    }

    // --------------------------------------------------=[ MANDAT EXPIRANT ]=-----------------------------------------------
    function getExpirantMandat() {
      ctrl.filtres.expirant.expirant = ctrl.expirantModel
        ? moment(ctrl.expirantModel, CONSTANTS.short_date_format).diff(moment(), 'days')
        : null;
    }
    function setExpirantMandat() {
      ctrl.expirantModel = ctrl.filtres.expirant.expirant
        ? moment()
            .add(ctrl.filtres.expirant.expirant, 'days')
            .format(CONSTANTS.short_date_format)
        : null;
    }

    // --------------------------------------------------=[ AVANCEMENT ]=-----------------------------------------------
    function getAvancement() {
      setLoading('avancement', true);

      var classe =
        globalService.getTypeApplication() === 'Transaction' ? 'RefMotifSuppression' : 'RefMotifSuppressionLocation';

      ReferencesService.getReferences({
        classes: classe,
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.filtres.avancement.list = json.list[classe];

            initAvancements();
          }
          setLoading('avancement', false);
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('avancement', false);
        });
    }

    function initAvancements() {
      ctrl.filtres.avancement.query = [];

      if (angular.isDefined(ctrl.avancementModel) && angular.isString(ctrl.avancementModel)) {
        var motifs = ctrl.avancementModel.split(',');

        angular.forEach(ctrl.filtres.avancement.list, function(motif) {
          if (motif.data && CustomUtils.collection.contains(motifs, motif.data.toString())) {
            ctrl.filtres.avancement.query.push(motif);
          }
        });
      }

      var defaultAvancement = {
        label: globalService.getTypeApplication() === 'Transaction' ? 'En vente' : 'En location',
        data: null
      };

      ctrl.filtres.avancement.list = ctrl.filtres.avancement.list.filter(function(avancement) {
        return avancement.label !== 'En vente' && avancement.label !== 'En location';
      });

      ctrl.filtres.avancement.list.push(defaultAvancement);

      if (!ctrl.filtres.avancement.query.length) {
        ctrl.filtres.avancement.query.push(defaultAvancement);
      }
    }

    function setAvancement() {
      ctrl.filtres.avancement.internalChange = true;
      if (ctrl.filtres.avancement.active) {
        var motifs = null;

        if (ctrl.filtres.avancement.query) {
          motifs = [];
          angular.forEach(ctrl.filtres.avancement.query, function(motif) {
            if (motif.label !== 'En vente' && motif.label !== 'En location') {
              motifs.push(motif.data);
            }
          });

          if (motifs.length) {
            motifs = motifs.join(',');
          } else motifs = null;

          // TODO => Demander à Julien pourquoi avoir cette regle ou la retirer si c'est juste une erreur.
          if (ctrl.mandatModel) {
            ctrl.mandatModel = false;
          }
        }

        ctrl.avancementModel = motifs;
      }
    }

    // -------------------------------------------------=[ QUALIFICATION ]=---------------------------------------------
    function getQualification() {
      setLoading('qualification', true);

      var classe =
        globalService.getTypeApplication() === 'Transaction' ? 'RefQualification' : 'RefQualificationLocation';

      ReferencesService.getReferences({
        classes: classe,
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.filtres.qualification.list = json.list[classe];

            initQualifications();
          }
          setLoading('qualification', false);
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          setLoading('qualification', false);
        });
    }

    function initQualifications() {
      if (angular.isDefined(ctrl.qualificationModel) && angular.isString(ctrl.qualificationModel)) {
        ctrl.filtres.qualification.query = [];
        var qualifications = ctrl.qualificationModel.split(',');

        angular.forEach(ctrl.filtres.qualification.list, function(qualification) {
          if (CustomUtils.collection.contains(qualifications, qualification.id.toString())) {
            ctrl.filtres.qualification.query.push(qualification);
          }
        });
      } else {
        ctrl.filtres.qualification.query = null;
      }
    }

    function setQualification() {
      ctrl.filtres.qualification.internalChange = true;
      if (ctrl.filtres.qualification.active) {
        var qualifications = [];

        if (ctrl.filtres.qualification.query) {
          angular.forEach(ctrl.filtres.qualification.query, function(qualification) {
            qualifications.push(qualification.id);
          });
          qualifications = qualifications.join(',');
        } else {
          qualifications = null;
        }

        ctrl.qualificationModel = qualifications;
      }
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('rSelectOption', {
    templateUrl: 'app/components/utils/r-select/r-select-option/r-select-option.html',
    controllerAs: 'rsoptionctrl',
    bindings: {
      rsOption: '<',
      rsLabelledBy: '<',
      rsClasses: '<',
      onSelectOption: '&'
    },
    controller: rSelectOptionController
  });

  /** @ngInject */
  function rSelectOptionController() {
    var ctrl = this;

    ctrl.isGroup = false;
    ctrl.label = '';

    ctrl.mouseover = false;

    ctrl.onClickOption = onClickOption;

    ctrl.$onInit = function() {
      ctrl.isGroup =
        ctrl.rsOption.hasOwnProperty('options') &&
        angular.isArray(ctrl.rsOption.options) &&
        ctrl.rsOption.options.length;

      ctrl.label = ctrl.rsOption.label || Object.getByString(ctrl.rsOption, ctrl.rsLabelledBy) || '';
    };

    function onClickOption(option) {
      var selected = option || ctrl.rsOption;
      ctrl.onSelectOption({ option: selected });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('tableauBord', {
    templateUrl: 'app/components/main-content/statistique/tableau-bord/tableau-bord.html',
    controllerAs: 'tableaubordctrl',
    bindings: {
    },
    controller: TableauBordController
  });

  /** @ngInject */
  function TableauBordController($log,
 
  CONSTANTS,
  globalService,
  RepertoireService,
  TableauBordService,
  moment
  ) {
    var ctrl = this;
    ctrl.envoyerStatistique = envoyerStatistique;
    ctrl.getDonnee = getDonnee;
    ctrl.getDetail = getDetail;
    //initialisaton variable
    ctrl.listeMois = [{mois:0,label:'Janvier',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:1,label:'Février',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:2,label:'Mars',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:3,label:'Avril',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:4,label:'Mai',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:5,label:'Juin',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:6,label:'Juillet',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:7,label:'Aout',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:8,label:'Septembre',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:9,label:'Octobre',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:10,label:'Novembre',libelleDate:'',libelleGraph:'',cocher:false},
                      {mois:11,label:'Decembre',libelleDate:'',libelleGraph:'',cocher:false}];
                      
    ctrl.employe = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;
    ctrl.transac = globalService.getTypeApplication();
    
    ctrl.statistiques = {
      ca: [],
      caprec: [],
      difca: [],
      objectifs: [],
      caActuel: [],
      caVise: [],
      compteurLabelFormat: []
    };
    /*ctrl.statistiques.nbVisitesN = [];
     ctrl.statistiques.nbVisitesNM1 = [];*/
    ctrl.statistiques.compteurLabelFormat = [""];

    var curDate = new Date();
    var m = curDate.getMonth();
    var y = curDate.getFullYear();
    
    ctrl.societes = {
      list: [],
      societe: null,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };
    
    ctrl.datepickers = {
      debut: {
        open: false,
        onClose: onCloseDatepicker
      }
    };
    
    function initialisation() {
        if(ctrl.employe.societe.agence.jourTab===null || ctrl.employe.societe.agence.moisTab===null){
            ctrl.dateExercice = moment().date(1).month(0).format(CONSTANTS.date_format);
        }else if(ctrl.employe.societe.agence.moisTab>6){
            ctrl.dateExercice = moment().date(ctrl.employe.societe.agence.jourTab).month(ctrl.employe.societe.agence.moisTab-1).subtract(1,'years').format(CONSTANTS.date_format);
        }else{
            ctrl.dateExercice = moment().date(ctrl.employe.societe.agence.jourTab).month(ctrl.employe.societe.agence.moisTab-1).format(CONSTANTS.date_format);
        }
        m = moment(ctrl.dateExercice,CONSTANTS.date_format).month();
        y = moment(ctrl.dateExercice,CONSTANTS.date_format).year();
        $log.info(m+'-'+y);
        searchInSocietes();
        recalculeLibelleMois();
        $log.info("init");
    }

    ctrl.$onInit = initialisation;
    function searchInSocietes(input) {
      RepertoireService.getSocietesList({
        recherche: input || null,
        numero: 0,
        pas: 10
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeChanged() {
      searchInNegos();
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : null,
        numero: 0,
        pas: 15,
        typeMethode: 'liste'
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
        
    }
    
    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
    }
    
    function recalculeLibelleMois(){
      var now = moment();
      angular.forEach(ctrl.listeMois, function(mois) {
        var datedebut = moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M');
        mois.cocher = datedebut.isBefore(now);
        var libelleDate = datedebut.format('DD/MM')+' - '+datedebut.add(1,'M').subtract(1,'d').format('DD/MM');
        mois.libelleDate = libelleDate;
        var libelleGraph = moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').format('DD/MM');
        mois.libelleGraph = libelleGraph;
        mois.moisDebut=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').format('DD/MM/YY');
        mois.moisFin=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').add(1,'M').subtract(1,'d').format('DD/MM/YY');
        mois.anneeDebut=moment(ctrl.dateExercice,CONSTANTS.date_format).format('DD/MM/YY');
        mois.anneeFin=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').add(1,'M').subtract(1,'d').format('DD/MM/YY');
        mois.moisDebutPrec=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').subtract(1,'y').format('DD/MM/YY');
        mois.moisFinPrec=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').add(1,'M').subtract(1,'d').subtract(1,'y').format('DD/MM/YY');
        mois.anneeDebutPrec=moment(ctrl.dateExercice,CONSTANTS.date_format).subtract(1,'y').format('DD/MM/YY');
        mois.anneeFinPrec=moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M').add(1,'M').subtract(1,'d').subtract(1,'y').format('DD/MM/YY');
        
      });
      
    }
    
    function envoyerStatistique(){
        
        var params = {};
        var societeIds = [];
        angular.forEach(ctrl.societes.societe, function(soc) {
            $log.info(soc);
            societeIds.push(soc.id);
        });
        if(societeIds.length>0){
            params.societeIds = societeIds.join(',');
        }
        params.negoId = ctrl.societes.nego ? ctrl.societes.nego.id : null;
        params.typeApplication = ctrl.transac;
        params.dateExercice = ctrl.dateExercice;
        params.vente = true;
        params.compromis = true;
        params.mois=ctrl.mois.mois;
        delete ctrl.donnee;
        ctrl.loading = true;
        TableauBordService.getList(params).then(function(retour){
            if (retour.status === 'OK') {
                recalculeLibelleMois();
                initialiseChart();
                ctrl.donnee=retour.donnee[0];
                computeStatObject(ctrl.donnee);
                angular.forEach(retour.details, function (stat) {
                    stat.open=false;
                });
            }
            ctrl.loading = false;
        },function (error){
            $log.info(error);
            ctrl.loading = false;
        });
    }
    
    //####################  Récupération des statistiques  ####################

    
    
    function computeStatObject(retour) {
      angular.forEach(retour.graphique, function (stat) {
        ctrl.statistiques.ca.push(Number(stat.valeur));
        ctrl.statistiques.caprec.push(Number(stat.valeurPrec));
        ctrl.statistiques.difca.push(Number(stat.valeur) - Number(stat.valeurPrec));
        ctrl.statistiques.objectifs.push(Number(stat.objectif));
      });
    }

    //####################  Diagramme en barres  ####################
    function initialiseChart(){
        ctrl.statistiques = {
            ca: [],
            caprec: [],
            difca: [],
            objectifs: [],
            caActuel: [],
            caVise: [],
            compteurLabelFormat: []
        };
        var libelleMois = [];
        angular.forEach(ctrl.listeMois, function (mois) {
            libelleMois.push(mois.libelleGraph);
        });
        
        ctrl.chartConfig = {
          options: {
            chart: {
              type: 'areaspline',
              spacingTop: 40,
              height: 280
            },
            plotOptions: {}
          },
          xAxis: {
            categories: libelleMois
          },
          yAxis: {
            title: {
              text: 'Montant'
            }
          },
          series: [
            {
              type: "line",
              name: y,
              data: ctrl.statistiques.ca,
              tooltip: {
                valueSuffix: ' €'
              }
            },
            {
              type: "line",
              name: y - 1,
              data: ctrl.statistiques.caprec,
              tooltip: {
                valueSuffix: ' €'
              }
            },
            {
              type: "line",
              name: 'Objectif',
              data: ctrl.statistiques.objectifs,
              tooltip: {
                valueSuffix: ' €'
              },
              pointPlacement: "-0.2"
            },
            {
              type: "column",
              name: 'Ecart',
              data: ctrl.statistiques.difca,
              visible: false,
              tooltip: {
                valueSuffix: ' €'
              }
            }
          ],
          title: {
            text: ''
          },

          loading: false
        };
    }
    function getDonnee() {
      var retour = [];
      angular.forEach(ctrl.donnee.details, function (stat) {
          var d ={};
          angular.copy(stat,d);
          delete d.detailCompromis;
          delete d.open;
          retour.push(d);
      });
      return retour;
    }
    function getDetail() {
      var retour = [];
      angular.forEach(ctrl.donnee.details, function (stat) {
          angular.forEach(stat.detailCompromis, function (det) {
              var d ={};
              angular.copy(det,d);
              d.nego = stat.label;
              d.societe = stat.label2;
              retour.push(d);
          });
      });
      return retour;
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('statistiquemensuel', {
    templateUrl: 'app/components/main-content/statistique/statistiquemensuel/statistiquemensuel.html',
    controllerAs: 'statistiquemensuelctrl',
    bindings: {
    },
    controller: StatistiqueMensuelController
  });

  /** @ngInject */
  function StatistiqueMensuelController(globalService,
    StatistiqueMensuelService, 
    
    $uibModal, 
    $log, 
    $sce, 
    $timeout,
    moment,
    RepertoireService,
    $window,
    CONSTANTS) {
    var ctrl = this;
    //initialisation fonction
    ctrl.envoyerStatistique = envoyerStatistique;
    ctrl.toutSelectionner = toutSelectionner;
    
    ctrl.$onInit = initialisation;
    //initialisaton variable
    ctrl.listeMois = [{mois:0,label:'Janvier',libelleDate:'',cocher:false},
                      {mois:1,label:'Février',libelleDate:'',cocher:false},
                      {mois:2,label:'Mars',libelleDate:'',cocher:false},
                      {mois:3,label:'Avril',libelleDate:'',cocher:false},
                      {mois:4,label:'Mai',libelleDate:'',cocher:false},
                      {mois:5,label:'Juin',libelleDate:'',cocher:false},
                      {mois:6,label:'Juillet',libelleDate:'',cocher:false},
                      {mois:7,label:'Aout',libelleDate:'',cocher:false},
                      {mois:8,label:'Septembre',libelleDate:'',cocher:false},
                      {mois:9,label:'Octobre',libelleDate:'',cocher:false},
                      {mois:10,label:'Novembre',libelleDate:'',cocher:false},
                      {mois:11,label:'Decembre',libelleDate:'',cocher:false}];
    
    ctrl.listeStatistique=[{label:'Detail des locations',value:'detailLocation',location:true,transaction:false,listeMois:true,moisFin:false,adminSeulement:false},
                                   {label:'Detail des encaissements',value:'detailEncaissement',location:true,transaction:false,listeMois:true,moisFin:false,adminSeulement:false},
                                   {label:'Suivi Activite',value:'suiviActivite',location:true,transaction:false,listeMois:true,moisFin:false,adminSeulement:false},
                                   {label:'Ca par agence',value:'caAgence',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'Ca par négociateur',value:'caNegociateur',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'Ca par négociateur complet',value:'caNegociateurComplet',location:true,transaction:true,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'Nbre de Location par agence',value:'nbAgence',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'Nbre de Location par négociateur',value:'nbNegociateur',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'PrestaLoc et MRH par agence',value:'nbAgenceEasyLoc',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:true},
                                   {label:'PrestaLoc et MRH par négociateur',value:'nbNegociateurEasyLoc',location:true,transaction:false,listeMois:false,moisFin:true,adminSeulement:false},
                                   {label:'Taux de Conversion',value:'tauxConversion',location:true,transaction:false,listeMois:true,moisFin:false,adminSeulement:false},
                                   {label:'Reporting Commercial',value:'reportingCommercial',location:true,transaction:true,listeMois:true,moisFin:false,adminSeulement:true},
                                   {label:'Reporting Commercial Brut',value:'reportingCommercialBrut',location:true,transaction:true,listeMois:true,moisFin:false,adminSeulement:true},
                                   {label:'Ca Commercial',value:'caCommercial',location:false,transaction:true,listeMois:true,moisFin:false,adminSeulement:true}];
    ctrl.employe = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;
    ctrl.transac = globalService.getTypeApplication();
    ctrl.admin = false;
    ctrl.societes = {
      list: [],
      societe: null,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };
    
    ctrl.datepickers = {
      debut: {
        open: false,
        onClose: onCloseDatepicker
      }
    };
    
    //Liste des fonctions
    
    function initialisation() {
      
      if(ctrl.transac){
        if(ctrl.employe.societe.agence.jourTab===null || ctrl.employe.societe.agence.moisTab===null){
            ctrl.dateExercice = moment().date(1).month(0).format(CONSTANTS.date_format);
        }else if(ctrl.employe.societe.agence.moisTab>6){
            ctrl.dateExercice = moment().date(ctrl.employe.societe.agence.jourTab).month(ctrl.employe.societe.agence.moisTab-1).subtract(1,'years').format(CONSTANTS.date_format);
        }else{
            ctrl.dateExercice = moment().date(ctrl.employe.societe.agence.jourTab).month(ctrl.employe.societe.agence.moisTab-1).format(CONSTANTS.date_format);
        }
        if(ctrl.employe.profileTrans.id===1){
          ctrl.admin = true;
        }else{
          ctrl.admin = false;
        }
        searchInSocietes();
        recalculeLibelleMois();
        if(ctrl.admin){
            if(ctrl.transac==='Transaction'){
                ctrl.listeStatistiqueType=ctrl.listeStatistique.filter(function (e){ return e.transaction});
            }else{
                ctrl.listeStatistiqueType=ctrl.listeStatistique.filter(function (e){ return e.location });
            }
        }else{
            if(ctrl.transac==='Transaction'){
                ctrl.listeStatistiqueType=ctrl.listeStatistique.filter(function (e){ return e.transaction && !e.adminSeulement});
            }else{
                ctrl.listeStatistiqueType=ctrl.listeStatistique.filter(function (e){ return e.location && !e.adminSeulement });
            }
        }
        
      }else {
        $timeout(initialisation, 200);
      }
    }
    
    function searchInSocietes(input) {
      RepertoireService.getSocietesList({
        recherche: input || null,
        numero: 0,
        pas: 10
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeChanged() {
      searchInNegos();
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : null,
        numero: 0,
        pas: 15,
        typeMethode: 'liste'
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
        
    }
    
    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
      recalculeLibelleMois();
    }
    
    function recalculeLibelleMois(){
      var now = moment();
      angular.forEach(ctrl.listeMois, function(mois) {
        var datedebut = moment(ctrl.dateExercice,CONSTANTS.date_format).add(mois.mois,'M');
        mois.cocher = datedebut.isBefore(now);
        var libelleDate = datedebut.format('DD/MM')+' - '+datedebut.add(1,'M').subtract(1,'d').format('DD/MM');
        mois.libelleDate = libelleDate;
      });
      
    }
    
    function toutSelectionner(){
      angular.forEach(ctrl.listeMois, function(mois) {
        mois.cocher = true;
      });
    }
    
    function envoyerStatistique(){
        ctrl.loading = true;
        var params = {};
        var societeIds = [];
        angular.forEach(ctrl.societes.societe, function(soc) {
            $log.info(soc);
            societeIds.push(soc.id);
        });
        if(societeIds.length>0){
            params.societes = societeIds.join(',');
        }
        params.nego = ctrl.societes.nego ? ctrl.societes.nego.id : null;
        params.typeApplication = ctrl.transac;
        params.location = ctrl.transac==="Location"?true:false;
        params.typeStatistique = ctrl.typeStatistique.value;
        params.date = ctrl.dateExercice;
        params.sendmail = ctrl.email;
        params.isCitya = ctrl.citya;
        var moisreturn = [];
        angular.forEach(ctrl.listeMois, function(mois) {
            if(mois.cocher){
                moisreturn.push(mois.mois);
            }
        });
        params.mois=moisreturn.join(',');
        
        if(ctrl.typeStatistique.moisFin){
            params.moisfin=ctrl.moisFin.mois;
        }
        StatistiqueMensuelService.getList(params).then(function(retour){
            $log.info(retour);
            if (retour.status === 'OK') {
              $window.open(retour.chemin, '_blank');
            }
            ctrl.loading = false;
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocReservation', {
    templateUrl: 'app/components/main-content/reservations/bloc-reservation/bloc-reservation.html',
    controllerAs: 'blocreservationctrl',
    controller: BlocReservationController,
    bindings: {
      reservation: '<',
      onShowFiche: '&'
    }
  });

  /** @ngInject */
  function BlocReservationController(ContratsService, $log) {
    var ctrl = this;

    ctrl.titre = 'Réservation';

    ctrl.ribbon = {
      date: false,
      text: '',
      classe: ''
    };

    ctrl.retourGestion = {
      active: false,
      retourne: false,
      onRetourGestion: onRetourGestion
    };

    ctrl.showFiche = showFiche;

    ctrl.$onInit = function() {
      if (ctrl.reservation.hasDateFinOption()) {
        ctrl.ribbon.date = ctrl.reservation.dateFinOption;
        ctrl.ribbon.text = 'Fin le ';
        if (ctrl.reservation.isDateFinOptionDepassee() < 0) ctrl.ribbon.classe = 'cr-success';
        else if (ctrl.reservation.isDateFinOptionDepassee() == 0) ctrl.ribbon.classe = 'cr-warning';
        else if (ctrl.reservation.isDateFinOptionDepassee() > 0) ctrl.ribbon.classe = 'cr-danger';
        else ctrl.ribbon.classe = 'cr-primary';
      }
      if (ctrl.reservation.hasDatePrevueVente()) {
        ctrl.ribbon.date = ctrl.reservation.datePrevueVente;
        ctrl.ribbon.text = 'Validée le ';
        ctrl.ribbon.classe = 'cr-primary';
      }
      if (ctrl.reservation.hasDateEffectiveVente()) {
        if (!ctrl.citya) {
          ctrl.titre = 'Location';
          ctrl.retourGestion.active = ctrl.reservation.affaire.gestion;
          ctrl.retourGestion.retourne =
            angular.isDefined(ctrl.reservation.infoBail) && ctrl.reservation.infoBail.envoiEnGerance;
        }

        ctrl.ribbon.date = ctrl.reservation.dateEffectiveVente;
        ctrl.ribbon.text = 'Prévue le ';

        if (ctrl.reservation.isDateEffectiveReservationDepassee() < 0) ctrl.ribbon.classe = 'cr-success';
        else if (ctrl.reservation.isDateEffectiveReservationDepassee() == 0) ctrl.ribbon.classe = 'cr-warning';
        else if (ctrl.reservation.isDateEffectiveReservationDepassee() > 0) ctrl.ribbon.classe = 'cr-danger';
        else ctrl.ribbon.classe = 'cr-primary';
      }
      if (ctrl.reservation.hasDateSignature()) {
        if (ctrl.citya) {
          ctrl.titre = 'Location';
          ctrl.retourGestion.active = ctrl.reservation.affaire.gestion;
          ctrl.retourGestion.retourne =
            angular.isDefined(ctrl.reservation.infoBail) && ctrl.reservation.infoBail.envoiEnGerance;
        }
        ctrl.ribbon.date = ctrl.citya ? ctrl.reservation.dateSignature : ctrl.reservation.dateSignature;
        ctrl.ribbon.text = 'Signée le ';
        ctrl.ribbon.classe = 'cr-primary';
      }
      if (ctrl.reservation.hasDateEncaissement()) {
        ctrl.ribbon.date = ctrl.reservation.dateEncaissement;
        ctrl.ribbon.text = 'Loué le ';
        ctrl.ribbon.classe = 'cr-primary';
      }
    };

    function onRetourGestion() {
      if (ctrl.retourGestion.active) {
        ContratsService.reservations
          .retourGestion({
            idLocationEnGerance: ctrl.reservation.id
          })
          .then(function(retour) {
            if (retour.status === 'OK' && retour.retour) {
              ctrl.retourGestion.retourne = true;
            }
          })
          .catch(function(error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          });
      }
    }

    function showFiche() {
      ctrl.onShowFiche({ id: ctrl.reservation.id });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocParution', {
    templateUrl: 'app/components/main-content/parutions-ics-box/bloc-parution/bloc-parution.html',
    controllerAs: 'blocparutionctrl',
    controller: BlocParutionController,
    bindings: {
      parution: '<',
      template: '<',
      onHideMapParution: '&',
      onShowFiche: '&',
      onSetParution: '&',
      onMouseEnter: '&',
      onMouseLeave: '&',
      isLast: '<',
      onAllReady: '&',
      blocHeight: '<'
    }
  });

  /** @ngInject */
  function BlocParutionController(globalService, $element) {
    var ctrl = this;

    ctrl.imgSrc =
      ctrl.parution.lot && ctrl.parution.lot.multimediaPrincipal
        ? globalService.baseImgSrc() + ctrl.parution.lot.id + '/ipad/' + ctrl.parution.lot.multimediaPrincipal.fileName
        : 'assets/images/pictos/no_photo.jpg';

    ctrl.templateFile =
      'app/components/main-content/parutions-ics-box/bloc-parution/templates/' +
      (angular.isDefined(ctrl.template) && ctrl.template !== 'tablist'
        ? ctrl.template + '-blocparution-template.html'
        : 'grid-blocparution-template.html');

    ctrl.hideMapParution = hideMapParution;
    ctrl.showFiche = showFiche;
    ctrl.setParution = setParution;
    ctrl.imgReady = imgReady;

    ctrl.$onInit = function() {
      if (ctrl.template === 'tablist') {
        $element[0].addEventListener('mouseenter', mouseEnter);
        $element[0].addEventListener('mouseleave', ctrl.onMouseLeave);
      }
    };

    ctrl.$onDestroy = function() {
      if (ctrl.template === 'tablist') {
        $element[0].removeEventListener('mouseenter', mouseEnter);
        $element[0].removeEventListener('mouseleave', ctrl.onMouseLeave);
      }
    };

    function mouseEnter() {
      ctrl.onMouseEnter({ parution: ctrl.parution });
    }

    function hideMapParution() {
      ctrl.onHideMapParution();
    }

    function showFiche() {
      ctrl.onShowFiche({ refLot: ctrl.parution.lot.referenceInterne });
    }

    function setParution(action) {
      ctrl.onSetParution({ lotId: ctrl.parution.lot.id, action: action });
    }

    function imgReady() {
      if (angular.isDefined(ctrl.isLast) && ctrl.isLast) ctrl.onAllReady();
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocPanneau', {
    templateUrl: 'app/components/main-content/panneaux/bloc-panneau/bloc-panneau.html',
    controllerAs: 'blocpanneauctrl',
    controller: BlocPanneauController,
    bindings: {
      panneau: '<',
      template: '<',
      onShowFiche: '&',
      onMouseEnter: '&',
      onMouseLeave: '&',
      isLast: '<',
      onAllReady: '&',
      blocHeight: '<'
    }
  });

  /** @ngInject */
  function BlocPanneauController(
    CONSTANTS,
    globalService,
    PanneauxService,
   
    $element,
    moment,
    $log
  ) {
    var ctrl = this;

    ctrl.transac = globalService.getTypeApplication();
    ctrl.employe = globalService.getEmploye();

    ctrl.imgSrc = ctrl.panneau.hasMultimediaPrincipal()
      ? globalService.baseImgSrc() + ctrl.panneau.id + '/ipad/' + ctrl.panneau.multimediaPrincipal.fileName
      : 'assets/images/pictos/no_photo.jpg';

    ctrl.templateFile =
      'app/components/main-content/panneaux/bloc-panneau/templates/' +
      (angular.isDefined(ctrl.template)
        ? ctrl.template + '-blocpanneau-template.html'
        : 'grid-blocpanneau-template.html');

    ctrl.eventsPath = 'evenementsPanneau' + (ctrl.transac === 'Location' ? 'Location' : '');
    ctrl.eventId = null;

    ctrl.texts = {
      panneau: '',
      vendre: ctrl.transac === 'Transaction' ? 'A vendre' : 'A louer',
      vendu: ctrl.transac === 'Transaction' ? 'Vendu' : 'Loue'
    };

    ctrl.hasPanneau = false;

    ctrl.getPanneauText = getPanneauText;
    ctrl.setPanneau = setPanneau;
    ctrl.hideMapPanneau = hideMapPanneau;
    ctrl.showFiche = showFiche;
    ctrl.imgReady = imgReady;

    ctrl.$onInit = function() {
      if (ctrl.template === 'tablist') {
        $element[0].addEventListener('mouseenter', mouseEnter);
        $element[0].addEventListener('mouseleave', ctrl.onMouseLeave);
      }
      ctrl.hasPanneau = getLastPanneau();
      ctrl.texts.panneau = getPanneauText();
    };

    ctrl.$onDestroy = function() {
      if (ctrl.template === 'tablist') {
        $element[0].removeEventListener('mouseenter', mouseEnter);
        $element[0].removeEventListener('mouseleave', ctrl.onMouseLeave);
      }
    };

    function getLastPanneau() {
      var index = 0,
        active = false;
      if (ctrl.panneau[ctrl.eventsPath].length) {
        if (ctrl.panneau[ctrl.eventsPath].length === 1) {
          ctrl.eventId = ctrl.panneau[ctrl.eventsPath][index].id;
        } else {
          for (var i = 1; i < ctrl.panneau[ctrl.eventsPath].length; i++) {
            if (
              ctrl.panneau[ctrl.eventsPath][i].id > ctrl.panneau[ctrl.eventsPath][index].id &&
              (!active || (active && ctrl.panneau[ctrl.eventsPath][i].active))
            ) {
              index = i;
              ctrl.eventId = ctrl.panneau[ctrl.eventsPath][i].id;
            }
          }
        }
      } else {
        return false;
      }

      if (angular.isDefined(ctrl.panneau[ctrl.eventsPath][index].type)) {
        if (ctrl.panneau[ctrl.eventsPath][index].type.data === 3102) {
          return null;
        } else if (
          angular.isDefined(ctrl.panneau[ctrl.eventsPath][index].active) &&
          !ctrl.panneau[ctrl.eventsPath][index].active
        ) {
          return 'retire';
        } else {
          return true;
        }
      } else {
        return false;
      }
    }

    function getEvent() {
      var event = ctrl.panneau[ctrl.eventsPath].filter(function(panneau) {
        return panneau.id === ctrl.eventId;
      });
      if (event.length) {
        return event[0];
      } else {
        return null;
      }
    }

    function getPanneauText() {
      var event = getEvent();
      if (ctrl.hasPanneau === null) {
        if (event.type) {
          return '<small class="panneau-date">' + event.date + '</small> Impossible';
        } else {
          return 'Erreur (B-PAN-140)';
        }
      } else if (event) {
        var retireText = ctrl.hasPanneau === 'retire' ? ' (Retir&eacute;)' : '';
        if (event.type) {
          if (event.type.label) {
            return (
              '<small class="panneau-date">' +
              event.date +
              '</small> ' +
              event.type.label.replace('Panneau - ', '') +
              retireText
            );
          } else {
            if (event.type.data) {
              switch (event.type.data) {
                case 200:
                  return '<small class="panneau-date">' + event.date + '</small> A vendre' + retireText;
                case 201:
                  return '<small class="panneau-date">' + event.date + '</small> Vendu' + retireText;
                case 3000:
                  return '<small class="panneau-date">' + event.date + '</small> A louer' + retireText;
                case 3001:
                  return '<small class="panneau-date">' + event.date + '</small> Loue' + retireText;
              }
            }
          }
        } else {
          return 'Erreur (B-PAN-134)';
        }
      } else {
        return 'Aucun';
      }
    }

    function setPanneau(action) {
      var event = false,
        index = 0;
      switch (action) {
        case 'vendre':
          event = {
            lot: { id: ctrl.panneau.id, type: ctrl.panneau.type },
            negociateur: { id: ctrl.employe.id },
            active: true,
            date: moment().format(CONSTANTS.date_format),
            type: { data: ctrl.transac === 'Transaction' ? 200 : 3000 }
          };
          break;
        case 'vendu':
          event = {
            lot: { id: ctrl.panneau.id, type: ctrl.panneau.type },
            negociateur: { id: ctrl.employe.id },
            active: true,
            date: moment().format(CONSTANTS.date_format),
            type: { data: ctrl.transac === 'Transaction' ? 201 : 3001 }
          };
          break;
        case 'aucun':
          for (var i = 0; i < ctrl.panneau[ctrl.eventsPath].length; i++) {
            if (ctrl.panneau[ctrl.eventsPath][i].id === ctrl.eventId) {
              ctrl.panneau[ctrl.eventsPath][i].lot = { id: ctrl.panneau.id, type: ctrl.panneau.type };
              ctrl.panneau[ctrl.eventsPath][i].negociateur = { id: ctrl.employe.id };
              ctrl.panneau[ctrl.eventsPath][i].active = false;
              index = i;
            }
          }
          break;
        case 'impossible':
          event = {
            lot: { id: ctrl.panneau.id, type: ctrl.panneau.type },
            negociateur: { id: ctrl.employe.id },
            active: true,
            date: moment().format(CONSTANTS.date_format),
            type: { data: 3102 }
          };
          break;
      }

      event = event || ctrl.panneau[ctrl.eventsPath][index];

      PanneauxService.setPanneau({
        xml: angular.toJson(event),
        lotid: ctrl.panneau.id,
        typeIds: event.type.data,
        typeApplication: ctrl.transac
      }).then(function(retour) {
        $log.info(retour);
        ctrl.panneau[ctrl.eventsPath] = retour.list;
        ctrl.hasPanneau = getLastPanneau();
        ctrl.texts.panneau = getPanneauText();
      });
    }

    function mouseEnter() {
      ctrl.onMouseEnter({ panneau: ctrl.panneau });
    }

    function hideMapPanneau() {
      ctrl.onHideMapPanneau();
    }

    function showFiche() {
      ctrl.onShowFiche({ refLot: ctrl.panneau.referenceInterne });
    }

    function imgReady() {
      if (angular.isDefined(ctrl.isLast) && ctrl.isLast) ctrl.onAllReady();
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('infoBail', {
    templateUrl: 'app/components/main-content/modif-reservation/info-bail/info-bail.html',
    controllerAs: 'infobailctrl',
    controller: InfoBailController,
    bindings: {
      reservation: '=',
      isDisabled: '<'
    }
  });

  /** @ngInject */
  function InfoBailController(CONSTANTS, globalService, ReferencesService, moment, $attrs, $log) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.disabled = $attrs.isDisabled && angular.isDefined(ctrl.isDisabled) ? ctrl.isDisabled : false;

    ctrl.isLoading = false;

    ctrl.typeBaux = [];
    ctrl.periodicite = [];
    ctrl.indice = [];
    ctrl.valIndiceBase = '';

    ctrl.datepickers = {
      datePriseEffet: false,
      finPrevue: false,
      dateEntree: false,
      appelLoyer: false,
      appelProvision: false,
      close: function(datepicker) {
        ctrl.datepickers[datepicker] = false;
      }
    };

    ctrl.getTypesBail = getTypesBail;
    ctrl.setDefaultFinPrevu = setDefaultFinPrevu;
    ctrl.changeFinPrevu = changeFinPrevu;
    
    ctrl.$onInit = function() {
      ctrl.reservation.infoBail = ctrl.reservation.infoBail || {};

      ctrl.reservation.infoBail.idbail =
        ctrl.reservation.infoBail.idbail || ctrl.reservation.affaire.mandatLocation.idBailGestion;
      ctrl.reservation.infoBail.loyerPrinc =
        ctrl.reservation.infoBail.loyerPrinc || ctrl.reservation.affaire.mandatLocation.loyer;
      ctrl.reservation.infoBail.provisionCharge =
        ctrl.reservation.infoBail.provisionCharge || ctrl.reservation.affaire.mandatLocation.charges;
      ctrl.reservation.infoBail.provisionAutre =
        ctrl.reservation.infoBail.provisionAutre || ctrl.reservation.affaire.mandatLocation.autresCharges;
      ctrl.reservation.infoBail.depotGarantie =
        ctrl.reservation.infoBail.depotGarantie || ctrl.reservation.affaire.mandatLocation.depotGarantie;

      if (ctrl.reservation.dateEffectiveVente) {
        ctrl.reservation.infoBail.datePriseEffet =
          ctrl.reservation.infoBail.datePriseEffet || ctrl.reservation.dateEffectiveVente;
        ctrl.reservation.infoBail.dateEntree =
          ctrl.reservation.infoBail.dateEntree || ctrl.reservation.dateEffectiveVente;
        ctrl.reservation.infoBail.appelLoyer =
          ctrl.reservation.infoBail.appelLoyer || ctrl.reservation.dateEffectiveVente;
        ctrl.reservation.infoBail.appelProvision =
          ctrl.reservation.infoBail.appelProvision || ctrl.reservation.dateEffectiveVente;
      }

      getTypesBail();
    };

    function getTypesBail() {
      ctrl.isLoading = true;
      ReferencesService.getReferences({
        classes: 'TypeBaux,Periodicite,Indice',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.typeBaux = json.list.TypeBaux;
            ctrl.periodicite = json.list.Periodicite;

            if (ctrl.citya) {
              var lasts = { I: '0', C: '0', L: '0', T: '0' },
                current = null;
              json.list.Indice.forEach(function(indice) {
                if (indice === ctrl.reservation.infoBail.indiceBase) {
                  current = indice;
                } else if (indice.type) {
                  var letter = indice.type.charAt(0),
                    num = indice.type.substring(1);

                  lasts[letter] = num > lasts[letter] ? num : lasts[letter];
                }
              });

              ctrl.indice = json.list.Indice.filter(function(indice) {
                var isLast = false;
                angular.forEach(lasts, function(num, letter) {
                  if (letter + num === indice.type) {
                    isLast = true;
                  }
                });
                return isLast;
              });
              if (current) {
                ctrl.indice.push(current);
              }
            } else {
              ctrl.indice = json.list.Indice;
            }

            if (ctrl.reservation.infoBail.typeBaux == null && ctrl.reservation.affaire.mandatLocation.typebailid) {
              ctrl.reservation.infoBail.typeBaux =
                ctrl.typeBaux.filter(function(bail) {
                  return bail.codeBail === parseInt(ctrl.reservation.affaire.mandatLocation.typebailid);
                })[0] || null;
            }

            if (ctrl.reservation.infoBail.periode == null && ctrl.reservation.affaire.mandatLocation.periodbailid) {
              ctrl.reservation.infoBail.periode =
                ctrl.periodicite.filter(function(periode) {
                  return periode.code === parseInt(ctrl.reservation.affaire.mandatLocation.periodbailid);
                })[0] || null;
            }
          }
          ctrl.isLoading = false;
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function setDefaultFinPrevu() {
      if (ctrl.reservation.infoBail.datePriseEffet && !ctrl.reservation.infoBail.finPrevue) {
        ctrl.reservation.infoBail.finPrevue = moment(ctrl.reservation.infoBail.datePriseEffet, CONSTANTS.date_format)
          .add(3, 'years')
          .subtract(1, 'days')
          .format(CONSTANTS.date_format);
      }
    }
    function changeFinPrevu() {
      if (ctrl.reservation.infoBail.datePriseEffet && ctrl.reservation.infoBail.typeBaux) {
        var nbYear = ctrl.reservation.infoBail.typeBaux.dureeBail.aa;
        var nbMonth = ctrl.reservation.infoBail.typeBaux.dureeBail.mm;
        if(ctrl.reservation.infoBail.dureeParticulierBail){
            if( ctrl.reservation.infoBail.dureeParticulierBail.aa){
                nbYear = ctrl.reservation.infoBail.dureeParticulierBail.aa;
            }
            if(ctrl.reservation.infoBail.dureeParticulierBail.mm){
                nbMonth = ctrl.reservation.infoBail.dureeParticulierBail.mm;
            }
        }
        $log.info(nbYear);
        ctrl.reservation.infoBail.finPrevue = moment(ctrl.reservation.infoBail.datePriseEffet, CONSTANTS.date_format)
          .add(nbYear, 'years')
          .add(nbMonth, 'months')
          .subtract(1, 'days')
          .format(CONSTANTS.date_format);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('prospectPanier', {
    templateUrl: 'app/components/main-content/modif-prospect/prospect-panier/prospect-panier.html',
    controllerAs: 'prospectpanierctrl',
    controller: ProspectPanierController,
    bindings: {
      prospect: '<',
      isLoading: '<'
    }
  });

  /** @ngInject */
  function ProspectPanierController(
    CONSTANTS,
    globalService,

    CustomUtils,
    PanierService,
    EvenementsService,
    VisiteService,
    ContratsService,
    ImpressionService,
    MailService,
    Prospect,
    $uibModal,
    ngDialog,
    CriteresParser,
    $rootScope,
    $scope,
    $state,
    $element,
    $timeout,
    $window,
    moment,
    $ocLazyLoad,
    toastr,
    $log
  ) {
    var ctrl = this;

    ctrl.globalService = globalService;
    ctrl.employe = globalService.getEmploye();

    ctrl.panier = {
      list: [],
      refList: [],
      nb: 0,
      getList: getList,
      onChange: onPanierChange,
      supprBien: supprBien,
      supprAllBien: supprAllBien
    };

    ctrl.evenement = {
      open: false,
      refLot: null,
      currentId: null,
      nouveau: null,
      fullScreen: false,
      onNouveau: onNewEvent,
      onChose: onChoseDate,
      onEdit: onEditEvent,
      onAnnuler: onAnulerEvent,
      onClose: onCloseEvent,
      onFullScreen: onFullScreen
    };

    ctrl.calendar = {
      reloading: false,
      events: [],
      title: '',
      view: 'day',
      viewDate: moment()
        .startOf('day')
        .toDate(),
      date: null,
      dateFin: null,
      onClick: onClickCalendar
    };

    ctrl.bonVisite = {
      selection: [],
      generer: genererBonVisite
    };

    ctrl.envoyerEmail = envoyerEmail;
    ctrl.imprimer = imprimer;
    ctrl.ajouterDesBiens = ajouterDesBiens;
    ctrl.showFiche = showFiche;
    ctrl.newContrat = newContrat;
    ctrl.toggleSelection = toggleSelection;
    ctrl.selectAll = selectAll;
    ctrl.onEvent = onEvent;
    ctrl.imgResize = imgResize;

    ctrl.$onInit = function () {
      ctrl.panier.getList();

      $window.moment = $window.moment || moment;
      $ocLazyLoad.load('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.10.6/locale/fr.js').then(function () {
        moment.locale('fr', {
          week: {
            dow: 1
          }
        });
        moment.locale('fr');
      });
    };

    $scope.$watch(
      function () {
        return ctrl.calendar.date;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          ctrl.calendar.viewDate = moment(newValue, CONSTANTS.date_format).toDate();
          getEvents();
        }
      },
      true
    );

    function onPanierChange() {
      $rootScope.$emit('nbPanierChange', {
        nb: ctrl.panier.nb
      });
    }

    function getList() {
      if (ctrl.prospect) {
        ctrl.isLoading = true;
        ctrl.panier.list = [];
        ctrl.panier.nb = 0;

        PanierService.getPanier({
          prospect: ctrl.prospect.referenceInterne,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        }).then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.panier.list = retour.list;
              ctrl.panier.nb = retour.nb;
              onPanierChange();

              ctrl.panier.refList = [];
              angular.forEach(ctrl.panier.list, function (property) {
                ctrl.panier.refList.push(property.lot.referenceInterne);
              });
            }

            ctrl.isLoading = false;
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.isLoading = false;
          }
        );
      } else {
        $timeout(getList, 200);
      }
    }

    function supprBien(refLot) {
      ctrl.isLoading = true;
      ctrl.panier.list = [];
      ctrl.panier.nb = 0;

      PanierService.setPanier({
        prospect: ctrl.prospect.referenceInterne,
        lot: refLot,
        action: 'suppr',
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            onPanierChange();

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (property) {
              ctrl.panier.refList.push(property.lot.referenceInterne);
            });
          }

          ctrl.isLoading = false;
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        }
      );
    }

    function supprAllBien() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous retirer tous les biens de ce panier ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return false;
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          ctrl.panier.loading = true;
          ctrl.panier.list = [];
          ctrl.panier.nb = 0;

          PanierService.setPanier({
              prospect: ctrl.prospect.referenceInterne,
              action: 'supprAll',
              typeMethode: 'liste',
              typeApplication: globalService.getTypeApplication()
            })
            .then(function (retour) {
              if (retour.status === 'OK') {
                ctrl.panier.list = retour.list;
                ctrl.panier.nb = retour.nb;
                onPanierChange({
                  nb: ctrl.panier.nb
                });

                ctrl.panier.refList = [];
                angular.forEach(ctrl.panier.list, function (property) {
                  ctrl.panier.refList.push(property.lot.referenceInterne);
                });
              } else {
                onPanierChange({
                  nb: 0
                });
              }

              ctrl.panier.loading = false;
            })
            .catch(function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') {
                  $log.warn(error.message);
                  onPanierChange({
                    nb: 0
                  });
                } else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.panier.loading = false;
            });
        }
      });
    }

    function envoyerEmail(refLot) {
      if (angular.isUndefined(refLot)) {
        refLot = '';
        angular.forEach(ctrl.panier.list, function (property, index) {
          refLot += property.lot.referenceInterne;
          if (index <= ctrl.panier.list.length) refLot += ',';
        });
      }

      openMailForm(refLot, ctrl.prospect);
    }

    function imprimer() {
      var impression = {
        lotsid: ''
      };

      angular.forEach(ctrl.panier.list, function (lot, index) {
        impression.lotsid += lot.lot.id;
        if (index < ctrl.panier.list.length - 1) impression.lotsid += ',';
      });

      ImpressionService.openImpression(impression);
    }

    function openMailForm(refLot, prospect) {
      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== liste-bien.component.js l.663");
          }
        });
      });
    }

    function ajouterDesBiens() {
      $rootScope.$emit('prospectPanierChange', {
        prospect: ctrl.prospect,
        nb: ctrl.panier.nb
      });

      var query = globalService.getStorageItem('QUERY-LISTE-BIEN') || {
        search: null
      };

      query.search = CriteresParser.prospectToSearch(ctrl.prospect);

      globalService.setStorageItem('QUERY-LISTE-BIEN', query);
      $state.go('listeBien');
    }

    function showFiche(refLot) {
      $rootScope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.panier.refList
      });
    }

    function newContrat(refLot) {
      if (ctrl.prospect) {
        var query = {
            lotRef: refLot,
            prospectRef: ctrl.prospect.referenceInterne
          },
          request;
        if (globalService.getTypeApplication() === 'Transaction') {
          request = ContratsService.compromis.nouveau(query);
        } else {
          request = ContratsService.reservations.nouvelle(query);
        }

        request.then(function (retour) {
          if (retour.status === 'OK') {
            if (globalService.getTypeApplication() === 'Transaction') {
              $state.go('modifCompromis', {
                reference: retour.compromis.id
              });
            } else {
              $state.go('modifReservation', {
                reference: retour.reservation.id
              });
            }
          }
        });
      }
    }

    function genererBonVisite() {
      if (ctrl.bonVisite.selection.length) {
        ctrl.panier.loading = true;

        var idList = '';

        angular.forEach(ctrl.bonVisite.selection, function (id, index) {
          idList += id;

          if (index < ctrl.bonVisite.selection.length - 1) {
            idList += ',';
          }
        });

        VisiteService.bonVisite({
            lotIdsVisite: idList,
            prospectId: ctrl.prospect.id
          })
          .then(function (retour) {
            $log.info(retour);
            var url = globalService.baseUrl() + 'Download';

            if (globalService.getTypeApplication() === 'Location') {
              url += 'Location';
            }

            url += '?edition=edition&filename=' + retour.fileName + '&path=' + retour.path;

            $window.open(url, '_blank');

            ctrl.panier.loading = false;
          })
          .catch(function (error) {
            $log.info(error);
            ctrl.panier.loading = false;
          });
      } else {
        toastr.warning(
          'Vous devez s&eacute;lectionner au moins un bien pour pouvoir g&eacute;n&eacute;rer un bon de visite.<br>',

          'Aucun bien s&eacute;lectionn&eacute;<br>',

          {
            timeOut: 8000
          }
        );
      }
    }

    function toggleSelection(refLot, idLot, selected) {
      if (selected) {
        $log.info('Ajouter le lot : [ ' + refLot + ' ] à la sélection.');

        if (!CustomUtils.collection.contains(ctrl.bonVisite.selection, idLot)) {
          ctrl.bonVisite.selection.push(idLot);
        }

        $rootScope.$emit('ajouterSelection', {
          refLot: refLot
        });
      } else {
        $log.info('Retirer le lot : [ ' + refLot + ' ] de la sélection.');

        ctrl.bonVisite.selection = ctrl.bonVisite.selection.filter(function (id) {
          return id !== idLot;
        });

        $rootScope.$emit('retirerSelection', {
          refLot: refLot
        });
      }
    }

    function selectAll() {
      ctrl.allSelected = !ctrl.allSelected;
      angular.forEach(ctrl.panier.list, function (lot) {
        lot.lot.isSelected = ctrl.allSelected;
        toggleSelection(lot.lot.referenceInterne, lot.lot.id, lot.lot.isSelected);
      });
    }

    function onEvent(refLot, event) {
      ctrl.evenement.refLot = refLot;
      if (event) {
        ctrl.evenement.currentId = event.id;
        ctrl.calendar.viewDate = ctrl.calendar.date = moment(event.date, CONSTANTS.date_format).toDate();
        ctrl.evenement.nouveau = true;
      } else {
        ctrl.calendar.viewDate = ctrl.calendar.date = moment()
          .startOf('day')
          .toDate();
      }
      ctrl.evenement.open = true;
      getEvents();
    }

    function onChoseDate(formatedDatetime) {
      ctrl.evenement.datetime = formatedDatetime;
      addEvent(ctrl.evenement.refLot, formatedDatetime);
      onCloseEvent();
    }

    function onEditEvent(refLot, event) {
      ctrl.isLoading = true;

      PanierService.evenement({
          prospect: ctrl.prospect.referenceInterne,
          lot: refLot,
          evenementId: event.id,
          dateEvenement: event.date,
          dateFinEvenement: event.dateFin ? event.dateFin : null,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (property) {
              ctrl.panier.refList.push(property.lot.referenceInterne);
            });
          }

          ctrl.isLoading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function onNewEvent(date, dateFin) {
      ctrl.evenement.currentId = null;
      addEvent(ctrl.evenement.refLot, date, dateFin);
    }

    function onAnulerEvent() {
      PanierService.evenement({
          prospect: ctrl.prospect.referenceInterne,
          lot: ctrl.evenement.refLot,
          evenementId: ctrl.evenement.currentId,
          annuler: true,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (property) {
              ctrl.panier.refList.push(property.lot.referenceInterne);
            });
          }

          ctrl.isLoading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function onClickCalendar(calendarDate) {
      ctrl.calendar.reloading = true;
      ctrl.calendar.date = moment(calendarDate).format(CONSTANTS.date_format);
      $timeout(function () {
        ctrl.calendar.reloading = false;
      });
    }

    function onCloseEvent() {
      ctrl.evenement.open = false;
      ctrl.evenement.refLot = null;
      ctrl.evenement.currentId = null;
      ctrl.evenement.nouveau = false;
      ctrl.evenement.fullScreen = false;
    }

    function onFullScreen(fullScreen) {
      ctrl.evenement.fullScreen = fullScreen;
    }

    function addEvent(refLot, date) {
      PanierService.evenement({
        prospect: ctrl.prospect.referenceInterne,
        lot: refLot,
        dateEvenement: date,
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (property) {
              ctrl.panier.refList.push(property.lot.referenceInterne);
            });
          }

          ctrl.isLoading = false;
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        }
      );
    }

    function getEvents() {
      if (moment(ctrl.calendar.viewDate).isValid()) {
        EvenementsService.getList({
            nego: ctrl.employe.id,
            debut: moment(ctrl.calendar.viewDate)
              .startOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            fin: moment(ctrl.calendar.viewDate)
              .endOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            forAgenda: true,
            active: true,
            typeMethode: 'complete'
          })
          .then(function (retour) {
            if (retour.status === 'OK') {
              ctrl.calendar.events = retour.list;
              setEvents();
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          });
      }
    }

    function setEvents() {
      angular.forEach(ctrl.calendar.events, function (event) {
        event.title = event.commentaire;
        event.color = {
          primary: event.color || event.type.couleur.replace('0x', '#'),
          secondary: shadeBlend(-0.2, event.type.couleur.replace('0x', '#'))
        };
        event.startsAt = moment(event.date, CONSTANTS.date_format).toDate();
        event.endsAt = event.dateFin ?
          moment(event.dateFin, CONSTANTS.date_format).toDate() :
          moment(event.date, CONSTANTS.date_format)
          .add(1, 'h')
          .toDate();
      });
    }

    function shadeBlend(p, c0, c1) {
      var n = p < 0 ? p * -1 : p,
        u = Math.round,
        w = parseInt,
        f,
        t;
      if (c0.length > 7) {
        f = c0.split(',');
        t = (c1 ? c1 : p < 0 ? 'rgb(0,0,0)' : 'rgb(255,255,255)').split(',');
        var R = w(f[0].slice(4)),
          G = w(f[1]),
          B = w(f[2]);
        return (
          'rgb(' +
          (u((w(t[0].slice(4)) - R) * n) + R) +
          ',' +
          (u((w(t[1]) - G) * n) + G) +
          ',' +
          (u((w(t[2]) - B) * n) + B) +
          ')'
        );
      } else {
        f = w(c0.slice(1), 16);
        t = w((c1 ? c1 : p < 0 ? '#000000' : '#FFFFFF').slice(1), 16);
        var R1 = f >> 16,
          G1 = (f >> 8) & 0x00ff,
          B1 = f & 0x0000ff;
        return (
          '#' +
          (0x1000000 +
            (u(((t >> 16) - R1) * n) + R1) * 0x10000 +
            (u((((t >> 8) & 0x00ff) - G1) * n) + G1) * 0x100 +
            (u(((t & 0x0000ff) - B1) * n) + B1)
          )
          .toString(16)
          .slice(1)
        );
      }
    }

    function imgResize() {
      var img = $element.find('.property-img'),
        imgRect = img[0].getBoundingClientRect(),
        width = imgRect.width,
        height = (width - 30) * 3 / 4 + 30;

      img.parent().css('height', height + 'px');
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('criteresProspect', {
    templateUrl: 'app/components/main-content/modif-prospect/criteres-prospect/criteres-prospect.html',
    controllerAs: 'criteresprospectctrl',
    bindings: {
      prospect: '=',
      isLoading: '=',
      validation: '='
    },
    controller: CriteresProspectController
  });

  /** @ngInject */
  function CriteresProspectController(
   
    PropertiesService,
    LocalisationService,
    ReferencesService,
    globalService,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.transac = globalService.getTypeApplication();

    ctrl.prix = {
      open: true,
      required: true,
      onChange: onChangePrix,
      getLabel: getPrixLabel
    };

    ctrl.types = {
      open: true,
      loading: false,
      required: true,
      list: [],
      getTypes: getTypes,
      toggleType: toggleType
    };

    ctrl.villes = {
      open: true,
      loading: false,
      selected: [],
      list: [],
      getVilles: getVilles,
      setVilles: setVilles
    };

    ctrl.references = {
      classes: '',
      loading: false,
      list: [],
      checked: {},
      getReferences: getReferences
    };

    ctrl.criteresSupp = {
      show: false,
      open: true,
      loading: false,
      list: [],
      getCriteres: getCriteres,
      setCriteres: setCriteres
    };

    ctrl.orderByArray = [
      function(a) {
        return a['posPage' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function(a) {
        return a['posLigne' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function(a) {
        return a['posCol' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      }
    ];

    function setLoading() {
      ctrl.isLoading =
        ctrl.types.loading || ctrl.villes.loading || ctrl.references.loading || ctrl.criteresSupp.loading;
    }

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.prospect) {
        getTypes();
        getCriteres();
        if (ctrl.prospect.hasVilles()) ctrl.villes.selected = ctrl.prospect.villes;
        if (!ctrl.prospect.hasPrixMin()) ctrl.prospect.prixMin = null;
        if (!ctrl.prospect.hasPrixMax()) ctrl.prospect.prixMax = null;
      } else {
        $timeout(function() {
          initialisation();
        }, 200);
      }
    }

    function onChangePrix() {
      ctrl.prix.required = !(ctrl.prospect.hasPrixMin() || ctrl.prospect.hasPrixMax());
    }

    function getTypes() {
      ctrl.types.loading = true;

      PropertiesService.getTypesBiens({
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(retour) {
          if (retour.status === 'OK') {
            ctrl.types.list = retour.list;
            if (ctrl.prospect.hasTypesBien()) {
              ctrl.types.required = false;
              angular.forEach(ctrl.types.list, function(type) {
                type.checked =
                  ctrl.prospect.typesBien.filter(function(current) {
                    return current.id === type.id;
                  }).length > 0
                    ? true
                    : null;
              });

              ctrl.criteresSupp.show = ctrl.prospect.hasTypesBien();
            }
          }
          ctrl.types.loading = false;
          setLoading();
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.types.loading = false;
          setLoading();
        });
    }

    function toggleType() {
      ctrl.prospect.typesBien = ctrl.types.list.filter(function(current) {
        return current.checked;
      });

      var hasTypes = ctrl.prospect.hasTypesBien();
      ctrl.validation.typesBien.$setValidity('required', !hasTypes);
      ctrl.types.required = !hasTypes;
      ctrl.criteresSupp.show = hasTypes;
      if (hasTypes) {
        getCriteres();
      }
    }

    function getVilles(input) {
      ctrl.villes.loading = true;
      ctrl.villes.list = [];

      LocalisationService.getVillesByQuery({
        recherche: input,
        typeMethode: 'complete',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.villes.list = json.list;
          }
          ctrl.villes.loading = false;
          setLoading();
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.villes.loading = false;
          setLoading();
        });
    }

    function setVilles() {
      ctrl.prospect.villes = ctrl.villes.selected;
    }

    function getReferences() {
      ctrl.references.loading = true;

      PropertiesService.getReferences({
        classes: ctrl.references.classes,
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.references.list = json.list;

            angular.forEach(ctrl.criteresSupp.list, function(critere) {
              var prospectCrit = ctrl.prospect.criteres.filter(function(current) {
                return critere.id === current.critere.id;
              })[0];
              switch (critere.type) {
                case 'int':
                  if (prospectCrit && (prospectCrit.intMin || prospectCrit.intMax)) {
                    critere.intMin = prospectCrit.intMin;
                    critere.intMax = prospectCrit.intMax;
                  } else {
                    critere.intMin = null;
                    critere.intMax = null;
                  }
                  break;

                case 'float':
                  if (prospectCrit && (prospectCrit.floatMin || prospectCrit.floatMax)) {
                    critere.floatMin = prospectCrit.floatMin;
                    critere.floatMax = prospectCrit.floatMax;
                  } else {
                    critere.floatMin = null;
                    critere.floatMax = null;
                  }
                  break;

                case 'boolean':
                  if (prospectCrit && (angular.isDefined(prospectCrit.bool) && prospectCrit.bool !== null)) {
                    critere.bool = prospectCrit.bool;
                  } else {
                    critere.bool = null;
                  }
                  break;

                case 'date':
                  if (prospectCrit && (angular.isDefined(prospectCrit.date) && prospectCrit.date !== null)) {
                    critere.date = prospectCrit.date;
                  } else {
                    critere.date = null;
                  }
                  break;

                case 'combo':
                  ctrl.references.checked[critere.classeValeursName] = [];
                  if (prospectCrit) {
                    angular.forEach(ctrl.references.list[critere.classeValeursName], function(reference) {
                      angular.forEach(prospectCrit.combo, function(critReference) {
                        if (reference.id === critReference.id)
                          ctrl.references.checked[critere.classeValeursName].push(reference);
                      });
                    });
                  }
                  break;
              }
            });
          }
          ctrl.references.loading = false;
          setLoading();
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.references.loading = false;
          setLoading();
        });
    }

    function getCriteres() {
      ctrl.criteresSupp.loading = true;

      var params = {
        typeApplication: globalService.getTypeApplication()
      };

      if (ctrl.prospect.hasTypesBien()) {
        if (ctrl.prospect.typesBien.length > 1) {
          params.typeBien = 'lot';
        } else {
          params.typeBien = ctrl.prospect.typesBien[0].simpleData;
          params.afficher = true;
        }
      }

      ReferencesService.getCritereListe(params)
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.criteresSupp.list = json.list.filter(function(critere) {
              return critere['rapprocher' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
            });
            ctrl.references.classes = '';
            angular.forEach(ctrl.criteresSupp.list, function(critere, index) {
              if (angular.isDefined(critere.classeValeurs)) {
                var splited = critere.classeValeurs.split('.');
                critere.classeValeursName = splited[splited.length - 1];
                ctrl.references.classes += critere.classeValeursName;

                if (index < ctrl.criteresSupp.list.length - 1) ctrl.references.classes += ',';
              }
            });
            getReferences();
          } else {
            ctrl.criteresSupp.list = [];
          }
          ctrl.criteresSupp.loading = false;
          setLoading();
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.criteresSupp.list = [];
          ctrl.criteresSupp.loading = false;
          setLoading();
        });
    }

    function setCriteres() {
      var tmp = [];

      angular.forEach(ctrl.criteresSupp.list, function(critere) {
        var current = {
          obligatoire: true,
          critere: {
            id: critere.id,
            nomChamp: critere.nomChamp,
            type: critere.type
          }
        };

        angular.forEach(ctrl.prospect.criteres, function(prospectCrit) {
          if (critere.nomChamp === prospectCrit.critere.nomChamp) current.id = prospectCrit.id;
        });

        switch (critere.type) {
          case 'int':
            if (critere.intMin || critere.intMax) {
              current.intMin = critere.intMin;
              current.intMax = critere.intMax;
              tmp.push(current);
            }
            break;

          case 'float':
            if (critere.floatMin || critere.floatMax) {
              current.floatMin = critere.floatMin;
              current.floatMax = critere.floatMax;
              tmp.push(current);
            }
            break;

          case 'boolean':
            if (angular.isDefined(critere.bool) && critere.bool !== null) {
              current.bool = critere.bool;
              tmp.push(current);
            }
            break;

          case 'date':
            if (angular.isDefined(critere.date) && critere.date !== null) {
              current.date = critere.date;
              tmp.push(current);
            }
            break;

          case 'combo':
            current.combo = [];
            if (ctrl.references.checked[critere.classeValeursName].length) {
              current.combo = ctrl.references.checked[critere.classeValeursName];
              tmp.push(current);
            }
            break;
        }
      });

      ctrl.prospect.setCriteres(tmp);
    }

    function getPrixLabel() {
      if (ctrl.transac === 'Transaction') {
        return 'Prix';
      } else if (ctrl.employe && ctrl.employe.societe.rapproLoyerTTC) {
        return 'Loyer <small>(TCC)</small>';
      } else {
        return 'Loyer <small>(HC)</small>';
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('etatProspect', {
    templateUrl: 'app/components/main-content/modif-prospect/etat-prospect/etat-prospect.html',
    controllerAs: 'etatprospectctrl',
    controller: EtatProspectController,
    bindings: {
      prospect: '<',
      isLoading: '<',
      validation: '=',
      visited: '<'
    }
  });

  /** @ngInject */
  function EtatProspectController(
    CONSTANTS,
   
    globalService,
    RepertoireService,
    ReferencesService,
    Perso,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.datepickers = {
      dateEntree: {
        open: false,
        onClose: closeDatepicker
      },
      dateFin: {
        open: false,
        onClose: closeDatepicker
      },
      dateEcheance: {
        open: false,
        onClose: closeDatepicker
      },
      dateProchainContact: {
        open: false,
        onClose: closeDatepicker
      },
      dateDernierContact: {
        open: false,
        onClose: closeDatepicker
      }
    };

    ctrl.societes = {
      list: [],
      societe: null,
      search: searchInSocietes,
      getSocietes: getSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.references = {
      classes: ['RefAvancementProspect', 'RefQualification', 'RefOrigineClient'],
      RefAvancementProspect: [],
      RefQualification: [],
      RefOrigineClient: []
    };

    ctrl.$onInit = initialisation;

    function initialisation(iterations) {
      iterations = isFinite(iterations) ? iterations : 1;
      if (ctrl.prospect) {
        getSocietes();
        setNego();
        getReferences(ctrl.references.classes.join(','));
      } else if (iterations <= 10) {
        $timeout(function() {
          iterations++, initialisation(iterations);
        }, 350);
      }
    }

    function getReferences(classes) {
      ReferencesService.getReferences({
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : ctrl.employe.societe.id,
        classes: classes,
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            angular.forEach(json.list, function(classe, nom) {
              ctrl.references[nom] = classe;
            });
          }

          ctrl.isLoading = false;
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function setNego() {
      if (!ctrl.isLoading) {
        if (ctrl.prospect.nego) {
          ctrl.negos.nego = ctrl.prospect.nego;
          ctrl.negos.nego.perso = ctrl.negos.nego.perso.isModel
            ? ctrl.negos.nego.perso
            : new Perso(ctrl.negos.nego.perso);

          if (ctrl.prospect.nego.societe && ctrl.prospect.nego.societe.id) {
            ctrl.societes.societe = ctrl.prospect.nego.societe;
          }
        }
      } else {
        $timeout(setNego, 200);
      }
    }

    function getSocietes() {
      RepertoireService.getSocietesList().then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function searchInSocietes(input) {
      RepertoireService.getSocietesList({
        recherche: input || null,
        numero: 0,
        pas: 10
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeChanged() {
      searchInNegos();
      getReferences(ctrl.references.classes.join(','));
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : null,
        numero: 0,
        pas: 15
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
      ctrl.prospect.nego = ctrl.negos.nego;
    }

    function closeDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('photo', {
    templateUrl: 'app/components/main-content/modif-bien/photo/photo.html',
    controllerAs: 'photoctrl',
    bindings: {
      lot: '='
    },
    controller: PhotoController
  });

  /** @ngInject */
  function PhotoController(
    CONSTANTS,
    globalService,
    CustomUtils,

    FileUploader,
    ngDialog,
    PropertiesService,
    ReferencesService,
    $timeout,
    Lightbox
  ) {
    var ctrl = this;

    ctrl.transac = globalService.getTypeApplication();
    ctrl.citya = CONSTANTS.configClient.citya;
    ctrl.rhinovURL = '';

    ctrl.src = globalService.baseImgSrc();
    ctrl.withCred = globalService.withCredentials();

    ctrl.srcNoPhoto = 'assets/images/pictos/no_photo.jpg';
    ctrl.urlToupload = globalService.baseUrl() + 'FileUpload';
    ctrl.uploader = new FileUploader({
      url: ctrl.urlToupload,
      withCredentials: ctrl.withCred,
      formData: [{
        lotref: null,
        type: 1,
        negoId: globalService.getEmploye().id
      }]
    });

    ctrl.RefImage = [];

    ctrl.maxOrder = 0;

    ctrl.lightboxImgs = [];

    ctrl.fullscreenMode = fullscreenMode;
    ctrl.setOrdre = setOrdre;
    ctrl.incOrdre = incOrdre;
    ctrl.decOrdre = decOrdre;
    ctrl.reOrderAll = reOrderAll;
    ctrl.rotationPhoto = rotationPhoto;
    ctrl.removePhoto = removePhoto;
    ctrl.setBandeau = setBandeau;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        if (ctrl.transac === 'Transaction' && ctrl.citya) {
          ctrl.rhinovURL = (CONSTANTS.configClient.prod ? 'https://stella-gateway.citya.com/renovation/create/' : 'https://stella-gateway-test.citya.com/renovation/create/') + ctrl.lot.id
        }

        ctrl.uploader.formData[0].lotref = ctrl.lot.referenceInterne;
        ctrl.maxOrder = ctrl.lot.multimedia.length + 1;

        ReferencesService.getReferences({
          classes: 'RefImage',
          typeApplication: globalService.getTypeApplication()
        }).then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.RefImage = retour.list.RefImage;
          }
          setImgList();
        });
      } else {
        $timeout(initialisation, 200);
      }
    }

    function setImgList() {
      ctrl.lightboxImgs = [];
      angular.forEach(ctrl.lot.multimedia, function (photo) {
        photo.noCacheValue = '?nc=' + Date.now();
        ctrl.lightboxImgs.push({
          url: ctrl.src + '/' + ctrl.lot.id + '/' + photo.fileName + photo.noCacheValue
        });
        photo.bandeau = null;
        var bandeaux = photo.fileName.split('-');
        if (angular.isArray(bandeaux) && bandeaux.length) {
          var selected = ctrl.RefImage.filter(function (bandeau) {
            return bandeau.subNom === bandeaux[0];
          });
          if (angular.isArray(selected) && selected.length) {
            photo.bandeau = selected[0];
          }
        }
      });
    }

    // FILTERS
    //noinspection JSUnusedGlobalSymbols
    ctrl.uploader.filters.push({
      name: 'customFilter',
      fn: function () {
        return this.queue.length < 10;
      }
    });

    //noinspection JSUnusedGlobalSymbols
    ctrl.sortableOptions = {
      'ui-floating': 'auto',
      cursor: 'move',
      helper: 'clone',
      opacity: 0.5,
      stop: function () {
        angular.forEach(ctrl.lot.multimedia, function (photo, index) {
          photo.ordre = index + 1;
          photo.photoPrincipale = index === 0;
        });
      }
    };

    // CALLBACKS
    ctrl.uploader.onBeforeUploadItem = function (item) {
      item.formData.push({
        ordre: ctrl.maxOrder
      });
      item.formData.push({
        Filename: item.file.name
      });
      ctrl.maxOrder++;
    };

    ctrl.uploader.onCompleteAll = function () {
      PropertiesService.getPropertiesList({
        search: {
          lotReference: ctrl.lot.referenceInterne
        },
        typeMethode: 'complete',
        typeApplication: globalService.getTypeApplication()
      }).then(function (json) {
        if (json.status === 'OK' && json.list.nblot) {
          ctrl.lot.multimedia = json.list.biens[0].multimedia;
          setImgList();
        }
      });
    };

    function fullscreenMode(index) {
      Lightbox.openModal(ctrl.lightboxImgs, index, {});
    }

    function reOrderAll(photo, oldOrdre) {
      if (oldOrdre !== photo.ordre) {
        var desc = oldOrdre < photo.ordre;
        angular.forEach(ctrl.lot.multimedia, function (current) {
          if (current.id !== photo.id) {
            var ordre = CustomUtils.number.toInteger(current.ordre);
            if (desc && oldOrdre < current.ordre && current.ordre <= photo.ordre) {
              ordre -= 1;
            } else if (!desc && oldOrdre > current.ordre && current.ordre >= photo.ordre) {
              ordre += 1;
            }
            current.ordre = ordre;
          }
          current.photoPrincipale = current.ordre === 1;
        });
      }
    }

    function setOrdre(photo, ordre) {
      var oldOrdre = CustomUtils.number.toInteger(photo.ordre);
      photo.ordre = ordre;
      reOrderAll(photo, oldOrdre);
    }

    function incOrdre(photo) {
      var oldOrdre = CustomUtils.number.toInteger(photo.ordre);
      photo.ordre = oldOrdre + 1;
      reOrderAll(photo, oldOrdre);
    }

    function decOrdre(photo) {
      var oldOrdre = CustomUtils.number.toInteger(photo.ordre);
      photo.ordre = oldOrdre - 1;
      reOrderAll(photo, oldOrdre);
    }

    function rotationPhoto(photo, horaire) {
      delete photo.bandeau;

      PropertiesService.editPhoto({
        multimediaId: photo.id,
        action: 'rotation',
        horaire: horaire,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        if (retour.status === 'OK') {
          ctrl.lot.multimedia = ctrl.lot.multimedia.filter(function (multimedia) {
            return multimedia.id !== photo.id;
          });
          if (angular.isArray(ctrl.lot.multimedia)) ctrl.lot.multimedia.push(retour.list[0]);
          else ctrl.lot.multimedia = [retour.list[0]];
          setImgList();
        }
      });
    }

    function removePhoto(photo) {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer cette photo ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          setOrdre(photo, ctrl.lot.multimedia.length);

          delete photo.bandeau;

          PropertiesService.editPhoto({
            multimediaId: photo.id,
            action: 'supprimer',
            typeApplication: globalService.getTypeApplication()
          }).then(function (retour) {
            if (retour.status === 'OK') {
              ctrl.lot.multimedia = ctrl.lot.multimedia.filter(function (multimedia) {
                return multimedia.id !== photo.id;
              });
              ctrl.maxOrder = ctrl.lot.multimedia.length + 1;
              setImgList();
            }
          });
        }
      });
    }

    function setBandeau(photo) {
      var idBandeau = photo.bandeau.id;
      delete photo.bandeau;

      PropertiesService.editPhoto({
        multimediaId: photo.id,
        action: 'bandeau',
        idBandeau: idBandeau,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        if (retour.status === 'OK') {
          ctrl.lot.multimedia = ctrl.lot.multimedia.filter(function (multimedia) {
            return multimedia.id !== photo.id;
          });
          if (angular.isArray(ctrl.lot.multimedia)) ctrl.lot.multimedia.push(retour.list[0]);
          else ctrl.lot.multimedia = [retour.list[0]];
          setImgList();
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('parution', {
    templateUrl: 'app/components/main-content/modif-bien/parution/parution.html',
    controllerAs: 'parutionctrl',
    bindings: {
      lot: '=',
      isLoading: '='
    },
    controller: ParutionController
  });

  /** @ngInject */
  function ParutionController(ReferencesService, PropertiesService, globalService, $timeout, $q, CustomUtils) {
    var ctrl = this;
    ctrl.typeApplication = globalService.getTypeApplication();
    ctrl.presta = {
      vitrine: null,
      listePrestataire: ''
    };
    ctrl.queryPresta = {
      lotId: null,
      typeApplication: ctrl.typeApplication
    };
    ctrl.query = {
      lotId: null,
      typeApplication: ctrl.typeApplication,
      isActif: null
    };

    ctrl.loaders = {
      getPrestataire: false,
      setPrestataire: false,
      checkImgs: false
    };

    ctrl.getPrestataire = getPrestataire;
    ctrl.modifPrestataire = modifPrestataire;
    ctrl.setLoading = setLoading;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        ctrl.query.lotId = ctrl.lot.id;
        getPrestataire();
      } else {
        $timeout(initialisation, 200);
      }
    }

    function checkImgParution(prestataires) {
      setLoading('checkImgs', true);

      var globalDefer = $q.defer(),
        promises = [],
        deferred;

      ctrl.presta.listePrestataire = [];

      angular.forEach(prestataires, function(prestataire) {
        deferred = $q.defer();
        prestataire.hasImg = false;
        var imgSrc = 'assets/images/logos/' + prestataire.nom + '.png';
        CustomUtils.isImage(imgSrc)
          .then(function(image) {
            prestataire.hasImg = true;
            prestataire.imgSrc = image.src;
          })
          .finally(function() {
            if (prestataire.nom === 'Vitrine Papier') {
              ctrl.presta.vitrine = prestataire;
              ctrl.presta.vitrine.checked = false;
            } else {
              prestataire.checked = false;
              ctrl.presta.listePrestataire.push(prestataire);
            }
            deferred.resolve();
            promises.push(deferred.promise);
          });
      });
      $q.all(promises).then(function() {
        setLoading('checkImgs', false);
        globalDefer.resolve();
      });

      return globalDefer.promise;
    }

    function getPrestataire() {
      setLoading('getPrestataire', true);

      ReferencesService.getPrestataires(ctrl.queryPresta).then(function(prestaListe) {
        if (prestaListe.status === 'OK') {
          checkImgParution(prestaListe.list).then(function() {
            PropertiesService.getParutionListe(ctrl.query)
              .then(function(parutions) {
                angular.forEach(parutions.list, function(p) {
                  if (angular.isDefined(p.prestataire) && p.prestataire.nom === 'Vitrine Papier') {
                    ctrl.presta.vitrine.checked = p.actif;
                  }
                });
                angular.forEach(ctrl.presta.listePrestataire, function(presta, index) {
                  ctrl.presta.listePrestataire[index].checked = false;
                  angular.forEach(parutions.list, function(p) {
                    if (angular.isDefined(p.prestataire) && presta.id === p.prestataire.id) {
                      ctrl.presta.listePrestataire[index].checked = p.actif;
                    }
                  });
                });

                setLoading('getPrestataire', false);
              })
              .catch(function() {
                setLoading('getPrestataire', false);
              });
          });
        }
      });
    }

    function modifPrestataire(presta) {
      setLoading('setPrestataire', true);
      ctrl.querySend = {
        lotId: ctrl.lot.id,
        typeApplication: ctrl.typeApplication
      };

      if (presta.checked) {
        ctrl.querySend.addPrestaId = presta.id;

        PropertiesService.addParutionListe(ctrl.querySend)
          .then(function(parution) {
            angular.forEach(parution.list, function(p) {
              if (angular.isDefined(p.prestataire) && p.prestataire.nom === 'Vitrine Papier') {
                ctrl.presta.vitrine.checked = p.actif;
              }
            });
            angular.forEach(ctrl.presta.listePrestataire, function(presta, index) {
              ctrl.presta.listePrestataire[index].checked = false;
              angular.forEach(parution.list, function(p) {
                if (angular.isDefined(p.prestataire) && presta.id === p.prestataire.id) {
                  ctrl.presta.listePrestataire[index].checked = p.actif;
                }
              });
            });
            setLoading('setPrestataire', false);
          })
          .catch(function() {
            setLoading('setPrestataire', false);
          });
      } else {
        ctrl.querySend.supprPrestaId = presta.id;

        PropertiesService.supprParutionListe(ctrl.querySend)
          .then(function(parution) {
            angular.forEach(parution.list, function(p) {
              if (angular.isDefined(p.prestataire) && p.prestataire.nom === 'Vitrine Papier') {
                ctrl.presta.vitrine.checked = p.actif;
              }
            });
            angular.forEach(ctrl.presta.listePrestataire, function(presta, index) {
              ctrl.presta.listePrestataire[index].checked = false;
              angular.forEach(parution.list, function(p) {
                if (angular.isDefined(p.prestataire) && presta.id === p.prestataire.id) {
                  ctrl.presta.listePrestataire[index].checked = p.actif;
                }
              });
            });
            setLoading('setPrestataire', false);
          })
          .catch(function() {
            setLoading('setPrestataire', false);
          });
      }
    }

    function setLoading(loader, value) {
      ctrl.loaders[loader] = value;
      var isLoading = false;

      angular.forEach(ctrl.loaders, function(current) {
        if (current) isLoading = true;
      });

      ctrl.idLoading = isLoading;
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('mandatTransaction', {
    require: {
      parent: '^modifBien'
    },
    templateUrl: 'app/components/main-content/modif-bien/mandat-transaction/mandat-transaction.html',
    controllerAs: 'mandattransactionctrl',
    bindings: {
      lot: '=',
      isLoading: '=',
      validation: '=',
      visited: '<'
    },
    controller: MandatTransactionController
  });

  /** @ngInject */
  function MandatTransactionController(
    CONSTANTS,
    globalService,
    ReferencesService,
    RepertoireService,
    EvenementsService,
    Perso,
    Evenement,
    moment,
    $timeout,
    $uibModal,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.commission = 0;
    ctrl.prixVendeur = 0;
    ctrl.tauxCommInv = 0;

    ctrl.employe = globalService.getEmploye();

    ctrl.datepickers = {
      debut: {
        open: false,
        onClose: onCloseDatepicker
      },
      fin: {
        open: false,
        onClose: onCloseDatepicker
      },
      suivi: {
        open: false,
        onClose: onCloseDatepicker
      }
    };

    ctrl.references = {
      classes: ['RefTypeMandat', 'RefQualification', 'RefOrigineMandat', 'RefMotifSuppression'],
      RefTypeMandat: null,
      RefQualification: null,
      RefOrigineMandat: null,
      RefMotifsSuppression: null
    };

    ctrl.societes = {
      list: [],
      societe: null,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.setDateEcheance = setDateEcheance;
    ctrl.calculCommission = calculCommission;
    ctrl.avenant = avenant;

    ctrl.$onInit = initialisation;

    function initialisation() {
      ctrl.isLoading = true;

      searchInSocietes();

      if (ctrl.lot) {
        if (angular.isUndefined(ctrl.lot.mandatTransaction)) {
          ctrl.lot.mandatTransaction = {
            dateCreation: '',
            dateEcheance: '',
            prixVente: 0,
            tauxComm: 0
          };
        }

        if (ctrl.lot.mandatTransaction.dateCreation && moment(ctrl.lot.mandatTransaction.dateCreation, CONSTANTS.date_format).isValid() && !ctrl.lot.mandatTransaction.dateEcheance) {
          ctrl.lot.mandatTransaction.dateEcheance = moment(ctrl.lot.mandatTransaction.dateCreation, CONSTANTS.date_format).add(15, 'months').format(CONSTANTS.date_format);
        }

        if (ctrl.lot.mandatTransaction.nego) {
          ctrl.negos.nego = ctrl.lot.mandatTransaction.nego;
          ctrl.negos.nego.perso = new Perso(ctrl.negos.nego.perso);

          if (ctrl.lot.mandatTransaction.nego.societe && ctrl.lot.mandatTransaction.nego.societe.id) {
            ctrl.societes.societe = ctrl.lot.mandatTransaction.nego.societe;
          }
        }

        getReferences(ctrl.references.classes.join(','));
        calculCommission();
      } else {
        $timeout(initialisation, 200);
      }
    }

    function getReferences(classes) {
      ReferencesService.getReferences({
          societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : ctrl.employe.societe.id,
          classes: classes,
          typeApplication: 'Transaction'
        })
        .then(function (json) {
          if (json.status === 'OK') {
            angular.forEach(json.list, function (classe, nom) {
              ctrl.references[nom] = classe;

              if (nom === 'RefMotifSuppression') {
                ctrl.references.RefMotifSuppression = ctrl.references.RefMotifSuppression.filter(function (ref) {
                  return ref.label !== 'En vente';
                });
                ctrl.references.RefMotifSuppression.push({
                  label: 'En vente'
                });
              }
            });
          }

          ctrl.isLoading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function searchInSocietes(input) {
      RepertoireService.getSocietesList({
        recherche: input || null,
        numero: 0,
        pas: 10
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeChanged() {
      ctrl.negos.nego = ctrl.lot.mandatTransaction.nego = null;
      searchInNegos();
      getReferences('RefOrigineMandat');
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : null,
        numero: 0,
        pas: 15,
        typeMethode: 'liste'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
      ctrl.lot.mandatTransaction.nego = ctrl.negos.nego;
    }

    function setDateEcheance() {
      if (ctrl.lot.mandatTransaction.dateCreation && moment(ctrl.lot.mandatTransaction.dateCreation, CONSTANTS.date_format).isValid()) {
        ctrl.lot.mandatTransaction.dateEcheance = moment(ctrl.lot.mandatTransaction.dateCreation, CONSTANTS.date_format).add(15, 'months').format(CONSTANTS.date_format);
      }
    }

    /*function calculCommission2(origin) {
     switch (origin) {
     case 'prixVente':
     if (ctrl.lot.mandatTransaction.prixVente && ctrl.lot.mandatTransaction.tauxComm) {
     ctrl.commission = ctrl.lot.mandatTransaction.prixVente * (ctrl.lot.mandatTransaction.tauxComm / 100);
     ctrl.prixVendeur = ctrl.lot.mandatTransaction.prixVente - ctrl.commission;
     ctrl.tauxCommInv = (ctrl.commission / ctrl.prixVendeur) * 100;
     }
     break;
     case 'tauxComm':
     if (ctrl.lot.mandatTransaction.tauxComm && ctrl.lot.mandatTransaction.prixVente) {
     ctrl.commission = ctrl.lot.mandatTransaction.prixVente * (ctrl.lot.mandatTransaction.tauxComm / 100);
     ctrl.prixVendeur = ctrl.lot.mandatTransaction.prixVente - ctrl.commission;
     ctrl.tauxCommInv = (ctrl.commission / ctrl.prixVendeur) * 100;
     }
     break;
     case 'commission':
     if (ctrl.commission) {
     if (!ctrl.employe.societe.agence.surPrixVente && ctrl.lot.mandatTransaction.prixVente) {
     ctrl.lot.mandatTransaction.tauxComm = (ctrl.commission / ctrl.lot.mandatTransaction.prixVente) * 100;
     ctrl.prixVendeur = ctrl.lot.mandatTransaction.prixVente - ctrl.commission;
     ctrl.tauxCommInv = (ctrl.commission / ctrl.prixVendeur) * 100;
     } else if (ctrl.employe.societe.agence.surPrixVente && ctrl.prixVendeur) {
     ctrl.tauxCommInv = (ctrl.commission / ctrl.prixVendeur) * 100;
     ctrl.lot.mandatTransaction.prixVente = ctrl.prixVendeur + ctrl.commission;
     ctrl.lot.mandatTransaction.tauxComm = (ctrl.commission / ctrl.lot.mandatTransaction.prixVente) * 100;
     }
     }
     break;
     case 'prixVendeur':
     if (ctrl.prixVendeur && ctrl.tauxCommInv) {
     ctrl.commission = (ctrl.tauxCommInv / 100) * ctrl.prixVendeur;
     ctrl.lot.mandatTransaction.prixVente = ctrl.prixVendeur + ctrl.commission;
     ctrl.lot.mandatTransaction.tauxComm = (ctrl.commission / ctrl.lot.mandatTransaction.prixVente) * 100;
     }
     break;
     case 'tauxCommInv':
     if (ctrl.tauxCommInv && ctrl.prixVendeur) {
     ctrl.commission = (ctrl.tauxCommInv / 100) * ctrl.prixVendeur;
     ctrl.lot.mandatTransaction.prixVente = ctrl.prixVendeur + ctrl.commission;
     ctrl.lot.mandatTransaction.tauxComm = (ctrl.commission / ctrl.lot.mandatTransaction.prixVente) * 100;
     }
     break;
     default:
     if (ctrl.lot.mandatTransaction.prixVente && ctrl.lot.mandatTransaction.tauxComm) {
     ctrl.prixVendeur = ctrl.lot.mandatTransaction.prixVente * (1 - (ctrl.lot.mandatTransaction.tauxComm / 100));
     ctrl.commission = ctrl.lot.mandatTransaction.prixVente - ctrl.prixVendeur;
     ctrl.tauxCommInv = (ctrl.commission / ctrl.prixVendeur) * 100;
     }
     break;
     }
     }*/

    function calculCommission(origin) {
      var prixVente = ctrl.lot.mandatTransaction.prixVente ? ctrl.lot.mandatTransaction.prixVente : 0,
        prixVendeur = ctrl.prixVendeur ? ctrl.prixVendeur : 0,
        commission = ctrl.commission ? ctrl.commission : 0,
        tauxComm = ctrl.lot.mandatTransaction.tauxComm ? ctrl.lot.mandatTransaction.tauxComm / 100 : 0,
        tauxCommInv = ctrl.tauxCommInv ? ctrl.tauxCommInv / 100 : 0;

      switch (origin) {
        case 'prixVente':
          if (prixVente) {
            if (prixVendeur) {
              commission = prixVente - prixVendeur;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (commission) {
              prixVendeur = prixVente - commission;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (tauxComm) {
              commission = prixVente * tauxComm;
              prixVendeur = prixVente - commission;
              tauxCommInv = commission / prixVendeur;
            }
          }
          break;
        case 'prixVendeur':
          if (prixVendeur) {
            if (prixVente) {
              commission = prixVente - prixVendeur;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (commission) {
              prixVente = prixVendeur + commission;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (tauxCommInv) {
              commission = prixVendeur * tauxCommInv;
              prixVente = prixVendeur + commission;
              tauxComm = commission / prixVente;
            }
          }
          break;
        case 'commission':
          if (commission) {
            if (prixVendeur) {
              prixVente = prixVendeur + commission;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (prixVente) {
              prixVendeur = prixVente - commission;
              tauxComm = commission / prixVente;
              tauxCommInv = commission / prixVendeur;
            } else if (tauxComm) {
              prixVente = commission / tauxComm;
              prixVendeur = prixVente - commission;
              tauxCommInv = commission / prixVendeur;
            } else if (tauxCommInv) {
              prixVendeur = commission / tauxCommInv;
              prixVente = prixVendeur + commission;
              tauxCommInv = commission / prixVendeur;
            }
          } else {
            tauxComm = 0;
            tauxCommInv = 0;
            if (prixVendeur) prixVente = prixVendeur;
            else if (prixVente) prixVendeur = prixVente;
          }
          break;
        case 'tauxComm':
          if (tauxComm) {
            if (prixVente) {
              commission = prixVente * tauxComm;
              prixVendeur = prixVente - commission;
              tauxCommInv = commission / prixVendeur;
            }
          } else {
            commission = 0;
            prixVendeur = prixVente || 0;
            tauxCommInv = 0;
          }
          break;
        case 'tauxCommInv':
          if (tauxCommInv) {
            if (prixVendeur) {
              commission = prixVendeur * tauxCommInv;
              prixVente = prixVendeur + commission;
              tauxComm = commission / prixVente;
            }
          } else {
            commission = 0;
            prixVente = prixVendeur || 0;
            tauxComm = 0;
          }
          break;
        default:
          if (prixVente && tauxComm) {
            commission = prixVente * tauxComm;
            prixVendeur = prixVente - commission;
            tauxCommInv = commission / prixVendeur;
          }
          break;
      }

      ctrl.lot.mandatTransaction.prixVente = prixVente;
      ctrl.prixVendeur = prixVendeur;
      ctrl.commission = commission;
      ctrl.lot.mandatTransaction.tauxComm = tauxComm * 100;
      ctrl.tauxCommInv = tauxCommInv * 100;
    }

    function avenant() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/avenant/modal.avenant.html',
        controller: 'ModalAvenantController',
        controllerAs: 'modalavenantctrl',
        resolve: {
          datefin: function () {
            return ctrl.lot.mandatTransaction.dateEcheance ? ctrl.lot.mandatTransaction.dateEcheance : false;
          }
        }
      });

      modalInstance.result.then(function (retour) {
        if (retour.status === 'OK') {
          EvenementsService.ajouter({
            xml: new Evenement({
              type: {
                data: 3701,
                label: 'Avenant'
              },
              lot: {
                id: ctrl.lot.id,
                type: ctrl.lot.type
              },
              accompli: false,
              active: true,
              date: moment().format(CONSTANTS.date_format),
              suivi: true,
              commentaire: 'Avenant au mandant numero ' + retour.avenant.numero
            }).toJson(),
            lotId: ctrl.lot.id,
            typeIds: 3701,
            nego: ctrl.employe.id,
            typeMethode: 'complete'
          }).then(
            function (json) {
              if (json.status === 'OK') {
                ctrl.lot.referenceInterne += 'A';
                ctrl.lot.mandatTransaction.dateCreation = retour.avenant.datedeb;
                ctrl.lot.mandatTransaction.dateEcheance = retour.avenant.datefin;
                ctrl.parent.save();
              }
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
            }
          );
        }
      });
    }

    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
      if (datepicker === 'debut') {
        setDateEcheance();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('lotPanneaux', {
      templateUrl: 'app/components/main-content/modif-bien/panneaux/panneaux.html',
      controllerAs: 'lotpanneauxctrl',
      bindings: {
        lot: '=',
        isLoading: '='
      },
      controller: LotPanneauxController
    });

  /** @ngInject */
  function LotPanneauxController(CONSTANTS, globalService, EvenementsService, PanneauxService,
    moment, $timeout, toastr, $log) {
    var ctrl = this;
    ctrl.transac = globalService.getTypeApplication();
    ctrl.employe = globalService.getEmploye();

    ctrl.typesList = ['vendre', 'vendu', 'impossible'];

    ctrl.panneaux = {
      vendre: {
        actif: {},
        enleve: false,
        text: ctrl.transac === 'Transaction' ? 'A vendre' : 'A louer',
        pluriel: ''
      },
      vendu: {
        actif: {},
        enleve: false,
        text: ctrl.transac === 'Transaction' ? 'Vendu' : 'Loue',
        pluriel: ''
      },
      impossible: {
        actif: {},
        enleve: false,
        text: 'Impossible',
        pluriel: ''
      }
    };

    ctrl.datepickers = {
      datevendre: false,
      dateFinvendre: false,
      datevendu: false,
      dateFinvendu: false,
      dateimpossible: false,
      dateFinimpossible: false,
      onClose: onCloseDatepicker
    };

    ctrl.enregistrer = enregistrerPanneau;
    ctrl.supprimer = supprimerPanneau;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot && ctrl.lot.id) {
        ctrl.isLoading = true;
        EvenementsService
          .getList({
            lotid: ctrl.lot.id,
            typeIds: '200,201,3000,3001,3102',
            typeApplication: ctrl.transac
          })
          .then(function (json) {
            if (json.status === 'OK' && json.list) {
              setPanneaux(json.list);
            }
            ctrl.isLoading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  'Une erreur s&apos;est produite lors de la r&eacute;cup&eacute;ration des panneaux.<br>Veuillez r&eacute;essayer utl&eacute;rieurement.',
                  'Erreur r&eacute;cup&eacute;ration panneaux (code erreur : <i>MODB-PAN-81</i>)', {
                    timeOut: 8000
                  }
                );
              }
            } else $log.error(error.status);
            ctrl.isLoading = false;
          });
      } else $timeout(initialisation, 200);
    }

    function setPanneaux(panneaux) {
      angular.forEach(panneaux, function (panneau) {
        var type = '';
        if (panneau.type.data === 200 || panneau.type.data === 3000) {
          type = 'vendre';
        } else if (panneau.type.data === 201 || panneau.type.data === 3001) {
          type = 'vendu';
        } else if (panneau.type.data === 3102) {
          type = 'impossible'
        }

        if (type && panneau.active && !ctrl.panneaux[type].actif.id || (ctrl.panneaux[type].actif.id &&
            (ctrl.panneaux[type].actif.dateFin && panneau.dateFin &&
              (moment(ctrl.panneaux[type].actif.dateFin, CONSTANTS.date_format).isAfter(moment(panneau.dateFin, CONSTANTS.date_format)))) ||
            ((!ctrl.panneaux[type].actif.dateFin || !panneau.dateFin) &&
              (moment(ctrl.panneaux[type].actif.date, CONSTANTS.date_format).isAfter(moment(panneau.date, CONSTANTS.date_format)))))) {
          ctrl.panneaux[type].actif = panneau;
          ctrl.panneaux[type].actif.prix = ctrl.panneaux[type].actif.prix && angular.isNumber(ctrl.panneaux[type].actif.prix) ? ctrl.panneaux[type].actif.prix : 1;
        }
      });

      ctrl.panneaux.vendre.pluriel = ctrl.panneaux.vendre.actif.prix && ctrl.panneaux.vendre.actif.prix > 1 ? 's' : '';
      ctrl.panneaux.vendre.enleve = ctrl.panneaux.vendre.dateFin && moment().isAfter(moment(ctrl.panneaux.vendre.dateFin, CONSTANTS.date_format));

      ctrl.panneaux.vendu.pluriel = ctrl.panneaux.vendu.actif.prix && ctrl.panneaux.vendu.actif.prix > 1 ? 's' : '';
      ctrl.panneaux.vendu.enleve = ctrl.panneaux.vendu.dateFin && moment().isAfter(moment(ctrl.panneaux.vendu.dateFin, CONSTANTS.date_format));

      ctrl.panneaux.impossible.pluriel = ctrl.panneaux.impossible.actif.prix && ctrl.panneaux.impossible.actif.prix > 1 ? 's' : '';
      ctrl.panneaux.impossible.enleve = ctrl.panneaux.impossible.dateFin && moment().isAfter(moment(ctrl.panneaux.impossible.dateFin, CONSTANTS.date_format));
    }

    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker] = false;
    }

    function enregistrerPanneau(type) {
      var typeId = 0;

      if (type === 'vendre') {
        typeId = ctrl.transac === 'Transaction' ? 200 : 3000;
      } else if (type === 'vendu') {
        typeId = ctrl.transac === 'Transaction' ? 201 : 3001;
      } else if (type === 'impossible') {
        typeId = 3102;
      }

      ctrl.panneaux[type].actif.lot = ctrl.panneaux[type].actif.lot && ctrl.panneaux[type].actif.lot.id ? ctrl.panneaux[type].actif.lot : {
        id: ctrl.lot.id,
        type: ctrl.lot.type
      };
      ctrl.panneaux[type].actif.negociateur = ctrl.panneaux[type].actif.negociateur && ctrl.panneaux[type].actif.negociateur.id ? ctrl.panneaux[type].actif.negociateur : {
        id: ctrl.employe.id
      };
      ctrl.panneaux[type].actif.active = true;
      ctrl.panneaux[type].actif.type = ctrl.panneaux[type].actif.type && ctrl.panneaux[type].actif.type.data ? ctrl.panneaux[type].actif.type : {
        data: typeId
      };

      ctrl.isLoading = true;

      PanneauxService
        .setPanneau({
          xml: angular.toJson(ctrl.panneaux[type].actif),
          lotid: ctrl.lot.id,
          typeIds: typeId,
          typeApplication: ctrl.transac
        })
        .then(function (json) {
          if (json.status === 'OK') {
            ctrl.panneaux[type].pluriel = ctrl.panneaux[type].actif.prix && ctrl.panneaux[type].actif.prix > 1 ? 's' : '';
            ctrl.panneaux[type].enleve = ctrl.panneaux[type].dateFin && moment().isAfter(moment(ctrl.panneaux[type].dateFin, CONSTANTS.date_format));
          }
          ctrl.isLoading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de l&apos;enregistrement du panneau.<br>Veuillez r&eacute;essayer utl&eacute;rieurement.',
                'Erreur enregistrement panneau (code erreur : <i>MODB-PAN-170</i>)', {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function supprimerPanneau(type) {
      ctrl.panneaux[type].actif.active = false;

      if (ctrl.panneaux[type].actif.id) {
        EvenementsService
          .supprimer({
            supprId: ctrl.panneaux[type].actif.id,
            lotid: ctrl.lot.id,
            typeIds: '200,201,3000,3001,3102',
            typeApplication: ctrl.transac
          })
          .then(function (json) {
            if (json.status === 'OK' && json.list) {
              ctrl.panneaux[type].actif = {};
              setPanneaux(json.list);
            }
            ctrl.isLoading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  'Une erreur s&apos;est produite lors de la suppression du panneau.<br>Veuillez r&eacute;essayer utl&eacute;rieurement.',
                  'Erreur suppression panneau (code erreur : <i>MODB-PAN-204</i>)', {
                    timeOut: 8000
                  }
                );
              }
            } else $log.error(error.status);
            ctrl.isLoading = false;
          });
      } else {
        ctrl.panneaux[type].actif = {
          prix: null,
          date: null,
          dateFin: null,
          commentaire: null
        };
      }

    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('mandatLocation', {
    templateUrl: 'app/components/main-content/modif-bien/mandat-location/mandat-location.html',
    controllerAs: 'mandatlocationctrl',
    bindings: {
      lot: '=',
      isLoading: '=',
      validation: '=',
      paramsGestion: '<',
      visited: '<'
    },
    controller: MandatLocationController
  });

  /** @ngInject */
  function MandatLocationController(
    CONSTANTS,
    globalService,
    ReferencesService,
    PropertiesService,
    ProspectsService,
    RepertoireService,
    Perso,
    Adresse,
    $timeout,
    toastr,
    ngDialog,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.honoraires = 0;
    ctrl.maxHonoraireVDB = 0;
    ctrl.maxHonoraireEDL = 0;

    ctrl.datepickers = {
      debut: {
        open: false
      },
      fin: {
        open: false
      },
      libre: {
        open: false
      },
      dateDernierVersement: {
        open: false
      },
      dateRevisionLoyer: {
        open: false
      },
      suivi: {
        open: false
      },
      onClose: onCloseDatepicker
    };

    ctrl.references = {
      classes: ['RefMotifSuppressionLocation', 'RefQualificationLocation', 'RefZoneAlur', 'RefAssureurGLI'],
      RefMotifsSuppressionLocation: null,
      RefQualificationLocation: null,
      RefZoneAlur: null,
      RefAssureurGLI: null,
      RefRepartition: [{
          id: 1,
          label: 'Tantièmes',
          value: true
        },
        {
          id: 2,
          label: 'Compteur de répartition',
          value: false
        }
      ]
    };

    ctrl.locataires = {
      list: [],
      search: searchInLocataires,
      reset: locataireReset
    };

    ctrl.societes = {
      list: [],
      societe: null,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.calculHonoraires = calculHonoraires;
    ctrl.alertVdbEld = alertVdbEld;
    ctrl.calculZoneAlur = calculZoneAlur;

    ctrl.$onInit = initialisation;

    function initialisation() {
      ctrl.isLoading = true;

      if (ctrl.lot) {
        if (angular.isUndefined(ctrl.lot.mandatLocation)) {
          ctrl.lot.mandatLocation = {
            dateCreation: '',
            dateEcheance: '',
            loyer: 0,
            tauxHonoraire: 0
          };
        }

        if (angular.isUndefined(ctrl.lot.mandatLocation.locataire)) {
          ctrl.lot.mandatLocation.locataire = new Perso({
            physique: true,
            type: 'PersoPhysique',
            adresses: [{
              immeuble: '',
              rue: '',
              complement: '',
              cp: '',
              ville: ''
            }],
            contacts: []
          });
        }

        RepertoireService.getSocietesList().then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.societes.list = retour.list;
            } else {
              $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
            }
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          }
        );

        ReferencesService.getReferences({
            classes: ctrl.references.classes.join(','),
            typeApplication: 'Location'
          })
          .then(function (json) {
            if (json.status === 'OK') {
              ctrl.references.RefMotifSuppressionLocation = json.list.RefMotifSuppressionLocation;
              ctrl.references.RefQualificationLocation = json.list.RefQualificationLocation;
              ctrl.references.RefZoneAlur = json.list.RefZoneAlur;
              ctrl.references.RefAssureurGLI = json.list.RefAssureurGLI;

              ctrl.references.RefMotifSuppressionLocation = ctrl.references.RefMotifSuppressionLocation.filter(function (
                ref
              ) {
                return ref.label !== 'En location';
              });
              ctrl.references.RefMotifSuppressionLocation.push({
                label: 'En location'
              });
            }

            ctrl.isLoading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.isLoading = false;
          });

        ctrl.lot.mandatLocation.tvaHono = ctrl.lot.mandatLocation.tvaHono || ctrl.employe.societe.agence.tva || 20;

        calculHonoraires('init');

        if (ctrl.lot.mandatLocation.nego) {
          ctrl.negos.nego = ctrl.lot.mandatLocation.nego;
          ctrl.negos.nego.perso = new Perso(ctrl.negos.nego.perso);

          if (ctrl.lot.mandatLocation.nego.societe && ctrl.lot.mandatLocation.nego.societe.id) {
            ctrl.societes.societe = ctrl.lot.mandatLocation.nego.societe;
          }
        }

        if (ctrl.citya) {
          ctrl.lot.mandatLocation.mrhInternet = angular.isDefined(ctrl.lot.mandatLocation.mrhInternet) ?
            ctrl.lot.mandatLocation.mrhInternet :
            true;
        }
      } else {
        $timeout(initialisation, 200);
      }
    }

    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
    }

    function searchInLocataires(input) {
      ProspectsService.getListe({
        search: {
          recherche: input || null
        },
        numero: 0,
        pas: 10,
        typeApplication: 'Location',
        typeMethode: 'complete'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.locataires.list = retour.prospects;

            angular.forEach(ctrl.locataires.list, function (locataire) {
              locataire.perso.physique = angular.isDefined(locataire.perso.physique) ? locataire.perso.physique : true;
              locataire.perso.type = angular.isDefined(locataire.perso.type) ? locataire.perso.type : 'PersoPhysique';
              locataire.perso.adresses =
                angular.isArray(locataire.perso.adresses) && locataire.perso.adresses.length ?
                locataire.perso.adresses :
                [new Adresse()];
              locataire.perso.contacts =
                angular.isArray(locataire.perso.contacts) && locataire.perso.contacts.length ?
                locataire.perso.contacts :
                [];
            });
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function locataireReset() {
      ctrl.lot.mandatLocation.locataire = new Perso();
    }

    function searchInSocietes(input) {
      RepertoireService.getSocietesList({
        recherche: input || null,
        numero: 0,
        pas: 10
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeChanged() {
      ctrl.negos.nego = ctrl.lot.mandatLocation.nego = null;
      ctrl.negos.search();
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societe && ctrl.societes.societe.id ? ctrl.societes.societe.id : null,
        numero: 0,
        pas: 15,
        typeMethode: 'liste'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
      ctrl.lot.mandatLocation.nego = ctrl.negos.nego;
    }

    function calculHonoraires(origin) {
      var loyer = ctrl.lot.mandatLocation.loyer ? ctrl.lot.mandatLocation.loyer : 0,
        loyerTTC = ctrl.lot.mandatLocation.loyerTTC ? ctrl.lot.mandatLocation.loyerTTC : 0,
        honoraires = ctrl.honoraires ? ctrl.honoraires : 0,
        tauxHonoraire = ctrl.lot.mandatLocation.tauxHonoraire ? ctrl.lot.mandatLocation.tauxHonoraire / 100 : 0,
        charges = ctrl.lot.mandatLocation.charges ? ctrl.lot.mandatLocation.charges : 0,
        autresCharges = ctrl.lot.mandatLocation.autresCharges ? ctrl.lot.mandatLocation.autresCharges : 0;

      switch (origin) {
        case 'honoraires':
          if (honoraires && loyer) {
            tauxHonoraire = honoraires / loyer;
          }
          break;
        case 'loyer':
          if (loyer) {
            if (tauxHonoraire) {
              honoraires = loyer * tauxHonoraire;
            }
            loyerTTC = loyer + charges + autresCharges;
          }
          break;
        case 'loyerTTC':
          if (loyerTTC) {
            loyer = loyerTTC - charges - autresCharges;
            if (tauxHonoraire) {
              honoraires = loyer * tauxHonoraire;
            }
          }
          break;
        case 'charges':
        case 'autresCharges':
          loyerTTC = loyer + charges + autresCharges;
          break;
        case 'init':
          if (loyer && tauxHonoraire) {
            honoraires = loyer * tauxHonoraire;
          }
          break;
      }

      ctrl.lot.mandatLocation.loyer = ctrl.lot.mandatLocation.loyer != null ? loyer : ctrl.lot.mandatLocation.loyer;
      ctrl.lot.mandatLocation.loyerTTC =
        ctrl.lot.mandatLocation.loyerTTC != null ? loyerTTC : ctrl.lot.mandatLocation.loyerTTC;
      ctrl.honoraires = ctrl.honoraires != null ? honoraires : ctrl.honoraires;
      ctrl.lot.mandatLocation.tauxHonoraire =
        ctrl.lot.mandatLocation.tauxHonoraire != null ? tauxHonoraire * 100 : ctrl.lot.mandatLocation.tauxHonoraire;
      ctrl.lot.mandatLocation.charges =
        ctrl.lot.mandatLocation.charges != null ? charges : ctrl.lot.mandatLocation.charges;
      ctrl.lot.mandatLocation.autresCharges =
        ctrl.lot.mandatLocation.autresCharges != null ? autresCharges : ctrl.lot.mandatLocation.autresCharges;

      var surface = ctrl.lot.surface || ctrl.lot.surfaceHabitable || ctrl.lot.surfaceCarrez;
      if (angular.isDefined(surface) && surface > 0 && angular.isDefined(ctrl.lot.mandatLocation.zoneAlur)) {
        if (ctrl.lot.mandatLocation.zoneAlur.prix && origin !== 'honoraireVDB') {
          ctrl.maxHonoraireVDB = surface * ctrl.lot.mandatLocation.zoneAlur.prix;
          if (origin === 'zoneAlur') {
            ctrl.lot.mandatLocation.honoraireVDB = ctrl.maxHonoraireVDB;
          }
        }
        if (ctrl.lot.mandatLocation.zoneAlur.edl && origin !== 'honoraireEDL') {
          ctrl.maxHonoraireEDL = surface * ctrl.lot.mandatLocation.zoneAlur.edl;
          if (origin === 'zoneAlur') {
            ctrl.lot.mandatLocation.honoraireEDL = ctrl.maxHonoraireEDL;
          }
        }
      }

      var honorairesVDBEDL = ctrl.lot.mandatLocation.honoraireVDB + ctrl.lot.mandatLocation.honoraireEDL,
        diff;

      if (honorairesVDBEDL && origin !== 'honoraires') {
        ctrl.honoraires = honorairesVDBEDL;

        if (ctrl.lot.mandatLocation.loyer) {
          ctrl.lot.mandatLocation.tauxHonoraire = ctrl.honoraires / ctrl.lot.mandatLocation.loyer * 100;
        }
      } else if (honorairesVDBEDL > ctrl.honoraires) {
        if (ctrl.maxHonoraireEDL) {
          if (ctrl.honoraires <= ctrl.maxHonoraireEDL) {
            ctrl.lot.mandatLocation.honoraireEDL = ctrl.honoraires;
            ctrl.lot.mandatLocation.honoraireVDB = 0;
          } else {
            ctrl.lot.mandatLocation.honoraireEDL = ctrl.maxHonoraireEDL;
            ctrl.lot.mandatLocation.honoraireVDB = ctrl.honoraires - ctrl.lot.mandatLocation.honoraireEDL;
          }
        } else {
          diff = honorairesVDBEDL - ctrl.honoraires;

          if (ctrl.lot.mandatLocation.honoraireVDB >= diff) {
            ctrl.lot.mandatLocation.honoraireVDB -= diff;
          } else {
            diff -= ctrl.lot.mandatLocation.honoraireVDB;
            ctrl.lot.mandatLocation.honoraireVDB = 0;
            ctrl.lot.mandatLocation.honoraireEDL -= diff;
          }
        }
      } else if (honorairesVDBEDL < ctrl.honoraires) {
        if (ctrl.maxHonoraireEDL) {
          if (ctrl.honoraires <= ctrl.maxHonoraireEDL) {
            ctrl.lot.mandatLocation.honoraireEDL = ctrl.honoraires;
            ctrl.lot.mandatLocation.honoraireVDB = 0;
          } else {
            ctrl.lot.mandatLocation.honoraireEDL = ctrl.maxHonoraireEDL;
            ctrl.lot.mandatLocation.honoraireVDB = ctrl.honoraires - ctrl.maxHonoraireEDL;
          }
        } else {
          ctrl.lot.mandatLocation.honoraireVDB += ctrl.honoraires - honorairesVDBEDL;
        }
      }
    }

    function alertVdbEld(origin) {
      var warningVDBEDL = false,
        text,
        html;

      if (ctrl.lot.mandatLocation.zoneAlur) {
        if (ctrl.lot.mandatLocation.honoraireVDB !== ctrl.maxHonoraireVDB && origin === 'honoraireVDB') {
          warningVDBEDL = true;
          text =
            ctrl.lot.mandatLocation.honoraireVDB > ctrl.maxHonoraireVDB ? 'sup&eacute;rieurs' : 'inf&eacute;rieurs';
          html =
            'Les <strong>honoraires VDB</strong> saisis sont <strong>' + text + '</strong> au maximum autoris&eacute;.';
        } else if (ctrl.lot.mandatLocation.honoraireEDL !== ctrl.maxHonoraireEDL && origin === 'honoraireEDL') {
          warningVDBEDL = true;
          text =
            ctrl.lot.mandatLocation.honoraireEDL > ctrl.maxHonoraireEDL ? 'sup&eacute;rieurs' : 'inf&eacute;rieurs';
          html =
            'Les <strong>honoraires EDL</strong> saisis sont <strong>' + text + '</strong> au maximum autoris&eacute;.';
        }

        if (warningVDBEDL) {
          ngDialog.open({
            template: '<h3><i class="fa fa-fw fa-warning"></i> Attention :</h3>' + '<div>' + html + '</div>',
            plain: true,
            className: 'ngdialog-theme-default'
          });
        }
      }
    }

    function calculZoneAlur() {
      if (ctrl.lot.hasAdresse() && ctrl.lot.adresse.hasCp() && ctrl.lot.adresse.hasVille()) {
        if (angular.isDefined(ctrl.calculAlurEnCours) && ctrl.calculAlurEnCours.cancelable) {
          $timeout.cancel(ctrl.calculAlurEnCours);
        }

        ctrl.calculAlurEnCours = $timeout(function () {
          PropertiesService.getZoneAlur({
            cp: ctrl.lot.adresse.cp || null,
            ville: ctrl.lot.adresse.ville || null,
            typeApplication: 'Location'
          }).then(
            function (retour) {
              if (retour.status === 'OK' && retour.list.length) {
                ctrl.lot.mandatLocation.zoneAlur = retour.list[0];
                calculHonoraires('zoneAlur');
              } else {
                toastr.warning(
                  'Assurez-vous d&apos;avoir correctement saisie le <strong><i>code postal</i></strong> et la <strong><i>ville</i></strong> du bien dans la partie <strong><i>lot</i></strong>.',

                  'Impossible de d&eacute;finir la Zone Alur du bien.',

                  {
                    timeOut: 8000
                  }
                );
              }
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
            }
          );
        });
      } else {
        toastr.warning(
          'Assurez-vous d&apos;avoir correctement saisie le <strong><i>code postal</i></strong> et la <strong><i>ville</i></strong> du bien dans la partie <strong><i>lot</i></strong>.',

          'Impossible de d&eacute;finir la Zone Alur du bien.',

          {
            timeOut: 8000
          }
        );
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('extranet', {
    templateUrl: 'app/components/main-content/modif-bien/extranet/extranet.html',
    controllerAs: 'extranetctrl',
    bindings: {
      lot: '='
    },
    controller: ExtranetController
  });

  /** @ngInject */
  function ExtranetController(globalService, Perso, MailService, $uibModal, $log, $sce, $timeout) {
    var ctrl = this;

    ctrl.nego = globalService.getEmploye();

    ctrl.loading = false;
    ctrl.urlSite = '';
    ctrl.de = 'vfillon@ics.fr';

    ctrl.sendMail = sendMail;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        setUrlSite();

        if (ctrl.nego) {
          if (ctrl.nego.societe && ctrl.nego.societe.agence && ctrl.nego.societe.agence.email) {
            ctrl.de = ctrl.nego.societe.agence.email;
          }
          ctrl.nego.perso = new Perso(ctrl.nego.perso);
          if (ctrl.nego.perso.getEmail()) {
            ctrl.de = ctrl.nego.perso.getEmail();
          }
        }
      } else {
        $timeout(initialisation, 200);
      }
    }

    function setUrlSite() {
      var employe = globalService.getEmploye();
      var host = globalService.baseUrl();
      if (
        angular.isDefined(employe.societe.agence.urlPublic) &&
        employe.societe.agence.urlPublic != null &&
        employe.societe.agence.urlPublic.length > 0
      ) {
        host = employe.societe.agence.urlPublic;
      }
      var login = ctrl.lot.proprietaire.login;
      var pass = ctrl.lot.proprietaire.mdp;
      var siteExtranet = employe.societe.agence.siteExtranetProprio;

      var url = siteExtranet + '?url=' + host + '&login=' + login + '&mdp=' + pass;
      $log.warn(url);
      ctrl.urlSite = $sce.trustAsResourceUrl(url);
    }

    function sendMail(login, password) {
      ctrl.loading = true;
      var params = {
        proprietaire: ctrl.lot.proprietaire.id
      };

      if (angular.isDefined(login) && login) {
        params.addLogin = true;
      }
      if (angular.isDefined(password) && password) {
        params.addPassword = true;
      }

      MailService
        .getModelProprietaire(params)
        .then(function (retour) {
          MailService
            .envoyer({
              de: ctrl.de,
              a: retour.a,
              objet: retour.objet,
              corps: retour.corps,
              sansCopie: true,
              typeApplication: globalService.getTypeApplication()
            })
            .then(function (retour) {
              if (retour.status === 'OK') {
                $log.info("L'e-mail a bien été envoyé.");
              } else {
                $log.info("L'e-mail n'a pas été envoyé !.. <== extranet.component.js l.49");
              }
            })
            .catch(function (error) {
              $log.error(error.message);
            })
            .finally(function () {
              ctrl.loading = false;
            });
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('lot', {
    templateUrl: 'app/components/main-content/modif-bien/lot/lot.html',
    controllerAs: 'lotctrl',
    bindings: {
      lot: '=',
      isLoading: '=',
      validation: '=',
      paramsGestion: '<',
      visited: '<'
    },
    controller: LotController
  });

  /** @ngInject */
  function LotController(CONSTANTS, globalService) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.transac = globalService.getTypeApplication();

    ctrl.accordions = {
      dpeges: true,
      criterelot: true,
      infolot: false,
      piece: false,
      consignes: false,
      complement: false,
      cadastre:false,
      tantieme:false
    };

    ctrl.$onInit = function() {
      if (!ctrl.citya) {
        ctrl.accordions.consignes = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('ged', {
    templateUrl: 'app/components/main-content/modif-bien/ged/ged.html',
    controllerAs: 'gedctrl',
    bindings: {
      lot: '='
    },
    controller: GedController
  });

  /** @ngInject */
  function GedController(
    CONSTANTS,
    globalService,
   
    PropertiesService,
    MailService,
    $uibModal,
    FileUploader,
    $timeout,
    ngDialog,
    $window,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;
    ctrl.withCred = globalService.withCredentials();
    ctrl.urlToupload = globalService.baseUrl() + 'Uploader';
    ctrl.uploader = new FileUploader({
      url: ctrl.urlToupload,
      withCredentials: ctrl.withCred,
      formData: [
        {
          lot: null,
          type: 1,
          chemin: 'ged',
          negoId: globalService.getEmploye().id
        }
      ]
    });

    ctrl.ged = [];
    ctrl.gedIds = [];

    ctrl.maxOrder = 0;

    ctrl.setOrdre = setOrdre;
    ctrl.removeGed = removeGed;
    ctrl.dlGed = dlGed;
    ctrl.checkGedIds = checkGedIds;
    ctrl.envoyerGedMail = envoyerGedMail;
    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.lot) {
        ctrl.uploader.formData[0].lot = ctrl.lot.referenceInterne;
        ctrl.maxOrder = 0;
        setGedList();
      } else {
        $timeout(initialisation, 200);
      }
    }

    function setGedList() {
      PropertiesService.gedListe({
        reference: ctrl.lot.referenceInterne,
        typeMethode: 'complete',
        typeApplication: globalService.getTypeApplication()
      }).then(function(json) {
        if (json.status === 'OK') {
          ctrl.ged = json.list;

          angular.forEach(ctrl.ged, function(ged) {
            ged.checked = false;
          });
        }
      });
    }

    function checkGedIds() {
      ctrl.gedIds = [];
      angular.forEach(ctrl.ged, function(ged) {
        if (ged.checked) ctrl.gedIds.push(ged.id);
      });
    }

    function envoyerGedMail() {
      MailService.getModel({
        gedlots: ctrl.gedIds.join(','),
        typeApplication: globalService.getTypeApplication()
      }).then(function(retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function() {
              return retour;
            }
          }
        });

        modalInstance.result.then(function(retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== liste-bien.component.js l.663");
          }
        });
      });
    }

    // FILTERS
    //noinspection JSUnusedGlobalSymbols
    ctrl.uploader.filters.push({
      name: 'customFilter',
      fn: function() {
        return this.queue.length < 10;
      }
    });

    //noinspection JSUnusedGlobalSymbols
    ctrl.sortableOptions = {
      'ui-floating': 'auto',
      stop: function() {
        angular.forEach(ctrl.ged, function(photo, index) {
          photo.ordre = index + 1;
          photo.photoPrincipale = index === 0;
        });
      }
    };

    // CALLBACKS
    ctrl.uploader.onBeforeUploadItem = function(item) {
      item.formData.push({ ordre: ctrl.maxOrder });
      item.formData.push({ fileName: item.file.name });
      ctrl.maxOrder++;
    };

    ctrl.uploader.onCompleteAll = function() {
      setGedList();
    };

    function setOrdre(photo, oldOrdre) {
      angular.forEach(ctrl.ged, function(current) {
        if (current.id !== photo.id) {
          if (oldOrdre < photo.ordre) {
            if (oldOrdre < current.ordre && current.ordre <= photo.ordre) {
              current.ordre -= 1;
            }
          } else if (oldOrdre > photo.ordre) {
            if (oldOrdre > current.ordre && current.ordre >= photo.ordre) {
              current.ordre += 1;
            }
          }
        }

        current.photoPrincipale = current.ordre === 1;
      });
    }

    function removeGed(ged) {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer ce document ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function(data) {
        if (data.status === 'OK') {
          PropertiesService.removeGed({
            reference: ctrl.lot.referenceInterne,
            gedId: ged.id,
            typeMethode: 'complete',
            typeApplication: globalService.getTypeApplication()
          }).then(function(json) {
            if (json.status === 'OK') {
              ctrl.ged = json.list.filter(function(current) {
                return current.id !== ged.id;
              });
              ctrl.gedIds = ctrl.gedIds.filter(function(current) {
                return current.id !== ged.id;
              });
              delete ctrl.lot.ged;
            }
          });
        }
      });
    }

    function dlGed(ged) {
      var lienDl = globalService.baseUrl() + 'Download?ged=' + ged.id;
      $window.open(lienDl);
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('diffusion', {
    templateUrl: 'app/components/main-content/modif-bien/diffusion/diffusion.html',
    controllerAs: 'diffusionctrl',
    bindings: {
      lot: '=',
      isLoading: '=',
      validation: '=',
      paramsGestgion: '<',
      visited: '<'
    },
    controller: DiffusionController
  });

  /** @ngInject */
  function DiffusionController(CONSTANTS, globalService, $timeout) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.transac = globalService.getTypeApplication();

    ctrl.commentairePattern = /[^\n\s]/;

    ctrl.$onInit = initialisation;

    function initialisation(iteration) {
      iteration = isFinite(iteration) ? iteration : 1;
      if (ctrl.lot) {
        ctrl.lot.description = ctrl.lot.description ? ctrl.lot.description.replace(/\r?\n|\r/g, '') : '';
      } else {
        $timeout(function() {
          iteration++;
          initialisation(iteration);
        }, 350);
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocProspect', {
    templateUrl: 'app/components/main-content/liste-prospects/bloc-prospect/bloc-prospect.html',
    controllerAs: 'blocprospectctrl',
    controller: BlocProspectController,
    bindings: {
      prospect: '<',
      onShowFiche: '&',
      rapprocher: '=',
      onToggleSelection: '&'
    }
  });

  /** @ngInject */
  function BlocProspectController($timeout) {
    var ctrl = this;

    ctrl.selection = {
      active: false,
      toggle: toggleSelection
    };

    ctrl.nego = '';

    ctrl.showFiche = showFiche;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.prospect) {
        ctrl.selection.active =
          angular.isDefined(ctrl.rapprocher) && ctrl.rapprocher && angular.isFunction(ctrl.onToggleSelection);

        if (ctrl.prospect.nego) {
          ctrl.nego = ctrl.prospect.nego.perso ? ctrl.prospect.nego.perso.nomComplet : ctrl.prospect.nego.initiales;
        }
      } else {
        $timeout(initialisation, 200);
      }
    }

    function showFiche() {
      ctrl.onShowFiche({ reference: ctrl.prospect.referenceInterne });
    }

    function toggleSelection() {
      if (angular.isFunction(ctrl.onToggleSelection)) {
        ctrl.prospect.selected = !ctrl.prospect.selected;
        ctrl.onToggleSelection({ prospect: ctrl.prospect, selected: ctrl.prospect.selected });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('ficheReservation', {
    templateUrl: 'app/components/main-content/fiches/fiche-reservation/fiche-reservation.html',
    controllerAs: 'fichereservationctrl',
    controller: FicheReservationController,
    bindings: {
      ref: '<',
      onClickBack: '&',
      onChangeFiche: '&'
    }
  });

  /** @ngInject */
  function FicheReservationController(
    globalService,
    ContratsService,
    ImpressionService,
    ngDialog,
    hotkeys,
    $scope,
    $state,
    toastr,
    $attrs,
    $log
  ) {
    var ctrl = this;

    ctrl.loading = true;

    ctrl.titre = 'Réservation';

    ctrl.hasChangeFiche = angular.isDefined($attrs.onChangeFiche);

    ctrl.reservation = {};

    ctrl.editer = editer;
    ctrl.changeFiche = changeFiche;
    ctrl.imprimer = imprimer;
    ctrl.supprimer = supprimerReservation;

    ctrl.titleLabel = {
      date: false,
      text: '',
      classe: ''
    };

    ctrl.$onInit = function () {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'alt+m',
          description: 'Modifier',
          callback: function () {
            ctrl.editer();
          }
        })
        .add({
          combo: 'alt+s',
          description: 'Supprimer',
          callback: function () {
            ctrl.supprimer();
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fiche',
          callback: function () {
            ctrl.onClickBack();
          }
        });

      ContratsService.reservations
        .getList({
          idLocation: ctrl.ref,
          typeMethode: 'complete'
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.reservation = retour.reservation;

            ctrl.titleLabel.active = false;
            /* if (ctrl.reservation.hasDateEffectiveVente()) {
              ctrl.titre = 'Location';
              ctrl.retourGestion = {
                active: ctrl.reservation.affaire.gestion,
                retourne: angular.isDefined(ctrl.reservation.infoBail) && ctrl.reservation.infoBail.envoiEnGerance
              };

              if (!ctrl.reservation.hasDateEtatDesLieux()) {
                ctrl.titleLabel.date = ctrl.reservation.dateEffectiveVente;
                ctrl.titleLabel.text = 'Prévu le ';

                if (ctrl.reservation.isDateEffectiveReservationDepassee() < 0) ctrl.titleLabel.classe = 'label-success';
                else if (ctrl.reservation.isDateEffectiveReservationDepassee() == 0)
                  ctrl.titleLabel.classe = 'label-warning';
                else if (ctrl.reservation.isDateEffectiveReservationDepassee() > 0)
                  ctrl.titleLabel.classe = 'label-danger';
                else ctrl.titleLabel.classe = 'label-info';
              } else {
                ctrl.titleLabel.date = ctrl.reservation.dateEtatDesLieux;
                ctrl.titleLabel.text = 'Signé le ';
                ctrl.titleLabel.classe = 'label-success';
              }
            } else if (ctrl.reservation.hasDateEncaissement()) {
              ctrl.titleLabel.date = ctrl.reservation.dateEtatDesLieux;
              ctrl.titleLabel.text = 'Loué le ';
              ctrl.titleLabel.classe = 'label-success';
            } else if (ctrl.reservation.hasDateFinOption()) {
              ctrl.titleLabel.date = ctrl.reservation.dateFinOption;
              ctrl.titleLabel.text = 'Fin le ';

              if (ctrl.reservation.isDateFinOptionDepassee() < 0) ctrl.titleLabel.classe = 'label-success';
              else if (ctrl.reservation.isDateFinOptionDepassee() == 0) ctrl.titleLabel.classe = 'label-warning';
              else if (ctrl.reservation.isDateFinOptionDepassee() > 0) ctrl.titleLabel.classe = 'label-danger';
              else ctrl.titleLabel.classe = 'label-info';
            } else ctrl.titleLabel.active = false; */

            if (ctrl.reservation.hasDateFinOption()) {
              ctrl.titleLabel.active = true;
              ctrl.titleLabel.date = ctrl.reservation.dateFinOption;
              ctrl.titleLabel.text = 'Fin le ';
              if (ctrl.reservation.isDateFinOptionDepassee() < 0) ctrl.titleLabel.classe = 'cr-success';
              else if (ctrl.reservation.isDateFinOptionDepassee() == 0) ctrl.titleLabel.classe = 'cr-warning';
              else if (ctrl.reservation.isDateFinOptionDepassee() > 0) ctrl.titleLabel.classe = 'cr-danger';
              else ctrl.titleLabel.classe = 'cr-primary';
            }
            if (ctrl.reservation.hasDatePrevueVente()) {
              ctrl.titleLabel.active = true;
              ctrl.titleLabel.date = ctrl.reservation.datePrevueVente;
              ctrl.titleLabel.text = 'Validée le ';
              ctrl.titleLabel.classe = 'cr-primary';
            }
            if (ctrl.reservation.hasDateEffectiveVente()) {
              ctrl.titleLabel.active = true;

              if (!ctrl.citya) {
                ctrl.titre = 'Location';
                ctrl.retourGestion = {
                  active: ctrl.reservation.affaire.gestion,
                  retourne: angular.isDefined(ctrl.reservation.infoBail) && ctrl.reservation.infoBail.envoiEnGerance
                };
              }

              ctrl.titleLabel.date = ctrl.reservation.dateEffectiveVente;
              ctrl.titleLabel.text = 'Prévue le ';

              if (ctrl.reservation.isDateEffectiveReservationDepassee() < 0) ctrl.titleLabel.classe = 'cr-success';
              else if (ctrl.reservation.isDateEffectiveReservationDepassee() == 0)
                ctrl.titleLabel.classe = 'cr-warning';
              else if (ctrl.reservation.isDateEffectiveReservationDepassee() > 0) ctrl.titleLabel.classe = 'cr-danger';
              else ctrl.titleLabel.classe = 'cr-primary';
            }
            if (ctrl.reservation.hasDateSignature()) {
              ctrl.titleLabel.active = true;

              if (ctrl.citya) {
                ctrl.titre = 'Location';
                ctrl.retourGestion = {
                  active: ctrl.reservation.affaire.gestion,
                  retourne: angular.isDefined(ctrl.reservation.infoBail) && ctrl.reservation.infoBail.envoiEnGerance
                };
              }
              ctrl.titleLabel.date = ctrl.citya ? ctrl.reservation.dateSignature : ctrl.reservation.dateSignature;
              ctrl.titleLabel.text = 'Signée le ';
              ctrl.titleLabel.classe = 'cr-primary';
            }
            if (ctrl.reservation.hasDateEncaissement()) {
              ctrl.titleLabel.active = true;
              ctrl.titleLabel.date = ctrl.reservation.dateEncaissement;
              ctrl.titleLabel.text = 'Loué le ';
              ctrl.titleLabel.classe = 'cr-primary';
            }
          }

          ctrl.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.loading = false;
        });
    };

    function editer() {
      if (globalService.getTypeApplication() !== 'Location') {
        globalService.setTypeApplication('Location', false, false);
      }
      $state.go('modifReservation', {
        reference: ctrl.reservation.id
      }, {
        reload: true
      });
      ctrl.onClickBack();
    }

    function changeFiche(target) {
      ctrl.onChangeFiche({
        target: target
      });
    }

    function imprimer() {
      var params = {
        locationid: ctrl.reservation.id,
        lotsid: ctrl.reservation.affaire.id
      };
      if (ctrl.reservation.hasLocataire()) {
        params.prospectsid = ctrl.reservation.locataire.id;
      }
      ImpressionService.openImpression(params);
    }

    function supprimerReservation() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer cette r&eacute;s&egrave;rvation ?</span>';
          },
          commentaire: function commentaireFactory() {
            return true;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK' && data.deleteRaison) {
          ctrl.loading = true;
          ContratsService.reservations
            .supprimer({
              deleteId: ctrl.reservation.id,
              deleteRaison: data.deleteRaison
            })
            .then(
              function (retour) {
                if (retour.status === 'OK') {
                  ctrl.reservation = retour.reservation;
                  if (
                    $state.current.name === 'contrat' &&
                    ($state.params.type === 'reservation' || $state.params.type === 'location')
                  ) {
                    $state.reload();
                  }
                  ctrl.onClickBack();
                }
                ctrl.loading = false;
              },
              function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    toastr.error(
                      'Une erreur s&apos;est produite lors de la suppression.<br>Veuillez r&eacute;essayer utl&eacute;rieurement.',
                      'Erreur suppression reservation (code erreur : <i>MOD-RES-174</i>)', {
                        timeOut: 8000
                      }
                    );
                  }
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            );
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('blocBien', {
    templateUrl: 'app/components/main-content/liste-bien/bloc-bien/bloc-bien.html',
    controllerAs: 'blocbienctrl',
    controller: BlocBienController,
    bindings: {
      bien: '<',
      template: '<',
      eventActif: '<',
      onToggleFiche: '&',
      onFermer: '&',
      onSupprimer: '&',
      onSelection: '&',
      onFavoris: '&',
      onEmail: '&',
      onEvent: '&',
      onContrat: '&',
      onMouseEnter: '&',
      onMouseLeave: '&'
    }
  });

  /** @ngInject */
  function BlocBienController(
    CONSTANTS,
    globalService,

    CustomUtils,
    $element,
    $rootScope,
    $scope,
    $attrs,
    $timeout,
    moment
  ) {
    var ctrl = this;

    ctrl.loading = true;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.transac = null;

    ctrl.employe = globalService.getEmploye();

    ctrl.compromis = {
      active: false,
      enAttente: false,
      onClick: openCompromis
    };

    ctrl.presta = false;

    ctrl.eventProspect = {
      active: false,
      template: '',
      event: null
    };

    ctrl.proprietaire = {
      confidentiel: true,
      isOpen: false,
      toggle: function () {
        ctrl.proprietaire.isOpen = !ctrl.proprietaire.isOpen;
      }
    };

    ctrl.fermer = $attrs.onFermer && angular.isFunction(ctrl.onFermer);

    ctrl.supprimer = {
      active: $attrs.onSupprimer && angular.isFunction(ctrl.onSupprimer),
      onClick: onClickSupprimer
    };

    ctrl.selection = {
      active: $attrs.onSelection && angular.isFunction(ctrl.onSelection),
      selected: false,
      onToggle: toggleSelection
    };

    ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT') != null;

    ctrl.coupCoeurAgence =
      ctrl.employe &&
      ctrl.employe.societe &&
      ctrl.employe.societe.agence &&
      ctrl.employe.societe.agence.coupCoeurAgence;

    ctrl.libreLe = false;

    ctrl.nego = '';

    ctrl.qualification = null;

    ctrl.actions = {
      favoris: {
        nom: 'favoris',
        icon: ctrl.coupCoeurAgence ? 'fa-bell-o' : 'fa-heart',
        tooltip: ctrl.coupCoeurAgence ? 'Ajouter aux biens urgents' : 'Ajouter aux favoris',
        onClick: onClickFavoris
      },
      panier: {
        nom: 'panier',
        icon: 'fa-shopping-cart',
        tooltip: 'Ajouter au panier',
        onClick: onClickFavoris
      },
      event: {
        nom: 'event',
        event: $attrs.eventActif && ctrl.eventActif != null ? ctrl.eventActif : null,
        icon: 'fa-calendar',
        tooltip: $attrs.eventActif && ctrl.eventActif != null ?
          'Modifier le rendez-vous ou en plannifier un autre' : 'Plannifier un rendez-vous',
        onClick: onClickEvent
      },
      email: {
        nom: 'email',
        icon: 'fa-envelope',
        tooltip: 'Envoyer par email',
        onClick: onClickEmail
      },
      contrat: {
        nom: 'contrat',
        icon: 'fa-file-o',
        tooltip: 'Éditer un contrat',
        onClick: onClickContrat
      },
      actives: [],
      setActives: setActionsActives
    };

    ctrl.classes = {
      img: '',
      infosImg: '',
      infos: '',
      description: '',
      infosSupp: ''
    };

    ctrl.styles = {
      img: {}
    };

    ctrl.panierActifListener = $rootScope.$on('panierActif', function (event, active) {
      ctrl.panierProspect = active;
      setActionsActives();
    });

    ctrl.selectionListener = $rootScope.$on('selection-changed', function () {
      ctrl.selection.selected = $rootScope.selectionList[ctrl.bien.referenceInterne];
    });

    ctrl.toggleFiche = toggleFiche;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.bien) {
        ctrl.transac = ctrl.bien.hasOwnProperty('mandatTransaction') ? 'Transaction' : 'Location';

        ctrl.actions.contrat.tooltip =
          'Éditer ' + (ctrl.transac === 'Transaction' ? 'un compromis' : 'une réservation');

        switch (ctrl.template) {
          case 'grid':
          case 'map':
          case 'tablist':
          case 'listNoPhotos':
            ctrl.classes.img = 'col-xs-12';
            ctrl.classes.infosImg = ctrl.template === 'listNoPhotos' ? 'hidden' : '';
            ctrl.classes.infos = 'col-xs-12';
            ctrl.classes.description = 'hidden';
            ctrl.classes.infosSupp = ctrl.template !== 'listNoPhotos' ? 'hidden' : '';

            ctrl.eventProspect.template = ctrl.template === 'listNoPhotos' ? 'list' : 'grid';

            if (ctrl.template !== 'map') {
              ctrl.styles.img.height = Math.round(Math.round($element.width() / 10) * 10 * 3 / 4 / 10) * 10;
              ctrl.widthChangeListener = $scope.$watch(
                function () {
                  return $element.width();
                },
                function (newWidth, oldWidth) {
                  if (newWidth !== oldWidth) {
                    ctrl.styles.img.height = Math.round(Math.round(newWidth / 10) * 10 * 3 / 4 / 10) * 10;
                  }
                }
              );
            }

            if (ctrl.template === 'tablist') {
              $element[0].addEventListener('mouseenter', mouseEnter);
              $element[0].addEventListener('mouseleave', ctrl.onMouseLeave);
            }
            break;
          case 'list':
          case 'panier':
          case 'favoris':
          case 'selection':
          case 'actualites':
            ctrl.classes.img = 'col-xs-4 col-sm-3 col-md-4';
            ctrl.classes.infos = 'col-xs-8 col-sm-9 col-md-8';
            ctrl.classes.infosImg = 'hidden';

            ctrl.eventProspect.template = 'list';
            break;
        }

        if (!ctrl.bien['mandat' + ctrl.transac].archive) {
          if (ctrl.bien.enCompromis) {
            ctrl.compromis.active = true;
            if (ctrl.bien.enCompromis.match(/^en attente/i)) {
              ctrl.compromis.enAttente = true;
            }
          } else if (ctrl.bien.importPresta) {
            ctrl.presta = true;
          }
        }

        ctrl.libreLe =
          ctrl.bien['mandat' + ctrl.transac].libreLe &&
          moment(ctrl.bien['mandat' + ctrl.transac].libreLe, CONSTANTS.date_format).isAfter(moment());

        ctrl.nbJoursMandat = ctrl.bien['mandat' + ctrl.transac].dateCreation ?
          moment().diff(moment(ctrl.bien['mandat' + ctrl.transac].dateCreation, CONSTANTS.date_format), 'days') :
          false;

        if (ctrl.bien['mandat' + ctrl.transac].qualification && ctrl.bien['mandat' + ctrl.transac].qualification.type) {
          ctrl.qualification = '';
          if (ctrl.bien['mandat' + ctrl.transac].qualification.type.match(/^\**$/)) {
            var i = ctrl.bien['mandat' + ctrl.transac].qualification.type.length;
            while (i--) {
              ctrl.qualification += '&#9733;';
            }
          } else {
            ctrl.qualification = ctrl.bien['mandat' + ctrl.transac].qualification.type;
          }
        }

        if (angular.isArray(ctrl.bien.evenementsProspect)) {
          var actifEvents = ctrl.bien.evenementsProspect.filter(function (event) {
            return event.active;
          });

          if (actifEvents.length) {
            var lastEventId = 0;
            angular.forEach(actifEvents, function (event) {
              lastEventId = event.id > lastEventId ? event.id : lastEventId;
            });
            if (lastEventId) {
              var lastEvent = actifEvents.filter(function (event) {
                return event.id === lastEventId;
              })[0];
              ctrl.eventProspect.event = lastEvent;
              ctrl.eventProspect.active = true;
            } else {
              ctrl.eventProspect.active = false;
            }
          }
        }

        ctrl.selection.selected = angular.isDefined($rootScope.selectionList) &&
          $rootScope.selectionList.hasOwnProperty(ctrl.bien.referenceInterne) &&
          $rootScope.selectionList[ctrl.bien.referenceInterne];

        ctrl.proprietaire.confidentiel = !ctrl.employe ||
          (ctrl.employe && !ctrl.employe.societe.afficherNomVendeur) ||
          ctrl.template === 'tablist' ||
          ctrl.template === 'grid' ||
          ctrl.template === 'map' ||
          ctrl.template === 'listNoPhotos';

        if (ctrl.bien['mandat' + ctrl.transac] && ctrl.bien['mandat' + ctrl.transac].nego) {
          ctrl.nego = ctrl.bien['mandat' + ctrl.transac].nego.perso ?
            ctrl.bien['mandat' + ctrl.transac].nego.perso.nomComplet :
            ctrl.bien['mandat' + ctrl.transac].nego.initiales;
        }

        setActionsActives();

        ctrl.loading = false;

        angular.element(function () {
          if (ctrl.bien.hasMultimediaPrincipal()) {
            ctrl.imgLoading = true;

            var src =
              globalService.baseImgSrc(ctrl.transac) + ctrl.bien.id + '/ipad/' + ctrl.bien.multimediaPrincipal.fileName;

            CustomUtils.isImage(src)
              .then(function (image) {
                if (image.src) {
                  ctrl.styles.img['background-image'] = 'url(' + image.src + ')';
                  ctrl.styles.img['background-position'] = 'left top';
                }
              })
              .finally(function () {
                if (ctrl.isLast && angular.isDefined(ctrl.onAllReady) && angular.isFunction(ctrl.onAllReady)) {
                  ctrl.onAllReady();
                }
                ctrl.imgLoading = false;
              });
          } else {
            if (ctrl.isLast && angular.isDefined(ctrl.onAllReady) && angular.isFunction(ctrl.onAllReady)) {
              ctrl.onAllReady();
            }
          }
        });
      } else {
        $timeout(initialisation, 200);
      }
    }

    ctrl.$onDestroy = function () {
      ctrl.panierActifListener();
      ctrl.panierActifListener = null;
      ctrl.selectionListener();
      ctrl.selectionListener = null;

      if (ctrl.template === 'tablist') {
        $element[0].removeEventListener('mouseenter', mouseEnter);
        $element[0].removeEventListener('mouseleave', ctrl.onMouseLeave);
      }
    };

    function setActionsActives() {
      ctrl.actions.actives = [];
      if (
        $attrs.onFavoris &&
        angular.isFunction(ctrl.onFavoris) &&
        (ctrl.template !== 'favoris' || (ctrl.template === 'favoris' && ctrl.panierProspect))
      ) {
        ctrl.actions.actives.push(ctrl.panierProspect ? ctrl.actions.panier : ctrl.actions.favoris);
      }
      if ($attrs.onEvent && angular.isFunction(ctrl.onEvent)) {
        ctrl.actions.actives.push(ctrl.actions.event);
      }
      if ($attrs.onEmail && angular.isFunction(ctrl.onEmail)) {
        ctrl.actions.actives.push(ctrl.actions.email);
      }
      if ($attrs.onContrat && angular.isFunction(ctrl.onContrat)) {
        ctrl.actions.actives.push(ctrl.actions.contrat);
      }
    }

    function openCompromis() {
      if (ctrl.compromis.active && !ctrl.compromis.enAttente) {
        var idCompromis = ctrl.bien.enCompromis.match(/(\d+)/);
        if (idCompromis) {
          var type = 'fiche' + (ctrl.transac === 'Transaction' ? 'Compromis' : 'Reservation');
          $scope.$emit('showFiche', {
            type: type,
            ref: parseInt(idCompromis[0], 10)
          });
        }
      }
    }

    function mouseEnter() {
      ctrl.onMouseEnter({
        property: ctrl.bien
      });
    }

    function onClickFavoris() {
      ctrl.onFavoris({
        lot: ctrl.bien,
        panier: ctrl.panierProspect
      });
    }

    function onClickEvent() {
      var retour = {
        refLot: ctrl.bien.referenceInterne
      };
      if (ctrl.actions.event.event && ctrl.actions.event.event.id) {
        retour.event = ctrl.actions.event.event;
      }
      ctrl.onEvent(retour);
    }

    function onClickEmail() {
      ctrl.onEmail({
        refLot: ctrl.bien.referenceInterne
      });
    }

    function onClickContrat() {
      ctrl.onContrat({
        refLot: ctrl.bien.referenceInterne
      });
    }

    function toggleSelection() {
      $rootScope.selectionList[ctrl.bien.referenceInterne] = !$rootScope.selectionList[ctrl.bien.referenceInterne];

      if (angular.isDefined(ctrl.selection)) {
        ctrl.selection.selected = $rootScope.selectionList[ctrl.bien.referenceInterne];
      }
      ctrl.onSelection({
        refLot: ctrl.bien.referenceInterne,
        idLot: ctrl.bien.id,
        selected: $rootScope.selectionList[ctrl.bien.referenceInterne]
      });
    }

    function onClickSupprimer() {
      ctrl.onSupprimer({
        refLot: ctrl.bien.referenceInterne,
        idLot: ctrl.bien.id
      });
    }

    function toggleFiche() {
      ctrl.onToggleFiche({
        refLot: ctrl.bien.referenceInterne
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('ficheProspect', {
    templateUrl: 'app/components/main-content/fiches/fiche-prospect/fiche-prospect.html',
    controllerAs: 'ficheprospectctrl',
    controller: FicheProspectController,
    bindings: {
      ref: '<',
      onClickBack: '&',
      onChangeFiche: '&'
    }
  });

  /** @ngInject */
  function FicheProspectController(
    globalService,
    ProspectsService,

    ImpressionService,
    CriteresParser,
    $state,
    $uibModal,
    hotkeys,
    $rootScope,
    $scope,
    $attrs,
    $log
  ) {
    var ctrl = this;

    ctrl.loading = true;

    ctrl.transac = null;

    ctrl.prospect = {};

    ctrl.hasChangeFiche = angular.isDefined($attrs.onChangeFiche);

    ctrl.editer = editer;
    ctrl.rapprocher = rapprocher;
    ctrl.changeFiche = changeFiche;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.imprimer = imprimer;

    ctrl.$onInit = function () {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+e',
          description: 'Envoyer par email',
          callback: function () {
            ctrl.envoyerEmail();
          }
        })
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'alt+m',
          description: 'Modifier',
          callback: function () {
            ctrl.editer();
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fiche',
          callback: function () {
            ctrl.onClickBack();
          }
        });

      ProspectsService.getListe({
        search: {
          reference: ctrl.ref
        },
        typeMethode: 'complete'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            if (retour.nb) {
              ctrl.prospect = retour.prospects[0];

              if (ctrl.prospect.transaction && ctrl.prospect.location) {
                ctrl.transac = globalService.getTypeApplication();
              } else if (ctrl.prospect.location) {
                ctrl.transac = 'Location';
              } else {
                ctrl.transac = 'Transaction';
              }
            }
          }

          ctrl.loading = false;
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.loading = false;
        }
      );
    };

    function editer() {
      $state.go(
        'modifProspect', {
          reference: ctrl.prospect.referenceInterne,
          typeApplication: ctrl.transac
        }, {
          reload: true
        }
      );
      ctrl.onClickBack();
    }

    function changeFiche(target) {
      ctrl.onChangeFiche({
        target: target
      });
    }

    function rapprocher() {
      $rootScope.$emit('prospectPanierChange', {
        prospect: ctrl.prospect
      });

      var query = globalService.getStorageItem('QUERY-LISTE-BIEN') || {
        search: null
      };

      query.search = CriteresParser.prospectToSearch(ctrl.prospect);

      globalService.setStorageItem('QUERY-LISTE-BIEN', query);
      $state.go('listeBien', {}, {
        reload: true
      });
    }

    function envoyerEmail() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/formcontact/modal.formcontact.html',
        controller: 'ModalFormContactController',
        controllerAs: 'modalformcontactctrl',
        resolve: {
          message: function () {
            return {
              destinataire: ctrl.prospect.perso.getEmail(),
              prospects: ctrl.prospect.referenceInterne
            };
          }
        }
      });

      modalInstance.result.then(function () {
        ctrl.open = true;
      });
    }

    function imprimer() {
      ImpressionService.openImpression({
        prospectsid: ctrl.prospect.id
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('ficheCompromis', {
      templateUrl: 'app/components/main-content/fiches/fiche-compromis/fiche-compromis.html',
      controllerAs: 'fichecompromisctrl',
      controller: FicheCompromisController,
      bindings: {
        ref: '<',
        onClickBack: '&',
        onChangeFiche: '&'
      }
    });

  /** @ngInject */
  function FicheCompromisController(globalService, ContratsService, ImpressionService, ngDialog, hotkeys, $scope,
    $state, toastr, $attrs, $log) {
    var ctrl = this;

    ctrl.loading = true;

    ctrl.titre = 'Compromis';

    ctrl.hasChangeFiche = angular.isDefined($attrs.onChangeFiche);

    ctrl.compromis = {};

    ctrl.editer = editer;
    ctrl.changeFiche = changeFiche;
    ctrl.imprimer = imprimer;
    ctrl.supprimer = supprimerCompromis;

    ctrl.titleLabel = {
      date: false,
      text: '',
      classe: ''
    };

    ctrl.$onInit = function () {
      hotkeys.bindTo($scope)
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'alt+m',
          description: 'Modifier',
          callback: function () {
            ctrl.editer();
          }
        })
        .add({
          combo: 'alt+s',
          description: 'Supprimer',
          callback: function () {
            ctrl.supprimer()
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fiche',
          callback: function () {
            ctrl.onClickBack();
          }
        });

      ContratsService
        .compromis.getList({
          idVente: ctrl.ref,
          typeMethode: 'complete'
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.compromis = retour.compromis;

            if (ctrl.compromis.hasDateEffectiveVente()) {
              ctrl.titre = 'Vente';
              ctrl.titleLabel.active = true;
              ctrl.titleLabel.date = ctrl.compromis.dateEffectiveVente;
              ctrl.titleLabel.text = 'Vendu le ';
              ctrl.titleLabel.classe = 'label-success';
            } else if (ctrl.compromis.hasDatePrevueVente()) {
              ctrl.titleLabel.active = true;
              ctrl.titleLabel.date = ctrl.compromis.datePrevueVente;
              ctrl.titleLabel.text = 'Prévue le ';
              if (ctrl.compromis.isDatePrevueDepassee()) ctrl.titleLabel.classe = 'label-warning';
              else ctrl.titleLabel.classe = 'label-info';
            } else ctrl.titleLabel.active = false;
          }

          ctrl.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.loading = false;
        });
    };

    function editer() {
      if (globalService.getTypeApplication() !== 'Transaction') {
        globalService.setTypeApplication('Transaction', false, false);
      }
      $state.go('modifCompromis', {
        reference: ctrl.compromis.id
      }, {
        reload: true
      });
      ctrl.onClickBack();
    }

    function changeFiche(target) {
      ctrl.onChangeFiche({
        target: target
      });
    }

    function imprimer() {
      var params = {
        compromisid: ctrl.compromis.id,
        lotsid: ctrl.compromis.affaire.id
      }
      if (ctrl.compromis.hasAcheteur()) {
        params.prospectsid = ctrl.compromis.acheteur.id;
      }
      ImpressionService.openImpression(params);
    }

    function supprimerCompromis() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer ce compromis ?</span>';
          },
          commentaire: function commentaireFactory() {
            return true;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK' && data.deleteRaison) {
          ctrl.loading = true;
          ContratsService
            .compromis.supprimer({
              deleteId: ctrl.compromis.id,
              deleteRaison: data.deleteRaison
            })
            .then(
              function (retour) {
                if (retour.status === 'OK') {
                  if ($state.current.name === 'contrat' && ($state.params.type === 'compromis' || $state.params.type === 'vente')) {
                    $state.reload();
                  }
                  ctrl.onClickBack();
                }
                ctrl.loading = false;
              },
              function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    toastr.error(
                      'Une erreur s&apos;est produite lors de la suppression.<br>Veuillez r&eacute;essayer utl&eacute;rieurement.',
                      'Erreur suppression location (code erreur : <i>FCH-CMP-173</i>)',

                      {
                        timeOut: 8000
                      });
                  }
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            );
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocCompromis', {
    templateUrl: 'app/components/main-content/compromis/bloc-compromis/bloc-compromis.html',
    controllerAs: 'bloccompromisctrl',
    controller: BlocCompromisController,
    bindings: {
      compromis: '<',
      onShowFiche: '&'
    }
  });

  /** @ngInject */
  function BlocCompromisController() {
    var ctrl = this;

    ctrl.titre = 'Compromis';

    ctrl.ribbon = {
      date: false,
      text: '',
      classe: ''
    };

    ctrl.showFiche = showFiche;

    ctrl.$onInit = function() {
      if (ctrl.compromis.hasDateEffectiveVente()) {
        ctrl.titre = 'Vente';
        ctrl.ribbon.date = ctrl.compromis.dateEffectiveVente;
        ctrl.ribbon.text = 'Vendu le ';
        ctrl.ribbon.classe = 'cr-success';
      } else if (ctrl.compromis.hasDatePrevueVente()) {
        ctrl.ribbon.date = ctrl.compromis.datePrevueVente;
        ctrl.ribbon.text = 'Prévue le ';

        if (ctrl.compromis.isDatePrevueDepassee() < 0) ctrl.ribbon.classe = 'cr-success';
        else if (ctrl.compromis.isDatePrevueDepassee() == 0) ctrl.ribbon.classe = 'cr-warning';
        else if (ctrl.compromis.isDatePrevueDepassee() > 0) ctrl.ribbon.classe = 'cr-danger';
        else ctrl.ribbon.classe = 'cr-info';
      }
    };

    function showFiche() {
      ctrl.onShowFiche({ id: ctrl.compromis.id });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('visites', {
    templateUrl: 'app/components/main-content/accueil/visites/visites.html',
    controllerAs: 'visitesctrl',
    bindings: {
      visites: '<',
      displayedDate: '='
    },
    controller: VisitesController
  });

  /** @ngInject */
  function VisitesController(
    CONSTANTS,
    globalService,
    EvenementsService,
    MailService,
    $uibModal,
    $rootScope,
    Evenement,
    moment,
    $log
  ) {
    var ctrl = this;

    var monthNames = [];
    monthNames[0] = 'Janvier';
    monthNames[1] = 'Février';
    monthNames[2] = 'Mars';
    monthNames[3] = 'Avril';
    monthNames[4] = 'Mai';
    monthNames[5] = 'Juin';
    monthNames[6] = 'Juillet';
    monthNames[7] = 'Août';
    monthNames[8] = 'Septembre';
    monthNames[9] = 'Octobre';
    monthNames[10] = 'Novembre';
    monthNames[11] = 'Décembre';

    var weekdayNames = [];
    weekdayNames[0] = 'Dimanche';
    weekdayNames[1] = 'Lundi';
    weekdayNames[2] = 'Mardi';
    weekdayNames[3] = 'Mercredi';
    weekdayNames[4] = 'Jeudi';
    weekdayNames[5] = 'Vendredi';
    weekdayNames[6] = 'Samedi';

    ctrl.employe = globalService.getEmploye();

    ctrl.newCompteRendu = {};
    ctrl.openAccordion = [];

    //####################  Création d'un compte-rendu  ####################
    ctrl.fillCR = fillCR;
    ctrl.addCompteRendu = addCompteRendu;
    ctrl.envoyerEmail = envoyerEmail;

    function fillCR(visite) {
      ctrl.newCompteRendu.description = visite.compteRendu;
    }

    function addCompteRendu(visiteForm, visite, index, callback) {
      if (
        angular.isUndefined(visiteForm.$error) ||
        angular.isUndefined(visiteForm.$error.required) ||
        !visiteForm.$error.required.length > 0
      ) {
        visite.compteRendu = ctrl.newCompteRendu.description;
        delete visite.slot;
        updateVisite(visite, ctrl.displayedDate, getNextDay(ctrl.displayedDate), callback);
        ctrl.openAccordion[index] = false;
        ctrl.newCompteRendu.description = null;
      }
    }

    function envoyerEmail(visiteForm, visite, index) {
      addCompteRendu(visiteForm, visite, index, function(retour) {
        if (retour.status === 'OK' || retour.status === 'ZERO_RESULT') {
          openMailForm(visite);
        }
      });
    }

    function openMailForm(visite) {
      MailService.getModel({
        events: visite.id,
        envoiCompteRendu: true,
        typeApplication: globalService.getTypeApplication()
      }).then(function(retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function() {
              if (angular.isDefined(visite)) {
                retour.events = visite.id;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function(retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== panier.component.js l.521");
          }
        });
      });
    }

    function updateVisite(visite, dateDebut, dateFin, callback) {
      delete visite.slot;
      delete visite.actions;
      delete visite.description;

      EvenementsService.ajouter({
        xml: visite.toJson(),
        typeMethode: 'complete',
        nego: ctrl.employe.id,
        typeIds: 2,
        compteRendu: false,
        active: true,
        debut: getDateString(dateDebut),
        fin: getDateString(dateFin)
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.visites = retour.list.sort(orderByDates);
            setVisites(dateDebut);
          } else {
            ctrl.visites = [];
          }
          if (angular.isFunction(callback)) callback(retour);
        },

        function(error) {
          ctrl.visites = [];
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          if (angular.isFunction(callback)) callback(error);
        }
      );
    }

    function orderByDates(a, b) {
      return moment(a.date, CONSTANTS.date_format).diff(moment(b.date, CONSTANTS.date_format));
    }

    function setVisites(dateDebut) {
      angular.forEach(ctrl.visites, function(visite) {
        visite.slot = getSlotVisite(visite.date, visite.dateFin, dateDebut);
        visite.description = visite.commentaire;
        visite.actions = [];

        if (visite.active === false) {
          visite.description = '(ANNULÉ) ' + visite.commentaire;
          visite.actions = visite.actions.filter(function(action) {
            return action.type !== 'annuler';
          });
        } else if (
          !visite.actions.filter(function(action) {
            return action.type === 'annuler';
          }).length
        ) {
          visite.actions.push({
            type: 'annuler',
            label:
              '<span class="visite-action-annuler"><i class="fa fa-fw fa-ban"></i><span class="hidden-xs"> Annuler</span></span>',
            onClick: function() {
              visite.active = false;
              delete visite.slot;
              delete visite.description;
              delete visite.actions;
              EvenementsService.ajouter({
                xml: new Evenement(visite).toJson(),
                nego: ctrl.employe.id,
                typeIds: 2,
                compteRendu: false,
                active: true,
                typeMethode: 'complete',
                debut: getDateString(dateDebut),
                fin: getDateString(getNextDay(dateDebut))
              }).then(
                function(retour) {
                  if (retour.status === 'OK') {
                    ctrl.visites = retour.list.sort(orderByDates);
                    setVisites(dateDebut);
                  }
                },
                function(error) {
                  if (error.status) {
                    if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                    else if (error.status !== 'SESSION_EXPIRED')
                      $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  } else $log.error(error.status);
                }
              );
            }
          });
        }

        if (visite.lot) {
          if (
            !visite.actions.filter(function(action) {
              return action.type === 'lot';
            }).length
          ) {
            visite.actions.unshift({
              type: 'lot',
              label:
                '<span class="visite-action-lot"><i class="fa fa-fw fa-home"></i><span class="hidden-xs"> Lot' +
                (visite.lot.proprietaire ? ' : ' + visite.lot.proprietaire.nomComplet : '') +
                '</span></span>',
              onClick: function() {
                $rootScope.$emit('showFiche', { type: 'ficheBien', ref: visite.lot.referenceInterne });
              }
            });
          }
        }
        if (visite.prospect) {
          if (
            !visite.actions.filter(function(action) {
              return action.type === 'prospect';
            }).length
          ) {
            visite.actions.unshift({
              type: 'prospect',
              label:
                '<span class="visite-action-prospect"><i class="fa fa-fw fa-user"></i><span class="hidden-xs"> Prospect' +
                (visite.prospect.perso ? ' : ' + visite.prospect.perso.nomComplet : '') +
                '</span></span>',
              onClick: function() {
                $rootScope.$emit('showFiche', { type: 'ficheProspect', ref: visite.prospect.referenceInterne });
              }
            });
          }
        }
      });
    }

    //####################  Traitement des dates et heures  ####################
    function getNextDay(date) {
      var dateFinVisites = angular.copy(date);
      dateFinVisites.setDate(date.getDate() + 1);
      return dateFinVisites;
    }

    function getDateString(date) {
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return day + '/' + month + '/' + date.getFullYear();
    }

    function getSlotVisite(dateDebut, dateFin, debutDisplayed) {
      var dateTimeStart = dateDebut.split(' ');
      var dateStart = dateTimeStart[0];
      var result = '';
      if (dateStart === getDateString(debutDisplayed) && dateTimeStart[1] !== '00h00') result += dateTimeStart[1];
      if (dateFin) {
        var dateTimeEnd = dateFin.split(' ');
        var dateEnd = dateTimeEnd[0];
        if (dateStart === dateEnd && dateTimeEnd[1] !== '00h00') result += ' - ' + dateTimeEnd[1];
      }
      if (result === '') result += 'journée ent.';
      result += ' :';
      return result;
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('ficheBien', {
    templateUrl: 'app/components/main-content/fiches/fiche-bien/fiche-bien.html',
    controllerAs: 'fichebienctrl',
    controller: FicheBienController,
    bindings: {
      ref: '<',
      onClickBack: '&',
      onChangeFiche: '&'
    }
  });

  /** @ngInject */
  function FicheBienController(
    CONSTANTS,
    globalService,

    CustomUtils,
    PropertiesService,
    Prospect,
    ImpressionService,
    MailService,
    CriteresParser,
    ReferencesService,
    $rootScope,
    hotkeys,
    $scope,
    $uibModal,
    $q,
    $state,
    Lightbox,
    $attrs,
    toastr,
    $log,
    $window
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.employe = globalService.getEmploye();

    ctrl.imgSrc = globalService.baseImgSrc();

    ctrl.transac = globalService.getTypeApplication();

    ctrl.loading = {
      loading: true,
      criteres: true,
      parutions: true
    };

    ctrl.property = {};
    ctrl.criteres = {};
    ctrl.parutions = [];

    ctrl.carousel = {
      interval: 5000,
      active: 0
    };

    ctrl.lightboxImgs = [];

    ctrl.honoraires = false;
    ctrl.commission = 0;

    ctrl.orderByArray = [
      function (a) {
        return a['posPage' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posLigne' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      },
      function (a) {
        return a['posCol' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')];
      }
    ];

    ctrl.hasChangeFiche = angular.isDefined($attrs.onChangeFiche);

    ctrl.coupCoeurAgence =
      ctrl.employe &&
      ctrl.employe.societe &&
      ctrl.employe.societe.agence &&
      ctrl.employe.societe.agence.coupCoeurAgence;

    ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;
    ctrl.panierActifListener = $rootScope.$on('panierActif', function (event, active) {
      ctrl.panierProspect =
        active && globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;
    });

    ctrl.editer = editer;
    ctrl.imprimer = imprimer;
    ctrl.ajouterFavoris = ajouterFavoris;
    ctrl.rapprochementProspect = rapprochementProspect;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.dupliquer = dupliquer;
    ctrl.changeFiche = changeFiche;
    ctrl.fullscreenMode = fullscreenMode;

    ctrl.$onInit = function () {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+r',
          description: 'Rapprocher',
          callback: function () {
            ctrl.rapprochementProspect();
          }
        })
        .add({
          combo: 'alt+a',
          description: 'Ajouter au' +
            (ctrl.panierProspect ? ' panier' : 'x ' + (ctrl.coupCoeurAgence ? 'biens urgents' : 'favoris')),
          callback: function () {
            ctrl.ajouterFavoris();
          }
        })
        .add({
          combo: 'alt+e',
          description: 'Envoyer par email',
          callback: function () {
            ctrl.envoyerEmail();
          }
        })
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'alt+c',
          description: 'Créer une copie',
          callback: function () {
            ctrl.dupliquer();
          }
        })
        .add({
          combo: 'alt+m',
          description: 'Modifier',
          callback: function () {
            ctrl.editer();
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fiche',
          callback: function () {
            ctrl.onClickBack();
          }
        });

      PropertiesService.getPropertiesList({
          search: {
            lotReference: ctrl.ref
          },
          typeMethode: 'complete',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (json) {
          if (json.status === 'OK') {
            ctrl.property = json.list.biens[0];

            angular.forEach(ctrl.property.multimedia, function (photo) {
              ctrl.lightboxImgs.push({
                url: ctrl.imgSrc + '/' + ctrl.property.id + '/' + photo.fileName
              });
            });

            if (ctrl.property.hasMandatTransaction()) {
              ctrl.transac = 'Transaction';
              ctrl.property.libellePrix = 'Prix : ';

              if (ctrl.property.mandatTransaction.prixVente && ctrl.property.mandatTransaction.tauxComm) {
                ctrl.commission =
                  Math.round(
                    ctrl.property.mandatTransaction.prixVente * (ctrl.property.mandatTransaction.tauxComm / 100) * 100
                  ) / 100;
              }
            } else {
              ctrl.transac = 'Location';
              ctrl.property.libellePrix = 'Loyer : ';

              if (ctrl.property.mandatLocation.honoraireVDB && ctrl.property.mandatLocation.honoraireEDL) {
                ctrl.honoraires = ctrl.property.mandatLocation.honoraireVDB + ctrl.property.mandatLocation.honoraireEDL;
              } else if (ctrl.property.mandatLocation.loyer && ctrl.property.mandatLocation.tauxHonoraire) {
                ctrl.honoraires =
                  ctrl.property.mandatLocation.loyer * (ctrl.property.mandatLocation.tauxHonoraire / 100);
              }
            }

            ReferencesService.getCritereListe({
                afficher: true,
                typeBien: ctrl.property.type,
                typeApplication: ctrl.transac
              })
              .then(function (json) {
                if (json.status === 'OK') {
                  ctrl.criteres = json.list;

                  ctrl.hasCriteres = false;

                  ctrl.criteres.forEach(function (critere) {
                    if (ctrl.property[critere.nomChamp]) {
                      ctrl.hasCriteres = true;
                    }
                  });
                } else {
                  ctrl.criteres = [];
                }
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    ctrl.onClickBack();
                  }
                } else $log.error(error.status);
                ctrl.criteres = [];
              })
              .finally(function () {
                ctrl.loading.criteres = false;
                stopLoading();
              });

            PropertiesService.getParutionListe({
                lotId: ctrl.property.id,
                typeApplication: ctrl.transac
              })
              .then(function (parution) {
                checkImgParution(parution.list).then(function (formatedParution) {
                  ctrl.parutions = formatedParution.filter(function (current) {
                    return current.actif;
                  });
                });
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    ctrl.onClickBack();
                  }
                } else $log.error(error.status);
              })
              .finally(function () {
                ctrl.loading.parutions = false;
                stopLoading();
              });
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              ctrl.onClickBack();
            }
          } else $log.error(error.status);
        });
    };

    ctrl.$onDestroy = function () {
      ctrl.panierActifListener();
    };

    function editer() {
      if (globalService.getTypeApplication() !== ctrl.transac) {
        globalService.setTypeApplication(ctrl.transac, false, false);
      }
      if (ctrl.transac === 'Transaction' && ctrl.citya) {
        editionOtherPage();
      } else {
        $state.go(
          'modifBien', {
            reference: ctrl.property.referenceInterne,
            typeApplication: ctrl.transac
          }, {
            reload: true
          }
        );
      }
      ctrl.onClickBack();
    }

    function editionOtherPage() {
      var url = $state.href('modifBien', {
        reference: ctrl.property.referenceInterne,
        typeApplication: ctrl.transac
      });
      $window.open(url, '_blank');
    }

    function imprimer() {
      ImpressionService.openImpression({
        lotsid: ctrl.property.id
      });
    }

    function stopLoading() {
      ctrl.loading.loading = ctrl.loading.criteres || ctrl.loading.parutions;
    }

    function checkImgParution(parution) {
      var globalDefer = $q.defer(),
        promises = [],
        deferred;

      angular.forEach(parution, function (current) {
        deferred = $q.defer();
        current.hasImg = false;
        if (current.prestataire && current.prestataire.nom) {
          var imgSrc = 'assets/images/logos/' + current.prestataire.nom + '.png';

          CustomUtils.isImage(imgSrc)
            .then(function (image) {
              current.hasImg = true;
              current.imgSrc = image.src;
            })
            .finally(function () {
              deferred.resolve();
              promises.push(deferred.promise);
            });
        } else {
          deferred.resolve();
        }
      });

      $q.all(promises).then(function () {
        globalDefer.resolve(parution);
      });

      return globalDefer.promise;
    }

    function ajouterFavoris() {
      if (ctrl.panierProspect) {
        $rootScope.$emit('ajouterPanier', {
          refLot: ctrl.property.referenceInterne
        });
      } else {
        $rootScope.$emit('ajouterFavori', {
          idLot: ctrl.property.id
        });
      }
    }

    function rapprochementProspect() {
      var query = globalService.getStorageItem('QUERY-LISTE-PROSPECT') || {
        search: null
      };

      CriteresParser.bienToSearch(ctrl.property).then(function (retour) {
        if (retour.status === 'OK') {
          query.search = retour.search;
          globalService.setStorageItem('QUERY-LISTE-PROSPECT', query);

          var lotTransac = ctrl.property.hasMandatTransaction() ? 'Transaction' : 'Location';
          if (globalService.getTypeApplication() !== lotTransac) {
            globalService.setTypeApplication(lotTransac, false, false);
          }

          $state.go('listeProspects', {
            rapprocher: ctrl.property.referenceInterne
          }, {
            reload: true
          });
          ctrl.onClickBack();
        }
      });
    }

    function envoyerEmail() {
      if (ctrl.panierProspect) {
        if (!ctrl.panierProspect.referenceInterne.includes('CLOUD-')) {
          openMailForm(ctrl.panierProspect);
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: ctrl.panierProspect,
            callback: function (retour) {
              openMailForm(retour.prospect);
            }
          });
        }
      } else {
        openMailForm();
      }
    }

    function openMailForm(prospect) {
      MailService.getModel({
        lots: ctrl.property.referenceInterne,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== fiche-bien.component.js l.263");
          }
        });
      });
    }

    function dupliquer() {
      /* toastr.warning(
        'Cette fonctionnalité est en cours de développement.<br>Elle sera activée lors de la prochaine mise à jour.',
        'En développement',
        {
          timeOut: 8000
        }
      ); */
      ctrl.loading.loading = true;
      PropertiesService.saveBien({
          copieLot: ctrl.ref
        })
        .then(function (json) {
          if (json.status === 'OK') {
            $state.go('modifBien', {
              reference: json.bien.referenceInterne,
              typeApplication: globalService.getTypeApplication()
            });
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                "Une erreur s'est produite lors de la copie du lot.<br>Veuillez réessayer utlérieurement.",
                'Erreur sauvegarde lot (code erreur : <i>FB-380</i>)', {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
        })
        .finally(function () {
          ctrl.loading.loading = false;
          stopLoading();
        });
    }

    function changeFiche(target) {
      ctrl.onChangeFiche({
        target: target
      });
    }

    function fullscreenMode(index) {
      Lightbox.openModal(ctrl.lightboxImgs, index, {});
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('todoliste', {
    templateUrl: 'app/components/main-content/accueil/todoliste/todoliste.html',
    controllerAs: 'todolistectrl',
    bindings: {
      newTaskPanel: '<'
    },
    controller: ToDoListeController
  });

  /** @ngInject */
  function ToDoListeController(
    CONSTANTS,
    globalService,
    RepertoireService,
   
    ToDoListeService,
    moment,
    $timeout,
    $rootScope,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.todoliste = [];
    ctrl.newTask = {
      negoId: null,
      description: ''
    };

    ctrl.societes = {
      list: [],
      currentList: [],
      societes: [],
      societesId: null,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.addNewTask = addNewTask;
    ctrl.checkTask = checkTask;

    ctrl.showFiche = showFiche;
    ctrl.showProspect = showProspect;

    ctrl.$onInit = initialisation;

    function initialisation(iteration) {
      iteration = iteration || 0;
      if (ctrl.employe) {
        getSocietes();
        // Récupération des tâches à accomplir
        ToDoListeService.getList({
          negoId: ctrl.employe.id,
          accompli: false
        }).then(
          function(retour) {
            if (retour.status === 'OK') {
              var isLocation = globalService.getTypeApplication() === 'Location';
              ctrl.todoliste = retour.list.filter(function(task) {
                return angular.isUndefined(task.isLocation) || task.isLocation === isLocation;
              });
            }
          },
          function(error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          }
        );
      } else if (iteration < 10) {
        $timeout(function() {
          initialisation(iteration++);
        }, 200);
      }
    }

    //####################  Cochage/Décochage d'une case  ####################
    function checkTask(task, index) {
      var accompli = !task.accompli;
      setAccompliToDo(task.eventId, accompli, index);
    }

    function setAccompliToDo(id, accompli, index) {
      ToDoListeService.getList({
        eventId: id,
        accompli: accompli,
        negoId: ctrl.employe.id
      }).then(
        function(retour) {
          if (retour.status === 'OK' && retour.list.length > 0) {
            ctrl.todoliste[index] = retour.list[0];
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    //####################  Création d'une nouvelle tâche  ####################
    function addNewTask(newTaskForm) {
      if (
        angular.isUndefined(newTaskForm.$error) ||
        angular.isUndefined(newTaskForm.$error.required) ||
        !newTaskForm.$error.required.length > 0
      ) {
        addNewToDo(ctrl.newTask);
        ctrl.newTaskPanel.open = !ctrl.newTaskPanel.open;
      }
    }

    function addNewToDo(todo) {
      ToDoListeService.getList({
        addevent: true,
        negoId: todo.negoId ? todo.negoId : ctrl.employe.id,
        description: todo.description,
        date: moment().format(CONSTANTS.date_format),
        accompli: false
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.todoliste = retour.list;
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function getSocietes() {
      RepertoireService.getSocietesList({
        typeMethode: 'basic',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
            ctrl.societes.currentList = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function searchInSocietes(input) {
      if (ctrl.societes.list.length > 0) {
        ctrl.societes.currentList = ctrl.societes.list.filter(function(societe) {
          return societe.nom.indexOf(input) !== -1 || societe.nom.toLowerCase().indexOf(input) !== -1;
        });
      } else ctrl.societes.currentList = ctrl.societes.list;
    }

    function societeChanged() {
      if (angular.isArray(ctrl.societes.societes) && ctrl.societes.societes.length) {
        ctrl.societes.societesId = '';
        angular.forEach(ctrl.societes.societes, function(societe, index) {
          ctrl.societes.societesId += societe.id;
          if (index < ctrl.societes.societes.length - 1) ctrl.societes.societesId += ',';
        });
      } else ctrl.societes.societesId = null;
      searchInNegos();
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societesId ? ctrl.societes.societesId : ctrl.employe.societe.id,
        numero: 0,
        pas: 15,
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
      ctrl.newTask.negoId = ctrl.negos.nego ? ctrl.negos.nego.id : null;
    }

    function showFiche(refLot) {
      $rootScope.$emit('showFiche', { type: 'ficheBien', ref: refLot });
    }

    function showProspect(referenceInterne) {
      $rootScope.$emit('showFiche', { type: 'ficheProspect', ref: referenceInterne });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('statistiques', {
      templateUrl: 'app/components/main-content/accueil/statistiques/statistiques.html',
      controllerAs: 'statsctrl',
      controller: StatsController
    });

  /** @ngInject */
  function StatsController(globalService, StatistiquesService, $window, $log) {
    var ctrl = this;

    var curDate = new Date();
    var m = curDate.getMonth();
    var y = curDate.getFullYear();

    var monthNames = [];
    monthNames[0] = "Janvier";
    monthNames[1] = "Février";
    monthNames[2] = "Mars";
    monthNames[3] = "Avril";
    monthNames[4] = "Mai";
    monthNames[5] = "Juin";
    monthNames[6] = "Juillet";
    monthNames[7] = "Août";
    monthNames[8] = "Septembre";
    monthNames[9] = "Octobre";
    monthNames[10] = "Novembre";
    monthNames[11] = "Décembre";
    var month = monthNames[m];

    ctrl.employe = globalService.getEmploye();
    ctrl.application = globalService.getTypeApplication();

    var windowWidth = $window.innerWidth;
    var chartCALegend = "";
    if (windowWidth >= 768) chartCALegend = "Chiffre d'Affaires Commercial HT";

//####################  Récupération des statistiques  ####################

    ctrl.statistiques = {
      ca: [],
      caprec: [],
      difca: [],
      objectifs: [],
      caActuel: [],
      caVise: [],
      compteurLabelFormat: []
    };
    /*ctrl.statistiques.nbVisitesN = [];
     ctrl.statistiques.nbVisitesNM1 = [];*/
    ctrl.statistiques.compteurLabelFormat = [""];

    StatistiquesService
      .getList({
        negoId: ctrl.employe ? ctrl.employe.id : null
      })
      .then(
        function (retour) {
          if (retour.status === 'OK') {
            computeStatObject(retour);
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );

    function computeStatObject(retour) {
      angular.forEach(retour.list, function (stat) {
        // ***** Génération de données aléatoires pour la visualisation. A SUPPRIMER *****
        //stat.ca = ((Math.random() * 15000).toFixed(2));
        //stat.objectif = ((Math.random() * 15000).toFixed(2));
        // ***** *****
        if(ctrl.application === "Location"){
            stat.ca = stat.caloc;
            stat.caprec = stat.calocprec;
        }
        ctrl.statistiques.ca.push(Number(stat.ca));
        ctrl.statistiques.caprec.push(Number(stat.caprec));
        ctrl.statistiques.difca.push(Number(stat.ca) - Number(stat.caprec));
        ctrl.statistiques.objectifs.push(Number(stat.objectif));
        if (Number(stat.mois) - 1 === m) {
          ctrl.statistiques.caActuel.push(Number(stat.ca));
          ctrl.statistiques.caVise.push(Number(stat.objectif));
          ctrl.statistiques.compteurLabelFormat.push('<div style="text-align:center"><span style="font-size:25px;color:white">'
            + ctrl.statistiques.caActuel + '</span><br/>' + '<span style="font-size:12px;color:#888888">/' + ctrl.statistiques.caVise + ' €</span></div>');
          /*ctrl.statistiques.nbVisitesN.push(Number(stat.nb+1), Number(stat.nbvisite));
           ctrl.statistiques.nbVisitesNM1.push(Number(stat.nbprec+1), 0);*/
        }
      });
      ctrl.statistiques.ca = ctrl.statistiques.ca.reverse();
      ctrl.statistiques.caprec = ctrl.statistiques.caprec.reverse();
      ctrl.statistiques.difca = ctrl.statistiques.difca.reverse();
      ctrl.statistiques.objectifs = ctrl.statistiques.objectifs.reverse();
    }

    //####################  Diagramme en barres  ####################
    ctrl.chartConfig = {
      options: {
        chart: {
          type: 'areaspline',
          spacingTop: 40,
          height: 280
        },
        plotOptions: {}
      },
      xAxis: {
        categories: [
          'Jan.',
          'Fév.',
          'Mar.',
          'Avr.',
          'Mai',
          'Jui.',
          'Juil.',
          'Aoû.',
          'Sep.',
          'Oct.',
          'Nov.',
          'Déc.'
        ]
      },
      yAxis: {
        title: {
          text: chartCALegend
        }
      },
      series: [
        {
          type: "column",
          name: y,
          data: ctrl.statistiques.ca,
          tooltip: {
            valueSuffix: ' €'
          }
        },
        {
          type: "column",
          name: y - 1,
          data: ctrl.statistiques.caprec,
          tooltip: {
            valueSuffix: ' €'
          }
        },
        {
          type: "line",
          name: 'Objectif',
          data: ctrl.statistiques.objectifs,
          tooltip: {
            valueSuffix: ' €'
          },
          pointPlacement: "-0.2"
        },
        {
          type: "column",
          name: 'Ecart',
          data: ctrl.statistiques.difca,
          visible: false,
          tooltip: {
            valueSuffix: ' €'
          }
        }
      ],
      title: {
        text: ''
      },

      loading: false
    };

    //####################  Diagramme jauge  ####################
    ctrl.chartObjectifConfig = {
      options: {
        chart: {
          type: 'solidgauge',
          spacingTop: 15,
          spacing: [0, 0, 0, 0],
          margin: [0, 0, 0, 0],
          height: 280
        },
        pane: {
          center: ['50%', '70%'],
          size: '100%',
          startAngle: -90,
          endAngle: 90,
          background: {
            borderWidth: 0,
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc'
          }
        },
        solidgauge: {
          dataLabels: {
            y: -30,
            borderWidth: 0,
            useHTML: true
          }
        }
      },
      series: [{
        name: 'CA du mois',
        data: ctrl.statistiques.caActuel,
        dataLabels: {
          align: 'center',
          style: {
            textAlign: "center",
            whiteSpace: "normal",
            textShadow: "none"
          },
          format: ctrl.statistiques.compteurLabelFormat
        },
        tooltip: {
          valueSuffix: ' €'
        }
      }],
      title: {
        text: 'Objectif - ' + month + ' ' + y,
        y: 18,
        style: {
          fontSize: "18px",
          textShadow: "1px 2px 2px rgba(0, 0, 0, 0.8)"
        }
      },
      yAxis: {
        currentMin: 0,
        currentMax: ctrl.statistiques.caVise,
        stops: [
          [0.1],
          [0.5],
          [0.9]
        ],
        lineWidth: 0,
        tickInterval: ctrl.statistiques.caVise,
        tickPixelInterval: 400,
        tickWidth: 0,
        labels: {
          y: 15
        }
      },
      loading: false
    };

//####################  Nombre de visites  ####################

    /*
     ctrl.chartNbConfig = {
     options: {
     chart: {
     type: 'bar',
     style: {
     color: "#FFF"
     },
     height: 200,
     backgroundColor: "#040404"
     },
     plotOptions: {
     series: {
     stacking: 'normal'
     }
     },
     legend: {
     itemStyle: {
     fontFamily: 'Palanquin',
     color: "#FFF"
     },
     itemHiddenStyle: {
     color: '#888'
     }
     }
     },
     title: {
     text: ''
     },
     xAxis: {
     categories: ['Nombre', 'Visites'],
     labels: {
     style: {
     fontFamily: 'Palanquin',
     color: "#FFF"
     }
     }
     },
     yAxis: {
     min: 0,
     allowDecimals: false,
     title: {
     text: ''
     },
     labels: {
     style: {
     fontFamily: 'Palanquin',
     color: "#FFF"
     }
     }
     },
     series: [{
     name: '2016',
     data: ctrl.statistiques.nbVisitesN,
     color: '#8BBD04',
     borderColor: '#8BBD04'
     }, {
     name: '2015',
     data: ctrl.statistiques.nbVisitesNM1,
     color: '#efa605',
     borderColor: '#efa605'
     }]
     };
     */

  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('accueilPerso', {
    templateUrl: 'app/components/main-content/accueil/accueil-perso/accueil-perso.html',
    controllerAs: 'accueilpersoctrl',
    controller: AccueilPersoController
  });

  /** @ngInject */
  function AccueilPersoController(
    CONSTANTS,
    globalService,
    CustomUtils,
    CriteresParser,
    RepertoireService,
    ProspectsService,
    PropertiesService,
    Prospect,
    Perso,
    Bien,
    ngDialog,
    $rootScope,
    $state,
    $q,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.globalService = globalService;

    ctrl.query = {
      type: null,
      nom: null,
      prenom: null,
      dateNaissance: null,
      codePostal: null,
      email: null,
      telephone: null,
      societeIds: null,
      icscloud: false,
      numero: 0,
      pas: 10,
      typeApplication: globalService.getTypeApplication(),
      typeMethode: 'liste'
    };

    ctrl.types = {
      Transaction: {
        acquereur: {
          label: 'prospect',
          value: 'prospect'
        },
        vendeur: {
          label: 'propriétaire',
          value: 'proprio'
        }
      },
      Location: {
        acquereur: {
          label: 'locataire',
          value: 'locataire'
        },
        vendeur: {
          label: 'bailleur',
          value: 'bailleur'
        }
      }
    };

    ctrl.typeActive = null;

    ctrl.texts = {
      btnAcceuilAcquereur: 'Accueil ' + ctrl.types[globalService.getTypeApplication()].acquereur.label,
      btnAcceuilVendeur: 'Accueil ' + ctrl.types[globalService.getTypeApplication()].vendeur.label,
      titreSearch: ''
    };

    ctrl.datepickers = {
      debut: {
        open: false
      },
      onClose: onCloseDatepicker
    };

    ctrl.societes = {
      query: null,
      list: [],
      groupChoices: societeGroupChoices,
      setSocietes: setSocietes
    };

    ctrl.typesBien = {
      active: false,
      list: [],
      selected: null
    };

    ctrl.search = {
      open: false,
      focus: false,
      typeSelector: false,
      toggle: toggleSearch,
      search: searchPerso
    };

    ctrl.persos = {
      loading: false,
      open: false,
      type: null,
      list: [],
      nb: 0,
      creation: creation,
      chosePerso: chosePerso,
      backToSearch: backToSearch,
      plusDeBiens: plusDeBiens
    };

    ctrl.$onInit = function () {
      PropertiesService.getSocietes({
          typeMethode: 'basic',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (json) {
          if (json.status === 'OK') ctrl.societes.list = json.list;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });

      PropertiesService.getTypesBiens({
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') ctrl.typesBien.list = retour.list;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });
    };

    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker].open = false;
    }

    function societeGroupChoices(item) {
      return item.hasOwnProperty('pool') ? item.pool.nom : undefined;
    }

    function setSocietes() {
      ctrl.query.societeIds =
        (angular.isDefined(ctrl.societes.query) && ctrl.societes.query !== null && ctrl.societes.query.id > 0) ? ctrl.societes.query.id : null;
    }

    function toggleSearch(type) {
      var isOpen = ctrl.query.type === ctrl.types[globalService.getTypeApplication()][type].value && ctrl.search.open,
        currentType = ctrl.query.type;
      ctrl.typeActive = !isOpen ? type : null;
      ctrl.query.type = ctrl.types[globalService.getTypeApplication()][type].value;
      ctrl.persos.open = currentType === ctrl.query.type && ctrl.persos.open;
      ctrl.texts.titreSearch =
        globalService.getTypeApplication().toUpperCase() +
        ' : ' +
        CustomUtils.string.ucfirst(ctrl.types[globalService.getTypeApplication()][type].label);
      ctrl.typesBien.active = ctrl.query.type === 'proprio' || ctrl.query.type === 'bailleur';
      ctrl.search.open = !isOpen;
    }

    function searchPerso() {
      ctrl.search.open = false;
      ctrl.persos.open = true;
      ctrl.persos.loading = true;

      ctrl.query.pas = ctrl.query.icscloud ? 5 : 10;
      $log.info(ctrl.query);
      RepertoireService.getPersoList(ctrl.query)

        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.persos.list = retour.list;
            ctrl.persos.nb = retour.nb;
          } else {
            ctrl.persos.nb = 0;
          }

          ctrl.persos.loading = false;
        })

        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.persos.nb = 0;
          ctrl.persos.loading = false;
        });
    }

    function chosePerso(perso) {
      switch (ctrl.query.type) {
        case 'prospect':
        case 'locataire':
          if (perso.ref.includes('CLOUD-')) {
            ctrl.persos.loading = true;

            createFromCloud(perso, function (retour) {
              $rootScope.$emit('prospectPanierChange', {
                prospect: retour.prospect
              });
              $state.go('modifProspect', {
                reference: retour.prospect.referenceInterne,
                typeApplication: globalService.getTypeApplication(),
                etape: 2
              });
            });
          } else {
            $rootScope.$emit('prospectPanierChange', {
              prospect: perso
            });
            $state.go('modifProspect', {
              reference: perso.ref,
              typeApplication: globalService.getTypeApplication(),
              etape: 2
            });
          }
          break;

        case 'proprio':
        case 'bailleur':
          if (perso.ref.includes('CLOUD-')) {
            var confirmDialog = ngDialog.openConfirm({
              templateUrl: 'app/modal/type-select-dialog/type-select-dialog.html',
              controller: 'TypeSelectDialogController',
              controllerAs: 'typeselectdialogctrl',
              resolve: {
                types: function () {
                  var deferred = $q.defer();

                  PropertiesService.getTypesBiens({
                      typeApplication: globalService.getTypeApplication()
                    })
                    .then(function (retour) {
                      if (retour.status === 'OK') deferred.resolve(retour.list);
                    })
                    .catch(function (error) {
                      if (error.status) {
                        if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                        else if (error.status !== 'SESSION_EXPIRED')
                          $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                      } else $log.error(error.status);
                    });

                  return deferred.promise;
                }
              }
            });

            confirmDialog.then(function (data) {
              if (data.status === 'OK' && data.type) {
                PropertiesService.ajouterBien({
                    newlotClass: data.type,
                    typeApplication: globalService.getTypeApplication()
                  })
                  .then(function (retour) {
                    retour.bien = retour.bien.isModel ? retour.bien : new Bien(retour.bien);
                    perso.removeIds();
                    perso.clean();
                    perso.type = 'PersoPhysique';
                    perso.physique = true;
                    retour.bien.setProprietaire(perso);

                    PropertiesService.saveBien({
                        xmllot: retour.bien.toJson()
                      })
                      .then(function (json) {
                        if (json.status === 'OK') {
                          $state.go('modifBien', {
                            reference: json.bien.referenceInterne,
                            typeApplication: globalService.getTypeApplication()
                          });
                        }
                      })
                      .catch(handleError);
                    $state.go('modifBien', {
                      reference: retour.ref,
                      typeApplication: globalService.getTypeApplication()
                    });
                  })
                  .catch(handleError);
              }
            });
          } else {
            $state.go('modifBien', {
              reference: perso.ref,
              typeApplication: globalService.getTypeApplication()
            });
          }

          break;
      }
    }

    function plusDeBiens(perso) {
      if (perso.ref.includes('CLOUD-')) {
        createFromCloud(perso, function (retour) {
          chercherBiens(retour.prospect);
        });
      } else {
        ProspectsService.getListe({
            search: {
              reference: perso.ref
            },
            typeApplication: globalService.getTypeApplication(),
            typeMethode: 'complete'
          })

          .then(function (retour) {
            if (retour.status === 'OK' && retour.nb) {
              chercherBiens(retour.prospects[0]);
            }
          })

          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          });
      }
    }

    function chercherBiens(prospect) {
      $rootScope.$emit('prospectPanierChange', {
        prospect: prospect
      });

      var query = globalService.getStorageItem('QUERY-LISTE-BIEN') || {
        search: null
      };

      query.search = CriteresParser.prospectToSearch(prospect);

      globalService.setStorageItem('QUERY-LISTE-BIEN', query);
      $state.go('listeBien');
    }

    function createFromCloud(perso, callback) {
      if (perso.ref) {
        ProspectsService.editerProspect({
            addProspect: true,
            typeApplication: globalService.getTypeApplication(),
            typeMethode: 'complete'
          })
          .then(function (json) {
            if (json.status === 'OK') {
              json.prospect = json.prospect.isModel ? json.prospect : new Prospect(json.prospect);
              perso.removeIds();
              perso.clean();
              perso.type = 'PersoPhysique';
              perso.physique = true;
              json.prospect.perso = perso.isModel ? perso : new Perso(perso);

              ProspectsService.editerProspect({
                  fromcloud: true,
                  xmlProspect: json.prospect.toJson(),
                  typeApplication: globalService.getTypeApplication(),
                  typeMethode: 'complete'
                })
                .then(function (retour) {
                  if (retour.status === 'OK' && angular.isFunction(callback)) {
                    callback(retour);
                  }

                  ctrl.persos.loading = false;
                })
                .catch(function (error) {
                  if (error.status) {
                    if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                    else if (error.status !== 'SESSION_EXPIRED')
                      $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  } else $log.error(error.status);
                  ctrl.persos.loading = false;
                });
            } else {
              ctrl.persos.loading = false;
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.persos.loading = false;
          });
      }
    }

    function creation() {
      switch (ctrl.query.type) {
        case 'prospect':
        case 'locataire':
          ProspectsService.editerProspect({
              addProspect: true,
              typeApplication: globalService.getTypeApplication(),
              typeMethode: 'complete'
            })
            .then(handleSuccess)
            .catch(handleError);
          break;

        case 'proprio':
        case 'bailleur':
          PropertiesService.ajouterBien({
              newlotClass: ctrl.typesBien.selected,
              typeApplication: globalService.getTypeApplication()
            })
            .then(handleSuccess)
            .catch(handleError);
          break;
      }
    }

    function handleSuccess(json) {
      if (json.status === 'OK') {
        var params = {};
        switch (ctrl.query.type) {
          case 'prospect':
          case 'locataire':
            params.reference = json.prospect.referenceInterne;
            if (ctrl.query.nom) params.nom = ctrl.query.nom;
            if (ctrl.query.prenom) params.prenom = ctrl.query.prenom;
            if (ctrl.query.dateNaissance) params.dateNaissance = ctrl.query.dateNaissance;
            if (ctrl.query.codePostal) params.cp = ctrl.query.codePostal;
            if (ctrl.query.email) params.email = ctrl.query.email;
            if (ctrl.query.tel) params.tel = ctrl.query.tel;
            params.typeApplication = globalService.getTypeApplication();
            $state.go('modifProspect', params);
            break;

          case 'proprio':
          case 'bailleur':
            params.reference = json.bien.referenceInterne;
            if (ctrl.query.nom) params.nom = ctrl.query.nom;
            if (ctrl.query.prenom) params.prenom = ctrl.query.prenom;
            if (ctrl.query.dateNaissance) params.dateNaissance = ctrl.query.dateNaissance;
            if (ctrl.query.codePostal) params.cp = ctrl.query.codePostal;
            if (ctrl.query.email) params.email = ctrl.query.email;
            if (ctrl.query.tel) params.tel = ctrl.query.tel;
            $state.go('modifBien', params);
            break;
        }
      }
    }

    function handleError(error) {
      if (error.status) {
        if (error.status === 'ZERO_RESULT') $log.warn(error.message);
        else if (error.status !== 'SESSION_EXPIRED')
          $log.error(error.status + (error.message ? ' - ' + error.message : ''));
      } else $log.error(error.status);
    }

    function backToSearch(context) {
      ctrl.persos.open = false;
      ctrl.search.open = true;
      ctrl.search.focus = context;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('actualites', {
      templateUrl: 'app/components/main-content/accueil/actualites/actualites.html',
      controllerAs: 'actualitesctrl',
      bindings: {
        actualites: '<'
      },
      controller: ActualitesController
    });

  /** @ngInject */
  function ActualitesController(globalService, $rootScope, $element, $scope, $timeout) {

    var ctrl = this;

    ctrl.loading = false;

    ctrl.blocBienHeight = 0;

    ctrl.employe = globalService.getEmploye();

    ctrl.refListBien = [];
    ctrl.refListProspect = [];

    ctrl.imgResize = imgResize;
    ctrl.onViewDiffusion = onViewDiffusion;
    ctrl.showFicheBien = showFicheBien;
    ctrl.showFicheProspect = showFicheProspect;

    ctrl.$onInit = function () {
      ctrl.loading = true;
      angular.forEach(ctrl.actualites.diffusions, function (actu) {
        if (actu.alerte.lot) {
          ctrl.refListBien.push(actu.alerte.lot.referenceInterne);
        } else if (actu.alerte.prospect) {
          ctrl.refListProspect.push(actu.alerte.prospect.referenceInterne);
        }
      });
    };

    //####################  Ouverture fiches  ####################
    function showFicheBien(refLot) {
      $rootScope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.refListBien
      });
    }

    function showFicheProspect(refProspect) {
      $rootScope.$emit('showFiche', {
        type: 'ficheProspect',
        ref: refProspect,
        refList: ctrl.refListProspect
      });
    }

    //####################  Resize des images biens  ####################
    function imgResize(iterations) {
      iterations = iterations ? iterations : 0;
      var imgs = $element[0].querySelectorAll('.property-img');
      if (imgs && imgs.length) {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight = ((((width - 30) * 3) / 4) + 30);
        $scope.$broadcast('masonry.reload');
      } else if (iterations <= 10) $timeout(function () {
        imgResize(iterations + 1);
      }, 500);
    }

    //####################  Diffusion marquée vue  ####################
    function onViewDiffusion(alerteId) {
      ctrl.actualites.functions.onViewDiffusion(alerteId);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('validationViewer', {
      templateUrl: 'app/components/utils/validation-viewer/validation-viewer.html',
      controllerAs: 'validationviewerctrl',
      bindings: {
        vvTimeline: '='
      },
      controller: ValidationViewerController
    });

  /** @ngInject */
  function ValidationViewerController(/*$log*/) {
    var ctrl = this;

    ctrl.$onInit = function () {
      //$log.info(ctrl.vvTimeline.etapes.etapes);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('treeView', {
      templateUrl: 'app/components/utils/tree-view/tree-view.html',
      controllerAs: 'treeviewctrl',
      bindings: {
        fichiers: '<',
        onSelectFichier: '&',
        isFirst: '<'
      },
      controller: TreeViewController
    });

  /** @ngInject */
  function TreeViewController() {
    var ctrl = this;

    ctrl.selectFichier = selectFichier;

    ctrl.$onInit = function () {
      angular.forEach(ctrl.fichiers, function (fichier) {
        fichier.isFolder = fichier.hasOwnProperty('fichiers');
        fichier.isOpen = false;
      });
    };

    ctrl.$onDestroy = function () {
      angular.forEach(ctrl.fichiers, function (fichier) {
        fichier.selected = false;
      });
    };

    function selectFichier(fichier) {
      if (fichier.isFolder) {
        fichier.isOpen = !fichier.isOpen;
      } else if (ctrl.isFirst) {
        var selected = false;

        checkSelected(ctrl.fichiers, fichier, selected);

        if (fichier.selected) {
          ctrl.onSelectFichier({fichier: fichier});
        } else {
          ctrl.onSelectFichier({fichier: null});
        }
      } else {
        ctrl.onSelectFichier({fichier: fichier});
      }
    }

    function checkSelected(fichiers, fichier, selected) {
      angular.forEach(fichiers, function (current) {
        if (current.file === fichier.file) {
          selected = current.selected = fichier.selected = !current.selected;
        } else {
          current.selected = false;
        }

        if (current.isFolder) {
          checkSelected(current.fichiers, fichier, selected);
        }
      });
    }
  }
})();
/**
 * @desc : Search box configurable :
 *
 * Attributs :
 *   - sb-on-search : Fonction à exécuter lors du lancement de la recherche.
 *                    La fonction a accès au paramètre 'search' qui contient l'ensemble des critères de la search box.
 *
 *   - sb-config :    Options de configuration de la search box
 *
 * @author : vfillon@ics.fr
 * @since : 2016-07-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('searchBox', {
    templateUrl: 'app/components/utils/search-box/search-box.html',
    controllerAs: 'searchboxctrl',
    controller: SearchBoxController,
    bindings: {
      sbOnSearch: '&',
      sbConfig: '<'
    }
  });

  /** @ngInject */
  function SearchBoxController(
    CONSTANTS,
    globalService,
    CustomUtils,
    PropertiesService,
    Prospect,
    ProspectsService,
    CriteresParser,
    toastr,
    $state,
    $rootScope,
    $scope,
    $uibModal,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.initialisation = true;

    ctrl.search = {
      recherche: null,
      cloud: null
    };

    ctrl.resume = {
      active: false,
      html: '',
      tooltip: '',
      focus: focusInput
    };

    ctrl.cloud = false;

    ctrl.criteres = {
      active: false,
      open: false,
      loading: false,
      list: {
        villes: {
          value: null
        },
        types: {
          value: null
        },
        prix: {
          valueMin: null,
          valueMax: null
        },
        criteres: {
          value: null
        }
      }
    };

    ctrl.filtres = {
      active: false,
      open: false,
      loading: false,
      list: {
        geolocalisation: {
          value: null
        },
        societes: {
          value: null
        },
        nego: {
          value: null
        },
        visibilite: {
          valueMandat: null,
          valueArchive: null
        },
        archive: {
          valueArchive: null
        },
        etat: {
          valueAttente: null,
          valueOption: null
        },
        typeContrat: {
          value: null
        },
        typeMandat: {
          value: null
        },
        dateMandat: {
          valueDatedeb: null,
          valueDatefin: null
        },
        expire: {
          value: null
        },
        expirant: {
          value: null
        },
        dateSaisie: {
          valueDatedeb: null,
          valueDatefin: null
        },
        dateSignature: {
          valueDatedeb: null,
          valueDatefin: null
        },
        gestionAgence: {
          value: null
        },
        avancement: {
          value: null
        },
        dureeVacance: {
          value: null
        },
        parution: {
          value: null
        },
        panneaux: {
          value: null
        },
        paru: {
          value: null
        },
        qualification: {
          value: null
        },
        encaissement: {
          value: null
        },
        intrabox: {
          value: null
        },
        valider: {
          value: null
        },
        sansDpe: {
          value: null
        }
      }
    };

    ctrl.prestataires = {
      active: false,
      open: false,
      loading: false,
      selected: null,
      onSelectPrestataire: function (prestataire, firstLoad) {
        ctrl.prestataires.selected = prestataire;
        ctrl.prestataires.value = prestataire.id;
        if (firstLoad) {
          startSearch(false, true);
        }
      },
      value: null
    };

    ctrl.additionalControls = {
      active: false,
      templates: {
        active: false,
        template: null,
        list: [],
        setTemplate: function (template) {
          ctrl.additionalControls.templates.template = template;
          ctrl.sbConfig.templates.onChange(template.nom);
        }
      },
      newElem: {
        active: false,
        open: false,
        typeElem: null,
        type: null,
        typesListe: [],
        ajouterElem: function () {
          var type = false;
          if (ctrl.additionalControls.newElem.typeElem === 'bien') type = ctrl.additionalControls.newElem.type;
          ctrl.sbConfig.additionalControls.newElem.ajouterElem(type);
        }
      },
      searchToProspect: {
        active: false,
        list: [],
        prospect: null,
        textBtn: 'Créer un prospect',
        search: searchInProspects,
        changed: prospectChange,
        valider: validerProspect
      },
      searchToPanier: {
        active: false,
        save: saveSearchToPanier
      },
      impression: {
        active: false,
        imprimer: function () {
          if (
            angular.isDefined(ctrl.sbConfig.additionalControls.imprimer) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.imprimer)
          ) {
            ctrl.sbConfig.additionalControls.imprimer();
          }
        }
      },
      edition: {
        active: false,
        editer: function (action) {
          if (
            angular.isDefined(ctrl.sbConfig.additionalControls.editerTout) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.editerTout)
          ) {
            updateSearch();
            ctrl.sbConfig.additionalControls.editerTout(action, ctrl.search);
          }
        }
      },
      envoyerEmail: {
        active: false,
        envoyer: function () {
          if (
            angular.isDefined(ctrl.sbConfig.additionalControls.envoyerEmail) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.envoyerEmail)
          ) {
            ctrl.sbConfig.additionalControls.envoyerEmail();
          }
        }
      },
      selection: {
        active: false,
        selected: false,
        toggleSelection: function () {
          if (
            angular.isDefined(ctrl.sbConfig.additionalControls.selection) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.selection)
          ) {
            ctrl.additionalControls.selection.selected = !ctrl.additionalControls.selection.selected;
            ctrl.sbConfig.additionalControls.selection(ctrl.additionalControls.selection.selected);
          }
        }
      },
      checkParutions: {
        active: false,
        showParutions: function () {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/modal/check-parutions/modal.check-parutions.html',
            controller: 'ModalCheckParutionsController',
            controllerAs: 'modalcheckparutionsctrl'
          });
          modalInstance.result.then(function () {
            $log.info('Fermeture check parutions');
          });
        }
      }
    };

    ctrl.resetCriteres = {
      active: false,
      reset: resetCriteres
    };

    ctrl.resetFiltres = {
      active: false,
      reset: resetFiltres
    };

    ctrl.configChangeListener = $scope.$watchCollection(
      function () {
        return ctrl.sbConfig;
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (
            newVal.placeholder !== oldVal.placeholder ||
            newVal.additionalControls !== oldVal.additionalControls ||
            newVal.templates !== oldVal.templates ||
            newVal.criteres !== oldVal.criteres ||
            newVal.filtres !== oldVal.filtres ||
            newVal.prestataires !== oldVal.prestataires
          ) {
            initSearchBox(true);
          }
          if (newVal.query !== oldVal.query) {
            initCriteres();
            initFiltres();
          }
        }
      },
      true
    );

    ctrl.templateListener = $scope.$on('template-change', function (event, template) {
      if (ctrl.additionalControls.templates.active) {
        ctrl.additionalControls.templates.setTemplate(template);
      }
    });

    ctrl.togglePanel = togglePanel;
    ctrl.startSearch = startSearch;
    ctrl.raz = raz;

    ctrl.$onInit = function () {
      initSearchBox();
    };

    ctrl.$onDestroy = function () {
      ctrl.configChangeListener();
      ctrl.configChangeListener = null;
      ctrl.templateListener();
      ctrl.templateListener = null;

      if (angular.isDefined(ctrl.additionalControls.selection.selectionListener)) {
        ctrl.additionalControls.selection.selectionListener();
        ctrl.additionalControls.selection.selectionListener = null;
      }

      if (angular.isDefined(ctrl.additionalControls.searchToPanier.panierListener)) {
        ctrl.additionalControls.searchToPanier.panierListener();
        ctrl.additionalControls.searchToPanier.panierListener = null;
      }
    };

    function initSearchBox(reload) {
      if (angular.isDefined(ctrl.sbConfig)) {
        // Placeholder
        ctrl.sbConfig.placeholder = ctrl.sbConfig.placeholder || 'Recherche';

        // Recherche syntaxique
        if (angular.isDefined(ctrl.sbConfig.query) && !CustomUtils.collection.isEmpty(ctrl.sbConfig.query)) {
          ctrl.search.recherche = ctrl.sbConfig.query.recherche || null;
        }

        // Prestataires
        ctrl.prestataires.firstLoad = !reload;

        // Cloud
        ctrl.cloud = angular.isDefined(ctrl.sbConfig.cloud) && ctrl.sbConfig.cloud;

        // Critères & Filtres
        initCriteres();
        initFiltres();

        // Templates
        if (angular.isDefined(ctrl.sbConfig.templates)) {
          var matchTemplate = ctrl.sbConfig.templates.list.filter(function (template) {
              return template.nom === ctrl.sbConfig.templates.default;
            }),
            defaultTemplate = null;

          if (angular.isArray(matchTemplate) && matchTemplate.length) {
            defaultTemplate = matchTemplate[0];
          }

          ctrl.additionalControls.templates.active = true;
          ctrl.additionalControls.templates.template = defaultTemplate || ctrl.sbConfig.templates.list[0];
          ctrl.additionalControls.templates.list = ctrl.sbConfig.templates.list || [];
        }

        // Additional Controls ==> [New elem | Tris | Search to Prospect | Search to Panier | Imprimer | Edition]
        if (angular.isDefined(ctrl.sbConfig.additionalControls)) {
          ctrl.additionalControls.active = true;

          // New Elem
          if (angular.isDefined(ctrl.sbConfig.additionalControls.newElem)) {
            ctrl.additionalControls.newElem.active = true;
            ctrl.additionalControls.newElem.typeElem = ctrl.sbConfig.additionalControls.newElem.typeElem;

            PropertiesService.getTypesBiens({
                typeApplication: globalService.getTypeApplication()
              })
              .then(function (retour) {
                if (retour.status === 'OK') ctrl.additionalControls.newElem.typesListe = retour.list;
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED')
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                } else $log.error(error.status);
              });
          }

          // Tris
          var nomChamps;
          if (angular.isDefined(ctrl.sbConfig.additionalControls.tris)) {
            nomChamps = {
              tri: 'tri',
              ordre: 'ordre'
            };
            var nomTri = ctrl.sbConfig.additionalControls.tris.nomChamp.tri || nomChamps.tri,
              nomOrdre = ctrl.sbConfig.additionalControls.tris.nomChamp.ordre || nomChamps.ordre;

            ctrl.additionalControls.tris = {
              open: false,
              list: ctrl.sbConfig.additionalControls.tris.list || {},
              ordre: ctrl.sbConfig.additionalControls.tris.default.ordre || ctrl.sbConfig.additionalControls.tris.list[0],
              tri: ctrl.sbConfig.additionalControls.tris.default.tri || 'desc',
              trier: function () {
                ctrl.search[nomTri] = ctrl.additionalControls.tris.tri;
                ctrl.search[nomOrdre] = ctrl.additionalControls.tris.ordre;
                startSearch();
              }
            };

            if (angular.isDefined(ctrl.sbConfig.query)) {
              if (angular.isDefined(ctrl.sbConfig.query[nomTri]) && ctrl.sbConfig.query[nomTri] !== null)
                ctrl.additionalControls.tris.tri = ctrl.sbConfig.query[nomTri];
              if (angular.isDefined(ctrl.sbConfig.query[nomOrdre]) && ctrl.sbConfig.query[nomOrdre] !== null)
                ctrl.additionalControls.tris.ordre = ctrl.sbConfig.query[nomOrdre];
            }
          }

          //Search to Prospect & Search to Panier
          ctrl.additionalControls.searchToProspect.active = angular.isDefined(
              ctrl.sbConfig.additionalControls.searchToProspect
            ) ?
            ctrl.sbConfig.additionalControls.searchToProspect :
            false;

          if (angular.isDefined(ctrl.sbConfig.additionalControls.searchToProspect)) {
            var prospect = globalService.getStorageItem('PANIER-PROSPECT') ? new Prospect(globalService.getStorageItem('PANIER-PROSPECT')) : false;
            ctrl.additionalControls.searchToPanier.active = prospect !== false;

            if (angular.isDefined(ctrl.additionalControls.searchToPanier.panierListener)) {
              ctrl.additionalControls.searchToPanier.panierListener();
            }

            ctrl.additionalControls.searchToPanier.panierListener = $rootScope.$on('panierActif', function (
              event,
              active
            ) {
              ctrl.additionalControls.searchToPanier.active = active;

              if (ctrl.additionalControls.searchToPanier.active) {
                var prospect = globalService.getStorageItem('PANIER-PROSPECT');
                if (
                  prospect &&
                  !prospect.referenceInterne.includes('CLOUD-') &&
                  prospect.isModel &&
                  ctrl.resetCriteres.active &&
                  !prospect.hasVilles() &&
                  !prospect.hasTypesBien() &&
                  !prospect.hasPrixMin() &&
                  !prospect.hasPrixMax() &&
                  !prospect.hasCriteres()
                ) {
                  toastr.warning(
                    '<br>Le prospect actif : <br>' +
                    '<strong>' +
                    prospect.perso.getNomComplet() +
                    '</strong><br>' +
                    'n&apos;a aucun crit&egrave;re de recherche enregistr&eacute;.<br>' +
                    'Vous pouvez associer les crit&egrave;res de la recherche actuelle &agrave; ce prospect &agrave; ' +
                    'tout moment en cliquant ici ou sur le bouton pr&eacute;vu &agrave; cet effet situ&eacute; ' +
                    '&agrave; droite de la barre de recherche.',

                    'Prospect actif sans crit&egrave;res.',

                    {
                      timeOut: 10000,
                      tapToDismiss: false,
                      closeButton: true,
                      onTap: function () {
                        ctrl.additionalControls.searchToPanier.save();
                      }
                    }
                  );
                }
              } else {
                raz(true);
              }
            });

            if (ctrl.additionalControls.searchToPanier.active) {
              if (
                prospect &&
                !prospect.referenceInterne.includes('CLOUD-') &&
                prospect.isModel &&
                ctrl.resetCriteres.active &&
                !prospect.hasVilles() &&
                !prospect.hasTypesBien() &&
                !prospect.hasPrixMin() &&
                !prospect.hasPrixMax() &&
                !prospect.hasCriteres()
              ) {
                toastr.warning(
                  '<br>Le prospect actif : <br>' +
                  '<strong><i>' +
                  prospect.perso.getNomComplet() +
                  '</i></strong><br>' +
                  'n&apos;a aucun crit&egrave;re de recherche enregistr&eacute;.<br>' +
                  'Vous pouvez associer les crit&egrave;res de la recherche actuelle &agrave; ce prospect &agrave; ' +
                  'tout moment en cliquant ici ou sur le bouton pr&eacute;vu &agrave; cet effet situ&eacute; ' +
                  '&agrave; droite de la barre de recherche.',

                  'Prospect actif sans crit&egrave;res.',

                  {
                    timeOut: 10000,
                    tapToDismiss: false,
                    closeButton: true,
                    onTap: function () {
                      ctrl.additionalControls.searchToPanier.save();
                    }
                  }
                );
              }
            }
          }

          // Impression
          ctrl.additionalControls.impression.active =
            angular.isDefined(ctrl.sbConfig.additionalControls.imprimer) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.imprimer);

          // Edition
          ctrl.additionalControls.edition.active =
            angular.isDefined(ctrl.sbConfig.additionalControls.editerTout) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.editerTout);

          // Envoyer email
          ctrl.additionalControls.envoyerEmail.active =
            angular.isDefined(ctrl.sbConfig.additionalControls.envoyerEmail) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.envoyerEmail);

          // Check parutions ICSBox
          ctrl.additionalControls.checkParutions.active =
            angular.isDefined(ctrl.sbConfig.additionalControls.checkParutions) &&
            ctrl.sbConfig.additionalControls.checkParutions;

          // Selection
          ctrl.additionalControls.selection.active =
            angular.isDefined(ctrl.sbConfig.additionalControls.selection) &&
            angular.isFunction(ctrl.sbConfig.additionalControls.selection);

          if (ctrl.additionalControls.selection.active) {
            ctrl.additionalControls.selection.selectionListener = $scope.$on('clearSelection', function () {
              ctrl.additionalControls.selection.selected = false;
            });
          }
        }
      } else {
        ctrl.criteres.active = false;
        ctrl.prestataires.active = false;
        ctrl.filtres.active = false;

        ctrl.sbConfig = {
          placeholder: 'Recherche'
        };
      }

      getResume();

      ctrl.initialisation = false;
    }

    function initCriteres(defaultQuery) {
      var currentQuery = defaultQuery ? ctrl.sbConfig.defaultQuery : ctrl.sbConfig.query;

      if (angular.isDefined(ctrl.sbConfig.criteres)) {
        var criteresInUse = false;
        angular.forEach(ctrl.criteres.list, function (critere, nom) {
          var active = angular.isDefined(ctrl.sbConfig.criteres[nom]);
          if (active) ctrl.criteres.active = true;

          switch (nom) {
            case 'prix':
              if (active) {
                critere.valueMin = angular.isDefined(currentQuery[ctrl.sbConfig.criteres[nom].nomChamp.min]) ?
                  currentQuery[ctrl.sbConfig.criteres[nom].nomChamp.min] :
                  null;
                critere.valueMax = angular.isDefined(currentQuery[ctrl.sbConfig.criteres[nom].nomChamp.max]) ?
                  currentQuery[ctrl.sbConfig.criteres[nom].nomChamp.max] :
                  null;
                if (
                  critere.valueMin !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp.min] ||
                  critere.valueMax !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp.max]
                ) {
                  criteresInUse = true;
                }
              } else {
                critere.valueMin = 'NOT_ACTIVE';
                critere.valueMax = 'NOT_ACTIVE';
              }
              break;

            default:
              if (active) {
                critere.value = angular.isDefined(currentQuery[ctrl.sbConfig.criteres[nom].nomChamp]) ?
                  currentQuery[ctrl.sbConfig.criteres[nom].nomChamp] :
                  null;
                if (critere.value !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp]) {
                  criteresInUse = true;
                }
              } else critere.value = 'NOT_ACTIVE';
              break;
          }
        });
        ctrl.resetCriteres.active = criteresInUse;
      } else {
        ctrl.criteres.active = false;
      }

      ctrl.prestataires.active = angular.isDefined(ctrl.sbConfig.prestataires);
      ctrl.prestataires.value = ctrl.prestataires.active ?
        currentQuery[ctrl.sbConfig.prestataires.nomChamp] :
        'NOT_ACTIVE';
      ctrl.prestataires.open = ctrl.prestataires.active;
    }

    function initFiltres(defaultQuery) {
      var currentQuery = defaultQuery ? ctrl.sbConfig.defaultQuery : ctrl.sbConfig.query;

      if (angular.isDefined(ctrl.sbConfig.filtres)) {
        var filtresInUse = false;
        angular.forEach(ctrl.filtres.list, function (filtre, nom) {
          var active = angular.isDefined(ctrl.sbConfig.filtres[nom]);
          if (active) ctrl.filtres.active = true;

          switch (nom) {
            case 'visibilite':
              if (active) {
                if (ctrl.sbConfig.filtres[nom].mandat) {
                  filtre.valueMandat = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.mandat]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.mandat] :
                    null;
                  if (filtre.valueMandat !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.mandat]) {
                    filtresInUse = true;
                  }
                } else filtre.valueMandat = 'NOT_ACTIVE';
                if (ctrl.sbConfig.filtres[nom].archive) {
                  filtre.valueArchive = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.archive]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.archive] :
                    null;
                  if (filtre.valueArchive !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.archive]) {
                    filtresInUse = true;
                  }
                } else filtre.valueArchive = 'NOT_ACTIVE';
              } else {
                filtre.valueMandat = 'NOT_ACTIVE';
                filtre.valueArchive = 'NOT_ACTIVE';
              }
              break;

            case 'dateMandat':
            case 'dateSaisie':
            case 'dateSignature':
              if (active) {
                if (ctrl.sbConfig.filtres[nom].datedeb) {
                  filtre.valueDatedeb = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.datedeb]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.datedeb] :
                    null;
                  if (filtre.valueDatedeb !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.datedeb]) {
                    filtresInUse = true;
                  }
                } else filtre.valueDatedeb = 'NOT_ACTIVE';
                if (ctrl.sbConfig.filtres[nom].datefin) {
                  filtre.valueDatefin = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.datefin]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.datefin] :
                    null;
                  if (filtre.valueDatefin !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.datefin]) {
                    filtresInUse = true;
                  }
                } else filtre.valueDatefin = 'NOT_ACTIVE';
              } else {
                filtre.valueDatedeb = 'NOT_ACTIVE';
                filtre.valueDatefin = 'NOT_ACTIVE';
              }
              break;

            case 'etat':
              if (active) {
                if (ctrl.sbConfig.filtres[nom].attente) {
                  filtre.valueAttente = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.attente]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.attente] :
                    null;
                  if (filtre.valueAttente !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.attente]) {
                    filtresInUse = true;
                  }
                } else filtre.valueAttente = 'NOT_ACTIVE';
                if (ctrl.sbConfig.filtres[nom].option) {
                  filtre.valueOption = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.option]) ?
                    currentQuery[ctrl.sbConfig.filtres[nom].nomChamp.option] :
                    null;
                  if (filtre.valueOption !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.option]) {
                    filtresInUse = true;
                  }
                } else filtre.valueOption = 'NOT_ACTIVE';
              } else {
                filtre.valueAttente = 'NOT_ACTIVE';
                filtre.valueOption = 'NOT_ACTIVE';
              }
              break;

            default:
              if (active) {
                filtre.value = angular.isDefined(currentQuery[ctrl.sbConfig.filtres[nom].nomChamp]) ?
                  currentQuery[ctrl.sbConfig.filtres[nom].nomChamp] :
                  null;
                if (filtre.value !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp]) {
                  filtresInUse = true;
                }
              } else filtre.value = 'NOT_ACTIVE';
              break;
          }
        });
        ctrl.resetFiltres.active = filtresInUse;
      } else {
        ctrl.filtres.active = false;
      }
    }

    function togglePanel(panel, open) {
      open = angular.isDefined(open) ? open : null;
      switch (panel) {
        case 'criteres':
          if (ctrl.criteres.open && (open === null || !open)) ctrl.criteres.open = false;
          else if (open === null || open) {
            ctrl.criteres.open = true;
            ctrl.prestataires.open = false;
            ctrl.filtres.open = false;
          }
          break;

        case 'prestataires':
          if (ctrl.prestataires.open && (open === null || !open)) ctrl.prestataires.open = false;
          else if (open === null || open) {
            ctrl.criteres.open = false;
            ctrl.prestataires.open = true;
            ctrl.filtres.open = false;
          }
          break;

        case 'filtres':
          if (ctrl.filtres.open && (open === null || !open)) ctrl.filtres.open = false;
          else if (open === null || open) {
            ctrl.criteres.open = false;
            ctrl.prestataires.open = false;
            ctrl.filtres.open = true;
          }
          break;
      }
    }

    function focusInput(target, value) {
      togglePanel('criteres', true);
      $timeout(function () {
        $scope.$broadcast('focus', {
          target: target,
          value: value
        });
      });
    }

    function getResume() {
      ctrl.resume.active = false;
      ctrl.resume.tooltip = ctrl.resume.html = '';
      if (ctrl.criteres.list.types.value && ctrl.criteres.list.types.value !== 'NOT_ACTIVE') {
        ctrl.resume.active = true;
        ctrl.resume.tooltip += CustomUtils.string.ucfirst(ctrl.criteres.list.types.value) + ' ';
        ctrl.resume.html +=
          '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'types\', ' +
          ctrl.criteres.list.types.value +
          ')">' +
          CustomUtils.string.ucfirst(ctrl.criteres.list.types.value) +
          '</a> ';
      }
      if (
        (ctrl.criteres.list.prix.valueMin && ctrl.criteres.list.prix.valueMin !== 'NOT_ACTIVE') ||
        (ctrl.criteres.list.prix.valueMax && ctrl.criteres.list.prix.valueMax !== 'NOT_ACTIVE')
      ) {
        ctrl.resume.active = true;
        if (ctrl.criteres.list.prix.valueMin && ctrl.criteres.list.prix.valueMin !== 'NOT_ACTIVE') {
          ctrl.resume.tooltip +=
            (ctrl.criteres.list.prix.valueMax ? 'entre ' : 'à partir de ') + ctrl.criteres.list.prix.valueMin + '€ ';
          ctrl.resume.html +=
            (ctrl.criteres.list.prix.valueMax ? 'entre ' : 'à partir de ') +
            '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'prix\', \'min\')">' +
            ctrl.criteres.list.prix.valueMin +
            '&euro;</a> ';
        }
        if (ctrl.criteres.list.prix.valueMax && ctrl.criteres.list.prix.valueMax !== 'NOT_ACTIVE') {
          ctrl.resume.tooltip +=
            (ctrl.criteres.list.prix.valueMin ? 'et ' : 'en dessous de ') + ctrl.criteres.list.prix.valueMax + '€ ';
          ctrl.resume.html +=
            (ctrl.criteres.list.prix.valueMin ? 'et ' : 'en dessous de ') +
            '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'prix\', \'max\')">' +
            ctrl.criteres.list.prix.valueMax +
            '&euro;</a> ';
        }
      }
      if (ctrl.criteres.list.villes.value && ctrl.criteres.list.villes.value !== 'NOT_ACTIVE') {
        var villes = angular.fromJson(ctrl.criteres.list.villes.value);
        if (angular.isArray(villes) && villes.length) {
          ctrl.resume.active = true;
          ctrl.resume.tooltip += 'à ';
          ctrl.resume.html += 'à ';
          angular.forEach(villes, function (ville, index) {
            ctrl.resume.tooltip += ville.nom + ' ';
            ctrl.resume.html +=
              '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'villes\')">' + ville.nom + '</a> ';
            if (index < villes.length - 1) {
              ctrl.resume.tooltip += 'ou ';
              ctrl.resume.html += 'ou ';
            }
          });
        }
      }
      if (ctrl.criteres.list.criteres.value && ctrl.criteres.list.criteres.value !== 'NOT_ACTIVE') {
        var criteres = angular.fromJson(ctrl.criteres.list.criteres.value);
        if (angular.isArray(criteres) && criteres.length) {
          ctrl.resume.tooltip += '\nCritères : ';
          ctrl.resume.html += '<br>Crit&egrave;res : ';
          angular.forEach(criteres, function (critere, index) {
            switch (critere.critere.type) {
              case 'int':
                if (critere.intMin || critere.intMax) {
                  ctrl.resume.active = true;
                  ctrl.resume.tooltip += critere.critere.nom + ' ';
                  ctrl.resume.html += critere.critere.nom + ' ';
                  if (critere.intMin) {
                    ctrl.resume.tooltip += (critere.intMax ? 'entre ' : 'à partir de ') + critere.intMin + ' ';
                    ctrl.resume.html +=
                      (critere.intMax ? 'entre ' : 'à partir de ') +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'min')\">" +
                      critere.intMin +
                      '</a> ';
                  }
                  if (critere.intMax) {
                    ctrl.resume.tooltip += (critere.intMin ? 'et ' : 'en dessous de ') + critere.intMax;
                    ctrl.resume.html +=
                      (critere.intMin ? 'et ' : 'en dessous de ') +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'max')\">" +
                      critere.intMax +
                      '</a>';
                  }
                  if (index < criteres.length - 1) {
                    ctrl.resume.tooltip += ', ';
                    ctrl.resume.html += ', ';
                  }
                }
                break;

              case 'float':
                if (critere.floatMin || critere.floatMax) {
                  ctrl.resume.active = true;
                  ctrl.resume.tooltip += critere.critere.nom + ' ';
                  ctrl.resume.html += critere.critere.nom + ' ';
                  if (critere.floatMin) {
                    ctrl.resume.tooltip += (critere.floatMax ? 'entre ' : 'à partir de ') + critere.floatMin + ' ';
                    ctrl.resume.html +=
                      (critere.floatMax ? 'entre ' : 'à partir de ') +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'min')\">" +
                      critere.floatMin +
                      '</a> ';
                  }
                  if (critere.floatMax) {
                    ctrl.resume.tooltip += (critere.floatMin ? 'et ' : 'en dessous de ') + critere.floatMax;
                    ctrl.resume.html +=
                      (critere.floatMin ? 'et ' : 'en dessous de ') +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'max')\">" +
                      critere.floatMax +
                      '</a>';
                  }
                  if (index < criteres.length - 1) {
                    ctrl.resume.tooltip += ', ';
                    ctrl.resume.html += ', ';
                  }
                }
                break;

              case 'boolean':
                if (angular.isDefined(critere.bool) && critere.bool !== null) {
                  ctrl.resume.active = true;
                  ctrl.resume.tooltip += critere.critere.nom + ' : ' + critere.bool ? 'oui ' : 'non ';
                  ctrl.resume.html +=
                    critere.critere.nom +
                    ' : ' +
                    '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                    critere.critere.nom +
                    "', " +
                    critere.bool.toString() +
                    ')">' +
                    (critere.bool ? 'oui' : 'non') +
                    '</a> ';
                  if (index < criteres.length - 1) {
                    ctrl.resume.tooltip += ', ';
                    ctrl.resume.html += ', ';
                  }
                }
                break;

              case 'date':
                if (critere.dateMin || critere.dateMax) {
                  ctrl.resume.active = true;
                  ctrl.resume.tooltip += critere.critere.nom + ' ';
                  ctrl.resume.html += critere.critere.nom + ' ';
                  if (critere.dateMin) {
                    ctrl.resume.tooltip += (critere.dateMax ? 'du ' : 'à partir du ') + critere.dateMin + ' ';
                    ctrl.resume.html +=
                      (critere.dateMax ? 'du ' : 'à partir du ') +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'min')\">" +
                      critere.dateMin +
                      '</a> ';
                  }
                  if (critere.dateMax) {
                    ctrl.resume.tooltip += (critere.dateMin ? 'au ' : "jusqu'au ") + critere.dateMax;
                    ctrl.resume.html +=
                      (critere.dateMin ? 'au ' : "jusqu'au ") +
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      "', 'max')\">" +
                      critere.dateMax +
                      '</a>';
                  }
                  if (index < criteres.length - 1) {
                    ctrl.resume.tooltip += ', ';
                    ctrl.resume.html += ', ';
                  }
                }
                break;

              case 'combo':
                if (angular.isArray(critere.combo) && critere.combo.length) {
                  ctrl.resume.active = true;
                  ctrl.resume.tooltip += critere.critere.nom + ' : ';
                  ctrl.resume.html += critere.critere.nom + ' : ';
                  angular.forEach(critere.combo, function (combo, idx) {
                    ctrl.resume.tooltip += combo.label + ' ';
                    ctrl.resume.html +=
                      '<a class="sb-resume-link" ng-click="searchboxctrl.resume.focus(\'' +
                      critere.critere.nom +
                      '\')">' +
                      combo.label +
                      '</a> ';
                    if (idx < combo.length - 1) {
                      ctrl.resume.tooltip += 'ou ';
                      ctrl.resume.html += 'ou ';
                    }
                  });
                  if (index < criteres.length - 1) {
                    ctrl.resume.tooltip += ', ';
                    ctrl.resume.html += ', ';
                  }
                }
                break;
            }
          });
        }
      }
    }

    function updateSearch() {
      if (angular.isDefined(ctrl.sbConfig)) {
        var oldExpire = ctrl.search.expire;
        var recherche = ctrl.search.recherche;

        ctrl.search = {
          recherche: null,
          cloud: null
        };

        if (recherche) {
          ctrl.search.recherche = recherche;
        }

        if (angular.isDefined(ctrl.sbConfig.criteres)) {
          var critereExist = false;
          angular.forEach(ctrl.criteres.list, function (critere, nom) {
            if (angular.isDefined(ctrl.sbConfig.criteres[nom])) {
              switch (nom) {
                case 'prix':
                  if (angular.isDefined(critere.valueMin)) {
                    ctrl.search[ctrl.sbConfig.criteres[nom].nomChamp.min] = critere.valueMin;
                  }
                  if (angular.isDefined(critere.valueMax)) {
                    ctrl.search[ctrl.sbConfig.criteres[nom].nomChamp.max] = critere.valueMax;
                  }
                  if (
                    (angular.isDefined(critere.valueMin) || angular.isDefined(critere.valueMax)) &&
                    (critere.valueMin !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp.min] ||
                      critere.valueMax !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp.max])
                  ) {
                    critereExist = true;
                  }
                  break;

                default:
                  if (angular.isDefined(critere.value)) {
                    ctrl.search[ctrl.sbConfig.criteres[nom].nomChamp] = critere.value;
                    if (critere.value !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.criteres[nom].nomChamp]) {
                      critereExist = true;
                    }
                  }
                  break;
              }
            }
          });
          ctrl.resetCriteres.active = critereExist;
        }

        if (angular.isDefined(ctrl.sbConfig.prestataires) && angular.isDefined(ctrl.prestataires.value)) {
          ctrl.search[ctrl.sbConfig.prestataires.nomChamp] = ctrl.prestataires.value;
        }

        if (angular.isDefined(ctrl.sbConfig.filtres)) {
          var filtreExist = false;
          angular.forEach(ctrl.filtres.list, function (filtre, nom) {
            if (angular.isDefined(ctrl.sbConfig.filtres[nom])) {
              switch (nom) {
                case 'visibilite':
                  if (ctrl.sbConfig.filtres[nom].mandat && angular.isDefined(filtre.valueMandat)) {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.mandat] = filtre.valueMandat;
                    if (filtre.valueMandat !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.mandat]) {
                      filtreExist = true;
                    }
                  }
                  if (ctrl.sbConfig.filtres[nom].archive && angular.isDefined(filtre.valueArchive)) {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.archive] = filtre.valueArchive;
                    if (filtre.valueArchive !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.archive]) {
                      filtreExist = true;
                    }
                  }
                  break;

                case 'dateMandat':
                case 'dateSaisie':
                case 'dateSignature':
                  if (ctrl.sbConfig.filtres[nom].datedeb && angular.isDefined(filtre.valueDatedeb) && filtre.valueDatedeb !== '') {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.datedeb] = filtre.valueDatedeb;
                    if (filtre.valueDatedeb !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.datedeb]) {
                      filtreExist = true;
                    }
                  }
                  if (ctrl.sbConfig.filtres[nom].datefin && angular.isDefined(filtre.valueDatefin) && filtre.valueDatefin !== '') {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.datefin] = filtre.valueDatefin;
                    if (filtre.valueDatefin !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.datefin]) {
                      filtreExist = true;
                    }
                  }
                  break;

                case 'etat':
                  if (ctrl.sbConfig.filtres[nom].attente && angular.isDefined(filtre.valueAttente)) {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.attente] = filtre.valueAttente;
                    if (filtre.valueAttente !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.attente]) {
                      filtreExist = true;
                    }
                  }
                  if (ctrl.sbConfig.filtres[nom].option && angular.isDefined(filtre.valueOption)) {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp.option] = filtre.valueOption;
                    if (filtre.valueOption !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp.option]) {
                      filtreExist = true;
                    }
                  }
                  break;

                case 'expire':
                case 'expirant':
                  if (angular.isDefined(filtre.value)) {
                    if (ctrl.sbConfig.filtres.expire.nomChamp === ctrl.sbConfig.filtres.expirant.nomChamp) {
                      if (nom === 'expire') {
                        ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp] = filtre.value;
                        ctrl.expireWasSet = true;
                      } else if (!ctrl.expireWasSet) {
                        ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp] = filtre.value;
                      } else if (angular.isUndefined(oldExpire)) {
                        ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp] = filtre.value;
                        ctrl.expireWasSet = false;
                      } else {
                        ctrl.expireWasSet = false;
                      }
                    } else {
                      ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp] = filtre.value;
                    }

                    if (filtre.value !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp]) {
                      filtreExist = true;
                    }
                  }
                  break;

                default:
                  if (angular.isDefined(filtre.value)) {
                    ctrl.search[ctrl.sbConfig.filtres[nom].nomChamp] = filtre.value;
                    if (filtre.value !== ctrl.sbConfig.defaultQuery[ctrl.sbConfig.filtres[nom].nomChamp]) {
                      filtreExist = true;
                    }
                  }
                  break;
              }
            }
          });
          ctrl.resetFiltres.active = filtreExist;
        }
      }
      getResume();
    }

    function startSearch(event, keepOpen) {
      updateSearch();

      if (ctrl.criteres && angular.isDefined(ctrl.criteres.open)) ctrl.criteres.open = false;
      if (ctrl.prestataires && angular.isDefined(ctrl.prestataires.open) && !keepOpen) ctrl.prestataires.open = false;
      if (ctrl.filtres && angular.isDefined(ctrl.filtres.open)) ctrl.filtres.open = false;

      ctrl.sbOnSearch({
        search: ctrl.search
      });
      if (angular.isDefined(event) && angular.isFunction(event.preventDefault)) event.preventDefault();
    }

    function searchInProspects(input) {
      ProspectsService.getListe({
        search: {
          recherche: input || null
        },
        numero: 0,
        pas: 10,
        typeApplication: globalService.getTypeApplication(),
        typeMethode: 'simple'
      }).then(
        function (retour) {
          if (retour.status === 'OK') ctrl.additionalControls.searchToProspect.list = retour.prospects;
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function prospectChange() {
      if (
        ctrl.additionalControls.searchToProspect.prospect &&
        ctrl.additionalControls.searchToProspect.prospect !== null
      )
        ctrl.additionalControls.searchToProspect.textBtn = 'Valider';
      else ctrl.additionalControls.searchToProspect.textBtn = 'Créer un prospect';
    }

    function validerProspect() {
      updateSearch();

      CriteresParser.searchToProspect(ctrl.search).then(
        function (json) {
          if (json.status === 'OK') {
            globalService.setStorageItem('SEARCH-TO-PROSPECT', json.prospect);

            if (
              angular.isDefined(ctrl.additionalControls.searchToProspect.prospect) &&
              ctrl.additionalControls.searchToProspect.prospect !== null
            ) {
              $state.go('modifProspect', {
                reference: ctrl.additionalControls.searchToProspect.prospect.referenceInterne,
                typeApplication: globalService.getTypeApplication()
              });
            } else {
              ProspectsService.editerProspect({
                  addProspect: true,
                  typeApplication: globalService.getTypeApplication(),
                  typeMethode: 'complete'
                })
                .then(function (jsonProspect) {
                  if (jsonProspect.status === 'OK') {
                    $state.go('modifProspect', {
                      reference: jsonProspect.prospect.referenceInterne,
                      typeApplication: globalService.getTypeApplication()
                    });
                  }
                })
                .catch(function (error) {
                  if (error.status) {
                    if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                    else if (error.status !== 'SESSION_EXPIRED')
                      $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  } else $log.error(error.status);
                });
            }
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function saveSearchToPanier() {
      updateSearch();

      var prospect = globalService.getStorageItem('PANIER-PROSPECT');

      if (ctrl.additionalControls.searchToPanier.active && prospect && prospect !== null) {
        if (!prospect.referenceInterne.includes('CLOUD-')) {
          CriteresParser.searchToProspect(ctrl.search).then(
            function (json) {
              if (json.status === 'OK') {
                prospect = new Prospect(prospect);

                prospect.prixMin = json.prospect.prixMin;
                prospect.prixMax = json.prospect.prixMax;
                prospect.typesBien = json.prospect.typesBien;
                prospect.villes = json.prospect.villes;
                prospect.setCriteres(json.prospect.criteres);

                ProspectsService.editerProspect({
                    xmlProspect: prospect.toJson(),
                    typeApplication: globalService.getTypeApplication(),
                    typeMethode: 'complete'
                  })
                  .then(function (jsonProspect) {
                    if (jsonProspect.status === 'OK') {
                      $rootScope.$emit('prospectPanierChange', {
                        prospect: jsonProspect.prospect,
                        nb: 0
                      });
                      toastr.success(
                        'Les crit&egrave;res de recherche ont &eacute;t&eacute; sauvegard&eacute;s avec succ&egrave; pour le prospect actif<br>',
                        'Sauvegarde des crit&egrave;res', {
                          timeOut: 8000
                        }
                      );
                    }
                  })
                  .catch(function (error) {
                    if (error.status) {
                      if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                      else if (error.status !== 'SESSION_EXPIRED') {
                        $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                        toastr.error(
                          'La sauvegarde des crit&egrave;res de recherche pour le prospect actif a &eacute;chou&eacute;e.<br>' +
                          'Veuillez recommancer ult&eacute;rieurement.<br>' +
                          'Si le probl&egrave;me persiste, contactez la hotline.<br>',
                          'Probl&egrave;me sauvegarde des crit&egrave;res (code erreur : <i>SRCH-BOX-663</i>)', {
                            timeOut: 8000
                          }
                        );
                      }
                    } else $log.error(error.status);
                  });
              }
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
            }
          );
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: prospect,
            callback: function (retour) {
              if (retour.status === 'OK') {
                CriteresParser.searchToProspect(ctrl.search).then(
                  function (json) {
                    if (json.status === 'OK') {
                      prospect = retour.prospect.isModel ? retour.prospect : new Prospect(retour.prospect);

                      prospect.referenceInterne = json.prospect.referenceInterne;
                      prospect.prixMin = json.prospect.prixMin;
                      prospect.prixMax = json.prospect.prixMax;
                      prospect.typesBien = json.prospect.typesBien;
                      prospect.villes = json.prospect.villes;
                      prospect.setCriteres(json.prospect.criteres);

                      ProspectsService.editerProspect({
                          xmlProspect: prospect.toJson(),
                          typeApplication: globalService.getTypeApplication(),
                          typeMethode: 'complete'
                        })
                        .then(function (jsonProspect) {
                          if (jsonProspect.status === 'OK') {
                            $rootScope.$emit('prospectPanierChange', {
                              prospect: jsonProspect.prospect,
                              nb: 0
                            });
                            toastr.success(
                              'Les crit&egrave;res de recherche ont &eacute;t&eacute; sauvegard&eacute;s avec succ&egrave; pour le prospect actif<br>',
                              'Sauvegarde des crit&egrave;res', {
                                timeOut: 8000
                              }
                            );
                          }
                        })
                        .catch(function (error) {
                          if (error.status) {
                            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                            else if (error.status !== 'SESSION_EXPIRED') {
                              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                              toastr.error(
                                'La sauvegarde des crit&egrave;res de recherche pour le prospect actif a &eacute;chou&eacute;e.<br>' +
                                'Veuillez recommancer ult&eacute;rieurement.<br>' +
                                'Si le probl&egrave;me persiste, contactez la hotline.<br>',
                                'Probl&egrave;me sauvegarde des crit&egrave;res (code erreur : <i>SRCH-BOX-1087</i>)', {
                                  timeOut: 8000
                                }
                              );
                            }
                          } else $log.error(error.status);
                        });
                    }
                  },
                  function (error) {
                    if (error.status) {
                      if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                      else if (error.status !== 'SESSION_EXPIRED')
                        $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    } else $log.error(error.status);
                  }
                );
              } else if (retour.status !== 'SESSION_EXPIRED') {
                toastr.error(
                  'La sauvegarde des crit&egrave;res de recherche pour le prospect actif a &eacute;chou&eacute;e.<br>' +
                  'Veuillez recommancer ult&eacute;rieurement.<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.<br>',
                  'Probl&egrave;me sauvegarde des crit&egrave;res (code erreur : <i>SRCH-BOX-1108</i>)', {
                    timeOut: 8000
                  }
                );
              }
            }
          });
        }
      }
    }

    function raz(fromPanier) {
      resetCriteres(false);
      resetFiltres(false);
      startSearch();
      if (!fromPanier) {
        $rootScope.$emit('removePanier');
      }
    }

    function resetCriteres(reload) {
      initCriteres(true);
      ctrl.search.recherche = null;
      ctrl.resetCriteres.active = false;
      if (reload) {
        startSearch();
      }
      $timeout(function () {
        $scope.$broadcast('resetCriteres');
      });
    }

    function resetFiltres(reload) {
      initFiltres(true);
      ctrl.resetFiltres.active = false;
      if (reload) {
        startSearch();
      }
      $timeout(function () {
        $scope.$broadcast('resetFiltres');
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('timelineHorizontal', {
      templateUrl: 'app/components/utils/timeline-horizontal/timeline-horizontal.html',
      controllerAs: 'timelinehorizontalctrl',
      bindings: {
        listeEtapes: '<',
        etapeCourante: '=',
        onChangeEtape: '&'
      },
      controller: TimeLineHorizontalController
    });

  /** @ngInject */
  function TimeLineHorizontalController() {
    var ctrl = this;

    ctrl.changeEtapeCourante = function (num) {
      ctrl.etapeCourante = num;
      ctrl.onChangeEtape({id: num});
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2017-11-06
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('rSelect', {
    templateUrl: 'app/components/utils/r-select/r-select.html',
    controllerAs: 'rsctrl',
    bindings: {
      ngModel: '=',
      rsOptions: '<',
      rsLabelledBy: '<',
      rsMultiple: '<',
      rsPlaceholder: '<',
      rsGroupBy: '<',
      rsClasses: '<',
      rsSearch: '&',
      rsSearchDelay: '<',
      rsOnChange: '&'
    },
    controller: rSelectController
  });

  /** @ngInject */
  function rSelectController(CustomUtils, $attrs, $scope, $window, $document, $element, $timeout, $log) {
    var ctrl = this;

    ctrl.initialising = true;

    ctrl.search = null;
    ctrl.workingSet = [];
    ctrl.options = [];

    ctrl.searching = false;

    ctrl.multiple = false;
    ctrl.groupBy = [];
    ctrl.isOpen = false;

    ctrl.disabled = false;
    ctrl.placeholder = '';

    ctrl.dropdownStyle = null;

    ctrl.focused = false;

    ctrl.getLabel = getLabel;
    ctrl.onToggleOptions = onToggleOptions;
    ctrl.onSearch = onSearch;
    ctrl.setModel = setModel;
    ctrl.removeChoice = removeChoice;
    ctrl.clearModel = clearModel;
    ctrl.onInputKeyDown = onInputKeyDown;

    ctrl.optionsListener = $scope.$watchCollection(
      function() {
        return ctrl.rsOptions;
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal) {
          setWorkingSet();
          ctrl.options = optionsFilter(ctrl.workingSet);
        }
      },
      true
    );

    ctrl.windowHeightListener = $scope.$watchCollection(
      function() {
        var elemRect = $element[0].getBoundingClientRect();
        return [$window.innerHeight, elemRect.bottom];
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal) {
          var elemRect = $element[0].getBoundingClientRect();
          ctrl.dropdownStyle = {
            'max-height': $window.innerHeight - elemRect.bottom - 30 + 'px'
          };
        }
      },
      true
    );

    ctrl.disabledListener = $scope.$watch(
      function() {
        return angular.isDefined($attrs.disabled) && $attrs.disabled;
      },
      function(newVal) {
        ctrl.disabled = newVal;
      }
    );

    ctrl.$onInit = function() {
      ctrl.multiple = angular.isDefined($attrs.rsMultiple) && ctrl.rsMultiple !== false;
      ctrl.disabled = angular.isDefined($attrs.disabled) && $attrs.disabled;
      ctrl.placeholder =
        angular.isDefined($attrs.rsPlaceholder) && ctrl.rsPlaceholder && (!ctrl.ngModel || ctrl.ngModel.length < 1)
          ? ctrl.rsPlaceholder
          : '';
      ctrl.rsClasses = ctrl.rsClasses || {};

      if (angular.isDefined($attrs.rsGroupBy) && ctrl.rsGroupBy.length) {
        ctrl.groupBy = angular.isArray(ctrl.rsGroupBy) ? ctrl.rsGroupBy : ctrl.rsGroupBy.split(',');
      }
      setWorkingSet();
      ctrl.options = optionsFilter(ctrl.workingSet);

      var elemRect = $element[0].getBoundingClientRect();
      ctrl.dropdownStyle = {
        'max-height': $window.innerHeight - elemRect.bottom - 30 + 'px'
      };

      ctrl.initialising = false;
    };

    ctrl.$onDestroy = function() {
      ctrl.optionsListener();
      ctrl.optionsListener = null;
      ctrl.windowHeightListener();
      ctrl.windowHeightListener = null;
      $document.off('click', onClickOutside);
    };

    function setWorkingSet() {
      if (ctrl.search) {
        var cleanSearch = CustomUtils.string.removeDiacritics(ctrl.search.toLowerCase());
        ctrl.workingSet = [];
        ctrl.rsOptions.forEach(function(option) {
          var matching = false;
          if (ctrl.groupBy.length) {
            ctrl.groupBy.forEach(function(group) {
              var current =
                Object.getByString(option, group) != null
                  ? CustomUtils.string.removeDiacritics(Object.getByString(option, group).toLowerCase())
                  : null;
              if (current != null && current.indexOf(cleanSearch) !== -1) {
                matching = true;
              }
            });
          }
          if (
            matching ||
            CustomUtils.string
              .removeDiacritics(Object.getByString(option, ctrl.rsLabelledBy).toLowerCase())
              .indexOf(cleanSearch) !== -1
          ) {
            ctrl.workingSet.push(option);
          }
        });
      } else {
        ctrl.workingSet = ctrl.rsOptions;
      }
    }

    function optionsFilter(options, index) {
      var retour = [];
      if (!angular.isArray(options)) return retour;
      if (ctrl.groupBy.length) {
        index = angular.isNumber(index) ? index : 0;
        var optMap = new Map();
        options.forEach(function(option) {
          var group = Object.getByString(option, ctrl.groupBy[index]);
          if (group != null) {
            var collection = optMap.get(group);
            if (!collection) {
              optMap.set(group, [option]);
            } else {
              collection.push(option);
            }
          } else {
            retour.push(option);
          }
        });

        retour = ctrl.groupBy.length > index + 1 && retour.length > 1 ? optionsFilter(retour, index + 1) : retour;
        optMap.forEach(function(opts, group) {
          retour.push({
            label: group,
            options: ctrl.groupBy.length > index + 1 ? optionsFilter(opts, index + 1) : opts
          });
        });
      } else {
        retour = options;
      }

      $log.debug(retour);
      return sortOptions(retour);
    }

    function sortOptions(options) {
      if (angular.isArray(options) && options.length > 1) {
        return options.sort(function(a, b) {
          var labelA = (a.label ? a.label : Object.getByString(a, ctrl.rsLabelledBy)).toLowerCase(),
            labelB = (b.label ? b.label : Object.getByString(b, ctrl.rsLabelledBy)).toLowerCase();
          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0;
        });
      } else return options;
    }

    function getLabel(option) {
      return option.label || Object.getByString(option, ctrl.rsLabelledBy) || '';
    }

    function onToggleOptions(open) {
      if (open) {
        ctrl.focusInputSearch = true;
        $document.on('click', onClickOutside);
      }
    }

    function onClickOutside(event) {
      if ($element.find('.rs-options') !== event.target && !$element.has(event.target[0]).length) {
        $timeout(function() {
          ctrl.isOpen = false;
          $document.off('click', onClickOutside);
        });
      }
    }

    function onSearch() {
      var searchDelay = angular.isDefined($attrs.rsSearchDelay) && ctrl.rsSearchDelay ? ctrl.rsSearchDelay : 0;

      if (angular.isDefined($attrs.rsSearch) && angular.isFunction(ctrl.rsSearch) && !ctrl.initialising) {
        var searchPromise = ctrl.rsSearch({ input: ctrl.search });
        if (searchPromise && angular.isFunction(searchPromise.then) && !ctrl.searching) {
          ctrl.searching = true;
          $timeout(function() {
            searchPromise.then(function() {
              ctrl.searching = false;
            });
          }, searchDelay);
        }
      } else {
        $timeout(function() {
          setWorkingSet();
          ctrl.options = optionsFilter(ctrl.workingSet);
        }, searchDelay);
      }
    }

    function setModel(option) {
      if (!ctrl.disabled && (ctrl.multiple || angular.isUndefined(option.options))) {
        ctrl.placeholder = '';
        if (ctrl.multiple) {
          ctrl.ngModel = angular.isArray(ctrl.ngModel) ? ctrl.ngModel : [];
          if (option.hasOwnProperty('options') && angular.isArray(option.options)) {
            ctrl.ngModel = ctrl.ngModel.concat(getGroupOptions(option.options)).unique();
          } else {
            ctrl.ngModel.push(option);
            ctrl.ngModel = ctrl.ngModel.unique();
          }
        } else {
          ctrl.ngModel = option;
          ctrl.focusInputSearch = false;
          $document.off('click', onClickOutside);
          ctrl.isOpen = false;
        }

        if (angular.isDefined($attrs.rsOnChange) && angular.isFunction(ctrl.rsOnChange)) {
          var searchDelay = angular.isDefined($attrs.rsSearchDelay) && ctrl.rsSearchDelay ? ctrl.rsSearchDelay : 0;
          $timeout(function() {
            ctrl.rsOnChange({ model: ctrl.ngModel });
          }, searchDelay);
        }
      }
    }

    function getGroupOptions(options) {
      var temp = [];
      options.forEach(function(option) {
        if (option.hasOwnProperty('options') && angular.isArray(option.options)) {
          temp = temp.concat(getGroupOptions(option.options)).unique();
        } else {
          temp.push(option);
        }
      });
      return temp;
    }

    function removeChoice(choice) {
      if (!ctrl.disabled) {
        ctrl.ngModel = ctrl.multiple
          ? ctrl.ngModel.filter(function(option) {
              return option !== choice;
            })
          : null;

        if (!ctrl.ngModel || (angular.isArray(ctrl.ngModel) && ctrl.ngModel.length < 1)) {
          ctrl.ngModel = null;
          ctrl.placeholder = angular.isDefined($attrs.rsPlaceholder) && ctrl.rsPlaceholder ? ctrl.rsPlaceholder : '';
        }

        if (angular.isDefined($attrs.rsOnChange) && angular.isFunction(ctrl.rsOnChange)) {
          var searchDelay = angular.isDefined($attrs.rsSearchDelay) && ctrl.rsSearchDelay ? ctrl.rsSearchDelay : 0;
          $timeout(function() {
            ctrl.rsOnChange({ model: ctrl.ngModel });
          }, searchDelay);
        }
      }
    }

    function clearModel() {
      if (!ctrl.disabled) {
        ctrl.ngModel = null;
        ctrl.placeholder = angular.isDefined($attrs.rsPlaceholder) && ctrl.rsPlaceholder ? ctrl.rsPlaceholder : '';
        if (!ctrl.multiple) {
          ctrl.isOpen = true;
          ctrl.focusInputSearch = true;
        }

        if (angular.isDefined($attrs.rsOnChange) && angular.isFunction(ctrl.rsOnChange)) {
          var searchDelay = angular.isDefined($attrs.rsSearchDelay) && ctrl.rsSearchDelay ? ctrl.rsSearchDelay : 0;
          $timeout(function() {
            ctrl.rsOnChange({ model: ctrl.ngModel });
          }, searchDelay);
        }
      }
    }

    function onInputKeyDown(event) {
      if (!ctrl.disabled) {
        if (!ctrl.isOpen) {
          ctrl.isOpen = true;
          onToggleOptions(true);
        }

        if (
          event &&
          ctrl.multiple &&
          angular.isArray(ctrl.ngModel) &&
          ctrl.ngModel.length &&
          (!ctrl.search || ctrl.search.length === 0)
        ) {
          if (event.keyCode === 8) {
            if (ctrl.focused) {
              removeChoice(ctrl.ngModel[ctrl.ngModel.length - 1]);
              ctrl.focused = false;
            } else {
              ctrl.focused = true;
            }
          } else {
            ctrl.focused = false;
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('negoSupp', {
    templateUrl: 'app/components/utils/nego-supp/nego-supp.html',
    controllerAs: 'negosuppctrl',
    bindings: {
      contrat: '=',
      isDisabled: '<'
    },
    controller: NegoSuppController
  });

  /** @ngInject */
  function NegoSuppController(CONSTANTS, globalService, RepertoireService, Perso, toastr, $log) {
    var ctrl = this;

    ctrl.transac = globalService.getTypeApplication();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.routes = {
      mandat: ctrl.transac === 'Transaction' ? 'mandatTransaction' : 'mandatLocation',
      aquereur: ctrl.transac === 'Transaction' ? 'acheteur' : 'locataire'
    };

    ctrl.texts = {
      mandat: ctrl.transac === 'Transaction' ? 'vendeur' : 'propriétaire',
      aquereur: ctrl.transac === 'Transaction' ? 'acheteur' : 'locataire'
    };

    ctrl.partsList =
      ctrl.transac === 'Transaction'
        ? [
            {
              label: 'vendeur',
              value: false
            },
            {
              label: 'acheteur',
              value: true
            }
          ]
        : [
            {
              label: 'propriétaire',
              value: false
            },
            {
              label: 'locataire',
              value: true
            }
          ];

    ctrl.taux = {
      affaire: 0,
      aquereur: 0,
      Supp1: 0,
      Supp2: 0,
      Supp3: 0,
      Ext1: 0,
      Ext2: 0,
      Ext3: 0
    };

    ctrl.tauxAgence = 0;
    ctrl.commAgence = 0;

    ctrl.nego = {
      id: null,
      perso: {
        physique: true,
        type: 'PersoPhysique',
        nom: null,
        prenom: null,
        contacts: [
          {
            type: 'Telephone',
            value: null
          }
        ]
      }
    };

    ctrl.calculCommission = calculCommission;
    ctrl.calculParts = calculParts;
    ctrl.openRepertoire = openRepertoire;
    ctrl.addNego = addNego;
    ctrl.deleteNego = deleteNego;

    ctrl.$onInit = function() {
      calculCommission('comm', 'affaire');
      calculCommission('comm', 'aquereur');

      for (var i = 1; i <= 3; i++) {
        if (ctrl.contrat['negoSupp' + i]) {
          calculCommission('comm', 'Supp' + i);
        }
        if (ctrl.contrat['negoExt' + i]) {
          calculCommission('comm', 'Ext' + i);
        }
      }
    };

    function calculCommission(type, origin) {
      if (ctrl.contrat) {
        var tauxComm =
            ctrl.transac === 'Transaction'
              ? ctrl.contrat.affaire[ctrl.routes.mandat].tauxComm
              : ctrl.contrat.tauxHono || ctrl.contrat.affaire[ctrl.routes.mandat].tauxHonoraire,
          commTTC =
            ctrl.transac === 'Transaction'
              ? ctrl.contrat.affaire[ctrl.routes.mandat].prixVente * (tauxComm / 100)
              : ctrl.contrat.affaire[ctrl.routes.mandat].loyer * (tauxComm / 100),
          commHT = commTTC * (100 - ctrl.contrat.tva) / 100,
          comm = ctrl.contrat.affaire[ctrl.routes.mandat].nego.ht ? commHT : commTTC;

        switch (origin) {
          case 'affaire':
            comm = ctrl.contrat.affaire[ctrl.routes.mandat].nego.ht ? commHT : commTTC;
            if (type === 'taux') {
              //noinspection JSPrimitiveTypeWrapperUsage
              ctrl.contrat.commSurAffaire = comm * (ctrl.taux[origin] / 100);
            } else {
              ctrl.taux[origin] = ctrl.contrat.commSurAffaire / comm * 100;
            }

            //noinspection JSPrimitiveTypeWrapperUsage
            ctrl.contrat.commSurAffaire = ctrl.contrat.commSurAffaire || 0;
            ctrl.taux[origin] = ctrl.taux[origin] || 0;
            break;

          case 'aquereur':
            comm = ctrl.contrat[ctrl.routes.aquereur].nego.ht ? commHT : commTTC;
            if (type === 'taux') {
              //noinspection JSPrimitiveTypeWrapperUsage
              ctrl.contrat.commSurAcheteur = comm * (ctrl.taux[origin] / 100);
            } else {
              ctrl.taux[origin] = ctrl.contrat.commSurAcheteur / comm * 100;
            }

            //noinspection JSPrimitiveTypeWrapperUsage
            ctrl.contrat.commSurAcheteur = ctrl.contrat.commSurAcheteur || 0;
            ctrl.taux[origin] = ctrl.taux[origin] || 0;
            break;

          default:
            comm = ctrl.contrat['nego' + origin].ht ? commHT : commTTC;
            if (type === 'taux') {
              ctrl.contrat['comm' + origin] = comm * (ctrl.taux[origin] / 100);
            } else {
              ctrl.taux[origin] = ctrl.contrat['comm' + origin] / comm * 100;
            }

            ctrl.contrat['comm' + origin] = ctrl.contrat['comm' + origin] || 0;
            ctrl.taux[origin] = ctrl.taux[origin] || 0;
            break;
        }

        calcTauxAgence();
      }
    }

    function calcTauxAgence() {
      var tauxComm =
          ctrl.transac === 'Transaction'
            ? ctrl.contrat.affaire[ctrl.routes.mandat].tauxComm
            : ctrl.contrat.tauxHono || ctrl.contrat.affaire[ctrl.routes.mandat].tauxHonoraire,
        commTTC =
          ctrl.transac === 'Transaction'
            ? ctrl.contrat.affaire[ctrl.routes.mandat].prixVente * (tauxComm / 100)
            : ctrl.contrat.affaire[ctrl.routes.mandat].loyer * (tauxComm / 100),
        commHT = commTTC * (100 - ctrl.contrat.tva) / 100,
        comm = ctrl.contrat.affaire[ctrl.routes.mandat].nego.ht ? commHT : commTTC;

      ctrl.tauxAgence = 100;

      angular.forEach(ctrl.taux, function(taux) {
        ctrl.tauxAgence -= taux;
      });

      ctrl.tauxAgence = Math.round(ctrl.tauxAgence * 100) / 100;
      ctrl.commAgence = Math.round(comm * (ctrl.tauxAgence / 100) * 100) / 100;
    }

    function calculParts() {
      var nbAffaire = 1,
        partAffaire = 0.5,
        nbAquereur = 1,
        partAquereur = 0.5;

      for (var i = 1; i <= 3; i++) {
        if (ctrl.contrat['negoSupp' + i]) {
          if (angular.isDefined(ctrl.contrat['sortantSupp' + i])) {
            ctrl.contrat['sortantSupp' + i] ? nbAquereur++ : nbAffaire++;
          }
        }else{
          delete ctrl.contrat['sortantSupp' + i] ;
          delete ctrl.contrat['partSupp' + i] ;
        }
        if (ctrl.contrat['negoExt' + i]) {
          if (angular.isDefined(ctrl.contrat['sortantExt' + i])) {
            ctrl.contrat['sortantExt' + i] ? nbAquereur++ : nbAffaire++;
          }
        }else{
            delete ctrl.contrat['sortantExt' + i];
            delete ctrl.contrat['partExt' + i];
        }
      }

      partAffaire = Math.floor(partAffaire / nbAffaire * 100) / 100;
      partAquereur = Math.floor(partAquereur / nbAquereur * 100) / 100;

      //noinspection JSPrimitiveTypeWrapperUsage
      ctrl.contrat.partAffaire = partAffaire;
      //noinspection JSPrimitiveTypeWrapperUsage
      ctrl.contrat.partAcheteur = partAquereur;

      for (var j = 1; j <= 3; j++) {
        if (angular.isDefined(ctrl.contrat['sortantSupp' + j])) {
          ctrl.contrat['partSupp' + j] = ctrl.contrat['sortantSupp' + j] ? partAquereur : partAffaire;
        } else {
          ctrl.contrat['partSupp' + j] = null;
        }
        if (angular.isDefined(ctrl.contrat['sortantExt' + j])) {
          ctrl.contrat['partExt' + j] = ctrl.contrat['sortantExt' + j] ? partAquereur : partAffaire;
        } else {
          ctrl.contrat['partExt' + j] = null;
        }
      }
    }

    function openRepertoire() {
      RepertoireService.openRepertoire({
        type: 'nego'
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.nego.id = retour.id;
            ctrl.nego.perso = retour.perso;
            $log.info(retour);
            if(retour.typeRepertoire==="negoext"){
                addNego(false);
            }else{
                addNego(true);
            }            
          } else if (retour.status !== 'SESSION_EXPIRED') {
            toastr.error(
              'Une erreur s&apos;est produite lors de la s&eacute;lection du n&eacute;gociateur.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

              'Probl&egrave;me s&eacute;lection n&eacute;gociateur (code erreur : <i>NEG-SUP-230</i>)',

              { timeOut: 8000 }
            );
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de la s&eacute;lection du n&eacute;gociateur.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me s&eacute;lection n&eacute;gociateur (code erreur : <i>NEG-SUP-244</i>)',

                { timeOut: 8000 }
              );
            }
          } else $log.error(error.status);
        }
      );
    }

    function addNego(intern) {
      
      var num = intern ? getNextNego('Supp') : getNextNego('Ext');

      if (num) {
        ctrl.nego.errorNom = !intern && !angular.isString(ctrl.nego.perso.nom);
        ctrl.nego.errorPrenom = false;//!intern && !angular.isString(ctrl.nego.perso.prenom);

        if ((intern && ctrl.nego.id) || (!ctrl.nego.errorNom && !ctrl.nego.errorPrenom)) {
          ctrl.contrat[intern ? 'negoSupp' + num : 'negoExt' + num] = {
            id: ctrl.nego.id,
            perso: new Perso(ctrl.nego.perso)
          };
          ctrl.nego = {
            id: null,
            perso: {
              physique: true,
              type: 'PersoPhysique',
              nom: null,
              prenom: null,
              contacts: [
                {
                  type: 'Telephone',
                  value: null
                }
              ]
            }
          };
        }

        ctrl.contrat[intern ? 'partSupp' + num : 'partExt' + num] = 0;
        ctrl.contrat[intern ? 'tauxSupp' + num : 'tauxExt' + num] = 0;
        ctrl.contrat[intern ? 'commSupp' + num : 'commExt' + num] = 0;
      } else {
        ctrl.nego = {
          id: null,
          perso: {
            physique: true,
            type: 'PersoPhysique',
            nom: null,
            prenom: null,
            contacts: [
              {
                type: 'Telephone',
                value: null
              }
            ]
          }
        };

        toastr.warning(
          '<br>Vous ne pouvez pas ajouter d&apos;aventage de n&eacute;gociateur ' +
            (intern ? 'suppl&eacute;mentaire' : 'externe'),

          'Limite du nombre de nego ' + (intern ? 'suppl&eacutementaire' : 'externe') + ' atteinte<br>',

          { timeOut: 8000 }
        );
      }
    }

    function getNextNego(type, num) {
      num = num || 1;
      if (num <= 3) {
        return angular.isDefined(ctrl.contrat['nego' + type + num]) ? getNextNego(type, num + 1) : num;
      } else return false;
    }

    function deleteNego(nego) {
      ctrl.contrat['nego' + nego] = null;
      ctrl.contrat['part' + nego] = null;
      ctrl.contrat['comm' + nego] = null;
      ctrl.contrat['sortant' + nego] = null;
      calculParts();
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('personnalite', {
    templateUrl: 'app/components/utils/personnalite/personnalite.html',
    controllerAs: 'personnalitectrl',
    bindings: {
      personnalite: '=',
      etatCivil: '<',
      gravitant: '<',
      isRequired: '<',
      isLoading: '=',
      paramsGestion: '=',
      template: '<',
      typeOnly: '<'
    },
    controller: PersonnaliteController
  });

  /** @ngInject */
  function PersonnaliteController(CONSTANTS, globalService, CustomUtils, ReferencesService, Perso, $timeout, $log) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.etatCivilService = {
      active: ctrl.etatCivil,
      open: false
    };
    ctrl.commentairelService = {
      active: true,
      open: false
    };
    ctrl.RefCivilite = [];
    ctrl.RefTypeContact = [];
    ctrl.RefFormeJuridique = [];

    ctrl.contacts = {
      type: null,
      value: null,
      required: false,
      types: [
        {
          name: 'Email',
          value: 'Email'
        },
        {
          name: 'Portable',
          value: 'TelMobile'
        },
        {
          name: 'Fixe',
          value: 'Telephone'
        }
      ],
      add: addContact,
      edit: editContact,
      save: saveContact,
      delete: deleteContact
    };

    ctrl.datepicker = {
      open: false,
      onClose: onCloseDatepicker
    };

    ctrl.getTypeValue = getTypeValue;
    ctrl.modifTypePerso = modifTypePerso;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.personnalite) {
        ctrl.personnalite = ctrl.personnalite.isModel ? ctrl.personnalite : new Perso(ctrl.personnalite);

        if (!ctrl.personnalite.hasType()) {
          if (ctrl.typeOnly == 'morale') {
            ctrl.personnalite.type = 'PersoMorale';
            ctrl.personnalite.physique = false;
            ctrl.personnalite.morale = true;
          } else {
            ctrl.personnalite.type = 'PersoPhysique';
            ctrl.personnalite.physique = true;
            ctrl.personnalite.morale = false;
          }
        }

        checkContactRequired();

        if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = true;

        ReferencesService.getReferences({
          classes: 'RefCivilite,RefTypeContact,RefFormeJuridique',
          typeApplication: globalService.getTypeApplication()
        })
          .then(function(json) {
            if (json.status === 'OK') {
              ctrl.listRef = json.list;
              ctrl.RefCivilite = json.list.RefCivilite;

              if (ctrl.gravitant) {
                ctrl.RefCivilite = ctrl.RefCivilite.filter(function(civilite) {
                  return civilite.simple;
                });
              }

              ctrl.RefTypeContact = json.list.RefTypeContact;
              ctrl.RefFormeJuridique = json.list.RefFormeJuridique;

              if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
            }
          })
          .catch(function(error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            if (angular.isDefined(ctrl.isLoading)) ctrl.isLoading = false;
          });
      } else $timeout(initialisation, 200);
    }

    function getTypeValue(type) {
      var result = ctrl.contacts.types.filter(function(current) {
        return current.value === type;
      });
      return angular.isObject(result) && !CustomUtils.collection.isEmpty(result) ? result[0].name : false;
    }

    function onCloseDatepicker() {
      ctrl.datepicker.open = false;
    }

    function addContact() {
      ctrl.personnalite.contacts.push({
        value: ctrl.contacts.value,
        type: ctrl.contacts.type
      });

      ctrl.contacts.value = null;
      ctrl.contacts.type = null;
      checkContactRequired();
    }

    function editContact(contactId) {
      ctrl.contacts.editing = true;
      ctrl.contacts.current = contactId;
    }

    function saveContact() {
      ctrl.contacts.current = null;
      ctrl.contacts.editing = false;
    }

    function deleteContact(contactId) {
      angular.forEach(ctrl.personnalite.contacts, function(contact, index) {
        if (contact.id === contactId) {
          ctrl.personnalite.contacts.splice(index, 1);
        }
      });
      ctrl.contacts.current = null;
      ctrl.contacts.editing = false;
      checkContactRequired();
    }

    function checkContactRequired() {
      ctrl.contacts.required = ctrl.citya && !ctrl.personnalite.getTelMobile() && !ctrl.personnalite.getTel();
    }

    function modifTypePerso() {
      if (ctrl.personnalite.type === 'PersoPhysique') {
        ctrl.personnalite.physique = true;
        ctrl.personnalite.morale = false;
      } else {
        ctrl.personnalite.physique = false;
        ctrl.personnalite.morale = true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('loader', {
      templateUrl: 'app/components/utils/loader/loader.html',
      controllerAs: 'loaderctrl',
      controller: LoaderController
    });

  /** @ngInject */
  function LoaderController() {}
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('listeGravitants', {
    templateUrl: 'app/components/utils/liste-gravitants/liste-gravitants.html',
    controllerAs: 'listegravitantsctrl',
    controller: ListeGravitantsController,
    bindings: {
      gravitants: '=',
      isDisabled: '<'
    }
  });

  /** @ngInject */
  function ListeGravitantsController(
    globalService,
    ReferencesService,
    Perso,
    RepertoireService,
    toastr,
    $scope,
    $attrs,
    $log
  ) {
    var ctrl = this;

    ctrl.disabled = $attrs.isDisabled && angular.isDefined(ctrl.isDisabled) ? ctrl.isDisabled : false;

    ctrl.isLoading = false;

    ctrl.gravitant = {
      open: false,
      typesList: [],
      current: {
        type: null,
        perso: new Perso()
      },
      ajouter: ajouterGravitant,
      search: searchGravitant,
      supprimer: supprimerGravitant
    };

    $scope.$watchCollection(
      function() {
        return ctrl.gravitants;
      },
      function(newVal, oldVal) {
        if (newVal !== oldVal) {
          angular.forEach(ctrl.gravitants, function(gravitant) {
            gravitant.perso = gravitant.perso.isModel ? gravitant.perso : new Perso(gravitant.perso);
          });
        }
      }
    );

    ctrl.$onInit = function() {
      ctrl.gravitants = ctrl.gravitants || [];
      getTypesGravitants();

      angular.forEach(ctrl.gravitants, function(gravitant) {
        gravitant.perso = gravitant.perso.isModel ? gravitant.perso : new Perso(gravitant.perso);
      });
    };

    function getTypesGravitants() {
      var classe = 'RefTypeGravitant' + (globalService.getTypeApplication() === 'Transaction' ? 'Transaction' : '');
      ctrl.isLoading = true;
      ReferencesService.getReferences({
        classes: classe,
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(json) {
          if (json.status === 'OK') {
            ctrl.gravitant.typesList = json.list[classe];
          }
          ctrl.isLoading = false;
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.isLoading = false;
        });
    }

    function ajouterGravitant() {
      if (
        ctrl.gravitant.current.type &&
        ctrl.gravitant.current.perso.hasNom() &&
        ctrl.gravitant.current.perso.hasAdresses()
      ) {
        ctrl.gravitant.current.modifiable = true;
        ctrl.gravitants.push(ctrl.gravitant.current);
        // Réinitialiser l'objet current après avoir ajouté le nouveau gravitant
        ctrl.gravitant.current = {
          type: null,
          perso: new Perso()
        };
      } else {
        toastr.warning(
          "Vous devez renseigner au moins le type de gravitant, son nom et son adresse pour pouvoir l'enregistrer.",
          'Saisie gravitant incomplète',
          { timeOut: 8000 }
        );
      }
    }

    function searchGravitant() {
      ctrl.gravitant.open = true;

      RepertoireService.openRepertoire().then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.gravitant.current.perso = retour.perso;
          } else if (retour.status !== 'SESSION_EXPIRED') {
            toastr.error(
              "Une erreur s'est produite lors de la sélection de la personnalité.<br>" +
                'Veuillez réessayer ultérieurement.<br>' +
                '<br>' +
                'Si le problème persiste, contactez la hotline.',
              'Problème sélection de personnalité (code erreur : <i>INFBA-120</i>)',
              { timeOut: 8000 }
            );
          }
        },
        function(error) {
          if (error.status !== 'SESSION_EXPIRED') {
            toastr.error(
              "Une erreur s'est produite lors de la sélection de la personnalité.<br>" +
                'Veuillez réessayer ultérieurement.<br>' +
                '<br>' +
                'Si le problème persiste, contactez la hotline.',
              'Problème sélection de personnalité (code erreur : <i>INFBA-133</i>)',
              { timeOut: 8000 }
            );
          }
        }
      );
    }

    function supprimerGravitant(target) {
      ctrl.gravitants = ctrl.gravitants.filter(function(gravitant) {
        return gravitant !== target;
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('communication', {
    templateUrl: 'app/components/utils/communication/communication.html',
    controllerAs: 'communicationctrl',
    bindings: {
      lot: '=',
      prospect: '=',
      isLoading: '='
    },
    controller: CommunicationController
  });

  /** @ngInject */
  function CommunicationController(
    EvenementsService,
    ReferencesService,
    globalService,
   
    $rootScope,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.query = {
      lotid: null,
      prospectid: null
    };

    ctrl.listeEvenements = [];
    ctrl.eventsAAfficher = [];

    ctrl.ordre = '-index';

    ctrl.ready = false;

    ctrl.references = {};

    ctrl.nbevents = 0;

    ctrl.ajoutEvent = true;

    ctrl.types = {
      list: []
    };

    ctrl.date = {
      datedebut: null,
      datefin: null,
      debutOpen: false,
      finOpen: false,
      onChoseDebut: function(retour) {
        ctrl.date.datedebut = retour.date;
      },
      onChoseFin: function(retour) {
        ctrl.date.datefin = retour.date;
      },
      onCloseDebut: function() {
        ctrl.date.debutOpen = false;
      },
      onCloseFin: function() {
        ctrl.date.finOpen = false;
      }
    };
    ctrl.nego = globalService.getEmploye();
    initialisationAjout();

    ctrl.getListeEvenement = getListeEvenement;
    ctrl.addEvenement = addEvenement;
    ctrl.showFiche = showFiche;
    ctrl.showProspect = showProspect;

    ctrl.editEvenement = editEvenement;
    ctrl.modifEvenement = modifEvenement;
    ctrl.newEvenement = newEvenement;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (ctrl.prospect || ctrl.lot) {
        ctrl.query = {
          lotid: angular.isDefined(ctrl.lot) && ctrl.lot.id ? ctrl.lot.id : null,
          prospectid: angular.isDefined(ctrl.prospect) && ctrl.prospect.id ? ctrl.prospect.id : null
        };
        ctrl.getListeEvenement();
        getReference();
      } else {
        $timeout(function() {
          initialisation();
        }, 200);
      }
    }

    function getListeEvenement() {
      ctrl.isLoading = true;

      if (ctrl.types.list.length > 0) {
        var ids = [];
        angular.forEach(ctrl.types.list, function(type) {
          if (type.checked) {
            ids.push(type.data);
          }
        });
        ctrl.query.typeIds = ids.join(',');

        ctrl.query.debut = ctrl.date.datedebut || null;
        ctrl.query.fin = ctrl.date.datefin || null;
      }
      $log.warn('lance event');
      EvenementsService.getList(ctrl.query)
        .then(affichageJsonEvnement)
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.eventsAAfficher = [];
          ctrl.ready = true;
          ctrl.critere = {
            open: false
          };
          ctrl.isLoading = false;
        });
    }

    function getReference() {
      ReferencesService.getReferences({
        classes: 'RefEvenement',
        typeApplication: globalService.getTypeApplication()
      }).then(function(json) {
        if (json.status === 'OK') {
          ctrl.references = json.list;
          ctrl.types = {
            list: angular.copy(json.list.RefEvenement).filter(function(type) {
              type.checked = angular.isDefined(type.cocherDefaut) ? type.cocherDefaut : true;
              if (globalService.getTypeApplication() === 'Transaction') {
                return (
                  type.data !== 3000 &&
                  type.data !== 3001 &&
                  type.data !== 3002 &&
                  type.data !== 3003 &&
                  type.data !== 3004
                );
              } else {
                return (
                  type.data !== 8 &&
                  type.data !== 10 &&
                  type.data !== 200 &&
                  type.data !== 201 &&
                  type.data !== 2000 &&
                  type.data !== 3701
                );
              }
            })
          };
        }
      });
    }

    function affichageJsonEvnement(json) {
      var tableauEvents = [];
      var listeEvents = {};
      $log.warn('debut event');
      if (json.status === 'OK') {
        ctrl.listeEvenements = json.list;

        var arrayTypesPanneaux = [200, 201, 3000, 3001, 3102];

        angular.forEach(ctrl.listeEvenements, function(event) {
          var index = indexedDate(event.date),
            textEvenement = event.commentaire,
            nego = '',
            heure = '',
            date = '',
            dateComplete = '';

          if (arrayTypesPanneaux.includes(event.type.data)) {
            var textRetire = '';
            if (event.active === false) {
              textRetire = '(RETIRÉ) ';
            }
            textEvenement = textRetire + event.type.label;
          }
          if (event.type.data === 2 && event.active === false) {
            textEvenement = '(ANNULÉ) ' + event.commentaire;
          }
          if (angular.isDefined(event.parution)) {
            textEvenement = event.parution.prestataire.nom + ' - ' + event.commentaire;
          }
          if (angular.isDefined(event.parutionLibre)) {
            var regex = new RegExp(',', 'g');
            textEvenement += ' - ' + event.parutionLibre.replace(regex, ', ');
          }
          if (
            angular.isDefined(event.prospect) &&
            angular.isDefined(event.prospect.perso) &&
            angular.isDefined(event.prospect.perso.nomComplet)
          ) {
            textEvenement += ' - ' + event.prospect.perso.nomComplet;
          }
          if (angular.isDefined(event.compteRendu) && event.compteRendu !== '') {
            textEvenement += ' - ' + event.compteRendu;
          }
          if (
            angular.isDefined(event.negociateur) &&
            event.negociateur !== '' &&
            angular.isDefined(event.negociateur.perso) &&
            angular.isDefined(event.negociateur.perso.nomComplet)
          ) {
            nego = event.negociateur.perso.nomComplet
              ? event.negociateur.perso.nomComplet
              : event.negociateur.initiales;
            textEvenement += ' - par ' + nego;
          }
          if (angular.isDefined(event.date) && event.date !== '' && event.date.length >= 12) {
            dateComplete = event.date;
            date = event.date.substring(0, 10);
            heure = event.date.substring(11);
          }

          var current = {
            evenement: event,
            heure: heure,
            text: textEvenement,
            tooltip: 'le ' + dateComplete + ' par ' + nego
          };

          if (angular.isDefined(event.lot) && !ctrl.lot) current.refLot = event.lot.referenceInterne;
          if (angular.isDefined(event.prospect) && !ctrl.prospect)
            current.refProspect = event.prospect.referenceInterne;

          if (!listeEvents.hasOwnProperty(index)) {
            listeEvents[index] = {
              badgeClass: 'badgeOk',
              badgeIconClass: 'fa-calendar',
              title: 'Evenement',
              contents: [],
              date: date,
              index: index
            };
          }

          listeEvents[index].contents.push(current);
        });
      }
      $log.warn('fin event');
      angular.forEach(listeEvents, function(event) {
        tableauEvents.push(event);
      });
      ctrl.eventsAAfficher = tableauEvents;
      ctrl.ready = true;
      ctrl.critere = {
        open: false
      };
      $log.warn('unloading');
      ctrl.isLoading = false;
    }

    function indexedDate(date) {
      if (angular.isDefined(date) && date !== '' && date.length >= 10) {
        var dateAIndexer = date.substring(0, 10);
        var arrayDate = dateAIndexer.split('/');
        return arrayDate[2] + arrayDate[1] + arrayDate[0];
      } else {
        return '';
      }
    }

    function verificationEnvoie(ajoutevenement) {
      $log.info(ajoutevenement);
      return !(
        angular.isDefined(ajoutevenement.$error) &&
        angular.isDefined(ajoutevenement.$error.required) &&
        ajoutevenement.$error.required.length > 0
      );
    }

    function addEvenement(ajoutevenement) {
      if (verificationEnvoie(ajoutevenement)) {
        var type = angular.copy(ctrl.ajout.type);
        delete type.checked;

        ctrl.query.xml = {
          accompli: false,
          active: true,
          alertMail: false,
          compteRendu: '',
          commentaire: ctrl.ajout.description,
          type: type,
          negociateur: {
            id: ctrl.nego.id
          },
          suivi: false,
          date: ctrl.ajout.datedebut,
          dateFin: ctrl.ajout.datefin
        };

        if (ctrl.lot) {
          ctrl.query.xml.lot = {
            id: ctrl.lot.id,
            type: ctrl.lot.type
          };
        }
        if (ctrl.prospect) {
          ctrl.query.xml.prospect = {
            id: ctrl.prospect.id
          };
        }

        EvenementsService.ajouter(ctrl.query).then(function(json) {
          affichageJsonEvnement(json);
          initialisationAjout();
          ajoutevenement.$setPristine();
        });
      }
    }

    function editEvenement(evenement) {
      $log.info(evenement.evenement);
      ctrl.evenementSelected = evenement.evenement;
      ctrl.ajoutEvent = false;
      ctrl.modifIsOpen = true;
    }

    function modifEvenement(evenement) {
      ctrl.query.xml = evenement;
      EvenementsService.ajouter(ctrl.query).then(function(json) {
        affichageJsonEvnement(json);
        initialisationAjout();
        ctrl.ajoutEvent = true;
        ctrl.modifIsOpen = false;
      });
    }

    function newEvenement() {
      initialisationAjout();
      ctrl.ajoutEvent = true;
      ctrl.modifIsOpen = false;
    }
    function showFiche(refLot) {
      $rootScope.$emit('showFiche', { type: 'ficheBien', ref: refLot });
    }

    function showProspect(referenceInterne) {
      $rootScope.$emit('showFiche', { type: 'ficheProspect', ref: referenceInterne });
    }

    function initialisationAjout() {
      ctrl.ajout = {
        debutOpen: false,
        finOpen: false,
        onChoseDebut: function(retour) {
          ctrl.ajout.datedebut = retour.date;
        },
        onChoseFin: function(retour) {
          ctrl.ajout.datefin = retour.date;
        },
        onCloseDebut: function() {
          ctrl.ajout.debutOpen = false;
        },
        onCloseFin: function() {
          ctrl.ajout.finOpen = false;
        }
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('datetimePicker', {
      templateUrl: 'app/components/utils/datetime-picker/datetime-picker.html',
      controllerAs: 'datetimepickerctrl',
      controller: DatetimePickerController,
      bindings: {
        model: '=',
        dateModel: '=',
        heureModel: '=',
        modelFin: '=',
        heureFinModel: '=',
        timePicker: '<',
        timeRange: '<',
        isSupprimable: '<',
        nouveauActive: '<',
        onNouveau: '&',
        onAnnuler: '&',
        onChose: '&',
        onClose: '&',
        onFullScreen: '&',
        onSelectSocietes: '&',
        onSelectNego: '&'
      }
    });

  /** @ngInject */
  function DatetimePickerController(CONSTANTS, globalService, RepertoireService, moment, $attrs, $timeout, $log) {
    var ctrl = this;

    ctrl.date = new Date();
    ctrl.heure = null;
    ctrl.heureFin = null;

    ctrl.heureFinAuto = true;

    ctrl.timepicker = ctrl.timePicker || (angular.isDefined($attrs.timePicker) && angular.isUndefined(ctrl.timePicker));
    ctrl.timerange = ctrl.timeRange || (angular.isDefined($attrs.timeRange) && angular.isUndefined(ctrl.timeRange));
    ctrl.annulation = angular.isDefined($attrs.onAnnuler);
    ctrl.supprimable = angular.isUndefined($attrs.isSupprimable) || ctrl.isSupprimable;
    ctrl.nouveau = angular.isDefined($attrs.nouveauActive) && ctrl.nouveauActive;

    ctrl.datepicker = {
      options: {
        showWeeks: false,
        startingDay: 1
      }
    };

    ctrl.baseModels = {
      model: ctrl.model,
      date: ctrl.dateModel,
      heure: ctrl.heureModel,
      modelFin: ctrl.modelFin,
      heureFin: ctrl.heureFinModel
    };

    ctrl.fullScreen = {
      active: angular.isDefined($attrs.onFullScreen) && angular.isFunction(ctrl.onFullScreen),
      isFullScreen: false,
      toggle: toggleFullScreen
    };

    ctrl.societes = {
      active: angular.isDefined($attrs.onSelectSocietes) && angular.isFunction(ctrl.onSelectSocietes),
      list: [],
      currentList: [],
      societes: [],
      societesId: null,
      groupChoices: societeGroupChoices,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      active: angular.isDefined($attrs.onSelectNego) && angular.isFunction(ctrl.onSelectNego),
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.onChange = onChange;
    ctrl.choseDate = choseDate;
    ctrl.nouveauRdv = nouveauRdv;
    ctrl.removeDate = removeDate;
    ctrl.closeDate = closeDate;
    ctrl.annulerRDV = annulerRDV;

    ctrl.$onInit = function () {
      ctrl.date = ctrl.heure = new Date();

      ctrl.model = angular.isDefined($attrs.model) && angular.isUndefined(ctrl.model) ? null : ctrl.model;
      ctrl.dateModel = angular.isDefined($attrs.dateModel) && angular.isUndefined(ctrl.dateModel) ? null : ctrl.dateModel;
      ctrl.heureModel = angular.isDefined($attrs.heureModel) && angular.isUndefined(ctrl.heureModel) ? null : ctrl.heureModel;
      ctrl.modelFin = angular.isDefined($attrs.modelFin) && angular.isUndefined(ctrl.modelFin) ? null : ctrl.modelFin;
      ctrl.heureFinModel = angular.isDefined($attrs.heureFinModel) && angular.isUndefined(ctrl.heureFinModel) ? null : ctrl.heureFinModel;

      if (angular.isDefined(ctrl.model)) {
        if (ctrl.model === null) {
          ctrl.model = '';
        }
        if (angular.isFunction(ctrl.model.getMonth)) {
          ctrl.date = ctrl.heure = ctrl.model;
        } else if (angular.isString(ctrl.model)) {
          if (ctrl.model.includes('/') && ctrl.model.includes('h')) {
            ctrl.date = ctrl.heure = moment(ctrl.model, CONSTANTS.date_format).toDate();
          } else if (ctrl.model.includes('/')) {
            ctrl.date = ctrl.heure = moment(ctrl.model, 'DD/MM/YYYY').toDate();
          } else if (ctrl.model.includes('h')) {
            ctrl.date = ctrl.heure = moment(ctrl.model, 'HH[h]mm').toDate();
          } else {
            ctrl.date = ctrl.heure = new Date();
          }
        } else {
          ctrl.date = ctrl.heure = new Date();
        }
      }

      if (angular.isDefined(ctrl.dateModel)) {
        if (ctrl.dateModel === null) {
          ctrl.dateModel = '';
        }
        if (angular.isFunction(ctrl.dateModel.getMonth)) {
          ctrl.date = ctrl.dateModel;
        } else if (angular.isString(ctrl.dateModel)) {
          if (ctrl.dateModel.includes('/') && ctrl.dateModel.includes('h')) {
            ctrl.date = moment(ctrl.dateModel, CONSTANTS.date_format).toDate();
          } else if (ctrl.dateModel.includes('/')) {
            ctrl.date = moment(ctrl.dateModel, 'DD/MM/YYYY').toDate();
          } else {
            ctrl.date = new Date();
          }
        } else {
          ctrl.date = new Date();
        }
      }

      if (angular.isDefined(ctrl.heureModel)) {
        if (ctrl.heureModel === null) {
          ctrl.heureModel = '';
        }
        if (angular.isFunction(ctrl.heureModel.getMonth)) {
          ctrl.heure = ctrl.heureModel;
        } else if (angular.isString(ctrl.heureModel)) {
          if (ctrl.heureModel.includes('/') && ctrl.heureModel.includes('h')) {
            ctrl.heure = moment(ctrl.heureModel, CONSTANTS.date_format).toDate();
          } else if (ctrl.heureModel.includes('h')) {
            ctrl.heure = moment(ctrl.heureModel, 'HH[h]mm').toDate();
          } else {
            ctrl.heure = new Date();
          }
        } else {
          ctrl.heure = new Date();
        }
      }

      if (angular.isDefined(ctrl.modelFin)) {
        if (ctrl.modelFin === null) {
          ctrl.modelFin = '';
        }
        if (angular.isFunction(ctrl.modelFin.getMonth)) {
          ctrl.heureFin = ctrl.modelFin;
        } else if (angular.isString(ctrl.modelFin)) {
          if (ctrl.modelFin.includes('/') && ctrl.modelFin.includes('h')) {
            ctrl.heureFin = moment(ctrl.modelFin, CONSTANTS.date_format).toDate();
          } else if (ctrl.modelFin.includes('/')) {
            ctrl.heureFin = moment(ctrl.modelFin, 'DD/MM/YYYY').toDate();
          } else if (ctrl.modelFin.includes('h')) {
            ctrl.heureFin = moment(ctrl.modelFin, 'HH[h]mm').toDate();
          } else {
            ctrl.heureFin = moment(new Date()).add(1, 'hours').toDate();
          }
        } else {
          ctrl.heureFin = moment(new Date()).add(1, 'hours').toDate();
        }
      }

      if (angular.isDefined(ctrl.heureFinModel)) {
        if (ctrl.heureFinModel === null) {
          ctrl.heureFinModel = '';
        }
        if (angular.isFunction(ctrl.heureFinModel.getMonth)) {
          ctrl.heureFin = ctrl.heureFinModel;
        } else if (angular.isString(ctrl.heureFinModel)) {
          if (ctrl.heureFinModel.includes('/') && ctrl.heureFinModel.includes('h')) {
            ctrl.heureFin = moment(ctrl.heureFinModel, CONSTANTS.date_format).toDate();
          } else if (ctrl.heureFinModel.includes('h')) {
            ctrl.heureFin = moment(ctrl.heureFinModel, 'HH[h]mm').toDate();
          } else {
            ctrl.heureFin = new moment(new Date()).add(1, 'hours').toDate();
          }
        } else {
          ctrl.heureFin = new moment(new Date()).add(1, 'hours').toDate();
        }
      }

      onChange();
      getSocietes();
    };

    function fullDateFormat(date, heure) {
      return dateFormat(date) + ' ' + (heure ? heureFormat(heure) : heureFormat(date));
    }

    function dateFormat(date) {
      var current;
      if (angular.isDefined(date)) current = new Date(date);
      else current = new Date();

      var year = current.getFullYear(),
        month = (current.getMonth() + 1) < 10 ? '0' + (current.getMonth() + 1) : (current.getMonth() + 1),
        day = current.getDate() < 10 ? '0' + current.getDate() : current.getDate();

      return day + '/' + month + '/' + year;
    }

    function heureFormat(heure) {
      var current;
      if (angular.isDefined(heure)) current = new Date(heure);
      else current = new Date();

      var hours = current.getHours() < 10 ? '0' + current.getHours() : current.getHours(),
        minutes = current.getMinutes() < 10 ? '0' + current.getMinutes() : current.getMinutes();

      return hours + 'h' + minutes;
    }

    function onChange(heureFinPicked) {
      if (heureFinPicked) {
        ctrl.heureFinAuto = false;
      }
      if (angular.isDefined(ctrl.model)) ctrl.model = fullDateFormat(ctrl.date, ctrl.heure);
      if (angular.isDefined(ctrl.dateModel)) ctrl.dateModel = dateFormat(ctrl.date);
      if (angular.isDefined(ctrl.heureModel)) ctrl.heureModel = heureFormat(ctrl.heure);

      if (ctrl.heureFinAuto) {
        ctrl.heureFin = moment(ctrl.heure).add(1, 'hours').toDate();
      }

      if (angular.isDefined(ctrl.modelFin)) ctrl.modelFin = fullDateFormat(ctrl.date, ctrl.heureFin);
      if (angular.isDefined(ctrl.heureFinModel)) ctrl.heureFinModel = heureFormat(ctrl.heureFin);
    }

    function choseDate() {
      if (angular.isDefined(ctrl.onChose) && angular.isFunction(ctrl.onChose)) {
        var retour = {};
        if (ctrl.timepicker) {
          retour.date = fullDateFormat(ctrl.date, ctrl.heure);
          if (ctrl.timerange) {
            retour.dateFin = angular.isDefined(ctrl.modelFin) ? fullDateFormat(ctrl.date, ctrl.heureFin) : heureFormat(ctrl.heureFin);
          }
        } else {
          retour.date = dateFormat(ctrl.date);
        }
        ctrl.onChose(retour);
      }
      onChange();
      ctrl.onClose();
    }

    function nouveauRdv() {
      if (angular.isDefined(ctrl.onNouveau) && angular.isFunction(ctrl.onNouveau)) {
        var retour = {};
        if (ctrl.timepicker) {
          retour.date = fullDateFormat(ctrl.date, ctrl.heure);
          if (ctrl.timerange) {
            retour.dateFin = angular.isDefined(ctrl.modelFin) ? fullDateFormat(ctrl.date, ctrl.heureFin) : heureFormat(ctrl.heureFin);
          }
        } else {
          retour.date = dateFormat(ctrl.date);
        }
        ctrl.onNouveau(retour);
      }
      onChange();
      ctrl.onClose();
    }

    function removeDate() {
      if (ctrl.supprimable) {
        var currentDate = new Date();
        ctrl.date = currentDate;
        ctrl.heure = currentDate;

        if (angular.isDefined(ctrl.model)) ctrl.model = null;
        if (angular.isDefined(ctrl.dateModel)) ctrl.dateModel = null;
        if (angular.isDefined(ctrl.heureModel)) ctrl.heureModel = null;
        if (angular.isDefined(ctrl.modelFin)) ctrl.modelFin = null;
        if (angular.isDefined(ctrl.heureFinModel)) ctrl.heureFinModel = null;
      }
    }

    function closeDate() {
      if (angular.isDefined(ctrl.model)) ctrl.model = ctrl.baseModels.model;
      if (angular.isDefined(ctrl.dateModel)) ctrl.dateModel = ctrl.baseModels.date;
      if (angular.isDefined(ctrl.heureModel)) ctrl.heureModel = ctrl.baseModels.heure;
      if (angular.isDefined(ctrl.modelFin)) ctrl.modelFin = ctrl.baseModels.modelFin;
      if (angular.isDefined(ctrl.heureFinModel)) ctrl.heureFinModel = ctrl.baseModels.heureFin;

      $timeout(function () {
        ctrl.onClose();
      });
    }

    function annulerRDV() {
      ctrl.onAnnuler();

      $timeout(function () {
        ctrl.onClose();
      });
    }

    function toggleFullScreen() {
      ctrl.fullScreen.isFullScreen = !ctrl.fullScreen.isFullScreen;
      ctrl.onFullScreen({ fullScreen: ctrl.fullScreen.isFullScreen });
    }

    function getSocietes() {
      RepertoireService
        .getSocietesList({
          typeMethode: 'basic',
          typeApplication: globalService.getTypeApplication()
        })
        .then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
            ctrl.societes.currentList = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
        );
    }

    function societeGroupChoices(item) {
      return item.hasOwnProperty('pool') ? item.pool.nom : undefined;
    }

    function searchInSocietes(input) {
      if (ctrl.societes.list.length > 0) {
        ctrl.societes.currentList = ctrl.societes.list.filter(function (societe) {
          return societe.nom.indexOf(input) !== -1 || societe.nom.toLowerCase().indexOf(input) !== -1;
        });
      } else ctrl.societes.currentList = ctrl.societes.list;
    }

    function societeChanged() {
      if (angular.isArray(ctrl.societes.societes) && ctrl.societes.societes.length) {
        ctrl.societes.societesId = '';
        angular.forEach(ctrl.societes.societes, function (societe, index) {
          ctrl.societes.societesId += societe.id;
          if (index < (ctrl.societes.societes.length - 1)) ctrl.societes.societesId += ',';
        });
      } else ctrl.societes.societesId = null;
      ctrl.onSelectSocietes({ societes: ctrl.societes.societesId });

      if (ctrl.negos.active) {
        searchInNegos();
      }
    }

    function searchInNegos(input) {
      RepertoireService
        .getNegoList({
          recherche: input || null,
          societe: ctrl.societes.societesId,
          numero: 0,
          pas: 15,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
        );
    }

    function negoChanged() {
      ctrl.onSelectNego({ nego: ctrl.negos.nego.id });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('blocPerso', {
    templateUrl: 'app/components/utils/bloc-perso/bloc-perso.html',
    controllerAs: 'blocpersoctrl',
    controller: BlocPersoController,
    bindings: {
      perso: '=',
      titreBloc: '<',
      templateRight: '<',
      isEditable: '<',
      typePerso: '<',
      isProspect: '<',
      onSelectProspect: '&',
      onSupprimer: '&',
      typeOnly:'<'
    }
  });

  /** @ngInject */
  function BlocPersoController(RepertoireService, Perso, $attrs,$log) {
    var ctrl = this;

    ctrl.editing = false;

    ctrl.supprimer = {
      isSupprimable: $attrs.onSupprimer && angular.isFunction(ctrl.onSupprimer),
      tooltip: $attrs.onSupprimer && angular.isFunction(ctrl.onSupprimer) ? 'Supprimer' : 'Vider',
      icon: $attrs.onSupprimer && angular.isFunction(ctrl.onSupprimer) ? 'fa-trash' : 'fa-eraser',
      onClick: supprimer
    };
    $log.info('Type',ctrl.typeOnly);
    ctrl.changePerso = changePerso;

    function changePerso() {
      var type = ctrl.typePerso ? ctrl.typePerso : null,
        isProspect = $attrs.isProspect && angular.isDefined(ctrl.isProspect) ? ctrl.isProspect : null;
      RepertoireService.openRepertoire({
        type: type,
        isProspect: isProspect
      }).then(function(retour) {
        if (retour.status === 'OK') {
          if (isProspect && $attrs.onSelectProspect && angular.isFunction(ctrl.onSelectProspect)) {
            ctrl.onSelectProspect({ prospect: retour.prospect });
          } else {
            ctrl.perso = retour.perso;
          }
        }
      });
    }

    function supprimer() {
      if (ctrl.supprimer.isSupprimable) {
        ctrl.onSupprimer();
      } else {
        ctrl.perso = new Perso();
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('adresse', {
    templateUrl: 'app/components/utils/adresse/adresse.html',
    controllerAs: 'adressectrl',
    bindings: {
      adresse: '=',
      checkIfRequired: '<',
      validation: '=',
      paramsGestion: '<',
      visited: '<',
      template: '<',
      onCopy: '&'
    },
    controller: AdresseController
  });

  /** @ngInject */
  function AdresseController(globalService, Adresse, LocalisationService, $timeout, $attrs, $log) {
    var ctrl = this;

    ctrl.required = false;
    ctrl.disabled = true;

    ctrl.villes = {
      loading: false,
      selected: null,
      list: [],
      getVilles: getVilles,
      setVilles: setVilles
    };

    ctrl.copy = {
      active: false,
      copyFrom: copyFrom
    };

    ctrl.$onInit = initialisation;

    function initialisation() {
      if (angular.isDefined(ctrl.adresse)) {
        ctrl.adresse = ctrl.adresse.isModel ? ctrl.adresse : new Adresse(ctrl.adresse);
        if (ctrl.adresse.hasCp() || ctrl.adresse.hasVille()) {
          ctrl.villes.selected = {
            codePostal: ctrl.adresse.hasCp() ? ctrl.adresse.cp : null,
            nom: ctrl.adresse.hasVille() ? ctrl.adresse.ville : null
          };
        }

        ctrl.copy.active = angular.isDefined($attrs.onCopy) && angular.isFunction(ctrl.onCopy);
      } else {
        $timeout(function() {
          initialisation();
        }, 200);
      }

      ctrl.paramsGestion = angular.isDefined(ctrl.paramsGestion) ? ctrl.paramsGestion : false;
      ctrl.required =
        angular.isDefined(ctrl.checkIfRequired) &&
        ctrl.checkIfRequired &&
        (!ctrl.paramsGestion || (ctrl.paramsGestion && !ctrl.paramsGestion.adresse));
      ctrl.disabled = ctrl.paramsGestion && ctrl.paramsGestion.adresse;
    }

    function getVilles(input, origin) {
      if (input && input.length) {
        ctrl.villes.loading = true;
        ctrl.villes.list = [];

        LocalisationService.getVillesByQuery({
          recherche: input,
          typeMethode: 'complete',
          typeApplication: globalService.getTypeApplication()
        })
          .then(function(json) {
            if (json.status === 'OK') {
              ctrl.villes.list = json.list;
              if (!input && ctrl.villes.selected && !ctrl.villes.selected.nom && !ctrl.villes.selected.codePostal) {
                ctrl.villes.selected = null;
              }
            }
            ctrl.villes.loading = false;
          })
          .catch(function(error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                var cp = '',
                  ville = '';

                if (origin === 'cp') {
                  cp = input;
                  if (ctrl.adresse.hasVille()) {
                    ville = ctrl.adresse.ville;
                  } else if (ctrl.villes.selected && ctrl.villes.selected.nom) {
                    ville = ctrl.villes.selected.nom;
                  }
                }
                if (origin === 'ville') {
                  ville = input;
                  if (ctrl.adresse.hasCp()) {
                    cp = ctrl.adresse.cp;
                  } else if (ctrl.villes.selected && ctrl.villes.selected.codePostal) {
                    cp = ctrl.villes.selected.codePostal;
                  }
                }

                ctrl.villes.selected = {
                  codePostal: cp ? cp : null,
                  nom: ville ? ville : null
                };

                ctrl.villes.list.push(ctrl.villes.selected);

                setVilles();
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.villes.loading = false;
          });
      }
    }

    function setVilles() {
      if (ctrl.villes.selected) {
        ctrl.adresse.cp = ctrl.villes.selected.codePostal;
        ctrl.adresse.ville = ctrl.villes.selected.nom;
      } else {
        ctrl.adresse.cp = '';
        ctrl.adresse.ville = '';
      }
    }

    function copyFrom() {
      if (ctrl.copy.active) {
        ctrl.onCopy();

        $timeout(function() {
          ctrl.adresse = ctrl.adresse.isModel ? ctrl.adresse : new Adresse(ctrl.adresse);
          if (ctrl.adresse.hasCp() || ctrl.adresse.hasVille()) {
            ctrl.villes.selected = {
              codePostal: ctrl.adresse.hasCp() ? ctrl.adresse.cp : null,
              nom: ctrl.adresse.hasVille() ? ctrl.adresse.ville : null
            };
          }
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('tgnCalendar', {
    templateUrl: 'app/components/main-content/tgn-calendar/tgn-calendar.html',
    controllerAs: 'tgncalendarctrl',
    controller: TgnCalendarController,
    bindings: {
      readOnly: '<'
    }
  });

  /** @ngInject */
  function TgnCalendarController(
    CONSTANTS,
    globalService,
    EvenementsService,
    ImpressionService,
    Evenement,
    $window,
    $ocLazyLoad,
    RepertoireService,
    moment,
    calendarEventTitle,
    ngDialog,
    $uibModal,
    $rootScope,
    $scope,
    $attrs,
    $log
  ) {
    var ctrl = this;

    ctrl.nego = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.isReadOnly = angular.isDefined($attrs.readOnly) && ctrl.readOnly !== false;

    ctrl.calendar = {
      title: '',
      view: ctrl.citya ? 'month' : 'day',
      viewDate: new Date(),
      dayEventWidth: 325,
      cellIsOpen: false,
      actions: ctrl.isReadOnly ? [] : [{
          type: 'edit',
          label: '<span class="tgn-event-action-edit"><i class="fa fa-fw fa-pencil"></i></span>',
          onClick: function (args) {
            eventClicked(args.calendarEvent);
          }
        },
        {
          type: 'delete',
          label: '<span class="tgn-event-action-remove"><i class="fa fa-fw fa-trash-o"></i></span>',
          onClick: function (args) {
            removeEvent(args.calendarEvent);
          }
        }
      ],
      eventClicked: eventClicked,
      timespanClicked: timespanClicked
    };

    ctrl.societes = {
      list: [],
      currentList: [],
      societes: [],
      societesId: null,
      groupChoices: societeGroupChoices,
      search: searchInSocietes,
      changed: societeChanged
    };

    ctrl.negos = {
      list: [],
      nego: null,
      search: searchInNegos,
      changed: negoChanged
    };

    ctrl.addEvent = addEvent;
    ctrl.imprimer = imprimer;

    ctrl.originalCalendarEventTitle = calendarEventTitle;

    ctrl.calendarViewDateListener = $scope.$watch(
      function () {
        return ctrl.calendar.viewDate;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          getEvents();
        }
      },
      true
    );

    ctrl.calendarViewListener = $scope.$watch(
      function () {
        return ctrl.calendar.view;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          getEvents();
        }
      },
      true
    );

    ctrl.windowWidthListener = $scope.$watch(
      function () {
        return $window.innerWidth;
      },
      function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if ($window.innerWidth < 480) {
            ctrl.calendar.dayEventWidth = 230;
          } else if ($window.innerWidth < 768) {
            ctrl.calendar.dayEventWidth = 285;
          } else if ($window.innerWidth < 1200) {
            ctrl.calendar.dayEventWidth = 325;
          } else {
            ctrl.calendar.dayEventWidth = 365;
          }
        }
      },
      true
    );

    ctrl.$onInit = function () {
      $window.moment = $window.moment || moment;
      $ocLazyLoad.load('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.10.6/locale/fr.js').then(function () {
        moment.locale('fr', {
          week: {
            dow: 1
          }
        });
        moment.locale('fr');
      });

      if ($window.innerWidth < 768) {
        ctrl.calendar.dayEventWidth = 285;
      } else if ($window.innerWidth < 1200) {
        ctrl.calendar.dayEventWidth = 325;
      } else {
        ctrl.calendar.dayEventWidth = 365;
      }

      if (!ctrl.citya) {
        if (!angular.isArray(ctrl.societes.societes) || !ctrl.societes.societes.length) {
          ctrl.societes.societes = [ctrl.nego.societe];
          ctrl.societes.societesId = '' + ctrl.nego.societe.id;
        }
        if (!ctrl.negos.nego) {
          ctrl.negos.nego = ctrl.nego;
        }
      }

      calendarEventTitle.monthView = calendarEventTitle.monthViewTooltip = calendarEventTitle.weekViewTooltip = calendarEventTitle.dayViewTooltip = function (
        event
      ) {
        return moment(event.startsAt).format('HH[h]mm') + ' - ' + getDateFinToString(event) + ' : ' + event.title;
      };
      calendarEventTitle.weekView = calendarEventTitle.dayView = function (event) {
        return ' - ' + getDateFinToString(event) + ' : ' + event.title;
      };

      getEvents();
      getSocietes();
    };

    ctrl.$onDestroy = function () {
      ctrl.calendarViewDateListener();
      ctrl.calendarViewListener();
      calendarEventTitle = ctrl.originalCalendarEventTitle;
    };

    function getSocietes() {
      RepertoireService.getSocietesList({
        typeMethode: 'basic',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.societes.list = retour.list;
            ctrl.societes.currentList = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des sociétés a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function societeGroupChoices(item) {
      return item.hasOwnProperty('pool') ? item.pool.nom : undefined;
    }

    function searchInSocietes(input) {
      if (ctrl.societes.list.length > 0) {
        ctrl.societes.currentList = ctrl.societes.list.filter(function (societe) {
          return societe.nom.indexOf(input) !== -1 || societe.nom.toLowerCase().indexOf(input) !== -1;
        });
      } else ctrl.societes.currentList = ctrl.societes.list;
    }

    function societeChanged() {
      if (angular.isArray(ctrl.societes.societes) && ctrl.societes.societes.length) {
        ctrl.societes.societesId = '';
        angular.forEach(ctrl.societes.societes, function (societe, index) {
          ctrl.societes.societesId += societe.id;
          if (index < ctrl.societes.societes.length - 1) ctrl.societes.societesId += ',';
        });
      } else ctrl.societes.societesId = null;
      getEvents();
      ctrl.negos.search();
    }

    function searchInNegos(input) {
      RepertoireService.getNegoList({
        recherche: input || null,
        societe: ctrl.societes.societesId ? ctrl.societes.societesId : ctrl.nego.societe.id,
        numero: 0,
        pas: 15,
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoChanged() {
      getEvents();
    }

    function getEvents() {
      EvenementsService.getList({
        socIds: ctrl.societes.societesId ? ctrl.societes.societesId : ctrl.nego.societe.id,
        nego: ctrl.negos.nego && ctrl.negos.nego.id ? ctrl.negos.nego.id : null,
        debut: moment(ctrl.calendar.viewDate)
          .startOf(ctrl.calendar.view)
          .format(CONSTANTS.date_format),
        fin: moment(ctrl.calendar.viewDate)
          .endOf(ctrl.calendar.view)
          .format(CONSTANTS.date_format),
        forAgenda: true,
        active: true,
        typeMethode: 'complete'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.events = retour.list;
            setEvents();
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') {
              $log.warn(error.message);
              ctrl.events = [];
            } else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function getDateFinToString(event) {
      if (event && event.startsAt && event.endsAt) {
        if (moment(event.startsAt).diff(moment(event.endsAt), 'days') !== 0) {
          return moment(event.endsAt).format('DD/MM HH[h]mm');
        } else {
          return moment(event.endsAt).format('HH[h]mm');
        }
      } else {
        return '';
      }
    }

    function setEvents() {
      angular.forEach(ctrl.events, function (event) {
        event.color =
          event.color && event.color.primary && event.color.secondary ?
          event.color : {
            primary: event.type && event.type.couleur ? event.type.couleur.replace('0x', '#') : '#555555',
            secondary: event.type && event.type.couleur ?
              shadeBlend(-0.2, event.type.couleur.replace('0x', '#')) : shadeBlend(-0.2, '#555555')
          };
        event.startsAt = moment(event.date, CONSTANTS.date_format).toDate();
        event.endsAt = event.dateFin ?
          moment(event.dateFin, CONSTANTS.date_format).toDate() :
          moment(event.date, CONSTANTS.date_format)
          .add(1, 'h')
          .toDate();
        event.actions = ctrl.calendar.actions;

        event.title = event.commentaire;

        if (event.type && event.type.label === 'visite' && event.active === false) {
          event.title = '(ANNULÉ) ' + (event.commentaire ? event.commentaire : 'Visite');
          if (!ctrl.isReadOnly) {
            event.actions = event.actions.filter(function (action) {
              return action.type !== 'annuler';
            });
          }
        } else if (event.type && event.type.label === 'visite' && !ctrl.isReadOnly) {
          event.title = event.commentaire ? event.commentaire : 'Visite';
          event.actions = event.actions.filter(function (action) {
            return action.type !== 'delete';
          });
          if (!event.actions.filter(function (action) {
              return action.type === 'annuler';
            }).length) {
            event.actions.push({
              type: 'annuler',
              label: '<span class="tgn-event-action-annuler"><i class="fa fa-fw fa-ban"></i></span>',
              onClick: function () {
                var confirmDialog = ngDialog.openConfirm({
                  templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
                  controller: 'ConfirmDialogController',
                  controllerAs: 'confirmdialogctrl',
                  resolve: {
                    titre: function titreFactory() {
                      return "Confirmation d'annulation";
                    },
                    message: function messageFactory() {
                      return '<span>Souhaitez-vous annuler cet évènement ?</span>';
                    },
                    commentaire: function commentaireFactory() {
                      return false;
                    },
                    confirmText: function confirmTextFactory() {
                      return false;
                    },
                    annulerText: function annulerTextFactory() {
                      return false;
                    }
                  }
                });

                confirmDialog.then(function (data) {
                  if (data.status === 'OK') {
                    event.active = false;
                    saveEvent(event);
                  }
                });
              }
            });
          }
        }
        if (event.negociateur.perso.nomComplet) {
          event.title += ' - ' + event.negociateur.perso.nomComplet;
        }
        if (event.lot && !ctrl.isReadOnly) {
          if (!event.actions.filter(function (action) {
              return action.type === 'lot';
            }).length) {
            event.actions.unshift({
              type: 'lot',
              label: '<span class="tgn-event-action-lot"><i class="fa fa-fw fa-home"></i></span>',
              onClick: function (args) {
                $rootScope.$emit('showFiche', {
                  type: 'ficheBien',
                  ref: args.calendarEvent.lot.referenceInterne
                });
              }
            });
          }
        }
        if (event.prospect && !ctrl.isReadOnly) {
          if (!event.actions.filter(function (action) {
              return action.type === 'prospect';
            }).length) {
            event.actions.unshift({
              type: 'prospect',
              label: '<span class="tgn-event-action-prospect"><i class="fa fa-fw fa-user"></i></span>',
              onClick: function (args) {
                $rootScope.$emit('showFiche', {
                  type: 'ficheProspect',
                  ref: args.calendarEvent.prospect.referenceInterne
                });
              }
            });
          }
        }
      });
    }

    function saveEvent(e) {
      var event = new Evenement(e);
      EvenementsService.ajouter({
        xml: event.toJson(true),
        nego: ctrl.nego.id,
        debut: moment(ctrl.calendar.viewDate)
          .startOf(ctrl.calendar.view)
          .format(CONSTANTS.date_format),
        fin: moment(ctrl.calendar.viewDate)
          .endOf(ctrl.calendar.view)
          .format(CONSTANTS.date_format),
        forAgenda: true,
        active: true,
        typeMethode: 'complete'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.events = retour.list;
            setEvents();
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function removeEvent(event) {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer cet évènement ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return false;
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          EvenementsService.supprimer({
            supprId: event.id,
            nego: ctrl.nego.id,
            debut: moment(ctrl.calendar.viewDate)
              .startOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            fin: moment(ctrl.calendar.viewDate)
              .endOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            forAgenda: true,
            active: true,
            typeMethode: 'complete'
          }).then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.events = retour.list;
                setEvents();
              }
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
            }
          );
        }
      });
    }

    function addEvent() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/form-event/modal.form-event.html',
        controller: 'ModalFormEventController',
        controllerAs: 'modalformeventctrl',
        resolve: {
          event: function () {
            return {
              date: '',
              commentaire: '',
              type: null,
              negociateur: {
                id: ctrl.nego.id
              },
              accompli: false,
              active: true,
              alertMail: false,
              compteRendu: '',
              suivi: false
            };
          },
          negoExt: function () {
            return true;
          }
        }
      });

      modalInstance.result.then(function (retour) {
        if (retour.status === 'OK') {
          saveEvent(retour.event);
        }
      });
    }

    function eventClicked(event) {
      if (!ctrl.isReadOnly) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/form-event/modal.form-event.html',
          controller: 'ModalFormEventController',
          controllerAs: 'modalformeventctrl',
          resolve: {
            event: function () {
              return event;
            },
            negoExt: function () {
              return true;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          switch (retour.status) {
            case 'OK':
              saveEvent(retour.event);
              break;
            case 'CANCEL':
              retour.event.active = false;
              saveEvent(retour.event);
              break;
            case 'DELETE':
              removeEvent(retour.event);
              break;
            case 'EXIT':
              break;
            default:
              $log.error(retour);
              break;
          }
        });
      }
    }

    function timespanClicked(date, cell) {
      if (ctrl.calendar.view === 'month') {
        if (
          (ctrl.calendar.cellIsOpen &&
            moment(date)
            .startOf('day')
            .isSame(moment(ctrl.calendar.viewDate).startOf('day'))) ||
          cell.events.length === 0 ||
          !cell.inMonth
        ) {
          ctrl.calendar.cellIsOpen = false;
        } else {
          ctrl.calendar.cellIsOpen = true;
          ctrl.calendar.viewDate = date;
        }
      } else if (ctrl.calendar.view === 'year') {
        if (
          (ctrl.calendar.cellIsOpen &&
            moment(date)
            .startOf('month')
            .isSame(moment(ctrl.calendar.viewDate).startOf('month'))) ||
          cell.events.length === 0
        ) {
          ctrl.calendar.cellIsOpen = false;
        } else {
          ctrl.calendar.cellIsOpen = true;
          ctrl.calendar.viewDate = date;
        }
      }
    }

    function shadeBlend(p, c0, c1) {
      var n = p < 0 ? p * -1 : p,
        u = Math.round,
        w = parseInt,
        f,
        t;
      if (c0.length > 7) {
        f = c0.split(',');
        t = (c1 ? c1 : p < 0 ? 'rgb(0,0,0)' : 'rgb(255,255,255)').split(',');
        var R = w(f[0].slice(4)),
          G = w(f[1]),
          B = w(f[2]);
        return (
          'rgb(' +
          (u((w(t[0].slice(4)) - R) * n) + R) +
          ',' +
          (u((w(t[1]) - G) * n) + G) +
          ',' +
          (u((w(t[2]) - B) * n) + B) +
          ')'
        );
      } else {
        f = w(c0.slice(1), 16);
        t = w((c1 ? c1 : p < 0 ? '#000000' : '#FFFFFF').slice(1), 16);
        var R1 = f >> 16,
          G1 = (f >> 8) & 0x00ff,
          B1 = f & 0x0000ff;
        return (
          '#' +
          (
            0x1000000 +
            (u(((t >> 16) - R1) * n) + R1) * 0x10000 +
            (u((((t >> 8) & 0x00ff) - G1) * n) + G1) * 0x100 +
            (u(((t & 0x0000ff) - B1) * n) + B1)
          )
          .toString(16)
          .slice(1)
        );
      }
    }

    function imprimer() {
      ImpressionService.downloadFile({
          toPdf: true,
          agenda: true,
          dateDebut: moment(ctrl.calendar.viewDate)
            .startOf(ctrl.calendar.view)
            .format(CONSTANTS.date_format),
          dateFin: moment(ctrl.calendar.viewDate)
            .endOf(ctrl.calendar.view)
            .format(CONSTANTS.date_format),
          socId: ctrl.societes.societesId ? ctrl.societes.societesId : ctrl.nego.societe.id,
          negoId: ctrl.negos.nego && ctrl.negos.nego.id ? ctrl.negos.nego.id : ctrl.nego.id,
          typeApplication: globalService.getTypeApplication()
        },
        'PDF'
      ).then(function (retour) {
        if (retour.status === 'OK') {
          $window.open(retour.link, '_blank');
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('statistique', {
    templateUrl: 'app/components/main-content/statistique/statistique.html',
    controllerAs: 'statistiquectrl',
    bindings: {
    },
    controller: StatistiqueController
  });

  /** @ngInject */
  function StatistiqueController($log,globalService) {
    var ctrl = this;
    ctrl.transac = (globalService.getTypeApplication()=='Transaction'?true:false);
    
    function initialisation() {
      $log.info("init");
    }

    ctrl.$onInit = initialisation;

  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('repertoire', {
    templateUrl: 'app/components/main-content/repertoire/repertoire.html',
    controllerAs: 'repertoirectrl',
    controller: RepertoireController
  });

  /** @ngInject */
  function RepertoireController(
    CONSTANTS,
    globalService,
    RepertoireService,
    ImpressionService,
    $rootScope,
    $timeout,
    moment,
    $uibModal,
    $window,
    $log
  ) {
    var ctrl = this;

    ctrl.nego = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.loading = false;

    ctrl.query = {
      type: null,
      rechercheContact: null,
      rechercheNom: null,
      numero: 0,
      pas: 40,
      typeApplication: globalService.getTypeApplication()
    };

    ctrl.searchPattern = '.{3,}';
    ctrl.nomRequired = false;
    ctrl.contactRequired = false;

    ctrl.typesPerso = {
      list: CONSTANTS.typesPerso[globalService.getTypeApplication()],
      selected: null
    };

    ctrl.repertoire = {
      nb: 0,
      list: [],
      noResult: false,
      selected: null
    };

    ctrl.setRequired = setRequired;
    ctrl.getList = getList;
    ctrl.togglePerso = togglePerso;
    ctrl.imprimer = imprimer;
    ctrl.showFiche = showFiche;
    ctrl.showProspect = showProspect;
    ctrl.envoyerEmail = envoyerEmail;

    ctrl.$onInit = function () {
      setRequired();
    };

    function setRequired() {
      ctrl.nomRequired = !ctrl.query.rechercheContact || (ctrl.query.rechercheNom && !ctrl.query.rechercheNom.match(ctrl.searchPattern));
      ctrl.contactRequired = !ctrl.query.rechercheNom || (ctrl.query.rechercheContact && !ctrl.query.rechercheContact.match(ctrl.searchPattern));
    }

    function getList(scroll) {
      if (!scroll) {
        ctrl.query.numero = 0;
        ctrl.repertoire.nb = 0;
        ctrl.repertoire.list = [];
      }
      if (ctrl.query.numero > 0 && (ctrl.query.numero >= ctrl.repertoire.nb || ctrl.loading)) return;
      ctrl.loading = true;

      $timeout.cancel(ctrl.queryWorking);
      ctrl.queryWorking = $timeout(function () {
        RepertoireService.getPersoList(ctrl.query).then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.repertoire.noResult = false;
                if (scroll) {
                  angular.forEach(retour.list, function (perso) {
                    perso.actions = {
                      lot: (perso.typeRepertoire === 'propriolist' || perso.typeRepertoire === 'bailleur') && perso.ref,
                      prospect: perso.typeRepertoire === 'prospectlist' && perso.ref
                    };
                    ctrl.repertoire.list.push(perso);
                  });
                  ctrl.query.numero += ctrl.query.pas;
                } else {
                  ctrl.repertoire.nb = retour.nb;
                  ctrl.repertoire.list = retour.list.map(function (perso) {
                    perso.actions = {
                      lot: (perso.typeRepertoire === 'propriolist' || perso.typeRepertoire === 'bailleur') && perso.ref,
                      prospect: perso.typeRepertoire === 'prospectlist' && perso.ref
                    };
                    return perso;
                  });
                  ctrl.query.numero = ctrl.query.pas;
                }
              }
            }
          )
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.repertoire.nb = 0;
                ctrl.repertoire.noResult = true;
                ctrl.repertoire.list = [];
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          })
          .finally(function () {
            ctrl.loading = false;
          });
      });
    }

    function togglePerso(perso) {
      if (ctrl.repertoire.selected === perso) {
        ctrl.repertoire.selected.selected = false;
        ctrl.repertoire.selected = null;
      } else {
        if (ctrl.repertoire.selected && ctrl.repertoire.selected.isModel) {
          ctrl.repertoire.selected.selected = false;
        }
        ctrl.repertoire.selected = perso;
        ctrl.repertoire.selected.selected = true;
      }
    }

    function imprimer() {
      ImpressionService.downloadFile({
          toPdf: true,
          agenda: true,
          dateDebut: moment(ctrl.calendar.viewDate)
            .startOf(ctrl.calendar.view)
            .format(CONSTANTS.date_format),
          dateFin: moment(ctrl.calendar.viewDate)
            .endOf(ctrl.calendar.view)
            .format(CONSTANTS.date_format),
          socId: ctrl.societes.societesId ? ctrl.societes.societesId : ctrl.nego.societe.id,
          negoId: ctrl.negos.nego && ctrl.negos.nego.id ? ctrl.negos.nego.id : ctrl.nego.id,
          typeApplication: globalService.getTypeApplication()
        },
        'PDF'
      ).then(function (retour) {
        if (retour.status === 'OK') {
          $window.open(retour.link, '_blank');
        }
      });
    }

    function showFiche(ref) {
      $rootScope.$emit('showFiche', {
        type: 'ficheBien',
        ref: ref
      });
    }

    function showProspect(ref) {
      $rootScope.$emit('showFiche', {
        type: 'ficheProspect',
        ref: ref
      });
    }

    function envoyerEmail(perso) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/formcontact/modal.formcontact.html',
        controller: 'ModalFormContactController',
        controllerAs: 'modalformcontactctrl',
        resolve: {
          message: function () {
            var message = {};
            if (angular.isDefined(perso)) {
              message.destinataire = perso.getEmail();
            }
            return message;
          }
        }
      });

      modalInstance.result.then(function (retour) {
        if (retour.status === 'OK') {
          $log.info("L'e-mail a bien été envoyé.");
        } else {
          $log.info("L'e-mail n'a pas été envoyé !.. <== panier.component.js l.521");
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('reservations', {
    templateUrl: 'app/components/main-content/reservations/reservations.html',
    controllerAs: 'reservationsctrl',
    controller: ReservationsController
  });

  /** @ngInject */
  function ReservationsController(
    CONSTANTS,
    globalService,
    CustomUtils,
    ContratsService,
    ImpressionService,
    $scope,
    $stateParams,
    $timeout,
    $window,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.initialisation = true;
    ctrl.loading = false;

    ctrl.employe = globalService.getEmploye();

    ctrl.defaultQuery = {
      search: {
        recherche: null,
        societe: ctrl.employe.societe.id || null,
        nego: null,
        archive: false,
        isValide: true,
        type: $stateParams.type || null,
        encaissement: $stateParams.type === 'location' && CONSTANTS.configClient.citya ? false : null,
        datedeb: null,
        datefin: null,
        ordre: 'triDate',
        tri: 'desc'
      },
      numero: 0,
      pas: 16,
      typeMethode: 'short'
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.reservations = {
      list: [],
      nb: 0,
      refList: [],
      getList: getReservationsList
    };

    ctrl.sbConfig = {
      query: ctrl.query.search,
      defaultQuery: ctrl.defaultQuery.search,
      additionalControls: {
        tris: {
          list: CONSTANTS.dictionnaire.FR.reservations.tri,
          nomChamp: {
            tri: 'tri',
            ordre: 'ordre'
          },
          default: {
            tri: 'desc',
            ordre: 'triDate'
          }
        },
        imprimer: imprimer
      },
      filtres: {
        societes: {
          nomChamp: 'societe'
        },
        nego: {
          nomChamp: 'nego'
        },
        typeContrat: {
          nomChamp: 'type'
        },
        visibilite: {
          archive: true,
          mandat: false,
          nomChamp: {
            archive: 'archive'
          }
        },
        dateSignature: {
          datedeb: true,
          datefin: true,
          nomChamp: {
            datedeb: 'datedeb',
            datefin: 'datefin'
          }
        }
      }
    };

    ctrl.showFicheReservation = showFicheReservation;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if ($stateParams.type) {
        ctrl.query.search.type = $stateParams.type;

        if ($stateParams.type === 'location') {
          ctrl.sbConfig.filtres.encaissement = {
            nomChamp: 'encaissement'
          };
        } else {
          ctrl.sbConfig.filtres.valider = {
            nomChamp: 'validation'
          };
        }

        getReservationsList(false, false);
        ctrl.initialisation = false;
      } else {
        $timeout(initialisation, 200);
      }
    }

    function getReservationsList(query, scroll) {
      if (!scroll) {
        ctrl.query.numero = 0;
        ctrl.reservations.list = [];
        ctrl.reservations.nb = 0;
      }
      if (ctrl.query.numero > 0 && (ctrl.query.numero >= ctrl.reservations.nb || ctrl.loading)) return;
      ctrl.loading = true;
      ctrl.query.search =
        angular.isDefined(query) && !CustomUtils.collection.isEmpty(query) ? query : ctrl.query.search;

      /*if (angular.isUndefined(ctrl.query.search.archive) || ctrl.query.search.archive === null)
        ctrl.query.search.archive = false;*/
      if (angular.isUndefined(ctrl.query.search.isValide) || ctrl.query.search.isValide === null)
        ctrl.query.search.isValide = true;

      $timeout.cancel(ctrl.queryWorking);
      ctrl.queryWorking = $timeout(function () {
        ContratsService.reservations
          .getList(ctrl.query)
          .then(function (retour) {
            if (retour.status === 'OK' && retour.nb > 0) {
              if (scroll) {
                angular.forEach(retour.list, function (reservation) {
                  ctrl.reservations.list.push(reservation);
                  ctrl.reservations.refList.push(reservation.id);
                });
                ctrl.query.numero += ctrl.query.pas;
              } else {
                ctrl.reservations.list = retour.list;
                ctrl.reservations.nb = retour.nb;
                ctrl.reservations.refList = [];

                angular.forEach(retour.list, function (reservation) {
                  ctrl.reservations.refList.push(reservation.id);
                });

                ctrl.query.numero = ctrl.query.pas;
              }
            }

            ctrl.loading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.reservations.list = [];
                ctrl.reservations.nb = 0;
                ctrl.reservations.refList = [];
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.loading = false;
          });
      });
    }

    function showFicheReservation(id) {
      $scope.$emit('showFiche', {
        type: 'ficheReservation',
        ref: id,
        refList: ctrl.reservations.refList
      });
    }

    function imprimer() {
      ImpressionService.downloadFile({
          toPdf: true,
          typeApplication: 'Location',
          listeCompromis: true,
          societe: angular.isDefined(ctrl.query.search.societe) ? ctrl.query.search.societe : null,
          nego: angular.isDefined(ctrl.query.search.nego) ? ctrl.query.search.nego : null,
          compromis: $stateParams.type === 'reservation',
          vente: $stateParams.type === 'location',
          annule: false,
          byDate: true,
          dateDeb: ctrl.query.search.datedeb || null,
          dateFin: ctrl.query.search.datefin || null
        },
        'PDF'
      ).then(function (retour) {
        if (retour.status === 'OK') {
          $window.open(retour.link, '_blank');
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('parutionsIcsBox', {
    templateUrl: 'app/components/main-content/parutions-ics-box/parutions-ics-box.html',
    controllerAs: 'parutionsicsboxctrl',
    controller: ParutionsIcsBoxController
  });

  /** @ngInject */
  function ParutionsIcsBoxController(
    CONSTANTS,
    globalService,

    ParutionsService,
    ImpressionService,
    $stateParams,
    $timeout,
    $element,
    $rootScope,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.initialisation = true;

    ctrl.employe = globalService.getEmploye();

    ctrl.defaultQuery = {
      recherche: null,
      prestaId: null,
      societesId: ctrl.employe.societe.id || null,
      nego: null,
      parution: null,
      avancement: null,
      qualification: null,
      type: null,
      numero: 0,
      pas: 32,
      tri: 'desc',
      ordre: 'triDate',
      typeMethode: 'liste',
      typeApplication: globalService.getTypeApplication()
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.loading = true;
    ctrl.noResults = false;
    ctrl.template = 'listNoPhotos';

    ctrl.prestataires = [];

    ctrl.parutions = {
      nbparutions: 0,
      nblots: 0,
      pluriel: '',
      lotspluriel: '',
      list: [],
      refList: [],
      lotsid: []
    };

    ctrl.blocBienHeight = 0;

    ctrl.message = {
      open: false,
      status: null,
      message: null
    };

    ctrl.queryWorking = null;

    ctrl.searchBoxOptions = {
      query: ctrl.query,
      defaultQuery: ctrl.defaultQuery,
      placeholder: 'Appartement 3 pieces 53 M2 200000 euros',
      templates: {
        list: [{
            nom: 'grid',
            icon: 'fa-th',
            tooltip: 'Grille'
          },
          {
            nom: 'list',
            icon: 'fa-list',
            tooltip: 'Liste'
          },
          {
            nom: 'listNoPhotos',
            icon: 'fa-bars',
            tooltip: 'Liste sans photos'
          }
        ],
        default: 'listNoPhotos',
        onChange: function (template) {
          setTemplate(template);
        }
      },
      filtres: {
        societes: {
          nomChamp: 'societesId'
        },
        nego: {
          nomChamp: 'nego'
        },
        parution: {
          nomChamp: 'parution'
        },
        avancement: {
          nomChamp: 'avancement'
        }
      },
      prestataires: {
        nomChamp: 'prestaId'
      },
      additionalControls: {
        tris: {
          list: CONSTANTS.dictionnaire.FR.listebien.tri,
          nomChamp: {
            tri: 'tri',
            ordre: 'ordre'
          },
          default: {
            tri: 'desc',
            ordre: 'triDate'
          }
        },
        imprimer: imprimer,
        editerTout: editerTout,
        checkParutions: true
      }
    };

    ctrl.getList = getList;
    ctrl.setTemplate = setTemplate;
    ctrl.imgResize = imgResize;
    ctrl.showFicheProperty = showFicheProperty;
    ctrl.setParution = setParution;

    ctrl.$onInit = function () {
      if (angular.isDefined($stateParams.recherche) || globalService.getStorageItem('QUERY-LISTE-PARUTIONS')) {
        var queryParam = $stateParams.recherche || globalService.getStorageItem('QUERY-LISTE-PARUTIONS');
        if (angular.isObject(queryParam)) {
          ctrl.query = queryParam;
        }
      }

      globalService.setStorageItem('QUERY-LISTE-PARUTIONS', ctrl.query);

      ctrl.searchBoxOptions.query = ctrl.query;
      ctrl.searchBoxOptions.templates.default = ctrl.template;

      if (!CONSTANTS.configClient.citya ||
        (CONSTANTS.configClient.citya && globalService.getTypeApplication() === 'Location')
      ) {
        ctrl.searchBoxOptions.filtres.qualification = {
          nomChamp: 'qualification'
        };
      }

      ctrl.initialisation = false;
    };

    function getList(search, scroll) {
      if (ctrl.queryWorking) {
        $timeout(function () {
          getList(search, scroll);
        }, 100);
        return;
      }

      if (search) {
        ctrl.query.recherche = search.recherche || null;
        ctrl.query.prestaId = search.prestaId || null;
        ctrl.query.societesId = search.societesId || null;
        ctrl.query.nego = search.nego || null;
        ctrl.query.avancement = search.avancement || null;
        ctrl.query.parution = angular.isDefined(search.parution) ? search.parution : null;
        ctrl.query.qualification = search.qualification || null;
        ctrl.query.tri = search.tri || null;
        ctrl.query.ordre = search.ordre || null;
      }
      ctrl.query.typeApplication = globalService.getTypeApplication();
      ctrl.noResults = false;

      if (!scroll) {
        ctrl.query.numero = 0;
        ctrl.parutions.nblots = 0;
        ctrl.parutions.nbparutions = 0;
        ctrl.parutions.lotspluriel = 0;
        ctrl.parutions.pluriel = 0;
        ctrl.parutions.list = [];
        ctrl.parutions.refList = [];
      }

      if (ctrl.parutions.nblots > 0 && ctrl.query.numero >= ctrl.parutions.nblots) return;

      if (ctrl.query.prestaId) {
        ctrl.queryWorking = true;
        globalService.setStorageItem('QUERY-LISTE-PARUTIONS', ctrl.query);
        ctrl.loading = true;

        ParutionsService.getParutions(ctrl.query)
          .then(function (json) {
            if (json.status === 'OK') {
              ctrl.parutions.nblots = json.list.nbparutions;
              ctrl.parutions.nbparutions = json.list.nbparutionsactive || 0;
              ctrl.parutions.lotspluriel = ctrl.parutions.nblots > 1 ? 's' : '';

              ctrl.query.numero += ctrl.query.pas;

              $rootScope.selectionList = $rootScope.selectionList || {};

              angular.forEach(json.list.parutions, function (parution) {
                if (
                  ctrl.query.parution === null ||
                  (ctrl.query.parution && parution.actif) ||
                  (!ctrl.query.parution && !parution.actif)
                ) {
                  ctrl.parutions.refList.push(parution.lot.referenceInterne);
                  ctrl.parutions.list.push(parution);
                }
                ctrl.parutions.lotsid.push(parution.lot.id);
              });

              ctrl.parutions.pluriel = ctrl.parutions.nbparutions > 1 ? 's' : '';
            } else {
              ctrl.noResults = true;
            }

            ctrl.loading = false;
            ctrl.queryWorking = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.noResults = true;
            ctrl.loading = false;
            ctrl.queryWorking = false;
          });
      }
    }

    function setTemplate(template) {
      ctrl.template = template;
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.parutions-list').querySelectorAll('.parution-img');
      if (imgs.length && ctrl.template !== 'listNoPhotos') {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight =
          ctrl.template === 'grid' || ctrl.template === 'map' ? (width - 30) * 3 / 4 + 131 : (width - 30) * 3 / 4 + 30;
      }
    }

    function showFicheProperty(refLot) {
      $scope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.parutions.refList
      });
    }

    function setParution(lotId, action) {
      if (lotId) {
        var params = {
          lotId: lotId,
          typeApplication: globalService.getTypeApplication()
        };

        if (action === 'ajouter') {
          params.addPrestaId = ctrl.query.prestaId;
        } else {
          params.supprPrestaId = ctrl.query.prestaId;
        }

        ParutionsService.setParution(params).then(function (retour) {
          if (retour.status === 'OK') {
            angular.forEach(ctrl.parutions.list, function (parution) {
              if (parution.lot.id === lotId) {
                parution.actif = action === 'ajouter';
                if (parution.actif) {
                  ctrl.parutions.nbparutions++;
                } else {
                  ctrl.parutions.nbparutions--;
                }
              }
            });
          }
        });
      }
    }

    function editerTout(action) {
      var params = angular.copy(ctrl.query);
      params.action = action;
      params.numero = null;
      params.pas = null;
      params.typeApplication = globalService.getTypeApplication();

      if (params.numero > 0) {
        params.pas = params.numero;
        params.numero = 0;
      }

      ParutionsService.setParution(params).then(function (retour) {
        if (retour.status === 'OK') {
          ctrl.parutions.list = retour.list.parutions;
          ctrl.parutions.nbparutions = action === 'ajouterTout' ? retour.list.nbparutions : 0;
        }
      });
    }

    function imprimer() {
      var oldNumero = ctrl.query.numero,
        oldPas = ctrl.query.pas,
        oldTypeMethode = ctrl.query.typeMethode;

      ctrl.query.numero = 0;
      ctrl.query.pas = null;
      ctrl.query.typeMethode = 'idlot';

      ParutionsService.getParutions(ctrl.query)
        .then(function (json) {
          if (json.status === 'OK') {
            var params = {
              lotsid: ''
            };
            angular.forEach(json.list.parutions, function (parution, index) {
              params.lotsid += parution.lot.id;
              if (index < json.list.nbparutions - 1) params.lotsid += ',';
            });

            ImpressionService.openImpression(params);
          }
        })
        .finally(function () {
          ctrl.query.numero = oldNumero;
          ctrl.query.pas = oldPas;
          ctrl.query.typeMethode = oldTypeMethode;
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('panneaux', {
    templateUrl: 'app/components/main-content/panneaux/panneaux.html',
    controllerAs: 'panneauxctrl',
    controller: PanneauxController
  });

  /** @ngInject */
  function PanneauxController(
    CONSTANTS,
    $stateParams,
    globalService,

    PanneauxService,
    ImpressionService,
    $timeout,
    $element,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.initialisation = true;

    ctrl.employe = globalService.getEmploye();

    ctrl.defaultQuery = {
      recherche: null,
      panneaux: null,
      avancement: null,
      societe: ctrl.employe ? ctrl.employe.societe.id : null,
      nego: null,
      qualification: null,
      mandat: true,
      archive: false,
      tri: 'desc',
      ordre: 'triDate',
      numero: 0,
      pas: 32,
      typeMethode: 'listePanneau',
      typeApplication: globalService.getTypeApplication()
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.loading = true;
    ctrl.noResults = false;
    ctrl.template = 'listNoPhotos';

    ctrl.panneaux = {
      nbpanneaux: 0,
      list: [],
      refList: [],
      pluriel: ''
    };

    ctrl.blocBienHeight = 0;

    ctrl.queryWorking = null;

    ctrl.searchBoxOptions = {
      query: ctrl.query,
      defaultQuery: ctrl.defaultQuery,
      placeholder: 'Appartement 3 pieces 53 M2 200000 euros',
      templates: {
        list: [{
            nom: 'grid',
            icon: 'fa-th',
            tooltip: 'Grille'
          },
          {
            nom: 'list',
            icon: 'fa-list',
            tooltip: 'Liste'
          },
          {
            nom: 'listNoPhotos',
            icon: 'fa-bars',
            tooltip: 'Liste sans photos'
          }
        ],
        default: 'listNoPhotos',
        onChange: function (template) {
          setTemplate(template);
        }
      },
      filtres: {
        panneaux: {
          nomChamp: 'panneaux'
        },
        societes: {
          nomChamp: 'societe'
        },
        nego: {
          nomChamp: 'nego'
        },
        avancement: {
          nomChamp: 'avancement'
        },
        visibilite: {
          mandat: true,
          archive: true,
          nomChamp: {
            mandat: 'mandat',
            archive: 'archive'
          }
        }
      },
      additionalControls: {
        imprimer: imprimer
      }
    };

    ctrl.getList = getList;
    ctrl.setTemplate = setTemplate;
    ctrl.imgResize = imgResize;
    ctrl.showFicheProperty = showFicheProperty;

    ctrl.$onInit = function () {
      if (
        angular.isDefined($stateParams.recherche) ||
        globalService.getStorageItem('QUERY-LISTE-PANNEAUX')
      ) {
        var queryParam =
          $stateParams.recherche || globalService.getStorageItem('QUERY-LISTE-PANNEAUX');
        if (angular.isObject(queryParam)) {
          ctrl.query = queryParam;
        }
      }

      ctrl.query.typeMethode = 'listePanneau';

      ctrl.searchBoxOptions.query = ctrl.query;
      ctrl.searchBoxOptions.templates.default = ctrl.template;

      if (!CONSTANTS.configClient.citya ||
        (CONSTANTS.configClient.citya && globalService.getTypeApplication() === 'Location')
      ) {
        ctrl.searchBoxOptions.filtres.qualification = {
          nomChamp: 'qualification'
        };
      }

      globalService.setStorageItem('QUERY-LISTE-PANNEAUX', ctrl.query);

      getList(false, false);

      ctrl.initialisation = false;
    };

    function getList(search, scroll) {
      if (!scroll) ctrl.query.numero = 0;
      if (ctrl.query.numero > ctrl.panneaux.nbpanneaux || (ctrl.query.numero > 0 && ctrl.loading)) {
        return;
      }
      if (ctrl.query.numero === 0) {
        ctrl.panneaux.nbpanneaux = 0;
        ctrl.panneaux.list = [];
      }
      if (search) {
        ctrl.query.recherche = search.recherche || null;
        ctrl.query.panneaux = angular.isDefined(search.panneaux) && search.panneaux !== '' ? search.panneaux : null;
        ctrl.query.avancement = search.avancement || null;
        ctrl.query.mandat = angular.isDefined(search.mandat) ? search.mandat : null;
        ctrl.query.archive = angular.isDefined(search.archive) ? search.archive : null;
        ctrl.query.societe = search.societe || null;
        ctrl.query.nego = search.nego || null;
        ctrl.query.qualification = search.qualification || null;
        ctrl.query.tri = search.tri || null;
        ctrl.query.ordre = search.ordre || null;
      }
      ctrl.query.typeApplication = globalService.getTypeApplication();

      globalService.setStorageItem('QUERY-LISTE-PANNEAUX', ctrl.query);

      $timeout.cancel(ctrl.queryWorking);
      ctrl.queryWorking = $timeout(function () {
        ctrl.loading = true;
        ctrl.noResults = false;

        PanneauxService.getPanneaux(ctrl.query)

          .then(function (json) {
            if (json.status === 'OK') {
              var num = ctrl.query.numero + ctrl.query.pas;
              if (ctrl.panneaux.nbpanneaux > 0 && num > ctrl.panneaux.nbpanneaux) num = ctrl.panneaux.nbpanneaux;
              $log.info('Récupération réussie des panneaux ' + ctrl.query.numero + ' à ' + num);
              ctrl.query.numero += ctrl.query.pas;
              ctrl.panneaux.nbpanneaux = json.list.nbpanneaux;
              ctrl.panneaux.pluriel = ctrl.panneaux.nbpanneaux > 1 ? 's' : '';

              angular.forEach(json.list.panneaux, function (panneau) {
                ctrl.panneaux.list.push(panneau);
              });
            }

            ctrl.loading = false;
          })

          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.noResults = true;
                ctrl.query.numero = ctrl.panneaux.nbpanneaux = 0;
                ctrl.panneaux.list = [];
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.loading = false;
          });
      });
    }

    function setTemplate(template) {
      ctrl.template = template;
      ctrl.query.numero = 0;

      getList(false, false);
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.panneaux-list').querySelectorAll('.panneau-img');
      if (imgs.length && ctrl.template !== 'listNoPhotos') {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight =
          ctrl.template === 'grid' || ctrl.template === 'map' ? (width - 30) * 3 / 4 + 131 : (width - 30) * 3 / 4 + 30;
      }
    }

    function showFicheProperty(refLot) {
      $scope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.panneaux.refList
      });
    }

    function imprimer() {
      var oldNumero = ctrl.query.numero,
        oldPas = ctrl.query.pas,
        oldTypeMethode = ctrl.query.typeMethode;

      ctrl.query.numero = 0;
      ctrl.query.pas = null;
      ctrl.query.typeMethode = 'idlot';

      PanneauxService.getPanneaux(ctrl.query)
        .then(function (json) {
          if (json.status === 'OK') {
            var params = {
              lotsid: ''
            };
            angular.forEach(json.list.panneaux, function (panneau, index) {
              params.lotsid += panneau.id;
              if (index < json.list.nbpanneaux - 1) params.lotsid += ',';
            });

            ImpressionService.openImpression(params);
          }
        })
        .finally(function () {
          ctrl.query.numero = oldNumero;
          ctrl.query.pas = oldPas;
          ctrl.query.typeMethode = oldTypeMethode;
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('modifReservation', {
    templateUrl: 'app/components/main-content/modif-reservation/modif-reservation.html',
    controllerAs: 'modifreservationctrl',
    controller: ModifReservationController
  });

  /** @ngInject */
  function ModifReservationController(
    CONSTANTS,
    globalService,
    CustomUtils,
   
    ContratsService,
    ImpressionService,
    Perso,
    $stateParams,
    $rootScope,
    toastr,
    moment,
    ngDialog,
    $state,
    $window,
    $scope,
    $q,
    $log
  ) {
    var ctrl = this;

    ctrl.titre = 'RÉSERVATION';

    ctrl.reservation = null;

    ctrl.forceExit = false;

    ctrl.loading = false;

    ctrl.citya = CONSTANTS.configClient.citya;
    ctrl.dossierLocataireAfficher = false;
    ctrl.employe = globalService.getEmploye();

    ctrl.honoraires = 0;
    ctrl.honorairesHT = 0;
    ctrl.baseHonoraires = 0;
    ctrl.tauxMax = ctrl.employe.profileTrans.tauxRemiseLocation;

    ctrl.verrouillages = {
      signature: false,
      controlComptable: false
    };

    ctrl.remises = {
      list: [],
      proprietaire: {
        text: 'Remise',
        value: 0
      },
      locataire: {
        text: 'Remise',
        value: 0
      },
      affectations: [{
          label: 'Locataire',
          value: true
        },
        {
          label: 'Propriétaire',
          value: false
        }
      ],
      tri: 'date',
      ordre: false,
      toggleTri: toggleRemisesTri,
      getList: getRemisesList
    };

    ctrl.encaissements = {
      list: [],
      affectations: [{
          label: 'Locataire',
          value: true
        },
        {
          label: 'Propriétaire',
          value: false
        }
      ],
      tri: 'date',
      ordre: false,
      current: {
        date: '',
        valeur: 0,
        sortant: true
      },
      edited: false,
      toggleTri: toggleEncaissementsTri,
      getList: getEncaissementsList,
      ajouter: ajouterEncaissement,
      modifier: modifierEncaissement,
      supprimer: supprimerEncaissement
    };

    ctrl.datepickers = {
      date: {
        isOpen: false,
        class: ''
      },
      dateFinOption: {
        isOpen: false,
        class: ''
      },
      datePrevueVente: {
        isOpen: false,
        class: ''
      },
      dateEffectiveVente: {
        isOpen: false,
        class: ''
      },
      dateEtatDesLieux: {
        isOpen: false,
        class: ''
      },
      dateSignature: {
        isOpen: false,
        class: ''
      },
      dateEncaissement: {
        isOpen: false,
        class: ''
      },
      dateNewEncaissement: {
        isOpen: false
      },
      dateEditEncaissement: {
        isOpen: false
      },
      toggle: function (datepicker) {
        if (!ctrl.datepickers[datepicker].isOpen) {
          ctrl.datepickers[datepicker].isOpen = !isDisabled(datepicker);
        } else {
          ctrl.datepickers[datepicker].isOpen = false;
        }
        ctrl.form[datepicker].$setDirty(true);
      },
      close: function (datepicker) {
        ctrl.datepickers[datepicker].isOpen = false;
        ctrl.form[datepicker].$setDirty(true);
      }
    };

    ctrl.suiviEncaissementOpen = ctrl.citya;

    ctrl.isDisabled = isDisabled;
    ctrl.setLocataire = setLocataire;
    ctrl.setDateFin = setDateFin;
    ctrl.getEntremise = getEntremise;
    ctrl.calculHonoraires = calculHonoraires;
    ctrl.dossierLocataire = dossierLocataire;
    ctrl.goBack = goBack;
    ctrl.openAffaire = openAffaire;
    ctrl.imprimer = imprimerReservation;
    ctrl.save = saveReservation;
    ctrl.supprimer = supprimerReservation;

    ctrl.dateResaListener = null;

    $scope.$on('$stateChangeStart', preventExit);
    $window.onbeforeunload = function () {
      if (!ctrl.form.$pristine) {
        return 'Les modifications que vous avez apportées ne seront pas enregistrées';
      }
    };

    var dateEffetListener = $scope.$watch(
      function () {
        return ctrl.reservation && ctrl.reservation.dateEffectiveVente ? ctrl.reservation.dateEffectiveVente : null;
      },
      function (newVal, oldVal) {
        var dateEffetBail = ctrl.reservation.dateEffectiveVente;
        if(ctrl.citya){
            dateEffetBail = ctrl.reservation.dateEffectBail;
        }
          
        if (newVal !== oldVal && ctrl.reservation.infoBail && dateEffetBail) {
          ctrl.reservation.infoBail.datePriseEffet = setDateFrom(
            ctrl.reservation.infoBail.datePriseEffet,dateEffetBail
          );
          ctrl.reservation.infoBail.dateEntree = setDateFrom(
            ctrl.reservation.infoBail.dateEntree,
            dateEffetBail
          );
          ctrl.reservation.infoBail.appelLoyer = setDateFrom(
            ctrl.reservation.infoBail.appelLoyer,
            dateEffetBail
          );
          ctrl.reservation.infoBail.appelProvision = setDateFrom(
            ctrl.reservation.infoBail.appelProvision,
            dateEffetBail
          );
        }
      }
    );

    ctrl.$onInit = function () {
      if ($stateParams.reference) {
        ctrl.loading = true;

        ContratsService.reservations
          .getList({
            idLocation: $stateParams.reference,
            typeMethode: 'complete'
          })
          .then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.reservation = retour.reservation;

                if (ctrl.reservation.hasDateEffectiveVente()) {
                  ctrl.titre = 'LOCATION';
                  $rootScope.typeContrat = 'location';
                } else {
                  $rootScope.typeContrat = 'reservation';
                }

                if (ctrl.reservation.affaire.hasMandatLocation() && ctrl.reservation.affaire.mandatLocation.loyer) {
                  ctrl.reservation.loyer = ctrl.reservation.loyer || ctrl.reservation.affaire.mandatLocation.loyer;
                }

                if (
                  ctrl.reservation.affaire.hasMandatLocation() &&
                  ctrl.reservation.affaire.mandatLocation.tauxHonoraires
                ) {
                  ctrl.reservation.tauxHono =
                    ctrl.reservation.tauxHono || ctrl.reservation.affaire.mandatLocation.tauxHonoraires;
                }
                
                if (ctrl.reservation.affaire.hasMandatLocation() && ctrl.reservation.affaire.mandatLocation.nego.societe.activeDossierLocataire){
                    ctrl.dossierLocataireAfficher = ctrl.reservation.affaire.mandatLocation.nego.societe.activeDossierLocataire;
                }else{
                    ctrl.dossierLocataireAfficher = false;
                }
                
                genererGravitants();
                setReservationDates();

                if (ctrl.reservation.valider) {
                  calculHonoraires('init');
                } else {
                  calculHonoraires('reload');
                }
                getRemisesList();
                getEncaissementsList();
                setVerrouillages();

                ctrl.dateResaListener = $scope.$watch(
                  function () {
                    return ctrl.reservation.date;
                  },
                  function (oldval, newval) {
                    if (oldval !== newval) {
                      setDateFin();
                    }
                  }
                );

                ctrl.loading = false;
              } else {
                $state.go('reservation');
              }
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
      } else {
        $state.go('reservation');
      }
    };

    ctrl.$onDestroy = function () {
      if (ctrl.dateResaListener) {
        ctrl.dateResaListener();
        ctrl.dateResaListener = null;
      }

      dateEffetListener();
      dateEffetListener = null;
    };

    function preventExit(event, toState, toParams) {
      if (!ctrl.form.$pristine && !ctrl.forceExit) {
        event.preventDefault();

        var confirmDialog = ngDialog.openConfirm({
          templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
          controller: 'ConfirmDialogController',
          controllerAs: 'confirmdialogctrl',
          resolve: {
            titre: function titreFactory() {
              return 'Voulez-vous quitter la saisie ?';
            },
            message: function messageFactory() {
              return '<span><i class="fa fa-2r fa-exclamation-triangle text-danger"></i> Les modifications que vous avez apportées ne seront pas enregistrées</span>';
            },
            commentaire: function commentaireFactory() {
              return false;
            },
            confirmText: function confirmTextFactory() {
              return 'Quitter';
            },
            annulerText: function annulerTextFactory() {
              return false;
            }
          }
        });

        confirmDialog.then(function (data) {
          if (data.status === 'OK') {
            ctrl.forceExit = true;
            $state.go(toState, toParams);
          }
        });
      }
    }

    function genererGravitants() {
      if (ctrl.reservation.infoBail) {
        // Ajouter par défaut un gravitant locataire
        if (ctrl.reservation.hasLocataire()) {
          var hasLocataire = ctrl.reservation.infoBail.listeGravitant.filter(function (gravitant) {
            return gravitant.perso.id === ctrl.reservation.locataire.perso.id;
          });
          if (!hasLocataire.length) {
            var locataire = {
              type: {
                id: 20,
                label: 'Locataire'
              },
              perso: ctrl.reservation.locataire.perso
            };
            ctrl.reservation.infoBail.listeGravitant.push(locataire);
          }
        }

        // Ajouter par défaut un gravitant co-locataire
        if (ctrl.reservation.hasColocataire()) {
          var hasColocataire = ctrl.reservation.infoBail.listeGravitant.filter(function (gravitant) {
            return gravitant.perso.id === ctrl.reservation.colocataire.id;
          });

          if (!hasColocataire.length) {
            var coLocataire = {
              type: {
                id: 21,
                label: 'Co-locataire'
              },
              perso: ctrl.reservation.colocataire
            };
            ctrl.reservation.infoBail.listeGravitant.push(coLocataire);
          }
        } else ctrl.reservation.colocataire = new Perso();
      }
    }

    function isDisabled(champ) {
      switch (champ) {
        case 'date':
        case 'dateFinOption':
          return (
            ctrl.citya &&
            (!ctrl.employe.profileTrans.adminProfile ||
              ctrl.verrouillages.signature ||
              ctrl.verrouillages.controlComptable)
          );
        case 'dateEffectiveVente':
          return (
            ctrl.citya &&
            (!ctrl.reservation.datePrevueVente || ctrl.verrouillages.signature || ctrl.verrouillages.controlComptable)
          );
        case 'dateSignature':
          return ctrl.citya && ctrl.dossierLocataireAfficher && !ctrl.employe.profileTrans.adminProfile;
        case 'dateEncaissement':
          return ctrl.citya && ctrl.verrouillages.controlComptable && !ctrl.employe.profileTrans.adminProfile;
        case 'archive':
          return ctrl.citya && !ctrl.verrouillages.signature && !ctrl.employe.profileTrans.adminProfile;
        case 'datePrevueVente':
          return ctrl.citya && ctrl.dossierLocataireAfficher && !ctrl.employe.profileTrans.adminProfile;
        case 'tva':
          return ctrl.citya;
        case 'dateNewEncaissement':
        case 'dateEditEncaissement':
          return false;
        default:
          return ctrl.citya && (ctrl.verrouillages.signature || ctrl.verrouillages.controlComptable);
      }
    }

    function setLocataire(prospect) {
      ctrl.reservation.locataire = prospect;
    }

    function toggleRemisesTri(tri) {
      if (ctrl.remises.tri === tri) {
        ctrl.remises.ordre = !ctrl.remises.ordre;
      } else {
        ctrl.remises.tri = tri;
      }
    }

    function getRemisesList() {
      ctrl.loading = true;

      ContratsService.getRemisesList({
        idReference: ctrl.reservation.id,
        location: true,
        typeMethode: 'short'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.remises.list = retour.remises;

            if (ctrl.remises.list.length) {
              var date = moment();
              angular.forEach(ctrl.remises.list, function (remise) {
                if (remise.dateRemise) {
                  var current = moment(remise.dateRemise, CONSTANTS.date_format);
                  if (current.isBefore(date)) {
                    date = current;
                    ctrl.baseHonoraires = remise.prixDepart;
                  }
                }
              });
            }
          }
          ctrl.loading = false;
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.loading = false;
        }
      );
    }

    function toggleEncaissementsTri(tri) {
      if (ctrl.encaissements.tri === tri) {
        ctrl.encaissements.ordre = !ctrl.encaissements.ordre;
      } else {
        ctrl.encaissements.tri = tri;
      }
    }

    function getEncaissementsList() {
      ctrl.loading = true;

      ContratsService.reservations
        .getEncaissementsList({
          idLocation: ctrl.reservation.id
        })
        .then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.encaissements.list = retour.encaissements;
            }
            ctrl.loading = false;
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.loading = false;
          }
        );
    }

    function ajouterEncaissement() {
      if (ctrl.encaissements.current && ctrl.encaissements.current.date && ctrl.encaissements.current.valeur) {
        ContratsService.reservations
          .editerEncaissements({
            idlocation: ctrl.reservation.id,
            xml: angular.toJson(ctrl.encaissements.current)
          })
          .then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.encaissements.list = retour.encaissements;
                ctrl.encaissements.edited = true;
              }
              ctrl.loading = false;
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
      } else {
        toastr.warning(
          "Vous devez renseigner le montant et l'affectation de l'encaissement pour pouvoir l'enregistrer.",
          'Saisie encaissement incomplète'
        );
      }
    }

    function modifierEncaissement(id) {
      if (id) {
        var searchEncaissement = ctrl.encaissements.list.filter(function (encaissement) {
          return encaissement.id === id;
        });

        if (searchEncaissement.length) {
          ctrl.loading = true;

          var encaissement = searchEncaissement[0];
          encaissement.editable = null;

          ContratsService.reservations
            .editerEncaissements({
              idlocation: ctrl.reservation.id,
              xml: angular.toJson(encaissement)
            })
            .then(
              function (retour) {
                if (retour.status === 'OK') {
                  ctrl.encaissements.list = retour.encaissements;
                  ctrl.encaissements.edited = true;
                }
                ctrl.loading = false;
              },
              function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED')
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            );
        } else {
          toastr.error(
            "Une erreur est survenue lors de l'enregistrement de cet encaissement.<br>" +
            'Veuillez réessayer ultérieurement.',

            'Erreur édition encaissement'
          );
        }
      }
    }

    function supprimerEncaissement(id) {
      if (id) {
        ctrl.loading = true;

        ContratsService.reservations
          .editerEncaissements({
            deleteid: id
          })
          .then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.encaissements.list = retour.encaissements;
                ctrl.encaissements.edited = true;
              }
              ctrl.loading = false;
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
      }
    }

    function setVerrouillages() {
      ctrl.verrouillages = {
        signature: ctrl.reservation.dateEffectiveVente &&
          moment(ctrl.reservation.dateEffectiveVente, CONSTANTS.date_format).isBefore(moment(), 'day'),
        controlComptable: ctrl.reservation.dateEncaissement
      };

      angular.forEach(ctrl.datepickers, function (datepicker, nom) {
        if (datepicker.hasOwnProperty('class')) {
          datepicker.class = isDisabled(nom) ? 'disabled' : '';
        }
      });
    }

    function setDateFrom(target, source) {
      if (target) {
        target = moment(target, CONSTANTS.date_format).isBefore(moment(source, CONSTANTS.date_format)) ?
          source :
          target;
      } else {
        target = source;
      }

      return target;
    }

    function setReservationDates() {
      if (!ctrl.reservation.date) {
        ctrl.reservation.date = moment().format(CONSTANTS.date_format);
      }

      if (!ctrl.reservation.dateRedaction) {
        ctrl.reservation.dateRedaction = null;
      }

      if (!ctrl.reservation.dateFinOption) {
        setDateFin();
      }

      if (!ctrl.reservation.datePrevueVente) {
        ctrl.reservation.datePrevueVente = null;
      }

      if (!ctrl.reservation.dateEffectiveVente) {
        ctrl.reservation.dateEffectiveVente = null;
      }

      if (!ctrl.reservation.dateSignature) {
        ctrl.reservation.dateSignature = null;
      }

      if (!ctrl.reservation.dateEtatDesLieux) {
        ctrl.reservation.dateEtatDesLieux = null;
      }

      if (!ctrl.reservation.dateEncaissement) {
        ctrl.reservation.dateEncaissement = null;
      }
      if (!ctrl.reservation.dateEffetBail) {
        ctrl.reservation.dateEffetBail = null;
      }
    }

    function setDateFin() {
      if (ctrl.reservation.date) {
        ctrl.reservation.dateFinOption = moment(ctrl.reservation.date, CONSTANTS.date_format)
          .add(7, 'days')
          .format(CONSTANTS.date_format);
      }
    }

    function calculHonoraires(origin) {
      switch (origin) {
        case 'init':
          ctrl.reservation.loyer = ctrl.reservation.loyer || ctrl.reservation.affaire.mandatLocation.loyer || 0;
          ctrl.reservation.tauxHono =
            ctrl.reservation.tauxHono || ctrl.reservation.affaire.mandatLocation.tauxHonoraire || getTauxHono();
          ctrl.reservation.tva =
            ctrl.reservation.tva || ctrl.employe.societe.tva || ctrl.employe.societe.agence.tva || 20;
          ctrl.honorairesHT = getHonoHT(true);
          ctrl.honoraires = getHono(true);
          ctrl.reservation.honoVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB;
          ctrl.reservation.honoEDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL;
          ctrl.reservation.entremiseFixe = getEntremise();
          break;
        case 'reload':
          ctrl.reservation.loyer = ctrl.reservation.affaire.mandatLocation.loyer || 0;
          ctrl.reservation.tauxHono = ctrl.reservation.affaire.mandatLocation.tauxHonoraire || 0;
          ctrl.reservation.tva =
            ctrl.reservation.tva || ctrl.employe.societe.tva || ctrl.employe.societe.agence.tva || 20;
          ctrl.honorairesHT = getHonoHT(true);
          ctrl.honoraires = getHono(true);
          ctrl.reservation.honoVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB;
          ctrl.reservation.honoEDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL;
          ctrl.reservation.entremiseFixe = getEntremise();
          break;
        case 'loyer':
          if (ctrl.reservation.loyer) {
            ctrl.honorairesHT = getHonoHT(true);
            ctrl.honoraires = getHono();
          } else {
            ctrl.reservation.loyer = 0;
            ctrl.honorairesHT = 0;
            ctrl.honoraires = 0;
            ctrl.reservation.tauxHono = 0;
          }
          break;

        case 'honorairesHT':
          if (ctrl.honorairesHT) {
            ctrl.honoraires = getHono();
            ctrl.reservation.tauxHono = getTauxHono();
          } else {
            ctrl.honorairesHT = 0;
            ctrl.honoraires = 0;
            ctrl.reservation.tauxHono = 0;
          }
          break;

        case 'honoraires':
          if (ctrl.honoraires) {
            ctrl.honorairesHT = getHonoHT();
            ctrl.reservation.tauxHono = getTauxHono();
          } else {
            ctrl.honoraires = 0;
            ctrl.honorairesHT = 0;
            ctrl.reservation.tauxHono = 0;
          }
          break;

        case 'tva':
          ctrl.reservation.tva = ctrl.reservation.tva ? ctrl.reservation.tva : 0;
          ctrl.honoraires = getHono();
          ctrl.reservation.tauxHono = getTauxHono();
          break;
      }

      if (origin === 'init' || origin === 'reload') {
        ctrl.baseHonoraires =
          ctrl.reservation.loyer && ctrl.reservation.affaire.mandatLocation.tauxHonoraire ?
          ctrl.reservation.loyer * (ctrl.reservation.affaire.mandatLocation.tauxHonoraire / 100) :
          ctrl.honoraires;
      } else {
        if (ctrl.tauxMax < 100 && ctrl.honoraires < ctrl.baseHonoraires) {
          var tauxRemise = (ctrl.baseHonoraires - ctrl.honoraires) / ctrl.baseHonoraires * 100;
          if (tauxRemise > ctrl.tauxMax && !ctrl.citya) {
            toastr.warning(
              "Vous essayez d'appliquer une remise de " +
              Math.round(tauxRemise * 100) / 100 +
              '%.<br>Le taux de remise maximum est de <strong>' +
              ctrl.tauxMax +
              '%</strong>.',
              'Seuil de remise maximum dépassé.', {
                timeOut: 10000
              }
            );
            ctrl.honoraires = ctrl.lastHonoraires || ctrl.baseHonoraires;
            return calculHonoraires('honoraires');
          } else {
            ctrl.lastHonoraires = ctrl.honoraires;
          }
        } else {
          ctrl.lastHonoraires = ctrl.honoraires;
        }
      }

      calculHonoDetails(origin);
    }

    function getTauxHono(noHono, noHonoHT) {
      noHono = angular.isDefined(noHono) ? noHono : false;
      noHonoHT = angular.isDefined(noHonoHT) ? noHonoHT : false;
      if (ctrl.reservation.loyer) {
        if (ctrl.honoraires && !noHono) return ctrl.honoraires / ctrl.reservation.loyer * 100;
        else if (ctrl.honorairesHT && !noHonoHT)
          return ctrl.honorairesHT / ((100 - ctrl.reservation.tva) / 100) / ctrl.reservation.loyer * 100;
        else return 0;
      } else return 0;
    }

    function getHonoHT(noHono, noTauxHono) {
      noHono = angular.isDefined(noHono) ? noHono : false;
      noTauxHono = angular.isDefined(noTauxHono) ? noTauxHono : false;
      if (ctrl.honoraires && !noHono) return ctrl.honoraires / ((100 + ctrl.reservation.tva) / 100);
      else if (ctrl.reservation.loyer && ctrl.reservation.tauxHono && !noTauxHono)
        return ctrl.reservation.loyer * (ctrl.reservation.tauxHono / 100) / ((100 + ctrl.reservation.tva) / 100);
      else if (ctrl.reservation.loyer && ctrl.reservation.affaire.mandatLocation.tauxHonoraire)
        return (
          ctrl.reservation.loyer *
          (ctrl.reservation.affaire.mandatLocation.tauxHonoraire / 100) /
          ((100 + ctrl.reservation.tva) / 100)
        );
      else return 0;
    }

    function getHono(noHonoHT, noTauxHono) {
      noHonoHT = angular.isDefined(noHonoHT) ? noHonoHT : false;
      noTauxHono = angular.isDefined(noTauxHono) ? noTauxHono : false;
      if (ctrl.honorairesHT && !noHonoHT) {
        return ctrl.honorairesHT * ((100 + ctrl.reservation.tva) / 100);
      } else if (ctrl.reservation.loyer && ctrl.reservation.tauxHono && !noTauxHono) {
        return ctrl.reservation.loyer * (ctrl.reservation.tauxHono / 100);
      } else return 0;
    }

    function calculHonoDetails(origin) {
      var diff;

      ctrl.reservation.honoPRVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB ?
        ctrl.reservation.affaire.mandatLocation.honoraireVDB :
        0;
      ctrl.reservation.honoPREDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL ?
        ctrl.reservation.affaire.mandatLocation.honoraireEDL :
        0;
      ctrl.reservation.honoEntremise = getEntremise() ? getEntremise() : 0;

      ctrl.reservation.honoLRVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB ?
        ctrl.reservation.affaire.mandatLocation.honoraireVDB :
        0;
      ctrl.reservation.honoLREDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL ?
        ctrl.reservation.affaire.mandatLocation.honoraireEDL :
        0;

      if (origin !== 'honoProprietaire' && origin !== 'honoLocataire') {
        ctrl.reservation.honoProprietaire =
          origin === 'init' ?
          ctrl.reservation.honoProprietaire :
          ctrl.honoraires + ctrl.reservation.honoEntremise || ctrl.reservation.honoProprietaire;
        ctrl.reservation.honoLocataire =
          origin === 'init' ? ctrl.reservation.honoLocataire : ctrl.honoraires || ctrl.reservation.honoLocataire;
      }

      if (
        ctrl.reservation.honoProprietaire &&
        ctrl.reservation.honoProprietaire >
        ctrl.reservation.honoPRVDB + ctrl.reservation.honoPREDL + ctrl.reservation.honoEntremise
      ) {
        diff =
          ctrl.reservation.honoProprietaire -
          ctrl.reservation.honoPRVDB -
          ctrl.reservation.honoPREDL -
          ctrl.reservation.honoEntremise;
        ctrl.reservation.honoEntremise += diff;
        ctrl.remises.proprietaire.text = 'Majoration';
        ctrl.remises.proprietaire.value = Math.abs(Math.round(diff / ctrl.reservation.honoProprietaire * 100));
      } else if (
        ctrl.reservation.honoProprietaire &&
        ctrl.reservation.honoProprietaire <
        ctrl.reservation.honoPRVDB + ctrl.reservation.honoPREDL + ctrl.reservation.honoEntremise
      ) {
        diff =
          ctrl.reservation.honoPRVDB +
          ctrl.reservation.honoPREDL +
          ctrl.reservation.honoEntremise -
          ctrl.reservation.honoProprietaire;
        if (diff > ctrl.reservation.honoEntremise) {
          diff -= ctrl.reservation.honoEntremise;
          ctrl.reservation.honoEntremise = 0;

          if (diff > ctrl.reservation.honoPRVDB) {
            diff -= ctrl.reservation.honoPRVDB;
            ctrl.reservation.honoPRVDB = 0;

            ctrl.reservation.honoPREDL -= diff;
          } else {
            ctrl.reservation.honoPRVDB -= diff;
          }
        } else {
          ctrl.reservation.honoEntremise -= diff;
        }

        ctrl.remises.proprietaire.text = 'Remise';
        ctrl.remises.proprietaire.value = Math.abs(Math.round(diff / ctrl.reservation.honoProprietaire * 100));
      } else {
        ctrl.reservation.honoPRVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB;
        ctrl.reservation.honoPREDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL;
        ctrl.reservation.honoEntremise = getEntremise();

        ctrl.remises.proprietaire.text = 'Remise';
        ctrl.remises.proprietaire.value = 0;
      }

      if (
        ctrl.reservation.honoLocataire &&
        ctrl.reservation.honoLocataire > ctrl.reservation.honoLRVDB + ctrl.reservation.honoLREDL
      ) {
        diff = ctrl.reservation.honoLocataire - ctrl.reservation.honoLRVDB - ctrl.reservation.honoLREDL;
        ctrl.reservation.honoLRVDB += diff;
        ctrl.remises.locataire.text = 'Majoration';
        ctrl.remises.locataire.value = Math.abs(Math.round(diff / ctrl.reservation.honoLocataire * 100));
      } else if (
        ctrl.reservation.honoLocataire &&
        ctrl.reservation.honoLocataire < ctrl.reservation.honoLRVDB + ctrl.reservation.honoLREDL
      ) {
        diff = ctrl.reservation.honoLRVDB + ctrl.reservation.honoLREDL - ctrl.reservation.honoLocataire;
        if (diff > ctrl.reservation.honoLRVDB) {
          diff -= ctrl.reservation.honoLRVDB;
          ctrl.reservation.honoLRVDB = 0;

          ctrl.reservation.honoLREDL -= diff;
        } else {
          ctrl.reservation.honoLRVDB -= diff;
        }

        ctrl.remises.locataire.text = 'Remise';
        ctrl.remises.locataire.value = Math.abs(Math.round(diff / ctrl.reservation.honoLocataire * 100));
      } else {
        ctrl.reservation.honoLRVDB = ctrl.reservation.affaire.mandatLocation.honoraireVDB;
        ctrl.reservation.honoLREDL = ctrl.reservation.affaire.mandatLocation.honoraireEDL;

        ctrl.remises.locataire.text = 'Remise';
        ctrl.remises.locataire.value = 0;
      }
    }

    function getEntremise() {
      if (ctrl.reservation.affaire.mandatLocation.nego.societe.txLoyerEntremise) {
        return ctrl.reservation.loyer * (ctrl.reservation.affaire.mandatLocation.nego.societe.txLoyerEntremise / 100);
      } else if (ctrl.reservation.affaire.mandatLocation.nego.societe.fixeEntremise) {
        return ctrl.reservation.affaire.mandatLocation.nego.societe.fixeEntremise;
      } else if (ctrl.reservation.affaire.mandatLocation.nego.societe.txSurfaceEntremise) {
        return (
          ctrl.reservation.affaire.surface *
          (ctrl.reservation.affaire.mandatLocation.nego.societe.txSurfaceEntremise / 100)
        );
      } else return 0;
    }

    function dossierLocataire() {
      if (ctrl.form.$pristine) {
        saveDossierLocataire();
      } else {
        saveReservation(saveDossierLocataire);
      }
    }

    function saveDossierLocataire() {
      ContratsService.reservations
        .dossierLocataire({
          idLocation: ctrl.reservation.id
        })
        .then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.dateEnvoiDossierLocataire = retour.dateEnvoi;
              toastr.success('Le dossier locataire a été envoyé avec succés.', 'Envoie terminé', {
                  timeOut: 8000
                });
            }
            ctrl.loading = false;
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status === 'DATA_EXCEPTION') {
                toastr.error(error.message, 'Erreur dossier locataire', {
                  timeOut: 8000
                });
              } else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              }
            } else $log.error(error.status);
            ctrl.loading = false;
          }
        );
    }

    function checkValidation() {
      var deferred = $q.defer(),
        validation =
        ctrl.reservation.hasProprietaire() &&
        ctrl.reservation.hasLocataire() &&
        ctrl.reservation.hasDate() &&
        ctrl.reservation.loyer;

      if (ctrl.encaissements.edited) {
        var sommeProprio = 0,
          sommeLocataire = 0;
        ctrl.encaissements.list.forEach(function (encaissement) {
          if (!encaissement.sortant) {
            sommeProprio += encaissement.valeur;
          } else {
            sommeLocataire += encaissement.valeur;
          }
        });

        var alerteSuppProprio = sommeProprio > ctrl.reservation.honoProprietaire,
          alerteInfProprio = sommeProprio < ctrl.reservation.honoProprietaire,
          diffProprio = CustomUtils.number.scaleTo(Math.abs(ctrl.reservation.honoProprietaire - sommeProprio)),
          alerteSuppLocataire = sommeLocataire > ctrl.reservation.honoLocataire,
          alerteInfLocataire = sommeLocataire < ctrl.reservation.honoLocataire,
          diffLocataire = CustomUtils.number.scaleTo(Math.abs(ctrl.reservation.honoLocataire - sommeLocataire));

        if (alerteSuppProprio || alerteInfProprio || alerteSuppLocataire || alerteInfLocataire) {
          var titre = 'Ajustement des honoraires',
            message = '';

          if (alerteSuppProprio || alerteInfProprio) {
            titre += ' Propriétaire';
            message +=
              '<span>La somme des encaissements affectés au propriétaire est ' +
              (alerteSuppProprio ? 'supérieure ' : 'inférieure ') +
              'de ' +
              diffProprio +
              '€ par rapport au montant des honoraires propriétaire.';

            if (alerteSuppLocataire || alerteInfLocataire) {
              titre += ' et';
              message += '<br><br>';
            } else {
              titre += ' ?';
            }
          }
          if (alerteSuppLocataire || alerteInfLocataire) {
            titre += ' Locataire ?';
            message +=
              '<span>La somme des encaissements affectés au locataire est ' +
              (alerteSuppLocataire ? 'supérieure ' : 'inférieure ') +
              'de ' +
              diffLocataire +
              '€ par rapport au montant des honoraires locataire.';
          }

          message += '<br><br>Les honoraires vont être ajustés pour correspondre à la somme des encaissements.';

          var confirmDialog = ngDialog.openConfirm({
            templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
            controller: 'ConfirmDialogController',
            controllerAs: 'confirmdialogctrl',
            resolve: {
              titre: function titreFactory() {
                return titre;
              },
              message: function messageFactory() {
                return message;
              },
              commentaire: function commentaireFactory() {
                return false;
              },
              confirmText: function confirmTextFactory() {
                return 'Confirmer';
              },
              annulerText: function annulerTextFactory() {
                return 'Annuler';
              }
            }
          });

          confirmDialog.then(function (data) {
            if (data.status === 'OK') {
              ctrl.reservation.honoProprietaire = sommeProprio;
              ctrl.reservation.honoLocataire = sommeLocataire;
              deferred.resolve({
                status: 'CONFIRMED',
                validation: validation
              });
            } else {
              deferred.resolve({
                status: 'CANCELED'
              });
            }
          });
        }
      } else {
        deferred.resolve({
          status: 'CONFIRMED',
          validation: validation
        });
      }
      return deferred.promise;
    }

    function imprimerReservation() {
      var params = {
        locationid: ctrl.reservation.id,
        lotsid: ctrl.reservation.affaire.id
      };
      if (ctrl.reservation.hasLocataire()) {
        params.prospectsid = ctrl.reservation.locataire.id;
      }
      ImpressionService.openImpression(params);
    }

    function saveReservation(callback) {
      checkValidation().then(function (retour) {
        if (retour.status === 'CONFIRMED' && retour.validation) {
          ctrl.loading = true;

          if (
            ctrl.reservation.hasColocataire() &&
            ((ctrl.reservation.colocataire.isModel && !ctrl.reservation.colocataire.hasNom()) ||
              (!ctrl.reservation.colocataire.isModel &&
                (ctrl.reservation.colocataire.nom == null || ctrl.reservation.colocataire.nom == '')))
          ) {
            delete ctrl.reservation.colocataire;
          }

          ContratsService.reservations
            .editer({
              xmlLocation: ctrl.reservation.toJson(),
              typeMethode: 'complete',
              typeApplication: globalService.getTypeApplication()
            })
            .then(
              function (retour) {
                if (retour.status === 'OK') {
                  ctrl.reservation = retour.reservation;

                  if (ctrl.reservation.hasDateEffectiveVente()) {
                    ctrl.titre = 'LOCATION';
                    $rootScope.typeContrat = 'location';
                  } else {
                    ctrl.titre = 'RÉSERVATION';
                    $rootScope.typeContrat = 'reservation';
                  }

                  ctrl.reservation.colocataire = ctrl.reservation.colocataire || new Perso();

                  genererGravitants();
                  getRemisesList();
                  setVerrouillages();

                  ctrl.form.$setPristine(true);
                }
                ctrl.loading = false;
                toastr.success('Les modifications ont été enregistrées avec succes.', 'Enregistrement terminé');
              },
              function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    toastr.error(
                      "Une erreur s'est produite lors de la sauvegarde.<br>Veuillez réessayer utlérieurement.",
                      'Erreur sauvegarde reservation (code erreur : <i>MOD-LOC-667</i>)', {
                        timeOut: 8000
                      }
                    );
                  }
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            )
            .finally(function () {
              if (angular.isFunction(callback)) {
                callback();
              }
            });
        } else {
          if (retour.status === 'CONFIRMED') {
            toastr.error("Veuillez renseigner l'ensemble des champs requis.", 'Saisie incomplète');
          } else {
            toastr.warning(
              "L'enregistrement à été annulé, veuillez rectifier les encaissements puis enregistrer à nouveau.",
              'Enregistrement annulé'
            );
          }
        }
      });
    }

    function supprimerReservation() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer cette location ?</span>';
          },
          commentaire: function commentaireFactory() {
            return true;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK' && data.deleteRaison) {
          ctrl.loading = true;
          ContratsService.reservations
            .supprimer({
              deleteId: ctrl.reservation.id,
              deleteRaison: data.deleteRaison
            })
            .then(
              function (retour) {
                if (retour.status === 'OK') {
                  ctrl.reservation = retour.reservation;
                  ctrl.forceExit = true;
                  $state.go('contrat', {
                    type: 'reservation'
                  });
                }
                ctrl.loading = false;
              },
              function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    toastr.error(
                      "Une erreur s'est produite lors de la suppression.<br>Veuillez réessayer utlérieurement.",
                      'Erreur suppression reservation (code erreur : <i>MOD-LOC-733</i>)', {
                        timeOut: 8000
                      }
                    );
                  }
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            );
        }
      });
    }

    function goBack() {
      if (ctrl.reservation.hasDateEffectiveVente()) $state.go('contrat', {
        type: 'location'
      });
      else $state.go('contrat', {
        type: 'reservation'
      });
    }

    function openAffaire() {
      var url = $state.href('modifBien', {
        reference: ctrl.reservation.affaire.referenceInterne,
        typeApplication: 'Location'
      });
      $window.open(url, '_blank');
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('modifProspect', {
    templateUrl: 'app/components/main-content/modif-prospect/modif-prospect.html',
    controllerAs: 'modifprospectctrl',
    controller: ModifProspectController
  });

  /** @ngInject */
  function ModifProspectController(
    CONSTANTS,
    ProspectsService,
    globalService,

    ImpressionService,
    $stateParams,
    CriteresParser,
    Prospect,
    Perso,
    toastr,
    ngDialog,
    $uibModal,
    $state,
    $rootScope,
    $window,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.prospect = null;

    ctrl.forceExit = false;

    ctrl.prospectLoading = false;

    ctrl.loading = false;

    ctrl.timeline = {
      current: 1,
      etapes: {
        titre: 'SAISIE DU PROSPECT',
        titre2: '',
        completed: false,
        etapes: [{
            id: 1,
            libelle: 'Prospect',
            icone: 'fa-user',
            visited: false,
            completed: true,
            rFields: {
              typePerso: {
                label: 'Type',
                completed: false
              },
              nom: {
                label: 'Nom',
                completed: false
              },
              prenom: {
                label: 'Prénom',
                completed: false
              },
              contact: {
                label: 'Téléphone',
                completed: true
              }
            }
          },
          {
            id: 2,
            libelle: 'Critères',
            icone: 'fa-search',
            visited: false,
            completed: true,
            rFields: {
              typeBien: {
                label: 'Type de bien',
                completed: false
              },
              prix: {
                label: 'Prix min et/ou max',
                completed: false
              }
            }
          },
          {
            id: 3,
            libelle: 'État',
            icone: 'fa-id-card-o',
            visited: false,
            completed: true,
            rFields: {
              origine: {
                label: 'Origine',
                completed: false
              },
              nego: {
                label: 'Négo',
                completed: false
              }
            }
          },
          {
            id: 4,
            libelle: 'Panier',
            icone: 'fa-shopping-cart',
            visited: false,
            completed: true,
            rFields: false
          },
          {
            id: 5,
            libelle: 'Communication',
            icone: 'fa-comments',
            visited: false,
            completed: true,
            rFields: false
          }
        ]
      },
      prev: etapePrecedente,
      next: etapeSuivante,
      onChange: onChangeEtape,
      checkEtapes: checkEtapes
    };

    ctrl.save = save;
    ctrl.goBack = goBack;
    ctrl.supprimer = supprimerProspect;
    ctrl.plusDeBiens = plusDeBiens;
    ctrl.imprimer = imprimer;
    ctrl.envoyerEmail = envoyerEmail;

    $scope.$watch(
      function () {
        return ctrl.prospect;
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal && newVal.isModel) {
          setEtapesCompleted();
        }
      },
      true
    );

    ctrl.$onInit = function () {
      if ($stateParams.typeApplication && $stateParams.typeApplication !== globalService.getTypeApplication()) {
        globalService.setTypeApplication($stateParams.typeApplication, true, false);
      } else if ($stateParams.reference) {
        ctrl.prospectLoading = true;
        ctrl.loading = true;

        if ($stateParams.etape) {
          ctrl.timeline.current = Number($stateParams.etape);
        }

        if (ctrl.citya) {
          ctrl.timeline.etapes.etapes[0].rFields.contact.completed = false;
        }

        ProspectsService.getListe({
          search: {
            reference: $stateParams.reference
          },
          typeMethode: 'complete'
        }).then(
          function (retour) {
            if (retour.status === 'OK') {
              if (retour.nb) {
                ctrl.prospect = retour.prospects[0];

                ctrl.prospectLoading = true;

                if (!ctrl.prospect.hasPerso()) {
                  ctrl.prospect.setPerso(new Perso());
                }

                if (!ctrl.prospect.perso.hasType()) {
                  ctrl.prospect.perso.physique = true;
                  ctrl.prospect.peros.type = 'PersoPhysique';
                }

                if (!ctrl.prospect.perso.hasNom() && $stateParams.nom) ctrl.prospect.perso.nom = $stateParams.nom;
                if (!ctrl.prospect.perso.hasPrenom() && $stateParams.prenom)
                  ctrl.prospect.perso.prenom = $stateParams.prenom;
                if (!ctrl.prospect.perso.hasDateNaissance() && $stateParams.dateNaissance)
                  ctrl.prospect.perso.dateNaissance = $stateParams.dateNaissance;
                if (!ctrl.prospect.perso.adresses[0].hasCp() && $stateParams.cp)
                  ctrl.prospect.perso.adresses[0].cp = $stateParams.cp;
                if ($stateParams.email) ctrl.prospect.perso.addContact('Email', $stateParams.email);
                if ($stateParams.tel)
                  ctrl.prospect.perso.addContact(
                    $stateParams.tel.startsWith('06') || $stateParams.tel.startsWith('07') ? 'TelMobile' : 'Telephone',
                    $stateParams.tel
                  );

                ctrl.timeline.etapes.titre2 = ctrl.prospect.perso.getNomComplet();

                setEtapesCompleted();
                ctrl.loading = false;

                if (globalService.getStorageItem('SEARCH-TO-PROSPECT')) {
                  var criteresProspect = globalService.getStorageItem('SEARCH-TO-PROSPECT');

                  if (criteresProspect.prixMin !== null) ctrl.prospect.prixMin = criteresProspect.prixMin;
                  if (criteresProspect.prixMax !== null) ctrl.prospect.prixMax = criteresProspect.prixMax;
                  if (criteresProspect.typesBien !== null) ctrl.prospect.typesBien = criteresProspect.typesBien;
                  if (criteresProspect.villes !== null) ctrl.prospect.villes = criteresProspect.villes;
                  if (criteresProspect.criteres !== null) ctrl.prospect.criteres = criteresProspect.criteres;

                  globalService.setStorageItem('SEARCH-TO-PROSPECT', null);

                  if (checkEtapes()) {
                    ctrl.save();
                  }
                }
              } else {
                $state.go('listeProspects');
              }
            } else {
              $state.go('listeProspects');
            }
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.prospectLoading = true;
            ctrl.loading = false;
          }
        );
      } else {
        toastr.error(
          'Une erreur s&apos;est produite lors de la r&eacute;cup&eacute;ration du prospect.<br>' +
          'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
          'Si le probl&egrave;me persiste, contactez la hotline.',
          'Erreur r&eacute;cup&eacute;ration du bien (code erreur : MODP-189)', {
            timeout: 8000
          }
        );
      }
    };

    $scope.$on('$stateChangeStart', preventExit);
    $window.onbeforeunload = function () {
      if (!ctrl.form.$pristine) {
        return 'Les modifications que vous avez apportées ne seront pas enregistrées';
      }
    };

    function preventExit(event, toState, toParams) {
      if (!ctrl.form.$pristine && !ctrl.forceExit) {
        event.preventDefault();

        var confirmDialog = ngDialog.openConfirm({
          templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
          controller: 'ConfirmDialogController',
          controllerAs: 'confirmdialogctrl',
          resolve: {
            titre: function titreFactory() {
              return 'Voulez-vous quitter la saisie ?';
            },
            message: function messageFactory() {
              return '<span><i class="fa fa-2r fa-exclamation-triangle text-danger"></i> Les modifications que vous avez apport&eacute;es ne seront pas enregistr&eacute;es</span>';
            },
            commentaire: function commentaireFactory() {
              return false;
            },
            confirmText: function confirmTextFactory() {
              return 'Quitter';
            },
            annulerText: function annulerTextFactory() {
              return false;
            }
          }
        });

        confirmDialog.then(function (data) {
          if (data.status === 'OK') {
            ctrl.forceExit = true;
            $state.go(toState, toParams);
          }
        });
      }
    }

    function setEtapesCompleted() {
      ctrl.timeline.etapes.completed = true;

      angular.forEach(ctrl.timeline.etapes.etapes, function (etape) {
        switch (etape.id) {
          case 1:
            etape.rFields.typePerso.completed = ctrl.prospect.perso.hasType();
            etape.rFields.nom.completed = ctrl.prospect.perso.hasNom();
            etape.rFields.prenom.completed = ctrl.prospect.perso.physique ? ctrl.prospect.perso.hasPrenom() : true;
            etape.rFields.contact.completed = !ctrl.citya || (ctrl.citya && (ctrl.prospect.perso.getTelMobile() || ctrl.prospect.perso.getTel()));

            etape.completed =
              etape.rFields.typePerso.completed &&
              etape.rFields.nom.completed &&
              etape.rFields.prenom.completed &&
              etape.rFields.contact.completed;
            break;

          case 2:
            etape.rFields.typeBien.completed = ctrl.prospect.hasTypesBien();
            etape.rFields.prix.completed = ctrl.prospect.hasPrixMin() || ctrl.prospect.hasPrixMax();

            etape.completed = etape.rFields.typeBien.completed && etape.rFields.prix.completed;
            break;

          case 3:
            etape.rFields.origine.completed = !ctrl.citya || (ctrl.citya && ctrl.prospect.hasOrigine());
            etape.rFields.nego.completed = ctrl.prospect.nego && ctrl.prospect.nego.id;

            etape.completed = etape.rFields.origine.completed && etape.rFields.nego.completed;
            break;
        }

        if (!etape.completed) {
          ctrl.timeline.etapes.completed = false;
        }
      });
    }

    function etapePrecedente() {
      if (ctrl.timeline.current > 1) onChangeEtape(ctrl.timeline.current - 1);
    }

    function etapeSuivante() {
      if (ctrl.timeline.current < ctrl.timeline.etapes.etapes.length) onChangeEtape(ctrl.timeline.current + 1);
    }

    function onChangeEtape(id) {
      setEtapesCompleted();
      ctrl.timeline.etapes.etapes[ctrl.timeline.current - 1].visited = true;
      ctrl.timeline.current = id;
      $state.go(
        'modifProspect', {
          reference: $stateParams.reference,
          recherche: $stateParams.recherche,
          typeApplication: globalService.getTypeApplication(),
          etape: ctrl.timeline.current
        }, {
          notify: false
        }
      );
    }

    function checkEtapes() {
      setEtapesCompleted();
      return ctrl.timeline.etapes.completed;
    }

    function save() {
      if (checkEtapes()) {
        ctrl.loading = true;

        ProspectsService.editerProspect({
          xmlProspect: ctrl.prospect.toJson(),
          typeMethode: 'complete',
          typeApplication: globalService.getTypeApplication()
        }).then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.prospect = retour.prospect;
              $rootScope.$emit('prospectPanierChange', {
                prospect: ctrl.prospect
              });

              ctrl.form.$setPristine(true);
            }
            ctrl.loading = false;
            toastr.success('Les modifications ont été enregistrées avec succes.', 'Enregistrement terminé');
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  'Une erreur s&apos;est produite lors de la sauvegarde.<br>' +
                  'Veuillez r&eacute;essayer utl&eacute;rieurement.<br><br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                  'Erreur sauvegarde prospect (code erreur : <i>MOD-PRP-322</i>)', {
                    tiemout: 8000
                  }
                );
              }
            } else $log.error(error.status);
            ctrl.loading = false;
          }
        );
      } else {
        toastr.error('Veuillez renseigner l&apos;ensemble des champs requis.', 'Saisie incomplète');
      }
    }

    function supprimerProspect() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer ce prospect ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          ctrl.loading = true;
          ProspectsService.supprimerProspect({
            deleteRef: ctrl.prospect.referenceInterne
          }).then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.prospect = retour.prospect;
                ctrl.forceExit = true;
                $state.go('listeProspects');
              }
              ctrl.loading = false;
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED') {
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  toastr.error(
                    'Une erreur s&apos;est produite lors de la suppression.<br>' +
                    'Veuillez r&eacute;essayer utl&eacute;rieurement.<br><br>' +
                    'Si le probl&egrave;me persiste, contactez la hotline.',

                    'Erreur suppression prospect (code erreur : <i>MODP-385</i>)', {
                      timeOut: 8000
                    }
                  );
                }
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
        }
      });
    }

    function plusDeBiens() {
      $rootScope.$emit('prospectPanierChange', {
        prospect: ctrl.prospect
      });

      var query = globalService.getStorageItem('QUERY-LISTE-BIEN') || {
        search: null
      };

      query.search = CriteresParser.prospectToSearch(ctrl.prospect);

      globalService.setStorageItem('QUERY-LISTE-BIEN', query);
      $state.go('listeBien');
    }

    function imprimer() {
      ImpressionService.openImpression({
        prospectsid: ctrl.prospect.id
      });
    }

    function envoyerEmail() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/formcontact/modal.formcontact.html',
        controller: 'ModalFormContactController',
        controllerAs: 'modalformcontactctrl',
        resolve: {
          message: function () {
            return {
              destinataire: ctrl.prospect.perso.getEmail(),
              prospects: ctrl.prospect.referenceInterne
            };
          }
        }
      });

      modalInstance.result.then(function () {
        ctrl.open = true;
      });
    }

    function goBack() {
      $state.go('listeProspect');
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('modifCompromis', {
    templateUrl: 'app/components/main-content/modif-compromis/modif-compromis.html',
    controllerAs: 'modifcompromisctrl',
    controller: ModifCompromisController
  });

  /** @ngInject */
  function ModifCompromisController(
    CONSTANTS,
    globalService,
   
    ContratsService,
    ImpressionService,
    Perso,
    $rootScope,
    $stateParams,
    toastr,
    moment,
    $window,
    $state,
    ngDialog,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.titre = 'COMPROMIS';

    ctrl.compromis = null;

    ctrl.forceExit = false;

    ctrl.loading = false;

    ctrl.employe = globalService.getEmploye();

    ctrl.prixVenteNet = 0;
    ctrl.tauxCommInv = 0;
    ctrl.commission = 0;
    ctrl.commissionHT = 0;
    ctrl.baseCommission = 0;
    ctrl.tauxMax = ctrl.employe.profileTrans.tauxRemiseTransaction;

    ctrl.verrouillage = false;

    ctrl.datepickers = {
      datePrevueVente: false,
      dateEffectiveVente: false,
      dateLimite: false,
      date: false,
      dateEncaissement: false,
      dateHorsSru: false,
      onClose: onCloseDatepicker
    };

    ctrl.remises = {
      list: [],
      tri: 'date',
      ordre: false,
      toggleTri: toggleRemisesTri,
      getList: getRemisesList
    };

    ctrl.negoSuppOpen = ctrl.citya;

    ctrl.goBack = goBack;
    ctrl.setAcheteur = setAcheteur;
    ctrl.openAffaire = openAffaire;
    ctrl.imprimer = imprimerCompromis;
    ctrl.save = saveCompromis;
    ctrl.supprimer = supprimerCompromis;
    ctrl.calculCommission = calculCommission;

    ctrl.$onInit = function() {
      if ($stateParams.reference) {
        ctrl.loading = true;

        ContratsService.compromis
          .getList({
            idVente: $stateParams.reference,
            typeMethode: 'complete'
          })
          .then(
            function(retour) {
              if (retour.status === 'OK') {
                ctrl.compromis = retour.compromis;

                if (ctrl.compromis.hasDateEffectiveVente()) {
                  ctrl.titre = 'VENTE';
                  $rootScope.typeContrat = 'vente';
                } else {
                  $rootScope.typeContrat = 'compromis';
                }

                ctrl.compromis.notaireVendeur = ctrl.compromis.notaireVendeur || {};
                ctrl.compromis.notaireVendeur.perso =
                  ctrl.compromis.notaireVendeur.perso ||
                  new Perso({
                    physique: true,
                    type: 'PersoPhysique',
                    adresses: [
                      {
                        immeuble: '',
                        rue: '',
                        complement: '',
                        cp: '',
                        ville: ''
                      }
                    ],
                    contacts: []
                  });

                ctrl.compromis.notaireAcheteur = ctrl.compromis.notaireAcheteur || {};
                ctrl.compromis.notaireAcheteur.perso =
                  ctrl.compromis.notaireAcheteur.perso ||
                  new Perso({
                    physique: true,
                    type: 'PersoPhysique',
                    adresses: [
                      {
                        immeuble: '',
                        rue: '',
                        complement: '',
                        cp: '',
                        ville: ''
                      }
                    ],
                    contacts: []
                  });
                
                ctrl.compromis.honoChargeVendeur =
                  ctrl.compromis.honoChargeVendeur || ctrl.compromis.affaire.mandatTransaction.honoChargeVendeur || 0;
                ctrl.compromis.honoChargeAquereur =
                  ctrl.compromis.honoChargeAquereur || ctrl.compromis.affaire.mandatTransaction.honoChargeAquereur || 0;

                setCompromisDates();
                calculCommission('init');
                getRemisesList();
                setVerouillage();

                ctrl.loading = false;
              } else {
                $state.go('compromis');
              }
            },
            function(error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
      } else {
        $state.go('compromis');
      }
    };

    $scope.$on('$stateChangeStart', preventExit);
    $window.onbeforeunload = function() {
      if (!ctrl.form.$pristine) {
        return 'Les modifications que vous avez apportées ne seront pas enregistrées';
      }
    };

    function preventExit(event, toState, toParams) {
      if (!ctrl.form.$pristine && !ctrl.forceExit) {
        event.preventDefault();

        var confirmDialog = ngDialog.openConfirm({
          templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
          controller: 'ConfirmDialogController',
          controllerAs: 'confirmdialogctrl',
          resolve: {
            titre: function titreFactory() {
              return 'Voulez-vous quitter la saisie ?';
            },
            message: function messageFactory() {
              return '<span><i class="fa fa-2r fa-exclamation-triangle text-danger"></i> Les modifications que vous avez apport&eacute;es ne seront pas enregistr&eacute;es</span>';
            },
            commentaire: function commentaireFactory() {
              return false;
            },
            confirmText: function confirmTextFactory() {
              return 'Quitter';
            },
            annulerText: function annulerTextFactory() {
              return false;
            }
          }
        });

        confirmDialog.then(function(data) {
          if (data.status === 'OK') {
            ctrl.forceExit = true;
            $state.go(toState, toParams);
          }
        });
      }
    }

    function setAcheteur(prospect) {
      ctrl.compromis.acheteur = prospect;
    }

    function setCompromisDates() {
      if (!ctrl.compromis.dateRedaction) {
        ctrl.compromis.dateRedaction = moment().format(CONSTANTS.date_format);
      }

      if (!ctrl.compromis.date) {
        ctrl.compromis.date = ctrl.compromis.dateRedaction;
      }

      if (!ctrl.compromis.dateLimite) {
        ctrl.compromis.dateLimite = '';
      }

      if (!ctrl.compromis.datePrevueVente) {
        ctrl.compromis.datePrevueVente = '';
      }

      if (!ctrl.compromis.dateEffectiveVente) {
        ctrl.compromis.dateEffectiveVente = '';
      }

      if (!ctrl.compromis.dateEncaissement) {
        ctrl.compromis.dateEncaissement = '';
      }

      if (!ctrl.compromis.dateHorsSru) {
        ctrl.compromis.dateHorsSru = '';
      }
    }

    function setVerouillage() {
      ctrl.verrouillage =
        ctrl.citya &&
        ctrl.compromis.hasDateEncaissement() &&
        moment(ctrl.compromis.dateEncaissement, CONSTANTS.date_format).isBefore(moment());
    }

    function onCloseDatepicker(datepicker) {
      ctrl.datepickers[datepicker] = false;
    }

    function checkValidation() {
      return checkParts() && (
        ctrl.compromis.hasVendeur() &&
        ctrl.compromis.hasAcheteur() &&
        ctrl.compromis.hasDate() &&
        ((ctrl.citya && ctrl.compromis.hasDatePrevueVente()) || !ctrl.citya) &&
        ctrl.compromis.getPrixVente() &&
        ctrl.compromis.getTauxComm()
      );
    }

    function checkParts() {
      var sum = 0;
      sum += ctrl.compromis.partAffaire ? ctrl.compromis.partAffaire : 0;
      sum += ctrl.compromis.partAcheteur ? ctrl.compromis.partAcheteur : 0;
      for (var i = 1; i <= 3; i++) {
        sum += ctrl.compromis['partSupp' + i] ? ctrl.compromis['partSupp' + i] : 0;
        sum += ctrl.compromis['partExt' + i] ? ctrl.compromis['partExt' + i] : 0;
      }
      sum = Math.round(sum * 100) / 100;
      if (sum !== 1) {
        toastr.warning(
          'La somme des parts attribués aux négociateurs n\'est pas égale à 1.',
          'Mauvaise répartition des parts',
          { timeOut: 10000 }
        );
        return false;
      } else {
        return true;
      }
    }

    function calculCommission(origin) {
      switch (origin) {
        case 'prixVente':
          if (ctrl.compromis.affaire.mandatTransaction.prixVente) {
            ctrl.commissionHT = getCommHT(true);
            ctrl.commission = getComm();
            ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
            ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          }
          break;

        case 'prixVenteNet':
          if (ctrl.prixVenteNet) {
            ctrl.commission = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.prixVenteNet;
            ctrl.commissionHT = getCommHT(false, true);
            ctrl.compromis.affaire.mandatTransaction.tauxComm = getTauxComm();
            ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          }
          break;

        case 'tauxComm':
          if (ctrl.compromis.affaire.mandatTransaction.tauxComm) {
            ctrl.commissionHT = getCommHT(true);
            ctrl.commission = getComm();
            ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
            ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          }
          break;

        case 'tauxCommInv':
          if (ctrl.tauxCommInv) {
            ctrl.commission = ctrl.tauxCommInv / 100 * ctrl.prixVenteNet;
            ctrl.commissionHT = getCommHT(false, true);
            ctrl.compromis.affaire.mandatTransaction.prixVente = ctrl.prixVenteNet + ctrl.commission;
            ctrl.compromis.affaire.mandatTransaction.tauxComm = getTauxComm();
          }
          break;

        case 'commissionHT':
          if (ctrl.commissionHT) {
            ctrl.commission = getComm();
            ctrl.compromis.affaire.mandatTransaction.tauxComm = getTauxComm();
            ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
            ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          }
          break;

        case 'commission':
          if (ctrl.commission) {
            ctrl.commissionHT = getCommHT();
            ctrl.compromis.affaire.mandatTransaction.tauxComm = getTauxComm();
            ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
            ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          }
          break;

        case 'tva':
          ctrl.compromis.tva = angular.isNumber(ctrl.compromis.tva)
            ? parseFloat(ctrl.compromis.tva)
            : ctrl.compromis.tva;
          ctrl.commission = getComm();
          ctrl.compromis.affaire.mandatTransaction.tauxComm = getTauxComm();
          ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
          ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          break;

        case 'init':
          ctrl.compromis.affaire.mandatTransaction.prixVente =
            ctrl.compromis.affaire.mandatTransaction.prixVente ||
            ctrl.compromis.affaire.mandatTransaction.affaire.mandatTransaction.prixVente ||
            0;
          ctrl.compromis.tva = ctrl.compromis.tva ||  ctrl.employe.societe.tva || ctrl.employe.societe.agence.tva || 20;
          ctrl.compromis.affaire.mandatTransaction.tauxComm =
            ctrl.compromis.affaire.mandatTransaction.tauxComm || getTauxComm();
          ctrl.commissionHT = getCommHT();
          ctrl.commission = getComm();
          ctrl.prixVenteNet = ctrl.compromis.affaire.mandatTransaction.prixVente - ctrl.commission;
          ctrl.tauxCommInv = ctrl.commission / ctrl.prixVenteNet * 100;
          break;
      }

      /* if (origin === 'init') {
        ctrl.baseCommission = ctrl.lastCommission = getComm();
      } else {
        if (ctrl.tauxMax < 100 && ctrl.commission < ctrl.baseCommission) {
          var tauxRemise = ((ctrl.baseCommission - ctrl.commission) / ctrl.baseCommission) * 100;
          if (tauxRemise > ctrl.tauxMax) {
            toastr.warning('Vous essayez d&apos;appliquer une remise de ' + (Math.round(tauxRemise * 100) / 100) + '%.<br>Le taux de remise maximum est de <strong>' + ctrl.tauxMax + '%</strong>.',
              'Seuil de remise maximum d&eacute;pass&eacute;.',
              {timeOut: 10000});
            ctrl.commission = ctrl.lastCommission || ctrl.baseCommission;
            return calculCommission('commission');
          } else {
            ctrl.lastCommission = ctrl.commission;
          }
        } else {
          ctrl.lastCommission = ctrl.commission;
        }
      } */
    }

    function getTauxComm(noComm, noCommHT) {
      noComm = angular.isDefined(noComm) ? noComm : false;
      noCommHT = angular.isDefined(noCommHT) ? noCommHT : false;
      if (ctrl.compromis.affaire.mandatTransaction.prixVente) {
        if (ctrl.commission && !noComm)
          return ctrl.commission / ctrl.compromis.affaire.mandatTransaction.prixVente * 100;
        else if (ctrl.commissionHT && !noCommHT)
          return (
            ctrl.commissionHT /
            ((100 - ctrl.compromis.tva) / 100) /
            ctrl.compromis.affaire.mandatTransaction.prixVente *
            100
          );
        else return 0;
      } else return 0;
    }

    function getCommHT(noComm, noTauxComm) {
      noComm = angular.isDefined(noComm) ? noComm : false;
      noTauxComm = angular.isDefined(noTauxComm) ? noTauxComm : false;
      if (ctrl.commission && !noComm) return ctrl.commission / ((100 + ctrl.compromis.tva) / 100);
      else if (
        ctrl.compromis.affaire.mandatTransaction.prixVente &&
        ctrl.compromis.affaire.mandatTransaction.tauxComm &&
        !noTauxComm
      )
        return (
          ctrl.compromis.affaire.mandatTransaction.prixVente *
          (ctrl.compromis.affaire.mandatTransaction.tauxComm / 100) /
          ((100 + ctrl.compromis.tva) / 100)
        );
      else if (ctrl.compromis.affaire.mandatTransaction.prixVente && ctrl.compromis.affaire.mandatTransaction.tauxComm)
        return (
          ctrl.compromis.affaire.mandatTransaction.prixVente *
          (ctrl.compromis.affaire.mandatTransaction.tauxComm / 100) /
          ((100 + ctrl.compromis.tva) / 100)
        );
      else return 0;
    }

    function getComm(noCommHT, noTauxComm) {
      noCommHT = angular.isDefined(noCommHT) ? noCommHT : false;
      noTauxComm = angular.isDefined(noTauxComm) ? noTauxComm : false;
      if (ctrl.commissionHT && !noCommHT) {
        return ctrl.commissionHT * ((100 + ctrl.compromis.tva) / 100);
      } else if (
        ctrl.compromis.affaire.mandatTransaction.prixVente &&
        ctrl.compromis.affaire.mandatTransaction.tauxComm &&
        !noTauxComm
      ) {
        return (
          ctrl.compromis.affaire.mandatTransaction.prixVente * (ctrl.compromis.affaire.mandatTransaction.tauxComm / 100)
        );
      } else return 0;
    }

    function checkHonoAcquereurVendeur() {
      ctrl.compromis.honoChargeVendeur =
        ctrl.compromis.honoChargeVendeur || ctrl.compromis.affaire.mandatTransaction.honoChargeVendeur || 0;
      ctrl.compromis.honoChargeAquereur =
        ctrl.compromis.honoChargeAquereur || ctrl.compromis.affaire.mandatTransaction.honoChargeAquereur || 0;
      var diff =
        Math.round(ctrl.commission * 100) / 100 -
        (ctrl.compromis.honoChargeVendeur + ctrl.compromis.honoChargeAquereur);
      if (diff < 0) {
        toastr.warning(
          'La somme des Hono. Acheteur / Vendeur ne doit pas d&eacute;passer le montant de commission TTC.',
          'D&eacute;passement Hono. Acheteur / Vendeur',
          { timeOut: 10000 }
        );
      } else if (diff > 0) {
        toastr.warning(
          'La somme des Hono. Acheteur / Vendeur est inf&eacute;rieure au montant de commission TTC.',
          'Carence Hono. Acheteur / Vendeur',
          { timeOut: 10000 }
        );
      }
    }

    function toggleRemisesTri(tri) {
      if (ctrl.remises.tri === tri) {
        ctrl.remises.ordre = !ctrl.remises.ordre;
      } else {
        ctrl.remises.tri = tri;
      }
    }

    function getRemisesList() {
      ctrl.loading = true;

      ContratsService.getRemisesList({
        idReference: ctrl.compromis.id,
        location: false,
        typeMethode: 'short'
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.remises.list = retour.remises;

            if (ctrl.remises.list.length) {
              var date = moment(new Date());
              angular.forEach(ctrl.remises.list, function(remise) {
                var current = moment(remise.dateRemise, CONSTANTS.date_format);
                if (current.isBefore(date)) {
                  date = current;
                  ctrl.baseCommission = remise.prixDepart;
                }
              });
            }
          }
          ctrl.loading = false;
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.loading = false;
        }
      );
    }

    function imprimerCompromis() {
      var params = {
        compromisid: ctrl.compromis.id,
        lotsid: ctrl.compromis.affaire.id
      };
      if (ctrl.compromis.hasAcheteur()) {
        params.prospectsid = ctrl.compromis.acheteur.id;
      }
      ImpressionService.openImpression(params);
    }

    function saveCompromis() {
      if (checkValidation()) {
        ctrl.loading = true;

        checkHonoAcquereurVendeur();

        ContratsService.compromis
          .editer({
            xmlCompromis: ctrl.compromis.toJson(),
            typeMethode: 'complete',
            typeApplication: globalService.getTypeApplication()
          })
          .then(
            function(retour) {
              if (retour.status === 'OK') {
                ctrl.compromis = retour.compromis;

                if (ctrl.compromis.hasDateEffectiveVente()) {
                  ctrl.titre = 'VENTE';
                  $rootScope.typeContrat = 'vente';
                } else {
                  ctrl.titre = 'COMPROMIS';
                  $rootScope.typeContrat = 'compromis';
                }

                setCompromisDates();
                getRemisesList();
                setVerouillage();

                ctrl.form.$setPristine(true);
              }
              ctrl.loading = false;
              toastr.success('Les modifications ont été enregistrées avec succes.', 'Enregistrement terminé');
            },
            function(error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED') {
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  toastr.error(
                    'Une erreur s&apos;est produite lors de la sauvegarde du compromis.<br>' +
                      'Veuillez r&eacute;essayer utl&eacute;rieurement.<br>' +
                      '<br>' +
                      'Si le probl&egrave;me persiste, contactez la hotline.',

                    'Erreur sauvegarde compromis (code erreur : <i>MOD-CMP-441</i>)',
                    { timeout: 8000 }
                  );
                }
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
      } else {
        toastr.error("Veuillez renseigner l'ensemble des champs requis.", 'Saisie incomplète');
      }
    }

    function supprimerCompromis() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer ce compromis ?</span>';
          },
          commentaire: function commentaireFactory() {
            return true;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function(data) {
        if (data.status === 'OK' && data.deleteRaison) {
          ctrl.loading = true;
          ContratsService.compromis
            .supprimer({
              deleteId: ctrl.compromis.id,
              deleteRaison: data.deleteRaison
            })
            .then(
              function(retour) {
                if (retour.status === 'OK') {
                  ctrl.compromis = retour.compromis;
                  ctrl.forceExit = true;
                  $state.go('contrat', { type: 'compromis' });
                }
                ctrl.loading = false;
              },
              function(error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED') {
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                    toastr.error(
                      'Une erreur s&apos;est produite lors de la suppression.<br>' +
                        'Veuillez r&eacute;essayer utl&eacute;rieurement.<br><br>' +
                        'Si le probl&egrave;me persiste, contactez la hotline.',
                      'Erreur suppression compromis (code erreur : <i>MOD-CMP-503</i>)',

                      { timeOut: 8000 }
                    );
                  }
                } else $log.error(error.status);
                ctrl.loading = false;
              }
            );
        }
      });
    }

    function goBack() {
      if (ctrl.compromis.hasDateEffectiveVente()) $state.go('contrat', { type: 'vente' });
      else $state.go('contrat', { type: 'compromis' });
    }

    function openAffaire() {
      var url = $state.href('modifBien', {
        reference: ctrl.compromis.affaire.referenceInterne,
        typeApplication: 'Transaction'
      });
      $window.open(url, '_blank');
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('modifBien', {
    templateUrl: 'app/components/main-content/modif-bien/modif-bien.html',
    controllerAs: 'modifbienctrl',
    controller: ModifBienController
  });

  /** @ngInject */
  function ModifBienController(
    CONSTANTS,
    globalService,
    PropertiesService,
    RepertoireService,
    ImpressionService,
    MailService,
    CustomUtils,
    CriteresParser,
    Prospect,
    Perso,
    Adresse,
    $rootScope,
    $stateParams,
    toastr,
    ngDialog,
    $uibModal,
    $state,
    $window,
    $scope,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.refLot = null;
    ctrl.lot = null;
    ctrl.type = null;

    ctrl.forceExit = false;

    ctrl.loading = false;
    ctrl.globalService = globalService;

    ctrl.employe = globalService.getEmploye();
    ctrl.paramsGestion = false;

    ctrl.isEditable = false;

    ctrl.timeline = {
      current: 1,
      etapes: {
        titre: 'SAISIE DU LOT',
        titre2: $stateParams.reference,
        completed: false,
        etapes: [{
            id: 1,
            libelle: 'Propriétaire',
            icone: 'fa-user',
            completed: true,
            visited: false,
            rFields: {
              typePerso: {
                label: 'Type',
                completed: false
              },
              nom: {
                label: 'Nom',
                completed: false
              },
              prenom: {
                label: 'Prénom',
                completed: false
              },
              contact: {
                label: 'Téléphone',
                completed: true
              }
            }
          },
          {
            id: 2,
            libelle: 'Mandat',
            icone: 'fa-book',
            completed: true,
            visited: false,
            rFields: {}
          },
          {
            id: 3,
            libelle: 'Lot',
            icone: 'fa-building',
            completed: true,
            visited: false,
            rFields: {
              rue: {
                label: 'Adresse (rue)',
                completed: false
              },
              cp: {
                label: 'Adresse (cp)',
                completed: false
              },
              ville: {
                label: 'Adresse (ville)',
                completed: false
              }
            }
          },
          {
            id: 4,
            libelle: 'Diffusion',
            icone: 'fa-bullhorn',
            completed: true,
            visited: false,
            rFields: {
              description: {
                label: 'Description',
                completed: false
              }
            }
          },
          {
            id: 5,
            libelle: 'Communication',
            icone: 'fa-comments',
            visited: false,
            completed: true,
            rFields: false
          },
          {
            id: 6,
            libelle: 'Documents',
            icone: 'fa-photo',
            visited: false,
            completed: true,
            rFields: false
          }
        ]
      },
      prev: etapePrecedente,
      next: etapeSuivante,
      onChange: onChangeEtape,
      checkEtapes: checkEtapes
    };

    ctrl.proprietaires = {
      list: [],
      search: searchInProprietaires,
      reset: proprietaireReset
    };

    ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;

    ctrl.getLot = getLot;
    ctrl.save = save;
    ctrl.supprimer = supprimerLot;
    ctrl.rapprocher = rapprocherProspect;
    ctrl.imprimer = imprimer;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.goBack = goBack;

    $scope.$watch(
      function () {
        return ctrl.lot;
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal && newVal.isModel) {
          setEtapesCompleted();
        }
      },
      true
    );

    ctrl.panierActifListener = $rootScope.$on('panierActif', function (event, active) {
      ctrl.panierProspect =
        active && globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;
    });

    ctrl.exitListener = $scope.$on('$stateChangeStart', preventExit);
    $window.onbeforeunload = function () {
      if (!ctrl.form.$pristine) {
        return 'Les modifications que vous avez apportées ne seront pas enregistrées';
      }
    };

    ctrl.$onInit = initialisation;

    ctrl.$onDestroy = function () {
      ctrl.panierActifListener();
      ctrl.panierActifListener = null;
      ctrl.exitListener();
      ctrl.exitListener = null;
    };

    function initialisation(iteration) {
      iteration = angular.isDefined(iteration) ? iteration : 1;
      if ($stateParams.reference) {
        if ($stateParams.typeApplication && $stateParams.typeApplication !== globalService.getTypeApplication()) {
          globalService.setTypeApplication($stateParams.typeApplication, true, false);
        }

        ctrl.refLot = $stateParams.reference;

        if ($stateParams.etape) {
          ctrl.timeline.current = Number($stateParams.etape);
        }

        getLot();
      } else if (iteration < 10) {
        iteration++;
        $timeout(function () {
          initialisation(iteration);
        }, 350);
      } else {
        toastr.error(
          "Une erreur s'est produite lors de la récupération du bien.<br>" +
          'Veuillez réessayer ultérieurement.<br>' +
          'Si le problème persiste, contactez la hotline.',
          'Erreur récupération du bien (code erreur : MODB-185)', {
            timeout: 8000
          }
        );
      }
    }

    function preventExit(event, toState, toParams) {
      if (!ctrl.form.$pristine && !ctrl.forceExit) {
        event.preventDefault();

        var confirmDialog = ngDialog.openConfirm({
          templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
          controller: 'ConfirmDialogController',
          controllerAs: 'confirmdialogctrl',
          resolve: {
            titre: function titreFactory() {
              return 'Voulez-vous quitter la saisie ?';
            },
            message: function messageFactory() {
              return '<span><i class="fa fa-2r fa-exclamation-triangle text-danger"></i> Les modifications que vous avez apportées ne seront pas enregistrées</span>';
            },
            commentaire: function commentaireFactory() {
              return false;
            },
            confirmText: function confirmTextFactory() {
              return 'Quitter';
            },
            annulerText: function annulerTextFactory() {
              return false;
            }
          }
        });

        confirmDialog.then(function (data) {
          if (data.status === 'OK') {
            ctrl.forceExit = true;
            $state.go(toState, toParams);
          }
        });
      }
    }

    /* ------------------------------------------------=[ TIMELINE ]=------------------------------------------------ */
    function etapePrecedente() {
      if (ctrl.timeline.current > 1) onChangeEtape(ctrl.timeline.current - 1);
    }

    function etapeSuivante() {
      if (ctrl.timeline.current < ctrl.timeline.etapes.etapes.length) onChangeEtape(ctrl.timeline.current + 1);
    }

    function onChangeEtape(id) {
      setEtapesCompleted();
      ctrl.timeline.etapes.etapes[ctrl.timeline.current - 1].visited = true;
      ctrl.timeline.current = id;
      $state.go(
        'modifBien', {
          reference: $stateParams.reference,
          etape: ctrl.timeline.current
        }, {
          notify: false
        }
      );
    }

    function checkEtapes() {
      setEtapesCompleted();
      return ctrl.timeline.etapes.completed;
    }

    function setEtapesCompleted() {
      ctrl.timeline.etapes.completed = true;

      angular.forEach(ctrl.timeline.etapes.etapes, function (etape) {
        switch (etape.id) {
          case 1:
            etape.rFields.typePerso.completed = ctrl.lot.hasProprietaire() && ctrl.lot.proprietaire.hasType();
            etape.rFields.nom.completed = ctrl.lot.hasProprietaire() && ctrl.lot.proprietaire.hasNom();
            etape.rFields.prenom.completed =
              ctrl.lot.hasProprietaire() && ctrl.lot.proprietaire.physique ? ctrl.lot.proprietaire.hasPrenom() : true;
            etape.rFields.contact.completed = !ctrl.citya || (ctrl.citya && (ctrl.lot.proprietaire.getTelMobile() || ctrl.lot.proprietaire.getTel()));

            etape.completed =
              etape.rFields.typePerso.completed &&
              etape.rFields.nom.completed &&
              etape.rFields.prenom.completed &&
              etape.rFields.contact.completed;
            break;

          case 2:
            if (globalService.getTypeApplication() === 'Transaction') {
              etape.rFields.nego.completed = ctrl.lot.mandatTransaction.nego && ctrl.lot.mandatTransaction.nego.id;
              etape.rFields.prixVente.completed = ctrl.lot.hasPrix();
              etape.rFields.noMandat.completed =
                (ctrl.lot.mandatTransaction.avancement && ctrl.lot.mandatTransaction.avancement.data === 8) ||
                ctrl.lot.hasNoMandat();

              etape.completed =
                etape.rFields.nego.completed && etape.rFields.prixVente.completed && etape.rFields.noMandat.completed;
            } else {
              etape.rFields.dateCreation.completed = ctrl.lot.hasDateCreation();
              etape.rFields.nego.completed = ctrl.lot.mandatLocation.nego && ctrl.lot.mandatLocation.nego.id;
              etape.rFields.loyer.completed = ctrl.lot.hasLoyer();
              etape.rFields.mandat.completed =
                (ctrl.lot.mandatLocation.avancement && ctrl.lot.mandatLocation.avancement.data === 8) ||
                ctrl.lot.hasNoMandatGestion() ||
                ctrl.lot.hasNoMandat();
              etape.rFields.depotGarantie.completed = ctrl.lot.hasDepotGarantie();

              etape.completed =
                etape.rFields.nego.completed &&
                etape.rFields.dateCreation.completed &&
                etape.rFields.loyer.completed &&
                etape.rFields.mandat.completed &&
                etape.rFields.depotGarantie.completed;
            }
            break;

          case 3:
            if (ctrl.lot.hasAdresse()) {
              ctrl.lot.adresse = ctrl.lot.adresse.isModel ? ctrl.lot.adresse : new Adresse(ctrl.lot.adresse);
              etape.rFields.rue.completed = ctrl.lot.adresse.hasRue();
              etape.rFields.cp.completed = ctrl.lot.adresse.hasCp();
              etape.rFields.ville.completed = ctrl.lot.adresse.hasVille();
            } else {
              etape.rFields.rue.completed = etape.rFields.cp.completed = etape.rFields.ville.completed = false;
            }

            etape.completed =
              etape.rFields.rue.completed && etape.rFields.cp.completed && etape.rFields.ville.completed;
            break;

          case 4:
            etape.completed = etape.rFields.description.completed = ctrl.lot.hasDescription();
            break;
        }

        if (!etape.completed) {
          ctrl.timeline.etapes.completed = false;
        }
      });
    }

    /* ----------------------------------------------=[ PROPRIETAIRE ]=---------------------------------------------- */
    function searchInProprietaires() {
      RepertoireService.openRepertoire({
        type: globalService.getTypeApplication() === 'Transaction' ? 'proprio' : 'bailleur'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            ctrl.lot.proprietaire = retour.perso;
          }
        },
        function (error) {
          $log.info(error);
        }
      );
    }

    function proprietaireReset() {
      ctrl.lot.proprietaire = new Perso();
    }

    /* ---------------------------------------------------=[ LOT ]=-------------------------------------------------- */
    function getLot() {
      ctrl.lot = null;

      if (ctrl.refLot && ctrl.refLot !== null) {
        ctrl.loading = true;

        PropertiesService.getPropertiesList({
            search: {
              lotReference: ctrl.refLot
            },
            typeMethode: 'complete',
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (json) {
            if (json.status === 'OK' && json.list.nblot) {
              ctrl.type = json.list.biens[0].type;
              ctrl.lot = json.list.biens[0];

              if (angular.isUndefined(ctrl.lot.importPresta) || !ctrl.lot.importPresta) {
                ctrl.isEditable = true;
              }

              if (!ctrl.lot.hasProprietaire()) {
                ctrl.lot.setProprietaire(new Perso());
              }

              if (!ctrl.lot.proprietaire.hasType()) {
                ctrl.lot.proprietaire.type = 'PersoPhysique';
                ctrl.lot.proprietaire.physique = true;
              }

              if (ctrl.lot.pubVitrine && ctrl.lot.pubVitrine.length > 270) {
                ctrl.lot.pubVitrine = ctrl.lot.pubVitrine.substring(0, 270);
              }

              if (!ctrl.lot.proprietaire.hasNom() && $stateParams.nom) ctrl.lot.proprietaire.nom = $stateParams.nom;
              if (!ctrl.lot.proprietaire.hasPrenom() && $stateParams.prenom)
                ctrl.lot.proprietaire.prenom = $stateParams.prenom;
              if (!ctrl.lot.proprietaire.hasDateNaissance() && $stateParams.dateNaissance)
                ctrl.lot.proprietaire.dateNaissance = $stateParams.dateNaissance;
              if (!ctrl.lot.proprietaire.adresses[0].hasCp() && $stateParams.cp)
                ctrl.lot.proprietaire.adresses[0].cp = $stateParams.cp;
              if ($stateParams.email) ctrl.lot.proprietaire.addContact('Email', $stateParams.email);
              if ($stateParams.tel)
                ctrl.lot.proprietaire.addContact(
                  $stateParams.tel.startsWith('06') || $stateParams.tel.startsWith('07') ? 'TelMobile' : 'Telephone',
                  $stateParams.tel
                );

              if (!ctrl.lot['mandat' + globalService.getTypeApplication()].avancement) {
                ctrl.lot['mandat' + globalService.getTypeApplication()].avancement = {
                  label: globalService.getTypeApplication() === 'Location' ? 'En location' : 'En vente'
                };
              }

              if (globalService.getTypeApplication() === 'Location') {
                if (ctrl.employe.societe.agence.copieGestion && ctrl.lot.gestion === true) {
                  ctrl.paramsGestion = {
                    proprio: ctrl.employe.societe.agence.copieGestionContactProprio,
                    nego: ctrl.employe.societe.agence.copieGestionNego,
                    mandat: ctrl.employe.societe.agence.copieGestionMandat,
                    honoraire: ctrl.employe.societe.agence.copieGestionHonoraire,
                    adresse: ctrl.employe.societe.agence.copieGestionAdresse,
                    descriptif: ctrl.employe.societe.agence.copieGestionDescriptif
                  };
                }

                ctrl.timeline.etapes.etapes[1].rFields = {
                  dateCreation: {
                    label: 'Entrée',
                    completed: false
                  },
                  nego: {
                    label: 'Négo',
                    completed: false
                  },
                  loyer: {
                    label: 'Loyer',
                    completed: false
                  },
                  mandat: {
                    label: 'Mandat Loc. ou Mandat Gestion',
                    completed: false
                  },
                  depotGarantie: {
                    label: 'Dépôt de garantie',
                    completed: false
                  }
                };
              } else {
                ctrl.timeline.etapes.etapes[1].rFields = {
                  nego: {
                    label: 'Négo',
                    completed: false
                  },
                  prixVente: {
                    label: 'Prix Vente',
                    completed: false
                  },
                  noMandat: {
                    label: 'Numéro Mandat',
                    completed: false
                  }
                };
              }

              setEtapesCompleted();
              ctrl.loading = false;
            } else {
              $state.go('listeBien');
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            $state.go('listeBien');
          });
      } else {
        $state.go('listeBien');
      }
    }

    function checkHonoraires() {
      var commission = CustomUtils.number.roundTo(
          ctrl.lot.mandatTransaction.prixVente -
          ctrl.lot.mandatTransaction.prixVente * (1 - ctrl.lot.mandatTransaction.tauxComm / 100)
        ),
        honoAcheteur = ctrl.lot.mandatTransaction.honoChargeAquereur ?
        ctrl.lot.mandatTransaction.honoChargeAquereur :
        0,
        honoVendeur = ctrl.lot.mandatTransaction.honoChargeVendeur ? ctrl.lot.mandatTransaction.honoChargeVendeur : 0;
      if (honoVendeur + honoAcheteur > commission) {
        toastr.warning(
          "La somme des Hono. Acheteur / Vendeur ne doit pas dépasser le montant total d'honoraires.",
          'Dépassement Hono. Acheteur / Vendeur', {
            timeOut: 10000
          }
        );
      } else if (honoVendeur + honoAcheteur < commission) {
        toastr.warning(
          "La somme des Hono. Acheteur / Vendeur est inférieure au montant total d'honoraires.",
          'Carence Hono. Acheteur / Vendeur', {
            timeOut: 10000
          }
        );
      }
    }

    function save() {
      if (checkEtapes()) {
        ctrl.loading = true;

        if (
          ctrl.lot['mandat' + globalService.getTypeApplication()].avancement &&
          (ctrl.lot['mandat' + globalService.getTypeApplication()].avancement.label === 'En location' ||
            ctrl.lot['mandat' + globalService.getTypeApplication()].avancement.label === 'En vente')
        ) {
          ctrl.lot['mandat' + globalService.getTypeApplication()].avancement = null;
        }

        if (globalService.getTypeApplication() === 'Transaction') checkHonoraires();

        if (angular.isArray(ctrl.lot.multimedia) && ctrl.lot.multimedia.length) {
          angular.forEach(ctrl.lot.multimedia, function (photo) {
            delete photo.noCacheValue;
          });
        }

        return PropertiesService.saveBien({
            xmllot: ctrl.lot.toJson()
          })
          .then(function (json) {
            if (json.status === 'OK') {
              ctrl.lot = json.bien;

              if (!ctrl.lot['mandat' + globalService.getTypeApplication()].avancement) {
                ctrl.lot['mandat' + globalService.getTypeApplication()].avancement = {
                  label: globalService.getTypeApplication() === 'Location' ? 'En location' : 'En vente'
                };
              }

              ctrl.form.$setPristine(true);

              $state.go(
                'modifBien', {
                  reference: ctrl.lot.referenceInterne,
                  typeApplication: globalService.getTypeApplication(),
                  etape: ctrl.timeline.current
                }, {
                  notify: false
                }
              );
            }
            ctrl.loading = false;
            toastr.success('Les modifications ont été enregistrées avec succes.', 'Enregistrement terminé');
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status === 'DATA_EXCEPTION') {
                $log.warn(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(error.message, 'Erreur n° mandat', {
                  timeOut: 8000
                });
              } else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  "Une erreur s'est produite lors de la sauvegarde.<br>Veuillez réessayer utlérieurement.",
                  'Erreur sauvegarde lot (code erreur : <i>MODB-464</i>)', {
                    timeOut: 8000
                  }
                );
              }
            } else $log.error(error.status);
            ctrl.loading = false;
          });
      } else {
        toastr.error("Veuillez renseigner l'ensemble des champs requis.", 'Saisie incomplète');
      }
    }

    function supprimerLot() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer ce bien ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return 'Supprimer';
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          ctrl.loading = true;
          PropertiesService.supprimerBien({
            deleteRef: ctrl.lot.referenceInterne || ctrl.refLot
          }).then(
            function (retour) {
              if (retour.status === 'OK') {
                ctrl.lot = retour.bien;
                ctrl.forceExit = true;
                $state.go('listeBien');
              }
              ctrl.loading = false;
            },
            function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED') {
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  toastr.error(
                    "Une erreur s'est produite lors de la suppression.<br>Veuillez réessayer utlérieurement.",
                    'Erreur suppression lot (code erreur : <i>MODB-523</i>)',

                    {
                      timeOut: 8000
                    }
                  );
                }
              } else $log.error(error.status);
              ctrl.loading = false;
            }
          );
        }
      });
    }

    function rapprocherProspect() {
      var query = globalService.getStorageItem('QUERY-LISTE-PROSPECT') || {
        search: null
      };

      CriteresParser.bienToSearch(ctrl.lot).then(function (retour) {
        if (retour.status === 'OK') {
          query.search = retour.search;
          globalService.setStorageItem('QUERY-LISTE-PROSPECT', query);

          var lotTransac = ctrl.lot.hasMandatTransaction() ? 'Transaction' : 'Location';
          if (globalService.getTypeApplication() !== lotTransac) {
            globalService.setTypeApplication(lotTransac, false, false);
          }

          $state.go('listeProspects', {
            rapprocher: ctrl.lot.referenceInterne
          });
        }
      });
    }

    function imprimer() {
      ImpressionService.openImpression({
        lotsid: ctrl.lot.id
      });
    }

    function envoyerEmail() {
      if (ctrl.panierProspect) {
        if (!ctrl.panierProspect.referenceInterne.includes('CLOUD-')) {
          openMailForm(ctrl.panierProspect);
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: ctrl.panierProspect,
            callback: function (retour) {
              openMailForm(retour.prospect);
            }
          });
        }
      } else {
        openMailForm();
      }
    }

    function openMailForm(prospect) {
      MailService.getModel({
        lots: ctrl.lot.referenceInterne,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== fiche-bien.component.js l.263");
          }
        });
      });
    }

    function goBack() {
      $state.go('listeBien');
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('login', {
    templateUrl: 'app/components/main-content/login/login.html',
    controllerAs: 'loginctrl',
    controller: LoginController
  });

  /** @ngInject */
  function LoginController(
    CONSTANTS,
    globalService,

    LoginService,
    $scope,
    $state,
    $stateParams,
    $timeout,
    Perso,
    toastr,
    $log
  ) {
    var ctrl = this;

    ctrl.count = 0;

    ctrl.loading = false;

    ctrl.initiales = '';
    ctrl.mdp = '';

    ctrl.missingLogin = false;
    ctrl.badLogin = false;
    ctrl.connexionTimedOut = false;

    ctrl.retry = true;

    ctrl.typeApplication = globalService.getTypeApplication() || 'Transaction';

    ctrl.typeAppListener = $scope.$on('typeApplication', function (event, args) {
      ctrl.typeApplication = args.transac;
    });

    ctrl.isAppleDevice = false;

    ctrl.login = login;
    ctrl.logout = logout;

    ctrl.versionAuthorise = false;

    ctrl.$onInit = function () {
      var parser = new UAParser();
      var result = parser.getResult();
      ctrl.isAppleDevice =
        result.device &&
        (result.device.type === 'tablet' || result.device.type === 'mobile') &&
        result.device.vendro === 'Apple';

      if ($stateParams.connexionTimedOut) {
        ctrl.connexionTimedOut = true;
      }

      if ($stateParams.errLocalStorage) {
        toastr.error(
          'Si le mode navigation priv&eacute;e est activ&eacute;, essayez de le d&eacute;sactiver avant de continuer.' +
          '<br>' +
          'Si le probl&egrave;me persiste, contactez la hotline.',
          'Erreur d&apos;acc&egrave;s aux sauvegardes'
        );
      } else {
        globalService.setEmploye(null);

        if (CONSTANTS.configClient.citya) {
          kerberosLogin();
        }
      }
      $timeout(function () {
        if (globalService.getVersion().indexOf('2.') === 0) {
          ctrl.versionAuthorise = true;
        }
      });
    };

    ctrl.$onDestroy = function () {
      ctrl.typeAppListener();
      ctrl.typeAppListener = null;
    };

    function kerberosLogin() {
      globalService.setTypeApplication(ctrl.typeApplication, false, true);

      LoginService.checkKerberos().then(function (json) {
        if (json.status === 'OK' && angular.isDefined(json.employe)) {
          $log.info('Authentification Kerberos (' + ctrl.typeApplication + ') : OK');
          json.employe.perso = new Perso(json.employe.perso);

          globalService.setEmploye(json.employe);

          $timeout(function () {
            if (
              $stateParams.prevState !== false &&
              $stateParams.prevState.name !== 'login' &&
              $stateParams.prevState.name !== 'logout'
            ) {
              $state.go($stateParams.prevState.name, $stateParams.prevState.params);
            } else {
              $state.go('accueil');
            }
          });
        }
      });
    }

    function login(stop) {
      stop = angular.isDefined(stop) ? stop : false;

      ctrl.loading = true;
      ctrl.badLogin = false;
      ctrl.missingLogin = false;
      ctrl.connexionTimedOut = false;

      globalService.setTypeApplication(ctrl.typeApplication, false, true);

      LoginService.login({
          initiales: ctrl.initiales,
          mdp: ctrl.mdp,
          location: ctrl.typeApplication === 'Location',
          kerberos: false
        })
        .then(function (json) {
          if (json.status === 'OK' && angular.isDefined(json.employe)) {
            json.employe.perso = new Perso(json.employe.perso);

            globalService.setEmploye(json.employe);

            $timeout(function () {
              if (
                $stateParams.prevState !== false &&
                $stateParams.prevState.name !== 'login' &&
                $stateParams.prevState.name !== 'logout'
              ) {
                $state.go($stateParams.prevState.name, $stateParams.prevState.params);
              } else {
                $state.go('accueil');
              }
            });
          }

          ctrl.loading = false;
        })
        .catch(function (error) {
          if (error.status === 'MISSING_PARAMETER') {
            ctrl.missingLogin = true;
          } else if (!stop) {
            ctrl.typeApplication = ctrl.typeApplication === 'Transaction' ? 'Location' : 'Transaction';
            stop = true;
            login(stop);
          } else {
            ctrl.typeApplication = ctrl.typeApplication === 'Transaction' ? 'Location' : 'Transaction';
            globalService.setTypeApplication(ctrl.typeApplication, false, true);
            if (error.status === 'BAD_LOGIN') {
              ctrl.badLogin = true;
            } else if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              }
            } else {
              $log.error(error.status);
            }
          }
          ctrl.loading = false;
        });
    }

    function logout() {
      LoginService.logout();
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('listeProspects', {
    templateUrl: 'app/components/main-content/liste-prospects/liste-prospects.html',
    controllerAs: 'listeprospectsctrl',
    controller: ListeProspectsController
  });

  /** @ngInject */
  function ListeProspectsController(
    CONSTANTS,
    CustomUtils,
    ProspectsService,
    globalService,

    MailService,
    $scope,
    $stateParams,
    $state,
    $uibModal,
    toastr,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.citya = CONSTANTS.configClient.citya;

    //ctrl.loading = true;

    ctrl.defaultQuery = {
      search: {
        recherche: null,
        societe: ctrl.employe.societe.id || null,
        nego: null,
        archive: false,
        prixMin: null,
        prixMax: null,
        dateDebut: null,
        dateFin: null,
        type: null,
        //cpVille: null,
        villes: null,
        criteres: null,
        tri: 'desc',
        ordre: 'triDate'
      },
      numero: 0,
      pas: 50,
      typeApplication: globalService.getTypeApplication(),
      typeMethode: 'simple'
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.rapprocher = {
      active: false,
      refLot: null,
      prospects: [],
      toggle: toggleSelection
    };

    ctrl.searchBoxOptions = {
      query: ctrl.query.search,
      defaultQuery: ctrl.defaultQuery.search,
      placeholder: 'MARTIN',
      additionalControls: {
        tris: {
          list: CONSTANTS.dictionnaire.FR.prospects.tri,
          nomChamp: {
            tri: 'tri',
            ordre: 'ordre'
          },
          default: {
            tri: 'desc',
            ordre: 'triDate'
          }
        }
      },
      criteres: {
        villes: {
          nomChamp: 'villes'
        },
        types: {
          nomChamp: 'type'
        },
        prix: {
          nomChamp: {
            min: 'prixMin',
            max: 'prixMax'
          }
        },
        criteres: {
          nomChamp: 'criteres'
        }
      },
      filtres: {
        societes: {
          nomChamp: 'societe'
        },
        nego: {
          nomChamp: 'nego'
        },
        dateSaisie: {
          datedeb: true,
          datefin: true,
          nomChamp: {
            datedeb: 'dateDebut',
            datefin: 'dateFin'
          }
        },
        visibilite: {
          mandat: false,
          archive: true,
          nomChamp: {
            archive: 'archive'
          }
        }
      }
    };

    ctrl.prospects = {
      nb: null,
      list: [],
      refList: []
    };

    ctrl.loading = false;

    ctrl.getList = getList;
    ctrl.creerProspect = creerProspect;
    ctrl.showFicheProspect = showFicheProspect;

    ctrl.$onInit = function () {
      if (
        angular.isDefined($stateParams.recherche) ||
        globalService.getStorageItem('QUERY-LISTE-PROSPECT')
      ) {
        var queryParam =
          $stateParams.recherche ||
          globalService.getStorageItem('QUERY-LISTE-PROSPECT');
        if (
          angular.isObject(queryParam) &&
          queryParam.hasOwnProperty('search') &&
          angular.isObject(queryParam.search)
        ) {
          ctrl.query = CustomUtils.collection.override(ctrl.query, queryParam);
        } else if (angular.isObject(queryParam) && !CustomUtils.collection.isEmpty(queryParam))
          ctrl.query.search = CustomUtils.collection.override(ctrl.query.search, queryParam);
      }

      if (angular.isDefined($stateParams.rapprocher) && $stateParams.rapprocher) {
        ctrl.rapprocher.active = true;
        ctrl.rapprocher.refLot = $stateParams.rapprocher;
        ctrl.searchBoxOptions.additionalControls.envoyerEmail = envoyerEmail;
        ctrl.searchBoxOptions.additionalControls.selection = toggleSelection;
        ctrl.query.search.archive = false;
      }

      if (!ctrl.citya) {
        ctrl.searchBoxOptions.additionalControls.newElem = {
          typeElem: 'prospect',
          ajouterElem: function () {
            creerProspect();
          }
        };
      }

      ctrl.searchBoxOptions.query = ctrl.query.search;

      globalService.setStorageItem('QUERY-LISTE-PROSPECT', ctrl.query);

      getList(false, false);
    };

    function getList(search, scroll) {
      if (!scroll) {
        ctrl.query.numero = 0;
        ctrl.query.pas = ctrl.query.pas || ctrl.defaultQuery.pas;
        ctrl.prospects.list = [];
        ctrl.prospects.refList = [];
        ctrl.rapprocher.prospects = [];
      }

      if ((ctrl.query.numero > 0 && ctrl.query.numero >= ctrl.prospects.nb) || (ctrl.query.numero > 0 && ctrl.loading))
        return false;

      ctrl.loading = true;
      ctrl.noResults = false;

      if (search) {
        ctrl.query.search = CustomUtils.collection.override(ctrl.query.search, search);
      }

      ctrl.query.typeApplication = globalService.getTypeApplication();

      globalService.setStorageItem('QUERY-LISTE-PROSPECT', ctrl.query);

      ProspectsService.getListe(ctrl.query)
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.prospects.nb = retour.nb || 0;

            if (ctrl.prospects.nb) {
              angular.forEach(retour.prospects, function (prospect) {
                ctrl.prospects.list.push(prospect);
                ctrl.prospects.refList.push(prospect.referenceInterne);
              });
              ctrl.query.numero += ctrl.query.pas;
            } else if (scroll && ctrl.prospects.list.length) {
              ctrl.prospects.nb = ctrl.prospects.list.length;
              ctrl.query.numero += ctrl.query.pas;
            } else {
              ctrl.prospects.nb = 0;
              ctrl.prospects.list = [];
              ctrl.prospects.refList = [];
            }
          } else {
            ctrl.prospects.nb = 0;
            ctrl.prospects.list = [];
            ctrl.prospects.refList = [];
          }
          ctrl.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.noResults = true;
          ctrl.prospects.nb = 0;
          ctrl.prospects.list = [];
          ctrl.prospects.refList = [];
          ctrl.loading = false;
        });
    }

    function creerProspect() {
      ProspectsService.editerProspect({
          addProspect: true,
          typeApplication: globalService.getTypeApplication(),
          typeMethode: 'complete'
        })
        .then(function (json) {
          if (json.status === 'OK') {
            $state.go('modifProspect', {
              reference: json.prospect.referenceInterne,
              typeApplication: globalService.getTypeApplication()
            });
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });
    }

    function envoyerEmail() {
      if (ctrl.rapprocher.active && ctrl.rapprocher.refLot && ctrl.rapprocher.prospects.length) {
        openMailForm(ctrl.rapprocher.refLot, ctrl.rapprocher.prospects);
      }
    }

    function openMailForm(refLot, prospects) {
      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isArray(prospects) && prospects.length) {
                var destinataires = [],
                  refList = [];
                angular.forEach(ctrl.rapprocher.prospects, function (prospect) {
                  if (prospect.perso && prospect.perso.hasContacts()) {
                    destinataires.push(prospect.perso.getEmail());
                    refList.push(prospect.referenceInterne);
                  }
                });
                retour.destinataire = destinataires.join(',');
                retour.prospects = refList.join(',');
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== liste-prospects.component.js l.261");
          }
        });
      });
    }

    function toggleSelection(selected, prospect) {
      if (angular.isDefined(prospect)) {
        if (selected) {
          if (prospect.perso && prospect.perso.hasContacts() && prospect.perso.getEmail()) {
            ctrl.rapprocher.prospects.push(prospect);
          } else {
            prospect.selected = false;
            toastr.warning(
              'L&apos;adresse email de ce prospect n&apos;a pas &eacute;t&eacute; renseign&eacute;e<br>' +
              'Ce bien ne peut pas lui &ecirc;tre propos&eacute; par email.<br>',
              'Prospect sans email', {
                timeOut: 8000
              }
            );
          }
        } else {
          ctrl.rapprocher.prospects = ctrl.rapprocher.prospects.filter(function (current) {
            return current.id !== prospect.id;
          });
        }
      } else {
        var notify = false;
        angular.forEach(ctrl.prospects.list, function (current) {
          current.selected = selected;
          if (selected && current.perso && current.perso.hasContacts() && current.perso.getEmail()) {
            ctrl.rapprocher.prospects.push(current);
          } else if (selected) {
            current.selected = false;
            notify = true;
          }
        });
        if (notify) {
          toastr.warning(
            'Les adresses email d&apos;un ou plusieur prospects parmis la s&eacute;lection n&apos;ont pas &eacute;t&eacute; renseign&eacute;es<br>' +
            'Ce bien ne peut pas leur &ecirc;tre propos&eacute; par email.<br>',
            'Prospect(s) sans email', {
              timeOut: 8000
            }
          );
        }
        if (!selected) {
          ctrl.rapprocher.prospects = [];
        }
      }
    }

    function showFicheProspect(reference) {
      $scope.$emit('showFiche', {
        type: 'ficheProspect',
        ref: reference,
        refList: ctrl.prospects.refList
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('listeBien', {
    templateUrl: 'app/components/main-content/liste-bien/liste-bien.html',
    controllerAs: 'listebienctrl',
    controller: ListeBienController
  });

  /** @ngInject */
  function ListeBienController(
    CONSTANTS,
    globalService,
    PropertiesService,
    CustomUtils,
    Prospect,
    MailService,
    $timeout,
    $stateParams,
    $state,
    uiGmapGoogleMapApi,
    $window,
    $uibModal,
    $scope,
    $rootScope,
    $animate,
    $element,
    $log
  ) {
    var ctrl = this;

    ctrl.initialisation = true;

    ctrl.employe = globalService.getEmploye();

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.defaultQuery = {
      search: {
        recherche: null,
        lotReference: null,
        localisation: null,
        type: null,
        prixMin: null,
        prixMax: null,
        villes: null,
        criteres: null,
        nego: null,
        intrabox: false,
        mandat: true,
        archive: false,
        typeMandat: null,
        datedeb: null,
        datefin: null,
        expireDans: null,
        expireDepuis: null,
        gestionAgence: null,
        avancement: null,
        panneaux: null,
        paru: null,
        qualification: ctrl.citya && globalService.getTypeApplication() === 'Location' ? '1,2,3,5,7,8,9' : null,
        sansDpe: null,
        enAttente: null,
        enOption:
          (angular.isDefined(ctrl.employe) && ctrl.employe.societe.sansRapproCompromis) || ctrl.citya ? false : null,
        dureeVacance: null,
        societe: ctrl.employe ? ctrl.employe.societe.id : null,
        tri: 'desc',
        ordre: 'triDate'
      },
      numero: 0,
      pas: null,
      typeMethode: 'liste',
      typeApplication: globalService.getTypeApplication(),
      template: ctrl.citya && globalService.getTypeApplication() === 'Transaction' ? 'list' : 'map'
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.localQuery = 'QUERY-LISTE-BIEN';

    ctrl.pas = 32;

    ctrl.loading = true;
    ctrl.noResults = false;

    ctrl.properties = {
      nblot: 0,
      pluriel: '',
      list: [],
      mapnumero: 0,
      nbMapLot: 0,
      mapPluriel: '',
      nbNotVisible: 0,
      notVisiblePluriel: '',
      refList: []
    };

    ctrl.blocBienHeight = 0;

    ctrl.message = {
      open: false,
      status: null,
      message: null
    };

    ctrl.queryWorking = null;

    ctrl.map = {
      controller: {},
      mapObj: {},
      center: {
        latitude: 47,
        longitude: 2,
        zoom: 6
      },
      zoom: 12,
      zoomListener: null,
      mapOptions: {
        fullscreenControl: false
      },
      markerOptions: {
        icon: {
          anchor: {
            x: 0,
            y: 0
          },
          path: 'M 0.000 22.000 L 5.694 21.250 L 11.000 19.053 L 15.556 15.556 L 19.053 11.000 ' +
            'L 21.250 5.694 L 22.000 0.000 L 21.250 -5.694 L 19.053 -11.000 L 15.556 -15.556 ' +
            'L 11.000 -19.053 L 5.694 -21.250 L 0.000 -22.000 L -5.694 -21.250 ' +
            'L -11.000 -19.053 L -15.556 -15.556 L -19.053 -11.000 L -21.250 -5.694 ' +
            'L -22.000 0.000 L -21.250 5.694 L -19.053 11.000 L -15.556 15.556 ' +
            'L -11.000 19.053 L -5.694 21.250 L 0.000 22.000 z',
          fillColor: '#ff0000',
          fillOpacity: 1,
          scale: 0.4
        }
      },
      markersController: {},
      clusterOptions: {
        maxZoom: 12,
        averageCenter: true,
        minimumClusterSize: 5,
        imagePath: 'assets/images/map/circle_cluster_m',
        styles: [{
            url: 'assets/images/map/circle_cluster_m1.png',
            height: 24,
            width: 24,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 12
          },
          {
            url: 'assets/images/map/circle_cluster_m2.png',
            height: 36,
            width: 36,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 12
          },
          {
            url: 'assets/images/map/circle_cluster_m3.png',
            height: 48,
            width: 48,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 14
          },
          {
            url: 'assets/images/map/circle_cluster_m4.png',
            height: 60,
            width: 60,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 14
          },
          {
            url: 'assets/images/map/circle_cluster_m5.png',
            height: 72,
            width: 72,
            anchor: [0, 0],
            textColor: '#ffffff',
            textSize: 16
          }
        ]
      },
      window: {
        show: false,
        property: {}
      },
      windowOptions: {
        boxClass: 'custom-bloc-map-bien-info-window',
        pixelOffset: {
          width: -137.5,
          height: 10,
          widthUnit: 'px',
          heightUnit: 'px'
        }
      },
      markerHighlight: {
        show: false,
        property: {},
        options: {
          boxClass: 'marker-highlight',
          pixelOffset: {
            width: -12,
            height: -12,
            widthUnit: 'px',
            heightUnit: 'px'
          }
        }
      },
      tablist: {
        open: true,
        visible: true,
        loading: false,
        reloading: false
      },
      events: {
        bounds_changed: mapBoundsChanged
      },
      markerEvents: {
        click: markerClick
      }
    };

    ctrl.searchBoxOptions = {
      query: ctrl.query.search,
      defaultQuery: ctrl.defaultQuery.search,
      placeholder: 'Appartement 3 pieces 53 M2 200000 euros',
      templates: {
        list: [{
            nom: 'map',
            icon: 'fa-map-marker',
            tooltip: 'Carte'
          },
          {
            nom: 'grid',
            icon: 'fa-th',
            tooltip: 'Grille'
          },
          {
            nom: 'list',
            icon: 'fa-list',
            tooltip: 'Liste'
          },
          {
            nom: 'listNoPhotos',
            icon: 'fa-bars',
            tooltip: 'Liste sans photos'
          }
        ],
        default: ctrl.defaultQuery.template,
        onChange: function (template) {
          setTemplate(template);
        }
      },
      criteres: {
        villes: {
          nomChamp: 'villes'
        },
        types: {
          nomChamp: 'type'
        },
        prix: {
          nomChamp: {
            min: 'prixMin',
            max: 'prixMax'
          }
        },
        criteres: {
          nomChamp: 'criteres'
        }
      },
      filtres: {
        geolocalisation: {
          nomChamp: 'localisation'
        },
        societes: {
          nomChamp: 'societe'
        },
        nego: {
          nomChamp: 'nego'
        },
        avancement: {
          nomChamp: 'avancement'
        },
        visibilite: {
          mandat: true,
          archive: true,
          nomChamp: {
            mandat: 'mandat',
            archive: 'archive'
          }
        },
        panneaux: {
          nomChamp: 'panneaux'
        },
        qualification: {
          nomChamp: 'qualification'
        }
      },
      additionalControls: {
        tris: {
          list: CONSTANTS.dictionnaire.FR.listebien.tri,
          nomChamp: {
            tri: 'tri',
            ordre: 'ordre'
          },
          default: {
            tri: 'desc',
            ordre: 'triDate'
          }
        },
        newElem: {
          typeElem: 'bien',
          ajouterElem: function (type) {
            PropertiesService.ajouterBien({
                newlotClass: type,
                typeApplication: globalService.getTypeApplication()
              })
              .then(function (json) {
                if (json.status === 'OK') {
                  $state.go('modifBien', {
                    reference: json.bien.referenceInterne,
                    typeApplication: globalService.getTypeApplication()
                  });
                }
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED')
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                } else $log.error(error.status);
              });
          }
        },
        searchToProspect: true,
        selection: function (selected) {
          if (selected) {
            var oldNum = ctrl.query.numero,
              oldPas = ctrl.query.pas,
              oldType = ctrl.query.typeMethode;
            ctrl.query.numero = 0;
            ctrl.query.pas = null;
            ctrl.query.typeMethode = 'short';

            PropertiesService.getPropertiesList(ctrl.query)
              .then(function (json) {
                if (json.status === 'OK') {
                  var refList = [];
                  angular.forEach(json.list.biens, function (bien) {
                    refList.push(bien.referenceInterne);
                  });
                  ajouterAllSelection(refList);
                }
                ctrl.query.numero = oldNum;
                ctrl.query.pas = oldPas;
                ctrl.query.typeMethode = oldType;
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED')
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                } else $log.error(error.status);
                ctrl.query.numero = oldNum;
                ctrl.query.pas = oldPas;
                ctrl.query.typeMethode = oldType;
              });
          } else {
            retirerAllSelection();
          }
        }
      }
    };

    ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;

    ctrl.panierActifListener = $rootScope.$on('panierActif', function (event, active) {
      ctrl.panierProspect =
        active && globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : false;
    });

    ctrl.getList = getList;
    ctrl.getNonGeolocalise = getNonGeolocalise;
    ctrl.setTemplate = setTemplate;
    ctrl.imgResize = imgResize;
    ctrl.tablistToggle = tablistToggle;
    ctrl.onRepeatComplete = onRepeatComplete;
    ctrl.mapLazyload = mapLazyload;
    ctrl.markerClick = markerClick;
    ctrl.highlightMarker = highlightMarker;
    ctrl.hideHighlightedMarker = hideHighlightedMarker;
    ctrl.hideMapProperty = hideMapProperty;
    ctrl.showFicheProperty = showFicheProperty;
    ctrl.envoyerBienEmail = envoyerBienEmail;
    ctrl.ajouterFavoris = ajouterFavoris;
    ctrl.toggleSelection = toggleSelection;

    ctrl.$onInit = function () {
      // Désactiver le panneau de droite sur mobiles
      if ($window.innerWidth < 768) {
        ctrl.map.tablist.visible = false;
        ctrl.map.tablist.open = false;
      }

      uiGmapGoogleMapApi.then(function (googleMaps) {
        ctrl.googleMapApi = googleMaps;
        ctrl.map.markerOptions.animation = ctrl.googleMapApi.Animation.DROP;
      });

      if (angular.isDefined($stateParams.type) && $stateParams.type === 'stock') {
        ctrl.localQuery = 'QUERY-GESTION-STOCK';

        ctrl.searchBoxOptions.filtres.sansDpe = {
          nomChamp: 'sansDpe'
        };
      }

      if (angular.isDefined($stateParams.recherche) || globalService.getStorageItem(ctrl.localQuery)) {
        var queryParam = $stateParams.recherche || globalService.getStorageItem(ctrl.localQuery);
        if (
          angular.isObject(queryParam) &&
          queryParam.hasOwnProperty('search') &&
          angular.isObject(queryParam.search)
        ) {
          ctrl.query = CustomUtils.collection.override(ctrl.query, queryParam);
        } else if (angular.isObject(queryParam) && !CustomUtils.collection.isEmpty(queryParam))
          ctrl.query.search = CustomUtils.collection.override(ctrl.query.search, queryParam);
      }

      ctrl.searchBoxOptions.query = ctrl.query.search;
      ctrl.searchBoxOptions.templates.default = ctrl.query.template;

      if (ctrl.panierProspect) {
        ctrl.query.refProspect = ctrl.panierProspect.referenceInterne;
      }

      globalService.setStorageItem(ctrl.localQuery, ctrl.query);

      if (globalService.getTypeApplication() === 'Transaction') {
        ctrl.searchBoxOptions.filtres.typeMandat = {
          nomChamp: 'typeMandat'
        };
        ctrl.searchBoxOptions.filtres.dateMandat = {
          datedeb: true,
          datefin: true,
          nomChamp: {
            datedeb: 'datedeb',
            datefin: 'datefin'
          }
        };
        ctrl.searchBoxOptions.filtres.expire = {
          nomChamp: 'expireDans'
        };
        ctrl.searchBoxOptions.filtres.expirant = {
          nomChamp: 'expireDans'
        };
        ctrl.searchBoxOptions.filtres.intrabox = {
          nomChamp: 'intrabox'
        };
      } else {
        ctrl.searchBoxOptions.filtres.etat = {
          attente: true,
          option: true,
          nomChamp: {
            attente: 'enAttente',
            option: 'enOption'
          }
        };
        ctrl.searchBoxOptions.filtres.gestionAgence = {
          nomChamp: 'gestionAgence'
        };
        ctrl.searchBoxOptions.filtres.dureeVacance = {
          nomChamp: 'dureeVacance'
        };
      }

      if (!ctrl.citya) {
        ctrl.searchBoxOptions.filtres.paru = {
          nomChamp: 'paru'
        };
      }

      $animate.on('enter', $element, function callback(element, phase) {
        if (element.hasClass('map-tablist') && phase === 'close') {
          $timeout(function () {
            ctrl.map.tablist.visible = true;
          });
        }
      });

      getList(false, false);

      ctrl.initialisation = false;
    };

    ctrl.$onDestroy = function () {
      if (angular.isFunction(ctrl.panierActifListener)) {
        ctrl.panierActifListener();
      }
      if (angular.isFunction(ctrl.blocBienListener)) {
        ctrl.blocBienListener();
      }
      $timeout.cancel(ctrl.map.tablist.reloading);
      $timeout.cancel(ctrl.queryWorking);
      $timeout.cancel(ctrl.mapRefreshing);
    };

    function refreshMap(iteration) {
      iteration = iteration ? iteration : 1;
      if (angular.isFunction(ctrl.map.controller.refresh)) {
        if (angular.isFunction(ctrl.map.markersController.clean)) {
          ctrl.map.markersController.clean();
        }
        if (angular.isDefined(ctrl.mapRefreshing)) {
          $timeout.cancel(ctrl.mapRefreshing);
        }
        ctrl.mapRefreshing = $timeout(function () {
          if (ctrl.properties.list.length) {
            var bounds = new ctrl.googleMapApi.LatLngBounds();
            angular.forEach(ctrl.properties.list, function (property) {
              if (property.isVisible) {
                bounds.extend(new ctrl.googleMapApi.LatLng(property.adresse.latitude, property.adresse.longitude));
              }
            });
            ctrl.map.controller.getGMap().panToBounds(bounds);
            if (ctrl.map.controller.getGMap().getZoom() > ctrl.map.zoom) {
              ctrl.map.controller.getGMap().setZoom(ctrl.map.zoom);
            }
            ctrl.map.controller.refresh();
          } else {
            if (ctrl.map.controller.getGMap().getZoom() > ctrl.map.zoom) {
              ctrl.map.controller.getGMap().setZoom(ctrl.map.zoom);
            }
            ctrl.map.controller.refresh({
              latitude: ctrl.map.center.latitude,
              longitude: ctrl.map.center.longitude
            });
          }

          if (angular.isFunction(ctrl.map.markersController.newModels)) {
            ctrl.map.markersController.newModels(ctrl.properties.list);
          }
        }, 350);
      } else if (iteration <= 10) {
        iteration++;
        refreshMap(iteration);
      }
    }

    function getList(search, scroll) {
      if (!scroll) ctrl.query.numero = 0;

      if (ctrl.query.numero > ctrl.properties.nblot || (ctrl.query.numero > 0 && ctrl.loading)) return;

      ctrl.loading = true;
      ctrl.map.tablist.loading = true;
      ctrl.noResults = false;

      if (ctrl.query.numero === 0) {
        ctrl.properties.nblot = 0;
        ctrl.properties.list = [];
        ctrl.properties.refList = [];
        ctrl.properties.mapnumero = 0;
        ctrl.properties.nbMapLot = 0;
        ctrl.properties.nbNotVisible = 0;
      }

      if (search) {
        ctrl.query.search = CustomUtils.collection.override(ctrl.query.search, search);
      }

      /* Patch correctif soucis de date vide */
      ctrl.query.search.datedeb = ctrl.query.search.datedeb && ctrl.query.search.datedeb !== '' ? ctrl.query.search.datedeb : null;
      ctrl.query.search.datefin = ctrl.query.search.datefin && ctrl.query.search.datefin !== '' ? ctrl.query.search.datefin : null;

      ctrl.query.refProspect = ctrl.panierProspect ? ctrl.panierProspect.referenceInterne : null;

      ctrl.query.template = ctrl.query.template || 'map';
      ctrl.query.typeMethode = 'liste';
      ctrl.query.typeApplication = globalService.getTypeApplication();

      if (ctrl.query.template === 'map') {
        ctrl.query.pas = null;
        if (ctrl.query.search.localisation === false) {
          ctrl.query.search.localisation = null;
        }
      } else {
        ctrl.query.pas = ctrl.pas;
      }

      angular.forEach(ctrl.query.search, function (param, nom) {
        var isCritere = false;
        angular.forEach(ctrl.searchBoxOptions.criteres, function (critere) {
          if (angular.isString(critere.nomChamp) && critere.nomChamp === nom) {
            isCritere = true;
          } else if (angular.isObject(critere.nomChamp) && !CustomUtils.collection.isEmpty(critere.nomChamp)) {
            for (var critereNom in critere.nomChamp) {
              if (critereNom === nom) {
                isCritere = true;
              }
            }
          }
        });

        if (isCritere) {
          ctrl.searchBoxOptions.additionalControls.searchToProspect = true;
        }
      });

      globalService.setStorageItem(ctrl.localQuery, ctrl.query);

      if (angular.isDefined(ctrl.queryWorking)) {
        $timeout.cancel(ctrl.queryWorking);
      }

      ctrl.queryWorking = $timeout(function () {
        PropertiesService.getPropertiesList(ctrl.query)
          .then(function (json) {
            if (json.status === 'OK') {
              if (ctrl.query.template !== 'map') {
                var num = ctrl.query.numero + ctrl.query.pas;
                if (ctrl.properties.nblot > 0 && num > ctrl.properties.nblot) num = ctrl.properties.nblot;
                $log.info('Récupération des biens ' + ctrl.query.numero + ' à ' + num);
              }

              ctrl.properties.nblot = json.list.nblot;
              ctrl.properties.pluriel = ctrl.properties.nblot > 1 ? 's' : '';

              $rootScope.selectionList = $rootScope.selectionList || {};

              var tempList = angular.copy(ctrl.properties.list);

              angular.forEach(json.list.biens, function (bien) {
                if (ctrl.query.template === 'map') {
                  if (bien.hasAdresse() && bien.adresse.hasCoords()) {
                    bien.markerOptions = ctrl.map.markerOptions;
                    bien.isVisible = true;
                    tempList.push(bien);
                    ctrl.properties.nbMapLot++;
                    ctrl.properties.refList.push(bien.referenceInterne);
                  } else {
                    bien.isVisible = false;
                  }
                } else {
                  tempList.push(bien);
                  ctrl.properties.refList.push(bien.referenceInterne);
                }

                $rootScope.selectionList[bien.referenceInterne] =
                  $rootScope.selectionList[bien.referenceInterne] || false;
              });

              ctrl.properties.list = tempList;

              if (ctrl.query.template === 'map') {
                ctrl.properties.mapPluriel = ctrl.properties.nbMapLot > 1 ? 's' : '';
                ctrl.properties.nbNotVisible = ctrl.properties.nblot - ctrl.properties.nbMapLot;
                ctrl.properties.notVisiblePluriel = ctrl.properties.nbNotVisible > 1 ? 's' : '';
                ctrl.properties.nblot = ctrl.properties.nbMapLot;
              }

              if (ctrl.query.numero === 0) ctrl.properties.mapnumero = 16;
              ctrl.query.numero += ctrl.query.pas;
            }

            ctrl.loading = false;
            ctrl.map.tablist.loading = false;

            if (ctrl.query.template === 'map') {
              refreshMap();
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.noResults = true;
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.loading = false;
            ctrl.map.tablist.loading = false;
          });
      });
    }

    function getNonGeolocalise() {
      ctrl.query.search.localisation = false;
      $scope.$broadcast('template-change', {
        nom: 'grid',
        icon: 'fa-th',
        tooltip: 'Grille'
      });
    }

    function setTemplate(template) {
      ctrl.query.template = template;
      ctrl.query.numero = 0;
      getList(false, false);
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.properties-list').querySelectorAll('.property-img');
      if (imgs.length && ctrl.query.template !== 'listNoPhotos') {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight =
          ctrl.query.template === 'grid' || ctrl.query.template === 'map' ?
          (width - 30) * 3 / 4 + 131 :
          (width - 30) * 3 / 4 + 30;
      }

      if (!ctrl.blocBienListener) {
        ctrl.blocBienListener = $rootScope.$watch(
          function () {
            if ($element.querySelectorAll('.properties-list').querySelectorAll('.property-img').length) {
              return $element
                .querySelectorAll('.properties-list')
                .querySelectorAll('.property-img')[0]
                .getBoundingClientRect().width;
            } else {
              return width;
            }
          },
          function (newValue, oldValue) {
            if (newValue !== oldValue) {
              imgResize();
            }
          },
          true
        );
      }
    }

    function tablistToggle() {
      if (ctrl.map.tablist.visible) ctrl.map.tablist.visible = false;
      ctrl.map.tablist.open = !ctrl.map.tablist.open;
      refreshMap();
    }

    function onRepeatComplete(tablist) {
      if (tablist) ctrl.map.tablist.loading = false;
      else ctrl.loading = false;
    }

    function mapLazyload() {
      if (ctrl.properties.nblot > ctrl.properties.mapnumero) {
        if (ctrl.properties.mapnumero) ctrl.map.tablist.loading = true;
        ctrl.properties.mapnumero += 16;
      }
    }

    function mapBoundsChanged(map) {
      if (angular.isDefined(ctrl.map.tablist.reloading)) {
        $timeout.cancel(ctrl.map.tablist.reloading);
      }

      ctrl.map.tablist.reloading = $timeout(function () {
        var bounds = map.getBounds();
        ctrl.properties.nbMapLot = 0;

        angular.forEach(ctrl.properties.list, function (property) {
          if (
            property.hasAdresse() &&
            property.adresse.hasCoords() &&
            bounds.contains(new ctrl.googleMapApi.LatLng(property.adresse.latitude, property.adresse.longitude))
          ) {
            property.isVisible = true;
            ctrl.properties.nbMapLot += 1;
          } else property.isVisible = false;
        });
        ctrl.properties.mapPluriel = ctrl.properties.nbMapLot > 1 ? 's' : '';
        ctrl.properties.mapnumero = 0;
        mapLazyload();
      }, 350);
    }

    function hideHighlightedMarker() {
      ctrl.map.markerHighlight.show = false;
      ctrl.map.markerHighlight.property = null;
    }

    function highlightMarker(property) {
      hideHighlightedMarker();

      if (angular.isDefined(ctrl.map.markerHighlight.reloading)) {
        $timeout.cancel(ctrl.map.markerHighlight.reloading);
      }

      ctrl.map.markerHighlight.reloading = $timeout(
        function () {
          ctrl.map.markerHighlight.property = property;
          ctrl.map.markerHighlight.show = true;
        },
        350,
        true,
        property
      );
    }

    function hideMapProperty() {
      ctrl.map.window.show = false;
      ctrl.map.window.property = null;
    }

    //noinspection JSUnusedLocalSymbols,JSUnusedLocalSymbols
    function markerClick(marker, event, property) {
      hideMapProperty();

      if (angular.isDefined(ctrl.map.window.reloading)) {
        $timeout.cancel(ctrl.map.window.reloading);
      }

      ctrl.map.window.reloading = $timeout(
        function () {
          ctrl.map.window.property = property;
          ctrl.map.window.show = true;
        },
        350,
        true,
        property
      );
    }

    function showFicheProperty(refLot) {
      $scope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.properties.refList
      });
    }

    function envoyerBienEmail(refLot) {
      if (ctrl.panierProspect) {
        if (!ctrl.panierProspect.referenceInterne.includes('CLOUD-')) {
          openMailForm(refLot, ctrl.panierProspect);
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: ctrl.panierProspect,
            callback: function (retour) {
              openMailForm(refLot, retour.prospect);
            }
          });
        }
      } else {
        openMailForm(refLot);
      }
    }

    function openMailForm(refLot, prospect) {
      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.error("L'e-mail n'a pas été envoyé.");
          }
        });
      });
    }

    function ajouterFavoris(lot, panier) {
      if (panier) {
        $rootScope.$emit('ajouterPanier', {
          refLot: lot.referenceInterne
        });
      } else {
        $rootScope.$emit('ajouterFavori', {
          idLot: lot.id
        });
      }
    }

    function toggleSelection(refLot, selected) {
      if (selected) {
        $log.info('Ajout du lot : [ ' + refLot + ' ] à la sélection.');
        $rootScope.$emit('ajouterSelection', {
          refLot: refLot
        });
      } else {
        $log.info('Retrait du lot : [ ' + refLot + ' ] de la sélection.');
        $rootScope.$emit('retirerSelection', {
          refLot: refLot
        });
      }
    }

    function ajouterAllSelection(refList) {
      $log.info('Ajout de tous les lots à la sélection.');
      $rootScope.$emit('ajouterAllSelection', {
        refList: refList
      });
    }

    function retirerAllSelection() {
      $log.info('Retrait de tous les lots de la sélection.');
      $rootScope.$emit('clearSelection');
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('installation', {
    templateUrl: 'app/components/main-content/installation/installation.html',
    controllerAs: 'installationctrl',
    controller: InstallationController
  });

  /** @ngInject */
  function InstallationController(
    CONSTANTS,
    globalService,
   
    $scope,
    $state,
    $stateParams,
    $timeout,
    InstallationService,
    ClientICSService,
    toastr,
    $log
  ) {
    var ctrl = this;

    ctrl.count = 0;
    ctrl.cleInstallation = "";
    ctrl.clientICS = null;
    ctrl.loading = false;
    
    ctrl.install = install;
    ctrl.etapePrecedente = etapePrecedente;
    ctrl.etapeSuivante = etapeSuivante;
    ctrl.creer = creer;
    ctrl.message = "";
    ctrl.isErreur = false;
    
    ctrl.typeApplication = globalService.getTypeApplication() || 'Transaction';
    
    ctrl.timeline = {
      current: 1,
      etapes: {
        titre: '',
        completed: false,
        etapes: [
          {
            id: 1,
            libelle: 'Cle Installation',
            icone: 'fa-key',
            completed: true,
            visited: false
          },
          {
            id: 2,
            libelle: 'Agence',
            icone: 'fa-building',
            completed: false,
            visited: false
          },
          {
            id: 3,
            libelle: 'Modèle',
            icone: 'fa-clone',
            completed: false,
            visited: false
          },
          {
            id: 4,
            libelle: 'Utilisateur',
            icone: 'fa-user',
            completed: false,
            visited: false
          }
        ]
      },
      prev: etapePrecedente,
      next: etapeSuivante,
      onChange: onChangeEtape,
      checkEtapes: checkEtapes
    };
    
    ctrl.typeAppListener = $scope.$on('typeApplication', function(event, args) {
      ctrl.typeApplication = args.transac;
    });

    ctrl.$onInit = function() {
        $log.info('initialisation');
    };

    ctrl.$onDestroy = function() {
      ctrl.typeAppListener();
      ctrl.typeAppListener = null;
    };
    
    function etapePrecedente() {
      if (ctrl.timeline.current > 1) onChangeEtape(ctrl.timeline.current - 1);
    }

    function etapeSuivante() {
      if (ctrl.timeline.current < ctrl.timeline.etapes.etapes.length) onChangeEtape(ctrl.timeline.current + 1);
    }

    function onChangeEtape(id) {
      setEtapesCompleted();
      if(ctrl.clientICS!==null){
        ctrl.timeline.etapes.etapes[ctrl.timeline.current - 1].visited = true;
        ctrl.timeline.current = id;
      }else{
        ctrl.timeline.current = 1;
        ctrl.clientICS=null;
      }
      
    }

    function checkEtapes() {
      setEtapesCompleted();
      return ctrl.timeline.etapes.completed;
    }

    function setEtapesCompleted() {
      angular.forEach(ctrl.timeline.etapes.etapes, function(etape) {
        switch (etape.id) {
          case 1:
            etape.completed = (ctrl.clientICS!==null);
            break;
          case 2:
            etape.completed = etape.visited;
            break;
          case 3:
            etape.completed = etape.visited;
            break;
          case 4:
            etape.completed = (ctrl.clientICS!=null && ctrl.clientICS.emailAdministrateur!=="" && ctrl.clientICS.passAdministrateur!=="" && etape.visited);
            break;
        }
      });
      ctrl.timeline.etapes.completed = true;
      
    }
    
    function install() {
      ctrl.loading = true;
      var params = {cleInstallation:ctrl.cleInstallation};
      InstallationService.installation(params).then(function(json){
            ctrl.loading = false;
            if (json.status === 'OK' && angular.isDefined(json.cleAgence)) {
                ctrl.clientICS = json;
                
                $log.info(json);
                etapeSuivante();
            }
            
        }).catch(function(error){
            ctrl.loading = false;
            if (error.status) {                
                ctrl.message = error.message;
                ctrl.isErreur = true;
                $log.error(error);
            }
        })
    }
    
    function creer() {
        ctrl.loading = true;
        var params = {json:ctrl.clientICS};
        $log.info(params);
        ClientICSService.creer(params).then(function(json){
            
            if (json.status === 'OK') {
                toastr.success(
                  'Cr&eacute;ation de votre agence reussi.<br>' +
                  'Vous allez etre rediriger vers la page de login.<br>' +
                  'd\'ici quelques instant<br>'
                );
                $timeout(function() {
                    $log.info('Creation Termine');
                    $state.go('login');
                },3000);
            }
            ctrl.loading = false;
        }).catch(function(error){
            if (error.status) {
                $log.error(error);
                toastr.error(
                  'La cr&eacute;ation a echoué.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',
                  'Probl&egrave;me cr&eacute;ation client (code erreur : <i>INS-183</i>)'
                );
            }
            ctrl.loading = false;
        })
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('compromis', {
    templateUrl: 'app/components/main-content/compromis/compromis.html',
    controllerAs: 'compromisctrl',
    controller: CompromisController
  });

  /** @ngInject */
  function CompromisController(
    CONSTANTS,
    globalService,
    CustomUtils,
    ImpressionService,
    ContratsService,
    $scope,
    $stateParams,
    $timeout,
    $window,
    $log
  ) {
    var ctrl = this;

    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.initialisation = true;
    ctrl.loading = false;

    ctrl.employe = globalService.getEmploye();

    ctrl.defaultQuery = {
      search: {
        recherche: null,
        societe: ctrl.employe.societe.id || null,
        nego: null,
        archive: false,
        encaissement: null,
        datedeb: null,
        datefin: null,
        isValide: true,
        type: $stateParams.type || null,
        ordre: 'triDate',
        tri: 'desc'
      },
      numero: 0,
      pas: 16,
      typeMethode: 'short'
    };

    ctrl.query = angular.copy(ctrl.defaultQuery);

    ctrl.sbConfig = {
      query: ctrl.query.search,
      defaultQuery: ctrl.defaultQuery.search,
      additionalControls: {
        tris: {
          list: CONSTANTS.dictionnaire.FR.compromis.tri,
          nomChamp: {
            tri: 'tri',
            ordre: 'ordre'
          },
          default: {
            tri: 'desc',
            ordre: 'triDate'
          }
        },
        imprimer: imprimer
      },
      filtres: {
        societes: {
          nomChamp: 'societe'
        },
        nego: {
          nomChamp: 'nego'
        },
        typeContrat: {
          nomChamp: 'type'
        },
        visibilite: {
          archive: true,
          mandat: false,
          nomChamp: {
            archive: 'archive'
          }
        },
        dateSignature: {
          datedeb: true,
          datefin: true,
          nomChamp: {
            datedeb: 'datedeb',
            datefin: 'datefin'
          }
        }
      }
    };

    ctrl.compromis = {
      list: [],
      nb: 0,
      refList: [],
      getList: getCompromisList
    };

    ctrl.showFicheCompromis = showFicheCompromis;

    ctrl.$onInit = initialisation;

    function initialisation() {
      if ($stateParams.type) {
        ctrl.query.search.type = $stateParams.type;

        if ($stateParams.type === 'vente') {
          ctrl.sbConfig.filtres.encaissement = {
            nomChamp: 'encaissement'
          };
        }

        getCompromisList(false, false);
        ctrl.initialisation = false;
      } else {
        $timeout(initialisation, 200);
      }
    }

    function getCompromisList(query, scroll) {
      if (!scroll) {
        ctrl.query.numero = 0;
        ctrl.compromis.list = [];
        ctrl.compromis.nb = 0;
      }
      if (ctrl.query.numero > 0 && (ctrl.query.numero >= ctrl.compromis.nb || ctrl.loading)) return;
      ctrl.loading = true;
      ctrl.query.search =
        angular.isDefined(query) && !CustomUtils.collection.isEmpty(query) ? query : ctrl.query.search;

      if (angular.isUndefined(ctrl.query.search.isValide) || ctrl.query.search.isValide === null)
        ctrl.query.search.isValide = true;

      $timeout.cancel(ctrl.queryWorking);
      ctrl.queryWorking = $timeout(function () {
        ContratsService.compromis
          .getList(ctrl.query)
          .then(function (retour) {
            if (retour.status === 'OK' && retour.nb > 0) {
              if (scroll) {
                angular.forEach(retour.list, function (compromis) {
                  ctrl.compromis.list.push(compromis);
                  ctrl.compromis.refList.push(compromis.id);
                });
                ctrl.query.numero += ctrl.query.pas;
              } else {
                ctrl.compromis.list = retour.list;
                ctrl.compromis.nb = retour.nb;
                ctrl.compromis.refList = [];

                angular.forEach(retour.list, function (compromis) {
                  ctrl.compromis.refList.push(compromis.id);
                });

                ctrl.query.numero = ctrl.query.pas;
              }
            }

            ctrl.loading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.compromis.list = [];
                ctrl.compromis.nb = 0;
                ctrl.compromis.refList = [];
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.loading = false;
          });
      });
    }

    function showFicheCompromis(id) {
      $scope.$emit('showFiche', {
        type: 'ficheCompromis',
        ref: id,
        refList: ctrl.compromis.refList
      });
    }

    function imprimer() {
      ImpressionService.downloadFile({
          toPdf: true,
          typeApplication: 'Transaction',
          listeCompromis: true,
          societe: angular.isDefined(ctrl.query.search.societe) ? ctrl.query.search.societe : null,
          nego: angular.isDefined(ctrl.query.search.nego) ? ctrl.query.search.nego : null,
          compromis: $stateParams.type === 'compromis',
          vente: $stateParams.type === 'vente',
          annule: false,
          byDate: true,
          dateDeb: ctrl.query.search.datedeb || null,
          dateFin: ctrl.query.search.datefin || null
        },
        'PDF'
      ).then(function (retour) {
        if (retour.status === 'OK') {
          $window.open(retour.link, '_blank');
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('accueil', {
    templateUrl: 'app/components/main-content/accueil/accueil.html',
    controllerAs: 'accueilctrl',
    controller: AccueilController
  });

  /** @ngInject */
  function AccueilController(
    CONSTANTS,
    globalService,
    EvenementsService,
    DiffusionsService,
    Evenement,
    Perso,
   
    moment,
    $window,
    $rootScope,
    $state,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.citya = CONSTANTS.configClient.citya;

    var curDate = new Date();

    var monthNames = [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre'
    ];

    var weekdayNames = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

    var panelsOpened = $window.innerWidth >= 768;

    ctrl.panelsOpen = {
      statistiques: false,
      visites: panelsOpened,
      todoliste: panelsOpened,
      actualites: panelsOpened
    };

    //####################  VISITES  ####################
    ctrl.visites = {
      list: [],
      functions: {
        getListVisites: getListVisites,
        changeDayVisite: changeDayVisite,
        getDayTitleVisite: getDayTitleVisite
      },
      displayedDate: curDate
    };

    ctrl.$onInit = function() {
      if (ctrl.employe) {
        ctrl.employe.perso = new Perso(ctrl.employe.perso);
        getListVisites(ctrl.visites.displayedDate, getNextDay(ctrl.visites.displayedDate));
        getListDiffusions(false);
      } else {
        $state.go('logout');
      }
    };

    function getDayTitleVisite() {
      return getDayTitle(ctrl.visites.displayedDate);
    }

    function changeDayVisite(direction) {
      if (direction) ctrl.visites.displayedDate.setDate(ctrl.visites.displayedDate.getDate() + 1);
      else ctrl.visites.displayedDate.setDate(ctrl.visites.displayedDate.getDate() - 1);
      getListVisites(ctrl.visites.displayedDate, getNextDay(ctrl.visites.displayedDate));
    }

    function getListVisites(dateDebut, dateFin) {
      EvenementsService.getList({
        typeMethode: 'complete',
        nego: ctrl.employe.id,
        typeIds: 2,
        compteRendu: false,
        active: true,
        debut: getDateString(dateDebut),
        fin: getDateString(dateFin)
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            ctrl.visites.list = retour.list.sort(orderByDates);
            setVisites(dateDebut);
          } else {
            ctrl.visites.list = [];
          }
        },
        function(error) {
          ctrl.visites.list = [];
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function orderByDates(a, b) {
      return moment(a.date, CONSTANTS.date_format).diff(moment(b.date, CONSTANTS.date_format));
    }

    function setVisites(dateDebut) {
      angular.forEach(ctrl.visites.list, function(visite) {
        visite.slot = getSlotVisite(visite.date, visite.dateFin, dateDebut);
        visite.description = visite.commentaire;
        visite.actions = [];

        if (visite.active === false) {
          visite.description = '(ANNULÉ) ' + visite.commentaire;
          visite.actions = visite.actions.filter(function(action) {
            return action.type !== 'annuler';
          });
        } else if (
          !visite.actions.filter(function(action) {
            return action.type === 'annuler';
          }).length
        ) {
          visite.actions.push({
            type: 'annuler',
            label:
              '<span class="visite-action-annuler"><i class="fa fa-fw fa-ban"></i><span class="hidden-xs"> Annuler</span></span>',
            onClick: function() {
              visite.active = false;
              delete visite.slot;
              delete visite.description;
              delete visite.actions;
              EvenementsService.ajouter({
                xml: new Evenement(visite).toJson(),
                nego: ctrl.employe.id,
                typeIds: 2,
                compteRendu: false,
                active: true,
                typeMethode: 'complete',
                debut: getDateString(dateDebut),
                fin: getDateString(getNextDay(dateDebut))
              }).then(
                function(retour) {
                  if (retour.status === 'OK') {
                    ctrl.visites.list = retour.list.sort(orderByDates);
                    setVisites(dateDebut);
                  }
                },
                function(error) {
                  if (error.status) {
                    if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                    else if (error.status !== 'SESSION_EXPIRED')
                      $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                  } else $log.error(error.status);
                }
              );
            }
          });
        }

        if (visite.lot) {
          if (visite.lot) {
            if (
              !visite.actions.filter(function(action) {
                return action.type === 'lot';
              }).length
            ) {
              visite.actions.unshift({
                type: 'lot',
                label:
                  '<span class="visite-action-lot"><i class="fa fa-fw fa-home"></i><span class="hidden-xs"> Lot' +
                  (visite.lot.proprietaire ? ' : ' + visite.lot.proprietaire.nomComplet : '') +
                  '</span></span>',
                onClick: function() {
                  $rootScope.$emit('showFiche', { type: 'ficheBien', ref: visite.lot.referenceInterne });
                }
              });
            }
          }
          if (visite.prospect) {
            if (
              !visite.actions.filter(function(action) {
                return action.type === 'prospect';
              }).length
            ) {
              visite.actions.unshift({
                type: 'prospect',
                label:
                  '<span class="visite-action-prospect"><i class="fa fa-fw fa-user"></i><span class="hidden-xs"> Prospect' +
                  (visite.prospect.perso ? ' : ' + visite.prospect.perso.nomComplet : '') +
                  '</span></span>',
                onClick: function() {
                  $rootScope.$emit('showFiche', { type: 'ficheProspect', ref: visite.prospect.referenceInterne });
                }
              });
            }
          }
        }
      });
    }

    //####################  TO DO LISTE  ####################
    ctrl.todoliste = {
      functions: {
        onTapButtonAddTask: onTapButtonAddTask
      },
      newTaskPanel: {
        open: false
      }
    };

    function onTapButtonAddTask() {
      ctrl.todoliste.newTaskPanel.open = !ctrl.todoliste.newTaskPanel.open;
    }

    //####################  ACTUALITES  ####################
    ctrl.actualites = {
      functions: {
        getListDiffusions: getListDiffusions,
        onViewDiffusion: onViewDiffusion
      },
      lastBienIndex: 0,
      lazyloadNumero: 0,
      nbDiffusion: 0,
      diffusions: []
    };

    function onViewDiffusion(alerteId) {
      DiffusionsService.getList({
        negoId: ctrl.employe.id,
        alerteId: alerteId,
        numero: 0,
        pas: ctrl.actualites.lazyloadNumero,
        vue: true
      }).then(
        function(retour) {
          if (retour.status === 'OK') {
            var isLocation = globalService.getTypeApplication() === 'Location';
            var indexBiens = retour.list.diffusions
              .map(function(obj, index) {
                if (angular.isDefined(obj.alerte.lot)) return index;
              })
              .filter(function(element) {
                return angular.isDefined(element);
              });
            ctrl.actualites.lastBienIndex = indexBiens[indexBiens.length - 1];
            ctrl.actualites.nbDiffusion = retour.list.nbDiffusion;
            ctrl.actualites.diffusions = retour.list.diffusions.filter(function(actualite) {
              return angular.isUndefined(actualite.isLocation) || actualite.isLocation === isLocation;
            });
          }
        },
        function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function getListDiffusions(scroll) {
      if (!scroll) ctrl.lazyloadNumero = 0;

      if (!scroll || (scroll && ctrl.panelsOpen.actualites)) {
        DiffusionsService.getList({
          negoId: ctrl.employe.id,
          numero: ctrl.actualites.lazyloadNumero,
          pas: 8,
          vue: false
        }).then(
          function(retour) {
            if (retour.status === 'OK') {
              var isLocation = globalService.getTypeApplication() === 'Location';
              var indexBiens = retour.list.diffusions
                .map(function(obj, index) {
                  if (angular.isDefined(obj.alerte.lot)) return index;
                })
                .filter(function(element) {
                  return angular.isDefined(element);
                });
              ctrl.actualites.lastBienIndex = indexBiens[indexBiens.length - 1];
              ctrl.actualites.nbDiffusion = retour.list.nbDiffusion;
              ctrl.actualites.diffusions = ctrl.actualites.diffusions.concat(
                retour.list.diffusions.filter(function(actualite) {
                  return angular.isUndefined(actualite.isLocation) || actualite.isLocation === isLocation;
                })
              );
              ctrl.actualites.lazyloadNumero += 8;
            }
          },
          function(error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          }
        );
      }
    }

    //####################  UTILS DATES  ####################
    function getDayTitle(date) {
      return (
        weekdayNames[date.getDay()] +
        ' ' +
        date.getDate() +
        ' ' +
        monthNames[date.getMonth()] +
        ' ' +
        date.getFullYear()
      );
    }

    function getDateString(date) {
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return day + '/' + month + '/' + date.getFullYear();
    }

    function getSlotVisite(dateDebut, dateFin, debutDisplayed) {
      var dateTimeStart = dateDebut.split(' ');
      var dateStart = dateTimeStart[0];
      var result = '';
      if (dateStart === getDateString(debutDisplayed) && dateTimeStart[1] !== '00h00') result += dateTimeStart[1];
      if (dateFin) {
        var dateTimeEnd = dateFin.split(' ');
        var dateEnd = dateTimeEnd[0];
        if (dateStart === dateEnd && dateTimeEnd[1] !== '00h00') result += ' - ' + dateTimeEnd[1];
      }
      if (result === '') result += 'journée ent.';
      result += ' :';
      return result;
    }

    function getNextDay(date) {
      var dateFinVisites = angular.copy(date);
      dateFinVisites.setDate(date.getDate() + 1);
      return dateFinVisites;
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('selection', {
    templateUrl: 'app/components/header/selection/selection.html',
    controllerAs: 'selectionctrl',
    controller: SelectionController,
    bindings: {
      onSelectionChange: '&',
      onClickBack: '&'
    }
  });

  /** @ngInject */
  function SelectionController(
    CONSTANTS,
    globalService,
    PropertiesService,
    $rootScope,
    Prospect,
    MailService,
    $uibModal,
    ImpressionService,
    $element,
    toastr,
    hotkeys,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.selection = {
      list: [],
      nb: 0,
      refList: [],
      getList: getSelectionList,
      supprimer: supprimerSelection
    };

    ctrl.search = {
      references: null,
      tri: 'desc',
      ordre: 'triDate'
    };

    ctrl.tris = {
      open: false,
      list: CONSTANTS.dictionnaire.FR.listebien.tri,
      ordre: 'triDate',
      tri: 'desc',
      trier: function () {
        ctrl.search.tri = ctrl.tris.tri;
        ctrl.search.ordre = ctrl.tris.ordre;
        getSelectionList();
      }
    };

    ctrl.blocBienHeight = 0;

    ctrl.imprimer = imprimer;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.ajouterFavoris = ajouterFavoris;
    ctrl.clearSelection = clearSelection;
    ctrl.showFiche = showFiche;
    ctrl.imgResize = imgResize;

    ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT') ? globalService.getStorageItem('PANIER-PROSPECT') : null;
    ctrl.panierActifListener = $rootScope.$on('panierActif', function (event, active) {
      if (active) {
        ctrl.panierProspect = globalService.getStorageItem('PANIER-PROSPECT');
      }
    });

    ctrl.onSelectionChangedListener = $rootScope.$on('selection-changed', function () {
      ctrl.selection.getList();
    });

    ctrl.$onInit = function () {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+e',
          description: 'Envoyer par email',
          callback: function () {
            ctrl.envoyerEmail();
          }
        })
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fenêtre de selection',
          callback: function () {
            ctrl.onClickBack();
          }
        });

      getSelectionList();
    };

    ctrl.$onDestroy = function () {
      ctrl.panierActifListener();
      ctrl.onSelectionChangedListener();
    };

    function imprimer() {
      var impression = {
        lotsid: ''
      };

      angular.forEach(ctrl.selection.list, function (property, index) {
        impression.lotsid += property.id;
        if (index < ctrl.selection.list.length - 1) impression.lotsid += ',';
      });

      ImpressionService.openImpression(impression);
    }

    function getSelectionList() {
      ctrl.selection.refList = globalService.getStorageItem('SELECTION-LIST') || [];
      ctrl.selection.nb = ctrl.selection.refList.length;

      if (ctrl.selection.nb) {
        /* var references = '';
        angular.forEach(ctrl.selection.refList, function (ref, index) {
          references += ref;
          if (index < ctrl.selection.nb - 1) {
            references += ',';
          }
        }); */

        ctrl.search.references = ctrl.selection.refList.join(',');

        PropertiesService.getPropertiesList({
            search: ctrl.search,
            typeMethode: 'liste',
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (retour) {
            if (retour.status === 'OK') {
              ctrl.selection.list = retour.list.biens;
              ctrl.selection.nb = retour.list.nblot;
            }
          })

          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  'Une erreur s&apos;est produite lors de la r&eacute;cup&eacute;ration des coups de coeurs.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                  'Probl&egrave;me r&eacute;cup&eacute;ration coups de coeur (code erreur : <i>HDR-SLC-142</i>)',

                  {
                    timeOut: 8000
                  }
                );
              }
            } else $log.error(error.status);
          });
      } else {
        ctrl.selection.list = [];
        ctrl.selection.nb = 0;
      }
    }

    function supprimerSelection(refLot) {
      ctrl.selection.refList = ctrl.selection.refList.filter(function (ref) {
        return ref !== refLot;
      });

      globalService.setStorageItem('SELECTION-LIST', ctrl.selection.refList);
      ctrl.selection.nb = ctrl.selection.refList.length;

      getSelectionList();

      ctrl.onSelectionChange({
        refList: ctrl.selection.refList
      });
    }

    function clearSelection() {
      ctrl.selection.list = [];
      ctrl.selection.refList = [];
      ctrl.selection.nb = 0;
      $rootScope.$broadcast('clearSelection');
    }

    function envoyerEmail(refLot) {
      if (ctrl.panierProspect) {
        if (!ctrl.panierProspect.referenceInterne.includes('CLOUD-')) {
          openMailForm(refLot, ctrl.panierProspect);
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: ctrl.panierProspect,
            callback: function (retour) {
              openMailForm(refLot, retour.prospect);
            }
          });
        }
      } else {
        openMailForm(refLot);
      }
    }

    function openMailForm(refLot, prospect) {
      if (angular.isUndefined(refLot)) {
        refLot = '';
        angular.forEach(ctrl.selection.list, function (property, index) {
          refLot += property.referenceInterne;
          if (index <= ctrl.selection.list.length) refLot += ',';
        });
      }

      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== selection.component.js l.201");
          }
        });
      });
    }

    function ajouterFavoris(lot, panier) {
      if (panier) {
        $rootScope.$emit('ajouterPanier', {
          refLot: lot.referenceInterne
        });
      } else {
        $rootScope.$emit('ajouterFavori', {
          idLot: lot.id
        });
      }
    }

    function showFiche(refLot) {
      $scope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.selection.refList
      });
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.selection-list').querySelectorAll('.property-img');
      if (imgs.length) {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight = (width - 30) * 3 / 4 + 30;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .component('report', {
      templateUrl: 'app/components/header/report/report.html',
      controllerAs: 'reportctrl',
      controller: ReportController,
      bindings: {
        onClickBack: '&'
      }
    });

  /** @ngInject */
  function ReportController(globalService,ReportService , toastr) {
    var ctrl = this;

    ctrl.sendReport = sendReport;

    ctrl.$onInit = function () {

    };

    ctrl.$onDestroy = function () {

    };
    // /0: urgent, 1: major, 2: minor, 3: info, 4: feature request
    ctrl.niveau_priorites = [{'id': 0, 'label': 'Urgent'},
                             {'id': 1, 'label': 'Majeur'},
                             {'id': 2, 'label': 'Mineur'},
                             {'id': 3, 'label': 'Infos'},
                             {'id': 4, 'label': 'Demande de fonctionnalités'}]
    ctrl.niveau_priorite = null;
    function sendReport(){
		var envoyerReport ={'anomalieConnue':ctrl.dejaRencontre,
		'description':ctrl.description,
        'priorite':ctrl.niveau_priorite,
		'explication':ctrl.explication};

		var params = {'json':envoyerReport};
		ReportService.envoyer(params).then(function (json){
            if(json.status==='OK')
                toastr.success('Succes', 'Votre report a été envoyé avec succes a notre service developpement');
            else
                toastr.error('Erreur','Erreur lors de l\'envoie');
		}).catch(function (){
            toastr.error('Erreur','Erreur lors de l\'envoie');
		});



    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('panier', {
    templateUrl: 'app/components/header/panier/panier.html',
    controllerAs: 'panierctrl',
    controller: PanierController,
    bindings: {
      currentProspect: '<',
      onChoseProspect: '&',
      onRemovePanier: '&',
      onPanierChange: '&',
      onClickBack: '&'
    }
  });

  /** @ngInject */
  function PanierController(
    CONSTANTS,
    globalService,

    CustomUtils,
    ProspectsService,
    PanierService,
    CriteresParser,
    EvenementsService,
    ContratsService,
    VisiteService,
    moment,
    $ocLazyLoad,
    ImpressionService,
    MailService,
    Prospect,
    hotkeys,
    $uibModal,
    ngDialog,
    $rootScope,
    $state,
    $element,
    $scope,
    toastr,
    $window,
    $timeout,
    $log
  ) {
    var ctrl = this;

    ctrl.globalService = globalService;
    ctrl.employe = globalService.getEmploye();

    ctrl.panier = {
      loading: false,
      list: [],
      refList: [],
      nb: 0,
      getList: getPanierList,
      supprBien: supprBien,
      supprAllBien: supprAllBien
    };

    ctrl.prospect = {
      open: false,
      loading: false,
      saved: null,
      recherche: null,
      current: null,
      list: [],
      nbResult: 0,
      searchProspect: searchProspect,
      selectProspect: selectProspect,
      saveProspect: saveProspect,
      editProspect: editProspect,
      creerProspect: creerProspect,
      removeProspect: removeProspect
    };

    ctrl.sbConfig = {
      placeholder: 'MARTIN',
      cloud: true,
      visite: {
        context: 'S1'
      }
    };

    ctrl.bonVisite = {
      selection: [],
      generer: genererBonVisite
    };

    ctrl.evenement = {
      open: false,
      refLot: null,
      currentId: null,
      nouveau: null,
      fullScreen: false,
      societes: null,
      nego: null,
      onNouveau: onNewEvent,
      onChose: onChoseDate,
      onEdit: onEditEvent,
      onAnnuler: onAnulerEvent,
      onClose: onCloseEvent,
      onFullScreen: onFullScreen,
      onSelectSocietes: onSelectSocietes,
      onSelectNego: onSelectNego
    };

    ctrl.calendar = {
      reloading: false,
      events: [],
      title: '',
      view: 'day',
      viewDate: moment().toDate(),
      date: null,
      dateFin: null,
      onClick: onClickCalendar
    };

    ctrl.allSelected = false;

    ctrl.blocBienHeight = 0;

    ctrl.envoyerEmail = envoyerEmail;
    ctrl.imprimer = imprimer;
    ctrl.showFiche = showFiche;
    ctrl.newContrat = newContrat;
    ctrl.toggleSelection = toggleSelection;
    ctrl.selectAll = selectAll;
    ctrl.rapprocher = rapprocher;
    ctrl.onEvent = onEvent;
    ctrl.imgResize = imgResize;

    ctrl.$onInit = function () {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+m',
          description: 'Modifier',
          callback: function () {
            $state.go('modifProspect', {
              reference: ctrl.prospect.current.referenceInterne,
              typeApplication: globalService.getTypeApplication()
            });
          }
        })
        .add({
          combo: 'alt+c',
          description: 'Communication prospect',
          callback: function () {
            $state.go('modifProspect', {
              reference: ctrl.prospect.current.referenceInterne,
              typeApplication: globalService.getTypeApplication(),
              etape: 5
            });
          }
        })
        .add({
          combo: 'alt+b',
          description: 'Generer bon de visite',
          callback: function () {
            ctrl.bonVisite.generer();
          }
        })
        .add({
          combo: 'alt+s',
          description: 'Tout (de)selectionner',
          callback: function () {
            ctrl.selectAll();
          }
        })
        .add({
          combo: 'alt+m',
          description: 'Envoyer par mail',
          callback: function () {
            ctrl.envoyerEmail();
          }
        })
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function () {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'alt+e',
          description: 'Enregistrer le prospect',
          callback: function () {
            ctrl.prospect.saveProspect();
          }
        })
        .add({
          combo: 'alt+q',
          description: 'Quitter le panier',
          callback: function () {
            ctrl.prospect.removeProspect();
          }
        })
        .add({
          combo: 'esc',
          description: 'Fermer la fenêtre panier',
          callback: function () {
            if (ctrl.evenement.open) {
              onCloseEvent();
            } else {
              ctrl.onClickBack();
            }
          }
        });

      if (angular.isDefined(ctrl.currentProspect) && ctrl.currentProspect !== null) {
        selectProspect(ctrl.currentProspect);
      } else if (globalService.getStorageItem('PANIER-PROSPECT')) {
        selectProspect(globalService.getStorageItem('PANIER-PROSPECT'));
      }

      $window.moment = $window.moment || moment;
      $ocLazyLoad.load('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.10.6/locale/fr.js').then(function () {
        moment.locale('fr', {
          week: {
            dow: 1
          }
        });
        moment.locale('fr');
      });
    };

    $scope.$watch(
      function () {
        return ctrl.calendar.date;
      },
      function (newValue, oldValue) {
        if (
          newValue !== oldValue &&
          !moment(newValue, CONSTANTS.date_format).isSame(moment(oldValue, CONSTANTS.date_format), 'day')
        ) {
          ctrl.calendar.viewDate = moment(newValue, CONSTANTS.date_format).toDate();
          getEvents();
        }
      },
      true
    );

    function supprBien(refLot) {
      ctrl.panier.loading = true;
      ctrl.panier.list = [];
      ctrl.panier.nb = 0;

      PanierService.setPanier({
          prospect: ctrl.prospect.current.referenceInterne,
          lot: refLot,
          action: 'suppr',
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (bien) {
              ctrl.panier.refList.push(bien.lot.referenceInterne);
            });
          }

          ctrl.panier.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') {
              $log.warn(error.message);
              ctrl.onPanierChange({
                nb: 0
              });
            } else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.panier.loading = false;
        });
    }

    function supprAllBien() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous retirer tous les biens de ce panier ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return false;
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          ctrl.panier.loading = true;
          ctrl.panier.list = [];
          ctrl.panier.nb = 0;

          PanierService.setPanier({
              prospect: ctrl.prospect.current.referenceInterne,
              action: 'supprAll',
              typeMethode: 'liste',
              typeApplication: globalService.getTypeApplication()
            })
            .then(function (retour) {
              if (retour.status === 'OK') {
                ctrl.panier.list = retour.list;
                ctrl.panier.nb = retour.nb;
                ctrl.onPanierChange({
                  nb: ctrl.panier.nb
                });

                ctrl.panier.refList = [];
                angular.forEach(ctrl.panier.list, function (bien) {
                  ctrl.panier.refList.push(bien.lot.referenceInterne);
                });
              }

              ctrl.panier.loading = false;
            })
            .catch(function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') {
                  $log.warn(error.message);
                  ctrl.onPanierChange({
                    nb: 0
                  });
                } else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              ctrl.panier.loading = false;
            });
        }
      });
    }

    function searchProspect(search) {
      ctrl.prospect.list = [];
      ctrl.prospect.nbResult = 0;
      ctrl.prospect.recherche = search.recherche;
      ctrl.prospect.loading = true;
      ctrl.prospect.open = true;

      ProspectsService.getListe({
          search: search || null,
          numero: 0,
          pas: 15,
          typeApplication: globalService.getTypeApplication(),
          typeMethode: 'simple'
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.prospect.list = retour.prospects;
            ctrl.prospect.nbResult = retour.nb;
          }

          ctrl.prospect.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') {
              $log.warn(error.message);
            } else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.prospect.loading = false;
        });
    }

    function selectProspect(prospect) {
      ctrl.prospect.saved = false;

      if (prospect.referenceInterne && !prospect.referenceInterne.includes('CLOUD-')) {
        ctrl.prospect.loading = true;

        ProspectsService.getListe({
          search: {
            reference: prospect.referenceInterne
          },
          typeMethode: 'complete'
        }).then(
          function (retour) {
            if (retour.status === 'OK') {
              ctrl.prospect.current = retour.prospects[0];
              ctrl.onChoseProspect({
                prospect: ctrl.prospect.current
              });
              ctrl.panier.getList(ctrl.prospect.current.referenceInterne);
              ctrl.prospect.open = false;
              ctrl.prospect.saved = true;
            }
            ctrl.prospect.loading = false;
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            ctrl.prospect.loading = false;
          }
        );
      } else {
        ctrl.prospect.current = new Prospect(prospect);
        ctrl.onChoseProspect({
          prospect: ctrl.prospect.current,
          nb: 0,
          external: true
        });
        ctrl.prospect.saved = false;
        ctrl.prospect.open = false;
        ctrl.panier.list = [];
        ctrl.panier.refList = [];
        ctrl.panier.nb = 0;
      }
    }

    function saveProspect(callback, fromcloud) {
      fromcloud = angular.isDefined(fromcloud) ? fromcloud : false;

      ctrl.prospect.loading = true;
      if (!ctrl.prospect.current.referenceInterne.includes('CLOUD-')) {
        var params = {
          xmlProspect: ctrl.prospect.current.toJson(),
          typeApplication: globalService.getTypeApplication(),
          typeMethode: 'complete'
        };

        if (fromcloud) {
          params.fromcloud = true;
        }

        ProspectsService.editerProspect(params)
          .then(function (retour) {
            if (retour.status === 'OK') {
              ctrl.prospect.current = retour.prospect;
              ctrl.onChoseProspect({
                prospect: ctrl.prospect.current
              });
              ctrl.panier.getList(ctrl.prospect.current.referenceInterne);
              ctrl.prospect.open = false;
              ctrl.prospect.saved = true;
              if (angular.isFunction(callback)) {
                callback({
                  status: 'OK',
                  prospect: ctrl.prospect.current
                });
              }
            } else $rootScope.$broadcast('panierActif', false);
            ctrl.prospect.loading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            $rootScope.$broadcast('panierActif', false);
            ctrl.prospect.loading = false;
          });
      } else {
        ProspectsService.editerProspect({
            addProspect: true,
            typeApplication: globalService.getTypeApplication(),
            typeMethode: 'complete'
          })
          .then(function (json) {
            if (json.status === 'OK') {
              ctrl.prospect.current.id = json.prospect.id;
              ctrl.prospect.current.referenceInterne = json.prospect.referenceInterne;
              ctrl.prospect.current = ctrl.prospect.current.isModel ?
                ctrl.prospect.current :
                new Prospect(ctrl.prospect.current);
              saveProspect(callback, true);
            }

            ctrl.prospect.loading = false;
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
            $rootScope.$broadcast('panierActif', false);
            ctrl.prospect.loading = false;
          });
      }
    }

    function editProspect(etape) {
      if (!ctrl.prospect.current.referenceInterne.includes('CLOUD-')) {
        $state.go('modifProspect', {
          reference: ctrl.prospect.current.referenceInterne,
          typeApplication: globalService.getTypeApplication(),
          etape: etape
        });
      } else {
        saveProspect(function (retour) {
          $state.go('modifProspect', {
            reference: retour.prospect.referenceInterne,
            typeApplication: globalService.getTypeApplication(),
            etape: etape
          });
        }, true);
      }
    }

    function creerProspect() {
      ProspectsService.editerProspect({
          addProspect: true,
          typeApplication: globalService.getTypeApplication(),
          typeMethode: 'complete'
        })
        .then(function (json) {
          if (json.status === 'OK')
            $state.go('modifProspect', {
              reference: json.prospect.referenceInterne,
              typeApplication: globalService.getTypeApplication(),
              nom: ctrl.prospect.recherche
            });
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });
    }

    function removeProspect() {
      ctrl.prospect.current = null;
      ctrl.onRemovePanier();
    }

    function getPanierList(refProspect) {
      ctrl.panier.loading = true;
      ctrl.panier.list = [];
      ctrl.panier.nb = 0;

      PanierService.getPanier({
          prospect: refProspect,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            $rootScope.selectionList = $rootScope.selectionList || {};

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (bien) {
              ctrl.panier.refList.push(bien.lot.referenceInterne);
              $rootScope.selectionList[bien.lot.referenceInterne] =
                $rootScope.selectionList[bien.lot.referenceInterne] || false;

              if ($rootScope.selectionList[bien.lot.referenceInterne]) {
                ctrl.bonVisite.selection.push(bien.lot.id);
              }
            });
          }

          ctrl.panier.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          ctrl.panier.loading = false;
        });
    }

    function imprimer() {
      var impression = {
        lotsid: '',
        prospectsid: ctrl.prospect.current.id
      };

      angular.forEach(ctrl.panier.list, function (lot, index) {
        impression.lotsid += lot.lot.id;
        if (index < ctrl.panier.list.length - 1) impression.lotsid += ',';
      });

      ImpressionService.openImpression(impression);
    }

    function envoyerEmail(refLot) {
      if (ctrl.prospect.current && ctrl.prospect.current.hasOwnProperty('referenceInterne')) {
        if (!ctrl.prospect.current.referenceInterne.includes('CLOUD-')) {
          openMailForm(refLot, ctrl.prospect.current);
        } else {
          saveProspect(function (retour) {
            openMailForm(refLot, retour.prospect);
          }, true);
        }
      } else {
        openMailForm(refLot);
      }
    }

    function openMailForm(refLot, prospect) {
      if (angular.isUndefined(refLot)) {
        refLot = '';
        angular.forEach(ctrl.panier.list, function (bien, index) {
          refLot += bien.lot.referenceInterne;
          if (index <= ctrl.panier.list.length) refLot += ',';
        });
      }

      MailService.getModel({
        lots: refLot,
        prospects: prospect.referenceInterne,
        typeApplication: globalService.getTypeApplication()
      }).then(function (retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function () {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function (retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== panier.component.js l.521");
          }
        });
      });
    }

    function showFiche(refLot) {
      $scope.$emit('showFiche', {
        type: 'ficheBien',
        ref: refLot,
        refList: ctrl.panier.refList
      });
    }

    function onEvent(refLot, event) {
      ctrl.evenement.refLot = refLot;
      if (event) {
        var date = moment(event.date, CONSTANTS.date_format);
        if (date.hour() < 1) {
          var current = moment();
          date.hour(current.hour());
          date.minute(current.minute());
        }

        ctrl.evenement.currentId = event.id;
        ctrl.calendar.viewDate = ctrl.calendar.date = date.toDate();
        ctrl.evenement.nouveau = true;
      } else {
        ctrl.calendar.viewDate = ctrl.calendar.date = moment().toDate();
      }
      ctrl.evenement.open = true;
      getEvents();
    }

    function onChoseDate(formatedDatetime, formatedDatetimeFin) {
      ctrl.evenement.datetime = formatedDatetime;
      ctrl.evenement.datetimeFin = formatedDatetimeFin;
      addEvent(ctrl.evenement.refLot, formatedDatetime, formatedDatetimeFin);
      onCloseEvent();
    }

    function onCloseEvent() {
      ctrl.evenement.open = false;
      ctrl.evenement.refLot = null;
      ctrl.evenement.currentId = null;
      ctrl.evenement.nouveau = false;
      ctrl.evenement.fullScreen = false;
    }

    function onFullScreen(fullScreen) {
      ctrl.evenement.fullScreen = fullScreen;
    }

    function onSelectSocietes(societes) {
      ctrl.evenement.societes = societes;
      getEvents();
    }

    function onSelectNego(nego) {
      ctrl.evenement.nego = nego;
      getEvents();
    }

    function addEvent(refLot, date, dateFin) {
      PanierService.evenement({
          nego: ctrl.evenement.nego ? ctrl.evenement.nego : ctrl.employe.id,
          prospect: ctrl.prospect.current.referenceInterne,
          lot: refLot,
          evenementId: ctrl.evenement.currentId ? ctrl.evenement.currentId : null,
          dateEvenement: date,
          dateFinEvenement: dateFin ? dateFin : null,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            var idLot = 0;
            angular.forEach(ctrl.panier.list, function (bien) {
              ctrl.panier.refList.push(bien.lot.referenceInterne);

              if (bien.lot.referenceInterne === refLot) idLot = bien.lot.id;
            });
            checkBonVisite(idLot);
          }

          ctrl.panier.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de l&apos;ajout de l&apos;&eacute;v&egrave;nement.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me ajout &eacute;v&egrave;nement (code erreur : <i>HDR-PNR-707</i>)',

                {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
          ctrl.panier.loading = false;
        });
    }

    function onEditEvent(refLot, event) {
      PanierService.evenement({
          prospect: ctrl.prospect.current.referenceInterne,
          lot: refLot,
          evenementId: event.id,
          dateEvenement: event.date,
          dateFinEvenement: event.dateFin ? event.dateFin : null,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (bien) {
              ctrl.panier.refList.push(bien.lot.referenceInterne);
            });
          }

          ctrl.panier.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de l&apos;ajout de l&apos;&eacute;v&egrave;nement.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me ajout &eacute;v&egrave;nement (code erreur : <i>HDR-PNR-771</i>)',

                {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
          ctrl.panier.loading = false;
        });
    }

    function onNewEvent(date, dateFin) {
      ctrl.evenement.currentId = null;
      addEvent(ctrl.evenement.refLot, date, dateFin);
    }

    function onAnulerEvent() {
      PanierService.evenement({
          prospect: ctrl.prospect.current.referenceInterne,
          lot: ctrl.evenement.refLot,
          evenementId: ctrl.evenement.currentId,
          annuler: true,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.panier.list = retour.list;
            ctrl.panier.nb = retour.nb;
            ctrl.onPanierChange({
              nb: ctrl.panier.nb
            });

            ctrl.panier.refList = [];
            angular.forEach(ctrl.panier.list, function (bien) {
              ctrl.panier.refList.push(bien.lot.referenceInterne);
            });
          }

          ctrl.panier.loading = false;
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de l&apos;annulation de l&apos;&eacute;v&egrave;nement.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me ajout &eacute;v&egrave;nement (code erreur : <i>HDR-PNR-838</i>)',

                {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
          ctrl.panier.loading = false;
        });
    }

    function checkBonVisite(idLot) {
      if (idLot) {
        var confirmDialog = ngDialog.openConfirm({
          templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
          controller: 'ConfirmDialogController',
          controllerAs: 'confirmdialogctrl',
          resolve: {
            titre: function titreFactory() {
              return false;
            },
            message: function messageFactory() {
              return 'Souhaitez-vous générer un bon de visite ?';
            },
            commentaire: function commentaireFactory() {
              return false;
            },
            confirmText: function confirmTextFactory() {
              return 'Générer';
            },
            annulerText: function annulerTextFactory() {
              return false;
            }
          }
        });

        confirmDialog.then(function (data) {
          if (data.status === 'OK') {
            ctrl.bonVisite.selection = [idLot];
            genererBonVisite();
          }
        });
      }
    }

    function onClickCalendar(calendarDate) {
      ctrl.calendar.reloading = true;
      ctrl.calendar.date = moment(calendarDate).format(CONSTANTS.date_format);
      $timeout(function () {
        ctrl.calendar.reloading = false;
      });
    }

    function getEvents() {
      if (moment(ctrl.calendar.viewDate).isValid()) {
        EvenementsService.getList({
            socIds: ctrl.evenement.societes,
            nego: ctrl.evenement.nego ? ctrl.evenement.nego : ctrl.employe.id,
            debut: moment(ctrl.calendar.viewDate)
              .startOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            fin: moment(ctrl.calendar.viewDate)
              .endOf(ctrl.calendar.view)
              .format(CONSTANTS.date_format),
            forAgenda: true,
            active: true,
            typeMethode: 'complete'
          })
          .then(function (retour) {
            if (retour.status === 'OK') {
              ctrl.calendar.events = retour.list;
              setEvents();
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') {
                $log.warn(error.message);
                ctrl.calendar.events = [];
              } else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          });
      }
    }

    function setEvents() {
      angular.forEach(ctrl.calendar.events, function (event) {
        event.title = event.commentaire;
        event.color = {
          primary: event.color || event.type.couleur.replace('0x', '#'),
          secondary: shadeBlend(-0.2, event.type.couleur.replace('0x', '#'))
        };
        event.startsAt = moment(event.date, CONSTANTS.date_format).toDate();
        event.endsAt = event.dateFin ?
          moment(event.dateFin, CONSTANTS.date_format).toDate() :
          moment(event.date, CONSTANTS.date_format)
          .add(1, 'h')
          .toDate();

        if (event.id === ctrl.evenement.currentId) {
          event.cssClass = 'current-event-highlight ' + globalService.getTypeApplication();
        }
      });
    }

    function newContrat(refLot) {
      if (ctrl.prospect.current) {
        var query = {
            lotRef: refLot,
            prospectRef: ctrl.prospect.current.referenceInterne,
            typeApplication: globalService.getTypeApplication()
          },
          request;
        if (globalService.getTypeApplication() === 'Transaction') {
          request = ContratsService.compromis.nouveau(query);
        } else {
          request = ContratsService.reservations.nouvelle(query);
        }

        request.then(function (retour) {
          if (retour.status === 'OK') {
            if (globalService.getTypeApplication() === 'Transaction') {
              $state.go('modifCompromis', {
                reference: retour.compromis.id
              });
            } else {
              $state.go('modifReservation', {
                reference: retour.reservation.id
              });
            }
          }
        });
      }
    }

    function toggleSelection(refLot, idLot, selected) {
      if (selected) {
        $log.info('Ajouter le lot : [ ' + refLot + ' ] à la sélection.');

        if (!CustomUtils.collection.contains(ctrl.bonVisite.selection, idLot)) {
          ctrl.bonVisite.selection.push(idLot);
        }

        $rootScope.$emit('ajouterSelection', {
          refLot: refLot
        });
      } else {
        $log.info('Retirer le lot : [ ' + refLot + ' ] de la sélection.');

        ctrl.bonVisite.selection = ctrl.bonVisite.selection.filter(function (id) {
          return id !== idLot;
        });

        $rootScope.$emit('retirerSelection', {
          refLot: refLot
        });
      }
    }

    function selectAll() {
      ctrl.allSelected = !ctrl.allSelected;
      angular.forEach(ctrl.panier.list, function (lot) {
        lot.lot.isSelected = ctrl.allSelected;
        toggleSelection(lot.lot.referenceInterne, lot.lot.id, lot.lot.isSelected);
      });
    }

    function rapprocher() {
      var query = globalService.getStorageItem('QUERY-LISTE-BIEN') || {
        search: null
      };

      query.search = CriteresParser.prospectToSearch(ctrl.prospect.current);

      globalService.setStorageItem('QUERY-LISTE-BIEN', query);
      $state.go('listeBien', {}, {
        reload: true
      });
    }

    function genererBonVisite() {
      if (ctrl.bonVisite.selection.length) {
        ctrl.panier.loading = true;

        VisiteService.bonVisite({
            lotIdsVisite: ctrl.bonVisite.selection.join(','),
            prospectId: ctrl.prospect.current.id,
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (retour) {
            var url = globalService.baseUrl() + 'Download';

            if (globalService.getTypeApplication() === 'Location') {
              url += 'Location';
            }

            url += '?edition=edition&filename=' + retour.fileName + '&path=' + retour.path;

            $window.open(url, '_blank');

            ctrl.panier.loading = false;
          })
          .catch(function (error) {
            $log.info(error);
            ctrl.panier.loading = false;
          });
      } else {
        toastr.warning(
          'Vous devez s&eacute;lectionner au moins un bien pour pouvoir g&eacute;n&eacute;rer un bon de visite.<br>',

          'Aucun bien s&eacute;lectionn&eacute;<br>',

          {
            timeOut: 8000
          }
        );
      }
    }

    function shadeBlend(p, c0, c1) {
      var n = p < 0 ? p * -1 : p,
        u = Math.round,
        w = parseInt,
        f,
        t;
      if (c0.length > 7) {
        f = c0.split(',');
        t = (c1 ? c1 : p < 0 ? 'rgb(0,0,0)' : 'rgb(255,255,255)').split(',');
        var R = w(f[0].slice(4)),
          G = w(f[1]),
          B = w(f[2]);
        return (
          'rgb(' +
          (u((w(t[0].slice(4)) - R) * n) + R) +
          ',' +
          (u((w(t[1]) - G) * n) + G) +
          ',' +
          (u((w(t[2]) - B) * n) + B) +
          ')'
        );
      } else {
        f = w(c0.slice(1), 16);
        t = w((c1 ? c1 : p < 0 ? '#000000' : '#FFFFFF').slice(1), 16);
        var R1 = f >> 16,
          G1 = (f >> 8) & 0x00ff,
          B1 = f & 0x0000ff;
        return (
          '#' +
          (
            0x1000000 +
            (u(((t >> 16) - R1) * n) + R1) * 0x10000 +
            (u((((t >> 8) & 0x00ff) - G1) * n) + G1) * 0x100 +
            (u(((t & 0x0000ff) - B1) * n) + B1)
          )
          .toString(16)
          .slice(1)
        );
      }
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.panier-list').querySelectorAll('.bien-img');
      if (imgs.length) {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight = (width - 30) * 3 / 4 + 30;
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').component('favoris', {
    templateUrl: 'app/components/header/favoris/favoris.html',
    controllerAs: 'favorisctrl',
    controller: FavorisController,
    bindings: {
      onFavorisChange: '&',
      onClickBack: '&'
    }
  });

  /** @ngInject */
  function FavorisController(
    globalService,
    FavorisService,
    ImpressionService,
    $rootScope,
    MailService,
    $uibModal,

    Prospect,
    $element,
    toastr,
    hotkeys,
    $scope,
    $log
  ) {
    var ctrl = this;

    ctrl.employe = globalService.getEmploye();

    ctrl.titre = ctrl.employe.societe.agence.coupCoeurAgence ? 'Biens urgent' : 'Coups de coeur';

    ctrl.favoris = {
      list: [],
      nb: 0,
      refList: [],
      getList: getFavorisList,
      supprimer: supprimerFavori
    };

    ctrl.blocBienHeight = 0;

    ctrl.panierProspect = !!globalService.getStorageItem('PANIER-PROSPECT');
    ctrl.panierActifListener = $rootScope.$on('panierActif', function(event, active) {
      ctrl.panierProspect = active;
    });

    ctrl.imprimer = imprimer;
    ctrl.envoyerEmail = envoyerEmail;
    ctrl.showFiche = showFiche;
    ctrl.ajouterFavoris = ajouterFavoris;
    ctrl.toggleSelection = toggleSelection;
    ctrl.imgResize = imgResize;

    ctrl.$onInit = function() {
      hotkeys
        .bindTo($scope)
        .add({
          combo: 'alt+e',
          description: 'Envoyer par email',
          callback: function() {
            ctrl.envoyerEmail();
          }
        })
        .add({
          combo: 'alt+i',
          description: 'Imprimer',
          callback: function() {
            ctrl.imprimer();
          }
        })
        .add({
          combo: 'esc',
          description:
            'Fermer la fenêtre des ' +
            (ctrl.employe.societe.agence.coupCoeurAgence ? 'biens urgent' : 'coups de coeur'),
          callback: function() {
            ctrl.onClickBack();
          }
        });

      ctrl.favoris.getList();
    };

    ctrl.$onDestroy = function() {
      ctrl.panierActifListener();
      ctrl.panierActifListener = null;
    };

    function imprimer() {
      var impression = {
        lotsid: ''
      };

      angular.forEach(ctrl.favoris.list, function(favori, index) {
        impression.lotsid += favori.lot.id;
        if (index < ctrl.favoris.list.length - 1) impression.lotsid += ',';
      });

      ImpressionService.openImpression(impression);
    }

    function getFavorisList() {
      FavorisService.getList({
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(retour) {
          if (retour.status === 'OK') {
            ctrl.favoris.list = retour.list;
            ctrl.favoris.nb = retour.nb;
            ctrl.favoris.refList = [];

            $rootScope.selectionList = $rootScope.selectionList || {};

            angular.forEach(ctrl.favoris.list, function(favori) {
              ctrl.favoris.refList.push(favori.lot.referenceInterne);
              $rootScope.selectionList[favori.lot.referenceInterne] =
                $rootScope.selectionList[favori.lot.referenceInterne] || false;
            });
          }
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de la r&eacute;cup&eacute;ration des coups de coeurs.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me r&eacute;cup&eacute;ration coups de coeur (code erreur : <i>HDR-FVR-131</i>)',

                { timeOut: 8000 }
              );
            }
          } else $log.error(error.status);
        });
    }

    function supprimerFavori(idLot) {
      FavorisService.supprimer({
        suppIdLot: idLot,
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      })
        .then(function(retour) {
          if (retour.status === 'OK') {
            ctrl.favoris.list = retour.list;
            ctrl.favoris.nb = retour.nb;
            ctrl.favoris.refList = [];

            angular.forEach(ctrl.favoris.list, function(favori) {
              ctrl.favoris.refList.push(favori.lot.referenceInterne);
            });

            ctrl.onFavorisChange({ nb: ctrl.favoris.nb, refList: ctrl.favoris.refList });
            $log.info('Le bien [ ' + idLot + ' ] à été retiré de la sélection.');
          }
        })
        .catch(function(error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Une erreur s&apos;est produite lors de la suppression du bien de la liste coups de coeurs.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me suppression coup de coeur (code erreur : <i>HDR-FVR-186</i>)',

                { timeOut: 8000 }
              );
            }
          } else $log.error(error.status);
        });
    }

    function envoyerEmail(refLot) {
      var prospect = globalService.getStorageItem('PANIER-PROSPECT');
      if (ctrl.panierProspect && prospect !== null) {
        if (!prospect.referenceInterne.includes('CLOUD-')) {
          openMailForm(refLot, prospect);
        } else {
          $rootScope.$emit('saveProspectPanier', {
            prospect: prospect,
            callback: function(retour) {
              openMailForm(refLot, retour.prospect);
            }
          });
        }
      } else {
        openMailForm(refLot);
      }
    }

    function openMailForm(refLot, prospect) {
      if (angular.isUndefined(refLot)) {
        refLot = '';
        angular.forEach(ctrl.favoris.list, function(property, index) {
          refLot += property.lot.referenceInterne;
          if (index <= ctrl.favoris.list.length) refLot += ',';
        });
      }

      MailService.getModel({
        lots: refLot,
        typeApplication: globalService.getTypeApplication()
      }).then(function(retour) {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/modal/formcontact/modal.formcontact.html',
          controller: 'ModalFormContactController',
          controllerAs: 'modalformcontactctrl',
          resolve: {
            message: function() {
              if (angular.isDefined(prospect)) {
                prospect = prospect.isModel ? prospect : new Prospect(prospect);
                retour.destinataire = prospect.perso.getEmail();
                retour.prospects = prospect.referenceInterne;
              }
              return retour;
            }
          }
        });

        modalInstance.result.then(function(retour) {
          if (retour.status === 'OK') {
            $log.info("L'e-mail a bien été envoyé.");
          } else {
            $log.info("L'e-mail n'a pas été envoyé !.. <== favoris.component.js l.228");
          }
        });
      });
    }

    function showFiche(refLot) {
      $scope.$emit('showFiche', { type: 'ficheBien', ref: refLot, refList: ctrl.favoris.refList });
    }

    function ajouterFavoris(lot, panier) {
      if (panier) {
        $rootScope.$emit('ajouterPanier', { refLot: lot.referenceInterne });
      }
    }

    function toggleSelection(refLot, selected) {
      if (selected) {
        $log.info('Ajouter le lot : [ ' + refLot + ' ] à la sélection.');
        $rootScope.$emit('ajouterSelection', { refLot: refLot });
      } else {
        $log.info('Retirer le lot : [ ' + refLot + ' ] de la sélection.');
        $rootScope.$emit('retirerSelection', { refLot: refLot });
      }
    }

    function imgResize() {
      var imgs = $element.querySelectorAll('.favoris-list').querySelectorAll('.property-img');
      if (imgs.length) {
        var width = imgs[0].getBoundingClientRect().width;

        ctrl.blocBienHeight = (width - 30) * 3 / 4 + 30;
      }
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-12-26
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .controller('TypeSelectDialogController', TypeSelectDialogController);

  /** @ngInject */
  function TypeSelectDialogController($scope, types) {
    var vm = this;

    vm.hasError = false;

    vm.types = {
      list: types,
      selected: null
    };

    vm.valider = valider;
    vm.annuler = annuler;

    function onChoseType() {
      vm.hasError = !vm.types.selected;
    }

    function valider() {
      onChoseType();
      /*eslint-disable */
      if (!vm.hasError) {
        $scope.confirm({
          status: 'OK',
          type: vm.types.selected
        });
      }
      /*eslint-enable */
    }

    function annuler() {
      /*eslint-disable */
      $scope.confirm({
        status: 'CANCEL'
      });
      $scope.closeThisDialog();
      /*eslint-enable */
    }
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-07-04
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function() {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalRepertoireController', ModalRepertoireController);

  /** @ngInject */
  function ModalRepertoireController(
    $uibModalInstance,
    CONSTANTS,
    RepertoireService,
    globalService,
    criteres,
    toastr,
    $log
  ) {
    var vm = this;

    vm.loading = false;

    vm.query = {
      type: criteres.type ? criteres.type : null,
      rechercheContact: criteres.rechercheContact ? criteres.rechercheContact : null,
      rechercheNom: criteres.rechercheNom ? criteres.rechercheNom : null,
      numero: 0,
      pas: 20,
      typeApplication: globalService.getTypeApplication()
    };

    vm.searchPattern = '.{3,}';
    vm.nomRequired = false;
    vm.contactRequired = false;

    vm.typesPerso = {
      active: angular.isUndefined(criteres.isProspect) || !criteres.isProspect,
      list: CONSTANTS.typesPerso[globalService.getTypeApplication()],
      selected: null
    };

    vm.repertoire = {
      nb: 0,
      list: [],
      selected: null
    };

    vm.setRequired = setRequired;
    vm.getList = getList;
    vm.selectPerso = selectPerso;
    vm.valider = valider;
    vm.annuler = annuler;

    vm.$onInit = function() {
      setRequired();
    };

    function setRequired() {
      vm.nomRequired =
        !vm.query.rechercheContact || (vm.query.rechercheNom && !vm.query.rechercheNom.match(vm.searchPattern));
      vm.contactRequired =
        !vm.query.rechercheNom || (vm.query.rechercheContact && !vm.query.rechercheContact.match(vm.searchPattern));
    }

    function getList() {
      vm.loading = true;

      RepertoireService.getPersoList(vm.query).then(
        function(retour) {
          if (retour.status === 'OK') {
            vm.repertoire.nb = retour.nb;
            vm.repertoire.list = retour.list;
          }

          vm.loading = false;
        },
        function() {
          vm.loading = false;
        }
      );
    }

    function selectPerso(perso) {
      if (vm.repertoire.selected && vm.repertoire.selected.isModel) {
        vm.repertoire.selected.selected = false;
      }
      vm.repertoire.selected = perso;
      vm.repertoire.selected.selected = true;
    }

    function valider() {
      if (vm.repertoire.selected) {
        vm.loading = true;

        if (vm.typesPerso.active) {
          RepertoireService.getPerso({
            reference: vm.repertoire.selected.referenceInterne,
            typeMethode: 'complete'
          }).then(
            function(retour) {
              if (retour.status === 'OK') {
                $uibModalInstance.close({
                  status: 'OK',
                  id: vm.repertoire.selected.ref ? parseInt(vm.repertoire.selected.ref) : null,
                  perso: retour.perso,
                  typeRepertoire: vm.repertoire.selected.typeRepertoire
                });
              }

              vm.loading = false;
            },
            function(error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else {
                $log.error(error.status);
                toastr.error(
                  "Une erreur s'est produite lors de la récupération de la personnalité.<br>" +
                    'Veuillez réessayer ultérieurement.<br>' +
                    '<br>' +
                    'Si le problème persiste, contactez la hotline.',

                  'Problème sélection personnalité (code erreur : <i>MOD-REP-111</i>)',

                  { timeOut: 8000 }
                );
              }
              vm.loading = false;
            }
          );
        } else {
          var ref = vm.repertoire.selected.ref.split(',')[0];
          RepertoireService.getProspect({
            reference: ref,
            typeMethode: 'complete'
          }).then(
            function(retour) {
              if (retour.status === 'OK') {
                $uibModalInstance.close({
                  status: 'OK',
                  prospect: retour.prospect
                });
              }

              vm.loading = false;
            },
            function(error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else {
                $log.error(error.status);
                toastr.error(
                  "Une erreur s'est produite lors de la récupération de la personnalité.<br>" +
                    'Veuillez réessayer ultérieurement.<br>' +
                    '<br>' +
                    'Si le problème persiste, contactez la hotline.',

                  'Problème sélection personnalité (code erreur : <i>MOD-REP-147</i>)',

                  { timeOut: 8000 }
                );
              }
              vm.loading = false;
            }
          );
        }
      }
    }

    function annuler() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-07-04
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalImpressionController', ModalImpressionController);

  /** @ngInject */
  function ModalImpressionController(
    CONSTANTS,
    globalService,
    $uibModalInstance,
    impression,
    ImpressionService,
    $window,
    $log
  ) {
    var vm = this;

    vm.citya = CONSTANTS.configClient.citya;

    vm.loading = false;

    vm.screenHeight = $($window).height();
    vm.fixedElemHeight = 222;

    vm.employe = globalService.getEmploye();

    vm.urlSpoolWord = globalService.getHost() + '/spool-word/';

    vm.type = {
      docActive: false,
      selected: 'DOC'
    };

    vm.fichiers = [];

    vm.selectedFile = null;

    vm.editFileName = null;

    vm.getModels = getModels;
    vm.onToggleFile = onToggleFile;
    vm.onEditFile = onEditFile;
    vm.onPrint = onPrint;
    vm.onCancel = onCancel;

    vm.$onInit = function () {
      if ($window.innerWidth >= 768) {
        vm.type.docActive = true;
      } else {
        vm.fixedElemHeight = 170;
      }

      getModels();
    };

    function getModels() {
      vm.loading = true;
      var params = {
        getModeles: ''
      };

      if (vm.type.selected === 'PDF') {
        params = {
          getModeles: vm.employe.societe.modeleXSL
        };
      }

      ImpressionService.getModels(params, vm.type.selected, globalService.getTypeApplication(), impression)
        .then(function (retour) {
          if (retour.status === 'OK') {
            vm.fichiers = retour.fichiers;
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function onToggleFile(fichier) {
      vm.selectedFile = fichier ? fichier : null;
      vm.editFileName = fichier && fichier.file ? fichier.file : null;
    }

    function onEditFile() {
      if (vm.type.selected === 'DOC' && vm.editFileName) {
        vm.loading = true;
        ImpressionService.setModels({
            edition: vm.editFileName,
            typeApplication: globalService.getTypeApplication()
          }).then(function (retour) {
            if (retour.status === 'OK') {
              $window.open(retour.link, '_blank');
            }
            vm.loading = false;
          })
          .catch(function () {
            vm.loading = false;
          });
      }
    }

    function onPrint() {
      if (vm.selectedFile) {
        vm.loading = true;

        var params = impression;
        params.typeApplication = globalService.getTypeApplication();
        params.edition = vm.selectedFile.file;

        ImpressionService.downloadFile(params, vm.type.selected)
          .then(function (retour) {
            if (retour.status === 'OK') {
              $window.open(retour.link, '_blank');
            }
            vm.loading = false;
          })
          .catch(function () {
            vm.loading = false;
          });
      }
    }

    function onCancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-07-04
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .controller('ModalFormContactController', ModalFormContactController);

  /** @ngInject */
  function ModalFormContactController($uibModalInstance, MailService, globalService, message,
    Perso) {
    var vm = this;

    vm.employe = globalService.getEmploye();

    vm.de = '';
    vm.a = '';
    vm.objet = '';
    vm.corps = '';

    vm.erreur = {
      hasError: false,
      message: ''
    };

    vm.envoyer = envoyer;
    vm.annuler = annuler;

    vm.$onInit = function () {
      if (vm.employe) {
        if (vm.employe.societe && vm.employe.societe.agence && vm.employe.societe.agence.email) {
          vm.de = vm.employe.societe.agence.email;
        }
        vm.employe.perso = new Perso(vm.employe.perso);
        if (vm.employe.perso.getEmail()) {
          vm.de = vm.employe.perso.getEmail();
        }
      }
      if (message.de) {
        vm.de = message.de;
      }

      vm.a = message.destinataire || message.a || '';
      vm.objet = message.objet || '';
      vm.corps = message.corps || '';
    }

    function envoyer() {
      MailService
        .envoyer({
          de: vm.de,
          a: vm.a,
          objet: vm.objet,
          corps: vm.corps,
          prospects: message.prospects,
          lots: message.lots,
          events: message.events,
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            $uibModalInstance.close(retour);
          } else {
            vm.erreur.message = retour.message;
            vm.erreur.hasError = true;
          }
        })
        .catch(function (error) {
          vm.erreur.message = error.message;
          vm.erreur.hasError = true;
        });
    }

    function annuler() {
      $uibModalInstance.dismiss('cancel');
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-07-04
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalFormEventController', ModalFormEventController);

  /** @ngInject */
  function ModalFormEventController(
    CONSTANTS,
    globalService,
    $uibModalInstance,
    ReferencesService,
    ProspectsService,
    PropertiesService,
    RepertoireService,
    moment,
    event,
    negoExt,
    ngDialog,
    $log
  ) {
    var vm = this;

    vm.nego = globalService.getEmploye();
    vm.citya = CONSTANTS.configClient.citya;

    vm.event = event;
    vm.types = [];

    vm.prospects = {
      list: [],
      search: prospectSearch
    };
    vm.lots = {
      list: [],
      search: lotSearch
    };

    vm.negoExt = angular.isDefined(negoExt) ? negoExt : false;

    vm.negos = {
      list: [],
      search: negoSearch
    };

    // Liste des CODES evenement qui ne correspondent pas à des évènements de l'agenda
    vm.eventHorsAgenda = [1, 5, 6, 7, 8, 9, 100, 101, 200, 201, 100, 1001, 1002, 3000, 3001, 3004, 3102, 3201, 3301];

    vm.datepickers = {
      dateDebut: false,
      dateFin: false,
      setDateFin: setDateFin,
      close: function (datepicker) {
        vm.datepickers[datepicker] = false;
      }
    };

    vm.enregistrer = enregistrer;
    vm.annuler = annuler;
    vm.supprimer = supprimer;
    vm.fermer = fermer;

    vm.$onInit = function () {
      // Impossible de créer un visite si Citya
      if (vm.citya) {
        vm.eventHorsAgenda.push(2);
      }

      ReferencesService.getReferences({
        classes: 'RefEvenement',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            vm.types = retour.list.RefEvenement.filter(function (ref) {
              return !vm.eventHorsAgenda.includes(ref.data);
            });
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );

      if (vm.event.negociateur && vm.event.negociateur.id) {
        RepertoireService.getNegoList({
          nego: vm.nego.id,
          numero: 0,
          pas: 1,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        }).then(
          function (retour) {
            if (retour.status === 'OK') {
              vm.event.negociateur = retour.list[0];
            }
          },
          function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED')
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
            } else $log.error(error.status);
          });
      } else {
        vm.event.negociateur = vm.nego;
      }

      if (!vm.event.date) {
        vm.event.date = moment().format(CONSTANTS.date_format);
        vm.event.dateFin = moment(vm.event.date, CONSTANTS.date_format).add(1, 'hours').format(CONSTANTS.date_format);
      }
      if (!vm.event.dateFin) {
        vm.event.dateFin = moment(vm.event.date, CONSTANTS.date_format).add(1, 'hours').format(CONSTANTS.date_format);
      }

      vm.event.dateFin = vm.event.dateFin || '';

      if (vm.event.prospect && vm.event.prospect.id) {
        vm.prospects.list.push(vm.event.prospect);
      } else {
        vm.event.prospect = null;
      }

      if (vm.event.lot && vm.event.lot.id) {
        vm.lots.list.push(vm.event.lot);
      } else {
        vm.event.lot = null;
      }
    };

    function prospectSearch(search) {
      vm.prospects.list = [];

      ProspectsService.getListe({
        search: {
          recherche: search || null
        },
        numero: 0,
        pas: 10,
        typeApplication: globalService.getTypeApplication(),
        typeMethode: 'simple'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            vm.prospects.list = retour.prospects;
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function lotSearch(search) {
      vm.lots.list = [];

      PropertiesService.getPropertiesList({
        search: {
          recherche: search || null
        },
        numero: 0,
        pas: 10,
        typeApplication: globalService.getTypeApplication(),
        typeMethode: 'liste'
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            vm.lots.list = retour.list.biens;

            // $log.info(vm.lots.list);
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function negoSearch(search) {
      RepertoireService.getNegoList({
        recherche: search || null,
        societe: vm.nego.societe.id,
        numero: 0,
        pas: 15,
        typeMethode: 'liste',
        typeApplication: globalService.getTypeApplication()
      }).then(
        function (retour) {
          if (retour.status === 'OK') {
            vm.negos.list = retour.list;
          } else {
            $log.error(retour.status, 'La récupération de la liste des négociateurs a échoué.');
          }
        },
        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        }
      );
    }

    function setDateFin() {
      if (vm.event && vm.event.date && !vm.event.dateFin) {
        vm.event.dateFin = moment(vm.event.date, CONSTANTS.date_format)
          .add(1, 'h')
          .format(CONSTANTS.date_format);
      }
    }

    function enregistrer() {
      if (vm.event && vm.event.date && vm.event.type) {
        $uibModalInstance.close({
          status: 'OK',
          event: vm.event
        });
      }
    }

    function annuler() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return "Confirmation d'annulation";
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous annuler cet évènement ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return false;
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          $uibModalInstance.close({
            status: 'CANCEL',
            event: vm.event
          });
        }
      });
    }

    function supprimer() {
      var confirmDialog = ngDialog.openConfirm({
        templateUrl: 'app/modal/confirm-dialog/confirm-dialog.html',
        controller: 'ConfirmDialogController',
        controllerAs: 'confirmdialogctrl',
        resolve: {
          titre: function titreFactory() {
            return 'Confirmation de suppression';
          },
          message: function messageFactory() {
            return '<span>Souhaitez-vous supprimer cet évènement ?</span>';
          },
          commentaire: function commentaireFactory() {
            return false;
          },
          confirmText: function confirmTextFactory() {
            return false;
          },
          annulerText: function annulerTextFactory() {
            return false;
          }
        }
      });

      confirmDialog.then(function (data) {
        if (data.status === 'OK') {
          $uibModalInstance.close({
            status: 'DELETE',
            event: vm.event
          });
        }
      });
    }

    function fermer() {
      $uibModalInstance.dismiss({
        status: 'EXIT'
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalETutorielController', ModalETutorielController);

  /** @ngInject */
  function ModalETutorielController($uibModalInstance, tutoriels) {
    var vm = this;

    vm.tutoriels = angular.isDefined(tutoriels) ? tutoriels : [];

    vm.fermer = fermer;

    function fermer() {
      $uibModalInstance.dismiss({
        status: 'EXIT'
      });
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-12-26
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .controller('ConfirmDialogController', ConfirmDialogController);

  /** @ngInject */
  function ConfirmDialogController($scope, titre, message, commentaire, confirmText, annulerText) {
    var vm = this;

    vm.deleteRaison = '';
    vm.hasError = false;

    vm.titre = angular.isDefined(titre) ? titre : false;
    vm.message = angular.isDefined(message) ? message : false;
    vm.commentaire = angular.isDefined(commentaire) ? commentaire : false;
    vm.confirmText = angular.isDefined(confirmText) && confirmText !== false ? confirmText : 'Confirmer';
    vm.annulerText = angular.isDefined(annulerText) && annulerText !== false ? annulerText : 'Annuler';

    vm.valider = valider;
    vm.annuler = annuler;

    function valider() {
      vm.hasError = false;
      /*eslint-disable */
      if (vm.commentaire) {
        if (angular.isString(vm.deleteRaison) && vm.deleteRaison.length) {
          $scope.confirm({
            status: 'OK',
            deleteRaison: vm.deleteRaison
          });
        } else {
          vm.hasError = true;
        }
      } else {
        $scope.confirm({
          status: 'OK'
        });
      }
      /*eslint-enable */
    }

    function annuler() {
      vm.hasError = false;
      /*eslint-disable */
      $scope.confirm({
        status: 'CANCEL'
      });
      $scope.closeThisDialog();
      /*eslint-enable */
    }
  }
})();
(function() {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalCheckParutionsController', ModalCheckParutionsController);

  /** @ngInject */
  function ModalCheckParutionsController(
    $uibModalInstance,
   
    globalService,
    CustomUtils,
    ParutionsService,
    $window,
    $q
  ) {
    var vm = this;

    vm.loading = false;

    vm.employe = globalService.getEmploye();

    vm.screenHeight = $($window).height();
    vm.fixedElemHeight = 230;

    vm.parutions = [];

    vm.fermer = fermer;

    vm.$onInit = function() {
      vm.loading = true;

      if ($window.innerWidth < 768) {
        vm.fixedElemHeight = 178;
      }

      if (angular.isDefined(vm.employe) && vm.employe.id) {
        ParutionsService.checkParutions({
          type: globalService.getTypeApplication() === 'Transaction' ? 'transaction' : 'location',
          nom: vm.employe.societe.nomDossierXBox
        })
          .then(function(json) {
            if (json.status === 'OK') {
              checkImgParution(json.list).then(function(parutions) {
                vm.parutions = parutions;
              });
            }
          })
          .finally(function() {
            vm.loading = false;
          });
      }
    };

    function checkImgParution(prestataires) {
      var globalDefer = $q.defer(),
        promises = [],
        deferred;

      angular.forEach(prestataires, function(prestataire) {
        deferred = $q.defer();
        prestataire.hasImg = false;
        var imgSrc = 'assets/images/logos/' + prestataire.presta + '.png';
        CustomUtils.isImage(imgSrc)
          .then(function(image) {
            prestataire.hasImg = true;
            prestataire.imgSrc = image.src;
          })
          .finally(function() {
            deferred.resolve();
            promises.push(deferred.promise);
          });
      });

      $q.all(promises).then(function() {
        globalDefer.resolve(prestataires);
      });

      return globalDefer.promise;
    }

    function fermer() {
      $uibModalInstance.dismiss({
        status: 'EXIT'
      });
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-12-26
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function() {
  'use strict';

  angular.module('transacGeslocNet').controller('ModalAvenantController', ModalAvenantController);

  /** @ngInject */
  function ModalAvenantController(CONSTANTS, moment, $uibModalInstance, datefin) {
    var vm = this;

    vm.avenant = {
      numero: null,
      datedeb: moment().format(CONSTANTS.date_format),
      datefin: angular.isDefined(datefin) ? datefin : null
    };

    vm.datepickers = {
      debut: {
        open: false,
        onClose: onCloseDatepicker
      },
      fin: {
        open: false,
        onClose: onCloseDatepicker
      }
    };

    vm.valider = valider;
    vm.annuler = annuler;
    vm.fermer = fermer;

    function onCloseDatepicker(datepicker) {
      vm.datepickers[datepicker].open = false;
    }

    function valider() {
      /*eslint-disable */
      if (vm.avenant.numero && vm.avenant.datedeb && vm.avenant.datefin) {
        $uibModalInstance.close({
          status: 'OK',
          avenant: vm.avenant
        });
      }
      /*eslint-enable */
    }

    function annuler() {
      $uibModalInstance.close({
        status: 'CANCEL'
      });
    }

    function fermer() {
      $uibModalInstance.dismiss({
        status: 'EXIT'
      });
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('title', TitleDirective);

  /** @ngInject */
  function TitleDirective($rootScope, CONSTANTS, globalService) {
    return {
      restrict: 'E',
      link: function (scope, element) {
        element.text(angular.isDefined(CONSTANTS.meta[globalService.getTypeApplication()]) ? CONSTANTS.meta[globalService.getTypeApplication()].meta_title : globalService.getTypeApplication());

        var listener = $rootScope.$on('$stateChangeStart', function (event, toState) {
          var baseTitle = angular.isDefined(CONSTANTS.meta[globalService.getTypeApplication()]) ? CONSTANTS.meta[globalService.getTypeApplication()].meta_title : globalService.getTypeApplication(),
            additionalTitle = angular.isDefined(toState.meta) && angular.isDefined(toState.meta.title) && toState.meta.title !== '' ? toState.meta.title + ' - ' : '';
          element.text(additionalTitle + baseTitle);
        });

        scope.$onDestroy = function () {
          listener();
          listener = null;
        };
      }
    };
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('tgnOnResize', TgnOnResizeController);

  /** @ngInject */
  function TgnOnResizeController($window) {
    return {
      restrict: 'A',
      scope: {
        method: '&tgnOnResize'
      },
      link: function (scope, elem) {
        var func = scope.method();

        func(elem);

        angular.element($window).on('resize', function () {
          scope.$apply(function () {
            func(elem);
          });
        });

        scope.$watch(elem[0].width, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            scope.$apply(function () {
              func(elem);
            });
          }
        });
      }
    };
  }
})();
/**
 * @desc : Element to focus when condition is true.
 *
 * @author : vfillon@ics.fr
 * @since : 2016-12-21
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('tgnFocus', tgnFocusController);

  /** @ngInject */
  function tgnFocusController($timeout, $parse) {
    return {
      //scope: true,   // optionally create a child scope
      link: function (scope, element, attrs) {
        var model = $parse(attrs.tgnFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
      }
    };
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('repeatComplete', repeatCompleteController);

  /** @ngInject */
  function repeatCompleteController($timeout) {
    return function (scope, element, attrs) {
      if (scope.$last) { // all are rendered
        $timeout(function () {
          scope.$eval(attrs.repeatComplete);
        }, 300);
      }
    }
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('onReady', onReadyController);

  /** @ngInject */
  function onReadyController($timeout) {
    return {
      restrict: 'A',
      scope: {
        method: '&onReady'
      },
      link: function (scope) {
        var func = scope.method();
        angular.element(function() {
          $timeout(function() {
            func();
          });
        });
      }
    }
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-12-21
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS - from Ben Nadel source code (https://www.bennadel.com/blog/2741-creating-a-range-loop-directive-in-angularjs.htm)
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('ngFor', ngForController);

  /** @ngInject */
  function ngForController($compile) {
    var rangePattern = /(-?\d+)(\.\.\.?)(-?\d+)/i,
      cachedSets = {};

    return ({
      compile: compile,
      priority: 1001,
      restirct: "A",
      terminal: true
    });

    //noinspection JSUnusedLocalSymbols
    function compile(tElement, tAttributes) {
      var input = tAttributes.ngFor;
      if (missingRange(input)) {
        throw( new Error("Missing valid range in the form of M..N (exclusive) or M...N (inclusive).") );
      }
      // Add the ngRepeat directive that has consumes an array made up of
      // the generated indices.
      // --
      // NOTE: We have to use $set() here, as opposed to .attr(), since the
      // directives have already been collected for this element. As such,
      // we have to explicitly let AngularJS know that new directives have
      // been added.
      tAttributes.$set(
        "ngRepeat",
        input.replace(rangePattern, replacePatternWithSet)
      );
      // Remove the ngFor directive from the markup (to make things look
      // a little it nicer).
      tAttributes.$set(tAttributes.$attr.ngFor, null);
      // Return the linking function to complete the compilation of the
      // ngRepeat directive we just injected.
      return ( link );
    }

    // I link the JavaScript events to the local scope.
    function link(scope, element) {
      // Once we have injected the ngRepeat directive, we have to make sure
      // that is compiles and links. Since the ngFor directive executes at
      // priority 1001, we want to continue the compilation at directives
      // that execute below 1001 (ie, the ngRepeat).
      $compile(element, null, 1001)(scope);
    }

    // ---
    // PRIVATE METHODS.
    // ---
    // I build a set whose values are an ordered collection of the indices
    // required to iterate over FROM->TO. If the set is exclusive, the last
    // value in the set is excluded.
    function buildSet(from, to, isExclusive) {
      var set = [], i;
      // Incrementing range.
      if (from <= to) {
        for (i = from; i <= to; i++) {
          set.push(i);
        }
        // Decrementing range.
      } else {
        for (i = from; i >= to; i--) {
          set.push(i);
        }
      }
      if (isExclusive) {
        set.pop();
      }
      return ( set );
    }

    // I check to see if the directive input is missing a valid range (ex, M..N).
    function missingRange(input) {
      return ( String(input).search(rangePattern) === -1 );
    }

    // I replace the matched range with a serialized set of indices.
    function replacePatternWithSet(range, start, operator, end) {
      // If this range has been parsed before, just return the cached set.
      if (cachedSets[range]) {
        return ( cachedSets[range] );
      }
      var from = parseInt(start, 10);
      var to = parseInt(end, 10);
      var isExclusive = ( operator === ".." );
      var set = buildSet(from, to, isExclusive);
      // Once we have the set, serialize it into something that the
      // ngRepeat directive can use, cache it, and return it.
      return ( cachedSets[range] = angular.toJson(set) );
    }
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('multipleEmails', MultipleEmails);

  /** @ngInject */
  function MultipleEmails() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ctrl) {
        ctrl.$parsers.unshift(function (viewValue) {

          var emails = viewValue.split(/[,|;]/);
          // define single email validator here
          var re = /\S+@\S+\.\S+/;

          // angular.foreach(emails, function() {
          var validityArr = emails.map(function (str) {
            return re.test(str.trim());
          }); // sample return is [true, true, true, false, false, false]
          var atLeastOneInvalid = false;
          angular.forEach(validityArr, function (value) {
            if (value === false)
              atLeastOneInvalid = true;
          });
          if (!atLeastOneInvalid) {
            // ^ all I need is to call the angular email checker here, I think.
            ctrl.$setValidity('multipleEmails', true);
            return viewValue;
          } else {
            ctrl.$setValidity('multipleEmails', false);
            return undefined;
          }
          // })
        });
      }
    };
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('multipleSubmit', multipleSubmitController);

  /** @ngInject */
  function multipleSubmitController() {
    return {
      restrict: 'A',
      require: '^^form',
      scope: {
        callback: '&multipleSubmit'
      },
      link: function (scope, element, attrs, form) {
        element.bind('click', function () {
          if (form.$valid) {
            scope.callback();
          }
        });
      }
    }
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net � ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('limitText', function () {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          nbReste: '=',
          limitChar: '@'
        },
        link: function (scope, elm, attrs, ngModel) {
          attrs.$set('ngTrim', 'false');

          scope.limitChar = angular.isNumber(scope.limitChar) ? scope.limitChar : Number(scope.limitChar);

          ngModel.$formatters.push(function (value) {
            if (value) {
              scope.nbReste = scope.limitChar - value.length;
            }
            return value;
          });

          ngModel.$parsers.push(function (value) {
            scope.nbReste = scope.limitChar - value.length;
            if (value.length > scope.limitChar) {
              value = value.substr(0, scope.limitChar);
              ngModel.$setViewValue(value);
              ngModel.$render();
            }
            return value;
          });
        }
      };
    })
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function() {
  'use strict';

  angular.module('transacGeslocNet').directive('lazyLoad', LazyLoad);

  /** @ngInject */
  function LazyLoad($timeout, $window, $document) {
    return {
      restrict: 'A',

      link: function(scope, element, attrs) {
        element.addClass('lazyload');
        element.parent().css({
          overflow: 'hidden',
          position: 'relative'
        });

        element.ready(function() {
          var windowWidth = $window.innerWidth,
            raw = element[0],
            isScrolling = false,
            nativeScrollWidth = browser() === 'Firefox' ? 17 : /*raw.offsetWidth - raw.clientWidth*/ 0,
            scrollbarMove = false,
            oldCoordY = false,
            getMouseXY = function(e) {
              var tempX, tempY;
              if (browser() === 'IE') {
                // grab the x-y pos.s if browser is IE
                tempX = e.clientX + $document.body.scrollLeft;
                tempY = e.clientY + $document.body.scrollTop;
              } else {
                // grab the x-y pos.s if browser is NS
                tempX = e.pageX;
                tempY = e.pageY;
              }

              if (tempX < 0) {
                tempX = 0;
              }
              if (tempY < 0) {
                tempY = 0;
              }

              return { x: tempX, y: tempY };
            },
            scrollLvl =
              angular.isDefined(attrs.scrollLvl) && isFinite(scope.$eval(attrs.scrollLvl))
                ? scope.$eval(attrs.scrollLvl) / 100
                : 0.75;

          // Désactiver la scrollbar sur mobiles
          if (windowWidth >= 768) {
            element.append(
              '<div class="lazyload-scrollbar-track">' + '  <div class="lazyload-scrollbar-bar"></div>' + '</div>'
            );

            var nativeScrollWidthPX = nativeScrollWidth > 0 ? 'calc(100% + ' + nativeScrollWidth + 'px)' : '100%',
              nativeScrollWidthPadding = (nativeScrollWidth > 0 ? nativeScrollWidth - 10 : 10) + 'px';

            element.css({
              width: nativeScrollWidthPX
            });

            var scrollBar = angular.element(element.find('.lazyload-scrollbar-bar')),
              scrollTrack = angular.element(element.find('.lazyload-scrollbar-track'));

            $timeout(function() {
              if (raw.offsetHeight >= raw.scrollHeight) {
                element.css({
                  paddingRight: 'initial'
                });
                scrollTrack.css({
                  opacity: '0'
                });
              } else {
                element.css({
                  paddingRight: nativeScrollWidthPadding
                });
                scrollTrack.css({
                  opacity: '1'
                });
                scrollBar.css({
                  height: (raw.offsetHeight / raw.scrollHeight * 100) + '%'
                });
              }
            });

            scope.$watch(
              function() {
                return raw.scrollHeight;
              },
              function(newVal, oldVal) {
                if (newVal !== oldVal) {
                  if (raw.offsetHeight >= raw.scrollHeight) {
                    element.css({
                      paddingRight: 'initial'
                    });
                    scrollTrack.css({
                      opacity: '0'
                    });
                  } else {
                    element.css({
                      paddingRight: nativeScrollWidthPadding
                    });
                    scrollTrack.css({
                      opacity: '1'
                    });
                    scrollBar.css({
                      height: (raw.offsetHeight / raw.scrollHeight * 100) + '%',
                      top: (raw.scrollTop * ((raw.offsetHeight - 30) / raw.scrollHeight)) + 'px'
                    });
                  }
                }
              }
            );
          }

          element.bind('scroll', function() {
            // Scrollbar uniquement sur mobiles
            if (windowWidth >= 768) {
              scrollBar.css({ top: (raw.scrollTop * ((raw.offsetHeight - 30) / raw.scrollHeight)) + 'px' });
            }
            if (!isScrolling && raw.scrollTop + raw.offsetHeight > raw.scrollHeight * scrollLvl) {
              isScrolling = true;
              scope.$apply(attrs.lazyLoad);

              $timeout(function() {
                isScrolling = false;

                // Scrollbar uniquement sur mobiles
                if (windowWidth >= 768) {
                  $timeout(function() {
                    scrollBar.css({
                      height: (raw.offsetHeight / raw.scrollHeight * 100) + '%',
                      top: (raw.scrollTop * ((raw.offsetHeight - 30) / raw.scrollHeight)) + 'px'
                    });
                  });
                }
              }, 500);
            }
          });

          // Scrollbar uniquement sur mobiles
          if (windowWidth >= 768) {
            element.bind('mousedown', function(e) {
              if (e.target === scrollBar[0]) {
                e.preventDefault();
                scrollbarMove = true;
                var coords = getMouseXY(e);
                oldCoordY = coords.y;
              }
            });

            element.bind('mousemove', function(e) {
              if (scrollbarMove) {
                var coords = getMouseXY(e);
                raw.scrollTop += (coords.y - oldCoordY) * (raw.scrollHeight / raw.offsetHeight);
                oldCoordY = coords.y;

                element.triggerHandler('scroll');
              }
            });

            angular.element($window).bind('mouseup', function() {
              scrollbarMove = false;
              oldCoordY = false;
            });

            scrollTrack.bind('click', function(e) {
              var coords = getMouseXY(e),
                rawBoundRect = raw.getBoundingClientRect();

              raw.scrollTop = angular.copy(
                (coords.y - rawBoundRect.top) * (raw.scrollHeight / raw.offsetHeight) - raw.offsetHeight / 2
              );

              element.triggerHandler('scroll');
            });
          }
        });
      }
    };

    /**
     * Gets the browser name or returns an empty string if unknown.
     * This function also caches the result to provide for any
     * future calls this function has.
     *
     * @returns {string}
     */
    function browser() {
      // Return cached result if avalible, else get result then cache it.
      if (browser.prototype._cachedResult) return browser.prototype._cachedResult;

      // Opera 8.0+
      var isOpera =
        (!!$window.opr && !!$window.opr.addons) || !!$window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]"
      var isSafari =
        /constructor/i.test($window.HTMLElement) ||
        (function(p) {
          return p.toString() === '[object SafariRemoteNotification]';
        })(!$window.safari || $window.safari.pushNotification);

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/ false || !!$document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!$window.StyleMedia;

      // Chrome 1+
      var isChrome = !!$window.chrome && !!$window.chrome.webstore;

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!$window.CSS;

      return (browser.prototype._cachedResult = isOpera
        ? 'Opera'
        : isFirefox
          ? 'Firefox'
          : isSafari
            ? 'Safari'
            : isChrome ? 'Chrome' : isIE ? 'IE' : isEdge ? 'Edge' : isBlink ? 'Blink' : "Don't know");
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('dynamicHtml', DynamicHtmlDirective);

  /** @ngInject */
  function DynamicHtmlDirective($compile) {
    return {
      restrict: 'A',
      replace: true,
      link: function (scope, elem, attrs) {
        scope.$watch(attrs.dynamicHtml, function(html) {
          elem.html(html);
          $compile(elem.contents())(scope);
        });
      }
    };
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2017-05-18
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('customType', customType);

  /** @ngInject */
  function customType(CustomUtils) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, element, attrs, ngModel) {
        var parsers = {
            integer: function (value) {
              if (value) {
                var int = Math.trunc(CustomUtils.number.scaleTo(value));

                var formatted = CustomUtils.number.thounsandSeparator(int);
                if (formatted !== ngModel.$viewValue) {
                  ngModel.$setViewValue(formatted);
                  ngModel.$render();
                }
                return int;
              } else return value;
            },
            number: function (value) {
              if (value) {
                var num = CustomUtils.number.cleanNumber(value, true);
                if (num.match(/^[0-9]*[.][0-9]{2,}$/)) {
                  num = CustomUtils.number.roundTo(num);
                }
                var formatted = CustomUtils.number.thounsandSeparator(num);
                if (formatted !== ngModel.$viewValue) {
                  ngModel.$setViewValue(formatted);
                  ngModel.$render();
                }
                return parseFloat(num);
              } else return value;
            },
            date: function (value) {
              if (value) {
                var date = value.toString(), regex = /(\d{2})(\d{2})(\d{4})/;
                if (regex.test(date)) {
                  date = date.replace(regex, '$1' + '/' + '$2' + '/' + '$3');
                }

                return date;
              } else return value;
            },
            datetime: function (value) {
              if (value) {
                var datetime = value.toString(), regex = /(\d{2})(\d{2})(\d{4})(\d{2})(\d{2})/;
                if (regex.test(datetime)) {
                  datetime = datetime.replace(regex, '$1' + '/' + '$2' + '/' + '$3' + ' ' + '$4' + 'h' + '$5');
                }

                return datetime;
              } else return value;
            }
          },

          formatters = {
            integer: function (value) {
              if (value) {
                return CustomUtils.number.thounsandSeparator(Math.trunc(CustomUtils.number.scaleTo(value)));
              } else return value;
            },
            number: function (value) {
              if (value) {
                var num = CustomUtils.number.cleanNumber(value, true);
                if (num.match(/^[0-9]*[.][0-9]{2,}$/)) {
                  num = CustomUtils.number.roundTo(num);
                }
                return CustomUtils.number.thounsandSeparator(num);
              } else return value;
            }
          };

        switch (attrs.customType) {
          case 'integer':
            ngModel.$parsers.unshift(parsers.integer);
            ngModel.$formatters.unshift(formatters.integer);
            break;
          case 'number':
            ngModel.$parsers.unshift(parsers.number);
            ngModel.$formatters.unshift(formatters.number);
            break;
          case 'date':
            ngModel.$parsers.unshift(parsers.date);
            break;
          case 'datetime':
            ngModel.$parsers.unshift(parsers.datetime);
            break;
        }
      }
    };
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-13
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .directive('clickPrevent', ClickPrevent);

  /** @ngInject */
  function ClickPrevent() {
    return {
      restrict: 'A',
      link: function (scope, elem) {
        elem.on('touchstart click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
    };
  }
})();
/**
 * @desc : Gestion du bandeau stella pour intégration CITYA
 *
 * @author : vfillon@ics.fr
 * @since : 2017-01-23
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('bandeauStella', {
    templateUrl: 'app/components/bandeau-stella/bandeau-stella.html',
    controllerAs: 'bandeaustellactrl',
    controller: BandeauStellaController
  });

  /** @ngInject */
  function BandeauStellaController(globalService, $window, $scope, $sce) {
    var ctrl = this;

    ctrl.logged = false;
    ctrl.employe = globalService.getEmploye();

    ctrl.logo = {
      list: {
        Transaction: {
          sm: 'assets/images/pictos/transac-logo-sm.png',
          normal: 'assets/images/pictos/transac-logo.png'
        },
        Location: {
          sm: 'assets/images/pictos/loc-logo-sm.png',
          normal: 'assets/images/pictos/loc-logo.png'
        }
      },
      current: ''
    };

    ctrl.stellaApps = {
      url: 'http://srv-mycitya.citya.local/choix-application/',
      icon: 'assets/images/pictos/stella-apps.png',
      tooltip: "Choix de l'application"
    };

    ctrl.stellaSos = {
      url: 'http://myglpi/glpi/front/ticket.form.php',
      icon: 'assets/images/pictos/stella-sos.png',
      tooltip: 'SoS'
    };

    ctrl.parametrage = {
      url: '',
      icon: 'assets/images/pictos/parametrage.png',
      tooltip: "(En construction) Parametrage de l'application"
    };

    ctrl.logout = {
      url: 'logout',
      icon: 'assets/images/pictos/logout.png',
      tooltip: 'Déconnexion'
    };

    ctrl.userImg = '';

    ctrl.src = '/stella/header';

    angular.element($window).on('resize', setLogo);

    ctrl.typeApplicationListener = $scope.$on('typeApplication', function () {
      setLogo();
    });

    ctrl.loginTokenListener = $scope.$watch(
      function () {
        return globalService.isLogged();
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal) {
          ctrl.logged = newVal;
          ctrl.employe = globalService.getEmploye();
          setEmploye();
        }
      }
    );

    ctrl.trustSRC = trustSRC;

    ctrl.$onInit = function () {
      ctrl.logged = globalService.isLogged();
      ctrl.employe = globalService.getEmploye();

      setLogo();
      setEmploye();
    };

    ctrl.$onDestroy = function () {
      angular.element($window).off('resize', setLogo);
      ctrl.typeApplicationListener();
      ctrl.typeApplicationListener = null;
      ctrl.loginTokenListener();
      ctrl.loginTokenListener = null;
    };

    function setLogo() {
      ctrl.logo.current =
        ctrl.logo.list[globalService.getTypeApplication()][$window.innerWidth >= 768 ? 'normal' : 'sm'];
    }

    function setEmploye() {
      if (ctrl.employe && ctrl.employe.photoMini) {
        ctrl.userImg = ctrl.employe.photoMini;
      } else if (ctrl.employe && ctrl.employe.civilite && ctrl.employe.civilite.data) {
        ctrl.userImg =
          ctrl.employe.civilite.data === 1 ? 'assets/images/pictos/user-m.png' : 'assets/images/pictos/user-f.png';
      } else {
        ctrl.userImg = 'assets/images/pictos/user-m.png';
      }
    }

    function trustSRC(src) {
      return $sce.trustAsResourceUrl(src);
    }
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').component('customHeader', {
    templateUrl: 'app/components/header/header.html',
    controllerAs: 'headerctrl',
    controller: CustomHeaderController
  });

  /** @ngInject */
  function CustomHeaderController(
    CONSTANTS,
    globalService,
    CustomUtils,
    FavorisService,
    PanierService,
    ProspectsService,
    Prospect,
    $rootScope,
    $scope,
    Idle,
    $timeout,
    $animate,
    $window,
    $location,
    $element,
    toastr,
    $state,
    $document,
    $uibModal,
    $log
  ) {
    var ctrl = this;

    ctrl.globalService = globalService;

    ctrl.transac = globalService.getTypeApplication();

    ctrl.employe = globalService.getEmploye();
    ctrl.citya = CONSTANTS.configClient.citya;

    ctrl.parametrage = {
      active: false,
      url: $location.protocol() + '://' + $location.host() + '/admin'
    };

    ctrl.logged = false;

    ctrl.menu = {
      open: false,
      forced: false,
      liens: [{
          nom: 'Accueil',
          shortName: 'accueil',
          icon: 'fa-home',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('accueil');
          }
        },
        {
          nom: 'Liste des prospects',
          shortName: 'listeProspects',
          icon: 'fa-users',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('listeProspects');
          }
        },
        {
          nom: 'Liste des biens',
          shortName: 'listeBien',
          icon: 'fa-building',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('listeBien');
          }
        },
        {
          nom: 'Calendrier',
          shortName: 'calendrier',
          icon: 'fa-calendar',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('calendrier');
          }
        },
        {
          nom: 'Répertoire',
          shortName: 'repertoire',
          icon: 'fa-address-book-o',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('repertoire');
          }
        },
        {
          nom: globalService.getTypeApplication() === 'Transaction' ? 'Compromis' : 'Réservations',
          shortName: 'contrat',
          icon: 'fa-file-o',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('contrat', {
              type: globalService.getTypeApplication() === 'Transaction' ? 'compromis' : 'reservation'
            });
          }
        },
        {
          nom: globalService.getTypeApplication() === 'Transaction' ? 'Ventes' : 'Locations',
          shortName: 'contrat',
          icon: 'fa-file-text-o',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('contrat', {
              type: globalService.getTypeApplication() === 'Transaction' ? 'vente' : 'location'
            });
          }
        },
        {
          nom: 'Parutions ICS Box',
          shortName: 'parutionsIcsBox',
          icon: 'fa-newspaper-o',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('parutionsIcsBox');
          }
        },
        {
          nom: 'Gestion des panneaux',
          shortName: 'panneaux',
          icon: 'fa-map-signs',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('panneaux');
          }
        },
        {
          nom: 'Gestion du stock',
          shortName: 'gestionStock',
          icon: 'fa-clock-o',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('gestionStock', {
              recherche: {
                search: {
                  enAttente: !ctrl.citya ? true : null,
                  mandat: true,
                  archive: false,
                  tri: ctrl.citya ? 'asc' : 'desc',
                  ordre: ctrl.citya ? 'triLocationEtat' : 'triDate',
                  societe: ctrl.employe.societe.id || null
                },
                numero: 0,
                pas: 32,
                typeMethode: 'liste',
                typeApplication: 'Location',
                template: 'grid'
              }
            });
          }
        },
        {
          nom: 'Statistique',
          shortName: 'statistique',
          icon: 'fa-line-chart',
          active: false,
          onClick: function () {
            ctrl.menu.open = false;
            $state.go('statistique');
          }
        }
      ],
      current: [],
      toggle: function () {
        ctrl.menu.open = !ctrl.menu.open;

        $timeout(function () {
          if (ctrl.menu.open) {
            $document.on('click', onClickOutside);
          }
        });
      }
    };

    ctrl.fiches = {
      open: false,
      visible: false,
      origine: '',
      type: null,
      ref: {},
      show: showFiche,
      hide: hideFiche,
      change: changeFiche
    };

    ctrl.tutoriels = {
      common: [{
          id: 1,
          title: 'Connectons-nous',
          desc: "Présentation générale de l'application.",
          miniature: 'tuto-general.jpg',
          url: 'https://youtu.be/9FcGj1ylikI'
        },
        {
          id: 2,
          title: "Création d'un prospect",
          desc: "Démonstration commentée et expliquée de la création d'un prospect étape par étape.",
          miniature: 'tuto-fiche-prospect.jpg',
          url: 'https://youtu.be/UUT8WE8bmKM'
        },
        {
          id: 3,
          title: "Création d'une visite",
          desc: "Démonstration commentée et expliquée d'une prise de rendez-vous avec un prospect pour la visite d'un bien.",
          miniature: 'tuto-creation-visite.jpg',
          url: 'https://youtu.be/98qftUWlf4s'
        },
        {
          id: 4,
          title: "Visualisation d'un panier",
          desc: "Démonstration de l'accès au panier d'un prospect",
          miniature: 'tuto-visualisation-panier.jpg',
          url: 'https://youtu.be/pXoMeNno_Pw'
        },
        {
          id: 5,
          title: 'Parutions ICSBOX',
          desc: 'Présentation détaillée de la gestion des parutions ICSBOX',
          miniature: 'parutions-icsbox.jpg',
          url: 'https://youtu.be/Zxaw4O5RTHI'
        }
      ],
      Transaction: [{
        id: 1,
        title: "Création d'un bien",
        desc: "Démonstration commentée et expliquée de la création d'un bien étape par étape.",
        miniature: 'tuto-transac-creation-bien.jpg',
        url: 'https://youtu.be/tmPCkRgxe-o'
      }],
      Location: [{
        id: 1,
        title: "Création d'un bien",
        desc: "Démonstration commentée et expliquée de la création d'un bien étape par étape.",
        miniature: 'tuto-location-creation-bien.jpg',
        url: 'https://youtu.be/RFpJk9ZxyIo'
      }],
      open: openTutoriel
    };

    ctrl.panier = {
      open: false,
      visible: false,
      prospect: null,
      external: false,
      nb: 0,
      onChoseProspect: onChoseProspect,
      onSaveProspect: onSaveProspect,
      onChange: onChangePanier,
      onRemove: onRemovePanier,
      ajouter: ajouterPanier,
      toggle: togglePanier,
      show: showPanier,
      hide: hidePanier
    };

    ctrl.favoris = {
      open: false,
      visible: false,
      coupCoeurAgence: false,
      nb: 0,
      onChange: onFavorisChange,
      getList: getFavorisList,
      ajouter: ajouterFavori,
      toggle: toggleFavoris,
      show: showFavoris,
      hide: hideFavoris
    };

    ctrl.selection = {
      open: false,
      visible: false,
      nb: 0,
      refList: [],
      onChange: onSelectionChange,
      getList: getSelectionList,
      ajouter: ajouterSelection,
      retirer: retirerSelection,
      toggle: toggleSelection,
      show: showSelection,
      hide: hideSelection
    };

    ctrl.report = {
      open: false,
      visible: false,
      toggle: toggleReport,
      show: showReport,
      hide: hideReport
    };

    ctrl.stateChangeListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      closeOtherFiches();
      checkLienActive(toState, toParams);
    });

    ctrl.loginTokenListener = $scope.$watch(
      function () {
        return globalService.isLogged();
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal && !ctrl.logged && newVal) {
          initialisation();
          Idle.watch();
        }
        ctrl.logged = newVal;
      }
    );

    ctrl.typeApplicationListener = $scope.$on('typeApplication', function (event, args) {
      ctrl.transac = args.transac;
      getCurrentMenu();
    });

    $window.addEventListener('beforeunload', function () {
      globalService.setStorageItem('PANIER-PROSPECT', ctrl.panier.prospect);
    });

    angular.element($window).on('resize', resizeHandler);

    ctrl.$onInit = initialisation;
    ctrl.$onDestroy = destruction;

    function initialisation() {
      ctrl.logged = globalService.isLogged();
      ctrl.employe = globalService.getEmploye();
      ctrl.citya = CONSTANTS.configClient.citya;
      ctrl.menu.forced = ctrl.citya && $window.innerWidth >= 768;

      if (ctrl.logged && ctrl.employe) {
        getCurrentMenu();

        // Coups de coeurs ou Biens urgents :
        ctrl.favoris.coupCoeurAgence = ctrl.employe.societe.agence.coupCoeurAgence;

        // Get selection list
        $rootScope.selectionList = $rootScope.selectionList || {};
        getSelectionList();

        // Get panier prospect & nb
        var prospect = globalService.getStorageItem('PANIER-PROSPECT');
        if (prospect !== null && prospect.referenceInterne) {
          onChoseProspect(prospect);
          ctrl.panier.nb = globalService.getStorageItem('PANIER-NB') ? globalService.getStorageItem('PANIER-NB') : 0;
        } else {
          $rootScope.$broadcast('panierActif', false);
        }

        // Get favoris list
        getFavorisList();

        $timeout(function () {
          $animate.on('enter', $element[0], onEnterFicheContainer);
          checkLienActive();

          if (ctrl.employe.profileTrans.adminProfile && globalService.getVersion().indexOf('2.') === 0) {
            ctrl.parametrage.active = true;
          }
        });
      } else {
        ctrl.logged = false;
        ctrl.employe = null;
        $state.go('login');
      }
    }

    function destruction() {
      ctrl.stateChangeListener();
      ctrl.stateChangeListener = null;
      ctrl.loginTokenListener();
      ctrl.loginTokenListener = null;
      ctrl.typeApplicationListener();
      ctrl.typeApplicationListener = null;

      ctrl.showFicheListener();
      ctrl.showFicheListener = null;
      ctrl.ajoutPanierListener();
      ctrl.ajoutPanierListener = null;
      ctrl.nbPanierChangeListener();
      ctrl.nbPanierChangeListener = null;
      ctrl.ajouterFavorisListener();
      ctrl.ajouterFavorisListener = null;
      ctrl.ajouterSelectionListener();
      ctrl.ajouterSelectionListener = null;
      ctrl.ajouterAllSelectionListener();
      ctrl.ajouterAllSelectionListener = null;
      ctrl.retirerSelectionListener();
      ctrl.retirerSelectionListener = null;
      ctrl.clearSelectionListener();
      ctrl.clearSelectionListener = null;

      angular.element($window).off('resize', resizeHandler);

      $animate.off('enter');
      $document.off('click', onClickOutside);
    }

    function resizeHandler() {
      ctrl.menu.forced = ctrl.citya && $window.innerWidth >= 768;
    }

    function getCurrentMenu() {
      angular.forEach(ctrl.menu.liens, function (lien) {
        switch (lien.nom) {
          case 'Réservations':
            lien.nom = globalService.getTypeApplication() === 'Transaction' ? 'Compromis' : lien.nom;
            break;
          case 'Compromis':
            lien.nom = globalService.getTypeApplication() === 'Location' ? 'Réservations' : lien.nom;
            break;
          case 'Locations':
            lien.nom = globalService.getTypeApplication() === 'Transaction' ? 'Ventes' : lien.nom;
            break;
          case 'Ventes':
            lien.nom = globalService.getTypeApplication() === 'Location' ? 'Locations' : lien.nom;
            break;
        }
      });

      $timeout(function () {
        if (globalService.getTypeApplication() === 'Transaction') {
          ctrl.menu.current = ctrl.menu.liens.filter(function (lien) {
            return lien.shortName !== 'gestionStock';
          });
        } else {
          if (ctrl.citya) {
            ctrl.menu.current = ctrl.menu.liens.filter(function (lien) {
              return lien.shortName !== 'listeBien';
            });
          } else {
            ctrl.menu.current = ctrl.menu.liens;
          }
        }

        checkLienActive();
      });
    }

    function checkLienActive(toState, toParams) {
      var state = toState ? toState.name : $state.current.name,
        params = toParams || $state.params;

      angular.forEach(ctrl.menu.current, function (lien) {
        if (lien.shortName === 'contrat') {
          lien.active =
            state === 'contrat' &&
            ((lien.nom === 'Compromis' && params.type === 'compromis') ||
              (lien.nom === 'Ventes' && params.type === 'vente') ||
              (lien.nom === 'Réservations' && params.type === 'reservation') ||
              (lien.nom === 'Locations' && params.type === 'location'));
        } else {
          lien.active = state === lien.shortName;
        }
      });
    }

    function onEnterFicheContainer(element, phase) {
      if (element.hasClass('fiche-container') && phase === 'close') {
        $timeout(function () {
          $scope.$apply(function () {
            switch (true) {
              case ctrl.fiches.open:
                ctrl.fiches.visible = true;
                break;

              case ctrl.panier.open:
                ctrl.panier.visible = true;
                break;

              case ctrl.favoris.open:
                ctrl.favoris.visible = true;
                break;

              case ctrl.selection.open:
                ctrl.selection.visible = true;
                break;
            }
          });
        });
      }
    }

    function onClickOutside() {
      $document.off('click', onClickOutside);
      $timeout(function () {
        ctrl.menu.open = false;
      });
    }

    function closeOtherFiches(current) {
      if (ctrl.fiches.open && current !== 'fiches') hideFiche();
      if (ctrl.panier.open && current !== 'panier') hidePanier();
      if (ctrl.favoris.open && current !== 'favoris') hideFavoris();
      if (ctrl.selection.open && current !== 'selection') hideSelection();
      if (ctrl.report.open && current !== 'report') hideReport();
    }

    // ---------------------------------------------------=[ FICHES ]=--------------------------------------------------
    ctrl.showFicheListener = $rootScope.$on('showFiche', function (event, params) {
      if (params.type && params.ref) {
        if (
          ctrl.fiches.open &&
          ctrl.fiches.visible &&
          params.type === ctrl.fiches.type &&
          params.ref === ctrl.fiches.ref
        ) {
          hideFiche();
        } else {
          ctrl.fiches.type = params.type;
          ctrl.fiches.list = angular.isDefined(params.refList) ? params.refList : [];
          showFiche(params.ref);
        }
      }
    });

    function showFiche(ref) {
      if (ctrl.fiches.open || ctrl.fiches.ref !== false) {
        hideFiche();
      }

      closeOtherFiches('fiches');

      if (angular.isDefined(ctrl.fiches.reloading)) {
        $timeout.cancel(ctrl.fiches.reloading);
      }

      if (ref) {
        ctrl.fiches.reloading = $timeout(
          function () {
            ctrl.fiches.ref = ref;
            ctrl.fiches.open = true;
            ctrl.fiches.visible = true;
          },
          200,
          true,
          ref
        );
      }
    }

    function hideFiche() {
      ctrl.fiches.open = false;
      ctrl.fiches.visible = false;
      ctrl.fiches.ref = false;
    }

    function changeFiche(target) {
      var i = 0,
        ref = null;

      for (i; i < ctrl.fiches.list.length; i++) {
        if (ctrl.fiches.list[i] === ctrl.fiches.ref) {
          if (target === 'next') {
            if (i < ctrl.fiches.list.length - 1) ref = ctrl.fiches.list[i + 1];
            else ref = ctrl.fiches.list[0];
          } else {
            if (i > 0) ref = ctrl.fiches.list[i - 1];
            else ref = ctrl.fiches.list[ctrl.fiches.list.length - 1];
          }
          break;
        }
      }

      showFiche(ref);
    }

    // -------------------------------------------------=[ TUTORIEL ]=-------------------------------------------------
    function openTutoriel() {
      $log.info('Ouverture e-Toturiel');
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/e-tutoriel/modal.e-tutoriel.html',
        controller: 'ModalETutorielController',
        controllerAs: 'modaletutorielctrl',
        resolve: {
          tutoriels: function () {
            switch ($state.current.name) {
              case 'listeBien':
                return ctrl.tutoriels.common
                  .filter(function (tuto) {
                    return tuto.id === 1 || tuto.id === 3 || tuto.id === 4;
                  })
                  .concat(
                    ctrl.tutoriels[globalService.getTypeApplication()].filter(function (tuto) {
                      return tuto.id === 1;
                    })
                  );
              case 'listeProspects':
                return ctrl.tutoriels.common.filter(function (tuto) {
                  return tuto.id === 1 || tuto.id === 2 || tuto.id === 3 || tuto.id === 4;
                });
              case 'modifBien':
                return ctrl.tutoriels.common
                  .filter(function (tuto) {
                    return tuto.id === 1 || tuto.id === 4;
                  })
                  .concat(
                    ctrl.tutoriels[globalService.getTypeApplication()].filter(function (tuto) {
                      return tuto.id === 1;
                    })
                  );
              case 'modifProspect':
                return ctrl.tutoriels.common.filter(function (tuto) {
                  return tuto.id === 1 || tuto.id === 2 || tuto.id === 4;
                });
              case 'parutionsIcsBox':
                return ctrl.tutoriels.common.filter(function (tuto) {
                  return tuto.id === 1 || tuto.id === 4 || tuto.id === 5;
                });
              default:
                return ctrl.tutoriels.common.concat(ctrl.tutoriels[globalService.getTypeApplication()]);
            }
          }
        }
      });
      modalInstance.result.then(function () {
        $log.info('Fermeture e-Toturiel');
      });
    }

    // --------------------------------------------------=[ PANIER ]=--------------------------------------------------
    ctrl.nbPanierChangeListener = $rootScope.$on('nbPanierChange', function (event, params) {
      onChangePanier(params.nb);
    });

    ctrl.prospectPanierChangeListener = $rootScope.$on('prospectPanierChange', function (event, params) {
      onChoseProspect(params.prospect, params.nb, params.external);
    });

    ctrl.saveProspectPanierListener = $rootScope.$on('saveProspectPanier', function (event, params) {
      onSaveProspect(params.prospect, params.callback);
    });

    ctrl.ajoutPanierListener = $rootScope.$on('ajouterPanier', function (event, params) {
      ajouterPanier(params.refLot);
    });

    ctrl.ajoutPanierListener = $rootScope.$on('removePanier', onRemovePanier);

    function onChangePanier(nb) {
      ctrl.panier.nb = nb;
      globalService.setStorageItem('PANIER-NB', nb);
    }

    function onChoseProspect(prospect, nb, external) {
      if (prospect.referenceInterne) {
        nb =
          (angular.isDefined(nb) ? nb : 0) ||
          (globalService.getStorageItem('PANIER-NB') ? globalService.getStorageItem('PANIER-NB') : 0);
        ctrl.panier.external = angular.isDefined(external) ? external : prospect.referenceInterne.includes('CLOUD-');
        ctrl.panier.prospect = prospect;
        globalService.setStorageItem('PANIER-PROSPECT', prospect);
        onChangePanier(nb);
        $rootScope.$broadcast('panierActif', true);
      }
    }

    function onSaveProspect(prospect, callback) {
      var fromcloud = prospect.referenceInterne.includes('CLOUD-');

      ProspectsService.editerProspect({
          addProspect: true,
          typeApplication: globalService.getTypeApplication(),
          typeMethode: 'complete'
        })
        .then(function (json) {
          if (json.status === 'OK') {
            prospect.id = json.prospect.id;
            prospect.referenceInterne = json.prospect.referenceInterne;
            prospect = prospect.isModel ? prospect : new Prospect(prospect);

            var params = {
              xmlProspect: prospect.toJson(),
              typeApplication: globalService.getTypeApplication(),
              typeMethode: 'complete'
            };

            if (fromcloud) {
              params.fromcloud = true;
            }

            ProspectsService.editerProspect(params)
              .then(function (retour) {
                if (retour.status === 'OK') {
                  prospect = retour.prospect;
                  onChoseProspect(prospect, 0);
                  globalService.setStorageItem('PANIER-PROSPECT', prospect);
                  ctrl.panier.external = false;

                  if (angular.isFunction(callback)) {
                    callback({
                      status: 'OK',
                      prospect: prospect
                    });
                  }
                } else {
                  if (angular.isFunction(callback)) {
                    callback({
                      status: retour.status,
                      message: retour.message
                    });
                  }
                }
              })
              .catch(function (error) {
                if (error.status) {
                  if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                  else if (error.status !== 'SESSION_EXPIRED')
                    $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                } else $log.error(error.status);
                if (angular.isFunction(callback)) {
                  callback(error);
                }
              });
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
        });
    }

    function ajouterPanier(ref) {
      if (!ctrl.panier.external && !ctrl.panier.prospect.referenceInterne.includes('CLOUD-')) {
        PanierService.setPanier({
            prospect: ctrl.panier.prospect.referenceInterne,
            lot: ref,
            action: 'ajout',
            typeMethode: 'liste',
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (retour) {
            if (retour.status === 'OK') {
              onChangePanier(retour.nb);
            }
          })
          .catch(function (error) {
            if (error.status) {
              if (error.status === 'ZERO_RESULT') $log.warn(error.message);
              else if (error.status !== 'SESSION_EXPIRED') {
                $log.error(error.status + (error.message ? ' - ' + error.message : ''));
                toastr.error(
                  'Le bien ne s&apos;est pas ajout&eacute; correctement au panier.<br>' +
                  'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                  '<br>' +
                  'Si le probl&egrave;me persiste, contactez la hotline.',

                  'Probl&egrave;me ajout panier (code erreur : <i>HDR-557</i>)'
                );
              }
            } else $log.error(error.status);
          });
      } else {
        onSaveProspect(ctrl.panier.prospect, function (retour) {
          if (retour.status === 'OK') {
            ajouterPanier(ref);
          }
        });
      }
    }

    function onRemovePanier() {
      ctrl.panier.prospect = null;
      globalService.setStorageItem('PANIER-PROSPECT', null);
      globalService.setStorageItem('QUERY-LISTE-BIEN', null);
      onChangePanier(0);
      $rootScope.$broadcast('panierActif', false);
    }

    function togglePanier() {
      if (ctrl.panier.open) {
        hidePanier();
      } else {
        showPanier();
      }
    }

    function showPanier() {
      closeOtherFiches('panier');

      if (angular.isDefined(ctrl.panier.reloading)) {
        $timeout.cancel(ctrl.panier.reloading);
      }

      ctrl.panier.reloading = $timeout(function () {
        ctrl.panier.open = true;
      }, 200);
    }

    function hidePanier() {
      ctrl.panier.open = false;
      ctrl.panier.visible = false;
    }

    // --------------------------------------------------=[ FAVORIS ]=-------------------------------------------------
    ctrl.ajouterFavorisListener = $rootScope.$on('ajouterFavori', function (event, params) {
      ctrl.favoris.ajouter(params.idLot);
    });

    function getFavorisList() {
      FavorisService.getList({
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.favoris.nb = retour.list.length;
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Les coups de coeur n&apos;ont pas pu &ecirc;tre correctement r&eacute;cup&eacute;r&eacute;s.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me r&eacute;cup&eacute;ration coups de coeur (code erreur : <i>HDR-660</i>)',

                {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
        });
    }

    function ajouterFavori(idLot) {
      FavorisService.ajouter({
          addIdLot: idLot,
          typeMethode: 'liste',
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (retour) {
          if (retour.status === 'OK') {
            ctrl.favoris.nb = retour.list.length;
            $log.info('Le bien [ ' + idLot + ' ] à été ajouté à la sélection.');
          }
        })
        .catch(function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED') {
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              toastr.error(
                'Le bien ne s&apos;est pas ajout&eacute; correctement aux coups de coeur.<br>' +
                'Veuillez r&eacute;essayer ult&eacute;rieurement.<br>' +
                '<br>' +
                'Si le probl&egrave;me persiste, contactez la hotline.',

                'Probl&egrave;me ajout coup de coeur (code erreur : <i>HDR-690</i>)',

                {
                  timeOut: 8000
                }
              );
            }
          } else $log.error(error.status);
        });
    }

    function onFavorisChange(nb) {
      ctrl.favoris.nb = nb;
    }

    function toggleFavoris() {
      if (ctrl.favoris.open) {
        hideFavoris();
      } else {
        showFavoris();
      }
    }

    function showFavoris() {
      closeOtherFiches('favoris');

      if (angular.isDefined(ctrl.favoris.reloading)) {
        $timeout.cancel(ctrl.favoris.reloading);
      }

      ctrl.favoris.reloading = $timeout(function () {
        ctrl.favoris.open = true;
      }, 200);
    }

    function hideFavoris() {
      ctrl.favoris.open = false;
      ctrl.favoris.visible = false;
    }

    // --------------------------------------------------=[ SELECTION ]=------------------------------------------------
    ctrl.ajouterSelectionListener = $rootScope.$on('ajouterSelection', function (event, params) {
      ajouterSelection(params.refLot);
    });

    ctrl.ajouterAllSelectionListener = $rootScope.$on('ajouterAllSelection', function (event, params) {
      ajouterAllSelection(params.refList);
    });

    ctrl.retirerSelectionListener = $rootScope.$on('retirerSelection', function (event, params) {
      retirerSelection(params.refLot);
    });

    ctrl.clearSelectionListener = $rootScope.$on('clearSelection', function () {
      ctrl.selection.refList = [];
      ctrl.selection.nb = 0;
      hideSelection();

      $rootScope.selectionList = {};
      globalService.setStorageItem('SELECTION-LIST', null);
      $rootScope.$broadcast('selection-changed');
    });

    function getSelectionList() {
      ctrl.selection.refList = globalService.getStorageItem('SELECTION-LIST') || [];
      ctrl.selection.nb = ctrl.selection.refList.length;

      angular.forEach(ctrl.selection.refList, function (ref) {
        $rootScope.selectionList[ref] = true;
      });
    }

    function ajouterSelection(refLot) {
      if (!CustomUtils.collection.contains(ctrl.selection.refList, refLot)) {
        ctrl.selection.refList.push(refLot);
      }

      $rootScope.selectionList[refLot] = true;

      globalService.setStorageItem('SELECTION-LIST', ctrl.selection.refList);
      ctrl.selection.nb = ctrl.selection.refList.length;

      $rootScope.$broadcast('selection-changed');
    }

    function ajouterAllSelection(refList) {
      ctrl.selection.refList = refList;

      $rootScope.selectionList = {};
      angular.forEach(ctrl.selection.refList, function (ref) {
        $rootScope.selectionList[ref] = true;
      });

      globalService.setStorageItem('SELECTION-LIST', ctrl.selection.refList);
      ctrl.selection.nb = ctrl.selection.refList.length;

      $rootScope.$broadcast('selection-changed');
    }

    function retirerSelection(refLot) {
      ctrl.selection.refList = ctrl.selection.refList.filter(function (ref) {
        return ref !== refLot;
      });

      $rootScope.selectionList[refLot] = false;

      globalService.setStorageItem('SELECTION-LIST', ctrl.selection.refList);
      ctrl.selection.nb = ctrl.selection.refList.length;

      $rootScope.$broadcast('selection-changed');
    }

    function onSelectionChange(refList) {
      ctrl.selection.refList = refList;
      globalService.setStorageItem('SELECTION-LIST', ctrl.selection.refList);
      ctrl.selection.nb = ctrl.selection.refList.length;

      $timeout(function () {
        angular.forEach($rootScope.selectionList, function (selection, ref) {
          $rootScope.selectionList[ref] = CustomUtils.collection.contains(ctrl.selection.refList, ref);
        });

        $rootScope.$broadcast('selection-changed');
      });
    }

    function toggleSelection() {
      if (ctrl.selection.open) {
        hideSelection();
      } else {
        showSelection();
      }
    }

    function showSelection() {
      closeOtherFiches('selection');

      if (angular.isDefined(ctrl.selection.reloading)) {
        $timeout.cancel(ctrl.selection.reloading);
      }

      ctrl.selection.reloading = $timeout(function () {
        ctrl.selection.open = true;
      }, 200);
    }

    function hideSelection() {
      ctrl.selection.open = false;
      ctrl.selection.visible = false;
    }

    function toggleReport() {
      if (ctrl.report.open) {
        hideReport();
      } else {
        showReport();
      }
    }

    function showReport() {
      closeOtherFiches('report');
      ctrl.report.open = true;
      ctrl.report.visible = true;
    }

    function hideReport() {
      ctrl.report.open = false;
      ctrl.report.visible = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Societe', SocieteModel);

  /** @ngInject */
  function SocieteModel(Main, Adresse, Agence) {

    var Societe = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Societe.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // adresse
      setAdresse: function (val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Adresse(val);
        }
        this.adresse = val;
      },

      // agence
      setAgence: function (val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Agence(val);
        }
        this.agence = val;
      },

      // -----=[ METHODES ]=-----
      hasAdresse: function () {
        return this.hasOwnProperty('adresse') && (this.adresse.immeuble || this.adresse.rue
          || this.adresse.complement || this.adresse.cp || this.adresse.ville || this.adresse.pays);
      }

    };

    angular.extend(Societe.prototype, Main.prototype);

    return Societe;
  }
})();
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Reservation', ReservationModel);

  /** @ngInject */
  function ReservationModel(Contrat, Perso, Prospect, CONSTANTS, moment) {
    var Reservation = function(data) {
      Contrat.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Reservation.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // locataire
      setLocataire: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Prospect(val);
        }
        this.locataire = val;
      },

      // colocataire
      setColocataire: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Perso(val);
        }
        this.colocataire = val;
      },

      // caution1
      setCaution1: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Perso(val);
        }
        this.caution1 = val;
      },

      // caution2
      setCaution2: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Perso(val);
        }
        this.caution2 = val;
      },

      // -----=[ METHODES ]=-----
      hasLocataire: function() {
        return (
          this.hasOwnProperty('locataire') &&
          this.locataire &&
          this.locataire.hasOwnProperty('perso') &&
          this.locataire.perso.isModel
        );
      },

      getLocataireNomComplet: function() {
        if (this.hasLocataire()) {
          if (this.locataire.perso.hasNomComplet()) {
            return this.locataire.perso.getNomComplet();
          } else if (this.locataire.perso.hasNom()) {
            var nom = this.locataire.perso.nom;

            if (this.locataire.perso.hasPrenom()) {
              nom += ' ' + this.locataire.perso.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getLocataireAdresse: function() {
        if (this.hasLocataire() && this.locataire.perso.hasAdresses()) {
          return this.locataire.perso.adresses;
        } else return false;
      },

      getLocataireContacts: function() {
        if (this.hasLocataire() && this.locataire.perso.hasContacts()) {
          return this.locataire.perso.contacts;
        } else return false;
      },

      hasColocataire: function() {
        return this.hasOwnProperty('colocataire') && this.colocataire && this.colocataire.nom;
      },

      hasProprietaire: function() {
        return this.hasOwnProperty('affaire') && this.affaire.hasProprietaire() && this.affaire.proprietaire.isModel;
      },

      getProprietaireNomComplet: function() {
        if (this.hasProprietaire()) {
          if (this.affaire.proprietaire.hasNomComplet()) {
            return this.affaire.proprietaire.getNomComplet();
          } else if (this.affaire.proprietaire.hasNom()) {
            var nom = this.affaire.proprietaire.nom;

            if (this.affaire.proprietaire.hasPrenom()) {
              nom += ' ' + this.affaire.proprietaire.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getProprietaireAdresse: function() {
        if (this.hasProprietaire() && this.affaire.proprietaire.hasAdresses()) {
          return this.affaire.proprietaire.adresses;
        } else return false;
      },

      getProprietaireContacts: function() {
        if (this.hasProprietaire() && this.affaire.proprietaire.hasContacts()) {
          return this.affaire.proprietaire.contacts;
        } else return false;
      },

      hasNegoProprietaire: function() {
        return this.hasOwnProperty('affaire') && this.affaire.hasOwnProperty('nego');
      },

      getNegoProprietaireNomComplet: function() {
        if (this.hasProprietaire()) {
          if (this.affaire.proprietaire.hasNomComplet()) {
            return this.affaire.proprietaire.getNomComplet();
          } else if (this.affaire.proprietaire.hasNom()) {
            var nom = this.affaire.proprietaire.nom;

            if (this.affaire.proprietaire.hasPrenom()) {
              nom += ' ' + this.affaire.proprietaire.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      hasDateFinOption: function() {
        return this.hasOwnProperty('dateFinOption') && this.dateFinOption;
      },

      hasDateSignature: function() {
        return this.hasOwnProperty('dateSignature') && this.dateSignature;
      },

      hasDateEtatDesLieux: function() {
        return this.hasOwnProperty('dateEtatDesLieux') && this.dateEtatDesLieux;
      },

      isDateFinOptionDepassee: function() {
        if (!this.hasDatePrevueVente() && !this.hasDateEffectiveVente() && this.hasDateFinOption()) {
          return moment().diff(moment(this.dateFinOption, CONSTANTS.date_format), 'days');
        } else return null;
      },

      isDateEffectiveReservationDepassee: function() {
        if (!this.hasDateEtatDesLieux() && this.hasDateEffectiveVente()) {
          return moment().diff(moment(this.dateEffectiveVente, CONSTANTS.date_format), 'days');
        } else return null;
      },

      getHonoraires: function() {
        return this.loyer && this.tauxHono ? this.loyer / 100 * this.tauxHono : 0;
      }
    };

    angular.extend(Reservation.prototype, Contrat.prototype);

    return Reservation;
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Prospect', ProspectModel);

  /** @ngInject */
  function ProspectModel(Main, Critere, Perso, Nego) {

    var Prospect = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Prospect.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // criteres
      setCriteres: function (val) {
        if (angular.isArray(val)) {
          angular.forEach(val, function (critere) {
            if (critere.hasOwnProperty('critere') && critere.critere.id) {
              if (!critere.isModel) {
                critere = new Critere(critere);
              }
            }
          });
        }
        this.criteres = val;
      },

      // nego
      setNego: function (val) {
        if (angular.isObject(val)) {
          if (!val.isModel) {
            val = new Nego(val);
          }
        }
        this.nego = val;
      },

      // perso
      setPerso: function (val) {
        if (angular.isObject(val)) {
          if (!val.isModel) {
            val = new Perso(val);
          }
        }
        this.perso = val;
      },

      // -----=[ METHODES ]=-----
      hasPerso: function () {
        return this.hasOwnProperty('perso') && this.perso.hasType();
      },

      hasQualification: function () {
        return this.hasOwnProperty('qualification');
      },

      hasOrigine: function () {
        return this.hasOwnProperty('origine');
      },

      hasCommentaire: function () {
        return this.hasOwnProperty('commentaire') && this.commentaire !== '';
      },

      hasPrixMin: function () {
        return this.hasOwnProperty('prixMin') && this.prixMin > 0;
      },

      hasPrixMax: function () {
        return this.hasOwnProperty('prixMax') && this.prixMax > 0;
      },

      hasComRepertoire: function () {
        return this.hasOwnProperty('comRepertoire') && angular.isString(this.comRepertoire);
      },

      hasTypesBien: function () {
        return this.hasOwnProperty('typesBien') && angular.isArray(this.typesBien) && this.typesBien.length > 0;
      },

      hasVilles: function () {
        return this.hasOwnProperty('villes') && angular.isArray(this.villes) && this.villes.length > 0;
      },

      hasCriteres: function () {
        if (this.hasOwnProperty('criteres') && angular.isArray(this.criteres) && this.criteres.length > 0) {
          var hasCritere = false;

          angular.forEach(this.criteres, function (critere) {
            critere = critere.isModel ? critere : new Critere(critere);
            if (critere.hasValStr()) hasCritere = true;
          });

          return hasCritere;
        } else return false;
      }
    };

    angular.extend(Prospect.prototype, Main.prototype);

    return Prospect;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Perso', PersoModel);

  /** @ngInject */
  function PersoModel(Main, Adresse, CustomUtils) {
    var Perso = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);

        if (this.hasAdresses()) {
          this.adresses = this.adresses.filter(function(adresse) {
            return !CustomUtils.collection.isEmpty(adresse);
          });
        } else this.setAdresses([new Adresse()]);

        if (this.hasContacts()) {
          this.contacts = this.contacts.filter(function(contact) {
            return !CustomUtils.collection.isEmpty(contact);
          });
        }
      } else {
        this.physique = true;
        this.type = 'PersoPhysique';
        this.contacts = [];
        this.setAdresses([new Adresse()]);
      }
    };

    Perso.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----

      // adresses
      setAdresses: function(val) {
        if (angular.isArray(val)) {
          var adresses = [],
            best = 0,
            index = 0;
          angular.forEach(val, function(adresse, key) {
            if (angular.isObject(adresse)) {
              adresses[key] = {
                adresse: !adresse.isModel ? new Adresse(adresse) : adresse,
                score: 0
              };
              if (adresses[key].adresse.hasImmeuble()) adresses[key].score += 1;
              if (adresses[key].adresse.hasRue()) adresses[key].score += 5;
              if (adresses[key].adresse.hasComplement()) adresses[key].score += 1;
              if (adresses[key].adresse.hasCp()) adresses[key].score += 5;
              if (adresses[key].adresse.hasVille()) adresses[key].score += 5;
              if (adresses[key].adresse.hasPays()) adresses[key].score += 1;
              if (adresses[key].adresse.hasCoords()) adresses[key].score += 1;

              if (adresses[key].score > best) {
                best = adresses[key].score;
                index = key;
              } else if (adresses[key].score === best && key < index) {
                index = key;
              }
            }
          });
          val = adresses.length ? [adresses[index].adresse] : [];
        } else val = [];
        if (!val.length) {
          val.push(new Adresse());
        }
        this.adresses = val;
      },

      // -----=[ METHODES ]=-----
      hasType: function() {
        return this.hasOwnProperty('type') && this.type !== null;
      },

      hasNom: function() {
        return this.hasOwnProperty('nom') && angular.isString(this.nom) && this.nom !== '';
      },

      hasPrenom: function() {
        return this.hasOwnProperty('prenom') && angular.isString(this.prenom) && this.prenom !== '';
      },

      hasNomComplet: function() {
        return this.hasOwnProperty('nomComplet') && angular.isString(this.nomComplet) && this.nomComplet !== '';
      },

      hasDateNaissance: function() {
        return (
          this.hasOwnProperty('dateNaissance') && angular.isDefined(this.dateNaissance) && this.dateNaissance !== ''
        );
      },

      hasAdresses: function() {
        var hasAdresse = false;
        if (this.hasOwnProperty('adresses') && angular.isArray(this.adresses) && this.adresses.length) {
          angular.forEach(this.adresses, function(adresse) {
            if (adresse.immeuble || adresse.rue || adresse.complement || adresse.cp || adresse.ville || adresse.pays) {
              hasAdresse = true;
            }
          });
        }
        return hasAdresse;
      },

      hasContacts: function() {
        return this.hasOwnProperty('contacts') && angular.isArray(this.contacts) && this.contacts.length;
      },

      addContact: function(type, contact) {
        this.contacts = this.hasContacts() ? this.contacts : [];
        if (type && contact) {
          this.contacts.push({
            type: type,
            value: contact
          });
        }
      },

      getNomComplet: function() {
        if (this.hasNomComplet()) {
          return this.nomComplet;
        } else {
          var nomComplet = '';
          if (this.hasNom()) {
            nomComplet = this.nom;
          } else if (this.hasPrenom()) {
            nomComplet += this.prenom;
          }

          if (this.hasNom() && this.hasPrenom()) {
            nomComplet += ' ' + this.prenom;
          } else if (this.hasPrenom()) {
            nomComplet = this.prenom;
          }

          return nomComplet;
        }
      },

      getEmail: function() {
        if (this.hasContacts()) {
          var contacts = this.contacts;
          for (var i = 0; i < contacts.length; i++) {
            if (contacts[i].type === 'Email' && contacts[i].value) return contacts[i].value;
          }
        }
        return false;
      },

      getTelMobile: function() {
        if (this.hasContacts()) {
          var contacts = this.contacts;
          for (var i = 0; i < contacts.length; i++) {
            if (contacts[i].type === 'TelMobile' && contacts[i].value) return contacts[i].value;
          }
        }
        return false;
      },

      getTel: function() {
        if (this.hasContacts()) {
          var contacts = this.contacts;
          for (var i = 0; i < contacts.length; i++) {
            if (contacts[i].type === 'Telephone' && contacts[i].value) return contacts[i].value;
          }
        }
        return false;
      },

      removeIds: function() {
        delete this.id;
        if (this.hasAdresses()) {
          angular.forEach(this.adresses, function(adresse) {
            delete adresse.id;
          });
        }
        if (this.hasContacts()) {
          angular.forEach(this.contacts, function(contact) {
            delete contact.id;
          });
        }
      },

      clean: function() {
        for (var prop in this) {
          if (this.hasOwnProperty(prop) && (this[prop] === '' || this[prop] === null)) {
            delete this[prop];
          }
        }
      }
    };

    angular.extend(Perso.prototype, Main.prototype);

    return Perso;
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Nego', NegoModel);

  /** @ngInject */
  function NegoModel(Main, Societe, Perso) {

    var Nego = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Nego.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // perso
      setPerso: function (val) {
        if (angular.isObject(val)) {
          if (!val.isModel) {
            val = new Perso(val);
          }
        }
        this.perso = val;
      },

      // societe
      setSociete: function (val) {
        if (angular.isObject(val)) {
          if (!val.isModel) {
            val = new Societe(val);
          }
        }
        this.societe = val;
      }
    };

    angular.extend(Nego.prototype, Main.prototype);

    return Nego;
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Multimedia', MultimediaModel);

  /** @ngInject */
  function MultimediaModel(Main) {

    var Multimedia = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Multimedia.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----

      // -----=[ METHODES ]=-----
      hasFileName: function () {
        return this.hasOwnProperty('fileName');
      },

      hasCommentaire: function () {
        return this.hasOwnProperty('commentaire');
      }
    };

    angular.extend(Multimedia.prototype, Main.prototype);

    return Multimedia;
  }
})();
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Mandat', MandatModel);

  /** @ngInject */
  function MandatModel(Main, Nego) {
    var Mandat = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Mandat.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // nego
      setNego: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Nego(val);
        }
        this.nego = val;
      }

      // -----=[ METHODES ]=-----
    };

    angular.extend(Mandat.prototype, Main.prototype);

    return Mandat;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Main', MainModel);

  /** @ngInject */
  function MainModel(CustomUtils) {
    var Main = function(data) {
      if (data) {
        this.hydrate(data);
      }
    };

    Main.prototype = {
      isModel: true,

      hydrate: function(data) {
        // Hydratation
        angular.forEach(
          data,
          function(val, key) {
            var setter = 'set' + CustomUtils.string.ucfirst(key);
            if (angular.isFunction(this[setter])) this[setter](val);
            else if (data.hasOwnProperty(key)) this[key] = val;
          },
          this
        );
      },

      toJson: function(strict) {
        if (angular.isDefined(strict) && strict && angular.isFunction(this.isJsonProperties)) {
          var obj = {};
          Object.keys(this).forEach(function(key) {
            if (this.isJsonProperties(key)) {
              obj[key] = this[key];
            }
          }, this);
          return angular.toJson(obj);
        } else {
          return angular.toJson(this);
        }
      },

      equals: function() {
        var i, leftChain, rightChain;

        function compare2Objects(x, y) {
          var p;

          // remember that NaN === NaN returns false
          // and isNaN(undefined) returns true
          if (isNaN(x) && isNaN(y) && angular.isNumber(x) && angular.isNumber(y)) {
            return true;
          }

          // Compare primitives and functions.
          // Check if both arguments link to the same object.
          // Especially useful on the step where we compare prototypes
          if (x === y) {
            return true;
          }

          // Works in case when functions are created in constructor.
          // Comparing dates is a common scenario. Another built-ins?
          // We can even handle functions passed across iframes
          if (
            (angular.isFunction(x) && angular.isFunction(y)) ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)
          ) {
            return x.toString() === y.toString();
          }

          // At last checking prototypes as good as we can
          if (!(x instanceof Object && y instanceof Object)) {
            return false;
          }

          if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
          }

          if (x.constructor !== y.constructor) {
            return false;
          }

          if (x.prototype !== y.prototype) {
            return false;
          }

          // Check for infinitive linking loops
          if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
          }

          // Quick checking of one object being a subset of another.
          // todo: cache the structure of arguments[0] for performance
          for (p in y) {
            if (p === '$$hashKey') {
              return true;
            }
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
              return false;
            } else if (typeof y[p] !== typeof x[p]) {
              return false;
            }
          }

          for (p in x) {
            if (p === '$$hashKey') {
              return true;
            }
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
              return false;
            } else if (typeof y[p] !== typeof x[p]) {
              return false;
            }

            switch (typeof x[p]) {
              case 'object':
              case 'function':
                leftChain.push(x);
                rightChain.push(y);

                if (!compare2Objects(x[p], y[p])) {
                  return false;
                }

                leftChain.pop();
                rightChain.pop();
                break;

              default:
                if (x[p] !== y[p]) {
                  return false;
                }
                break;
            }
          }

          return true;
        }

        if (arguments.length < 1) {
          return true; //Die silently? Don't know how to handle such case, please help...
          // throw "Need two or more arguments to compare";
        }

        for (i = 0; i < arguments.length; i++) {
          leftChain = []; //Todo: this can be cached
          rightChain = [];

          if (!compare2Objects(this, arguments[i])) {
            return false;
          }
        }

        return true;
      }
    };

    return Main;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Evenement', EvenementModel);

  /** @ngInject */
  function EvenementModel(Main, Bien, Prospect, Nego) {
    var Evenement = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Evenement.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // lot
      setLot: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Bien(val);
        }
        this.lot = val;
      },

      // prospect
      setProspect: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Prospect(val);
        }
        this.prospect = val;
      },

      // negociateur
      setNegociateur: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Nego(val);
        }
        this.negociateur = val;
      },

      isJsonProperties: function(prop) {
        var jsonProperties = [
          'id',
          'type',
          'rappel',
          'date',
          'dateFin',
          'prospect',
          'lot',
          'commentaire',
          'negociateur',
          'parution',
          'vitrine',
          'active',
          'erreur',
          'alertMail',
          'prix',
          'parutionLibre',
          'suivi',
          'idBonVisite',
          'compteRendu',
          'accompli'
        ];
        return jsonProperties.indexOf(prop) !== -1;
      }
    };

    angular.extend(Evenement.prototype, Main.prototype);

    return Evenement;
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Critere', CritereModel);

  /** @ngInject */
  function CritereModel(Main) {

    var Critere = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Critere.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----

      // -----=[ METHODES ]=-----
      hasValStr: function () {
        return this.hasOwnProperty('valStr') && angular.isDefined(this.valStr);
      }
    };

    angular.extend(Critere.prototype, Main.prototype);

    return Critere;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Contrat', ContratModel);

  /** @ngInject */
  function ContratModel(Main, Bien) {
    var Contrat = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Contrat.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // affaire
      setAffaire: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Bien(val);
        }
        this.affaire = val;
      },

      // -----=[ METHODES ]=-----
      hasDate: function() {
        return this.hasOwnProperty('date') && this.date;
      },

      hasDateEffectiveVente: function() {
        return this.hasOwnProperty('dateEffectiveVente') && this.dateEffectiveVente;
      },

      hasDatePrevueVente: function() {
        return this.hasOwnProperty('datePrevueVente') && this.datePrevueVente;
      },

      hasDateEncaissement: function() {
        return this.hasOwnProperty('dateEncaissement') && this.dateEncaissement;
      }
    };

    angular.extend(Contrat.prototype, Main.prototype);

    return Contrat;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Compromis', CompromisModel);

  /** @ngInject */
  function CompromisModel(Contrat, Perso, CONSTANTS, moment) {
    var Compromis = function(data) {
      Contrat.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Compromis.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // acheteur
      setAcheteur: function(val) {
        if (angular.isObject(val) && val.hasOwnProperty('perso') && angular.isObject(val.perso) && !val.perso.isModel) {
          val.perso = new Perso(val.perso);
        }
        this.acheteur = val;
      },

      // notaireAcheteur
      setNotaireAcheteur: function(val) {
        if (angular.isObject(val) && val.hasOwnProperty('perso') && angular.isObject(val.perso) && !val.perso.isModel) {
          val.perso = new Perso(val.perso);
        }
        this.notaireAcheteur = val;
      },

      // notaireVendeur
      setNotaireVendeur: function(val) {
        if (angular.isObject(val) && val.hasOwnProperty('perso') && angular.isObject(val.perso) && !val.perso.isModel) {
          val.perso = new Perso(val.perso);
        }
        this.notaireVendeur = val;
      },

      // -----=[ METHODES ]=-----
      hasAcheteur: function() {
        return (
          this.hasOwnProperty('acheteur') &&
          this.acheteur &&
          this.acheteur.hasOwnProperty('perso') &&
          this.acheteur.perso.isModel
        );
      },

      getAcheteurNomComplet: function() {
        if (this.hasAcheteur()) {
          if (this.acheteur.perso.hasNomComplet()) {
            return this.acheteur.perso.getNomComplet();
          } else if (this.acheteur.perso.hasNom()) {
            var nom = this.acheteur.perso.nom;

            if (this.acheteur.perso.hasPrenom()) {
              nom += ' ' + this.acheteur.perso.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getAcheteurAdresse: function() {
        if (this.hasAcheteur() && this.acheteur.perso.hasAdresses()) {
          return this.acheteur.perso.adresses;
        } else return false;
      },

      getAcheteurContacts: function() {
        if (this.hasAcheteur() && this.acheteur.perso.hasContacts()) {
          return this.acheteur.perso.contacts;
        } else return false;
      },

      hasNotaireAcheteur: function() {
        return (
          this.hasOwnProperty('notaireAcheteur') &&
          this.notaireAcheteur &&
          this.notaireAcheteur.hasOwnProperty('perso') &&
          this.notaireAcheteur.perso.isModel
        );
      },

      getNotaireAcheteurNomComplet: function() {
        if (this.hasNotaireAcheteur()) {
          if (this.notaireAcheteur.perso.hasNomComplet()) {
            return this.notaireAcheteur.perso.getNomComplet();
          } else if (this.notaireAcheteur.perso.hasNom()) {
            var nom = this.notaireAcheteur.perso.nom;

            if (this.notaireAcheteur.perso.hasPrenom()) {
              nom += ' ' + this.notaireAcheteur.perso.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getNotaireAcheteurAdresse: function() {
        if (this.hasNotaireAcheteur() && this.notaireAcheteur.perso.hasAdresses()) {
          return this.notaireAcheteur.perso.adresses;
        } else return false;
      },

      getNotaireAcheteurContacts: function() {
        if (this.hasNotaireAcheteur() && this.notaireAcheteur.perso.hasContacts()) {
          return this.notaireAcheteur.perso.contacts;
        } else return false;
      },

      hasVendeur: function() {
        return this.hasOwnProperty('affaire') && this.affaire.hasProprietaire() && this.affaire.proprietaire.isModel;
      },

      getVendeurNomComplet: function() {
        if (this.hasVendeur()) {
          if (this.affaire.proprietaire.hasNomComplet()) {
            return this.affaire.proprietaire.getNomComplet();
          } else if (this.affaire.proprietaire.hasNom()) {
            var nom = this.affaire.proprietaire.nom;

            if (this.affaire.proprietaire.hasPrenom()) {
              nom += ' ' + this.affaire.proprietaire.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getVendeurAdresse: function() {
        if (this.hasVendeur() && this.affaire.proprietaire.hasAdresses()) {
          return this.affaire.proprietaire.adresses;
        } else return false;
      },

      getVendeurContacts: function() {
        if (this.hasVendeur() && this.affaire.proprietaire.hasContacts()) {
          return this.affaire.proprietaire.contacts;
        } else return false;
      },

      hasNotaireVendeur: function() {
        return (
          this.hasOwnProperty('notaireVendeur') &&
          this.notaireVendeur &&
          this.notaireVendeur.hasOwnProperty('perso') &&
          this.notaireVendeur.perso.isModel
        );
      },

      getNotaireVendeurNomComplet: function() {
        if (this.hasNotaireVendeur()) {
          if (this.notaireVendeur.perso.hasNomComplet()) {
            return this.notaireVendeur.perso.getNomComplet();
          } else if (this.notaireVendeur.perso.hasNom()) {
            var nom = this.notaireVendeur.perso.nom;

            if (this.notaireVendeur.perso.hasPrenom()) {
              nom += ' ' + this.notaireVendeur.perso.prenom;
            }
            return nom;
          }
        }
        return '';
      },

      getNotaireVendeurAdresse: function() {
        if (this.hasNotaireVendeur() && this.notaireVendeur.perso.hasAdresses()) {
          return this.notaireVendeur.perso.adresses;
        } else return false;
      },

      getNotaireVendeurContacts: function() {
        if (this.hasNotaireVendeur() && this.notaireVendeur.perso.hasContacts()) {
          return this.notaireVendeur.perso.contacts;
        } else return false;
      },

      isDatePrevueDepassee: function() {
        if (!this.hasDateEffectiveVente() && this.hasDatePrevueVente()) {
          return moment().diff(moment(this.datePrevueVente, CONSTANTS.date_format), 'days');
        } else return null;
      },

      getPrixVente: function() {
        return this.affaire.hasMandatTransaction() && this.affaire.mandatTransaction.hasOwnProperty('prixVente')
          ? this.affaire.mandatTransaction.prixVente
          : false;
      },

      getPrixNetVendeur: function() {
        return this.getCommission() ? this.affaire.mandatTransaction.prixVente - this.getCommission() : false;
      },

      getTauxComm: function() {
        return this.affaire.hasMandatTransaction() && this.affaire.mandatTransaction.hasOwnProperty('tauxComm')
          ? this.affaire.mandatTransaction.tauxComm
          : false;
      },

      getCommission: function() {
        return this.affaire.hasMandatTransaction() &&
          this.affaire.mandatTransaction.hasOwnProperty('prixVente') &&
          this.affaire.mandatTransaction.hasOwnProperty('tauxComm')
          ? this.affaire.mandatTransaction.prixVente / 100 * this.affaire.mandatTransaction.tauxComm
          : false;
      },

      getCommissionHT: function() {
        return this.getCommission() ? this.getCommission() / (1 + this.tva / 100) : false;
      }
    };

    angular.extend(Compromis.prototype, Contrat.prototype);

    return Compromis;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Bien', BienModel);

  /** @ngInject */
  function BienModel(Main, Perso, Mandat, Adresse, Multimedia) {
    var Bien = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Bien.prototype = {
      isBien: true,

      // -----=[ GETTERS / SETTERS ]=-----
      // proprietaire
      setProprietaire: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Perso(val);
        }
        this.proprietaire = val;
      },

      // mandat transaction
      setMandatTransaction: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Mandat(val);
        }
        this.mandatTransaction = val;
      },

      // mandat location
      setMandatLocation: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Mandat(val);
        }
        this.mandatLocation = val;
      },

      // adresse
      setAdresse: function(val) {
        if (angular.isObject(val)) {
          val = !val.isModel ? new Adresse(val) : val;
        } else val = new Adresse();
        this.adresse = val;
      },

      // multimediaPrincipal
      setMultimediaPrincipal: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Multimedia(val);
        }
        this.multimediaPrincipal = val;
      },

      // multimedia
      setMultimedia: function(val) {
        if (angular.isArray(val)) {
          angular.forEach(val, function(media, key) {
            if (angular.isObject(media) && !media.isModel) {
              val[key] = new Multimedia(media);
            }
          });
        }
        this.multimedia = val;
      },

      // -----=[ METHODES ]=-----
      hasLibelle: function() {
        return this.hasOwnProperty('libelle') && angular.isString(this.libelle) && this.libelle !== '';
      },

      hasDescription: function() {
        return this.hasOwnProperty('description') && angular.isString(this.description) && this.description !== '';
      },

      hasType: function() {
        return this.hasOwnProperty('type');
      },

      hasPiece: function() {
        return this.hasOwnProperty('piece') && this.piece > 0;
      },

      hasPieces: function() {
        return this.hasOwnProperty('pieces') && angular.isArray(this.pieces) && this.pieces.length;
      },

      hasSurface: function() {
        return this.hasOwnProperty('surface') && this.surface > 0;
      },

      hasPrix: function() {
        return this.getPrix() && this.getPrix() > 0;
      },

      // prix
      getPrix: function() {
        var prix = false;
        if (
          this.mandatTransaction &&
          this.mandatTransaction.hasOwnProperty('prixVente') &&
          this.mandatTransaction.prixVente
        ) {
          prix = this.mandatTransaction.prixVente;
        } else if (
          this.mandatLocation &&
          this.mandatLocation.hasOwnProperty('loyerTTC') &&
          this.mandatLocation.loyerTTC
        ) {
          prix = this.mandatLocation.loyerTTC;
        }
        return prix;
      },

      hasLoyer: function() {
        return this.hasMandatLocation() && this.mandatLocation.hasOwnProperty('loyer') && this.mandatLocation.loyer > 0;
      },

      hasDateCreation: function() {
        return (
          this.hasMandatLocation() &&
          this.mandatLocation.hasOwnProperty('dateCreation') &&
          this.mandatLocation.dateCreation &&
          this.mandatLocation.dateCreation !== ''
        );
      },

      hasDepotGarantie: function() {
        return (
          this.hasMandatLocation() &&
          this.mandatLocation.hasOwnProperty('depotGarantie') &&
          this.mandatLocation.depotGarantie >= 0
        );
      },

      hasNoMandat: function() {
        return (
          (this.hasMandatLocation() &&
            this.mandatLocation.hasOwnProperty('noMandat') &&
            this.mandatLocation.noMandat) ||
          (this.hasMandatTransaction() &&
            this.mandatTransaction.hasOwnProperty('noMandat') &&
            this.mandatTransaction.noMandat)
        );
      },

      hasNoMandatGestion: function() {
        return (
          this.hasMandatLocation() &&
          this.mandatLocation.hasOwnProperty('noMandatGestion') &&
          this.mandatLocation.noMandatGestion &&
          this.mandatLocation.noMandatGestion !== ''
        );
      },

      hasAdresse: function() {
        return (
          this.hasOwnProperty('adresse') &&
          (this.adresse.immeuble ||
            this.adresse.rue ||
            this.adresse.complement ||
            this.adresse.cp ||
            this.adresse.ville ||
            this.adresse.pays ||
            this.adresse.latitude ||
            this.adresse.longitude)
        );
      },

      hasMultimediaPrincipal: function() {
        return this.hasOwnProperty('multimediaPrincipal') && this.multimediaPrincipal.hasFileName();
      },

      hasMandatTransaction: function() {
        return this.hasOwnProperty('mandatTransaction');
      },

      hasMandatLocation: function() {
        return this.hasOwnProperty('mandatLocation');
      },

      hasCategorie: function() {
        return this.hasOwnProperty('categorie');
      },

      hasProprietaire: function() {
        return this.hasOwnProperty('proprietaire') && this.proprietaire;
      },

      hasLocataire: function() {
        return (
          this.hasMandatLocation() &&
          this.mandatLocation.hasOwnProperty('locataire') &&
          this.mandatLocation.locataire.nom
        );
      },
      hasCommentaire: function() {
        return (
          (this.hasMandatLocation() && this.mandatLocation.commentaire) ||
          (this.hasMandatTransaction() && this.mandatTransaction.commentaire)
        );
      },
      getTitle: function() {
        var title = '';

        if (this.hasCategorie()) title += this.categorie.label + ' ';
        else if (this.hasType()) title += this.type + ' ';

        if (this.hasPiece()) title += this.piece + ' pièce' + (this.piece > 1 ? 's ' : ' ');
        if (this.hasSurface()) title += this.surface + ' m² ';

        return title.slice(0, -1);
      },

      getFormatedLibelle: function() {
        if (this.hasLibelle()) {
          return this.libelle.replace(/\*/g, '').replace('ss', ' ');
        } else {
          var libelle = '';
          if (this.hasCategorie()) libelle += this.categorie.label + ' ';
          else if (this.hasType()) libelle += this.type + ' ';
          if (this.hasPiece()) {
            libelle += this.piece + ' piece';
            if (this.piece > 1) libelle += 's';
            libelle += ' ';
          }
          if (this.hasSurface()) libelle += this.surface + 'm² ';
          if (this.hasAdresse()) {
            if (this.adresse.hasCp()) libelle += this.adresse.cp + ' ';
            if (this.adresse.hasVille()) libelle += this.adresse.ville;
          }

          if (libelle.length) return libelle;
        }

        return '';
      },

      getAdresseComplete: function() {
        if (this.hasAdresse()) {
          var adresse = '';

          if (this.adresse.hasRue()) {
            adresse += this.adresse.rue + ', ';
          }
          if (this.adresse.hasCp()) {
            adresse += this.adresse.cp + ' ';
          }
          if (this.adresse.hasVille()) {
            adresse += this.adresse.ville;
          }

          return adresse;
        } else return '';
      },

      getCritereValue: function(nomCritere) {
        return angular.isDefined(this[nomCritere]) ? this[nomCritere] : null;
      },

      getSociete: function() {
        var societe = this.hasMandatLocation() ? this.mandatLocation.nego.societe : this.mandatTransaction.nego.societe;
        return societe || false;
      },

      getAgence: function() {
        var agence = this.hasMandatLocation()
          ? this.mandatLocation.nego.societe.agence
          : this.mandatTransaction.nego.societe.agence;
        return agence || false;
      }
    };

    angular.extend(Bien.prototype, Main.prototype);

    return Bien;
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('Alerte', AlerteModel);

  /** @ngInject */
  function AlerteModel(Main, Prospect, Bien) {

    var Alerte = function (data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Alerte.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // lot
      setLot: function (val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Bien(val);
        }
        this.lot = val;
      },

      // prospect
      setProspect: function (val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Prospect(val);
        }
        this.prospect = val;
      }
    };

    angular.extend(Alerte.prototype, Main.prototype);

    return Alerte;
  }
})();
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Societe', SocieteModel);

  /** @ngInject */
  function SocieteModel(Main, Adresse) {
    var Societe = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
      }
    };

    Societe.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----
      // adresse
      setAdresse: function(val) {
        if (angular.isObject(val) && !val.isModel) {
          val = new Adresse(val);
        }
        this.adresse = val;
      },

      // -----=[ METHODES ]=-----
      hasAdresse: function() {
        return (
          this.hasOwnProperty('adresse') &&
          (this.adresse.immeuble ||
            this.adresse.rue ||
            this.adresse.complement ||
            this.adresse.cp ||
            this.adresse.ville ||
            this.adresse.pays)
        );
      }
    };

    angular.extend(Societe.prototype, Main.prototype);

    return Societe;
  }
})();

(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('Adresse', AdresseModel);

  /** @ngInject */
  function AdresseModel(Main) {
    var Adresse = function(data) {
      Main.apply(this, arguments);
      if (data) {
        this.hydrate(data);
        this.immeuble = this.immeuble || '';
        this.rue = this.rue || '';
        this.complement = this.complement || '';
        this.cp = this.cp || '';
        this.ville = this.ville || '';
        this.pays = this.pays || '';
        this.latitude = this.latitude || '';
        this.longitude = this.longitude || '';
      } else {
        this.immeuble = '';
        this.rue = '';
        this.complement = '';
        this.cp = '';
        this.ville = '';
        this.pays = '';
        this.latitude = '';
        this.longitude = '';
      }
    };

    Adresse.prototype = {
      // -----=[ GETTERS / SETTERS ]=-----

      // -----=[ METHODES ]=-----
      hasCoords: function() {
        return (
          this.hasOwnProperty('latitude') &&
          angular.isDefined(this.latitude) &&
          this.latitude !== '' &&
          this.hasOwnProperty('longitude') &&
          angular.isDefined(this.longitude) &&
          this.longitude !== ''
        );
      },

      hasPays: function() {
        return this.hasOwnProperty('pays') && angular.isDefined(this.pays) && this.pays !== '';
      },

      hasCp: function() {
        return this.hasOwnProperty('cp') && angular.isDefined(this.cp) && this.cp !== '';
      },

      hasVille: function() {
        return this.hasOwnProperty('ville') && angular.isDefined(this.ville) && this.ville !== '';
      },

      hasRue: function() {
        return this.hasOwnProperty('rue') && angular.isDefined(this.rue) && this.rue !== '';
      },

      hasComplement: function() {
        return this.hasOwnProperty('complement') && angular.isDefined(this.complement) && this.complement !== '';
      },

      hasImmeuble: function() {
        return this.hasOwnProperty('immeuble') && angular.isDefined(this.immeuble) && this.immeuble !== '';
      },

      isJsonProperties: function(prop) {
        var jsonProperties = [
          'id',
          'perso',
          'immeuble',
          'batiment',
          'entree',
          'numero',
          'rue',
          'complement',
          'ville',
          'cp',
          'pays',
          'latitude',
          'longitude',
          'statut'
        ];
        return jsonProperties.contains(prop);
      }
    };

    angular.extend(Adresse.prototype, Main.prototype);

    return Adresse;
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('VisiteService', VisiteService);

  /** @ngInject */
  function VisiteService(globalService, VisiteResources, $q) {
    var ctrl = this;

    ctrl.bonVisite = bonVisite;

    function bonVisite(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.lotIdsVisite || !params.prospectId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "lotIdsVisite" et/ou "prospectId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.imprimer = angular.isDefined(params.imprimer) ? params.imprimer : true;
        params.editionFile = params.editionFile || 'Bon de visite.xsl';

        VisiteResources
          .bonVisite(
            params,

            function (json) {
              if (json.fileName && json.path) {
                json.status = 'OK';
                deferred.resolve(json);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'VisiteListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'VisiteListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ToDoListeService', ToDoListeService);

  /** @ngInject */
  function ToDoListeService(globalService, ToDoListeResources, $q) {
    var ctrl = this;

    ctrl.getList = getList;

    function getList(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.negoId) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "negoId" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'complete';

        ToDoListeResources
          .getTasks(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  var retour = {
                    status: 'OK',
                    list: []
                  };

                  angular.forEach(json.list, function (stat) {
                    retour.list.push(stat);
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ToDoListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ToDoListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ToDoListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('TableauBordService', TableauBordService);

  /** @ngInject */
  function TableauBordService(globalService, TableauBordResources, $q) {
    var ctrl = this;

    ctrl.getList = getList;

    function getList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      TableauBordResources
        .getStatistiques(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              var retour = {
                status: 'OK',
                donnee: json.list
              };
              deferred.resolve(retour);
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'TableauBordListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'TableauBordListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('StatistiquesService', StatistiquesService);

  /** @ngInject */
  function StatistiquesService(globalService, StatistiquesResources, $q) {
    var ctrl = this;

    ctrl.getList = getList;

    function getList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      StatistiquesResources
        .getStatistiques(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list) && json.list.length) {
                var retour = {
                  status: 'OK',
                  list: []
                };

                angular.forEach(json.list, function (stat) {
                  retour.list.push(stat);
                });

                deferred.resolve(retour);
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'StatistiqueNegoListe => Aucun Resultat.'
              })
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'StatistiqueNegoListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'StatistiqueNegoListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('StatistiqueMensuelService', StatistiqueMensuelService);

  /** @ngInject */
  function StatistiqueMensuelService(globalService, StatistiqueMensuelResources, $q) {
    var ctrl = this;

    ctrl.getList = getList;

    function getList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      StatistiqueMensuelResources
        .getStatistiques(
          params,

          function (json) {
            if (angular.isDefined(json.retour)) {
              var retour = {
                status: 'OK',
                chemin: json.retour.excel
              };
              deferred.resolve(retour);
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ClasseurServlet => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ClasseurServlet => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ReportService', ReportService);

  /** @ngInject */
  function ReportService(globalService, ReportResources, $q) {
    var ctrl = this;

    ctrl.envoyer = envoyer;

    function envoyer(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.json) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "json" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ReportResources
          .envoyer(
            params,

            function (json) {
              if (json.reussi) {
                json.status = 'OK';
                deferred.resolve(json);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ReportServlet => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ReportServlet => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('RepertoireService', RepertoireService);

  /** @ngInject */
  function RepertoireService(globalService, RepertoireResources, $uibModal, Perso, Prospect, $q) {
    var ctrl = this;

    ctrl.openRepertoire = openRepertoire;
    ctrl.getPersoList = getPersoList;
    ctrl.getPerso = getPerso;
    ctrl.getProspect = getProspect;
    ctrl.getSocietesList = getSocietesList;
    ctrl.getNegoList = getNegoList;

    function openRepertoire(params) {
      var deferred = $q.defer();

      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/repertoire/modal.repertoire.html',
        controller: 'ModalRepertoireController',
        controllerAs: 'modalrepertoirectrl',
        size: 'lg',
        resolve: {
          criteres: function () {
            return {
              type: params && params.type ? params.type : null,
              isProspect: params && params.isProspect ? params.isProspect : null
            };
          }
        }
      });

      modalInstance.result.then(function (retour) {
        if (retour.status === 'OK') {
          deferred.resolve(retour);
        } else {
          deferred.reject(retour);
        }
      });

      return deferred.promise;
    }

    /**
     * Retourne la liste des personalités en fonction des critères spécifiés.
     *
     * @param params Paramètres de l'appel : type | rechercheContact | rechercheNom | (typeApplication) | (typeMethode)
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function getPersoList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      RepertoireResources.getPersoList(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list) && json.list.length) {
              var list = [];

              angular.forEach(json.list, function (perso) {
                list.push(new Perso(perso));
              });

              deferred.resolve({
                status: 'OK',
                list: list,
                nb: json.nb || json.list.length
              });
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'RepertoireListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'RepertoireListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'RepertoireListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    /**
     * Retourne la personalité en fonction de la référence renseignée.
     *
     * @param params Paramètres de l'appel : reference | (typeApplication) | (typeMethode)
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function getPerso(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      RepertoireResources.getPerso(
        params,

        function (json) {
          if (angular.isDefined(json.list) && json.list.persos) {
            if (angular.isArray(json.list.persos) && json.list.persos.length) {
              deferred.resolve({
                status: 'OK',
                perso: new Perso(json.list.persos[0])
              });
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'PersoListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'PersoListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'PersoListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    /**
     * Retourne le prospect en fonction de la référence renseignée.
     *
     * @param params Paramètres de l'appel : reference | (typeApplication) | (typeMethode)
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function getProspect(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      var search = params.search ? angular.copy(params.search) : {};
      delete params.search;
      angular.forEach(search, function (value, key) {
        params[key] = value;
      });

      RepertoireResources.getProspect(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list.prospects) && json.list.prospects.length) {
              deferred.resolve({
                status: 'OK',
                prospect: new Prospect(json.list.prospects[0])
              });
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'ProspectListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'ProspectListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'ProspectListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    /**
     * Retourne la liste des sociétés
     *
     * @param params (typeApplication) | (typeMethode)
     * @returns {deferred.promise|{then, catch, finally}|{then}}
     */
    function getSocietesList(params) {
      var deferred = $q.defer();

      params = params || {};
      params.host = globalService.getHost();
      params.service = globalService.getService();

      RepertoireResources.getSocietesList(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list) && json.list.length) {
              deferred.resolve({
                status: 'OK',
                list: json.list
              });
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'SocieteListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'SocieteListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'SocieteListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    /**
     * Retourne la liste des négociateurs visibles en fonction des critères spécifiés.
     *
     * @param params Paramètres de l'appel : societe | rechercheNom
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function getNegoList(params) {
      var deferred = $q.defer();

      params.afficher = true;

      params.host = globalService.getHost();
      params.service = globalService.getService();

      RepertoireResources.getNegoList(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list.employes) && json.list.employes.length) {
              angular.forEach(json.list.employes, function (nego) {
                nego.perso = new Perso(nego.perso);
              });
              deferred.resolve({
                status: 'OK',
                list: json.list.employes,
                nb: json.list.nbemploye || json.list.employes.length
              });
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'EmployeListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'EmployeListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'EmployeListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('ReferencesService', ReferencesService);

  /** @ngInject */
  function ReferencesService(globalService, PropertiesResources, $q) {
    var ctrl = this;

    ctrl.listeReferences = {
      Transaction: {},
      Location: {}
    };

    ctrl.listePrestataires = {
      Transaction: [],
      Location: []
    };

    ctrl.listeCriteres = {
      Transaction: {},
      Location: {}
    };

    ctrl.getReferences = getReferences;
    ctrl.getPrestataires = getPrestataires;
    ctrl.getCritereListe = getCritereListe;

    function getReferences(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.classes || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "classes" et/ou "typeApplication" manquant.'
        });
      } else {
        params.typeMethode = params.typeMethode || 'complete';
        params.host = globalService.getHost();
        params.service = globalService.getService();

        var listeClasse = params.classes.split(','),
          listeClasseARecup = [],
          retourListeFinal = {};

        angular.forEach(listeClasse, function (classe) {
          if (
            classe &&
            ctrl.listeReferences[params.typeApplication].hasOwnProperty(classe) &&
            !params.societe &&
            ctrl.listeReferences[params.typeApplication][classe].length
          ) {
            retourListeFinal[classe] = ctrl.listeReferences[params.typeApplication][classe];
          } else if (
            classe &&
            ctrl.listeReferences[params.typeApplication].hasOwnProperty(classe) &&
            params.societe &&
            ctrl.listeReferences[params.typeApplication][classe].hasOwnProperty(params.societe) &&
            ctrl.listeReferences[params.typeApplication][classe][params.societe].length
          ) {
            retourListeFinal[classe] = ctrl.listeReferences[params.typeApplication][classe][params.societe];
          } else if (classe) {
            listeClasseARecup.push(classe);
          }
        });

        if (!listeClasseARecup.length) {
          deferred.resolve({
            status: 'OK',
            list: retourListeFinal
          });
        } else {
          params.classes = listeClasseARecup.join(',');

          PropertiesResources.references(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                angular.forEach(listeClasseARecup, function (classe) {
                  if (params.societe) {
                    ctrl.listeReferences[params.typeApplication][classe] =
                      ctrl.listeReferences[params.typeApplication][classe] || {};
                    ctrl.listeReferences[params.typeApplication][classe][params.societe] = json.list[classe];
                  } else {
                    ctrl.listeReferences[params.typeApplication][classe] = json.list[classe];
                  }
                  retourListeFinal[classe] = json.list[classe];
                });
                deferred.resolve({
                  status: 'OK',
                  list: retourListeFinal
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
        }
      }

      return deferred.promise;
    }

    function getPrestataires(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        if (ctrl.listePrestataires[params.typeApplication].length) {
          deferred.resolve({
            status: 'OK',
            list: ctrl.listePrestataires[params.typeApplication]
          });
        } else {
          params.isActif = angular.isDefined(params.isActif) ? params.isActif : true;
          params.typeMethode = params.typeMethode || 'short';
          params.host = globalService.getHost();
          params.service = globalService.getService();

          PropertiesResources.prestataire(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  angular.forEach(json.list, function (presta) {
                    ctrl.listePrestataires[params.typeApplication].push(presta);
                  });
                  deferred.resolve({
                    status: 'OK',
                    list: ctrl.listePrestataires[params.typeApplication]
                  });
                } else
                  deferred.reject({
                    status: 'ZERO_RESULT',
                    message: 'PrestataireListe => Aucun Resultat.'
                  });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'PrestataireListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'PrestataireListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
        }
      }

      return deferred.promise;
    }

    function getCritereListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeBien || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "typeBien" et/ou "typeApplication" manquant.'
        });
      } else {
        if (
          ctrl.listeCriteres[params.typeApplication].hasOwnProperty(params.typeBien) &&
          ctrl.listeCriteres[params.typeApplication][params.typeBien].length
        ) {
          deferred.resolve({
            status: 'OK',
            list: ctrl.listeCriteres[params.typeApplication][params.typeBien]
          });
        } else {
          params.typeMethode = params.typeMethode || 'complete';
          params.host = globalService.getHost();
          params.service = globalService.getService();

          PropertiesResources.critere(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  json.status = 'OK';
                  ctrl.listeCriteres[params.typeApplication][params.typeBien] = json.list;
                  deferred.resolve(json);
                } else
                  deferred.reject({
                    status: 'ZERO_RESULT',
                    message: 'CritereListe => Aucun Resultat.'
                  });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'CritereListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'CritereListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
        }
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ProspectsService', ProspectsService);

  /** @ngInject */
  function ProspectsService(globalService, ProspectsResources, Prospect, $q) {
    var ctrl = this;

    ctrl.typeApplication = globalService.getTypeApplication();
    ctrl.url = globalService.baseUrl();

    ctrl.getListe = getListe;
    ctrl.editerProspect = editerProspect;
    ctrl.supprimerProspect = supprimerProspect;

    function getListe(query) {
      var deferred = $q.defer(),
        params = angular.copy(query);

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'liste';

      var search = params.search ? angular.copy(params.search) : {};
      delete params.search;
      angular.forEach(search, function (value, key) {
        params[key] = value;
      });

      ProspectsResources
        .liste(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.prospects) && json.list.prospects.length) {
                var retour = {
                  status: 'OK',
                  nb: json.list.nbprospect,
                  prospects: []
                };

                angular.forEach(json.list.prospects, function (prospect) {
                  retour.prospects.push(new Prospect(prospect))
                });
                deferred.resolve(retour);
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'ProspectListe => Aucun Resultat.'
              })
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function editerProspect(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      ProspectsResources
        .edit(
          params,

          function (json) {
            if (angular.isDefined(json.referenceInterne)) {
              deferred.resolve({
                prospect: new Prospect(json),
                status: 'OK'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function supprimerProspect(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ProspectsResources
        .edit(
          params,

          function (json) {
            var retour = {};
            if (angular.isDefined(json.id) && angular.isDefined(json.referenceInterne)) {
              retour.status = 'OK';
              retour.prospect = new Prospect(json);
              deferred.resolve(retour);
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ProspectListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('PropertiesService', PropertiesService);

  /** @ngInject */
  function PropertiesService(globalService, PropertiesResources, Bien, Critere, $q) {
    var ctrl = this;

    ctrl.getPropertiesList = getPropertiesList;

    ctrl.getZoneAlur = getZoneAlur;

    ctrl.getSocietes = getSocietes;
    ctrl.getTypesBiens = getTypesBiens;

    ctrl.ajouterBien = ajouterBien;
    ctrl.saveBien = saveBien;
    ctrl.supprimerBien = supprimerBien;

    ctrl.getReferences = getReferences;

    ctrl.getCritereListe = getCritereListe;

    ctrl.getParutionListe = getParutionListe;
    ctrl.addParutionListe = addParutionListe;
    ctrl.supprParutionListe = supprParutionListe;

    ctrl.editPhoto = editPhoto;
    ctrl.gedListe = gedListe;
    ctrl.removeGed = removeGed;

    function getPropertiesList(query) {
      var deferred = $q.defer();

      if (angular.isUndefined(query) || !query.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        var params = angular.copy(query);
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'liste';

        var search = params.search ? angular.copy(params.search) : {};
        delete params.search;
        angular.forEach(search, function (value, key) {
          params[key] = value;
        });

        PropertiesResources
          .list(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list.biens) && json.list.biens.length) {
                  var retour = {
                    status: 'OK',
                    list: {
                      nblot: json.list.nblot,
                      biens: []
                    }
                  };

                  angular.forEach(json.list.biens, function (bien) {
                    retour.list.biens.push(new Bien(bien));
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'LotListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'LotListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LotListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getZoneAlur(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.cp || !params.ville || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "cp" et/ou "ville" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        PropertiesResources
          .zoneAlur(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  deferred.resolve({
                    status: 'OK',
                    list: json.list
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ZoneAlur => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ZoneAlur => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ZoneAlur => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getSocietes(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .societes(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  deferred.resolve({
                    status: 'OK',
                    list: json.list
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'SocieteListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'SocieteListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'SocieteListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getTypesBiens(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.afficher = true;
        params.classes = 'RefTypeBien';
        params.typeMethode = 'complete';

        PropertiesResources
          .references(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list.RefTypeBien) && json.list.RefTypeBien.length) {
                  deferred.resolve({
                    status: 'OK',
                    list: json.list.RefTypeBien
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ReferenceListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function ajouterBien(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.newlotClass || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "newlotClass" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        PropertiesResources
          .ajouter(
            params,

            function (json) {
              if (angular.isDefined(json.id) && angular.isDefined(json.referenceInterne)) {
                deferred.resolve({
                  status: 'OK',
                  bien: new Bien(json)
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function saveBien(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || (!params.xmllot && !params.copieLot)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "xmllot" et/ou "copieLot" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = 'complete';

        PropertiesResources
          .save(
            params,

            function (json) {
              if (angular.isDefined(json.id) && angular.isDefined(json.referenceInterne)) {
                deferred.resolve({
                  status: 'OK',
                  bien: new Bien(json)
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function supprimerBien(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.deleteRef) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "deleteRef" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        PropertiesResources
          .save(
            params,

            function (json) {
              if (angular.isDefined(json.id) && angular.isDefined(json.referenceInterne)) {
                deferred.resolve({
                  status: 'OK',
                  bien: new Bien(json)
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LotSave => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getReferences(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.classes || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "classes" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.afficher = true;
        params.typeMethode = params.typeMethode || 'complete';

        PropertiesResources
          .references(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                json.status = 'OK';
                deferred.resolve(json);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ReferenceListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getCritereListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeBien || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "typeBien" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'complete';

        PropertiesResources
          .critere(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  var retour = {
                    status: 'OK',
                    list: []
                  };

                  angular.forEach(json.list, function (critere) {
                    retour.list.push(new Critere(critere));
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'CritereListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'CritereListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'CritereListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getParutionListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.lotId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "lotId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .parution(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list.parutions) && json.list.parutions.length) {
                  deferred.resolve({
                    status: 'OK',
                    list: json.list.parutions
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ParutionListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function addParutionListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.lotId || !params.addPrestaId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "lotId" et/ou "addPrestaId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .parution(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  json.status = 'OK';
                  deferred.resolve(json);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ParutionListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function supprParutionListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.lotId || !params.supprPrestaId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "lotId" et/ou "supprPrestaId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .parution(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  json.status = 'OK';
                  deferred.resolve(json);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ParutionListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ParutionListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function editPhoto(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.multimediaId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "multimediaId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .editPhoto(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  json.status = 'OK';
                  deferred.resolve(json);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'MultimediaServlet => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'MultimediaServlet => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'MultimediaServlet => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function gedListe(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.reference || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "reference" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .gedListe(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  json.status = 'OK';
                  deferred.resolve(json);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'GedListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'GedListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'GedListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function removeGed(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.reference || !params.gedId || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "reference" et/ou "gedId" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.action = 'remove';
        params.typeMethode = params.typeMethode || 'short';

        PropertiesResources
          .gedListe(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length > -1) {
                  json.status = 'OK';
                  deferred.resolve(json);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'GedListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'GedListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'GedListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('ParutionsService', ParutionsServiceController);

  /** @ngInject */
  function ParutionsServiceController(globalService, ParutionsResources, Bien, $q) {
    var ctrl = this;

    ctrl.getPrestataires = getPrestataires;

    ctrl.getParutions = getParutions;
    ctrl.setParution = setParution;
    ctrl.checkParutions = checkParutions;

    function getPrestataires(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.isActif = angular.isDefined(params.isActif) ? params.isActif : true;
        params.typeMethode = params.typeMethode || 'short';

        ParutionsResources.prestataire(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list) && json.list.length) {
                deferred.resolve({
                  status: 'OK',
                  prestataires: json.list
                });
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'PrestataireListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'PrestataireListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'PrestataireListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function getParutions(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'liste';

        ParutionsResources.parution(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.parutions) && json.list.parutions.length) {
                json.status = 'OK';
                angular.forEach(json.list.parutions, function (parution) {
                  parution.lot = new Bien(parution.lot);
                });
                deferred.resolve(json);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ParutionListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ParutionListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ParutionListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function setParution(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || (!params.lotId && !params.action) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) ["lotId"|"action"] et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'liste';

        ParutionsResources.parution(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.parutions) && json.list.parutions.length) {
                json.status = 'OK';
                angular.forEach(json.list.parutions, function (parution) {
                  parution.lot = new Bien(parution.lot);
                });
                deferred.resolve(json);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'ParutionListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'ParutionListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'ParutionListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function checkParutions(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.type || !params.nom) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "type" et/ou "nom" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ParutionsResources.checkParutions(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list) && json.list.length) {
                deferred.resolve(json);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'EtatICSBOX => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'EtatICSBOX => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'EtatICSBOX => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('PanneauxService', PanneauxServiceController);

  /** @ngInject */
  function PanneauxServiceController(globalService, PropertiesResources, EvenementsResources, Bien, $q) {
    var ctrl = this;

    ctrl.getPanneaux = getPanneaux;
    ctrl.setPanneau = setPanneau;

    function getPanneaux(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        PropertiesResources.list(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.biens) && json.list.biens.length) {
                var retour = {
                  status: 'OK',
                  list: {
                    nbpanneaux: json.list.nblot || json.list.length,
                    panneaux: []
                  }
                };

                angular.forEach(json.list.biens, function (bien) {
                  if (bien && bien.id) {
                    retour.list.panneaux.push(new Bien(bien));
                  }
                });

                deferred.resolve(retour);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'LotListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'LotListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'LotListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function setPanneau(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.xml || !params.lotid || !params.typeIds || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "xml" et/ou "lotid" et/ou "typeIds" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'short';

        EvenementsResources.setEvenement(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list) && json.list.length) {
                json.status = 'OK';
                deferred.resolve(json);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'EvenementListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: 'BAD_QUERY',
                message: 'EvenementListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('PanierService', PanierService);

  /** @ngInject */
  function PanierService(globalService, PanierResources, Bien, $q) {
    var ctrl = this;

    ctrl.getPanier = getPanier;
    ctrl.setPanier = setPanier;
    ctrl.evenement = evenement;

    function getPanier(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.prospect || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMTER',
          message: 'Parametre(s) "prospect" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'liste';

        PanierResources.panier(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (
                angular.isArray(json.list.paniers) &&
                json.list.paniers.length &&
                angular.isArray(json.list.paniers[0].lotspanier) &&
                json.list.paniers[0].lotspanier.length
              ) {
                var retour = {
                  status: 'OK',
                  nb: json.list.paniers[0].lotspanier.length,
                  list: []
                };

                angular.forEach(json.list.paniers[0].lotspanier, function (bien) {
                  if (bien && bien.lot && bien.lot.id) {
                    bien.lot = new Bien(bien.lot);
                    retour.list.push(bien);
                  }
                });

                deferred.resolve(retour);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'PanierListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function setPanier(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.prospect || !params.lot || !params.action || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMTER',
          message: 'Parametre(s) "prospect" et/ou "lot" et/ou "action" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.typeMethode = params.typeMethode || 'liste';

        PanierResources.panier(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (
                angular.isArray(json.list.paniers) &&
                json.list.paniers.length &&
                angular.isArray(json.list.paniers[0].lotspanier) &&
                json.list.paniers[0].lotspanier.length
              ) {
                var retour = {
                  status: 'OK',
                  nb: json.list.paniers[0].lotspanier.length,
                  list: []
                };

                angular.forEach(json.list.paniers[0].lotspanier, function (bien) {
                  if (bien && bien.lot && bien.lot.id) {
                    bien.lot = new Bien(bien.lot);
                    retour.list.push(bien);
                  }
                });
                deferred.resolve(retour);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'PanierListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    function evenement(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.prospect || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMTER',
          message: 'Parametre(s) "prospect" et/ou "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.action = 'evenement';
        params.typeMethode = params.typeMethode || 'liste';

        PanierResources.panier(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (
                angular.isArray(json.list.paniers) &&
                json.list.paniers.length &&
                angular.isArray(json.list.paniers[0].lotspanier) &&
                json.list.paniers[0].lotspanier.length
              ) {
                var retour = {
                  status: 'OK',
                  nb: json.list.paniers[0].lotspanier.length,
                  list: []
                };

                angular.forEach(json.list.paniers[0].lotspanier, function (bien) {
                  if (bien && bien.lot && bien.lot.id) {
                    bien.lot = new Bien(bien.lot);
                    retour.list.push(bien);
                  }
                });
                deferred.resolve(retour);
              } else
                deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'PanierListe => Aucun Resultat.'
                });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'PanierListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('MailService', MailService);

  /** @ngInject */
  function MailService(globalService, MailResources, $q) {
    var ctrl = this;

    ctrl.typeApplication = globalService.getTypeApplication();
    ctrl.url = globalService.baseUrl() + '/';

    ctrl.envoyer = envoyer;
    ctrl.getModel = getModel;
    ctrl.getModelProprietaire = getModelProprietaire;

    function envoyer(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.de || !params.a || !params.objet) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "de" et/ou "a" et/ou "objet" manquant.'
        });
      } else {
        params.url = params.url ? params.url : ctrl.url;
        params.typeRetour = 'json';
        var message = angular.toJson(params);

        MailResources
          .mailXpress({
              xml: message,
              host: globalService.getHost(),
              service: globalService.getService()
            },

            function (json) {
              if (angular.isDefined(json.status) && json.status === 'Envoyé') {
                deferred.resolve({
                  status: 'OK'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'EmailXpress => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'EmailXpress => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getModel(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      MailResources
        .mailXpress(
          params,

          function (json) {
            if (angular.isDefined(json.corps)) {
              delete params.host;
              delete params.service;
              deferred.resolve(Object.assign({
                status: 'OK'
              }, json, params));
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'EmailXpress => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'EmailXpress => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      return deferred.promise;
    }

    function getModelProprietaire(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.proprietaire) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "proprietaire" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        MailResources
          .mailXpress(
            params,

            function (json) {
              if (angular.isDefined(json.corps)) {
                var retour = json;
                retour.status = 'OK';
                deferred.resolve(retour);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'EmailXpress => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'EmailXpress => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }
      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('LoginService', LoginService);

  /** @ngInject */
  function LoginService(CONSTANTS, globalService, LoginResources, $rootScope, Idle, $q, $state, $log) {
    var ctrl = this;

    ctrl.login = login;
    ctrl.logout = logout;
    ctrl.checkKerberos = checkKerberos;

    function login(params, deferred) {
      deferred = angular.isDefined(deferred) && angular.isFunction(deferred.resolve) ? deferred : $q.defer();

      if (CONSTANTS.configClient.citya && (angular.isUndefined(params.kerberos) || params.kerberos)) {
        checkKerberos()
          .then(function (retour) {
            if (retour.kerberos) {
              deferred.resolve({
                status: 'OK',
                employe: retour.employe
              });
            } else {
              params.kerberos = false;
              login(params, deferred);
            }
          })
          .catch(function () {
            params.kerberos = false;
            login(params, deferred);
          });
      } else if (!params.hasOwnProperty('initiales') || params.initiales === '') {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Vous devez renseigner votre identifiant.'
        });
      } else {
        LoginResources.login({
            login: {
              initiales: params.initiales,
              mdp: angular.isDefined(params.mdp) ? params.mdp : '',
              location: params.location ? params.location : false
            },
            host: globalService.getHost(),
            service: globalService.getService()
          },

          function (json) {
            if (angular.isDefined(json.id)) {
              deferred.resolve({
                status: 'OK',
                employe: json
              });
            } else {
              deferred.reject({
                status: 'BAD_LOGIN',
                message: 'Login ou mot de passe incorrect.'
              });
            }
          },

          function (error) {
            deferred.reject(error);
          }
        );
      }
      return deferred.promise;
    }

    function logout(params) {
      LoginResources.login({
          logout: '1',
          host: globalService.getHost(),
          service: globalService.getService()
        },

        function () {
          globalService.invalidateStorageToken();
          globalService.clearAllStorage();
          $state.go('login', params);
        },

        function (error) {
          if (error.status) {
            if (error.status === 'ZERO_RESULT') $log.warn(error.message);
            else if (error.status !== 'SESSION_EXPIRED')
              $log.error(error.status + (error.message ? ' - ' + error.message : ''));
          } else $log.error(error.status);
          $state.go('login', params);
        }
      );
    }

    function checkKerberos(deferred, stop) {
      stop = angular.isDefined(stop) ? stop : false;
      deferred = angular.isDefined(deferred) && angular.isFunction(deferred.resolve) ? deferred : $q.defer();

      LoginResources.kerberos({
          host: globalService.getHost(),
          service: globalService.getService()
        },

        function (json) {
          if (angular.isDefined(json.id)) {
            globalService.clearStorage();
            deferred.resolve({
              status: 'OK',
              employe: json
            });
          } else if (json.status === 'NEXISTE_PAS_EXCEPTION' && !stop) {
            $log.info('Authentification Kerberos (' + ctrl.typeApplication + ') : ECHEC');
            globalService.setTypeApplication(
              globalService.getTypeApplication() === 'Transaction' ? 'Location' : 'Transaction', false, true
            );
            checkKerberos(deferred, true);
          } else if (stop) {
            $log.info('Authentification Kerberos (' + ctrl.typeApplication + ') : ECHEC');
            globalService.setTypeApplication(
              globalService.getTypeApplication() === 'Transaction' ? 'Location' : 'Transaction', false, true
            );
            deferred.reject({
              status: json.status,
              message: json.message
            });
          }
        },

        function (error) {
          if (error.status === 'NEXISTE_PAS_EXCEPTION' && !stop) {
            $log.info('Authentification Kerberos (' + ctrl.typeApplication + ') : ECHEC');
            globalService.setTypeApplication(
              globalService.getTypeApplication() === 'Transaction' ? 'Location' : 'Transaction', false, true
            );
            checkKerberos(deferred, true);
          } else if (stop) {
            $log.info('Authentification Kerberos (' + ctrl.typeApplication + ') : ECHEC');
            globalService.setTypeApplication(
              globalService.getTypeApplication() === 'Transaction' ? 'Location' : 'Transaction', false, true
            );
            deferred.reject({
              status: error.status,
              message: error.message
            });
          }
        }
      );

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('LocalisationService', LocalisationService);

  /** @ngInject */
  function LocalisationService(CONSTANTS, globalService, LocalisationResources, $q) {
    var ctrl = this;

    ctrl.getVillesByQuery = getVillesByQuery;
    ctrl.geocode = geocode;

    /**
     * @description Retourne une liste de villes/codes postaux en fonction de la recherche
     *
     * @param params {object} recherche|numero|pas|typeMethode|typeApplication
     *
     * @return {object} status|[list|message]
     */
    function getVillesByQuery(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.numero = angular.isDefined(params.numero) ? params.numero : 0;
        params.pas = params.pas || 10;
        params.typeMethode = params.typeMethode || 'short';

        if (CONSTANTS.configClient.citya) {
          params.cloud = true;
        }

        LocalisationResources
          .villes(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  deferred.resolve({
                    status: 'OK',
                    list: json.list
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'VilleListe => Aucun Resultat.'
                })
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'VilleListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'VilleListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    /**
     * @description Retourne les coordonnées GPS résultant de l'adresse envoyée
     *
     * @param params {object} rue|complement|cp|ville|pays
     *
     * @return {object} status|[latitude|longitude|message]
     */
    function geocode(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      LocalisationResources
        .geocode(
          params,

          function (json) {
            if (angular.isDefined(json.latitude) && angular.isDefined(json.longitude)) {
              deferred.resolve({
                status: 'OK',
                latitude: json.latitude,
                longitude: json.longitude
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: 'BAD_QUERY',
                message: 'Geocode => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            deferred.reject(error);
          }
        );

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('InstallationService', InstallationService);

  /** @ngInject */
  function InstallationService(globalService, InstallationResources, $q) {
    var ctrl = this;

    ctrl.installation = installation;

    function installation(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.cleInstallation) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "Cle Installation" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        InstallationResources
          .installation(
            params,

            function (json) {
              if (json.cleAgence) {
                json.status = 'OK';
                deferred.resolve(json);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.erreur ? json.erreur : 'InstallationServlet => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'InstallationServlet => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : jdecorte@ics.fr
 * @since : 2018-01-12
 * @version : 0.0.2
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('InfoService', InfoService);

  /** @ngInject */
  function InfoService(globalService, InfoResources, $q) {
    var ctrl = this;

    ctrl.info = info;

    function info(params) {
      var deferred = $q.defer();
      params.host = globalService.getHost();
      params.service = globalService.getService();
      InfoResources
          .info(
            params,
            function (json) {
              if (json.version) {
                json.status = 'OK';
                deferred.resolve(json);
              }else deferred.reject(json);
            },
            function (error) {
              deferred.reject(error);
            }
          );
      return deferred.promise;
    }
  }
})();

/**
 * @desc : Service de gestion des impressions
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ImpressionService', ImpressionService);

  /** @ngInject */
  function ImpressionService(globalService, ImpressionResources, $uibModal, $window, $q) {
    var ctrl = this;

    ctrl.openImpression = openImpression;
    ctrl.getModels = getModels;
    ctrl.setModels = setModels;
    ctrl.downloadFile = downloadFile;

    function openImpression(params) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/modal/impression/modal.impression.html',
        controller: 'ModalImpressionController',
        controllerAs: 'modalimpressionctrl',
        resolve: {
          impression: function () {
            return params;
          }
        }
      });

      modalInstance.result.then(function () {
        ctrl.open = true;
      });
    }

    /**
     * Retourne l'arborescence de présentation des modèles d'impression disponibles
     *
     * @param {object} params modele | [typeMethode]
     * @param {string} type
     * @param {string} transac
     * @param {object} options
     *
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function getModels(params, type, transac, options) {
      var deferred = $q.defer();

      if (angular.isUndefined(params)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "getModeles" manquant.'
        });
      } else if (angular.isUndefined(type) || !angular.isString(type)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "type" manquant.'
        });
      } else if (angular.isUndefined(transac) || !angular.isString(transac)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "transac" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        if (type === 'PDF') options.toPdf = true;

        ImpressionResources['get' + type + transac](
          params,

          function (json) {
            if (angular.isDefined(json.fichiers)) {
              if (angular.isArray(json.fichiers) && json.fichiers.length) {
                deferred.resolve({
                  status: 'OK',
                  fichiers: json.fichiers,
                  params: options
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'Impression => Aucun Resultat.'
              })
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    /**
     * Retourne le lien de téléchargement du fichier à éditer ou créé
     *
     * @param {object} params edition | typeApplication
     *
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function setModels(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametres manquant.'
        });
      } else if (!params.hasOwnProperty('typeApplication')) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else if (!params.hasOwnProperty('edition')) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "edition" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();
        params.modify = true;

        ImpressionResources['getDOC' + params.typeApplication](
          params,

          function (json) {
            if (angular.isDefined(json.fileName) && angular.isDefined(json.path)) {
              deferred.resolve({
                status: 'OK',
                link: getDownloadLink(
                  params.typeApplication, [{
                    label: 'edition',
                    value: 'edition'
                  }, {
                    label: 'filename',
                    value: json.fileName
                  }, {
                    label: 'path',
                    value: json.path
                  }]
                )
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    /**
     * Retourne le lien de téléchargement du fichier généré
     *
     * @param {object} params [lotsid] | [prospectsid] | [bonVisiteIds] | [eventsid] | [compromisid] | [persoIds]
     *                        | [prospectionIds] | [proprioIds] | [eventType] | [dateDebut] | [dateFin] | [depuis]
     *                        | [parutionLibre] | [destinataire] | [expediteur] | [body] | [objet] | [email]
     *                        | [edition] | [toPdf] | [typeMethode] | typeApplication
     * @param {string} type
     *
     * @returns {deferred.promise|{then}|{then, catch, finally}}
     */
    function downloadFile(params, type) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.hasOwnProperty('typeApplication')) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else if (angular.isUndefined(type) || !angular.isString(type)) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "type" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ImpressionResources['get' + type + params.typeApplication](
          params,

          function (json) {
            if (angular.isDefined(json.fileName) && angular.isDefined(json.path)) {
              deferred.resolve({
                status: 'OK',
                link: getDownloadLink(
                  params.typeApplication, [{
                    label: 'edition',
                    value: 'edition'
                  }, {
                    label: 'filename',
                    value: json.fileName
                  }, {
                    label: 'path',
                    value: json.path
                  }]
                )
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'Impression => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );
      }

      return deferred.promise;
    }

    /**
     * Retourne l'URL de téléchargement direct du document/PDF souhaité.
     *
     * @param transac Type de transacion : Location | (Transacion)
     * @param params Paramètre de l'appel : (edition) | filename | path
     * @returns {string} Url de téléchargement direct
     */
    function getDownloadLink(transac, params) {
      var url = globalService.getHost() + '/' + globalService.getService() + '/Download';

      if (transac === 'Location') {
        url += 'Location';
      }

      angular.forEach(params, function (param, index) {
        var query = index === 0 ? '?' : '&';

        query += param.label + '=' + $window.encodeURIComponent(param.value);

        if (query.length > 1) {
          url += query;
        }
      });

      return url;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('globalService', globalService);

  /** @ngInject */
  function globalService(CONSTANTS, localStorageService, $state, Perso, $rootScope, $log, $timeout, moment) {
    var ctrl = this;

    ctrl.getHost = getHost;
    ctrl.getService = getService;
    ctrl.baseUrl = baseUrl;
    ctrl.baseImgSrc = baseImgSrc;

    ctrl.withCredentials = withCredentials;

    ctrl.getStorageToken = getStorageToken;
    ctrl.invalidateStorageToken = invalidateStorageToken;
    ctrl.cleanExpiredSTokens = cleanExpiredSTokens;

    ctrl.isLogged = isLogged;

    ctrl.getEmploye = getEmploye;
    ctrl.setEmploye = setEmploye;

    ctrl.getTypeApplication = getTypeApplication;
    ctrl.setTypeApplication = setTypeApplication;

    ctrl.getVersion = getVersion;
    ctrl.setVersion = setVersion;

    ctrl.getStorageItem = getStorageItem;
    ctrl.setStorageItem = setStorageItem;
    ctrl.removeStorageItem = removeStorageItem;
    ctrl.clearStorage = clearStorage;
    ctrl.clearAllStorage = clearAllStorage;

    function isMultiServer() {
      return CONSTANTS.configClient.Transaction.server !== CONSTANTS.configClient.Location.server ||
        CONSTANTS.configClient.Transaction.context !== CONSTANTS.configClient.Location.context
    }

    function getHost(application) {
      application = application ? application : getTypeApplication();
      return CONSTANTS.configClient[application].server;
    }

    function getService(application) {
      application = application ? application : getTypeApplication();
      return CONSTANTS.configClient[application].context;
    }

    function baseUrl(application) {
      application = application ? application : getTypeApplication();
      return getHost(application) + '/' + getService(application) + '/';
    }

    function baseImgSrc(application) {
      var agencePath = '';
      application = application ? application : getTypeApplication();
      var nego = getEmploye(application);
      if (!nego.societe.agence.dossierRealPath) {
        agencePath = '';
      } else {
        agencePath = nego.societe.agence.dossierRealPath;
      }
      return CONSTANTS.configClient[application].images || baseUrl() + agencePath + 'multimedia/';
    }

    function withCredentials(application) {
      application = application ? application : getTypeApplication();
      var cred = false;
      var nego = getEmploye(application);
      if (!nego.societe.agence.dossierRealPath) {
        cred = false;
      } else {
        cred = true;
      }
      return cred;
    }

    function generateStorageToken() {
      return moment().add(24, 'hours').valueOf();
    }

    function getStorageToken() {
      if (angular.isDefined($rootScope.sToken)) {
        return $rootScope.sToken;
      } else {
        $rootScope.sToken = generateStorageToken();
        return $rootScope.sToken;
      }
    }

    function invalidateStorageToken() {
      localStorageService.remove($rootScope.sToken + '-TYPE-APPLICATION');
      delete $rootScope.sToken;
    }

    function cleanExpiredSTokens() {
      var lsKeys = localStorageService.keys();
      var token = '';
      for (var i = 0; i < lsKeys.length; i++) {
        if (lsKeys[i].indexOf('-TYPE-APPLICATION') !== -1) {
          token = lsKeys[i].replace('-TYPE-APPLICATION', '');
          if (moment(token).isValid() && moment(token).isBefore(moment())) {
            localStorageService.remove(lsKeys[i]);
          }
        }
      }
    }

    function isLogged(application) {
      application = application ? application : getTypeApplication();
      return !!(getStorageItem('LOGIN-TOKEN') && (isMultiServer() ? getEmploye(application) : getEmploye()));
    }

    function getEmploye(application) {
      application = application ? application : getTypeApplication();
      var employe = getStorageItem('EMPLOYE', application);
      if (employe) {
        employe.perso = employe.perso.isModel ? employe.perso : new Perso(employe.perso);
      }
      return employe;
    }

    function setEmploye(employe, application) {
      application = application ? application : getTypeApplication();
      setStorageItem('EMPLOYE', employe);
      setStorageItem('LOGIN-TOKEN', !!employe);
    }

    function getStorageItem(key, application) {
      if (key) {
        application = application ? application : getTypeApplication();
        switch (key) {
          case 'VERSION':
            return localStorageService.get(key);
          case 'EMPLOYE':
          case 'LOGIN-TOKEN':
            if (isMultiServer()) {
              key += '-' + application;
            }
            return localStorageService.get(key);
          default:
            return localStorageService.get(key + '-' + application);
        }
      } else return null;
    }

    function setStorageItem(key, value, application) {
      if (key) {
        application = application ? application : getTypeApplication();
        switch (key) {
          case 'VERSION':
            localStorageService.set(key, value);
            break;
          case 'EMPLOYE':
          case 'LOGIN-TOKEN':
            if (isMultiServer()) {
              key += '-' + application;
            }
            localStorageService.set(key, value);
            break;
          default:
            localStorageService.set(key + '-' + application, value);
            break;
        }
      }
    }

    function removeStorageItem(key, value, application) {
      if (key) {
        application = application ? application : getTypeApplication();
        switch (key) {
          case 'EMPLOYE':
          case 'LOGIN-TOKEN':
            if (isMultiServer()) {
              key += '-' + application;
            }
            localStorageService.remove(key);
            break;
          case 'VERSION':
            localStorageService.remove(key);
            break;
          default:
            localStorageService.remove(key + '-' + application);
            break;
        }
      }
    }

    function getVersion() {
      return getStorageItem('VERSION') || '1.0';
    }

    function setVersion(value) {
      value = value || '1.0';
      $log.info('-------=[ Version Application : ' + value + ' ]=-------');
      setStorageItem('VERSION', value);
      $rootScope.$broadcast('version', {
        version: value
      });
    }

    function getTypeApplication() {
      var sToken = getStorageToken();
      return localStorageService.get(sToken + '-TYPE-APPLCIATION') || 'Transaction';
    }

    function setTypeApplication(value, reload, clear) {
      value = value || 'Transaction';
      var sToken = getStorageToken();
      var typeApplication = getTypeApplication();

      if (typeApplication !== value) {
        $log.info('-------=[ Switch Type Application ]=-------');
        $log.info('----- [' + typeApplication + ']   =>   [' + value + '] -----');
        $log.info('-------------------------------------------');

        if (angular.isDefined(clear) && clear) {
          clearStorage();
        }

        localStorageService.set(sToken + '-TYPE-APPLCIATION', value);
        $rootScope.favicon = value === 'Transaction' ? 'transac.ico' : 'gesloc.ico';
        $rootScope.$broadcast('typeApplication', {
          transac: value
        });

        if (angular.isDefined(reload) && reload) {
          $rootScope.$broadcast('reload', {
            fromType: typeApplication
          });
        }
      }
    }

    function clearStorage() {
      var lsKeys = localStorageService.keys();

      for (var i = 0; i < lsKeys.length; i++) {
        localStorageService.remove(lsKeys[i]);
      }

      $rootScope.$broadcast('clearSelection');
      $rootScope.$broadcast('removePanier');
    }

    function clearAllStorage() {
      localStorageService.clearAll();
      $rootScope.$broadcast('clearSelection');
      $rootScope.$broadcast('removePanier');
    }
  }
})();

/**
 * @desc : Service de geolocalisation par adresse
 *
 * @author : vfillon@ics.fr
 * @since : 2018-04-04
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('GeocoderService', GeocoderService);

  /** @ngInject */
  function GeocoderService(globalService, $q, $timeout) {
    var ctrl = this;

    ctrl.locations = globalService.getStorageItem('GEOLOCATIONS') ?
      angular.fromJson(globalService.getStorageItem('GEOLOCATIONS')) : {};

    ctrl.queue = [];

    // Amount of time (in milliseconds) to pause between each trip to the
    // Geocoding API, which places limits on frequency.
    ctrl.QUERY_PAUSE = 250;

    /**
     * executeNext() - execute the next function in the queue.
     *                  If a result is returned, fulfill the promise.
     *                  If we get an error, reject the promise (with message).
     *                  If we receive OVER_QUERY_LIMIT, increase interval and try again.
     */

    ctrl.geocode = geocodeAddress;

    function executeNext() {
      var task = ctrl.queue[0],
        geocoder = new google.maps.Geocoder();

      geocoder.geocode({
        address: task.address
      }, function (result, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          var parsedResult = {
            status: status,
            lat: result[0].geometry.location.lat(),
            lng: result[0].geometry.location.lng(),
            formattedAddress: result[0].formatted_address
          };
          ctrl.locations[task.address] = parsedResult;

          globalService.setStorageItem('GEOLOCATIONS', angular.toJson(ctrl.locations));

          ctrl.queue.shift();
          task.d.resolve(parsedResult);
        } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
          ctrl.queue.shift();
          task.d.reject({
            status: status,
            type: 'zero',
            message: 'Zero results for geocoding address ' + task.address
          });
        } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
          if (task.executedAfterPause) {
            ctrl.queue.shift();
            task.d.reject({
              status: status,
              type: 'busy',
              message: 'Geocoding server is busy can not process address ' + task.address
            });
          }
        } else if (status === google.maps.GeocoderStatus.REQUEST_DENIED) {
          ctrl.queue.shift();
          task.d.reject({
            status: status,
            type: 'denied',
            message: 'Request denied for geocoding address ' + task.address
          });
        } else {
          ctrl.queue.shift();
          task.d.reject({
            status: status,
            type: 'invalid',
            message: 'Invalid request for geocoding: status=' + status + ', address=' + task.address
          });
        }

        if (ctrl.queue.length) {
          if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
            var nextTask = ctrl.queue[0];
            nextTask.executedAfterPause = true;
            $timeout(executeNext, ctrl.QUERY_PAUSE);
          } else {
            $timeout(executeNext, 0);
          }
        }
      });
    }

    /**
     * @description Géocodage de l'adresse du lot. Retourne les coordonnées GPS correspondant à l'adresse
     *
     * @param {string} address
     * @returns {object} promise avec les coordonnées lat/lng correspondant à l'adresse
     */
    function geocodeAddress(address) {
      var d = $q.defer();

      if (ctrl.locations.hasOwnProperty(address) && angular.isDefined(ctrl.locations[address])) {
        d.resolve(ctrl.locations[address]);
      } else {
        ctrl.queue.push({
          address: address,
          d: d
        });

        if (ctrl.queue.length === 1) {
          executeNext();
        }
      }

      return d.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('FavorisService', FavorisService);

  /** @ngInject */
  function FavorisService(globalService, FavorisResources, Bien, $q) {
    var ctrl = this;

    ctrl.getList = getList;
    ctrl.ajouter = ajouter;
    ctrl.supprimer = supprimer;

    function getList(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        FavorisResources
          .favoris(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  var retour = {
                    status: 'OK',
                    list: json.list,
                    nb: json.list.length
                  };

                  angular.forEach(retour.list, function (bien) {
                    bien.lot = new Bien(bien.lot);
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'FavorisListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'FavorisListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'FavorisListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function ajouter(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        FavorisResources
          .favoris(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  var retour = {
                    status: 'OK',
                    list: json.list,
                    nb: json.list.length
                  };

                  angular.forEach(retour.list, function (bien) {
                    bien.lot = new Bien(bien.lot);
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'FavorisListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: 'BAD_QUERY',
                  message: 'FavorisListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function supprimer(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.typeApplication) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "typeApplication" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        FavorisResources
          .favoris(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  var retour = {
                    status: 'OK',
                    list: json.list,
                    nb: json.list.length
                  };

                  angular.forEach(retour.list, function (bien) {
                    bien.lot = new Bien(bien.lot);
                  });

                  deferred.resolve(retour);
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'FavorisListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: 'BAD_QUERY',
                  message: 'FavorisListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('EvenementsService', EvenementsService);

  /** @ngInject */
  function EvenementsService(globalService, EvenementsResources, Evenement, $q) {
    var ctrl = this;

    ctrl.getList = getList;
    ctrl.ajouter = ajouter;
    ctrl.supprimer = supprimer;

    function getList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      EvenementsResources.getEvenement(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list) && json.list.length) {
              var retour = {
                status: 'OK',
                list: []
              };

              angular.forEach(json.list, function (evenement) {
                retour.list.push(new Evenement(evenement));
              });

              deferred.resolve(retour);
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'EvenementListe => Aucun Resultat.',
                list: []
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function ajouter(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      EvenementsResources.setEvenement(
        params,

        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list) && json.list.length) {
              var retour = {
                status: 'OK',
                list: []
              };

              angular.forEach(json.list, function (evenement) {
                retour.list.push(new Evenement(evenement));
              });

              deferred.resolve(retour);
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'EvenementListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function supprimer(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeMethode = params.typeMethode || 'complete';

      EvenementsResources.getEvenement(
        params,
        function (json) {
          if (angular.isDefined(json.list)) {
            if (angular.isArray(json.list) && json.list.length) {
              var retour = {
                status: 'OK',
                list: []
              };

              angular.forEach(json.list, function (evenement) {
                retour.list.push(new Evenement(evenement));
              });

              deferred.resolve(retour);
            } else
              deferred.reject({
                status: 'ZERO_RESULT',
                message: 'EvenementListe => Aucun Resultat.'
              });
          } else if (json.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: json.status ? json.status : 'BAD_QUERY',
              message: json.message ? json.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(json);
        },

        function (error) {
          if (error.status !== 'SESSION_EXPIRED') {
            deferred.reject({
              status: error.status ? error.status : 'BAD_QUERY',
              message: error.message ? error.message : 'EvenementListe => Requete Incorrecte.'
            });
          } else deferred.reject(error);
        }
      );

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('DiffusionsService', DiffusionsService);

  /** @ngInject */
  function DiffusionsService(globalService, DiffusionsResources, Alerte, $q) {
    var ctrl = this;

    ctrl.getList = getList;

    function getList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      DiffusionsResources
        .getDiffusions(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.diffusions)) {
                var retour = {
                  status: 'OK',
                  nbDiffusions: json.list.nbDiffusion,
                  list: {
                    diffusions: []
                  }
                };

                angular.forEach(json.list.diffusions, function (actu) {
                  retour.list.diffusions.push({
                    alerte: new Alerte(actu.alerte),
                    vue: actu.vue
                  });
                });

                deferred.resolve(retour);
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'DiffusionListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'DiffusionListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'DiffusionListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-27
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('CustomUtils', CustomUtilsController);

  /** @ngInject */
  function CustomUtilsController($parse, CONSTANTS, $q) {
    var ctrl = this;

    ctrl.toArray = toArray;
    ctrl.isNull = isNull;
    ctrl.objectContains = objectContains;
    ctrl.encrypt = encrypt;
    ctrl.decrypt = decrypt;
    ctrl.isImage = isImage;

    ctrl.number = {
      isInteger: isInteger,
      toInteger: toInteger,
      roundTo: roundTo,
      scaleTo: scaleTo,
      cleanNumber: cleanNumber,
      thounsandSeparator: thounsandSeparator
    };

    ctrl.string = {
      ucfirst: ucfirst,
      ucwords: ucwords,
      nl2br: nl2br,
      match: match,
      utf8_encode: utf8_encode,
      distance: distanceLevenshtein,
      removeDiacritics: removeDiacritics
    };

    ctrl.collection = {
      contains: contains,
      remove: remove,
      isEmpty: isEmpty,
      override: override
    };

    ctrl.date = {
      parse: customDateParse,
      format: customDateFormat
    };

    var defaultDiacriticsRemovalMap = [{
        base: 'A',
        letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
      },
      {
        base: 'AA',
        letters: /[\uA732]/g
      },
      {
        base: 'AE',
        letters: /[\u00C6\u01FC\u01E2]/g
      },
      {
        base: 'AO',
        letters: /[\uA734]/g
      },
      {
        base: 'AU',
        letters: /[\uA736]/g
      },
      {
        base: 'AV',
        letters: /[\uA738\uA73A]/g
      },
      {
        base: 'AY',
        letters: /[\uA73C]/g
      },
      {
        base: 'B',
        letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
      },
      {
        base: 'C',
        letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
      },
      {
        base: 'D',
        letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
      },
      {
        base: 'DZ',
        letters: /[\u01F1\u01C4]/g
      },
      {
        base: 'Dz',
        letters: /[\u01F2\u01C5]/g
      },
      {
        base: 'E',
        letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
      },
      {
        base: 'F',
        letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
      },
      {
        base: 'G',
        letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
      },
      {
        base: 'H',
        letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
      },
      {
        base: 'I',
        letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
      },
      {
        base: 'J',
        letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
      },
      {
        base: 'K',
        letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
      },
      {
        base: 'L',
        letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
      },
      {
        base: 'LJ',
        letters: /[\u01C7]/g
      },
      {
        base: 'Lj',
        letters: /[\u01C8]/g
      },
      {
        base: 'M',
        letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
      },
      {
        base: 'N',
        letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
      },
      {
        base: 'NJ',
        letters: /[\u01CA]/g
      },
      {
        base: 'Nj',
        letters: /[\u01CB]/g
      },
      {
        base: 'O',
        letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
      },
      {
        base: 'OI',
        letters: /[\u01A2]/g
      },
      {
        base: 'OO',
        letters: /[\uA74E]/g
      },
      {
        base: 'OU',
        letters: /[\u0222]/g
      },
      {
        base: 'P',
        letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
      },
      {
        base: 'Q',
        letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
      },
      {
        base: 'R',
        letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
      },
      {
        base: 'S',
        letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
      },
      {
        base: 'T',
        letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
      },
      {
        base: 'TZ',
        letters: /[\uA728]/g
      },
      {
        base: 'U',
        letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
      },
      {
        base: 'V',
        letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
      },
      {
        base: 'VY',
        letters: /[\uA760]/g
      },
      {
        base: 'W',
        letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
      },
      {
        base: 'X',
        letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
      },
      {
        base: 'Y',
        letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
      },
      {
        base: 'Z',
        letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
      },
      {
        base: 'a',
        letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
      },
      {
        base: 'aa',
        letters: /[\uA733]/g
      },
      {
        base: 'ae',
        letters: /[\u00E6\u01FD\u01E3]/g
      },
      {
        base: 'ao',
        letters: /[\uA735]/g
      },
      {
        base: 'au',
        letters: /[\uA737]/g
      },
      {
        base: 'av',
        letters: /[\uA739\uA73B]/g
      },
      {
        base: 'ay',
        letters: /[\uA73D]/g
      },
      {
        base: 'b',
        letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
      },
      {
        base: 'c',
        letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
      },
      {
        base: 'd',
        letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
      },
      {
        base: 'dz',
        letters: /[\u01F3\u01C6]/g
      },
      {
        base: 'e',
        letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
      },
      {
        base: 'f',
        letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
      },
      {
        base: 'g',
        letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
      },
      {
        base: 'h',
        letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
      },
      {
        base: 'hv',
        letters: /[\u0195]/g
      },
      {
        base: 'i',
        letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
      },
      {
        base: 'j',
        letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
      },
      {
        base: 'k',
        letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
      },
      {
        base: 'l',
        letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
      },
      {
        base: 'lj',
        letters: /[\u01C9]/g
      },
      {
        base: 'm',
        letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
      },
      {
        base: 'n',
        letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
      },
      {
        base: 'nj',
        letters: /[\u01CC]/g
      },
      {
        base: 'o',
        letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
      },
      {
        base: 'oi',
        letters: /[\u01A3]/g
      },
      {
        base: 'ou',
        letters: /[\u0223]/g
      },
      {
        base: 'oo',
        letters: /[\uA74F]/g
      },
      {
        base: 'p',
        letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
      },
      {
        base: 'q',
        letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
      },
      {
        base: 'r',
        letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
      },
      {
        base: 's',
        letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
      },
      {
        base: 't',
        letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
      },
      {
        base: 'tz',
        letters: /[\uA729]/g
      },
      {
        base: 'u',
        letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
      },
      {
        base: 'v',
        letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
      },
      {
        base: 'vy',
        letters: /[\uA761]/g
      },
      {
        base: 'w',
        letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
      },
      {
        base: 'x',
        letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
      },
      {
        base: 'y',
        letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
      },
      {
        base: 'z',
        letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
      }
    ];

    /* -------------------------------------------------=[ COMMON ]=------------------------------------------------- */

    /**
     * @description get an object and return array of values
     * @param object
     * @returns {Array}
     */
    function toArray(object) {
      return angular.isArray(object) ?
        object :
        Object.keys(object).map(function (key) {
          return object[key];
        });
    }

    /**
     * @param value
     * @returns {boolean}
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * @description return if object contains partial object
     * @param partial{object}
     * @param object{object}
     * @returns {boolean}
     */
    function objectContains(partial, object) {
      var keys = Object.keys(partial);

      return (
        keys
        .map(function (el) {
          return angular.isDefined(object[el]) && object[el] === partial[el];
        })
        .indexOf(false) === -1
      );
    }

    /**
     * @description return encrypted string
     * @param string{string}
     * @returns {string}
     */
    function encrypt(string) {
      return CryptoJS.AES.encrypt(string, CONSTANTS.encoding.passphrase).toString();
    }

    /**
     * @description return decrypted string
     * @param string{string}
     * @returns {string}
     */
    function decrypt(string) {
      return CryptoJS.AES.decrypt(string, CONSTANTS.encoding.passphrase).toString(CryptoJS.enc.Utf8);
    }

    /**
     * @description return true if src exist.
     * @param {string} src
     * @returns {boolean}
     */
    function isImage(src) {
      var deferred = $q.defer(),
        image = new Image();

      image.onerror = function () {
        deferred.reject();
      };

      image.onload = function () {
        deferred.resolve(image);
      };

      image.src = src;

      return deferred.promise;
    }

    /* -------------------------------------------------=[ NUMBER ]=------------------------------------------------- */

    /**
     * @description return true if value is an finite integer
     * @param {object} value
     * @returns {boolean}
     */
    function isInteger(value) {
      var number = angular.isNumber(value) ? value : parseFloat(value);
      return angular.isNumber(number) && isFinite(number) && Math.floor(number) === number;
    }

    /**
     * @description return true if value is an finite integer
     * @param {*} value
     * @returns {number}
     */
    function toInteger(value) {
      return isInteger(value) ? Math.abs(value) : 0;
    }

    /**
     * @description return num rounded to scale
     * @param {number|string} num
     * @param {number} scale
     * @returns {number}
     */
    function roundTo(num, scale) {
      num = cleanNumber(num, true);
      scale = isInteger(scale) ? scale : 2;

      if (isNaN(parseFloat(num))) return null;
      else if (num.match(/^[0-9]*[.][0-9]{2,}$/)) {
        num = parseFloat(num);
        var number = Math.round(Math.round(num * Math.pow(10, scale + 2)) / Math.pow(10, 2)) / Math.pow(10, scale);
        return num - number > 0 ?
          number + Math.floor(2 * Math.round((num - number) * Math.pow(10, scale + 1)) / 10) / Math.pow(10, scale) :
          number;
      } else {
        return parseFloat(num);
      }
    }

    /**
     * @description return num scaled (no round) to scale
     * @param {number|string} num
     * @param {number} scale
     * @param {boolean} toString
     * @returns {number|string}
     */
    function scaleTo(num, scale, toString) {
      scale = isInteger(scale) ? scale : 2;
      var cleaned = cleanNumber(num, true),
        scaled = cleaned;

      if (!isInteger(cleaned)) {
        var decimals = parseFloat('0.' + cleaned.split('.')[1]),
          decimalMin = Math.pow(10, -scale),
          decimalMax = 99 * Math.pow(10, -scale);
        if (parseFloat(cleaned) > 0 && decimals > decimalMax) {
          cleaned = Math.ceil(cleaned);
        } else if (parseFloat(cleaned) > 0 && decimals < decimalMin) {
          cleaned = Math.floor(cleaned);
        } else if (parseFloat(cleaned) < 0 && decimals > decimalMax) {
          cleaned = Math.floor(cleaned);
        } else if (parseFloat(cleaned) > 0 && decimals < decimalMin) {
          cleaned = Math.ceil(cleaned);
        }

        scaled = Math.trunc(cleaned * Math.pow(10, scale)) / Math.pow(10, scale);
      }

      return toString ? scaled : parseFloat(scaled);
    }

    /**
     * @description return the number cleaned from all no digit char except dot
     * @param {number|string} number
     * @param {boolean} toString
     * @returns {string|number}
     */
    function cleanNumber(number, toString) {
      number = angular.isString(number) ? number : number.toString();
      var cleaned = number
        .replace(' ', '')
        .replace(',', '.')
        .replace(/[^0-9.-]/g, '');
      return toString ? cleaned : parseFloat(cleaned);
    }

    /**
     * @description return the number to string with separator added to each thousand multiple
     * @param {number|string} number
     * @param {string} separator
     * @returns {string}
     */
    function thounsandSeparator(number, separator) {
      number = cleanNumber(number, true);
      separator = separator || ' ';
      if (isNaN(parseFloat(number))) return '0';
      var splited = number.split('.'),
        regex = /(\d+)(\d{3})/;
      while (regex.test(splited[0])) {
        splited[0] = splited[0].replace(regex, '$1' + separator + '$2');
      }
      return splited.length > 2 ? splited[0] + '.' + splited[1] : splited.join('.');
    }

    /* -------------------------------------------------=[ STRING ]=------------------------------------------------- */

    /**
     * @description return the string to lowercase with uppercase first char
     * @param {string} input
     * @returns {string}
     */
    function ucfirst(input) {
      if (angular.isString(input)) {
        var f = input.charAt(0).toUpperCase();
        return f + input.substr(1);
      } else return input;
    }

    /**
     * @description return the string to lowercase with uppercase first char of each words
     * @param {string} input
     * @returns {string}
     */
    function ucwords(input) {
      return angular.isString(input) ?
        input.toLowerCase().replace(/(?:^|\s)\S/g, function (char) {
          return char.toUpperCase();
        }) :
        input;
    }

    /**
     * @description return the string with <br> instead of \n
     * @param {string} input
     * @returns {string}
     */
    function nl2br(input) {
      return angular.isString(input) ? input.replace(/\n/g, '<br>') : input;
    }

    /**
     * @description return if input match pattern with flags
     * @param {string} input
     * @param {string} pattern
     * @param {string} flag
     * @returns {boolean|null}
     */
    function match(input, pattern, flag) {
      var reg = new RegExp(pattern, flag);

      return angular.isString(input) ? input.match(reg) : null;
    }

    /**
     * @description return utf8 encoded string
     * @param {string} argString
     * @returns {string}
     */
    function utf8_encode(argString) {
      if (argString === null || typeof argString === 'undefined') {
        return '';
      }

      var string = argString + '',
        utftext = '',
        start,
        end,
        stringl;

      start = end = 0;
      stringl = string.length;
      for (var n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n),
          enc = null;

        if (c1 < 128) {
          end++;
        } else if (c1 > 127 && c1 < 2048) {
          enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        } else if ((c1 & 0xf800) !== 0xd800) {
          enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        } else {
          if ((c1 & 0xfc00) !== 0xd800) {
            throw new RangeError('Unmatched trail surrogate at ' + n);
          }
          var c2 = string.charCodeAt(++n);
          if ((c2 & 0xfc00) !== 0xdc00) {
            throw new RangeError('Unmatched lead surrogate at ' + (n - 1));
          }
          c1 = ((c1 & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
          enc = String.fromCharCode((c1 >> 18) | 240, ((c1 >> 12) & 63) | 128, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
          if (end > start) {
            utftext += string.slice(start, end);
          }
          utftext += enc;
          start = end = n + 1;
        }
      }

      if (end > start) {
        utftext += string.slice(start, stringl);
      }

      return utftext;
    }

    function distanceLevenshtein(str1, str2) {
      if (str1 === str2) return 0;
      if (str1.length === 0) return str2.length;
      if (str2.length === 0) return str1.length;
      var prevRow = new Array(str2.length + 1),
        curCol,
        nextCol,
        i,
        j,
        tmp;
      for (i = 0; i < prevRow.length; ++i) {
        prevRow[i] = i;
      }
      for (i = 0; i < str1.length; ++i) {
        nextCol = i + 1;
        for (j = 0; j < str2.length; ++j) {
          curCol = nextCol;
          nextCol = prevRow[j] + (str1.charAt(i) === str2.charAt(j) ? 0 : 1);
          tmp = curCol + 1;
          if (nextCol > tmp) {
            nextCol = tmp;
          }
          tmp = prevRow[j + 1] + 1;
          if (nextCol > tmp) {
            nextCol = tmp;
          }
          prevRow[j] = curCol;
        }
        prevRow[j] = nextCol;
      }
      return nextCol;
    }

    function removeDiacritics(str) {
      for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
        str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
      }
      return str;
    }

    /* -----------------------------------------------=[ COLLECTION ]=----------------------------------------------- */

    /**
     * @description return if collection contains expression
     * @param collection
     * @param expression{string}
     * @returns {boolean}
     */
    function contains(collection, expression) {
      collection = angular.isObject(collection) ? ctrl.toArray(collection) : collection;

      if (!angular.isArray(collection) || angular.isUndefined(expression)) {
        return false;
      }

      return collection.some(function (elm) {
        return (angular.isString(expression) && angular.isObject(elm)) || angular.isFunction(expression) ?
          $parse(expression)(elm) :
          elm === expression;
      });
    }

    /**
     * @description return collection without object
     * @param collection
     * @param object{object}
     * @returns {object}
     */
    function remove(collection, object) {
      if (angular.isUndefined(object)) {
        return collection;
      }
      collection = angular.isObject(collection) ? ctrl.toArray(collection) : collection;

      return collection.filter(function (elm) {
        return !ctrl.objectContains(object, elm);
      });
    }

    /**
     * @description return true if the object is empty
     * @param object{object}
     * @returns {boolean}
     */
    function isEmpty(object) {
      if (!angular.isObject(object)) return -1;
      return !Object.keys(object).length;
    }

    /**
     * @description Return the target merged and overrided by src
     * @param {object} target
     * @param {object} src
     * @returns {object}
     */
    function override(target) {
      if (angular.isUndefined(target) || target === null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (angular.isDefined(nextSource) && nextSource !== null) {
          for (var nextKey in nextSource) {
            if (nextSource.hasOwnProperty(nextKey)) {
              if (
                angular.isObject(to[nextKey]) &&
                !isEmpty(to[nextKey]) &&
                angular.isObject(nextSource[nextKey]) &&
                !isEmpty(nextSource[nextKey])
              ) {
                to[nextKey] = override(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = angular.copy(nextSource[nextKey]);
              }
            }
          }
        } else if (angular.isDefined(to) && to !== null) {
          to = angular.copy(nextSource);
        }
      }
      return to;
    }

    /**
     * @description return Date object from string
     * @param string
     * @returns {Date|bool}
     */
    function customDateParse(string) {
      if (angular.isString(string)) {
        var fullDateTab = string.split(' '),
          date = fullDateTab[0],
          dateTab = date.split('/'),
          year,
          month,
          day;

        if (dateTab.length) {
          year = parseInt(dateTab[2], 10);
          month = parseInt(dateTab[1], 10) - 1;
          day = parseInt(dateTab[0], 10);

          if (fullDateTab.length > 1) {
            var time = fullDateTab[1],
              timeTab = time.split('h'),
              hours,
              minutes;

            if (timeTab.length) {
              hours = parseInt(timeTab[0], 10);
              minutes = parseInt(timeTab[1], 10);

              return new Date(year, month, day, hours, minutes);
            }
          }
          return new Date(year, month, day);
        }
        return false;
      }
      return false;
    }

    /**
     * @description return String from Date object
     * @param date
     * @param format
     * @returns {string|bool}
     */
    function customDateFormat(date, format) {
      if (typeof date === Date) {
        format = format || 'complete';

        var year = date.getFullYear(),
          month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1,
          day = date.getTime(),
          hours = date.getHours(),
          minutes = date.getMinutes();

        switch (format) {
          case 'complete':
            return day + '/' + month + '/' + year + ' ' + hours + 'h' + minutes;

          case 'date':
            return day + '/' + month + '/' + year;

          case 'time':
            return hours + 'h' + minutes;

          default:
            return day + '/' + month + '/' + year + ' ' + hours + 'h' + minutes;
        }
      } else return false;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-27
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular.module('transacGeslocNet').service('CriteresParser', CriteresParserController);

  /** @ngInject */
  function CriteresParserController(
    globalService,
    PropertiesService,
    ReferencesService,
    LocalisationService,
    CustomUtils,
    $q
  ) {
    var ctrl = this;

    ctrl.bienToSearch = bienToSearch;
    ctrl.prospectToSearch = prospectToSearch;
    ctrl.searchToProspect = searchToProspect;

    /**
     * Conversion des critères d'un Bien vers une recherche de prospect
     *
     * @param {Bien} bien
     * @returns {{prixMin: (*|null), prixMax: (*|null), type: (*|null), villes: (*|null), criteres: (*|null)}}
     */
    function bienToSearch(bien) {
      var prix = bien.mandatTransaction ? bien.mandatTransaction.prixVente : bien.mandatLocation.loyer,
        retour = {
          status: false,
          search: {
            prixMax: prix || null,
            prixMin: prix || null,
            type: bien.type || null,
            villes: null,
            criteres: null
          }
        },
        globalDefer = $q.defer(),
        promises = [];

      // Ville
      var deferredVille = $q.defer();

      LocalisationService.getVillesByQuery({
          recherche: bien.adresse.cp || bien.adresse.ville,
          typeApplication: globalService.getTypeApplication()
        })
        .then(function (json) {
          retour.status = retour.status === 'OK' ? retour.status : json.status;
          if (json.status === 'OK') {
            //retour.search.cpVille = angular.toJson(json.list);
            retour.search.villes = angular.toJson(json.list);
          } else {
            retour.message = json.message;
          }
        })
        .finally(function () {
          deferredVille.resolve();
        });

      // Criteres
      var deferredCriteres = $q.defer();

      var params = {
        typeBien: retour.search.type,
        typeApplication: globalService.getTypeApplication()
      };

      if (retour.search.type !== 'lot') {
        params.afficher = true;
      }

      ReferencesService.getCritereListe(params)
        .then(function (json) {
          retour.status = retour.status === 'OK' ? retour.status : json.status;
          if (json.status === 'OK') {
            var tmp = [];

            angular.forEach(json.list, function (critere) {
              if (critere['rapprocher' + (globalService.getTypeApplication() === 'Location' ? 'Loc' : '')]) {
                var current = {
                  obligatoire: true,
                  critere: {
                    id: critere.id,
                    nomChamp: critere.nomChamp,
                    nom: critere.nom,
                    type: critere.type
                  }
                };

                switch (critere.type) {
                  case 'int':
                    if (bien.getCritereValue(critere.nomChamp) !== null) {
                      current.intMin = bien.getCritereValue(critere.nomChamp);
                      current.intMax = bien.getCritereValue(critere.nomChamp);
                      tmp.push(current);
                    }
                    break;

                  case 'float':
                    if (bien.getCritereValue(critere.nomChamp) !== null) {
                      current.floatMin = bien.getCritereValue(critere.nomChamp);
                      current.floatMax = bien.getCritereValue(critere.nomChamp);
                      tmp.push(current);
                    }
                    break;

                  case 'boolean':
                    if (bien.getCritereValue(critere.nomChamp) !== null) {
                      current.bool = bien.getCritereValue(critere.nomChamp);
                      tmp.push(current);
                    }
                    break;

                  case 'date':
                    if (bien.getCritereValue(critere.nomChamp) !== null) {
                      current.date = bien.getCritereValue(critere.nomChamp);
                      tmp.push(current);
                    }
                    break;

                  case 'combo':
                    if (bien.getCritereValue(critere.nomChamp) !== null) {
                      current.combo = [bien.getCritereValue(critere.nomChamp)];
                      tmp.push(current);
                    }
                    break;
                }
              }
            });

            if (tmp.length) {
              retour.search.criteres = angular.toJson(tmp);
            }
          } else {
            retour.message = json.message;
          }
        })
        .finally(function () {
          deferredCriteres.resolve();
        });

      promises.push(deferredVille.promise);
      promises.push(deferredCriteres.promise);

      $q.all(promises).then(function () {
        globalDefer.resolve(retour);
      });

      return globalDefer.promise;
    }

    /**
     * Conversion des critères d'un Prospect vers une recherche de bien
     *
     * @param prospect
     * @returns encrypted query
     */
    function prospectToSearch(prospect) {
      var search = {
        societe: globalService.getEmploye().societe.id,
        prixMin: prospect.prixMin || null,
        prixMax: prospect.prixMax || null,
        type: null,
        villes: null,
        mandat: true,
        archive: false,
        criteres: null
      };

      // Villes
      if (angular.isArray(prospect.villes) && prospect.villes.length) {
        var villes = [];
        angular.forEach(prospect.villes, function (ville) {
          villes.push({
            id: ville.id,
            codePostal: ville.codePostal,
            nom: ville.nom
          });
        });

        search.villes = angular.toJson(villes);
      }

      // Types de bien
      if (angular.isArray(prospect.typesBien) && prospect.typesBien.length) {
        search.type = '';
        angular.forEach(prospect.typesBien, function (type, index) {
          search.type += type.simpleData;
          if (index < prospect.typesBien.length - 1) search.type += ',';
        });
      }

      // Critères
      if (angular.isArray(prospect.criteres) && !CustomUtils.collection.isEmpty(prospect.criteres)) {
        var tmp = [];

        angular.forEach(prospect.criteres, function (critere) {
          var current = {
            obligatoire: true,
            critere: {
              id: critere.critere.id,
              nomChamp: critere.critere.nomChamp,
              nom: critere.critere.nom,
              type: critere.critere.type
            }
          };

          switch (critere.critere.type) {
            case 'int':
              if (critere.intMin || critere.intMax) {
                current.intMin = critere.intMin;
                current.intMax = critere.intMax;
                tmp.push(current);
              }
              break;

            case 'float':
              if (critere.floatMin || critere.floatMax) {
                current.floatMin = critere.floatMin;
                current.floatMax = critere.floatMax;
                tmp.push(current);
              }
              break;

            case 'boolean':
              if (angular.isDefined(critere.bool) && critere.bool !== null) {
                current.bool = critere.bool;
                tmp.push(current);
              }
              break;

            case 'date':
              if (angular.isDefined(critere.date) && critere.date !== null) {
                current.date = critere.date;
                tmp.push(current);
              }
              break;

            case 'combo':
              if (angular.isDefined(critere.combo) && angular.isArray(critere.combo) && critere.combo.length) {
                current.combo = critere.combo;
                tmp.push(current);
              }
              break;
          }
        });

        search.criteres = angular.toJson(tmp);
      }

      return search;
    }

    /**
     * Conversion d'une recherche de bien en critères prospect
     *
     * @param search
     * @returns {deferred.promise|{then, catch, finally}|{then}}
     */
    function searchToProspect(search) {
      var deferred = $q.defer(),
        retour = {
          status: false,
          prospect: {
            prixMin: search.prixMin || null,
            prixMax: search.prixMax || null,
            typesBien: null,
            villes: search.villes ? angular.fromJson(search.villes) : null,
            criteres: search.criteres ? angular.fromJson(search.criteres) : null
          }
        };

      if (angular.isString(search.type) && search.type.length) {
        retour.prospect.typesBien = [];

        PropertiesService.getTypesBiens({
            typeApplication: globalService.getTypeApplication()
          })
          .then(function (json) {
            retour.status = json.status;

            if (json.status === 'OK') {
              var listeTypeRecherche = search.type.split(',');
              angular.forEach(json.list, function (type) {
                if (CustomUtils.collection.contains(listeTypeRecherche, type.simpleData))
                  retour.prospect.typesBien.push(type);
              });

              deferred.resolve(retour);
            } else {
              retour.message = json.message;
              deferred.reject(retour);
            }
          })
          .catch(function (error) {
            retour.status = error.status;
            retour.message = error.message;
            deferred.reject(retour);
          });
      } else {
        retour.status = 'OK';
        deferred.resolve(retour);
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ContratsService', ContratsService);

  /** @ngInject */
  function ContratsService(globalService, ContratsResources, Compromis, Reservation, $q) {
    var ctrl = this;

    // Compromis
    ctrl.compromis = {
      getList: getListCompromis,
      nouveau: nouveauCompromis,
      editer: editerCompromis,
      supprimer: supprimerCompromis
    };

    // Reservations
    ctrl.reservations = {
      getList: getListReservations,
      nouvelle: nouvelleReservation,
      editer: editerReservation,
      supprimer: supprimerReservation,
      getEncaissementsList: getEncaissementsList,
      editerEncaissements: editerEncaissements,
      dossierLocataire: dossierLocataire,
      retourGestion: retourGestion
    };

    ctrl.getRemisesList = getRemisesList;

    /* -----------------------------------------=[ COMPROMIS ]=------------------------------------------------------ */
    function getListCompromis(query) {
      var deferred = $q.defer(),
        params = angular.copy(query);

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeApplication = 'Transaction';

      var search = params.search ? angular.copy(params.search) : {};
      delete params.search;
      angular.forEach(search, function (value, key) {
        params[key] = value;
      });

      ContratsResources
        .compromisList(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.compromis) && json.list.compromis.length) {
                if (params.idVente) {
                  deferred.resolve({
                    status: 'OK',
                    compromis: new Compromis(json.list.compromis[0])
                  });
                } else {
                  var list = [];
                  angular.forEach(json.list.compromis, function (compromis) {
                    list.push(new Compromis(compromis));
                  });

                  deferred.resolve({
                    status: 'OK',
                    list: list,
                    nb: json.list.nbCompromis || list.length
                  });
                }
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'VenteListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: 'BAD_QUERY',
                message: 'VenteListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function nouveauCompromis(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .editCompromis(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.compromis) && json.list.compromis.length) {
                deferred.resolve({
                  status: 'OK',
                  compromis: new Compromis(json.list.compromis[0])
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'VenteListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: 'BAD_QUERY',
                message: 'VenteListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function editerCompromis(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .editCompromis(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.compromis) && json.list.compromis.length) {
                deferred.resolve({
                  status: 'OK',
                  compromis: new Compromis(json.list.compromis[0])
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'VenteListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: 'BAD_QUERY',
                message: 'VenteListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function supprimerCompromis(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.deleteId || !params.deleteRaison) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "deleteId" et/ou "deleteRaison" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ContratsResources
          .compromisList(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  deferred.resolve({
                    status: 'OK',
                    compromis: json.list[0]
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'VenteListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: 'BAD_QUERY',
                  message: 'VenteListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    /* -----------------------------------------=[ LOCATIONS ]=------------------------------------------------------ */
    function getListReservations(query) {
      var deferred = $q.defer(),
        params = angular.copy(query);

      params.host = globalService.getHost();
      params.service = globalService.getService();
      params.typeApplication = 'Location';

      var search = params.search ? angular.copy(params.search) : {};
      delete params.search;
      angular.forEach(search, function (value, key) {
        params[key] = value;
      });

      ContratsResources
        .reservationsList(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.location) && json.list.location.length) {
                if (params.idLocation) {
                  var reservation = new Reservation(json.list.location[0]);

                  deferred.resolve({
                    status: 'OK',
                    reservation: reservation
                  });
                } else {
                  var list = [];
                  angular.forEach(json.list.location, function (reservation) {
                    list.push(new Reservation(reservation));
                  });

                  deferred.resolve({
                    status: 'OK',
                    list: list,
                    nb: json.list.nbLocation || list.length
                  });
                }
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'LocationListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function nouvelleReservation(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .editReservation(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.location) && json.list.location.length) {
                deferred.resolve({
                  status: 'OK',
                  reservation: new Reservation(json.list.location[0])
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'LocationListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function editerReservation(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .editReservation(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.location) && json.list.location.length) {
                deferred.resolve({
                  status: 'OK',
                  reservation: new Reservation(json.list.location[0])
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'LocationListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'LocationListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function supprimerReservation(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.deleteId || !params.deleteRaison) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "deleteId" et/ou "deleteRaison" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ContratsResources
          .reservationsList(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list) && json.list.length) {
                  deferred.resolve({
                    status: 'OK',
                    reservation: json.list[0]
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'LocationListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'LocationListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LocationListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getEncaissementsList(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.idLocation) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "idLocation" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ContratsResources
          .encaissementListe(
            params,

            function (json) {
              if (angular.isDefined(json.list)) {
                if (angular.isArray(json.list.encaissements) && json.list.encaissements.length) {
                  deferred.resolve({
                    status: 'OK',
                    encaissements: json.list.encaissements,
                    nb: json.list.nbencaissements
                  });
                } else deferred.reject({
                  status: 'ZERO_RESULT',
                  message: 'EncaissementListe => Aucun Resultat.'
                });
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'EncaissementListe => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'EncaissementListe => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function editerEncaissements(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .encaissementListe(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list.encaissements) && json.list.encaissements.length) {
                deferred.resolve({
                  status: 'OK',
                  encaissements: json.list.encaissements,
                  nb: json.list.nbencaissements
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'EncaissementListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'EncaissementListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'EncaissementListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }

    function dossierLocataire(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.idLocation) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "idLocation" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ContratsResources
          .dossierLocataire(
            params,

            function (json) {
              if (json && json.status === 'OK') {
                deferred.resolve({
                  status: 'OK',
                  dateEnvoi: json
                });
              } else {
                deferred.reject({
                  status: json.status,
                  message: json.message
                });
              }
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'DossierLocataire => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function retourGestion(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.idLocationEnGerance) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre "idLocationEnGerance" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ContratsResources
          .retourGestion(
            params,

            function (json) {
              if (json) {
                deferred.resolve({
                  status: 'OK',
                  retour: json
                });
              } else {
                deferred.reject({
                  status: 'NOT_SENT',
                  message: 'Une erreur s\'est produite. La location n\'a pas été retournée en gestion. (Code erreur : RES-RG-580)'
                });
              }
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'LocationGateway => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }

    function getRemisesList(params) {
      var deferred = $q.defer();

      params.host = globalService.getHost();
      params.service = globalService.getService();

      ContratsResources
        .remiseListe(
          params,

          function (json) {
            if (angular.isDefined(json.list)) {
              if (angular.isArray(json.list) && json.list.length) {
                deferred.resolve({
                  status: 'OK',
                  remises: json.list,
                  nb: json.list.length
                });
              } else deferred.reject({
                status: 'ZERO_RESULT',
                message: 'RemiseListe => Aucun Resultat.'
              });
            } else if (json.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: json.status ? json.status : 'BAD_QUERY',
                message: json.message ? json.message : 'RemiseListe => Requete Incorrecte.'
              });
            } else deferred.reject(json);
          },

          function (error) {
            if (error.status !== 'SESSION_EXPIRED') {
              deferred.reject({
                status: error.status ? error.status : 'BAD_QUERY',
                message: error.message ? error.message : 'RemiseListe => Requete Incorrecte.'
              });
            } else deferred.reject(error);
          }
        );

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */

(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .service('ClientICSService', ClientICSService);

  /** @ngInject */
  function ClientICSService(globalService, ClientICSResources, $q) {
    var ctrl = this;

    ctrl.creer = creer;

    function creer(params) {
      var deferred = $q.defer();

      if (angular.isUndefined(params) || !params.json) {
        deferred.reject({
          status: 'MISSING_PARAMETER',
          message: 'Parametre(s) "json" manquant.'
        });
      } else {
        params.host = globalService.getHost();
        params.service = globalService.getService();

        ClientICSResources
          .creer(
            params,

            function (json) {
              if (json.retour) {
                json.status = 'OK';
                deferred.resolve(json);
              } else if (json.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: json.status ? json.status : 'BAD_QUERY',
                  message: json.message ? json.message : 'ClientIcsServlet => Requete Incorrecte.'
                });
              } else deferred.reject(json);
            },

            function (error) {
              if (error.status !== 'SESSION_EXPIRED') {
                deferred.reject({
                  status: error.status ? error.status : 'BAD_QUERY',
                  message: error.message ? error.message : 'ClientIcsServlet => Requete Incorrecte.'
                });
              } else deferred.reject(error);
            }
          );
      }

      return deferred.promise;
    }
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('VisiteResources', VisiteResources);

  /** @ngInject */
  function VisiteResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      bonVisite: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'VisiteListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ToDoListeResources', ToDoListeResources);

  /** @ngInject */
  function ToDoListeResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getTasks: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'ToDoListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('TableauBordResources', TableauBordResources);

  /** @ngInject */
  function TableauBordResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getStatistiques: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'TableauBordListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('StatistiquesResources', StatistiquesResources);

  /** @ngInject */
  function StatistiquesResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getStatistiques: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'StatistiqueNegoListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('StatistiqueMensuelResources', StatistiqueMensuelResources);

  /** @ngInject */
  function StatistiqueMensuelResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getStatistiques: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'ClasseurServlet',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ReportResources', ReportResources);

  /** @ngInject */
  function ReportResources($resource, $httpParamSerializer) {

    return $resource(':host/:service/:servlet', null, {
      envoyer: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ReportServlet',
          typeRetour: 'json'
        }
      }
    });
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('RepertoireResources', RepertoireResources);

  /** @ngInject */
  function RepertoireResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      getPersoList: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'RepertoireListe',
          typeRetour: 'json'
        }
      },

      getSocietesList: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'SocieteListe',
          typeRetour: 'json'
        }
      },

      getNegoList: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'EmployeListe',
          typeRetour: 'json'
        }
      },

      getPerso: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'PersoListe',
          typeRetour: 'json'
        }
      },

      getProspect: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        transformRequest: function(data) {
          delete data.host;
          delete data.service;
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ProspectListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ProspectsResources', ProspectsResources);

  /** @ngInject */
  function ProspectsResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      liste: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ProspectListe',
          typeRetour: 'json'
        }
      },

      edit: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ProspectSave',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('PropertiesResources', PropertiesResources);

  /** @ngInject */
  function PropertiesResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      list: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'LotListe',
          typeRetour: 'json'
        }
      },

      save: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'LotSave',
          typeRetour: 'json'
        }
      },

      zoneAlur: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'ZoneAlur',
          typeRetour: 'json'
        }
      },

      societes: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'SocieteListe',
          typeRetour: 'json'
        }
      },

      ajouter: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'LotSave',
          typeRetour: 'json'
        }
      },

      references: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'ReferenceListe',
          typeRetour: 'json'
        }
      },

      prestataire: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'PrestataireListe',
          typeRetour: 'json'
        }
      },

      parution: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'ParutionListe',
          typeRetour: 'json'
        }
      },

      critere: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'CritereListe',
          typeRetour: 'json'
        }
      },

      editPhoto: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'MultimediaServlet',
          typeRetour: 'json'
        }
      },

      gedListe: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'GedListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('ParutionsResources', ParutionsResourcesController);

  /** @ngInject */
  function ParutionsResourcesController($resource, $httpParamSerializer) {
    //noinspection JSUnusedGlobalSymbols
    return $resource(':host/:service/:servlet', null, {
      parution: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        transformRequest: function(data) {
          delete data.host;
          delete data.service;
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ParutionListe',
          typeRetour: 'json'
        }
      },

      checkParutions: {
        url: ':host/:service/:servlet',
        method: 'GET',
        withCredentials: false,
        params: {
          host: '@host',
          service: '@service',
          servlet: 'EtatICSBOX.jsp',
          typeRetour: 'json'
        }
      },

      prestataire: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          host: '@host',
          service: '@service',
          servlet: 'PrestataireListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('PanierResources', PanierResources);

  /** @ngInject */
  function PanierResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      panier: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'PanierListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('MailResources', MailResources);

  /** @ngInject */
  function MailResources($resource, $httpParamSerializer) {
    //noinspection JSUnusedGlobalSymbols
    return $resource(':host/:service/:servlet', null, {
      mailXpress: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'EmailXpress',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('LoginResources', LoginResources);

  /** @ngInject */
  function LoginResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      login: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'EmployeLogin',
          typeRetour: 'json'
        }
      },
      kerberos: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'KerberosLogin',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('LocalisationResources', LocalisationResources);

  /** @ngInject */
  function LocalisationResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      villes: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'VilleListe',
          typeRetour: 'json'
        }
      },
      geocode: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'Geolocalisation', // TODO => Voir avec Julien le nom de la serlvet
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('InstallationResources', InstallationResources);

  /** @ngInject */
  function InstallationResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      installation: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'InstallationServlet',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : jdecorte@ics.fr
 * @since : 2018-01-12
 * @version : 0.0.2
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('InfoResources', InfoResources);

  /** @ngInject */
  function InfoResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      info: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          host: '@host',
          service: '@service',
          servlet: 'InfoListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ImpressionResources', ImpressionResources);

  /** @ngInject */
  function ImpressionResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getPDFTransaction: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'TransformServletJson'
        }
      },

      getPDFLocation: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'TransformServletLocationJson'
        }
      },

      getDOCTransaction: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'EditionXMLJson'
        }
      },

      getDOCLocation: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'EditionXMLLocationJson'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function() {
  'use strict';

  angular.module('transacGeslocNet').factory('FavorisResources', FavorisResources);

  /** @ngInject */
  function FavorisResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      favoris: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'FavorisListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('EvenementsResources', EvenementsResources);

  /** @ngInject */
  function EvenementsResources($resource, $httpParamSerializer) {
    //noinspection JSUnusedGlobalSymbols
    return $resource(':host/:service/:servlet', null, {
      getEvenement: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'EvenementListe',
          typeRetour: 'json'
        }
      },
      setEvenement: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'EvenementListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('DiffusionsResources', DiffusionsResources);

  /** @ngInject */
  function DiffusionsResources($resource) {
    return $resource(':host/:service/:servlet', null, {
      getDiffusions: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'DiffusionListe',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ContratsResources', ContratsResources);

  /** @ngInject */
  function ContratsResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      compromisList: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'VenteListe',
          typeRetour: 'json'
        }
      },

      reservationsList: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'LocationListe',
          typeRetour: 'json'
        }
      },

      editCompromis: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'VenteListe',
          typeRetour: 'json'
        }
      },

      editReservation: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'LocationListe',
          typeRetour: 'json'
        }
      },

      remiseListe: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'RemiseListe',
          typeRetour: 'json'
        }
      },

      encaissementListe: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'EncaissementListe',
          typeRetour: 'json'
        }
      },

      editEncaissements: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'EncaissementListe',
          typeRetour: 'json'
        }
      },

      dossierLocataire: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'DossierLocataire',
          typeRetour: 'json'
        }
      },

      retourGestion: {
        url: ':host/:service/:servlet',
        method: 'GET',
        params: {
          servlet: 'LocationGateway',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2016-04-08
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .factory('ClientICSResources', ClientICSResources);

  /** @ngInject */
  function ClientICSResources($resource, $httpParamSerializer) {
    return $resource(':host/:service/:servlet', null, {
      creer: {
        url: ':host/:service/:servlet',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        transformRequest: function (data) {
          delete(data.host);
          delete(data.service);
          return $httpParamSerializer(data);
        },
        params: {
          host: '@host',
          service: '@service',
          servlet: 'ClientIcsServlet',
          typeRetour: 'json'
        }
      }
    });
  }
})();
/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2017-11-17
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function() {
  'use strict';

  angular.module('transacGeslocNet').filter('tgnFormat', TgnFormatFilter);

  /** @ngInject */
  function TgnFormatFilter(CustomUtils) {
    var formatters = {
      integer: function(value, scale) {
        if (value) {
          return CustomUtils.number.thounsandSeparator(Math.trunc(CustomUtils.number.scaleTo(value, scale)));
        }
      },
      number: function(value, scale) {
        if (value) {
          var num = CustomUtils.number.cleanNumber(value, true);
          if (num.match(/^[0-9]*[.][0-9]{2,}$/)) {
            num = CustomUtils.number.roundTo(num, scale);
          }
          return CustomUtils.number.thounsandSeparator(num);
        }
      }
    };

    return function(elem, type, scale) {
      scale = CustomUtils.number.isInteger(scale) ? scale : 2;
      if (isFinite(Number(elem)) && formatters.hasOwnProperty(type)) {
        return formatters[type](elem, scale);
      } else return elem;
    };
  }
})();

/**
 * @desc :
 *
 * @author : vfillon@ics.fr
 * @since : 2017-03-07
 * @version : 0.0.1
 * @copyright : transac-gesloc.net © ICS
 */
(function () {
  'use strict';

  angular
    .module('transacGeslocNet')
    .filter('tgnFilterBy', TgnFilterByFilter);

  /** @ngInject */
  function TgnFilterByFilter($parse) {
    /**
     * @param value
     * @returns {boolean}
     */
    function isBoolean(value) {
      return typeof value === 'boolean';
    }

    /**
     * @description
     * get an object and return array of values
     * @param object
     * @returns {Array}
     */
    function toArray(object) {
      return angular.isArray(object)
        ? object
        : Object.keys(object).map(function (key) {
          return object[key];
        });
    }

    return function (collection, properties, search, strict) {
      var comparator;

      search = (angular.isString(search) || angular.isNumber(search) || isBoolean(search)) ?
        String(search).toLowerCase() : undefined;

      collection = angular.isObject(collection) ? toArray(collection) : collection;

      if (!angular.isArray(collection) || angular.isUndefined(search)) {
        return collection;
      }

      return collection.filter(function (elm) {
        return properties.some(function (prop) {
          /**
           * check if there is concatenate properties
           * example:
           * object: { first: 'foo', last:'bar' }
           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
           */
          if (!~prop.indexOf('+')) {
            comparator = $parse(prop)(elm)
          } else {
            var propList = prop.replace(/\s+/g, '').split('+');
            comparator = propList
              .map(function (prop) {
                return $parse(prop)(elm);
              })
              .join(' ');
          }

          if (!angular.isString(comparator) && !angular.isNumber(comparator) && !isBoolean(comparator)) {
            return false;
          }

          comparator = String(comparator).toLowerCase();

          return strict ? comparator === search : comparator.contains(search);
        });
      });
    };
  }
})();
angular.module('transacGeslocNet')
/** @ngInject */
  .filter('to_trusted', function ($sce) {
    return function (text) {
      return $sce.trustAsHtml(text);
    };
  })

  /** @ngInject */
  .filter('nl2br', function () {
    return function (input) {
      return angular.isString(input) ? input.replace(/\n/g, '<br>') : input;
    };
  })
  .filter('sumOfValue', function () {
    return function (data, key) {        
        if (angular.isUndefined(data) || angular.isUndefined(key))
            return 0;        
        var sum = 0;        
        angular.forEach(data,function(value){
            sum = sum + parseFloat(value[key], 10);
        });        
        return sum;
    }
    });
(function () {
  'use strict';

  angular.module('transacGeslocNet').run(RunBlock);

  /** @ngInject */
  function RunBlock(
    CONSTANTS,
    LoginService,
    InfoService,
    globalService,
    Perso,
    $rootScope,
    $state,
    $urlRouter,
    localStorageService,
    $window,
    $location,
    $templateCache,
    moment,
    $log
  ) {
    $log.info("-----=[ Démarrage de l'application ]=-----");

    globalService.cleanExpiredSTokens();

    // TODO => REACTIVER STELLA :
    $rootScope.stella = CONSTANTS.configClient.citya;

    $window.addEventListener('keydown', function (e) {
      if (e.keyCode === 112) {
        e.preventDefault();
      }
    });

    var idleWarnListener = $rootScope.$on('IdleWarn', function (e, countdown) {
      if (countdown === 5) {
        $log.warn('Inctivité détectée...');
      }
      $log.warn('Déconnexion dans ' + countdown + 's.');
    });
    var idleTimeoutListener = $rootScope.$on('IdleTimeout', function () {
      // Déconnexion après période d'inactivité (par défaut 20min)
      $log.warn('Déconnexion suite à une période prolongée d\'inctivité...');
      LoginService.logout({
        connexionTimedOut: true
      });
    });
    var idleEndListener = $rootScope.$on('IdleEnd', function () {
      $log.warn('Activité détectée.');
    });

    var stateChangeListener = $rootScope.$on('$stateChangeStart', onStateChangeHandler);
    var backToLoginListener = $rootScope.$on('BACK_TO_LOGIN', backToLoginHandler);
    var reloadListener = $rootScope.$on('reload', reloadHandler);

    $urlRouter.listen();

    $rootScope.$onDestroy = function () {
      idleWarnListener();
      idleWarnListener = null;
      idleTimeoutListener();
      idleTimeoutListener = null;
      idleEndListener();
      idleEndListener = null;

      stateChangeListener();
      stateChangeListener = null;

      backToLoginListener();
      backToLoginListener = null;

      reloadListener();
      reloadListener = null;
    };

    globalService.setTypeApplication(globalService.getTypeApplication(), false, false);

    $rootScope.favicon = globalService.getTypeApplication() === 'Transaction' ? 'transac.ico' : 'gesloc.ico';

    $log.info('APP ACTIVE : ', globalService.getTypeApplication());

    var employe = globalService.getEmploye() || false;

    if (employe) {
      if (globalService.getTypeApplication() === 'Transaction' && !employe.transaction) {
        globalService.setTypeApplication('Location', true, false);
      } else if (globalService.getTypeApplication() === 'Location' && !employe.location) {
        globalService.setTypeApplication('Transaction', true, false);
      }
    }

    loadVersion();

    var prospect = globalService.getStorageItem('PANIER-PROSPECT');
    if (prospect) {
      $rootScope.$broadcast('prospectPanierChange', {
        prospect: prospect
      });
    }

    $templateCache.put(
      'lightbox.html',
      '<div class=modal-body ng-swipe-left=Lightbox.nextImage() ng-swipe-right=Lightbox.prevImage()>' +
      '  <div class=lightbox-nav>' +
      '    <button class=close aria-hidden=true ng-click=$dismiss()>×</button>' +
      '    <div class=btn-group ng-if="Lightbox.images.length > 1">' +
      '      <a class="btn btn-xs btn-default" ng-click=Lightbox.prevImage()>‹ Pr&eacute;c&eacute;dante</a> ' +
      '      <a class="btn btn-xs btn-default" ng-click=Lightbox.nextImage()>Suivante ›</a>' +
      '    </div>' +
      '  </div>' +
      '  <div class=lightbox-image-container>' +
      '    <div class=lightbox-image-caption><span>{{Lightbox.imageCaption}}</span></div>' +
      '    <img ng-if=!Lightbox.isVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}}>' +
      '    <div ng-if=Lightbox.isVideo(Lightbox.image) class="embed-responsive embed-responsive-16by9">' +
      '      <video ng-if=!Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} controls autoplay></video>' +
      '      <embed-video ng-if=Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} ng-href={{Lightbox.imageUrl}} iframe-id=lightbox-video class=embed-responsive-item>' +
      '        <a ng-href={{Lightbox.imageUrl}}>Regarder video</a>' +
      '      </embed-video>' +
      '    </div>' +
      '  </div>' +
      '</div>'
    );

    /* ----------=[ FUNCTIONS ]=---------- */

    function onStateChangeHandler(event, toState, toParams, fromState, fromParams) {
      // test local storage
      if (!localStorageService.isSupported && $state.current.name !== 'login') {
        LoginService.logout({
          errLocalStorage: true
        });
      }

      // Check if not trying to access to admin route
      if (toState.name === 'admin') {
        // Prevent $urlRouter's default handler from firing
        event.preventDefault();

        if (fromState.name !== 'admin' && fromState.name !== '') {
          $window.location.assign($state.href(toState.name, {
            absolute: true
          }));
        }
        return;
      }

      // Ne pas conserver la sélection de bien pour Citya
      if (CONSTANTS.configClient.citya) {
        $rootScope.$broadcast('clearSelection');
      }

      // vérifier que l'utilisateur est connecté ou n'essaye pas d'acceder à une page qui nécessite une authentification
      if ((!toState.hasOwnProperty('autorized') || !toState.autorized) && !globalService.isLogged()) {
        event.preventDefault();
        globalService.setEmploye(null);
        $state.go('login', {
          prevState: toState
        });
      }

      // vérifier que la page corresponde à l'application active (transac = comrpomis/vente || gesloc = reservation/location)
      if (toState.name === 'contrat') {
        if (
          globalService.getTypeApplication() === 'Location' &&
          toParams.type !== 'reservation' &&
          toParams.type !== 'location' &&
          (fromParams.type === 'compromis' ||
            fromParams.type === 'vente' ||
            toParams.type === 'compromis' ||
            toParams.type === 'vente')
        ) {
          event.preventDefault();
          $state.go('contrat', {
            type: fromParams.type === 'compromis' || toParams.type === 'compromis' ? 'reservation' : 'location'
          });
        } else if (
          globalService.getTypeApplication() === 'Transaction' &&
          toParams.type !== 'compromis' &&
          toParams.type !== 'vente' &&
          (fromParams.type === 'reservation' ||
            fromParams.type === 'location' ||
            toParams.type === 'reservation' ||
            toParams.type === 'location')
        ) {
          event.preventDefault();
          $state.go('contrat', {
            type: fromParams.type === 'reservation' || toParams.type === 'reservation' ? 'compromis' : 'vente'
          });
        }
      }

      $rootScope.currentState = {
        name: toState.name,
        params: toParams
      };
    }

    function backToLoginHandler(event, params) {
      $state.go('login', {
        prevState: params.prevState
      });
    }

    function reloadHandler(event, params) {
      params = params || {};
      var typeApplication = globalService.getTypeApplication();
      params.fromType = angular.isDefined(params.fromType) ?
        params.fromType :
        typeApplication === 'Transaction' ?
        'Location' :
        'Transaction';
      var login =
        CONSTANTS.configClient[params.fromType].server !== CONSTANTS.configClient[typeApplication].server ||
        CONSTANTS.configClient[params.fromType].context !== CONSTANTS.configClient[typeApplication].context;
      if (login) {
        var employe = globalService.getEmploye();
        if (employe) {
          LoginService.login({
              initiales: employe.initiales,
              mdp: employe.mdp,
              location: typeApplication === 'Location'
            })
            .then(function (json) {
              if (json.status === 'OK' && angular.isDefined(json.employe)) {
                json.employe.perso = new Perso(json.employe.perso);
                globalService.setEmploye(json.employe);
                globalService.setTypeApplication(typeApplication, false, false);

                var targetState = $state.current.name || 'accueil';
                $state.transitionTo(targetState, null, {
                  reload: true,
                  inherit: false,
                  notify: true
                });
              }
            })
            .catch(function (error) {
              if (error.status) {
                if (error.status === 'ZERO_RESULT') $log.warn(error.message);
                else if (error.status !== 'SESSION_EXPIRED')
                  $log.error(error.status + (error.message ? ' - ' + error.message : ''));
              } else $log.error(error.status);
              globalService.setEmploye(null);
              $state.go('login', {
                prevState: $state.current
              });
            });
        } else {
          $state.go('login', {
            prevState: $state.current
          });
        }
      } else {
        globalService.setTypeApplication(typeApplication, false, false);
        var targetState = $state.current.name || 'accueil';
        $state.transitionTo(targetState, null, {
          reload: true,
          inherit: false,
          notify: true
        });
      }
    }

    function loadVersion() {
      //Ajout de la recuperation de la version serveur
      InfoService.info({}).then(function (json) {
        if (json.status === 'OK' && angular.isDefined(json.version)) {
          globalService.setVersion(json.version);
        }
      });
    }
    /* ----------=[ POLYFILL ]=---------- */
    if (!String.prototype.includes) {
      String.prototype.includes = function (search, start) {
        'use strict';
        if (!angular.isNumber(start)) {
          start = 0;
        }

        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      };
    }

    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
      };
    }

    if (!angular.isFunction(Object.assign)) {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, 'assign', {
        value: function assign(target) {
          // .length of function is 2
          'use strict';
          if (angular.isUndefined(target) || target === null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
          }

          var to = Object(target);

          for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (angular.isDefined(nextSource) && nextSource !== null) {
              // Skip over if undefined or null
              for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
          return to;
        },
        writable: true,
        configurable: true
      });
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.includes) {
      Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {
          // 1. Let O be ? ToObject(this value).
          //noinspection EqualityComparisonWithCoercionJS
          if (this == null) {
            throw new TypeError('"this" is null or not defined');
          }

          var o = Object(this);

          // 2. Let len be ? ToLength(? Get(O, "length")).
          var len = o.length >>> 0;

          // 3. If len is 0, return false.
          if (len === 0) {
            return false;
          }

          // 4. Let n be ? ToInteger(fromIndex).
          //    (If fromIndex is undefined, this step produces the value 0.)
          var n = fromIndex | 0;

          // 5. If n ≥ 0, then
          //  a. Let k be n.
          // 6. Else n < 0,
          //  a. Let k be len + n.
          //  b. If k < 0, let k be 0.
          var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

          // 7. Repeat, while k < len
          while (k < len) {
            // a. Let elementK be the result of ? Get(O, ! ToString(k)).
            // b. If SameValueZero(searchElement, elementK) is true, return true.
            // c. Increase k by 1.
            // NOTE: === provides the correct "SameValueZero" comparison needed here.
            if (o[k] === searchElement) {
              return true;
            }
            k++;
          }

          // 8. Return false
          return false;
        }
      });
    }

    // https://stackoverflow.com/a/6491621/5658459
    if (!angular.isFunction(Object.getByString)) {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, 'getByString', {
        value: function (o, s) {
          s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
          s = s.replace(/^\./, ''); // strip a leading dot
          var a = s.split('.');
          for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
              o = o[k];
            } else {
              return '';
            }
          }
          return o ? o : '';
        },
        writable: false,
        configurable: false
      });
    }

    // https://stackoverflow.com/a/1584377/5658459
    if (!angular.isFunction(Object.unique)) {
      Object.defineProperty(Array.prototype, 'unique', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function () {
          var target = [],
            source = this.concat();
          for (var index = 0; index < source.length; index++) {
            if (index === 0 || !target.includes(source[index])) {
              target.push(source[index]);
            }
          }
          return target;
        }
      });
    }

    Math.trunc =
      Math.trunc ||
      function (x) {
        if (isNaN(x)) {
          return NaN;
        }
        if (x > 0) {
          return Math.floor(x);
        }
        return Math.ceil(x);
      };

    $log.info('-------------------------------------');
  }

  /* --------------------------------------------=[ UI SELECT Overrides ]=------------------------------------------- */
  angular
    .module('ui.select')
    .config(ConfigUISelect)
    .run(RunUISelect);

  /** @ngInject */
  function ConfigUISelect($provide) {
    $provide.decorator('uiSelectDirective', function ($delegate) {
      var directive = $delegate[0];
      var directiveCompile = directive.compile;

      directive.compile = function () {
        var link = directiveCompile.apply(this, arguments);
        return function (scope, elem, attrs, ctrls) {
          link.apply(this, arguments);

          var $select = ctrls[0];

          $select.selectGroup = function (items) {
            angular.forEach(items, function (item) {
              $select.select(item, $select.skipFocusser);
            });
          };
        };
      };

      return $delegate;
    });
  }

  /** @ngInject */
  function RunUISelect($templateCache) {
    $templateCache.put(
      'bootstrap/choices.tpl.html',
      '<ul class="ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu" ng-show="$select.open && $select.items.length > 0">' +
      '  <li class="ui-select-choices-group" id="ui-select-choices-{{ $select.generatedId }}">' +
      '    <div class="divider" ng-show="$select.isGrouped && $index > 0"></div>' +
      '    <div ng-show="$select.isGrouped" class="ui-select-choices-group-label dropdown-header" ng-bind="$group.name" ng-click="$select.selectGroup($group.items)"></div>' +
      '    <div ng-attr-id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}" role="option">' +
      '      <span class="ui-select-choices-row-inner"></span>' +
      '    </div>' +
      '  </li>' +
      '</ul>'
    );

    $templateCache.put(
      'bootstrap/match.tpl.html',
      '<div class="ui-select-match" ng-hide="$select.open && $select.searchEnabled" ng-disabled="$select.disabled" ng-class="{\'btn-default-focus\':$select.focus}">' +
      '  <span tabindex="-1" class="btn btn-default form-control ui-select-toggle" aria-label="{{ $select.baseTitle }} activate" ng-disabled="$select.disabled" ng-click="$select.activate()" style="outline: 0;">' +
      '    <span ng-show="$select.isEmpty()" class="ui-select-placeholder text-muted">' +
      '      {{$select.placeholder}}' +
      '    </span> ' +
      '    <span ng-hide="$select.isEmpty()" class="ui-select-match-text pull-left" ng-class="{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}" ng-transclude=""></span> ' +
      '    <i class="caret pull-right" ng-click="$select.toggle($event)"></i> ' +
      '    <a ng-show="$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)" aria-label="{{ $select.baseTitle }} clear" style="margin-right: 10px" ng-click="$select.clear($event)" class="btn btn-xs btn-link pull-right">' +
      '      <i class="fa fa-remove" aria-hidden="true"></i>' +
      '    </a>' +
      '  </span>' +
      '</div>'
    );
  }

  /* -------------------------------------------=[ Mwl Calendar Overrides ]=----------------------------------------- */
  angular.module('mwl.calendar').config(ConfigMwlCalendar);

  /** @ngInject */
  function ConfigMwlCalendar($provide) {
    $provide.decorator('calendarTitle', function ($delegate, CONSTANTS, moment) {
      $delegate.week = function (viewDate) {
        return !CONSTANTS.configClient.citya ? 'Semaine ' + moment(viewDate).isoWeek() : '';
      };
      return $delegate;
    });
  }

  /* ------------------------------------------=[ Angular Input Directive ]=----------------------------------------- */
  /* angular.module('ng').config(inputDirectiveDecorator);

  /** @ngInject */
  /* function inputDirectiveDecorator($provide) {
    $provide.decorator('inputDirective', function($delegate) {
      var directive, link;
      directive = $delegate[0];
      link = directive.link.pre;
      directive.compile = function() {
        return function Link(scope, element) {
          if (element.hasClass('ng-invalid')) {
            element.parent().addClass('has-error');
          }
          scope.$watch(
            function() {
              return element.hasClass('ng-invalid');
            },
            function(newVal, oldVal) {
              if (newVal !== oldVal) {
                if (newVal) element.parent().addClass('has-error');
                else element.parent().removeClass('has-error');
              }
            }
          );
          return link.apply(this, arguments);
        };
      };
      return $delegate;
    });
  } */
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.type('RechercheParam', {
      name: 'RechercheParam',
      decode: function (val) {
        return angular.isString(val) ? angular.fromJson(val) : val;
      },
      encode: function (val) {
        return angular.toJson(val);
      },
      equals: function (a, b) {
        return this.is(a) && this.is(b) && angular.equals(a, b);
      },
      is: function (val) {
        return angular.isObject(val) && (angular.isDefined(val.recherche) || angular.isDefined(val.search));
      }
    });

    $stateProvider
      .state('admin', {
        url: '/admin'
      })

      .state('login', {
        url: '/Login?typeApplication',
        template: '<login class="flex-item flex-container"></login>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Connexion'
        },
        params: {
          prevState: false,
          errLocalStorage: {
            type: 'bool',
            value: false
          },
          connexionTimedOut: {
            type: 'bool',
            value: false
          }
        },
        autorized: true
      })

      .state('logout', {
        url: '/Logout',
        controller: function (LoginService) {
          LoginService.logout();
        },
        controllerAs: 'lougoutctrl',
        meta: {
          title: 'Connexion'
        },
        autorized: true
      })

      .state('accueil', {
        url: '/?typeApplication',
        template: '<accueil class="flex-item flex-container"></accueil>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        ncyBreadcrumb: {
          label: "Page d'accueil"
        }
      })

      .state('listeBien', {
        url: '/liste-bien?{recherche: RechercheParam}&typeApplication',
        template: '<liste-bien class="flex-item flex-container"></liste-bien>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Liste des biens'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Liste des biens'
        }
      })

      .state('gestionStock', {
        url: '/gestion-du-stock?{recherche: RechercheParam}&typeApplication',
        params: {
          type: 'stock'
        },
        template: '<liste-bien class="flex-item flex-container"></liste-bien>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Gestion du stock'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Gestion du stock'
        }
      })

      .state('modifBien', {
        url: '/saisie-bien?reference&etape&nom&prenom&dateNaissance&cp&email&tel&typeApplication',
        template: '<modif-bien class="flex-item flex-container"></modif-bien>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Modifier le bien'
        },
        ncyBreadcrumb: {
          parent: 'listeBien',
          label: 'Modifier un bien'
        }
      })

      .state('listeProspects', {
        url: '/liste-prospects?{recherche: RechercheParam}&rapprocher&typeApplication',
        template: '<liste-prospects class="flex-item flex-container"></liste-prospects>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Liste des prospects'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Liste des prospects'
        }
      })

      .state('modifProspect', {
        url: '/saisie-prospect?reference&etape&nom&prenom&dateNaissance&cp&email&tel&typeApplication',
        template: '<modif-prospect class="flex-item flex-container"></modif-prospect>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Modifier le Prospect'
        },
        ncyBreadcrumb: {
          parent: 'listeProspects',
          label: 'Modifier un prospect'
        }
      })

      .state('calendrier', {
        url: '/calendrier?typeApplication',
        template: '<tgn-calendar class="flex-item flex-container"></tgn-calendar>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Calendrier'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Calendrier'
        }
      })

      .state('repertoire', {
        url: '/repertoire?typeApplication',
        template: '<repertoire class="flex-item flex-container"></repertoire>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Répertoire'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Répertoire'
        }
      })

      .state('contrat', {
        url: '/contrat?type&typeApplication',
        templateProvider: function ($stateParams, $state, $rootScope, $log) {
          $rootScope.typeContrat = $stateParams.type;
          switch ($stateParams.type) {
            case 'compromis':
            case 'vente':
              return '<compromis class="flex-item flex-container"></compromis>';
            case 'reservation':
            case 'location':
              return '<reservations class="flex-item flex-container"></reservations>';
            default:
              $log.error("Le type de contrat n'a pas été renseigné. Impossible d'afficher la page souhaitée.");
              $state.go('accueil');
              break;
          }
        },
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
          if (
            globalService.getTypeApplication() === 'Location' &&
            ($stateParams.type === 'compromis' || $stateParams.type === 'vente')
          ) {
            globalService.setTypeApplication('Transaction', true, false);
          } else if (
            globalService.getTypeApplication() === 'Transaction' &&
            ($stateParams.type === 'reservation' || $stateParams.type === 'location')
          ) {
            globalService.setTypeApplication('Location', true, false);
          }
        },
        meta: {
          title: 'Contrats'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: '{{$root.typeContrat.charAt(0).toUpperCase() + $root.typeContrat.slice(1)}}{{$root.typeContrat !== "compromis" ? "s" : ""}}'
        }
      })

      .state('modifCompromis', {
        url: '/saisie-compromis?reference&typeApplication',
        template: '<modif-compromis class="flex-item flex-container"></modif-compromis>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Modifier le Compromis'
        },
        ncyBreadcrumb: {
          parent: function ($scope) {
            return $scope.$root.typeContrat ?
              'contrat({type:"' + $scope.$root.typeContrat + '"})' :
              'contrat({type:"compromis"})';
          },
          label: 'Saisie {{$root.typeContrat === "compromis" ? "du" : "de la"}} {{$root.typeContrat}}'
        }
      })

      .state('modifReservation', {
        url: '/saisie-reservation?reference&typeApplication',
        template: '<modif-reservation class="flex-item flex-container"></modif-reservation>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Modifier la Reservation'
        },
        ncyBreadcrumb: {
          parent: function ($scope) {
            return $scope.$root.typeContrat ?
              'contrat({type:"' + $scope.$root.typeContrat + '"})' :
              'contrat({type:"reservation"})';
          },
          label: 'Saisie de la {{$root.typeContrat}}'
        }
      })

      .state('parutionsIcsBox', {
        url: '/parutions-ics-box?{recherche: RechercheParam}&typeApplication',
        template: '<parutions-ics-box class="flex-item flex-container"></parutions-ics-box>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Parutions ICS Box'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Parutions ICS Box'
        }
      })
      .state('statistique', {
        url: '/statistique?typeApplication',
        template: '<statistique class="flex-item flex-container"></statistique>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Statistique'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Statistique'
        }
      })
      .state('panneaux', {
        url: '/gestion-des-panneaux?{recherche: RechercheParam}&typeApplication',
        template: '<panneaux class="flex-item flex-container"></panneaux>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Gestion des panneaux'
        },
        ncyBreadcrumb: {
          parent: 'accueil',
          label: 'Gestion des panneaux'
        }
      })

      .state('installation', {
        url: '/installation?typeApplication',
        template: '<installation class="flex-item flex-container"></installation>',
        onEnter: function (globalService, $stateParams) {
          if ($stateParams.typeApplication) {
            globalService.setTypeApplication($stateParams.typeApplication, false, false);
          }
        },
        meta: {
          title: 'Nouveau Client'
        },
        autorized: true
      });

    $urlRouterProvider.otherwise('/');
  }
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').constant('CONSTANTS', {
    configClient: {"debug":true,"Transaction":{"server":"https://luke.ics.fr","context":"TransacNetUnik","images":null},"Location":{"server":"https://luke.ics.fr","context":"TransacNetUnik","images":""},"citya":false}.hasOwnProperty('citya') ?
      {"debug":true,"Transaction":{"server":"https://luke.ics.fr","context":"TransacNetUnik","images":null},"Location":{"server":"https://luke.ics.fr","context":"TransacNetUnik","images":""},"citya":false} : {
        debug: true,
        /* --------------------=[ PROD UNIK ]=-------------------- */
        /* Transaction: {
          server: 'https://luke.ics.fr',
          context: 'TransacNetUnik',
          images: null
        },
        Location: {
          server: 'https://luke.ics.fr',
          context: 'TransacNetUnik',
          images: null
        },
        citya: false */
        /* --------------------=[ LOCAL VINCENT ]=-------------------- */
        Transaction: {
          server: 'http://10.20.1.88:8080',
          context: 'TransacNet1722',
          images: 'http://10.20.1.82:8080/Transaction1722/multimedia/'
        },
        Location: {
          server: 'http://10.20.1.88:8080',
          context: 'TransacNet1722',
          images: 'http://10.20.1.82:8080/Transaction1722/multimedia/'
        },
        citya: false,
        prod: false
        /* --------------------=[ LOCAL JULIEN ]=-------------------- */
        /*
        Transaction: {
          server: 'http://10.20.1.228:8080',
          context: 'TransacNet1722',
          images: null
        },
        Location: {
          server: 'http://10.20.1.228:8080',
          context: 'TransacNet1722',
          images: ''
        },
        citya: true*/
        /* --------------------=[ LOCAL HUGO ]=-------------------- */
        /* Transaction: {
          server: 'http://localhost:8082',
          context: 'TransacNet1722',
          images: null
        },
        Location: {
          server: 'http://localhost:8080',
          context: 'TransacNet1722',
          images: ''
        },
        citya: false */
        /* --------------------=[ CITYA TEST ]=-------------------- */
        /* Transaction: {
          server: 'http://srv-testics:8080',
          context: 'TransactionCityaTest',
          images: 'http://transacnet:8082/TransactionCitya/multimedia/'
        },
        Location: {
          server: 'http://srv-testics:8080',
          context: 'TransactionCityaLocTest',
          images: 'http://geslocnet:8080/TransactionCityaLocation/multimedia/'
        },
        citya: true */
        /* --------------------=[ CITYA PROD ]=-------------------- */
        /* Transaction: {
          server: 'http://transacnet:8082',
          context: 'TransactionCitya',
          images: 'http://transacnet:8082/TransactionCitya/multimedia/'
        },
        Location: {
          server: 'http://geslocnet:8080',
          context: 'TransactionCityaLocation',
          images: 'http://geslocnet:8080/TransactionCityaLocation/multimedia/'
        },
        citya: true */
      },
    date_format: 'DD/MM/YYYY HH[h]mm',
    short_date_format: 'DD/MM/YYYY',
    meta: {
      Transaction: {
        meta_title: "TransacNet - Logiciel de TRANSACTIONS pour les professionnels de l'immobilier. Développé par www.ics.fr"
      },
      Location: {
        meta_title: "LocNet - Logiciel de LOCATIONS pour les professionnels de l'immobilier. Développé www.ics.fr"
      }
    },
    encoding: {
      passphrase: 'TraGesNet'
    },
    dictionnaire: {
      FR: {
        listebien: {
          tri: {
            triPrix: 'Prix',
            triTypeBien: 'Type de bien',
            triSurface: 'Surface',
            triPiece: 'Nombre de pièces',
            triCP: 'Code postal',
            triDate: 'Ancienneté',
            triExclu: 'Exclusivité',
            triNego: 'Négociateur',
            triLocationEtat: 'Etat',
            triQualification: 'Qualification'
          }
        },
        prospects: {
          tri: {
            triPrix: 'Prix max',
            triDate: 'Ancienneté',
            triNom: 'Nom',
            triQualification: 'Qualification'
          }
        },
        compromis: {
          tri: {
            triDate: 'Ancienneté'
          }
        },
        reservations: {
          tri: {
            triDate: 'Ancienneté'
          }
        }
      },
      EN: {
        listebien: {
          tri: {
            triPrix: 'Price',
            triTypeBien: 'Type of property',
            triSurface: 'Area',
            triPiece: 'Nomber of rooms',
            triCP: 'Postal code',
            triDate: 'Publication date',
            triExclu: 'Exclusivity',
            triNego: 'Negotiator',
            triQualification: 'Qualification'
          }
        },
        prospects: {
          tri: {
            triPrix: 'Max Price',
            triDate: 'Publication date',
            triNom: 'Name',
            triQualification: 'Qualification'
          }
        },
        compromis: {
          tri: {
            triDate: 'Publication date'
          }
        },
        reservations: {
          tri: {
            triDate: 'Publication date'
          }
        }
      }
    },
    typesPerso: {
      Transaction: [{
          value: null,
          name: 'Tous'
        },
        {
          value: 'proprio',
          name: 'Vendeur'
        },
        {
          value: 'prospect',
          name: 'Acheteur'
        },
        {
          value: 'nego',
          name: 'Employé'
        },
        {
          value: 'negoext',
          name: 'Employé ext.'
        },
        {
          value: 'notaire',
          name: 'Notaire'
        }
      ],
      Location: [{
          value: null,
          name: 'Tous'
        },
        {
          value: 'locataire',
          name: 'Locataire'
        },
        {
          value: 'bailleur',
          name: 'Bailleur'
        },
        {
          value: 'nego',
          name: 'Employé'
        },
        {
          value: 'negoext',
          name: 'Employé ext.'
        },
        {
          value: 'caution',
          name: 'Caution'
        }
      ]
    }
  });
})();

(function () {
  'use strict';

  angular.module('transacGeslocNet').config(config);

  /** @ngInject */
  function config(
    CONSTANTS,
    $logProvider,
    $locationProvider,
    localStorageServiceProvider,
    $httpProvider,
    $breadcrumbProvider,
    uiGmapGoogleMapApiProvider,
    toastrConfig,
    uiSelectConfig,
    hotkeysProvider,
    calendarConfig,
    $touchProvider,
    $uibTooltipProvider,
    IdleProvider
  ) {
    // Enable log
    $logProvider.debugEnabled(CONSTANTS.configClient.debug);

    // Enable HTML5 Mode
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
      rewriteLinks: true
    });

    // configure Idle settings
    IdleProvider.idle(3595); // 00:59:55
    IdleProvider.timeout(5); // 00:00:05
    /* IdleProvider.idle(5);
    IdleProvider.timeout(5); */

    hotkeysProvider.cheatSheetHotkey = 'f1';
    hotkeysProvider.cheatSheetDescription = 'Afficher / masquer la liste des raccourcis';
    hotkeysProvider.templateHeader = '<h4 class="text-center text-uppercase"><strong>Raccourcis clavier</strong></h4>';
    hotkeysProvider.template =
      '<div class="cfp-hotkeys-container fade" ng-class="{in: helpVisible}" style="display: none;">' +
      '  <div class="cfp-hotkeys">' +
      '    <h4 class="cfp-hotkeys-title" ng-if="!header">{{ title }}</h4>' +
      '    <div ng-bind-html="header" ng-if="header"></div>' +
      '    <table>' +
      '      <tbody>' +
      '        <tr ng-repeat="hotkey in hotkeys | filter:{ description: \'!$$undefined$$\' }">' +
      '          <td class="cfp-hotkeys-keys">' +
      '            <div ng-repeat="key in hotkey.format() track by $index">' +
      '              <span ng-repeat="key in hotkey.format() track by $index"> <kbd>{{ key }}</kbd> <span ng-if="!$last">+</span></span>' +
      '            </div>' +
      '          </td>' +
      '          <td class="cfp-hotkeys-text">{{ hotkey.description }}</td>' +
      '        </tr>' +
      '      </tbody>' +
      '    </table>' +
      '    <div ng-bind-html="footer" ng-if="footer"></div>' +
      '    <div class="cfp-hotkeys-close" ng-click="toggleCheatSheet()">&#215;</div>' +
      '  </div>' +
      '</div>';

    // Config localStorage service
    localStorageServiceProvider.setPrefix('TGN');

    // Config $http requests (Ajax call)
    $httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push(function ($rootScope) {
      return {
        request: function (request) {
          request.url = request.url.replace(/http(s)?\:\%2F\%2F/, 'http$1://');
          return request;
        },
        response: function (response) {
          if (angular.isObject(response.data)) {
            if (response.data.hasOwnProperty('SessionExpiredException')) {
              response.data.status = 'SESSION_EXPIRED';
              $rootScope.$broadcast('BACK_TO_LOGIN', {
                prevState: $rootScope.currentState ? $rootScope.currentState : false
              });
            } else {
              var keys = Object.keys(response.data).filter(function (key) {
                return key.includes('Exception');
              });
              if (angular.isArray(keys) && keys.length) {
                response.data.status = keys[0].replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
                response.data.message = response.data[keys[0]].message ? response.data[keys[0]].message : false;
              } else if (angular.isArray(response.data)) {
                var res = response.data;
                response.data = {
                  status: 'OK',
                  list: res
                };
              } else {
                response.data.status = response.data.status || 'OK';
              }
            }
          }
          return response;
        }
      };
    });

    // Config breaccrumb
    $breadcrumbProvider.setOptions({
      template: '<div class="custom-breadcrumb hidden-xs">' +
        '  <span ng-repeat="step in steps track by $index">' +
        '    &nbsp;<i ng-if="::(!$first)" class="fa fa-caret-right"></i>&nbsp;' +
        '    <a ng-if="::(!$last)" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
        '    <span ng-if="::$last" class="active">{{step.ncyBreadcrumbLabel}}</span>' +
        '  </span>' +
        '</div>'
    });

    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyBB77f4EZdh7ga5RGnDkpc95FOfxUA3r0Y',
      v: '3',
      language: 'fr'
    });

    angular.extend(toastrConfig, {
      allowHtml: true,
      extendedTimeOut: 1500,
      messageClass: 'toast-message',
      progressBar: true,
      tapToDismiss: true,
      timeOut: 5000,
      newestOnTop: true,
      positionClass: 'toast-bottom-left'
    });

    uiSelectConfig.theme = 'bootstrap';
    uiSelectConfig.removeSelected = false;

    // Mwl Calendar
    calendarConfig.dateFormatter = 'moment';
    calendarConfig.allDateFormats.moment.date.hour = 'HH:mm';
    calendarConfig.i18nStrings.weekNumber = 'Semaine {week}';
    calendarConfig.showTimesOnWeekView = true;

    // For better mobile compatibility of mwl.calendar
    $touchProvider.ngClickOverrideEnabled(true);

    // Disabling UIBootstrap tooltips on touch devices
    var parser = new UAParser();
    var result = parser.getResult();

    var touch = result.device && (result.device.type === 'tablet' || result.device.type === 'mobile');
    if (touch) {
      $uibTooltipProvider.options({
        trigger: 'dontTrigger'
      });
    } else {
      $uibTooltipProvider.options({
        trigger: 'mouseenter'
      });
    }
  }
})();

angular.module("transacGeslocNet").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/header/header.html","<div class=custom-header ng-class=\"headerctrl.globalService.getTypeApplication() + (headerctrl.citya ? \' citya\' : \'\')\" ng-if=headerctrl.logged><!-- Menu --><div class=header-menu ng-if=!headerctrl.menu.forced><button type=button class=menu-btn ng-click=headerctrl.menu.toggle()><i class=\"fa fa-lg fa-bars\"></i></button><div class=menu-container ng-if=headerctrl.menu.open><ul class=\"menu-list list-unstyled\" role=menu><li ng-repeat=\"link in headerctrl.menu.current\" class=menu-link-container><a class=menu-link aria-label={{::link.nom}} ng-click=::link.onClick() ng-class=\"{\'active\': link.active}\"><i class=\"fa fa-2r {{::link.icon}}\"></i> {{::link.nom}}</a></li></ul><div class=ics-powered><ul class=list-unstyled><li>Copyright &copy; TRANSAC.NET</li><li><span>Designed by</span> <a href=http://ics.fr/ class=logo-ics target=_blank><!--suppress HtmlUnknownTarget, HtmlUnknownTarget, HtmlUnknownTarget --> <img src=assets/images/logo_ics.png class=img-responsive></a></li></ul></div></div></div><div class=\"header-menu forced\" ng-if=headerctrl.menu.forced><div class=menu-container><ul class=\"menu-list list-unstyled\" role=menu><li ng-repeat=\"link in headerctrl.menu.current\" class=menu-link-container><a class=menu-link aria-label={{link.nom}} ng-click=link.onClick() ng-class=\"{\'active\': link.active}\"><i class=\"fa fa-2x {{link.icon}}\"></i> <span class=link-label ng-bind=link.nom></span></a></li></ul><div class=ics-powered><ul class=list-unstyled><li class=copyright>Copyright &copy; TRANSAC.NET</li><li><span class=designed-by>Designed by</span> <a href=http://ics.fr/ class=logo-ics target=_blank><!--suppress HtmlUnknownTarget, HtmlUnknownTarget, HtmlUnknownTarget --> <img src=assets/images/logo_ics.png class=img-responsive></a></li></ul></div></div></div><!-- /Menu --><div class=\"header-toolbar flex-container-column\"><h1 class=\"header-app-title flex-item text-center\" ng-if=!headerctrl.citya><span class=hidden-xs ng-if=\"headerctrl.globalService.getTypeApplication() === \'Transaction\'\">TRANSAC.NET</span> <span class=visible-xs ng-if=\"headerctrl.globalService.getTypeApplication() === \'Transaction\'\">T.NET</span> <span class=hidden-xs ng-if=\"headerctrl.globalService.getTypeApplication() === \'Location\'\">LOC.NET</span> <span class=visible-xs ng-if=\"headerctrl.globalService.getTypeApplication() === \'Location\'\">L.NET</span></h1><div class=\"header-breadcrumb flex-item\" ng-if=headerctrl.citya><div ncy-breadcrumb></div></div><div class=e-tutoriel ng-if=false><div class=btn-group ng-click=::headerctrl.report.toggle()><div class=dropdown><i class=\"fa fa-fw fa-bug\"></i> <span class=\"e-tutoriel-label hidden-xs\">Report</span></div></div></div><div class=e-tutoriel ng-if=!headerctrl.citya><div class=btn-group ng-click=::headerctrl.tutoriels.open()><div class=dropdown><i class=\"fa fa-fw fa-question-circle-o\"></i> <span class=\"e-tutoriel-label hidden-xs\">E-Tutoriel</span></div></div></div><div class=panier-prospect><div class=btn-group ng-click=::headerctrl.panier.toggle()><div class=dropdown><i class=\"fa fa-fw fa-shopping-cart fa-badged\"><span class=\"fa-badge badge-opposed panier-nb\" ng-if=headerctrl.panier.nb>{{headerctrl.panier.nb}}</span> </i><span class=\"panier-nom hidden-xs\" ng-if=headerctrl.panier.prospect.perso.nomComplet>{{headerctrl.panier.prospect.perso.nomComplet}}</span> <span class=\"panier-nom hidden-xs\" ng-if=!headerctrl.panier.prospect.perso.nomComplet>Choisir prospect</span></div></div></div><div class=favoris><div class=btn-group ng-click=::headerctrl.favoris.toggle()><span class=dropdown><i class=\"fa fa-fw fa-badged\" ng-class=\"{\r\n               \'fa-heart\': !headerctrl.favoris.coupCoeurAgence,\r\n               \'fa-bell-o\': headerctrl.favoris.coupCoeurAgence\r\n             }\"><span class=\"fa-badge badge-opposed favoris-nb\" ng-if=headerctrl.favoris.nb>{{headerctrl.favoris.nb}}</span> </i><span class=\"favoris-label hidden-xs\" ng-if=headerctrl.favoris.coupCoeurAgence>Biens urgent</span> <span class=\"favoris-label hidden-xs\" ng-if=!headerctrl.favoris.coupCoeurAgence>Coups de coeur</span></span></div></div><div class=selection-rapide><div class=btn-group ng-click=::headerctrl.selection.toggle()><div class=dropdown><i class=\"fa fa-fw fa-check-square-o fa-badged\"><span class=\"fa-badge badge-opposed selection-nb\" ng-if=headerctrl.selection.nb>{{headerctrl.selection.nb}}</span> </i><span class=\"selection-label hidden-xs\">S&eacute;lection</span></div></div></div><div class=user-infos ng-if=!headerctrl.citya><div class=btn-group uib-dropdown ng-if=headerctrl.employe><span class=dropdown uib-dropdown-toggle><i class=\"fa fa-fw fa-user\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><div class=user-image style=\"background: url(\'{{ headerctrl.employe.photoMini }}\') center no-repeat; background-size: cover\"></div></li><li role=menuitem class=custom-block><div class=\"col-xs-12 text-center\"><span class=user-name>{{::headerctrl.employe.perso.prenom}} {{::headerctrl.employe.perso.nom}}</span></div></li><li role=menuitem class=custom-block><div class=\"col-xs-12 text-center\"><span class=user-societe>{{::headerctrl.employe.societe.nom}}</span></div></li><li class=divider></li><li role=menuitem class=custom-block ng-if=\"::(headerctrl.employe.transaction && headerctrl.employe.location)\"><div class=\"col-xs-12 text-center\"><span class=user-app-label>Application</span></div></li><li role=menuitem class=custom-block ng-if=\"::(headerctrl.employe.transaction && headerctrl.employe.location)\"><div class=\"user-app-value col-xs-12\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': headerctrl.transac === \'Transaction\'}\" ng-model=headerctrl.transac uib-btn-radio=\"\'Transaction\'\" ng-click=\"::headerctrl.globalService.setTypeApplication(\'Transaction\', true, false)\">Transac.Net</button></div><div class=\"user-app-value col-xs-12\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': headerctrl.transac === \'Location\'}\" ng-model=headerctrl.transac uib-btn-radio=\"\'Location\'\" ng-click=\"::headerctrl.globalService.setTypeApplication(\'Location\', true, false)\">Gesloc.Net</button></div></li><li class=divider ng-if=\"::(headerctrl.employe.transaction && headerctrl.employe.location)\"></li><li ng-if=headerctrl.parametrage.active role=menuitem class=\"custom-block param-btn\"><a ng-href={{::headerctrl.parametrage.url}} class=\"btn-custom btn-custom-block btn-secondary\"><i class=\"fa fa-fw fa-cogs\"></i> Param&eacute;trage</a></li><li class=divider ng-if=headerctrl.parametrage.active></li><li role=menuitem class=logout-btn><a ui-sref=logout class=\"btn-custom btn-custom-block btn-danger\"><i class=\"fa fa-fw fa-power-off\"></i> D&eacute;connexion</a></li></ul></div></div></div></div><div class=fiche-container ng-if=\"headerctrl.fiches.open || headerctrl.panier.open || headerctrl.favoris.open || headerctrl.selection.open || headerctrl.report.open\"><div ng-switch=headerctrl.fiches.type ng-if=headerctrl.fiches.visible style=\"height: 100%; width: 100%\"><div ng-switch-when=ficheBien style=\"height: 100%; width: 100%\"><fiche-bien ng-if=headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide() on-change-fiche=headerctrl.fiches.change(target)></fiche-bien><fiche-bien ng-if=!headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide()></fiche-bien></div><div ng-switch-when=ficheProspect style=\"height: 100%; width: 100%\"><fiche-prospect ng-if=headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide() on-change-fiche=headerctrl.fiches.change(target)></fiche-prospect><fiche-prospect ng-if=!headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide()></fiche-prospect></div><div ng-switch-when=ficheCompromis style=\"height: 100%; width: 100%\"><fiche-compromis ng-if=headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide() on-change-fiche=headerctrl.fiches.change(target)></fiche-compromis><fiche-compromis ng-if=!headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide()></fiche-compromis></div><div ng-switch-when=ficheReservation style=\"height: 100%; width: 100%\"><fiche-reservation ng-if=headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide() on-change-fiche=headerctrl.fiches.change(target)></fiche-reservation><fiche-reservation ng-if=!headerctrl.fiches.list.length ref=headerctrl.fiches.ref on-click-back=::headerctrl.fiches.hide()></fiche-reservation></div></div><panier ng-if=headerctrl.panier.visible current-prospect=headerctrl.panier.prospect on-chose-prospect=headerctrl.panier.onChoseProspect(prospect) on-remove-panier=::headerctrl.panier.onRemove() on-panier-change=headerctrl.panier.onChange(nb) on-click-back=::headerctrl.panier.hide()></panier><favoris ng-if=headerctrl.favoris.visible on-favoris-change=headerctrl.favoris.onChange(nb) on-click-back=::headerctrl.favoris.hide()></favoris><selection ng-if=headerctrl.selection.visible on-selection-change=headerctrl.selection.onChange(refList) on-click-back=::headerctrl.selection.hide()></selection><report ng-if=headerctrl.report.visible on-click-back=::headerctrl.report.hide()></report></div>");
$templateCache.put("app/components/bandeau-stella/bandeau-stella.html","<div class=bandeau-stella-container><!-- <iframe id=\"bandeau-stella\" frameborder=\"0\" scrolling=\"no\" marginheight=\"0\" marginwidth=\"0\" ng-src=\"{{bandeaustellactrl.trustSRC(bandeaustellactrl.src)}}\">\r\n  </iframe> --><div class=\"bs-toolbar text-center flex-container-column\"><div class=\"bs-app-logo flex-item\"><img class=app-logo ng-src={{bandeaustellactrl.logo.current}}></div><div class=bs-apps><div class=btn-group><a class=dropdown ng-href={{bandeaustellactrl.stellaApps.url}} uib-tooltip={{bandeaustellactrl.stellaApps.tooltip}} tooltip-placement=\"auto bottom\"><img class=bs-apps-icon ng-src={{bandeaustellactrl.stellaApps.icon}}></a></div></div><div class=bs-sos><div class=btn-group><a class=dropdown ng-href={{bandeaustellactrl.stellaSos.url}} target=_blank uib-tooltip={{bandeaustellactrl.stellaSos.tooltip}} tooltip-placement=\"auto bottom\"><img class=bs-sos-icon ng-src={{bandeaustellactrl.stellaSos.icon}}></a></div></div><div class=bs-parametrage><div class=btn-group><a class=dropdown ng-href={{bandeaustellactrl.parametrage.url}} uib-tooltip={{bandeaustellactrl.parametrage.tooltip}} tooltip-placement=\"auto bottom\"><img class=bs-parametrage-icon ng-src={{bandeaustellactrl.parametrage.icon}}></a></div></div><div class=bs-user-infos ng-if=bandeaustellactrl.employe><div class=btn-group uib-dropdown><a class=dropdown uib-dropdown-toggle><div class=user-image style=\"background: url(\'{{bandeaustellactrl.userImg}}\') center no-repeat; background-size: cover\"></div></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><div class=\"col-xs-12 text-center\"><span class=user-name>{{bandeaustellactrl.employe.perso.prenom}} {{bandeaustellactrl.employe.perso.nom}}</span></div></li><li role=menuitem class=custom-block><div class=\"col-xs-12 text-center\"><span class=user-societe>{{bandeaustellactrl.employe.societe.nom}}</span></div></li></ul></div></div><div class=bs-logout ng-if=bandeaustellactrl.logged><div class=btn-group><a class=dropdown ui-sref={{bandeaustellactrl.logout.url}} uib-tooltip={{bandeaustellactrl.logout.tooltip}} tooltip-placement=\"auto bottom\"><img class=bs-logout-icon ng-src={{bandeaustellactrl.logout.icon}}></a></div></div></div></div>");
$templateCache.put("app/modal/avenant/modal.avenant.html","<div class=dialog-contents><div class=container-fluid><h3 class=\"mav-titre text-center\">Cr&eacute;er un avenant au mandat <button type=button class=\"btn-xs btn-danger pull-right\" ng-click=modalavenantctrl.fermer()><i class=\"fa fa-times\"></i></button></h3><form name=modalAvenantForm ng-submit=modalavenantctrl.valider() class=col-xs-12><div class=row><div class=col-xs-12><div class=form-group><label for=numero class=control-label>Num&eacute;ro Avenant</label><div class=spacer-bottom><input id=numero name=numero type=text class=\"form-control input-sm\" placeholder=Numéro... ng-model=modalavenantctrl.avenant.numero required></div></div></div></div><div class=row><div class=col-xs-12><label class=control-label for=datedeb>D&eacute;but</label><div class=\"input-group spacer-bottom\"><input id=datedeb name=datedeb custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modalavenantctrl.avenant.datedeb required> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modalavenantctrl.datepickers.debut.open = !modalavenantctrl.datepickers.debut.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modalavenantctrl.datepickers.debut.open class=\"event-datepicker row\" ng-click=\"::modalavenantctrl.datepickers.debut.onClose(\'fin\')\"><datetime-picker click-prevent model=modalavenantctrl.avenant.datedeb time-picker=false date-model=modalavenantctrl.avenant.datedeb on-close=\"::modalavenantctrl.datepickers.debut.onClose(\'fin\')\"></datetime-picker></div></div></div><div class=row><div class=col-xs-12><label class=control-label for=datefin>Fin</label><div class=\"input-group spacer-bottom\"><input id=datefin name=datefin custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modalavenantctrl.avenant.datefin required> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modalavenantctrl.datepickers.fin.open = !modalavenantctrl.datepickers.fin.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modalavenantctrl.datepickers.fin.open class=\"event-datepicker row\" ng-click=\"::modalavenantctrl.datepickers.fin.onClose(\'fin\')\"><datetime-picker click-prevent model=modalavenantctrl.avenant.datefin time-picker=false date-model=modalavenantctrl.avenant.datefin on-close=\"::modalavenantctrl.datepickers.fin.onClose(\'fin\')\"></datetime-picker></div></div></div><div class=\"row text-center spacer-bottom\"><button type=button class=\"btn-custom btn-custom-sm btn-danger\" ng-click=modalavenantctrl.annuler()>Annuler</button> <button type=submit class=\"btn-custom btn-custom-sm btn-success\">Confirmer</button></div></form></div></div>");
$templateCache.put("app/modal/check-parutions/modal.check-parutions.html","<div class=modal-check-parutions><div class=modal-header><h3 class=\"modal-title col-xs-12\"><i class=\"fa fa-fw fa-calendar-check-o\"></i> &Eacute;tat des parutions ICSBox</h3></div><div class=modal-body><div lazy-load ng-style=\"{\'max-height\': (modalcheckparutionsctrl.screenHeight - modalcheckparutionsctrl.fixedElemHeight) + \'px\'}\"><div class=col-xs-12><div ng-if=!modalcheckparutionsctrl.loading ng-repeat=\"parution in modalcheckparutionsctrl.parutions\" class=\"media parution\"><div class=media-left><img ng-if=parution.hasImg class=media-object ng-src={{::parution.imgSrc}} alt={{::parution.presta}} title={{::parution.nom}}> <span ng-if=!parution.hasImg class=media-object>{{::parution.presta}}</span></div><div class=media-body><ul class=list-unstyled><li>{{::parution.date}}</li><li>{{::parution.nbaffaire}} affaire{{::(parution.nbaffaire > 1) ? \'s\' : \'\'}} en parution</li></ul></div><div ng-if=!$last class=divider></div></div></div><div class=loader ng-if=modalcheckparutionsctrl.loading></div></div></div><div class=modal-footer><button type=button class=\"btn-custom btn-custom-secondary pull-right spacer-bottom\" ng-click=modalcheckparutionsctrl.fermer()>Fermer</button></div></div>");
$templateCache.put("app/modal/confirm-dialog/confirm-dialog.html","<div class=dialog-contents><div class=container-fluid><h3 class=\"cd-titre text-center\" ng-if=confirmdialogctrl.titre ng-bind-html=confirmdialogctrl.titre></h3><div class=\"cd-message text-center spacer-bottom\" ng-if=confirmdialogctrl.message ng-bind-html=confirmdialogctrl.message></div><form name=confirmDialogForm ng-submit=confirmdialogctrl.valider() novalidate><div class=row ng-if=confirmdialogctrl.commentaire><div class=form-group><label class=control-label for=deleteRaison>Commentaire</label><textarea class=form-control id=deleteRaison name=deleteRaison rows=3 ng-model=confirmdialogctrl.deleteRaison ng-class=\"{\'validation-error\': confirmdialogctrl.hasError}\"></textarea></div></div><div class=\"row text-center\"><button type=button class=\"btn-custom btn-custom-sm btn-danger\" ng-click=confirmdialogctrl.annuler() ng-bind-html=confirmdialogctrl.annulerText></button> <button type=submit class=\"btn-custom btn-custom-sm btn-success\" ng-bind-html=confirmdialogctrl.confirmText></button></div></form></div></div>");
$templateCache.put("app/modal/e-tutoriel/modal.e-tutoriel.html","<div class=\"dialog-contents e-tuto-modal\"><div class=container-fluid><h3 class=\"e-tuto-titre text-center\">E-Tutoriel <button type=button class=\"btn-xs btn-danger pull-right\" ng-click=modaletutorielctrl.fermer()><i class=\"fa fa-times\"></i></button></h3><div class=col-xs-12><div ng-repeat=\"tuto in modaletutorielctrl.tutoriels\" class=\"media tutoriel\"><div class=media-left><a ng-href={{::tuto.url}} target=_blank><img class=media-object ng-src=\"{{::(\'assets/images/\' + tuto.miniature)}}\" alt={{::tuto.label}}></a></div><div class=media-body><h4 class=media-heading>{{::tuto.title}}</h4>{{::tuto.desc}}</div></div></div><button type=button class=\"btn-custom btn-custom-secondary pull-right spacer-bottom\" ng-click=modaletutorielctrl.fermer()>Fermer</button></div></div>");
$templateCache.put("app/modal/form-event/modal.form-event.html","<div class=modal-form-contact><div class=modal-header><h3 class=modal-title><i class=\"fa fa-fw fa-calendar\"></i> &Eacute;v&egrave;nement <button type=button class=\"btn-xs btn-danger pull-right\" ng-click=::modalformeventctrl.fermer()><i class=\"fa fa-times\"></i></button></h3></div><form name=formModifEvent class=form-horizontal ng-submit=::modalformeventctrl.enregistrer() novalidate><div class=modal-body><div class=form-group><label for=dateDebut class=\"col-xs-12 col-sm-3 control-label\">Date d&eacute;but</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input id=dateDebut custom-type=datetime ui-mask=\"99/99/9999 99h99\" class=form-control ng-model=modalformeventctrl.event.date ng-change=::modalformeventctrl.datepickers.setDateFin() required> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modalformeventctrl.datepickers.dateDebut = !modalformeventctrl.datepickers.dateDebut\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modalformeventctrl.datepickers.dateDebut class=\"event-datepicker row\" ng-click=\"modalformeventctrl.datepickers.dateDebut = false\"><datetime-picker click-prevent time-picker=true model=modalformeventctrl.event.date on-close=\"::modalformeventctrl.datepickers.close(\'dateDebut\')\"></datetime-picker></div></div></div><div class=form-group><label for=dateFin class=\"col-xs-12 col-sm-3 control-label\">Date fin</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input id=dateFin custom-type=datetime ui-mask=\"99/99/9999 99h99\" class=form-control ng-model=modalformeventctrl.event.dateFin> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modalformeventctrl.datepickers.dateFin = !modalformeventctrl.datepickers.dateFin\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modalformeventctrl.datepickers.dateFin class=\"event-datepicker row\" ng-click=\"modalformeventctrl.datepickers.dateFin = false\"><datetime-picker click-prevent time-picker=true model=modalformeventctrl.event.dateFin on-close=\"::modalformeventctrl.datepickers.close(\'dateFin\')\"></datetime-picker></div></div></div><div class=form-group ng-if=modalformeventctrl.types.length><label for=type class=\"col-xs-12 col-sm-3 control-label\">Type</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select id=type name=type theme=bootstrap close-on-select=true required ng-model=modalformeventctrl.event.type ng-class=\"{\'validation-error\': formModifEvent.type.$error.required && formModifEvent.$submitted}\"><ui-select-match placeholder=Type...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type in modalformeventctrl.types | filter: $select.search track by type.data\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=form-group><label for=prospect class=\"col-xs-12 col-sm-3 control-label\">Prospect</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select id=prospect name=prospect theme=bootstrap close-on-select=true ng-model=modalformeventctrl.event.prospect><ui-select-match placeholder=Prospect... allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"prospect in modalformeventctrl.prospects.list | filter: $select.search track by prospect.id\" refresh=modalformeventctrl.prospects.search($select.search) refresh-delay=500><div><strong ng-bind-html=\"::prospect.perso.getNomComplet() | highlight: $select.search\"></strong></div><div ng-if=::prospect.perso.getEmail()><small ng-bind-html=\"::prospect.perso.getEmail() | highlight: $select.search\"></small></div><small ng-if=::prospect.comRepertoire title={{::prospect.comRepertoire}}><i class=with-newlines>{{::prospect.comRepertoire}}</i></small></ui-select-choices></ui-select></div></div><div class=form-group><label for=lot class=\"col-xs-12 col-sm-3 control-label\">Lot</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select id=lot name=lot theme=bootstrap close-on-select=true ng-model=modalformeventctrl.event.lot><ui-select-match placeholder=Lot... allow-clear=true>{{$select.selected.getFormatedLibelle()}}</ui-select-match><ui-select-choices repeat=\"lot in modalformeventctrl.lots.list | filter: $select.search track by lot.id\" refresh=modalformeventctrl.lots.search($select.search) refresh-delay=500><div><strong ng-bind-html=\"lot.getFormatedLibelle() | highlight: $select.search\"></strong></div><small><i>{{lot.referenceInterne}}</i></small></ui-select-choices></ui-select></div></div><div class=form-group><label for=negociateur class=\"col-xs-12 col-sm-3 control-label\">N&eacute;go.</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select ng-model=modalformeventctrl.event.negociateur theme=bootstrap close-on-select=true><ui-select-match placeholder=Négo... allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in modalformeventctrl.negos.list | filter: $select.search track by nego.id\" refresh=modalformeventctrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=form-group><label for=commentaire class=\"col-xs-12 col-sm-3 control-label\">Description</label><div class=\"col-xs-12 col-sm-9 col-md-6 col-lg-8 spacer-bottom\"><textarea id=commentaire name=commentaire class=form-control rows=5 ng-model=modalformeventctrl.event.commentaire></textarea></div></div></div><div class=modal-footer><button class=\"btn-custom btn-success\" type=submit><i class=\"fa fa-fw fa-check\"></i> Valider</button> <button ng-if=\"modalformeventctrl.event.type.label === \'visite\' && (!modalformeventctrl.event.hasOwnProperty(\'active\') || modalformeventctrl.event.active)\" class=\"btn-custom btn-warning\" type=button ng-click=modalformeventctrl.annuler()><i class=\"fa fa-fw fa-ban\"></i> Annuler</button> <button ng-if=\"(modalformeventctrl.event.id && modalformeventctrl.event.type.label !== \'visite\') || (modalformeventctrl.event.id && modalformeventctrl.event.type.label === \'visite\' && modalformeventctrl.event.active === false)\" class=\"btn-custom btn-danger\" type=button ng-click=modalformeventctrl.supprimer()><i class=\"fa fa-fw fa-trash-o\"></i> Supprimer</button></div></form></div>");
$templateCache.put("app/modal/formcontact/modal.formcontact.html","<div class=modal-form-contact><div class=modal-header><h3 class=modal-title><i class=\"fa fa-fw fa-envelope-o\"></i> Envoyer un email</h3></div><form name=modalContactForm ng-submit=modalformcontactctrl.envoyer() novalidate><div class=modal-body><div class=\"row input-container\"><div class=\"col-xs-12 form-group\"><div class=input-group><span class=\"input-group-addon border-custom-primary\"><i class=\"fa fa-fw fa-at\"></i></span> <input type=text multiple-emails ng-model=modalformcontactctrl.a class=form-control placeholder=Destinataire(s)... required></div></div><div class=\"col-xs-12 form-group\"><input type=text ng-model=modalformcontactctrl.objet class=form-control placeholder=Objet... required></div><div class=\"col-xs-12 form-group\"><div text-angular ta-toolbar=[] ng-model=modalformcontactctrl.corps class=formcontact-corps></div></div></div><div class=\"row input-container\" ng-class=\"{\'hidden\': !modalformcontactctrl.erreur.hasError}\"><span class=text-danger><i class=\"fa fa-fw fa-exclamation-triangle\" aria-hidden=true></i> {{modalformcontactctrl.erreur.message}}</span></div></div><div class=modal-footer><button class=\"btn-custom btn-custom-primary\" type=submit>Envoyer</button> <button class=\"btn-custom btn-danger\" type=button ng-click=modalformcontactctrl.annuler()>Annuler</button></div></form></div>");
$templateCache.put("app/modal/impression/modal.impression.html","<div class=modal-impression><div class=modal-header><h3 class=\"modal-title col-xs-12 col-sm-4\"><i class=\"fa fa-fw fa-print\"></i> Imprimer</h3><div class=\"col-sm-4 hidden-xs\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': modalimpressionctrl.type.selected === \'DOC\'}\" ng-model=modalimpressionctrl.type.selected uib-btn-radio=\"\'DOC\'\" ng-change=modalimpressionctrl.getModels() ng-if=modalimpressionctrl.type.docActive><i class=\"fa fa-lg fa-file-word-o\"></i> DOC</button></div><div class=\"col-sm-4 hidden-xs\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': modalimpressionctrl.type.selected === \'PDF\'}\" ng-model=modalimpressionctrl.type.selected uib-btn-radio=\"\'PDF\'\" ng-change=modalimpressionctrl.getModels()><i class=\"fa fa-lg fa-file-pdf-o\"></i> PDF</button></div></div><div class=modal-body><div class=models-container lazy-load ng-style=\"{\'max-height\': (modalimpressionctrl.screenHeight - modalimpressionctrl.fixedElemHeight) + \'px\'}\"><tree-view fichiers=modalimpressionctrl.fichiers on-select-fichier=modalimpressionctrl.onToggleFile(fichier) is-first=true ng-if=!modalimpressionctrl.loading></tree-view><div class=loader ng-if=modalimpressionctrl.loading></div></div></div><div class=modal-footer><div class=row ng-if=\"modalimpressionctrl.type.selected === \'DOC\' && !modalimpressionctrl.citya\"><div class=\"col-xs-12 text-center flex-container-column-justify-center\"><div class=\"flex-item spacer-right\"><input type=text ng-model=modalimpressionctrl.editFileName class=form-control ng-disabled=modalimpressionctrl.selectedFile placeholder=\"Nouveau modèle\"></div><button type=button class=\"btn-custom btn-custom-primary\" ng-click=modalimpressionctrl.onEditFile()>{{modalimpressionctrl.selectedFile ? \'&Eacute;diter\' : \'Cr&eacute;er\'}}</button></div></div><hr class=separator ng-if=\"modalimpressionctrl.type.selected === \'DOC\' && !modalimpressionctrl.citya\"><div class=row><div class=\"col-xs-12 text-right\"><span class=spool-word ng-if=modalimpressionctrl.type.docActive><a class=spool-word-link target=_blank ng-href={{modalimpressionctrl.urlSpoolWord}}>T&eacute;l&eacute;charger Spool Word</a> </span><button type=button class=\"btn-custom btn-custom-primary\" ng-click=modalimpressionctrl.onPrint() ng-disabled=!modalimpressionctrl.selectedFile>Imprimer</button> <button class=\"btn-custom btn-danger\" type=button ng-click=modalimpressionctrl.onCancel()>Annuler</button></div></div></div></div>");
$templateCache.put("app/modal/repertoire/modal.repertoire.html","<div class=modal-form-contact><div class=modal-header><h3 class=modal-title><i class=\"fa fa-fw fa-users\"></i> R&eacute;pertoire</h3></div><div class=modal-body><form class=\"repertoire-criteres row\" ng-submit=modalrepertoirectrl.getList() name=repertoireForm><div class=\"col-xs-12 col-sm-6 col-lg-3\"><input type=text class=form-control ng-model=modalrepertoirectrl.query.rechercheNom placeholder=Nom pattern={{::modalrepertoirectrl.searchPattern}} title=\"3 caractères minimum\" ng-required=modalrepertoirectrl.nomRequired ng-change=modalrepertoirectrl.setRequired() ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-sm-6 col-lg-3\" ng-if=modalrepertoirectrl.typesPerso.active><ui-select ng-model=modalrepertoirectrl.query.type theme=bootstrap close-on-select=true><ui-select-match placeholder=Type...>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.value as type in modalrepertoirectrl.typesPerso.list | filter: $select.search track by type.value\"><div ng-bind-html=\"::type.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-12 col-sm-6 col-lg-3\"><input type=text class=form-control ng-model=modalrepertoirectrl.query.rechercheContact placeholder=\"Contact (tel, email...)\" pattern={{::modalrepertoirectrl.searchPattern}} title=\"3 caractères minimum\" ng-required=modalrepertoirectrl.contactRequired ng-change=modalrepertoirectrl.setRequired() ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-sm-6 col-lg-3 text-right\"><button type=submit class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-fw fa-search\"></i>Rechercher</button></div></form><hr><ul class=\"repertoire-list list-unstyled\" ng-if=!modalrepertoirectrl.loading><li class=\"perso row\" ng-repeat=\"perso in modalrepertoirectrl.repertoire.list\" ng-if=\"::((perso.hasNom() || perso.hasPrenom()) || perso.getEmail())\" ng-class=\"{\'selected\': perso.selected}\" ng-click=::modalrepertoirectrl.selectPerso(perso)><span class=\"perso-nom col-xs-12 col-sm-7 col-md-8\">{{::perso.getNomComplet()}}</span> <span class=\"perso-email col-xs-12 col-sm-5 col-md-4\" ng-if=::perso.getEmail()>{{::perso.getEmail()}}</span></li></ul><div ng-if=modalrepertoirectrl.loading class=loader></div></div><div class=modal-footer><button class=\"btn-custom btn-custom-primary\" type=button ng-click=modalrepertoirectrl.valider()>Valider</button> <button class=\"btn-custom btn-danger\" type=button ng-click=modalrepertoirectrl.annuler()>Annuler</button></div></div>");
$templateCache.put("app/modal/type-select-dialog/type-select-dialog.html","<div class=dialog-contents><div class=container-fluid><h3 class=\"cd-titre text-center\">Choisir un type de bien</h3><form name=typeDialogForm ng-submit=typeselectdialogctrl.valider() novalidate><div class=row><div class=form-group><ui-select ng-model=typeselectdialogctrl.types.selected theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Type de bien...\" allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.id as type in typeselectdialogctrl.types.list\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"row text-center\"><button type=button class=\"btn-custom btn-danger\" ng-click=typeselectdialogctrl.annuler()>Annuler</button> <button type=submit class=\"btn-custom btn-success\">Valider</button></div></form></div></div>");
$templateCache.put("app/template/timepicker/timepickerics.html","<table class=uib-timepicker><tbody><tr class=text-center ng-show=::showSpinners><td class=\"uib-increment hours\"><a ng-click=incrementHours() ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=noIncrementHours() tabindex=-1><i class=\"fa fa-fw fa-chevron-up\"></i></a></td><td>&nbsp;</td><td class=\"uib-increment minutes\"><a ng-click=incrementMinutes() ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=noIncrementMinutes() tabindex=-1><i class=\"fa fa-fw fa-chevron-up\"></i></a></td><td ng-show=showSeconds>&nbsp;</td><td ng-show=showSeconds class=\"uib-increment seconds\"><a ng-click=incrementSeconds() ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=noIncrementSeconds() tabindex=-1><i class=\"fa fa-fw fa-chevron-up\"></i></a></td><td ng-show=showMeridian></td></tr><tr><td class=\"form-group uib-time hours\" ng-class=\"{\'has-error\': invalidHours}\"><input type=text placeholder=H ng-model=hours ng-change=updateHours() class=\"form-control text-center\" ng-readonly=::readonlyInput maxlength=2 tabindex={{::tabindex}} ng-disabled=noIncrementHours() ng-blur=blur()></td><td class=uib-separator>:</td><td class=\"form-group uib-time minutes\" ng-class=\"{\'has-error\': invalidMinutes}\"><input type=text placeholder=Min ng-model=minutes ng-change=updateMinutes() class=\"form-control text-center\" ng-readonly=::readonlyInput maxlength=2 tabindex={{::tabindex}} ng-disabled=noIncrementMinutes() ng-blur=blur()></td><td ng-show=showSeconds class=uib-separator>:</td><td class=\"form-group uib-time seconds\" ng-class=\"{\'has-error\': invalidSeconds}\" ng-show=showSeconds><input type=text placeholder=SS ng-model=seconds ng-change=updateSeconds() class=\"form-control text-center\" ng-readonly=readonlyInput maxlength=2 tabindex={{::tabindex}} ng-disabled=noIncrementSeconds() ng-blur=blur()></td><td ng-show=showMeridian class=\"uib-time am-pm\"><button type=button ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=toggleMeridian() ng-disabled=noToggleMeridian() tabindex={{::tabindex}}>{{meridian}}</button></td></tr><tr class=text-center ng-show=::showSpinners><td class=\"uib-decrement hours\"><a ng-click=decrementHours() ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=noDecrementHours() tabindex=-1><i class=\"fa fa-fw fa-chevron-down\"></i></a></td><td>&nbsp;</td><td class=\"uib-decrement minutes\"><a ng-click=decrementMinutes() ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=noDecrementMinutes() tabindex=-1><i class=\"fa fa-fw fa-chevron-down\"></i></a></td><td ng-show=showSeconds>&nbsp;</td><td ng-show=showSeconds class=\"uib-decrement seconds\"><a ng-click=decrementSeconds() ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=noDecrementSeconds() tabindex=-1><i class=\"fa fa-fw fa-chevron-down\"></i></a></td><td ng-show=showMeridian></td></tr></tbody></table>");
$templateCache.put("app/template/datepicker/datepickerics.html","<div class=uib-datepicker ng-switch=datepickerMode role=application ng-keydown=keydown($event)><uib-daypicker ng-switch-when=day tabindex=0 template-url=app/template/datepicker/dayics.html></uib-daypicker><uib-monthpicker ng-switch-when=month tabindex=0 template-url=app/template/datepicker/monthics.html></uib-monthpicker><uib-yearpicker ng-switch-when=year tabindex=0 template-url=app/template/datepicker/yearics.html></uib-yearpicker></div>");
$templateCache.put("app/template/datepicker/dayics.html","<!--suppress XmlInvalidId, XmlHighlighting --><table class=uib-daypicker role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=move(-1) tabindex=-1><i class=\"fa fa-chevron-left\"></i></button></th><th colspan=\"{{::5 + showWeeks}}\"><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm uib-title\" ng-click=toggleMode() ng-disabled=\"datepickerMode === maxMode\" tabindex=-1><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=move(1) tabindex=-1><i class=\"fa fa-chevron-right\"></i></button></th></tr><tr><th ng-if=showWeeks class=text-center></th><th ng-repeat=\"label in ::labels track by $index\" class=text-center><small aria-label={{::label.full}}>{{::label.abbr}}</small></th></tr></thead><tbody><tr class=uib-weeks ng-repeat=\"row in rows track by $index\"><td ng-if=showWeeks class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button class=\"btn btn-default btn-sm\" uib-is-class=\"\'btn-info\' for selectedDt,\'active\' for activeDt on dt\" ng-click=select(dt.date) ng-disabled=::dt.disabled tabindex=-1><span ng-class=\"::{\'text-muted\': dt.secondary, \'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
$templateCache.put("app/template/datepicker/monthics.html","<!--suppress XmlInvalidId, XmlHighlighting --><table class=uib-monthpicker role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=move(-1) tabindex=-1><i class=\"fa fa-chevron-left\"></i></button></th><th><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm uib-title\" ng-click=toggleMode() ng-disabled=\"datepickerMode === maxMode\" tabindex=-1><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=move(1) tabindex=-1><i class=\"fa fa-chevron-right\"></i></button></th></tr></thead><tbody><tr class=uib-months ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button class=\"btn btn-default\" uib-is-class=\"\r\n             \'btn-info\' for selectedDt,\r\n             \'active\' for activeDt\r\n             on dt\" ng-click=select(dt.date) ng-disabled=::dt.disabled tabindex=-1><span ng-class=\"::{\'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
$templateCache.put("app/template/datepicker/yearics.html","<!--suppress XmlInvalidId, XmlHighlighting --><table class=uib-yearpicker role=grid aria-labelledby={{::uniqueId}}-title aria-activedescendant={{activeDateId}}><thead><tr><th><button type=button class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=move(-1) tabindex=-1><i class=\"fa fa-chevron-left\"></i></button></th><th colspan=\"{{::columns - 2}}\"><button id={{::uniqueId}}-title role=heading aria-live=assertive aria-atomic=true type=button class=\"btn btn-default btn-sm uib-title\" ng-click=toggleMode() ng-disabled=\"datepickerMode === maxMode\" tabindex=-1><strong>{{title}}</strong></button></th><th><button type=button class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=move(1) tabindex=-1><i class=\"fa fa-chevron-right\"></i></button></th></tr></thead><tbody><tr class=uib-years ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=gridcell id={{::dt.uid}} ng-class=::dt.customClass><button type=button class=\"btn btn-default\" uib-is-class=\"\r\n             \'btn-info\' for selectedDt,\r\n             \'active\' for activeDt\r\n             on dt\" ng-click=select(dt.date) ng-disabled=::dt.disabled tabindex=-1><span ng-class=\"::{\'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
$templateCache.put("app/components/header/favoris/favoris.html","<div ng-if=!favorisctrl.loading class=favoris-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-6\"><button type=button class=\"btn-custom btn-danger\" ng-click=::favorisctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-6 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::favorisctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer tout</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::favorisctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li></ul></div></div></div></div><div class=favoris><div class=\"favoris-display flex-container\"><div class=favoris-title><h3 class=\"col-xs-12 text-center title\">{{favorisctrl.titre}}</h3></div><div class=\"favoris-list flex-item flex-container\"><div class=\"col-xs-12 text-center\" ng-if=!favorisctrl.favoris.nb><span class=favoris-no-result>Aucun bien favori</span></div><div class=\"bien-container flex-item\" lazy-load><div class=\"col-xs-12 text-center\" ng-if=favorisctrl.favoris.nb><span class=favoris-nb>{{favorisctrl.favoris.nb}} bien{{favorisctrl.favoris.nb > 1 ? \'s\' : \'\'}}</span></div><bloc-bien ng-repeat=\"bien in favorisctrl.favoris.list\" class=\"col-xs-12 favoris-bien\" bien=::bien.lot template=\"\'favoris\'\" on-supprimer=::favorisctrl.favoris.supprimer(idLot) on-email=::favorisctrl.envoyerEmail(refLot) on-toggle-fiche=::favorisctrl.showFiche(refLot) on-favoris=\"::favorisctrl.ajouterFavoris(lot, panier)\" on-selection=\"::favorisctrl.toggleSelection(refLot, selected)\"></bloc-bien></div></div></div></div></div><div class=loader ng-if=favorisctrl.loading></div>");
$templateCache.put("app/components/header/panier/panier.html","<div class=panier-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-6\"><button type=button class=\"btn-custom btn-danger\" ng-click=::panierctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-6 text-right\"><div class=\"btn-group controls-action\" uib-dropdown ng-if=panierctrl.prospect.current><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::panierctrl.prospect.editProspect()><i class=\"fa fa-fw fa-user\"></i> <u>M</u>odifier prospect</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::panierctrl.prospect.editProspect(5)><i class=\"fa fa-fw fa-comments\"></i> <u>C</u>ommunication prospect</button></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=controls-action-btn ng-click=::panierctrl.onEvent(null)><i class=\"fa fa-fw fa-calendar\"></i> <u>R</u>endez-vous</button></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=controls-action-btn ng-click=::panierctrl.bonVisite.generer()><i class=\"fa fa-fw fa-file-o\"></i> <u>B</u>on de visite</button></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=controls-action-btn ng-click=::panierctrl.selectAll()><i class=\"fa fa-fw\" ng-class=\"{\'fa-window-close-o\': panierctrl.allSelected, \'fa-check-square-o\': !panierctrl.allSelected}\"></i> <span ng-if=!panierctrl.allSelected><u>T</u>out s&eacute;lectionner</span> <span ng-if=panierctrl.allSelected><u>T</u>out d&eacute;s&eacute;lectionner</span></button></li><li class=divider></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=controls-action-btn ng-click=::panierctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer tout</button></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=controls-action-btn ng-click=::panierctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider ng-if=panierctrl.panier.nb></li><li role=menuitem class=custom-block ng-if=!panierctrl.prospect.saved><button type=button class=controls-action-btn ng-click=::panierctrl.prospect.saveProspect()><i class=\"fa fa-fw fa-save\"></i> <u>S</u>auvegarder le prospect</button></li><li class=divider ng-if=!panierctrl.prospect.saved></li><li role=menuitem class=custom-block ng-if=panierctrl.panier.nb><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=::panierctrl.panier.supprAllBien()><i class=\"fa fa-fw fa-trash-o\"></i> <u>V</u>ider le panier</button></li><li class=divider ng-if=panierctrl.panier.nb></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::panierctrl.prospect.removeProspect()><i class=\"fa fa-fw fa-sign-out\"></i> <u>Q</u>uitter le panier</button></li></ul></div></div></div></div><div class=\"panier col-xs-12 no-padding\"><div class=\"panier-display flex-container\"><div class=panier-title ng-if=!panierctrl.prospect.current><h3 class=\"col-xs-12 text-center title\">Choisir un prospect</h3></div><div class=prospect-search ng-if=!panierctrl.prospect.current><search-box sb-on-search=panierctrl.prospect.searchProspect(search) sb-config=panierctrl.sbConfig></search-box></div><div class=panier-title ng-if=panierctrl.prospect.current><h3 class=\"text-center title\">{{panierctrl.prospect.current.perso.nomComplet}}</h3><div class=\"panier-prospect-details col-xs-12\"><div class=\"row text-center\" ng-if=\"panierctrl.prospect.current.comRepertoire != \'\'\"><span class=\"prospect-details-search with-newlines\">{{panierctrl.prospect.current.comRepertoire}}</span></div><div class=\"row text-center\" ng-if=\"panierctrl.prospect.current.commentaire != \'\'\"><span class=\"prospect-details-search with-newlines\">{{panierctrl.prospect.current.commentaire}}</span></div><div class=row><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-block btn-rapprocher\" ng-click=panierctrl.rapprocher()><i class=\"fa fa-fw fa-search\"></i> Chercher plus de biens</button></div></div></div></div><div class=\"prospect-list flex-item flex-container\" ng-if=panierctrl.prospect.open><div class=\"prospect-container flex-item\" lazy-load><div class=\"panier-prospects col-xs-12\" ng-if=panierctrl.prospect.nbResult><div class=\"prospect col-xs-12\" ng-repeat=\"prospect in panierctrl.prospect.list\" ng-click=panierctrl.prospect.selectProspect(prospect)><div class=row><div class=\"col-xs-12 flex-container-column\"><div class=\"prospect-nom flex-item\"><span ng-if=prospect.typeCloud class=badge ng-class=\"{\r\n									        \'pb-locataire\': prospect.typeCloud === \'L\',\r\n									        \'pb-proprietaire\': prospect.typeCloud === \'P\',\r\n									        \'pb-coproprietaire\': prospect.typeCloud === \'C\'\r\n								        }\">{{prospect.typeCloud}}</span> <span class=nom>{{prospect.perso.nomComplet}}</span></div><div class=\"prospect-contact text-right\" ng-repeat=\"contact in prospect.perso.contacts | tgnFilterBy : [\'contact.type\'] : \'Email\'\"><span class=contact-label><i class=\"fa fa-fw fa-envelope\"></i> </span><span class=contact-value>{{::contact.value}}</span></div></div><div class=col-xs-12 ng-if=\"::(prospect.comRepertoire && prospect.comRepertoire != \'\')\"><div class=\"prospect-search with-newlines\">{{::prospect.comRepertoire}}</div></div></div><div class=\"col-xs-12 no-padding\"><small class=prospect-nego>N&eacute;go : <span class=prospect-nego-valeur>{{::prospect.nego.perso.nomComplet}}</span></small></div></div></div><div class=\"no-results col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary btn-creer-prospect\" ng-click=panierctrl.prospect.creerProspect()><i class=\"fa fa-fw fa-plus\"></i> Cr&eacute;er un nouveau prospect</button></div></div></div><div class=\"panier-list flex-item flex-container\" ng-if=panierctrl.prospect.current><div class=\"bien-container flex-item\" lazy-load><div class=\"col-xs-12 text-center\" ng-if=!panierctrl.panier.nb><span class=panier-no-result>Aucun bien dans le panier</span></div><div class=\"col-xs-12 text-center\" ng-if=panierctrl.panier.nb><span class=panier-nb>{{panierctrl.panier.nb}} bien{{panierctrl.panier.nb > 1 ? \'s\' : \'\'}}</span></div><div class=panier-biens><bloc-bien ng-repeat=\"bien in panierctrl.panier.list\" class=\"col-xs-12 panier-bien\" bien=::bien.lot template=\"\'panier\'\" on-supprimer=::panierctrl.panier.supprBien(refLot) on-email=::panierctrl.envoyerEmail(refLot) on-event=\"::panierctrl.onEvent(refLot, event)\" event-actif=::bien.evenement on-toggle-fiche=panierctrl.showFiche(refLot) on-contrat=::panierctrl.newContrat(refLot) on-selection=\"::panierctrl.toggleSelection(refLot, idLot, selected)\"></bloc-bien></div></div></div></div></div><div ng-if=panierctrl.evenement.open class=event-datepicker ng-class=\"{\'full-screen\': panierctrl.evenement.fullScreen}\"><div class=event-panel-container><div class=\"container-fluid no-padding event-calendar-container\" lazy-load><div class=no-padding ng-class=\"{\r\n               \'col-lg-12\': !panierctrl.evenement.fullScreen,\r\n               \'col-lg-6 col-xl-5\': panierctrl.evenement.fullScreen\r\n             }\"><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><datetime-picker model=panierctrl.calendar.date model-fin=panierctrl.calendar.dateFin time-picker=true time-range=true is-supprimable=false ng-if=!panierctrl.calendar.reloading nouveau-active=panierctrl.evenement.nouveau on-nouveau=\"panierctrl.evenement.onNouveau(date, dateFin)\" on-annuler=panierctrl.evenement.onAnnuler() on-chose=\"panierctrl.evenement.onChose(date, dateFin)\" on-close=::panierctrl.evenement.onClose() on-full-screen=::panierctrl.evenement.onFullScreen(fullScreen) on-select-societes=::panierctrl.evenement.onSelectSocietes(societes) on-select-nego=::panierctrl.evenement.onSelectNego(nego)></datetime-picker></div><div class=\"col-xs-12 col-sm-6 spacer-top\"><mwl-calendar events=panierctrl.calendar.events view=panierctrl.calendar.view view-date=panierctrl.calendar.viewDate view-title=panierctrl.calendar.title day-view-start=06:00 day-view-end=23:00 day-view-split=60 day-view-event-width=225 on-timespan-click=panierctrl.calendar.onClick(calendarDate)></mwl-calendar></div></div><div class=\"col-xs-12 col-lg-6 col-xl-7 no-padding\" ng-if=panierctrl.evenement.fullScreen><div class=tgn-calendar-container><tgn-calendar read-only=true></tgn-calendar></div></div></div></div></div><div ng-if=\"panierctrl.panier.loading || panierctrl.prospect.loading\" class=loader></div></div>");
$templateCache.put("app/components/header/report/report.html","<div ng-if=!reportctrl.loading class=report-main-container><div class=custom-controls-nav-container deep-blur=reportctrl.onClickBack()><div class=custom-controls-nav><div class=\"controls col-xs-12\"><button type=button class=\"btn-custom btn-danger\" ng-click=::reportctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div></div></div><div class=report><div class=\"report-display flex-container\"><div class=\"report-title spacer-bottom\"><h3 class=\"col-xs-12 text-center title\">Reporter un bug</h3></div><div class=text-justify><p class=report-text>Cette version de ICSign est en version bêta. De fait, il se peut que vous rencontriez des dysfonctionnements relatifs à l\'utilisation des services proposés par ICSign. Dans l\'objectif de vous proposer un service fiable, répondant exactement à vos attentes, nous vous proposons de nous reporter la détection d\'un bug/dysfonctionnement de façon rapide et intéractive. Si vous êtes ici, vous avez cliqué sur le bouton \"Reporter un bug\" présent en bas à gauche ! Ce bouton sera présent à tout moment durant la phase de mise en production bêta du produit ICSign. Vous aurez alors la possibilité de nous signaler une anomalie en remplissant rapidement le court formulaire ci-dessous. Si le type de bug peut être vu sur la plateforme, il vous est possible de nous joindre une capture d\'écran automatique de l\'application, vous n\'avez qu\'a cliquer sur le bouton correspondant à la fin du formulaire et une image de l\'application ICSign nous sera transmise afin de mieux comprendre la problématique. NB: Il ne s\'agit pas d\'un espace de support afin de vous former à l\'utilisation du produit. Espace réservé à la remontée de dysfonctionnements afin d\'accélérer l\'amélioration du produit durant la phase bêta de ce dernier. Lorsque votre report sera traîté, un mail automatique vous sera envoyé afin de vous informer de sa résolution.</p></div><div class=\"report-list flex-item flex-container no-padding\"><p></p><form ng-submit=reportctrl.sendReport()><div class=\"col-xs-12 no-padding\"><label for=description class=\"col-xs-12 control-label\">Anomalie d&eacute;j&agrave; rencontr&eacute;e ?:</label><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: reportctrl.dejaRencontre === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=reportctrl.dejaRencontre uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: reportctrl.dejaRencontre === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=reportctrl.dejaRencontre uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div></div><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-8 col-md-12 col-lg-8 no-padding\"><label for=description class=\"col-xs-12 control-label\">Courte description:</label><div class=col-xs-12><input type=text id=description ng-model=reportctrl.description class=form-control rows=3></div></div><div class=\"col-sm-4 col-md-12 col-lg-4 no-padding\"><label for=niveau_priorite class=\"col-xs-12 control-label\">Niveau de priorité:</label><div class=\"col-xs-12 spacer-bottom\"><!-- <input type=\"select\" id=\"niveau_priorite\" ng-model=\"reportctrl.description\" class=\"form-control\" rows=\"3\"></input> --><select id=niveau_priorite class=form-control ng-model=reportctrl.niveau_priorite><option ng-repeat=\"niveau_priorite in reportctrl.niveau_priorites\" ng-value=niveau_priorite.id>{{niveau_priorite.label}}</option></select></div></div></div><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=explication class=\"col-xs-12 control-label\">Explication</label><div class=\"col-xs-12 spacer-bottom\"><textarea id=explication ng-model=reportctrl.explication class=form-control rows=3></textarea></div></div><div class=\"col-xs-12 text-right\" ng-if=false><button type=button class=\"btn-custom btn-custom-block btn-custom-secondary tec-save\"><i class=\"fa fa-fw fa-picture-o\"></i> <span class=hidden-xs>Prendre une capture d\'&eacute;cran</span></button></div><div class=\"col-xs-12 text-center\"><div class=\"col-xs-12 col-sm-8 text-right\"></div><div class=\"col-xs-12 col-sm-4 text-right\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-secondary tec-save\"><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Envoyer</span></button></div></div></form></div></div></div></div><div class=loader ng-if=reportctrl.loading></div>");
$templateCache.put("app/components/header/selection/selection.html","<div ng-if=!selectionctrl.loading class=selection-main-container><div class=custom-controls-nav-container deep-blur=selectionctrl.onClickBack()><div class=custom-controls-nav><div class=\"controls col-xs-6\"><button type=button class=\"btn-custom btn-danger\" ng-click=::selectionctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-6 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::selectionctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer tout</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::selectionctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block ng-if=selectionctrl.selection.nb><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=::selectionctrl.clearSelection()><i class=\"fa fa-fw fa-trash-o\"></i> <u>V</u>ider la s&eacute;lection</button></li></ul></div></div></div></div><div class=selection><div class=\"selection-display flex-container\"><div class=selection-title><h3 class=\"col-xs-12 text-center title\">S&eacute;lection<div class=\"sort-dropdown btn-group pull-left\" is-open=selectionctrl.tris.open uib-dropdown auto-close=outsideClick><span uib-dropdown-toggle class=\"btn btn-simple-custom\"><i class=\"fa fa-fw fa-sort-amount-asc\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=\"custom-block spacer-bottom\"><div class=col-xs-12><div class=input-group><span class=\"input-group-addon bg-custom-light\">Tri</span><select class=\"form-control border-rounded\" title=Tri ng-model=selectionctrl.tris.ordre><option ng-repeat=\"(valeur, nom) in ::selectionctrl.tris.list\" value={{::valeur}}>{{::nom}}</option></select></div></div></li><li role=menuitem class=custom-block><div class=col-xs-12><div class=input-group><span class=\"input-group-addon bg-custom-light\">Ordre</span><select class=\"form-control border-rounded\" title=Ordre ng-model=selectionctrl.tris.tri><option value=asc>Croissant</option><option value=desc>D&eacute;croissant</option></select></div></div></li><li class=divider></li><li role=menuitem><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-block btn-custom-primary\" ng-click=\"::selectionctrl.tris.trier(); selectionctrl.tris.open = false\">TRIER</button></div></li></ul></div></h3></div><div class=\"selection-list flex-item flex-container\"><div class=\"col-xs-12 text-center\" ng-if=!selectionctrl.selection.nb><span class=selection-no-result>Aucun bien s&eacute;lectionn&eacute;</span></div><div class=\"bien-container flex-item\" lazy-load><div class=\"col-xs-12 text-center\" ng-if=selectionctrl.selection.nb><span class=selection-nb>{{selectionctrl.selection.nb}} bien{{selectionctrl.selection.nb > 1 ? \'s\' : \'\'}}</span></div><bloc-bien ng-repeat=\"bien in selectionctrl.selection.list\" class=\"col-xs-12 selection-bien\" bien=::bien template=\"\'selection\'\" on-supprimer=::selectionctrl.selection.supprimer(refLot) on-email=::selectionctrl.envoyerEmail(refLot) on-favoris=\"::selectionctrl.ajouterFavoris(lot, panier)\" on-toggle-fiche=::selectionctrl.showFiche(refLot)></bloc-bien></div></div></div></div></div><div class=loader ng-if=selectionctrl.loading></div>");
$templateCache.put("app/components/main-content/accueil/accueil.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!accueilctrl.citya ncy-breadcrumb></div><div class=flex-item lazy-load=::accueilctrl.actualites.functions.getListDiffusions(true) scroll-lvl=95><div class=container-fluid><div class=col-xs-12><accueil-perso></accueil-perso></div><uib-accordion class=accueilAccordion close-others=false><div uib-accordion-group class=\"col-xs-12 col-sm-6 accordionVisites\" is-open=accueilctrl.panelsOpen.visites><uib-accordion-heading><div class=dashboardTitle><div class=\"prevNextButtons pull-right\" ng-click=$event.stopPropagation();$event.preventDefault() ng-if=accueilctrl.panelsOpen.visites><button type=button class=\"roundButton prevButton\" ng-click=::accueilctrl.visites.functions.changeDayVisite(false)><i class=\"fa fa-chevron-left\"></i></button> <button type=button class=roundButton ng-click=::accueilctrl.visites.functions.changeDayVisite(true)><i class=\"fa fa-chevron-right\"></i></button></div><div ng-class=\"{paddingPrevNext: accueilctrl.panelsOpen.visites}\" class=textTitle><h3>Visites du {{accueilctrl.visites.functions.getDayTitleVisite()}}</h3><hr class=dashboardSeparator></div></div></uib-accordion-heading><visites visites=accueilctrl.visites.list displayed-date=accueilctrl.visites.displayedDate></visites></div><div uib-accordion-group class=\"col-xs-12 col-sm-6 accordionToDo\" is-open=accueilctrl.panelsOpen.todoliste><uib-accordion-heading><div class=dashboardTitle><div class=dashboardTitle><div class=\"addButton pull-right\" ng-click=$event.stopPropagation();$event.preventDefault() ng-if=accueilctrl.panelsOpen.todoliste><button type=button class=roundButton ng-click=accueilctrl.todoliste.functions.onTapButtonAddTask()><i class=\"fa fa-plus\"></i></button></div><div ng-class=\"{paddingAdd: accueilctrl.panelsOpen.todoliste}\" class=textTitle><h3>Tâches à accomplir</h3><hr class=dashboardSeparator></div></div></div></uib-accordion-heading><todoliste new-task-panel=accueilctrl.todoliste.newTaskPanel></todoliste></div><div uib-accordion-group class=\"col-xs-12 col-sm-12 accordionStatistiques\" is-open=accueilctrl.panelsOpen.statistiques><uib-accordion-heading><h3 class=dashboardTitle>Statistiques <span ng-if=accueilctrl.employe>de {{::(accueilctrl.employe.perso.getNomComplet())}}</span></h3><hr class=dashboardSeparator></uib-accordion-heading><statistiques></statistiques></div><div uib-accordion-group class=\"col-xs-12 col-sm-12 accordionActualites\" is-open=accueilctrl.panelsOpen.actualites ng-if=accueilctrl.actualites.diffusions.length><uib-accordion-heading><div class=dashboardTitle><div class=textTitle><h3>Fil d\'actualités</h3><hr class=dashboardSeparator></div></div></uib-accordion-heading><actualites actualites=accueilctrl.actualites ng-if=accueilctrl.panelsOpen.actualites></actualites></div></uib-accordion></div></div></div>");
$templateCache.put("app/components/main-content/compromis/compromis.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!compromisctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\" ng-if=!compromisctrl.initialisation><!-- Search Box --><search-box sb-on-search=\"compromisctrl.compromis.getList(search, false)\" sb-config=compromisctrl.sbConfig></search-box><!-- /End Search Box --><!-- Compromis List --><div class=\"compromis-list flex-item flex-container\"><div ng-if=!compromisctrl.compromis.nb class=\"no-results col-xs-12 text-center\">Aucun r&eacute;sultat</div><div class=\"flex-item compromis-container\" lazy-load=\"::compromisctrl.compromis.getList(false, true)\"><div class=\"col-xs-12 text-center\"><span ng-if=\"compromisctrl.compromis.nb > 0\" class=nb-results>{{compromisctrl.compromis.nb}} {{compromisctrl.query.search.type || \'résultat\'}}{{(compromisctrl.compromis.nb > 1 && compromisctrl.query.search.type !== \'compromis\') ? \'s\' : \'\'}}</span></div><bloc-compromis class=\"col-xs-12 col-md-6 col-xl-4\" ng-repeat=\"compromis in compromisctrl.compromis.list\" compromis=compromis on-show-fiche=compromisctrl.showFicheCompromis(compromis.id)></bloc-compromis><div ng-if=compromisctrl.loading class=loader></div></div></div><!-- /End Compromis List --></div><div class=loader ng-if=compromisctrl.initialisation></div></div>");
$templateCache.put("app/components/main-content/liste-bien/liste-bien.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!listebienctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\" ng-if=!listebienctrl.initialisation><!-- Search Box --><search-box sb-on-search=\"listebienctrl.getList(search, false)\" sb-config=listebienctrl.searchBoxOptions></search-box><!-- /End Search Box --><!-- Properties List --><div class=\"properties-list flex-item flex-container\"><div ng-if=\"listebienctrl.query.template !== \'map\' && listebienctrl.noResults\" class=\"no-results col-xs-12 text-center\">Aucun résultat</div><div class=\"flex-item properties-container\" ng-if=\"listebienctrl.query.template !== \'map\'\" lazy-load=\"::listebienctrl.getList(false, true)\"><div class=\"col-xs-12 text-center\"><span ng-show=\"listebienctrl.properties.nblot > 0\" class=nb-results>{{listebienctrl.properties.nblot}} bien{{listebienctrl.properties.pluriel}}</span></div><bloc-bien ng-repeat=\"property in listebienctrl.properties.list track by property.id\" class=property-container ng-class=\"{\r\n					             \'col-xxs-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2\': listebienctrl.query.template === \'grid\',\r\n					             \'col-xs-12 col-md-6 col-xl-4\': listebienctrl.query.template === \'list\',\r\n					             \'col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2\': listebienctrl.query.template === \'listNoPhotos\'\r\n                     }\" repeat-complete=listebienctrl.onRepeatComplete() bien=::property template=listebienctrl.query.template on-email=::listebienctrl.envoyerBienEmail(property.referenceInterne) on-favoris=\"::listebienctrl.ajouterFavoris(lot, panier)\" on-toggle-fiche=::listebienctrl.showFicheProperty(refLot) on-selection=\"::listebienctrl.toggleSelection(refLot, selected)\"></bloc-bien><div ng-show=listebienctrl.loading class=loader></div></div><div class=\"property-map-container flex-item\" ng-if=\"listebienctrl.query.template === \'map\'\" ng-class=\"{\'map-with-tab\': listebienctrl.map.tablist.open}\"><div class=map-container><!--<leaflet layers=\"::listebienctrl.map.layers\" markers=\"listebienctrl.map.markers\" center=\"::listebienctrl.map.center\"></leaflet>--><ui-gmap-google-map center=listebienctrl.map.center zoom=listebienctrl.map.zoom pan=true control=listebienctrl.map.controller events=::listebienctrl.map.events options=listebienctrl.map.options><ui-gmap-map-control template=map-control-btn-template.html position=RIGHT_TOP index=-1></ui-gmap-map-control><ui-gmap-map-control template=map-control-not-visible-lots.html position=TOP_RIGHT></ui-gmap-map-control><ui-gmap-markers models=listebienctrl.properties.list fit=true coords=\"\'adresse\'\" type=\"\'cluster\'\" typeoptions=listebienctrl.map.clusterOptions options=\"\'markerOptions\'\" control=listebienctrl.map.markersController events=listebienctrl.map.markerEvents></ui-gmap-markers><ui-gmap-window ng-if=listebienctrl.map.window.show coords=listebienctrl.map.window.property.adresse show=true templateurl=\"\'bloc-map-template.html\'\" templateparameter=listebienctrl.map.window.property options=::listebienctrl.map.windowOptions isiconvisibleonclick=true></ui-gmap-window><ui-gmap-window ng-if=listebienctrl.map.markerHighlight.show coords=listebienctrl.map.markerHighlight.property.adresse show=true templateurl=\"\'marker-highlight.html\'\" templateparameter=listebienctrl.map.markerHighlight.property options=::listebienctrl.map.markerHighlight.options isiconvisibleonclick=false></ui-gmap-window></ui-gmap-google-map><div ng-show=listebienctrl.loading class=loader></div></div><div ng-if=listebienctrl.map.tablist.open class=map-tablist><div class=map-lazy-load-container><div class=map-tablist-properties-container lazy-load=listebienctrl.mapLazyload() ng-if=listebienctrl.map.tablist.visible><div class=\"col-xs-12 text-center\" ng-if=listebienctrl.properties.nbMapLot><span class=nb-results>{{listebienctrl.properties.nbMapLot}} bien{{listebienctrl.properties.mapPluriel}}</span></div><div ng-if=!listebienctrl.properties.nbMapLot class=\"no-results col-xs-12 text-center\">Aucun résultat</div><bloc-bien ng-repeat=\"property in listebienctrl.properties.list | tgnFilterBy: [\'isVisible\']: \'true\' | limitTo: listebienctrl.properties.mapnumero track by property.id\" class=\"property-container col-sm-12 col-md-6\" repeat-complete=listebienctrl.onRepeatComplete(true) bien=property template=\"\'tablist\'\" on-toggle-fiche=::listebienctrl.showFicheProperty(refLot) on-favoris=\"::listebienctrl.ajouterFavoris(lot, panier)\" on-email=::listebienctrl.envoyerBienEmail(refLot) on-selection=\"::listebienctrl.toggleSelection(refLot, selected)\" on-mouse-enter=listebienctrl.highlightMarker(property) on-mouse-leave=::listebienctrl.hideHighlightedMarker()></bloc-bien><div class=loader ng-if=listebienctrl.map.tablist.loading></div></div></div></div></div></div><!-- /End Properties List --></div><div class=loader ng-if=listebienctrl.initialisation></div></div><script type=text/ng-template id=map-control-btn-template.html><button type=\"button\" class=\"btn-map-control btn-custom-primary hidden-xs\" ng-click=\"$parent.$parent.$parent.$parent.listebienctrl.tablistToggle()\">\r\n    <i class=\"fa fa-fw\" ng-class=\"{\r\n				 \'fa-chevron-right\': $parent.$parent.$parent.$parent.listebienctrl.map.tablist.open,\r\n				 \'fa-chevron-left\': !$parent.$parent.$parent.$parent.listebienctrl.map.tablist.open\r\n			 }\"></i>\r\n  </button></script><script type=text/ng-template id=map-control-not-visible-lots.html><div class=\"nb-not-visible\" ng-show=\"$parent.$parent.$parent.$parent.listebienctrl.properties.nbNotVisible\" ng-click=\"$parent.$parent.$parent.$parent.listebienctrl.getNonGeolocalise()\">\r\n    {{$parent.$parent.$parent.$parent.listebienctrl.properties.nbNotVisible}} bien{{$parent.$parent.$parent.$parent.listebienctrl.properties.notVisiblePluriel}}\r\n    non g&eacute;olocalis&eacute;{{$parent.$parent.$parent.$parent.listebienctrl.properties.notVisiblePluriel}}\r\n  </div></script><script type=text/ng-template id=marker-highlight.html><div class=\"highlighted-marker\" ng-click=\"$parent.$parent.$parent.$parent.listebienctrl.markerClick(null, null, parameter)\"></div></script><script type=text/ng-template id=bloc-map-template.html><bloc-bien bien=\"::parameter\" template=\"\'map\'\" on-email=\"::$parent.$parent.$parent.$parent.listebienctrl.envoyerBienEmail(refLot)\"\r\n    on-favoris=\"::$parent.$parent.$parent.$parent.listebienctrl.ajouterFavoris(lot, panier)\" on-toggle-fiche=\"::$parent.$parent.$parent.$parent.listebienctrl.showFicheProperty(refLot)\"\r\n    on-selection=\"::$parent.$parent.$parent.$parent.listebienctrl.toggleSelection(refLot, selected)\" on-fermer=\"::$parent.$parent.$parent.$parent.listebienctrl.hideMapProperty()\"></bloc-bien></script>");
$templateCache.put("app/components/main-content/liste-prospects/liste-prospects.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!listeprospectsctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\"><search-box sb-on-search=\"listeprospectsctrl.getList(search, false)\" sb-config=listeprospectsctrl.searchBoxOptions></search-box><div class=\"prospects-liste flex-item flex-container\"><div ng-if=listeprospectsctrl.noResults class=\"no-results col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"><div class=\"col-xs-12 text-center spacer-bottom\">Aucun r&eacute;sultat</div><button type=button class=\"btn-custom btn-custom-block btn-custom-primary btn-creer-prospect\" ng-click=listeprospectsctrl.creerProspect() ng-if=!listeprospectsctrl.citya><i class=\"fa fa-fw fa-plus\"></i> Cr&eacute;er un nouveau prospect</button></div><div ng-if=\"!listeprospectsctrl.noResults && listeprospectsctrl.prospects.nb>0\" class=\"prospects-container flex-item\" lazy-load=\"listeprospectsctrl.getList(false, true)\"><div class=\"col-xs-12 text-center nb-prospect\"><span>{{listeprospectsctrl.prospects.nb}} prospect<span ng-if=\"listeprospectsctrl.prospects.nb > 1\">s</span></span></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" ng-repeat=\"prospect in listeprospectsctrl.prospects.list\"><bloc-prospect prospect=::prospect rapprocher=listeprospectsctrl.rapprocher.active on-toggle-selection=\"::listeprospectsctrl.rapprocher.toggle(selected, prospect)\" on-show-fiche=::listeprospectsctrl.showFicheProspect(reference)></bloc-prospect></div></div><div ng-if=listeprospectsctrl.loading class=loader></div></div></div></div>");
$templateCache.put("app/components/main-content/installation/installation.html","<div class=\"main-content flex-item flex-container installation-container text-center\"><div class=\"installation-box col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4\"><div class=row><div class=\"col-xs-12 no-padding\"><timeline-horizontal liste-etapes=installationctrl.timeline.etapes etape-courante=installationctrl.timeline.current on-change-etape=installationctrl.timeline.onChange(id)></timeline-horizontal></div><div class=\"col-xs-12 installation-etape installation-etape-1\" ng-if=\"installationctrl.timeline.current==1\"><div class=\"col-xs-12 no-padding spacer-bottom\"><div class=\"row text-center message spacer-bottom\"><span class=text-danger ng-show=installationctrl.isErreur>{{installationctrl.message}}</span></div><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3\"><span class=input-group-addon>Cle Installation</span> <input type=text id=cle class=form-control ng-model=installationctrl.cleInstallation placeholder=\"Cle Installation\" required></div></div><div class=\"col-xs-12 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=installationctrl.install()>Rechercher</button></div></div></div><div class=\"col-xs-12 installation-etape installation-etape-2\" ng-if=\"installationctrl.timeline.current==2\"><div class=\"col-xs-12 no-padding spacer-bottom\"><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3\"><span class=input-group-addon>Nom de l\'agence</span> <input type=text id=cle class=form-control ng-model=installationctrl.clientICS.nomClient placeholder=\"Nom Agence\" required></div></div><div class=\"col-xs-12 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=installationctrl.etapeSuivante()>Suivant</button></div></div></div><div class=\"col-xs-12 installation-etape installation-etape-3\" ng-if=\"installationctrl.timeline.current==3\"><div class=\"col-xs-12 no-padding spacer-bottom\"><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3 spacer-bottom\"><span class=input-group-addon>Modele d\'agence</span><ui-select ng-model=installationctrl.clientICS.copieFrom theme=bootstrap close-on-select=true><ui-select-match placeholder=Modele... allow-clear>{{$select.selected.nomModele}}</ui-select-match><ui-select-choices repeat=\"modele.idModele as modele in installationctrl.clientICS.modeleDisponible | filter: $select.search track by modele.idModele\"><span ng-bind-html=\"::modele.nomModele | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"input-group spacer-bottom col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3\" ng-if=installationctrl.clientICS.importation><div class=input-group><span class=input-group-addon>Importation a partire de :</span></div><div class=input-group><a href={{installationctrl.clientICS.urlClientDonnee}} target=_blank>{{installationctrl.clientICS.urlClientDonnee}}</a></div></div></div><div class=\"col-xs-12 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=installationctrl.etapeSuivante()>Suivant</button></div></div></div><div class=\"col-xs-12 installation-etape installation-etape-4\" ng-if=\"installationctrl.timeline.current==4\"><div class=\"col-xs-12 no-padding spacer-bottom\"><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3\"><span class=input-group-addon>Email</span> <input type=email id=email class=form-control ng-model=installationctrl.clientICS.emailAdministrateur placeholder=Email required></div></div><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3\"><span class=input-group-addon>Mot de passe</span> <input type=password id=pass class=form-control ng-model=installationctrl.clientICS.passAdministrateur placeholder=\"Mot de passe\" required></div></div><div class=\"col-xs-12 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=installationctrl.creer()>Creer</button></div></div></div></div><div ng-if=installationctrl.loading class=\"loader loader-md\"></div></div></div>");
$templateCache.put("app/components/main-content/login/login.html","<div class=\"main-content flex-item flex-container login-container text-center\"><form name=loginForm ng-submit=loginctrl.login() novalidate class=\"login-box col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4\"><div class=login-title-container><div class=login-title><div class=\"col-xs-12 col-sm-6\"><button type=button required ng-class=\"{\'checked\': loginctrl.typeApplication === \'Transaction\'}\" ng-model=loginctrl.typeApplication uib-btn-radio=\"\'Transaction\'\">TRANSAC.NET</button></div><div class=\"col-xs-12 col-sm-6\"><button type=button required ng-class=\"{\'checked\': loginctrl.typeApplication === \'Location\'}\" ng-model=loginctrl.typeApplication uib-btn-radio=\"\'Location\'\">GESLOC.NET</button></div></div></div><div class=custom-spacer></div><div class=spacer></div><div class=row><div class=\"login-form col-xs-12\"><div class=\"row text-center spacer-bottom\"><span class=text-danger ng-show=loginctrl.badLogin>Initiales ou mot de passe incorrect.</span></div><div class=\"row text-center spacer-bottom\"><span class=text-warning ng-show=loginctrl.connexionTimedOut>Vous avez &eacute;t&eacute; d&eacute;connect&eacute; suite &agrave; une p&eacute;riode prolong&eacute;e d&apos;inactivit&eacute;.</span></div><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><span class=\"input-group-addon text-custom-login\"><i class=\"fa fa-fw fa-at\"></i></span><label for=initiales class=sr-only>Initiales</label><input type=text id=initiales class=form-control ng-model=loginctrl.initiales placeholder=Initiales required></div></div><div class=form-group><div class=\"input-group col-xs-8 col-xs-offset-2 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><span class=\"input-group-addon text-custom-login\"><i class=\"fa fa-fw fa-lock\"></i></span><label for=mdp class=sr-only>Mot de passe</label><input type=password id=mdp class=form-control ng-model=loginctrl.mdp placeholder=\"Mot de passe\"></div></div><div class=form-group><button type=submit class=\"btn btn-custom btn-custom-login\">Connexion</button></div><div ng-if=loginctrl.versionAuthorise class=\"row text-center spacer-bottom\"><a ui-sref=installation class=text>Nouveau Client ?<br>Veuillez cliquer-ici pour saisir votre code d\'installation</a></div></div></div><div class=spacer></div><div class=row ng-if=loginctrl.isAppleDevice><div class=\"col-xs-12 text-center\">Impossible de se connecter depuis un appareil <i>Apple&copy;</i> ?<br><a href=https://youtu.be/u2a-yGJ1JfY target=_blank>Voir la proc&eacute;dure &agrave; suivre</a></div></div><div class=spacer ng-if=loginctrl.isAppleDevice></div><div ng-if=loginctrl.loading class=\"loader loader-md\"></div></form></div>");
$templateCache.put("app/components/main-content/modif-bien/modif-bien.html","<div class=\"main-content flex-item flex-container modif-bien\"><div ng-if=!modifbienctrl.citya ncy-breadcrumb></div><div class=flex-item lazy-load><div class=container-fluid ng-switch=modifbienctrl.timeline.current><form class=form-horizontal name=modifbienctrl.form ng-submit=modifbienctrl.save() novalidate><validation-viewer ng-if=!modifbienctrl.loading vv-timeline=modifbienctrl.timeline></validation-viewer><div class=row><!--<div class=\"col-xs-6 spacer-top\">\r\n            <button type=\"button\" class=\"btn-custom btn-custom-sm btn-custom-secondary\"\r\n                    ng-click=\"modifbienctrl.goBack()\">\r\n              <i class=\"fa fa-fw fa-arrow-left\"></i> Retour\r\n            </button>\r\n          </div>--><div class=\"col-xs-12 spacer-top text-right\"><button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifbienctrl.rapprocher()><i class=\"fa fa-fw fa-search-plus\"></i> Rapprocher</button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifbienctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <span class=hidden-xs>Imprimer</span></button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifbienctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <span class=hidden-xs>Envoyer</span></button></div><div class=\"col-xs-12 no-padding\"><timeline-horizontal liste-etapes=modifbienctrl.timeline.etapes etape-courante=modifbienctrl.timeline.current on-change-etape=modifbienctrl.timeline.onChange(id)></timeline-horizontal></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=1><div class=\"col-xs-12 no-padding spacer-bottom\"><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-2 col-md-offset-0 col-md-push-8 spacer-bottom\"><button type=button class=\"btn-custom btn-custom-sm btn-danger pull-right\" ng-click=modifbienctrl.proprietaires.reset()><i class=\"fa fa-fw fa-trash\"></i> Vider</button></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-4 col-md-offset-4 col-md-pull-2 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=modifbienctrl.proprietaires.search()><i class=\"fa fa-fw fa-address-book-o\"></i> Chercher un propri&eacute;taire</button></div></div><div class=\"col-xs-12 no-padding\"><personnalite personnalite=modifbienctrl.lot.proprietaire etat-civil=true is-loading=modifbienctrl.loading validation=modifbienctrl.form is-required=true visited=modifbienctrl.timeline.etapes.etapes[0].visited params-gestion=modifbienctrl.paramsGestion></personnalite><div class=\"col-xs-12 no-padding\" ng-if=modifbienctrl.citya><div class=\"col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-2 col-md-6\"><label class=no-padding-left>Accepte de recevoir des offres commerciales de la part de CITYA et des filiales de CITYA :</label></div><div class=\"col-xs-12 spacer-bottom no-padding\"><div class=\"col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-2 col-md-6 spacer-bottom\"><label for=demarchageCommercial class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercial name=demarchageCommercial class=\"checkbox form-control\" ng-model=modifbienctrl.lot.demarchageCommercial> <span class=checkbox-addon>Par email</span></label><label for=demarchageCommercialSms class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialSms name=demarchageCommercialSms class=\"checkbox form-control\" ng-model=modifbienctrl.lot.demarchageCommercialSms> <span class=checkbox-addon>Par sms</span></label><label for=demarchageCommercialCourrier class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialCourrier name=demarchageCommercialCourrier class=\"checkbox form-control\" ng-model=modifbienctrl.lot.demarchageCommercialCourrier> <span class=checkbox-addon>Par courrier</span></label><label for=demarchageCommercialTelephonique class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialTelephonique name=demarchageCommercialTelephonique class=\"checkbox form-control\" ng-model=modifbienctrl.lot.demarchageCommercialTelephonique> <span class=checkbox-addon>Par T&eacute;l&eacute;phone</span></label></div></div></div></div></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=2><mandat-transaction ng-if=\"modifbienctrl.globalService.getTypeApplication() === \'Transaction\'\" lot=modifbienctrl.lot is-loading=modifbienctrl.loading validation=modifbienctrl.form visited=modifbienctrl.timeline.etapes.etapes[1].visited></mandat-transaction><mandat-location ng-if=\"modifbienctrl.globalService.getTypeApplication() === \'Location\'\" lot=modifbienctrl.lot is-loading=modifbienctrl.loading validation=modifbienctrl.form params-gestion=modifbienctrl.paramsGestion visited=modifbienctrl.timeline.etapes.etapes[1].visited></mandat-location></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=3><lot lot=modifbienctrl.lot is-loading=modifbienctrl.loading validation=modifbienctrl.form params-gestion=modifbienctrl.paramsGestion visited=modifbienctrl.timeline.etapes.etapes[2].visited></lot></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=4><diffusion lot=modifbienctrl.lot is-loading=modifbienctrl.loading validation=modifbienctrl.form params-gestion=modifbienctrl.paramsGestion visited=modifbienctrl.timeline.etapes.etapes[3].visited></diffusion><hr class=primary><extranet lot=modifbienctrl.lot></extranet></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=5><communication lot=modifbienctrl.lot is-loading=modifbienctrl.loading></communication></div><div class=\"col-xs-12 bien-etape\" ng-switch-when=6><photo lot=modifbienctrl.lot></photo><hr class=primary><ged lot=modifbienctrl.lot></ged></div><div ng-if=modifbienctrl.loading class=loader></div><div class=clearfix></div><div class=timeline-etapes-controls><div class=\"col-xs-2 col-md-3 col-lg-4 text-left no-padding-left\"><button type=button class=\"btn-custom btn-custom-secondary tec-prev\" ng-if=\"modifbienctrl.timeline.current > 1\" ng-click=modifbienctrl.timeline.prev()><i class=\"fa fa-fw fa-chevron-left\"></i> <span class=\"hidden-xs hidden-sm\">Etape Precedente</span></button></div><div class=\"col-xs-4 col-md-3 col-lg-2 text-right no-padding-left\"><button type=button class=\"btn-custom btn-custom-block tec-delete\" ng-if=modifbienctrl.isEditable ng-click=modifbienctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <span class=hidden-xs>Supprimer</span></button></div><div class=\"col-xs-4 col-md-3 col-lg-2 text-center no-padding-right\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-secondary tec-save\" ng-if=modifbienctrl.isEditable><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Enregistrer</span></button></div><div class=\"col-xs-2 col-md-3 col-lg-4 text-right no-padding-right\"><button type=button class=\"btn-custom btn-custom-secondary tec-next\" ng-if=\"modifbienctrl.timeline.current < modifbienctrl.timeline.etapes.etapes.length\" ng-click=modifbienctrl.timeline.next()><span class=\"hidden-xs hidden-sm\">Etape Suivante</span> <i class=\"fa fa-fw fa-chevron-right\"></i></button></div></div></div></form></div></div></div>");
$templateCache.put("app/components/main-content/modif-compromis/modif-compromis.html","<div class=\"main-content flex-item flex-container modif-compromis\"><div ng-if=!modifcompromisctrl.citya ncy-breadcrumb></div><div class=flex-item lazy-load><div class=container-fluid><form class=\"form-horizontal col-xs-12\" name=modifcompromisctrl.form ng-if=modifcompromisctrl.compromis ng-submit=modifcompromisctrl.save() novalidate><div class=row><div class=\"compromis-titre flex-container-column\"><h3 class=\"titre-num flex-item\">COMPROMIS N&deg;{{::modifcompromisctrl.compromis.id}}</h3><div class=titre-action><button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=modifcompromisctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <span class=hidden-xs>Imprimer</span></button></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifcompromisctrl.compromis.affaire.proprietaire titre-bloc=\"\'VENDEUR\'\"></bloc-perso><div class=nego-proprietaire>N&eacute;go : {{modifcompromisctrl.compromis.affaire.mandatTransaction.nego.perso.nomComplet}}</div></div><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifcompromisctrl.compromis.acheteur.perso titre-bloc=\"\'ACHETEUR\'\" template-right=true is-editable=!modifcompromisctrl.verrouillage type-perso=\"\'prospect\'\" is-prospect=true on-select-prospect=modifcompromisctrl.setAcheteur(prospect)></bloc-perso><div class=nego-locataire>N&eacute;go : {{modifcompromisctrl.compromis.acheteur.nego.perso.nomComplet}}</div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifcompromisctrl.compromis.notaireVendeur.perso titre-bloc=\"\'NOTAIRE (Vendeur)\'\" is-editable=!modifcompromisctrl.verrouillage type-perso=\"\'notaire\'\" type-only=\"\'physique\'\"></bloc-perso></div><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifcompromisctrl.compromis.notaireAcheteur.perso titre-bloc=\"\'NOTAIRE (Acheteur)\'\" template-right=true is-editable=!modifcompromisctrl.verrouillage type-perso=\"\'notaire\'\" type-only=\"\'morale\'\"></bloc-perso></div></div><!--<div class=\"row\">\r\n            <div class=\"affaire-title col-xs-12\"><span class=\"title\">AFFAIRE :</span></div>\r\n            <div class=\"affaire-desc col-xs-12 text-center spacer-bottom\">\r\n                {{::modifcompromisctrl.compromis.affaire.getFormatedLibelle()}}\r\n            </div>\r\n        </div>--><div class=row><div class=col-xs-12><div class=\"bloc-affaire col-xs-12\"><div class=affaire-titre><div class=\"affaire-titre-label col-xs-12 text-center\">AFFAIRE <small class=titre-ref>Ref : {{modifcompromisctrl.compromis.affaire.referenceInterne}}</small> <button type=button class=\"btn-custom btn-custom-sm btn-custom-primary pull-right btn-edit-affaire\" ng-click=modifcompromisctrl.openAffaire() tooltip-placement=\"auto top\" uib-tooltip=\"Modifier l\'affaire\"><i class=\"fa fa-fw fa-pencil\"></i></button></div></div><div class=\"affaire-content col-xs-12 text-center\">{{::modifcompromisctrl.compromis.affaire.getFormatedLibelle()}}</div></div></div></div><hr class=darken-separator><div class=row><div class=\"affaire-details col-xs-12 spacer-top\"><div class=row><label for=dateRedaction class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date de R&eacute;daction</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateRedaction custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.dateRedaction ng-disabled=modifcompromisctrl.citya> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.dateRedaction = !modifcompromisctrl.datepickers.dateRedaction && !modifcompromisctrl.citya\" ng-class=\"{\'disabled\': modifcompromisctrl.citya}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.dateRedaction class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'dateRedaction\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.dateRedaction on-close=\"::modifcompromisctrl.datepickers.onClose(\'dateRedaction\')\"></datetime-picker></div></div><label for=dateSignature class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date de Signature</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateSignature custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.date ng-disabled=modifcompromisctrl.verrouillage> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.date = !modifcompromisctrl.datepickers.date && !modifcompromisctrl.verrouillage\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.date class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'date\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.date on-close=\"::modifcompromisctrl.datepickers.onClose(\'date\')\"></datetime-picker></div></div></div><div class=row><label for=dateLimite class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date conditions suspensives</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateLimite custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.dateLimite ng-disabled=modifcompromisctrl.verrouillage> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.dateLimite = !modifcompromisctrl.datepickers.dateLimite && !modifcompromisctrl.verrouillage\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.dateLimite class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'dateLimite\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.dateLimite on-close=\"::modifcompromisctrl.datepickers.onClose(\'dateLimite\')\"></datetime-picker></div></div><label for=datePrevueVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date Vente Pr&eacute;vue</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=datePrevueVente custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.datePrevueVente ng-disabled=modifcompromisctrl.verrouillage ng-required=modifcompromisctrl.citya> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.datePrevueVente = !modifcompromisctrl.datepickers.datePrevueVente && !modifcompromisctrl.verrouillage\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.datePrevueVente class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'datePrevueVente\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.datePrevueVente on-close=\"::modifcompromisctrl.datepickers.onClose(\'datePrevueVente\')\"></datetime-picker></div></div></div><div class=row><label ng-if=modifcompromisctrl.employe.societe.agence.horsSRU for=dateHorsSru class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date hors SRU</label><div ng-if=modifcompromisctrl.employe.societe.agence.horsSRU class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateHorsSru custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.dateHorsSru ng-disabled=modifcompromisctrl.verrouillage> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.dateHorsSru = !modifcompromisctrl.datepickers.dateHorsSru && !modifcompromisctrl.verrouillage\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.dateHorsSru class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'dateHorsSru\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.dateHorsSru on-close=\"::modifcompromisctrl.datepickers.onClose(\'dateHorsSru\')\"></datetime-picker></div></div><label for=dateEffectiveVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date Effective Vente</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateEffectiveVente custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.dateEffectiveVente ng-disabled=modifcompromisctrl.verrouillage> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.dateEffectiveVente = !modifcompromisctrl.datepickers.dateEffectiveVente && !modifcompromisctrl.verrouillage\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.dateEffectiveVente class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'dateEffectiveVente\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.dateEffectiveVente on-close=\"::modifcompromisctrl.datepickers.onClose(\'dateEffectiveVente\')\"></datetime-picker></div></div></div><div class=row><label for=dateEncaissement class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date Encaissement</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateEncaissement custom-type=date ui-mask=99/99/9999 class=form-control ng-model=modifcompromisctrl.compromis.dateEncaissement ng-disabled=\"modifcompromisctrl.verrouillage && !modifcompromisctrl.employe.profileTrans.adminProfile\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifcompromisctrl.datepickers.dateEncaissement = !modifcompromisctrl.datepickers.dateEncaissement && (!modifcompromisctrl.verrouillage || modifcompromisctrl.employe.profileTrans.adminProfile)\" ng-class=\"{\'disabled\': modifcompromisctrl.verrouillage && !modifcompromisctrl.employe.profileTrans.adminProfile}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifcompromisctrl.datepickers.dateEncaissement class=\"event-datepicker row\" ng-click=\"::modifcompromisctrl.datepickers.onClose(\'dateEncaissement\')\"><datetime-picker click-prevent time-picker=false date-model=modifcompromisctrl.compromis.dateEncaissement on-close=\"::modifcompromisctrl.datepickers.onClose(\'dateEncaissement\')\"></datetime-picker></div></div><label for=archive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=\"modifcompromisctrl.compromis.dateEffectiveVente!=\'\'\">Archiv&eacute;</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=modifcompromisctrl.compromis.archiver ng-if=\"modifcompromisctrl.compromis.dateEffectiveVente!=\'\'\" ng-disabled=\"modifcompromisctrl.verrouillage && !modifcompromisctrl.employe.profileTrans.adminProfile\"></div></div><div class=row><label for=prixVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Prix de vente</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=prixVente name=prixVente required class=form-control placeholder=0 ng-model=modifcompromisctrl.compromis.affaire.mandatTransaction.prixVente ng-blur=\"modifcompromisctrl.calculCommission(\'prixVente\')\" ng-disabled=modifcompromisctrl.verrouillage></div><div class=\"col-xs-12 col-md-5 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Tx. Hono.</label><div class=\"col-xs-12 col-sm-2 col-md-3 spacer-bottom\"><input ng-if=!modifcompromisctrl.employe.societe.agence.surPrixVente custom-type=number title=\"Tx. Comm.\" name=tauxComm required class=form-control placeholder=0 ng-blur=\"modifcompromisctrl.calculCommission(\'tauxComm\')\" ng-model=modifcompromisctrl.compromis.affaire.mandatTransaction.tauxComm ng-disabled=modifcompromisctrl.verrouillage> <input ng-if=modifcompromisctrl.employe.societe.agence.surPrixVente custom-type=number title=\"Tx. Comm.\" name=tauxCommInv required class=form-control placeholder=0 ng-blur=\"modifcompromisctrl.calculCommission(\'tauxCommInv\')\" ng-model=modifcompromisctrl.tauxCommInv ng-disabled=modifcompromisctrl.verrouillage></div><label for=commission class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Hono. TTC</label><div class=\"col-xs-12 col-sm-5 col-md-5 spacer-bottom\"><input custom-type=number id=commission class=form-control placeholder=0 ng-model=modifcompromisctrl.commission ng-blur=\"modifcompromisctrl.calculCommission(\'commission\')\" ng-disabled=modifcompromisctrl.verrouillage></div></div></div><div class=row><label for=prixVenteNet class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Prix (net vendeur)</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=prixVenteNet name=prixVente class=form-control placeholder=0 ng-model=modifcompromisctrl.prixVenteNet ng-blur=\"modifcompromisctrl.calculCommission(\'prixVenteNet\')\" ng-disabled=modifcompromisctrl.verrouillage></div><div class=\"col-xs-12 col-md-5 no-padding\"><label for=tva class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">TVA</label><div class=\"col-xs-12 col-sm-2 col-md-3 spacer-bottom\"><input custom-type=number id=tva name=tauxComm ng-required=!modifcompromisctrl.citya ng-disabled=modifcompromisctrl.citya class=form-control placeholder=0 step=0.1 ng-model=modifcompromisctrl.compromis.tva ng-blur=\"modifcompromisctrl.calculCommission(\'tva\')\"></div><label for=commissionHT class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Hono. HT</label><div class=\"col-xs-12 col-sm-5 col-md-5 spacer-bottom\"><input custom-type=number id=commissionHT class=form-control placeholder=0 ng-model=modifcompromisctrl.commissionHT ng-blur=\"modifcompromisctrl.calculCommission(\'commissionHT\')\" ng-disabled=modifcompromisctrl.verrouillage></div></div></div><div class=row><label for=honoChargeVendeur class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. Vendeur</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=honoChargeVendeur name=honoProprietaire class=form-control placeholder=0 ng-model=modifcompromisctrl.compromis.honoChargeVendeur ng-disabled=modifcompromisctrl.verrouillage></div><label for=honoChargeAquereur class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. Acheteur</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=honoChargeAquereur name=honoLocataire class=form-control placeholder=0 ng-model=modifcompromisctrl.compromis.honoChargeAquereur ng-disabled=modifcompromisctrl.verrouillage></div></div><div class=row><label for=numeroSequestre class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">N° de <span ng-if=modifcompromisctrl.citya>re&ccedil;u</span> <span ng-if=!modifcompromisctrl.citya>sequestre</span></label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input type=text id=numeroSequestre class=form-control ng-model=modifcompromisctrl.compromis.numeroSequestre ng-disabled=modifcompromisctrl.verrouillage></div><label for=montantSequestre class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Montant de sequestre</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=montantSequestre class=form-control ng-model=modifcompromisctrl.compromis.montantSequestre ng-disabled=modifcompromisctrl.verrouillage></div></div><div class=row><label for=commentaire class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-9 col-md-8 spacer-bottom\"><textarea rows=4 id=commentaire class=form-control ng-model=modifcompromisctrl.compromis.conditionSuspensive ng-disabled=modifcompromisctrl.verrouillage></textarea></div></div><div class=\"row spacer-bottom\"><uib-accordion close-others=false><!-- Nego supplémentaires --><div class=col-xs-12><div uib-accordion-group is-open=modifcompromisctrl.negoSuppOpen><uib-accordion-heading>Negociateurs <i class=\"fa fa-fw\" ng-class=\"{\r\n                             \'fa-chevron-up\': modifcompromisctrl.negoSuppOpen,\r\n                             \'fa-chevron-down\': !modifcompromisctrl.negoSuppOpen\r\n                           }\"></i></uib-accordion-heading><nego-supp contrat=modifcompromisctrl.compromis is-disabled=modifcompromisctrl.verrouillage></nego-supp></div></div><!-- Liste des gravitants --><div class=col-xs-12><div uib-accordion-group is-open=modifcompromisctrl.gravitantsIsOpen><uib-accordion-heading>Tiers <i class=\"fa fa-fw\" ng-class=\"{\r\n                             \'fa-chevron-up\': modifcompromisctrl.gravitantsIsOpen,\r\n                             \'fa-chevron-down\': !modifcompromisctrl.gravitantsIsOpen\r\n                           }\"></i></uib-accordion-heading><div class=\"col-xs-12 col-md-8 col-md-offset-2\"><liste-gravitants gravitants=modifcompromisctrl.compromis.listeGravitant is-disabled=modifcompromisctrl.verrouillage></liste-gravitants></div></div></div><!-- Suivi remises --><div class=col-xs-12><div uib-accordion-group is-open=modifcompromisctrl.suiviRemiseOpen><uib-accordion-heading>Suivi Remises <i class=\"fa fa-fw\" ng-class=\"{\r\n                             \'fa-chevron-up\': modifcompromisctrl.suiviRemiseOpen,\r\n                             \'fa-chevron-down\': !modifcompromisctrl.suiviRemiseOpen\r\n                           }\"></i></uib-accordion-heading><div class=\"row remises\"><div class=col-xs-12><table class=\"table table-bordered table-condensed\"><thead><tr><th><a href=# ng-click=\"modifcompromisctrl.remises.toggleTri(\'dateRemise\')\">Date remise <span class=\"fa fa-caret-down\" ng-show=\"modifcompromisctrl.remises.tri == \'dateRemise\' && !modifcompromisctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifcompromisctrl.remises.tri == \'dateRemise\' && modifcompromisctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifcompromisctrl.remises.toggleTri(\'prixDepart\')\">Prix de d&eacute;part <span class=\"fa fa-caret-down\" ng-show=\"modifcompromisctrl.remises.tri == \'prixDepart\' && !modifcompromisctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifcompromisctrl.remises.tri == \'prixDepart\' && modifcompromisctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifcompromisctrl.remises.toggleTri(\'prixFinal\')\">Prix remis&eacute; <span class=\"fa fa-caret-down\" ng-show=\"modifcompromisctrl.remises.tri == \'prixFinal\' && !modifcompromisctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifcompromisctrl.remises.tri == \'prixFinal\' && modifcompromisctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifcompromisctrl.remises.toggleTri(\'remise\')\">Taux remise <span class=\"fa fa-caret-down\" ng-show=\"modifcompromisctrl.remises.tri == \'remise\' && !modifcompromisctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifcompromisctrl.remises.tri == \'remise\' && modifcompromisctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifcompromisctrl.remises.toggleTri(\'nego\')\">N&eacute;go. <span class=\"fa fa-caret-down\" ng-show=\"modifcompromisctrl.remises.tri == \'nego\' && !modifcompromisctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifcompromisctrl.remises.tri == \'nego\' && modifcompromisctrl.remises.ordre\"></span></a></th></tr></thead><tbody><tr ng-repeat=\"remise in modifcompromisctrl.remises.list | orderBy:modifcompromisctrl.remises.tri:modifcompromisctrl.remises.ordre\"><td>{{remise.dateRemise}}</td><td>{{remise.prixDepart | tgnFormat: \'number\'}}</td><td>{{remise.prixFinal | tgnFormat: \'number\'}}</td><td>{{remise.remise | tgnFormat: \'number\'}}%</td><td>{{remise.nego.perso ? remise.nego.perso.nomComplet : remise.nego.initiales}}</td></tr></tbody></table></div></div></div></div></uib-accordion></div></div></div><div class=\"row compromis-controls\"><div class=\"col-xs-6 col-sm-4 col-sm-offset-2 col-lg-2 col-lg-offset-4 spacer-top spacer-bottom text-right\"><button type=button class=\"btn-custom btn-custom-block btn-danger\" ng-click=modifcompromisctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <span class=hidden-xs>Supprimer</span></button></div><div class=\"col-xs-6 col-sm-4 col-lg-2 spacer-top spacer-bottom\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-secondary btn-save\"><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Enregister</span></button></div></div></form><div ng-if=modifcompromisctrl.loading class=loader></div></div></div></div>");
$templateCache.put("app/components/main-content/modif-prospect/modif-prospect.html","<div class=\"main-content flex-item flex-container modif-prospect\"><div ng-if=!modifprospectctrl.citya ncy-breadcrumb></div><div class=flex-item lazy-load><div class=container-fluid ng-switch=modifprospectctrl.timeline.current><form class=form-horizontal name=modifprospectctrl.form ng-submit=modifprospectctrl.save() novalidate><validation-viewer ng-if=!modifprospectctrl.loading vv-timeline=modifprospectctrl.timeline></validation-viewer><div class=row><!--<div class=\"col-xs-6 spacer-top\">\r\n            <button type=\"button\" class=\"btn-custom btn-custom-sm btn-custom-secondary\"\r\n                    ng-click=\"modifprospectctrl.goBack()\">\r\n              <i class=\"fa fa-fw fa-arrow-left\"></i> <span class=\"hidden-xs\">Retour</span>\r\n            </button>\r\n          </div>--><div class=\"col-xs-12 spacer-top text-right\"><button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifprospectctrl.plusDeBiens()><i class=\"fa fa-fw fa-search\"></i> Chercher des biens</button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifprospectctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <span class=hidden-xs>Imprimer</span></button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=::modifprospectctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <span class=hidden-xs>Envoyer</span></button></div><div class=\"col-xs-12 no-padding\"><timeline-horizontal liste-etapes=modifprospectctrl.timeline.etapes etape-courante=modifprospectctrl.timeline.current on-change-etape=modifprospectctrl.timeline.onChange(id)></timeline-horizontal></div><div class=\"col-xs-12 prospect-etape\" ng-switch-when=1><personnalite personnalite=modifprospectctrl.prospect.perso etat-civil=true is-required=true is-loading=modifprospectctrl.loading></personnalite></div><div class=\"col-xs-12 prospect-etape\" ng-switch-when=2><criteres-prospect prospect=modifprospectctrl.prospect is-loading=modifprospectctrl.loading validation=modifprospectctrl.form></criteres-prospect></div><div class=\"col-xs-12 prospect-etape\" ng-switch-when=3><etat-prospect prospect=modifprospectctrl.prospect is-loading=modifprospectctrl.loading></etat-prospect></div><div class=\"col-xs-12 prospect-etape\" ng-switch-when=4><prospect-panier prospect=modifprospectctrl.prospect is-loading=modifprospectctrl.loading></prospect-panier></div><div class=\"col-xs-12 prospect-etape\" ng-switch-when=5><communication prospect=modifprospectctrl.prospect is-loading=modifprospectctrl.loading></communication></div><div class=clearfix></div><div class=timeline-etapes-controls><div class=\"col-xs-2 col-md-3 col-lg-4 text-left no-padding-left\"><button type=button class=\"btn-custom btn-custom-secondary tec-prev\" ng-if=\"modifprospectctrl.timeline.current > 1\" ng-click=modifprospectctrl.timeline.prev()><i class=\"fa fa-fw fa-chevron-left\"></i> <span class=\"hidden-xs hidden-sm\">Etape Precedente</span></button></div><div class=\"col-xs-4 col-md-3 col-lg-2 text-right no-padding-left\"><button type=button class=\"btn-custom btn-custom-block tec-delete\" ng-click=modifprospectctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <span class=hidden-xs>Supprimer</span></button></div><div class=\"col-xs-4 col-md-3 col-lg-2 text-center no-padding-right\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-secondary tec-save\"><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Enregister</span></button></div><div class=\"col-xs-2 col-md-3 col-lg-4 text-right no-padding-right\"><button type=button class=\"btn-custom btn-custom-secondary tec-next\" ng-if=\"modifprospectctrl.timeline.current < modifprospectctrl.timeline.etapes.etapes.length\" ng-click=modifprospectctrl.timeline.next()><span class=\"hidden-xs hidden-sm\">Etape Suivante</span> <i class=\"fa fa-fw fa-chevron-right\"></i></button></div></div></div></form><div ng-if=modifprospectctrl.loading class=loader></div></div></div></div>");
$templateCache.put("app/components/main-content/panneaux/panneaux.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!panneauxctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\" ng-if=!panneauxctrl.initialisation><!-- Search Box --><search-box sb-on-search=\"panneauxctrl.getList(search, false)\" sb-config=panneauxctrl.searchBoxOptions></search-box><!-- /End Search Box --><!-- Panneaux List --><div class=\"panneaux-list flex-item flex-container\"><div ng-if=panneauxctrl.noResults class=\"no-results col-xs-12 text-center\">Aucun résultat</div><div class=\"flex-item panneaux-container\" lazy-load=\"::panneauxctrl.getList(false, true)\"><div class=\"col-xs-12 text-center\"><span ng-if=\"panneauxctrl.panneaux.nbpanneaux > 0\" class=nb-results>{{panneauxctrl.panneaux.nbpanneaux}} bien{{panneauxctrl.panneaux.pluriel}}</span></div><bloc-panneau ng-repeat=\"panneau in panneauxctrl.panneaux.list\" panneau=panneau template=panneauxctrl.template class=panneau-container ng-class=\"{\r\n                          \'col-xxs-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2\': panneauxctrl.template === \'grid\',\r\n                          \'col-xs-12 col-lg-6 col-xl-4\': panneauxctrl.template === \'list\',\r\n                          \'col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2\': panneauxctrl.template === \'listNoPhotos\'\r\n				                }\" on-show-fiche=::panneauxctrl.showFicheProperty(refLot) is-last=$last on-all-ready=::panneauxctrl.imgResize() bloc-height=panneauxctrl.blocBienHeight repeat-complete=panneauxctrl.imgResize()></bloc-panneau><div ng-if=panneauxctrl.loading class=loader></div></div></div><!-- /End Properties List --></div><div class=loader ng-if=panneauxctrl.initialisation></div></div>");
$templateCache.put("app/components/main-content/modif-reservation/modif-reservation.html","<div class=\"main-content flex-item flex-container modif-reservation\"><div ng-if=!modifreservationctrl.citya ncy-breadcrumb></div><div class=flex-item lazy-load><div class=container-fluid><form class=\"form-horizontal col-xs-12\" name=modifreservationctrl.form ng-if=modifreservationctrl.reservation ng-submit=modifreservationctrl.save() novalidate><div class=row><div class=\"reservation-titre flex-container-column\"><h3 class=\"titre-num flex-item\">R&Eacute;SERVATION N&deg;{{::modifreservationctrl.reservation.id}}</h3><div class=titre-action><button type=button class=\"btn-custom btn-custom-sm btn-custom-secondary\" ng-click=modifreservationctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <span class=hidden-xs>Imprimer</span></button></div></div></div><div class=row><!-- Proprietaire --><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifreservationctrl.reservation.affaire.proprietaire titre-bloc=\"\'PROPRIETAIRE\'\"></bloc-perso><div class=nego-proprietaire>N&eacute;go : {{modifreservationctrl.reservation.affaire.mandatLocation.nego.perso.getNomComplet()}}</div></div><!-- Locataire --><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=modifreservationctrl.reservation.locataire.perso titre-bloc=\"\'LOCATAIRE\'\" template-right=true is-editable=\"!modifreservationctrl.isDisabled(\'locataire\')\" type-perso=\"\'locataire\'\" is-prospect=true on-select-prospect=modifreservationctrl.setLocataire(prospect)></bloc-perso><div class=nego-locataire>N&eacute;go : {{modifreservationctrl.reservation.locataire.nego.perso.getNomComplet()}}</div></div></div><!-- Colocataire(s) --><div class=row><div class=\"col-xs-12 col-md-6 col-md-offset-6\"><bloc-perso perso=modifreservationctrl.reservation.colocataire titre-bloc=\"\'COLOCATAIRE\'\" template-right=true is-editable=\"!modifreservationctrl.isDisabled(\'colocataire\')\" type-perso=\"\'locataire\'\"></bloc-perso></div></div><!-- Affaire --><div class=row><div class=col-xs-12><div class=\"bloc-affaire col-xs-12\"><div class=affaire-titre><div class=\"affaire-titre-label col-xs-12 text-center\">AFFAIRE <a class=\"btn-custom btn-custom-sm btn-custom-primary pull-right btn-edit-affaire\" ng-click=modifreservationctrl.openAffaire() tooltip-placement=\"auto top\" uib-tooltip=\"Ouvrir la saisie du lot\"><i class=\"fa fa-fw fa-pencil\"></i> </a><a class=\"btn-custom btn-custom-sm btn-custom-primary pull-right btn-reload\" ng-click=\"modifreservationctrl.calculHonoraires(\'reload\')\" tooltip-placement=\"auto top\" uib-tooltip=\"Recharger les informations du mandat\"><i class=\"fa fa-fw fa-refresh\"></i></a></div></div><div class=\"affaire-content col-xs-12 text-center\">{{::modifreservationctrl.reservation.affaire.getFormatedLibelle()}}</div></div></div></div><hr class=darken-separator><div class=row><!-- Détails réservation --><div class=\"reservation-details col-xs-12 spacer-top\"><div class=row><label for=date class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date r&eacute;servation</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=date custom-type=date name=date ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.date ng-disabled=\"modifreservationctrl.isDisabled(\'date\')\"> <span ng-class=modifreservationctrl.datepickers.date.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'date\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.date.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'date\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'date\')\" date-model=modifreservationctrl.reservation.date></datetime-picker></div></div><label for=dateFinOption class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date fin r&eacute;servation</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=dateFinOption custom-type=date name=dateFinOption ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateFinOption ng-disabled=\"modifreservationctrl.isDisabled(\'dateFinOption\')\"> <span ng-class=modifreservationctrl.datepickers.dateFinOption.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateFinOption\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateFinOption.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateFinOption\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateFinOption\')\" date-model=modifreservationctrl.reservation.dateFinOption></datetime-picker></div></div></div><div class=row><label for=datePrevueVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date validation dossier</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><div class=input-group><input id=datePrevueVente custom-type=date name=datePrevueVente ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.datePrevueVente ng-disabled=\"modifreservationctrl.isDisabled(\'datePrevueVente\')\"> <span ng-class=modifreservationctrl.datepickers.datePrevueVente.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'datePrevueVente\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.datePrevueVente.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'datePrevueVente\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'datePrevueVente\')\" date-model=modifreservationctrl.reservation.datePrevueVente></datetime-picker></div></div><label for=dateEffectiveVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date d&apos;effet du bail</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=!modifreservationctrl.citya><div class=input-group><input id=dateEffectiveVente custom-type=date name=dateEffectiveVente ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEffectiveVente ng-disabled=\"modifreservationctrl.isDisabled(\'dateEffectiveVente\')\"> <span ng-class=modifreservationctrl.datepickers.dateEffectiveVente.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEffectiveVente\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEffectiveVente.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEffectiveVente\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEffectiveVente\')\" date-model=modifreservationctrl.reservation.dateEffectiveVente></datetime-picker></div></div><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=modifreservationctrl.citya><div class=input-group><input id=dateEffectiveVente custom-type=date name=dateEffectiveVente ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEffectBail ng-disabled=\"modifreservationctrl.isDisabled(\'dateEffectiveVente\')\"> <span ng-class=modifreservationctrl.datepickers.dateEffectiveVente.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEffectiveVente\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEffectiveVente.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEffectiveVente\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEffectiveVente\')\" date-model=modifreservationctrl.reservation.dateEffectBail></datetime-picker></div></div></div><div class=row><label for=dateEtatDesLieux class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=!modifreservationctrl.citya>Date &eacute;tat des lieux</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=!modifreservationctrl.citya><div class=input-group><input id=dateEtatDesLieux custom-type=date name=dateEtatDesLieux ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEtatDesLieux ng-disabled=\"modifreservationctrl.isDisabled(\'dateEtatDesLieux\')\"> <span ng-class=modifreservationctrl.datepickers.dateEtatDesLieux.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEtatDesLieux\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEtatDesLieux.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEtatDesLieux\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEtatDesLieux\')\" date-model=modifreservationctrl.reservation.dateEtatDesLieux></datetime-picker></div></div><label for=dateSignature class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date signature bail</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=!modifreservationctrl.citya><div class=input-group><input id=dateSignature custom-type=date name=dateSignature ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateSignature ng-disabled=\"modifreservationctrl.isDisabled(\'dateSignature\')\"> <span ng-class=modifreservationctrl.datepickers.dateSignature.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateSignature\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateSignature.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateSignature\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateSignature\')\" date-model=modifreservationctrl.reservation.dateSignature></datetime-picker></div></div><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=modifreservationctrl.citya><div class=input-group><input id=dateSignature custom-type=date name=dateSignature ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEffectiveVente ng-disabled=\"modifreservationctrl.isDisabled(\'dateSignature\')\"> <span ng-class=modifreservationctrl.datepickers.dateSignature.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateSignature\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateSignature.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateSignature\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateSignature\')\" date-model=modifreservationctrl.reservation.dateEffectiveVente></datetime-picker></div></div><label for=dateEncaissement class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=modifreservationctrl.citya>Date contr&ocirc;le comptable</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=modifreservationctrl.citya><div class=input-group><input id=dateEncaissement custom-type=date name=dateEncaissement ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEncaissement ng-disabled=\"modifreservationctrl.isDisabled(\'dateEncaissement\')\"> <span ng-class=modifreservationctrl.datepickers.dateEncaissement.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEncaissement\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEncaissement.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEncaissement\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEncaissement\')\" date-model=modifreservationctrl.reservation.dateEncaissement></datetime-picker></div></div></div><div class=row><label for=dateEncaissement class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=!modifreservationctrl.citya>Date contr&ocirc;le comptable</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\" ng-if=!modifreservationctrl.citya><div class=input-group><input id=dateEncaissement custom-type=date name=dateEncaissement ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEncaissement ng-disabled=\"modifreservationctrl.isDisabled(\'dateEncaissement\')\"> <span ng-class=modifreservationctrl.datepickers.dateEncaissement.class class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEncaissement\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEncaissement.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEncaissement\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEncaissement\')\" date-model=modifreservationctrl.reservation.dateEncaissement></datetime-picker></div></div></div><div class=row><label for=archive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">{{modifreservationctrl.reservation.hasDateEffectiveVente() ? \'Location\' : \'Compromis\'}}&nbsp;archiv&eacute;e</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=modifreservationctrl.reservation.archiver ng-disabled=\"modifreservationctrl.isDisabled(\'archive\')\"></div></div><div class=row><label for=loyer class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Loyer</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=loyer name=loyer required class=form-control placeholder=0 ng-model=modifreservationctrl.reservation.loyer ng-disabled=\"modifreservationctrl.isDisabled(\'loyer\')\" ng-model-options=\"{debounce: 350}\" ng-change=\"modifreservationctrl.calculHonoraires(\'loyer\')\" ng-class=\"{\'validation-error\': modifreservationctrl.form.loyer.$error.required && modifreservationctrl.form.$submitted}\"></div><label for=honorairesHT class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. HT</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=honorairesHT name=honorairesHT class=form-control placeholder=0 ng-model=modifreservationctrl.honorairesHT ng-disabled=\"modifreservationctrl.isDisabled(\'honorairesHT\')\" ng-model-options=\"{debounce: 350}\" ng-required=\"!modifreservationctrl.honorairesHT && !modifreservationctrl.honoraires\" ng-change=\"modifreservationctrl.calculHonoraires(\'honorairesHT\')\"></div></div><div class=row><label for=tva class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Taux de TVA</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=tva name=tva ng-required=!modifreservationctrl.citya ng-disabled=\"modifreservationctrl.isDisabled(\'tva\')\" class=form-control placeholder=0 ng-model=modifreservationctrl.reservation.tva step=0.1 ng-model-options=\"{debounce: 350}\" ng-change=\"modifreservationctrl.calculHonoraires(\'tva\')\"></div><label for=honoraires class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. TTC</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom\"><input custom-type=number id=honoraires name=honoraires class=form-control placeholder=0 ng-model=modifreservationctrl.honoraires ng-model-options=\"{debounce: 350}\" ng-required=\"!modifreservationctrl.honoraires && !modifreservationctrl.honorairesHT\" ng-disabled=\"modifreservationctrl.isDisabled(\'honoraires\')\" ng-change=\"modifreservationctrl.calculHonoraires(\'honoraires\')\"></div></div><div class=row><label for=honoProprietaire class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. Propri&eacute;taire</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom no-padding\"><div class=col-xs-12><input custom-type=number id=honoProprietaire name=honoProprietaire class=form-control required placeholder=0 ng-model=modifreservationctrl.reservation.honoProprietaire ng-model-options=\"{debounce: 350}\" ng-change=\"modifreservationctrl.calculHonoraires(\'honoProprietaire\')\" ng-disabled=\"modifreservationctrl.isDisabled(\'honoProprietaire\')\" ng-class=\"{\'validation-error\': modifreservationctrl.form.honoProprietaire.$error.required && modifreservationctrl.form.$submitted}\"></div><div class=intended-list-container><div class=intended-list><dl><dt>{{modifreservationctrl.reservation.honoVDB | currency : \'€\' : 0}} ({{modifreservationctrl.reservation.honoPRVDB | tgnFormat: \'number\'}} &euro;)</dt><dd><em>VDB</em></dd></dl><dl><dt>{{modifreservationctrl.reservation.honoEDL | currency : \'€\' : 0}} ({{modifreservationctrl.reservation.honoPREDL | tgnFormat: \'number\'}} &euro;)</dt><dd><em>EDL</em></dd></dl><dl><dt>{{modifreservationctrl.reservation.entremiseFixe | currency : \'€\' : 0}} ({{modifreservationctrl.reservation.honoEntremise | tgnFormat: \'number\'}} &euro;)</dt><dd><em>Entremise</em></dd></dl><dl><dt>{{modifreservationctrl.remises.proprietaire.value | tgnFormat: \'integer\'}} %</dt><dd><em>{{modifreservationctrl.remises.proprietaire.text}}</em></dd></dl></div></div></div><label for=honoLocataire class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. Locataire</label><div class=\"col-xs-12 col-sm-9 col-md-3 spacer-bottom no-padding\"><div class=col-xs-12><input custom-type=number id=honoLocataire name=honoLocataire required class=form-control placeholder=0 ng-model=modifreservationctrl.reservation.honoLocataire ng-model-options=\"{debounce: 500}\" ng-change=\"modifreservationctrl.calculHonoraires(\'honoLocataire\')\" ng-disabled=\"modifreservationctrl.isDisabled(\'honoLocataire\')\"></div><div class=intended-list-container><div class=intended-list><dl><dt>{{::modifreservationctrl.reservation.affaire.mandatLocation.honoraireVDB | tgnFormat: \'number\'}} &euro; ({{modifreservationctrl.reservation.honoLRVDB | tgnFormat: \'number\'}} &euro;)</dt><dd><em>VDB</em></dd></dl><dl><dt>{{::modifreservationctrl.reservation.affaire.mandatLocation.honoraireEDL | tgnFormat: \'number\'}} &euro; ({{modifreservationctrl.reservation.honoLREDL | tgnFormat: \'number\'}} &euro;)</dt><dd><em>EDL</em></dd></dl><dl><dt>{{modifreservationctrl.remises.locataire.value | tgnFormat: \'integer\'}} %</dt><dd><em>{{modifreservationctrl.remises.locataire.text}}</em></dd></dl></div></div></div></div><div class=row><label for=conditionSuspensive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-9 col-md-8 spacer-bottom\"><textarea rows=4 id=conditionSuspensive class=form-control ng-model=modifreservationctrl.reservation.conditionSuspensive ng-disabled=\"modifreservationctrl.isDisabled(\'conditionSuspensive\')\"></textarea></div></div><div class=row ng-if=\"modifreservationctrl.citya && modifreservationctrl.dossierLocataireAfficher\"><div class=\"col-xs-12 spacer-bottom text-center\"><button type=button class=\"btn-custom btn-custom-primary\" ng-disabled=\"modifreservationctrl.isDisabled(\'dossierLocataire\')\" ng-click=modifreservationctrl.dossierLocataire()>Envoyer dossier locataire</button></div></div><div class=\"row spacer-bottom\"><uib-accordion close-others=false><!-- Nego supplémentaires --><div class=col-xs-12 ng-if=!modifreservationctrl.citya><div uib-accordion-group is-open=modifreservationctrl.negoSuppOpen><uib-accordion-heading>Negociateurs <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': modifreservationctrl.negoSuppOpen, \'fa-chevron-down\': !modifreservationctrl.negoSuppOpen}\"></i></uib-accordion-heading><nego-supp contrat=modifreservationctrl.reservation></nego-supp></div></div><!-- Info bail --><div class=col-xs-12><div uib-accordion-group is-open=modifreservationctrl.infoBailOpen><uib-accordion-heading>Info. Bail <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': modifreservationctrl.infoBailOpen, \'fa-chevron-down\': !modifreservationctrl.infoBailOpen}\"></i></uib-accordion-heading><info-bail reservation=modifreservationctrl.reservation is-disabled=\"modifreservationctrl.isDisabled(\'infosBail\')\"></info-bail></div></div><!-- Suivi remises --><div class=col-xs-12><div uib-accordion-group is-open=modifreservationctrl.suiviRemiseOpen><uib-accordion-heading>Suivi Remises <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': modifreservationctrl.suiviRemiseOpen, \'fa-chevron-down\': !modifreservationctrl.suiviRemiseOpen}\"></i></uib-accordion-heading><div class=\"row remises\"><div class=col-xs-12><table class=\"table table-bordered table-condensed\"><thead><tr><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'dateRemise\')\">Date remise <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'dateRemise\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'dateRemise\' && modifreservationctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'prixDepart\')\">Prix de d&eacute;part <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'prixDepart\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'prixDepart\' && modifreservationctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'prixFinal\')\">Prix remis&eacute; <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'prixFinal\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'prixFinal\' && modifreservationctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'remise\')\">Taux remise <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'remise\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'remise\' && modifreservationctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'nego\')\">N&eacute;go. <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'nego\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'nego\' && modifreservationctrl.remises.ordre\"></span></a></th><th><a href=# ng-click=\"modifreservationctrl.remises.toggleTri(\'beneficiaire\')\">B&eacute;n&eacute;ficiaire <span class=\"fa fa-caret-down\" ng-show=\"modifreservationctrl.remises.tri == \'beneficiaire\' && !modifreservationctrl.remises.ordre\"></span> <span class=\"fa fa-caret-up\" ng-show=\"modifreservationctrl.remises.tri == \'beneficiaire\' && modifreservationctrl.remises.ordre\"></span></a></th></tr></thead><tbody><tr ng-repeat=\"remise in modifreservationctrl.remises.list | orderBy:modifreservationctrl.remises.tri:modifreservationctrl.remises.ordre\"><td>{{remise.dateRemise}}</td><td>{{remise.prixDepart | tgnFormat: \'number\'}} &euro;</td><td>{{remise.prixFinal | tgnFormat: \'number\'}} &euro;</td><td>{{remise.remise | tgnFormat: \'number\'}}%</td><td>{{remise.nego.perso ? remise.nego.perso.nomComplet : remise.nego.initiales}}</td><td><span ng-if=!remise.proprietaire>Locataire</span> <span ng-if=remise.proprietaire>Propriétaire</span></td></tr></tbody></table></div></div></div></div><!-- Suivi encaissement --><div class=col-xs-12><div uib-accordion-group is-open=modifreservationctrl.suiviEncaissementOpen><uib-accordion-heading>Suivi Encaissements <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': modifreservationctrl.suiviEncaissementOpen, \'fa-chevron-down\': !modifreservationctrl.suiviEncaissementOpen}\"></i></uib-accordion-heading><div class=\"row encaissements-controls\"><div class=\"col-xs-12 no-padding encaissements-new\"><label for=dateNewEncaissement class=\"col-xs-12 col-sm-3 col-md-2 col-lg-1 control-label no-padding-left\">Date</label><div class=\"col-xs-12 col-sm-9 col-md-3 col-lg-2 spacer-bottom\"><div class=input-group><input id=dateNewEncaissement custom-type=date name=dateNewEncaissement ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.encaissements.current.date ng-disabled=\"modifreservationctrl.isDisabled(\'dateNewEncaissement\')\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateNewEncaissement\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateNewEncaissement.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateNewEncaissement\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateNewEncaissement\')\" date-model=modifreservationctrl.encaissements.current.date></datetime-picker></div></div><label for=montantNewEncaissement class=\"col-xs-12 col-sm-3 col-md-2 col-lg-1 control-label no-padding-left\">Somme</label><div class=\"col-xs-12 col-sm-9 col-md-3 col-lg-2 spacer-bottom\"><input type=number id=montantNewEncaissement name=montantNewEncaissement class=form-control placeholder=0 ng-model=modifreservationctrl.encaissements.current.valeur></div><div class=clearfix-md></div><label for=affectationNewEncaissement class=\"col-xs-12 col-sm-3 col-md-2 col-lg-1 control-label no-padding-left\">Affect&eacute; au</label><div class=\"col-xs-12 col-sm-9 col-md-3 col-lg-2 spacer-bottom\"><ui-select id=affectationNewEncaissement ng-model=modifreservationctrl.encaissements.current.sortant theme=bootstrap close-on-select=true><ui-select-match placeholder=Affectation...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"affectation.value as affectation in modifreservationctrl.encaissements.affectations | filter: $select.search\"><span ng-bind-html=\"::affectation.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-4 col-md-3 col-md-offset-2 col-lg-2 col-lg-offset-0\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary\" ng-click=modifreservationctrl.encaissements.ajouter()><i class=\"fa fa-fw fa-plus\"></i> Ajouter</button></div></div></div><div class=\"row encaissements\"><div class=col-xs-12><table class=\"table table-bordered table-condensed\"><thead><tr><th style=\"width: calc(33.34% - 26px)\"><a href=# ng-click=\"modifreservationctrl.encaissements.toggleTri(\'date\')\">Date de saisie <span ng-show=\"modifreservationctrl.encaissements.tri == \'date\' && !modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-down\"></span> <span ng-show=\"modifreservationctrl.encaissements.tri == \'date\' && modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-up\"></span></a></th><th style=\"width: calc(33.33% - 26px)\"><a href=# ng-click=\"modifreservationctrl.encaissements.toggleTri(\'valeur\')\">Somme encaiss&eacute;e <span ng-show=\"modifreservationctrl.encaissements.tri == \'valeur\' && !modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-down\"></span> <span ng-show=\"modifreservationctrl.encaissements.tri == \'valeur\' && modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-up\"></span></a></th><th style=\"width: calc(33.33% - 26px)\"><a href=# ng-click=\"modifreservationctrl.encaissements.toggleTri(\'sortant\')\">Affect&eacute; au <span ng-show=\"modifreservationctrl.encaissements.tri == \'sortant\' && !modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-down\"></span> <span ng-show=\"modifreservationctrl.encaissements.tri == \'sortant\' && modifreservationctrl.encaissements.ordre\" class=\"fa fa-caret-up\"></span></a></th><th style=\"width: 78px\"></th></tr></thead><tbody><tr ng-repeat=\"encaissement in modifreservationctrl.encaissements.list | orderBy:modifreservationctrl.encaissements.tri:modifreservationctrl.encaissements.ordre\"><td><div ng-if=!encaissement.editable>{{encaissement.date}}</div><div ng-if=encaissement.editable><div class=input-group><input id=dateEditEncaissement custom-type=date name=dateEditEncaissement ui-mask=99/99/9999 class=form-control ng-model=modifreservationctrl.reservation.dateEditEncaissement ng-disabled=\"modifreservationctrl.isDisabled(\'dateEditEncaissement\')\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"modifreservationctrl.datepickers.toggle(\'dateEditEncaissement\')\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=modifreservationctrl.datepickers.dateEditEncaissement.isOpen class=\"event-datepicker row\" ng-click=\"modifreservationctrl.datepickers.close(\'dateEditEncaissement\')\"><datetime-picker click-prevent time-picker=false on-close=\"modifreservationctrl.datepickers.close(\'dateEditEncaissement\')\" date-model=modifreservationctrl.reservation.dateEditEncaissement></datetime-picker></div></div></td><td><div ng-if=!encaissement.editable>{{encaissement.valeur}}</div><div ng-if=encaissement.editable><input custom-type=number name=valeurEncaissement class=form-control placeholder=0 min=0 ng-model=encaissement.valeur></div></td><td><div ng-if=!encaissement.editable><span ng-if=encaissement.sortant>Locataire</span> <span ng-if=!encaissement.sortant>Propriétaire</span></div><div ng-if=encaissement.editable><ui-select ng-model=encaissement.sortant theme=bootstrap close-on-select=true><ui-select-match placeholder=Affectation...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"affectation.value as affectation in modifreservationctrl.encaissements.affectations | filter: $select.search\"><span ng-bind-html=\"::affectation.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></td><td><button type=button class=\"btn-custom btn-custom-sm btn-custom-primary\" ng-if=!encaissement.editable ng-click=\"encaissement.editable = true;\"><i class=\"fa fa-fw fa-pencil\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-success\" ng-if=encaissement.editable ng-click=modifreservationctrl.encaissements.modifier(encaissement.id)><i class=\"fa fa-fw fa-check\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-danger\" ng-if=!encaissement.editable ng-click=modifreservationctrl.encaissements.supprimer(encaissement.id)><i class=\"fa fa-fw fa-times\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-danger\" ng-if=encaissement.editable ng-click=\"encaissement.editable = false;\"><i class=\"fa fa-fw fa-undo\"></i></button></td></tr></tbody></table></div></div></div></div></uib-accordion></div></div></div><!-- Contrôles --><div class=\"row reservation-controls\"><div class=\"col-xs-6 col-sm-4 col-sm-offset-2 col-lg-2 col-lg-offset-4 spacer-top spacer-bottom text-right\"><button type=button class=\"btn-custom btn-custom-block btn-danger\" ng-click=modifreservationctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <span class=hidden-xs>Supprimer</span></button></div><div class=\"col-xs-6 col-sm-4 col-lg-2 spacer-top spacer-bottom\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-secondary btn-save\"><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Enregister</span></button></div></div></form><div ng-if=modifreservationctrl.loading class=loader></div></div></div></div>");
$templateCache.put("app/components/main-content/parutions-ics-box/parutions-ics-box.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!parutionsicsboxctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\" ng-if=!parutionsicsboxctrl.initialisation><!-- Search Box --><search-box sb-on-search=\"parutionsicsboxctrl.getList(search, false)\" sb-config=parutionsicsboxctrl.searchBoxOptions></search-box><!-- /End Search Box --><!-- Properties List --><div class=\"parutions-list flex-item flex-container\"><div ng-if=parutionsicsboxctrl.noResults class=\"no-results col-xs-12 text-center\">Aucun résultat</div><div class=\"flex-item parutions-container\" lazy-load=\"::parutionsicsboxctrl.getList(false, true)\"><div class=\"col-xs-12 text-center\"><span ng-if=parutionsicsboxctrl.parutions.nblots class=nb-results>{{parutionsicsboxctrl.parutions.nbparutions}} parution{{parutionsicsboxctrl.parutions.pluriel}} sur {{parutionsicsboxctrl.parutions.nblots}} bien{{parutionsicsboxctrl.parutions.lotspluriel}}</span></div><bloc-parution ng-repeat=\"parution in parutionsicsboxctrl.parutions.list\" parution=parution template=parutionsicsboxctrl.template class=parution-container ng-class=\"{\r\n                           \'col-xxs-12 col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-2\': parutionsicsboxctrl.template === \'grid\',\r\n                           \'col-xs-12 col-lg-6 col-xl-4\': parutionsicsboxctrl.template === \'list\',\r\n                           \'col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2\': parutionsicsboxctrl.template === \'listNoPhotos\'\r\n                         }\" on-show-fiche=::parutionsicsboxctrl.showFicheProperty(refLot) on-set-parution=\"::parutionsicsboxctrl.setParution(lotId, action)\" bloc-height=parutionsicsboxctrl.blocBienHeight is-last=$last on-all-ready=::parutionsicsboxctrl.imgResize() repeat-complete=parutionsicsboxctrl.imgResize()></bloc-parution><div ng-if=parutionsicsboxctrl.loading class=loader></div></div></div><!-- /End Properties List --></div><div class=loader ng-if=parutionsicsboxctrl.initialisation></div></div>");
$templateCache.put("app/components/main-content/repertoire/repertoire.html","<div class=\"main-content flex-item flex-container\"><div ncy-breadcrumb ng-if=!repertoirectrl.isReadOnly></div><div class=\"flex-item flex-container\"><div class=\"repertoire-main-container flex-item flex-container\"><h2 class=\"text-center repertoire-title spacer-bottom\">R&eacute;pertoire<!-- <button type=\"button\" class=\"btn-custom btn-custom-sm btn-custom-primary pull-right\" ng-click=\"repertoirectrl.imprimer()\">\r\n          <i class=\"fa fa-fw fa-print\"></i>\r\n          <span class=\"hidden-xs\"> Imprimer</span>\r\n        </button> --></h2><form class=\"repertoire-criteres spacer-bottom\" ng-submit=repertoirectrl.getList() name=repertoireForm><div class=\"col-xs-12 col-sm-6 col-lg-3\"><input type=text class=form-control ng-model=repertoirectrl.query.rechercheNom placeholder=Nom pattern={{::repertoirectrl.searchPattern}} title=\"3 caractères minimum\" ng-required=repertoirectrl.nomRequired ng-change=repertoirectrl.setRequired() ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-sm-6 col-lg-3\"><ui-select ng-model=repertoirectrl.query.type theme=bootstrap close-on-select=true><ui-select-match placeholder=Type...>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type.value as type in repertoirectrl.typesPerso.list | filter: $select.search track by type.value\"><div ng-bind-html=\"::type.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-12 col-sm-6 col-lg-3\"><input type=text class=form-control ng-model=repertoirectrl.query.rechercheContact placeholder=\"Contact (tel, email...)\" pattern={{::repertoirectrl.searchPattern}} title=\"3 caractères minimum\" ng-required=repertoirectrl.contactRequired ng-change=repertoirectrl.setRequired() ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-sm-6 col-lg-3 text-right\"><button type=submit class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-fw fa-search\"></i>Rechercher</button></div></form><div class=\"repertoire-content col-xs-12 flex-item\"><div class=repertoire-display lazy-load=::repertoirectrl.getList(true)><div class=\"repertoire-list spacer-top\"><div class=\"row no-margin text-center\"><span ng-if=repertoirectrl.repertoire.nb>{{repertoirectrl.repertoire.nb}} r&eacute;sultat{{repertoirectrl.repertoire.nb > 1 ? \'s\' : \'\'}}</span> <span ng-if=repertoirectrl.repertoire.noResult>Aucun r&eacute;sultat</span></div><table class=\"table table-bordered table-hover\" ng-if=repertoirectrl.repertoire.nb><thead><tr><th>Type</th><th>R&eacute;f&eacute;rence</th><th>Civilit&eacute;</th><th>Nom</th><th>Pr&eacute;nom</th><th>Email</th><th>Tel</th><th>Adresse</th><th>Agence - n&eacute;gociateur</th><th class=hidden></th></tr></thead><tbody><tr class=perso ng-repeat=\"perso in repertoirectrl.repertoire.list\" ng-class=\"{\'archive\': perso.archive}\"><td data-title=Type class=text-center><i class=\"fa fa-fw\" ng-class=\"{\r\n                           \'fa-user-o\': perso.physique,\r\n                           \'fa-building-o\': !perso.physique\r\n                         }\"></i></td><td data-title=Référence><span ng-if=perso.archive>(Archiv&eacute;) </span>{{::perso.ref}}</td><td data-title=Civilité>{{::perso.civilite.label}}</td><td data-title=Nom>{{::perso.nom}}</td><td data-title=Prénom>{{::perso.prenom}}</td><td data-title=Email ng-class=\"{\'text-center\': !perso.getEmail()}\">{{perso.getEmail() ? perso.getEmail() : \'-\'}}</td><td data-title=Tel ng-class=\"{\'text-center\': !perso.getTelMobile() && !perso.getTel()}\">{{(perso.getTelMobile() || perso.getTel()) ? perso.getTelMobile() || perso.getTel() : \'-\'}}</td><td data-title=Adresse>{{::perso.adresses[0].rue}}<br>{{::perso.adresses[0].cp}}&nbsp;{{::perso.adresses[0].ville}}</td><td data-title=Agence>{{::perso.societe}} <span ng-if=::perso.nego>- {{::perso.nego}}</span></td><td><span ng-if=perso.actions.lot class=\"perso-action perso-action-lot\" ng-click=repertoirectrl.showFiche(perso.ref)><i class=\"fa fa-fw fa-home\"></i> </span><span ng-if=perso.actions.prospect class=\"perso-action perso-action-prospect\" ng-click=repertoirectrl.showProspect(perso.ref)><i class=\"fa fa-fw fa-user\"></i> </span><span ng-if=perso.getEmail() class=\"perso-action perso-action-email\" ng-click=repertoirectrl.envoyerEmail(perso)><i class=\"fa fa-fw fa-envelope\"></i></span></td></tr></tbody></table><!-- <div class=\"perso row\" ng-repeat=\"perso in repertoirectrl.repertoire.list\" ng-if=\"::((perso.hasNom() || perso.hasPrenom()) || perso.getEmail())\"\r\n              ng-class=\"{\'selected\': perso.selected}\" ng-click=\"::repertoirectrl.togglePerso(perso)\">\r\n              <div class=\"col-xs-12 flex-container-column\">\r\n                <div class=\"perso-infos flex-item\">\r\n                  <i class=\"fa fa-fw\" ng-class=\"{\r\n                      \'fa-user-o\': perso.physique,\r\n                      \'fa-building-o\': !perso.physique\r\n                    }\"></i>\r\n                  <span class=\"perso-nom\">{{::perso.getNomComplet()}}</span>\r\n                  <span class=\"perso-email\" ng-if=\"::perso.getEmail()\">{{::perso.getEmail()}}</span>\r\n                </div>\r\n                <div class=\"perso-actions\">\r\n                  <span ng-if=\"perso.actions.lot\" class=\"perso-action perso-action-lot\" ng-click=\"repertoirectrl.showFiche(perso.ref)\">\r\n                    <i class=\"fa fa-fw fa-home\"></i>\r\n                    <span class=\"hidden-xs\"> Lot</span>\r\n                  </span>\r\n                  <span ng-if=\"perso.actions.prospect\" class=\"perso-action perso-action-prospect\" ng-click=\"repertoirectrl.showProspect(perso.ref)\">\r\n                    <i class=\"fa fa-fw fa-user\"></i>\r\n                    <span class=\"hidden-xs\"> Prospect</span>\r\n                  </span>\r\n                </div>\r\n              </div>\r\n            </div> --><div ng-if=repertoirectrl.loading class=loader></div></div></div></div></div></div></div>");
$templateCache.put("app/components/main-content/reservations/reservations.html","<div class=\"main-content flex-item flex-container\"><div ng-if=!reservationsctrl.citya ncy-breadcrumb></div><div class=\"flex-item flex-container\" ng-if=!reservationsctrl.initialisation><!-- Search Box --><search-box sb-on-search=\"reservationsctrl.reservations.getList(search, false)\" sb-config=reservationsctrl.sbConfig></search-box><!-- /End Search Box --><!-- Reservations List --><div class=\"reservations-list flex-item flex-container\"><div ng-if=!reservationsctrl.reservations.nb class=\"no-results col-xs-12 text-center\">Aucun r&eacute;sultat</div><div class=\"flex-item reservations-container\" lazy-load=\"::reservationsctrl.reservations.getList(false, true)\"><div class=\"col-xs-12 text-center\"><span ng-if=reservationsctrl.reservations.nb class=nb-results>{{reservationsctrl.reservations.nb}} {{reservationsctrl.query.search.type === \'reservation\' ? \'réservation\' : \'location\'}}{{(reservationsctrl.reservations.nb > 1) ? \'s\' : \'\'}}</span></div><bloc-reservation class=\"col-xs-12 col-md-6 col-xl-4\" ng-repeat=\"reservation in reservationsctrl.reservations.list\" reservation=reservation on-show-fiche=reservationsctrl.showFicheReservation(id)></bloc-reservation><div ng-if=reservationsctrl.loading class=loader></div></div></div><!-- /End Reservations List --></div><div class=loader ng-if=reservationsctrl.initialisation></div></div>");
$templateCache.put("app/components/main-content/statistique/statistique.html","<div class=\"form-horizontal col-xs-12\"><div class=statistique><uib-tabset active=activeJustified justified=true><uib-tab index=0 ng-if=statistiquectrl.transac heading=\"Tableau de Bord\"><tableau-bord></uib-tab><uib-tab index=1 heading=\"Statistique Mensuel\"><statistiquemensuel></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/components/main-content/tgn-calendar/tgn-calendar.html","<div class=\"main-content flex-item flex-container\"><div ncy-breadcrumb ng-if=!tgncalendarctrl.isReadOnly></div><div class=\"flex-item flex-container\" lazy-load><div class=\"calendar-main-container col-xs-12\" ng-class=\"{\'is-read-only\': tgncalendarctrl.isReadOnly}\"><h2 class=\"text-center tgnc-title\">{{tgncalendarctrl.calendar.title}} <button type=button class=\"btn-custom btn-custom-sm btn-custom-primary pull-right\" ng-click=tgncalendarctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <span class=hidden-xs>Imprimer</span></button></h2><div class=\"row calendar-controls-container\"><div class=\"col-xs-9 col-sm-5 spacer-bottom\"><div class=btn-group><button type=button class=\"btn-custom btn-custom-sm btn-custom-primary\" mwl-date-modifier date=tgncalendarctrl.calendar.viewDate decrement=tgncalendarctrl.calendar.view ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\"><i class=\"fa fa-fw fa-chevron-left\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-lighten-secondary\" mwl-date-modifier date=tgncalendarctrl.calendar.viewDate set-to-today ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\">Aujourd&apos;hui</button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-primary\" mwl-date-modifier date=tgncalendarctrl.calendar.viewDate increment=tgncalendarctrl.calendar.view ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\"><i class=\"fa fa-fw fa-chevron-right\"></i></button></div></div><div class=\"col-xs-3 col-sm-2 text-center no-padding spacer-bottom\"><button type=button class=\"btn-custom btn-custom-sm btn-custom-primary\" ng-if=!tgncalendarctrl.isReadOnly ng-click=tgncalendarctrl.addEvent()><i class=\"fa fa-fw fa-calendar-plus-o\"></i> <span class=hidden-xs>Cr&eacute;er un &eacute;v&egrave;nement</span></button></div><div class=\"col-xs-12 col-sm-5 text-right spacer-bottom\"><div class=btn-group><button type=button class=\"btn-custom btn-custom-sm btn-custom-checkbox-primary\" ng-model=tgncalendarctrl.calendar.view uib-btn-radio=\"\'month\'\" ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\">Mois</button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-checkbox-primary\" ng-model=tgncalendarctrl.calendar.view uib-btn-radio=\"\'week\'\" ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\">Semaine</button> <button type=button class=\"btn-custom btn-custom-sm btn-custom-checkbox-primary\" ng-model=tgncalendarctrl.calendar.view uib-btn-radio=\"\'day\'\" ng-click=\"tgncalendarctrl.calendar.cellIsOpen = false\">jour</button></div></div></div><div class=row><div class=\"col-xxs-12 col-xs-6 spacer-bottom\" ng-class=\"{\r\n               \'col-sm-5 col-sm-offset-1 col-md-4 col-md-offset-2 col-lg-3 col-lg-offset-3\': tgncalendarctrl.isReadOnly,\r\n               \'col-sm-4 col-md-3 col-lg-2\': !tgncalendarctrl.isReadOnly\r\n             }\"><!-- <ui-select multiple ng-model=\"tgncalendarctrl.societes.societes\" theme=\"bootstrap\" close-on-select=\"true\" on-select=\"tgncalendarctrl.societes.changed()\"\r\n            on-remove=\"tgncalendarctrl.societes.changed()\">\r\n            <ui-select-match placeholder=\"Société...\">\r\n              {{$item.nom}}\r\n            </ui-select-match>\r\n            <ui-select-choices repeat=\"societe in tgncalendarctrl.societes.currentList | filter: $select.search track by societe.id\"\r\n              refresh=\"tgncalendarctrl.societes.search($select.search)\" group-by=\"tgncalendarctrl.societes.groupChoices\" refresh-delay=\"350\">\r\n              <span ng-bind-html=\"::societe.nom | highlight: $select.search\"></span>\r\n            </ui-select-choices>\r\n          </ui-select>\r\n          <span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=\"tgncalendarctrl.societes.societes.length\" ng-click=\"tgncalendarctrl.societes.societes = []; tgncalendarctrl.societes.changed()\">\r\n            <i class=\"fa fa-fw fa-times\"></i>\r\n          </span> --><r-select rs-multiple ng-model=tgncalendarctrl.societes.societes rs-options=tgncalendarctrl.societes.currentList rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé(s)...\'\" rs-on-change=tgncalendarctrl.societes.changed()></r-select></div><div class=\"col-xxs-12 col-xs-6 spacer-bottom\" ng-class=\"{\r\n               \'col-sm-5 col-md-4 col-lg-3\': tgncalendarctrl.isReadOnly,\r\n               \'col-sm-4 col-md-3 col-lg-2\': !tgncalendarctrl.isReadOnly\r\n             }\"><ui-select ng-model=tgncalendarctrl.negos.nego theme=bootstrap close-on-select=true on-select=tgncalendarctrl.negos.changed() on-remove=tgncalendarctrl.negos.changed()><ui-select-match placeholder=Négo... allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in tgncalendarctrl.negos.list | filter: $select.search track by nego.id\" refresh=tgncalendarctrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><br><div class=calendar-container><mwl-calendar events=tgncalendarctrl.events view=tgncalendarctrl.calendar.view view-date=tgncalendarctrl.calendar.viewDate view-title=tgncalendarctrl.calendar.title day-view-start=06:00 day-view-end=22:59 day-view-split=30 day-view-event-width={{tgncalendarctrl.calendar.dayEventWidth}} cell-is-open=tgncalendarctrl.calendar.cellIsOpen cell-auto-open-disabled=true on-event-click=tgncalendarctrl.calendar.eventClicked(calendarEvent) on-timespan-click=\"tgncalendarctrl.calendar.timespanClicked(calendarDate, calendarCell)\"></mwl-calendar></div></div></div></div>");
$templateCache.put("app/components/utils/communication/communication.html","<div class=\"communication-container col-xs-12\" ng-if=communicationctrl.ready><uib-accordion close-others=false><!-- Ajout d\'évènement --><div class=\"col-xs-12 ajoutEvenement\"><div ng-if=communicationctrl.ajoutEvent uib-accordion-group is-open=ajoutIsOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': ajoutIsOpen, \'fa-plus\': !ajoutIsOpen}\"></i> Ajout Evenement</uib-accordion-heading><div class=row><form name=ajoutevenement class=form-horizontal novalidate ng-submit=communicationctrl.addEvenement(ajoutevenement)><div class=\"col-xs-12 col-md-6 no-padding\"><div class=form-group ng-class=\"{\'has-error\':ajoutevenement.dateDebut.$error.required && ajoutevenement.$submitted}\"><label for=dateDebut class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&eacute;but</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateDebut name=dateDebut class=form-control ng-model=communicationctrl.ajout.datedebut required ng-click=\"communicationctrl.ajout.debutOpen = !communicationctrl.ajout.debutOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.ajout.debutOpen = !communicationctrl.ajout.debutOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.ajout.debutOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.ajout.onCloseDebut()><datetime-picker click-prevent model=communicationctrl.ajout.datedebut time-picker on-close=::communicationctrl.ajout.onCloseDebut()></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><div class=form-group ng-class=\"{\'has-error\':ajoutevenement.dateFin.$error.required && ajoutevenement.$submitted}\"><label for=dateFin class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date fin</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateFin name=dateFin class=form-control ng-model=communicationctrl.ajout.datefin required ng-click=\"communicationctrl.ajout.finOpen = !communicationctrl.ajout.finOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.ajout.finOpen = !communicationctrl.ajout.finOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.ajout.finOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.ajout.onCloseFin()><datetime-picker click-prevent model=communicationctrl.ajout.datefin time-picker on-close=::communicationctrl.ajout.onCloseFin()></datetime-picker></div></div></div><div class=\"col-xs-12 no-padding\"><div class=form-group ng-class=\"{\'has-error\':ajoutevenement.type.$error.required && ajoutevenement.$submitted}\"><label for=type class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Type</label><div class=\"col-xs-12 col-sm-6 col-md-8\"><ui-select ng-model=communicationctrl.ajout.type id=type theme=bootstrap><ui-select-match placeholder=Type>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type in communicationctrl.types.list | filter: $select.search track by type.data\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"col-xs-12 no-padding\"><div class=form-group ng-class=\"{\'has-error\':ajoutevenement.commentaire.$error.required && ajoutevenement.$submitted}\"><label for=commentaire class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea class=form-control id=commentaire name=commentaire required ng-model=communicationctrl.ajout.description rows=5></textarea></div></div></div><div class=\"col-xs-12 no-padding\"><div class=\"text-right col-xs-12 col-sm-11 col-md-10\"><button type=submit class=\"btn-custom btn-custom-primary\">Enregistrer</button></div></div></form></div></div><div ng-if=!communicationctrl.ajoutEvent uib-accordion-group is-open=communicationctrl.modifIsOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': communicationctrl.modifIsOpen, \'fa-plus\': !communicationctrl.modifIsOpen}\"></i> Modification Evenement</uib-accordion-heading><div class=row><form name=modifevenement class=form-horizontal novalidate ng-submit=communicationctrl.modifEvenement(communicationctrl.evenementSelected)><div class=\"col-xs-12 col-md-6 no-padding\"><div class=form-group ng-class=\"{\'has-error\':modifevenement.date.$error.required && modifevenement.$submitted}\"><label for=dateDebut class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&eacute;but</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateDebut name=dateDebut class=form-control ng-model=communicationctrl.evenementSelected.date required ng-click=\"communicationctrl.ajout.debutOpen = !communicationctrl.ajout.debutOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.ajout.debutOpen = !communicationctrl.ajout.debutOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.ajout.debutOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.ajout.onCloseDebut()><datetime-picker click-prevent model=communicationctrl.evenementSelected.date time-picker on-close=::communicationctrl.ajout.onCloseDebut()></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><div class=form-group ng-class=\"{\'has-error\':modifevenement.dateFin.$error.required && modifevenement.$submitted}\"><label for=dateFin class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date fin</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateFin name=dateFin class=form-control ng-model=communicationctrl.evenementSelected.dateFin ng-click=\"communicationctrl.ajout.finOpen = !communicationctrl.ajout.finOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.ajout.finOpen = !communicationctrl.ajout.finOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.ajout.finOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.ajout.onCloseFin()><datetime-picker click-prevent model=communicationctrl.evenementSelected.dateFin time-picker on-close=::communicationctrl.ajout.onCloseFin()></datetime-picker></div></div></div><div class=\"col-xs-12 no-padding\"><div class=form-group ng-class=\"{\'has-error\':modifevenement.commentaire.$error.required && modifevenement.$submitted}\"><label for=commentaire class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea class=form-control id=commentaire name=commentaire required ng-model=communicationctrl.evenementSelected.commentaire rows=5></textarea></div></div></div><div class=\"col-xs-12 no-padding\" ng-if=\"communicationctrl.evenementSelected.type.data===2\"><div class=form-group ng-class=\"{\'has-error\':modifevenement.compteRendu.$error.required && modifevenement.$submitted}\"><label for=compteRendu class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Compte rendu</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea class=form-control id=compteRendu name=compteRendu required ng-model=communicationctrl.evenementSelected.compteRendu rows=5></textarea></div></div></div><div class=\"col-xs-12 no-padding\"><div class=\"text-right col-xs-12 col-sm-11 col-md-10\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=communicationctrl.newEvenement()>Nouveau</button> <button type=submit class=\"btn-custom btn-custom-primary\">Enregistrer</button></div></div></form></div></div></div><!-- Infos supplémentaires --><div uib-accordion-group is-open=criteresIsOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': criteresIsOpen, \'fa-chevron-down\': !criteresIsOpen}\"></i> Liste des &eacute;v&egrave;nements<div class=pull-right click-prevent><i class=\"fa fa-2r fa-sort-amount-desc pointer\" ng-if=\"communicationctrl.ordre==\'-index\'\" ng-click=\"communicationctrl.ordre=\'index\'\"></i> <i class=\"fa fa-2r fa-sort-amount-asc pointer\" ng-if=\"communicationctrl.ordre==\'index\'\" ng-click=\"communicationctrl.ordre=\'-index\'\"></i></div></uib-accordion-heading><uib-accordion close-others=false><div class=\"col-xs-12 col-md-6\"><div uib-accordion-group is-open=dateIsOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': dateIsOpen, \'fa-chevron-down\': !dateIsOpen}\"></i> Date</uib-accordion-heading><div class=row><div class=\"col-xs-12 no-padding\"><div class=form-group><label for=dateDebutTri class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&eacute;but</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" class=form-control id=dateDebutTri name=dateDebut ng-model=communicationctrl.date.datedebut ng-click=\"communicationctrl.date.debutOpen = !communicationctrl.date.debutOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.date.debutOpen = !communicationctrl.date.debutOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.date.debutOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.date.onCloseDebut()><datetime-picker click-prevent model=communicationctrl.date.datedebut time-picker on-close=::communicationctrl.date.onCloseDebut()></datetime-picker></div></div></div><div class=\"col-xs-12 no-padding\"><div class=form-group><label for=dateFinTri class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date fin</label><div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=input-group><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateFinTri name=dateDebut class=form-control ng-model=communicationctrl.date.datefin ng-click=\"communicationctrl.date.finOpen = !communicationctrl.date.finOpen\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"communicationctrl.date.finOpen = !communicationctrl.date.finOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=communicationctrl.date.finOpen class=\"event-datepicker col-xs-12\" ng-click=::communicationctrl.date.onCloseFin()><datetime-picker click-prevent model=communicationctrl.date.datefin time-picker on-close=::communicationctrl.date.onCloseFin()></datetime-picker></div></div></div><div class=\"col-xs-12 col-sm-9 col-md-10 text-right no-padding\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=communicationctrl.getListeEvenement()>Appliquer</button></div></div></div></div><div class=\"col-xs-12 col-md-6\"><div uib-accordion-group is-open=typesIsOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': typesIsOpen, \'fa-chevron-down\': !typesIsOpen}\"></i> Type(s)</uib-accordion-heading><div class=\"col-xxs-12 col-xs-6 col-sm-4 col-md-6 col-lg-4\" ng-repeat=\"type in communicationctrl.types.list\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: type.checked}\" ng-model=type.checked uib-btn-checkbox>{{ type.label }}</button></div><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-primary pull-right\" ng-click=communicationctrl.getListeEvenement()>Appliquer</button></div></div></div></uib-accordion></div></uib-accordion><div class=\"col-xs-12 spacer-top\" ng-if=communicationctrl.eventsAAfficher.length><timeline><timeline-event ng-repeat=\"event in communicationctrl.eventsAAfficher | filter:communicationctrl.scearchEvent | orderBy : communicationctrl.ordre\" side=alternate><timeline-badge class={{::event.badgeClass}}><i class=\"fa {{::event.badgeIconClass}}\"></i></timeline-badge><timeline-panel><timeline-heading><h4><i class=\"fa fa-feed\"></i> {{::event.title}} du {{::event.date}}</h4></timeline-heading><div class=event><div class=item ng-repeat=\"content in event.contents\" tooltip-placement=\"auto top-left\" uib-tooltip={{::content.tooltip}}><span class=event-edit ng-click=::communicationctrl.editEvenement(content)><i class=\"fa fa-edit\"></i> </span>{{::content.heure}} - {{::content.text}} <span ng-if=\"::(content.refLot || content.refProspect)\">-</span> <span ng-if=content.refLot class=event-lot ng-click=::communicationctrl.showFiche(content.refLot)><i class=\"fa fa-fw fa-home\"></i> <span class=hidden-xs>Lot</span> </span><span ng-if=::content.refProspect class=event-prospect ng-click=::communicationctrl.showProspect(content.refProspect)><i class=\"fa fa-fw fa-user\"></i> <span class=hidden-xs>Prospect</span></span></div></div></timeline-panel></timeline-event></timeline></div><div class=\"col-xs-12 spacer-top text-center\" ng-if=!communicationctrl.eventsAAfficher.length>Aucun &eacute;v&egrave;nement pour la recherche</div></div>");
$templateCache.put("app/components/utils/adresse/adresse.html","<div class=\"row adresse-container\"><label for=adresse class=\"col-xs-12 control-label no-padding-left\" ng-class=\"::{\r\n           \'col-sm-1 col-md-4\': adressectrl.template !== \'small\',\r\n           \'col-sm-3 col-md-2\': adressectrl.template === \'small\'\r\n         }\">Adresse <i ng-if=adressectrl.copy.active class=\"fa fa-files-o\" ng-click=adressectrl.copy.copyFrom() aria-hidden=true tooltip-placement=\"auto top-left\" uib-tooltip=\"Copier l\'adresse du propriétaire\"></i></label><div class=col-xs-12 ng-class=\"::{\r\n         \'col-sm-10 col-md-8\': adressectrl.template !== \'small\',\r\n         \'col-sm-9 col-md-10\': adressectrl.template === \'small\'\r\n       }\"><div class=row><div class=\"col-xs-12 spacer-bottom\"><input id=immeuble type=text name=immeuble class=form-control placeholder=\"Nom Immeuble\" ng-model=adressectrl.adresse.immeuble ng-disabled=adressectrl.disabled></div></div><div class=row><div class=\"col-xs-12 spacer-bottom\"><input id=adresse name=adresse type=text class=form-control placeholder=Adresse ng-model=adressectrl.adresse.rue ng-required=adressectrl.required ng-disabled=adressectrl.disabled></div></div><div class=row><div class=\"col-xs-12 spacer-bottom\"><input id=adresse2 type=text class=form-control ng-model=adressectrl.adresse.complement placeholder=\"Adresse sup\" ng-disabled=adressectrl.disabled></div></div><div class=row><div class=\"col-sm-3 col-md-5 col-lg-4 spacer-bottom\"><ui-select ng-model=adressectrl.villes.selected theme=bootstrap id=cp name=cp spinner-enabled=true on-select=::adressectrl.villes.setVilles() on-remove=::adressectrl.villes.setVilles() ng-required=adressectrl.required ng-disabled=adressectrl.disabled ng-class=\"{\'validation-error\': adressectrl.validation.cp.$error.required && (adressectrl.validation.$submitted || adressectrl.visited)}\"><ui-select-match placeholder=\"Code postal...\" allow-clear=true>{{$select.selected.codePostal}}</ui-select-match><ui-select-choices repeat=\"ville in adressectrl.villes.list | filter: $search track by ville.id\" refresh=\"adressectrl.villes.getVilles($select.search, \'cp\')\" refresh-delay=350><div ng-bind-html=\"::ville.nom | highlight: $select.search\"></div><small>{{::ville.codePostal}}</small></ui-select-choices></ui-select></div><div class=\"col-sm-9 col-md-7 col-lg-8 spacer-bottom\"><ui-select ng-model=adressectrl.villes.selected theme=bootstrap id=ville name=ville spinner-enabled=true on-select=::adressectrl.villes.setVilles() on-remove=::adressectrl.villes.setVilles() ng-required=adressectrl.required ng-disabled=adressectrl.disabled><ui-select-match placeholder=Ville... allow-clear=true>{{$select.selected.nom}}</ui-select-match><ui-select-choices repeat=\"ville in adressectrl.villes.list | filter: $search track by ville.id\" refresh=\"adressectrl.villes.getVilles($select.search, \'ville\')\" refresh-delay=350><div ng-bind-html=\"::ville.nom | highlight: $select.search\"></div><small>{{::ville.codePostal}}</small></ui-select-choices></ui-select></div></div><div class=row><div class=col-xs-12><input id=pays type=text class=form-control ng-model=adressectrl.adresse.pays placeholder=Pays ng-disabled=adressectrl.disabled></div></div></div></div>");
$templateCache.put("app/components/utils/bloc-perso/bloc-perso.html","<div class=\"bloc-perso col-xs-12\"><div class=perso-titre ng-if=::blocpersoctrl.titreBloc><div class=\"perso-titre-label col-xs-12 text-center\">{{::blocpersoctrl.titreBloc}}<div class=\"bloc-perso-controls pull-right\" ng-if=blocpersoctrl.isEditable><button type=button class=\"btn-custom btn-custom-sm btn-edit-perso\" ng-class=\"{\'btn-custom-primary\': !blocpersoctrl.editing, \'btn-success\': blocpersoctrl.editing}\" ng-click=\"blocpersoctrl.editing = !blocpersoctrl.editing\" tooltip-placement=\"auto top\" uib-tooltip=Saisie><i class=\"fa fa-fw\" ng-class=\"{\'fa-pencil\': !blocpersoctrl.editing, \'fa-check\': blocpersoctrl.editing}\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-edit-perso btn-custom-primary\" ng-if=!blocpersoctrl.editing ng-click=blocpersoctrl.changePerso() tooltip-placement=\"auto top\" uib-tooltip=\"Chercher une autre personnalité\"><i class=\"fa fa-fw fa-address-book-o\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-edit-perso btn-danger\" ng-click=blocpersoctrl.supprimer.onClick() tooltip-placement=\"auto top\" uib-tooltip={{blocpersoctrl.supprimer.tooltip}}><i class=fa ng-class=blocpersoctrl.supprimer.icon></i></button></div></div><div class=perso-titre-nom ng-class=\"{\'text-right\': blocpersoctrl.templateRight}\" ng-if=!blocpersoctrl.editing><span class=titre-nom>{{blocpersoctrl.perso.getNomComplet()}}</span></div></div><div class=\"perso-content row\" ng-if=!blocpersoctrl.editing><div class=\"perso-adresse col-xs-12\" ng-class=\"{\'text-right\': blocpersoctrl.templateRight}\"><div ng-if=blocpersoctrl.perso.hasAdresses() class=row ng-repeat=\"adresse in blocpersoctrl.perso.adresses | limitTo : 1\"><span class=col-xs-12 ng-if=::adresse.hasRue()>{{::adresse.rue}}</span> <span class=col-xs-12 ng-if=::adresse.hasComplement()>{{::adresse.complement}}</span> <span class=col-xs-12 ng-if=\"::(adresse.hasCp() || adresse.hasVille())\"><span ng-if=::adresse.hasCp()>{{::adresse.cp}} </span><span ng-if=::adresse.hasVille()>{{::adresse.ville}}</span> </span><span class=col-xs-12 ng-if=::adresse.hasPays()>{{::adresse.pays}}</span></div><span ng-if=(!blocpersoctrl.perso.hasAdresses())><i>Adresse non renseign&eacute;e</i></span></div><div class=\"perso-contact col-xs-12\" ng-class=\"{\'text-right\': !blocpersoctrl.templateRight}\"><div ng-if=blocpersoctrl.perso.hasContacts() ng-repeat=\"contact in blocpersoctrl.perso.contacts\"><span>{{::contact.value}}</span></div><span ng-if=(!blocpersoctrl.perso.hasContacts())><i>Aucun contact renseign&eacute;</i></span></div></div><div class=bloc-perso-editing ng-if=blocpersoctrl.editing><personnalite personnalite=blocpersoctrl.perso template=\"\'small\'\" etat-civil=true type-only=blocpersoctrl.typeOnly></personnalite></div></div>");
$templateCache.put("app/components/utils/datetime-picker/datetime-picker.html","<div class=\"datetime-picker col-xs-12\"><div class=\"row spacer-top spacer-bottom underlined-primary\"><button type=button class=\"btn-custom btn-custom-transparent btn-cal-societe\" ng-click=datetimepickerctrl.fullScreen.toggle() ng-if=datetimepickerctrl.fullScreen.active><i class=\"fa fa-fw\" ng-class=\"{\r\n           \'fa-window-minimize\': datetimepickerctrl.fullScreen.isFullScreen,\r\n           \'fa-window-maximize\': !datetimepickerctrl.fullScreen.isFullScreen\r\n         }\"></i> {{datetimepickerctrl.fullScreen.isFullScreen ? \'Fermer calendrier société\' : \'Voir calendrier société\'}}</button> <button type=button class=\"btn-custom btn-custom-sm btn-danger pull-right\" ng-click=datetimepickerctrl.closeDate()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=row ng-if=\"datetimepickerctrl.societes.active && datetimepickerctrl.negos.active\"><div class=\"col-xs-8 col-xs-offset-2 spacer-bottom\"><!-- <ui-select multiple ng-model=\"datetimepickerctrl.societes.societes\" theme=\"bootstrap\" close-on-select=\"true\" on-select=\"datetimepickerctrl.societes.changed()\"\r\n        on-remove=\"datetimepickerctrl.societes.changed()\">\r\n        <ui-select-match placeholder=\"Société...\">\r\n          {{$item.nom}}\r\n        </ui-select-match>\r\n        <ui-select-choices repeat=\"societe in datetimepickerctrl.societes.currentList | filter: $select.search track by societe.id\"\r\n          refresh=\"datetimepickerctrl.societes.search($select.search)\" group-by=\"datetimepickerctrl.societes.groupChoices\"\r\n          refresh-delay=\"350\">\r\n          <span ng-bind-html=\"::societe.nom | highlight: $select.search\"></span>\r\n        </ui-select-choices>\r\n      </ui-select>\r\n      <span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=\"datetimepickerctrl.societes.societes.length\" ng-click=\"datetimepickerctrl.societes.societes = []; datetimepickerctrl.societes.changed()\">\r\n        <i class=\"fa fa-fw fa-times\"></i>\r\n      </span> --><r-select rs-multiple ng-model=datetimepickerctrl.societes.societes rs-options=datetimepickerctrl.societes.currentList rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé(s)...\'\" rs-on-change=datetimepickerctrl.societes.changed()></r-select></div><div class=\"col-xs-8 col-xs-offset-2 spacer-bottom\"><ui-select ng-model=datetimepickerctrl.negos.nego theme=bootstrap close-on-select=true on-select=datetimepickerctrl.negos.changed() on-remove=datetimepickerctrl.negos.changed()><ui-select-match placeholder=Négo...>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in datetimepickerctrl.negos.list | filter: $select.search track by nego.id\" refresh=datetimepickerctrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=row><div uib-datepicker ng-model=datetimepickerctrl.date class=dtp-datepicker ng-change=datetimepickerctrl.onChange() datepicker-options=datetimepickerctrl.datepicker.options></div></div><div class=row ng-if=datetimepickerctrl.timepicker><div uib-timepicker ng-model=datetimepickerctrl.heure class=dtp-timepicker ng-class=\"{\'col-xs-6\': datetimepickerctrl.timerange}\" ng-change=datetimepickerctrl.onChange() show-meridian=false></div><div ng-if=datetimepickerctrl.timerange uib-timepicker ng-model=datetimepickerctrl.heureFin class=\"dtp-timepicker col-xs-6\" ng-change=datetimepickerctrl.onChange(true) show-meridian=false></div></div><div class=\"row text-center spacer-top\"><button type=button class=\"btn-custom btn-custom-sm btn-success\" ng-click=datetimepickerctrl.choseDate()><i class=\"fa fa-fw fa-check\"></i> Valider</button> <button type=button ng-if=datetimepickerctrl.annulation class=\"btn-custom btn-custom-sm btn-warning\" ng-click=datetimepickerctrl.annulerRDV()><i class=\"fa fa-fw fa-ban\"></i> Annuler le RDV</button> <button type=button ng-if=datetimepickerctrl.supprimable class=\"btn-custom btn-custom-sm btn-danger\" ng-click=datetimepickerctrl.removeDate()><i class=\"fa fa-fw fa-trash\"></i></button></div><div class=\"row text-center spacer-top\" ng-if=datetimepickerctrl.nouveau><button type=button class=\"btn-custom btn-custom-sm btn-success\" ng-click=datetimepickerctrl.nouveauRdv()><i class=\"fa fa-fw fa-calendar-plus-o\"></i> Nouveau RDV</button></div></div>");
$templateCache.put("app/components/utils/liste-gravitants/liste-gravitants.html","<div class=liste-gravitants><div class=\"row gravitants-controls\"><div ng-if=\"!listegravitantsctrl.gravitant.open && !listegravitantsctrl.disabled\"><div class=\"col-xs-12 col-sm-6\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary spacer-bottom\" ng-click=\"listegravitantsctrl.gravitant.open = true\"><i class=\"fa fa-fw fa-plus\"></i> Cr&eacute;er un gravitant</button></div><div class=\"col-xs-12 col-sm-6\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary spacer-bottom\" ng-click=listegravitantsctrl.gravitant.search()><i class=\"fa fa-fw fa-search\"></i> Chercher un gravitant</button></div></div><div class=\"gravitants-new col-xs-12 no-padding\" ng-if=listegravitantsctrl.gravitant.open><div class=\"col-xs-12 spacer-bottom\"><ui-select ng-model=listegravitantsctrl.gravitant.current.type theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Type de gravitant...\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type in (listegravitantsctrl.gravitant.typesList | filter: $select.search) track by type.id\"><span ng-bind-html=\"::type.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div><personnalite personnalite=listegravitantsctrl.gravitant.current.perso template=\"\'small\'\" gravitant=true></personnalite><div class=\"col-xs-12 text-right\"><button type=button class=\"btn-custom btn-success\" ng-click=listegravitantsctrl.gravitant.ajouter()>Valider</button> <button type=button class=\"btn-custom btn-danger\" ng-click=\"listegravitantsctrl.gravitant.open = false\">Annuler</button></div></div></div><div class=\"row gravitants-list\"><div class=col-xs-12 ng-repeat=\"gravitant in listegravitantsctrl.gravitants\"><bloc-perso perso=gravitant.perso titre-bloc=gravitant.type.label.toUpperCase() is-editable=\"gravitant.modifiable && !listegravitantsctrl.disabled\" on-supprimer=listegravitantsctrl.gravitant.supprimer(gravitant)></bloc-perso></div></div></div>");
$templateCache.put("app/components/utils/nego-supp/nego-supp.html","<div class=nego-supplementaire><div class=\"row nego-affaire\"><label class=\"control-label no-padding-left col-xs-12 col-sm-3 col-md-2\">{{negosuppctrl.contrat.affaire[negosuppctrl.routes.mandat].nego.perso ? negosuppctrl.contrat.affaire[negosuppctrl.routes.mandat].nego.perso.nomComplet : negosuppctrl.contrat.affaire[negosuppctrl.routes.mandat].nego.initiales}}</label><div class=\"col-xs-12 col-sm-9 col-md-4 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 step=0.1 placeholder=0 ng-model=negosuppctrl.contrat.partAffaire ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>part {{negosuppctrl.texts.mandat}}</span></div></div><div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-5 col-md-offset-0 no-padding\" ng-if=!negosuppctrl.citya><div class=\"col-xs-12 col-sm-5 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=negosuppctrl.taux.affaire ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'taux\', \'affaire\')\" ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>% soit</span></div></div><div class=\"col-xs-12 col-sm-7 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=negosuppctrl.contrat.commSurAffaire ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'comm\', \'affaire\')\" ng-disabled=negosuppctrl.isDisabled> <span ng-if=negosuppctrl.contrat.affaire[negosuppctrl.routes.mandat].nego.ht class=input-group-addon>&euro; sur comm HT</span> <span ng-if=!negosuppctrl.contrat.affaire[negosuppctrl.routes.mandat].nego.ht class=input-group-addon>&euro; sur comm TTC</span></div></div></div></div><hr class=\"darken-separator visible-xs visible-sm\"><div class=\"row nego-aquereur\"><label class=\"control-label no-padding-left col-xs-12 col-sm-3 col-md-2\">{{negosuppctrl.contrat[negosuppctrl.routes.aquereur].nego.perso ? negosuppctrl.contrat[negosuppctrl.routes.aquereur].nego.perso.nomComplet : negosuppctrl.contrat[negosuppctrl.routes.aquereur].nego.initiales}}</label><div class=\"col-xs-12 col-sm-9 col-md-4 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 step=0.1 placeholder=0 ng-model=negosuppctrl.contrat.partAcheteur ng-model-options=\"{debounce: 350}\" ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>part {{negosuppctrl.texts.aquereur}}</span></div></div><div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-5 col-md-offset-0 no-padding\" ng-if=!negosuppctrl.citya><div class=\"col-xs-12 col-sm-5 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=negosuppctrl.taux.aquereur ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'taux\', \'aquereur\')\" ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>% soit</span></div></div><div class=\"col-xs-12 col-sm-7 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=negosuppctrl.contrat.commSurAcheteur ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'comm\', \'aquereur\')\" ng-disabled=negosuppctrl.isDisabled> <span ng-if=negosuppctrl.contrat[negosuppctrl.routes.aquereur].nego.ht class=input-group-addon>&euro; sur comm HT</span> <span ng-if=!negosuppctrl.contrat[negosuppctrl.routes.aquereur].nego.ht class=input-group-addon>&euro; sur comm TTC</span></div></div></div></div><div ng-for=\"i in 1...3\"><div class=\"row nego-supp\" ng-if=\"negosuppctrl.contrat[\'negoSupp\' + i]\"><hr class=\"darken-separator visible-xs visible-sm\"><div class=relative><div class=custom-floating-block><button type=button class=\"pull-right btn-danger btn-xs\" ng-click=\"negosuppctrl.deleteNego(\'Supp\' + i)\"><i class=\"fa fa-fw fa-trash\"></i></button></div><label class=\"control-label no-padding-left col-xs-12 col-sm-3 col-md-2\">{{negosuppctrl.contrat[\'negoSupp\' + i].perso ? negosuppctrl.contrat[\'negoSupp\' + i].perso.nomComplet : negosuppctrl.contrat[\'negoSupp\' + i].initiales}}</label><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom no-padding-right\"><input custom-type=number class=form-control min=0 step=0.1 placeholder=0 ng-model=\"negosuppctrl.contrat[\'partSupp\' + i]\" ng-disabled=negosuppctrl.isDisabled></div><div class=\"col-xs-8 col-sm-6 col-md-2 spacer-bottom no-padding-left\"><div class=input-group><span class=input-group-addon>part</span><ui-select ng-model=\"negosuppctrl.contrat[\'sortantSupp\' + i]\" theme=bootstrap close-on-select=true ng-disabled=negosuppctrl.isDisabled><ui-select-match placeholder=Affectation...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"affectation.value as affectation in negosuppctrl.partsList | filter: $select.search\"><span ng-bind-html=\"::affectation.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-5 col-md-offset-0 no-padding\" ng-if=!negosuppctrl.citya><div class=\"col-xs-12 col-sm-5 spacer-bottom\"><div class=input-group><input custom-type=number class=form-control min=0 placeholder=0 ng-model=\"negosuppctrl.taux[\'supp\' + i]\" ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'taux\', \'Supp\' + i)\" ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>% soit</span></div></div><div class=\"col-xs-12 col-sm-7 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=\"negosuppctrl.contrat[\'commSupp\' + i]\" ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'comm\', \'Supp\' + i)\" ng-disabled=negosuppctrl.isDisabled> <span ng-if=\"negosuppctrl.contrat[\'negoSupp\' + i].ht\" class=input-group-addon>&euro; sur comm HT </span><span ng-if=\"!negosuppctrl.contrat[\'negoSupp\' + i].ht\" class=input-group-addon>&euro; sur comm TTC</span></div></div></div></div></div></div><div ng-for=\"j in 1...3\"><div class=\"row nego-ext\" ng-if=\"negosuppctrl.contrat[\'negoExt\' + j]\"><hr class=\"darken-separator visible-xs visible-sm\"><div class=relative><div class=custom-floating-block><button type=button class=\"pull-right btn-danger btn-xs\" ng-click=\"negosuppctrl.deleteNego(\'Ext\' + j)\"><i class=\"fa fa-fw fa-trash\"></i></button></div><label class=\"control-label no-padding-left col-xs-12 col-sm-3 col-md-2\">{{negosuppctrl.contrat[\'negoExt\' + j].perso ? negosuppctrl.contrat[\'negoExt\' + j].perso.nomComplet : negosuppctrl.contrat[\'negoExt\' + j].initiales}}</label><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom no-padding-right\"><input custom-type=number class=form-control min=0 step=0.1 placeholder=0 ng-model=\"negosuppctrl.contrat[\'partExt\' + j]\" ng-disabled=negosuppctrl.isDisabled></div><div class=\"col-xs-8 col-sm-6 col-md-2 spacer-bottom no-padding-left\"><div class=input-group><span class=input-group-addon>part</span><ui-select ng-model=\"negosuppctrl.contrat[\'sortantExt\' + j]\" theme=bootstrap close-on-select=true ng-disabled=negosuppctrl.isDisabled><ui-select-match placeholder=Affectation...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"affectation.value as affectation in negosuppctrl.partsList | filter: $select.search\"><span ng-bind-html=\"::affectation.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-sm-9 col-sm-offset-3 col-md-5 col-md-offset-0 no-padding\" ng-if=!negosuppctrl.citya><div class=\"col-xs-12 col-sm-5 spacer-bottom\"><div class=input-group><input custom-type=number class=form-control min=0 placeholder=0 ng-model=\"negosuppctrl.taux[\'ext\' + j]\" ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'taux\', \'Ext\' + j)\" ng-disabled=negosuppctrl.isDisabled> <span class=input-group-addon>% soit</span></div></div><div class=\"col-xs-12 col-sm-7 spacer-bottom\"><div class=input-group><input custom-type=number class=\"form-control border-rounded\" min=0 placeholder=0 ng-model=\"negosuppctrl.contrat[\'commExt\' + j]\" ng-model-options=\"{debounce: 350}\" ng-change=\"negosuppctrl.calculCommission(\'comm\', \'Ext\' + j)\" ng-disabled=negosuppctrl.isDisabled> <span ng-if=\"negosuppctrl.contrat[\'negoExt\' + j].ht\" class=input-group-addon>&euro; sur comm HT </span><span ng-if=\"!negosuppctrl.contrat[\'negoExt\' + j].ht\" class=input-group-addon>&euro; sur comm TTC</span></div></div></div></div></div></div><hr class=\"darken-separator visible-xs visible-sm\"><div class=\"row part-agence\" ng-if=!negosuppctrl.citya><div class=\"col-xs-12 text-center spacer-bottom spacer-top\"><span>Net agence</span> <strong>{{negosuppctrl.tauxAgence}}%</strong> soit <strong>{{negosuppctrl.commAgence}}&euro;</strong></div></div><div class=\"row add-nego\" ng-if=negosuppctrl.addNegoOpen><div class=\"col-xs-12 text-center spacer-bottom\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=negosuppctrl.openRepertoire() ng-disabled=\"negosuppctrl.contrat.negoSupp1 && negosuppctrl.contrat.negoSupp2 && negosuppctrl.contrat.negoSupp3\"><i class=\"fa fa-fw fa-search\"></i> Chercher un n&eacute;gociateur</button> <button type=button class=\"pull-right btn-danger btn-xs\" ng-click=\"negosuppctrl.addNegoOpen = false\"><i class=\"fa fa-fw fa-times\"></i></button></div><label class=\"control-label no-padding-left col-xs-12 col-sm-3 col-md-2\">N&eacute;go. ext.</label><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom\"><input type=text class=form-control placeholder=Nom ng-model=negosuppctrl.nego.perso.nom ng-disabled=\"negosuppctrl.contrat.negoExt1 && negosuppctrl.contrat.negoExt2 && negosuppctrl.contrat.negoExt3\" ng-class=\"{\'validation-error\': negosuppctrl.nego.errorNom}\"></div><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom\"><input type=text class=form-control placeholder=Prenom ng-model=negosuppctrl.nego.perso.prenom ng-disabled=\"negosuppctrl.contrat.negoExt1 && negosuppctrl.contrat.negoExt2 && negosuppctrl.contrat.negoExt3\" ng-class=\"{\'validation-error\': negosuppctrl.nego.errorPrenom}\"></div><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom\"><input type=tel class=form-control placeholder=Tel. ng-model=negosuppctrl.nego.perso.contacts[0].value ng-disabled=\"negosuppctrl.contrat.negoExt1 && negosuppctrl.contrat.negoExt2 && negosuppctrl.contrat.negoExt3\"></div><div class=\"col-xs-4 col-sm-3 col-md-2 spacer-bottom no-padding-right text-right\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=negosuppctrl.addNego()><i class=\"fa fa-fw fa-save\"></i> Ajouter</button></div></div><div class=\"row nego-controls spacer-top\"><div class=\"col-xs-6 text-right\"><button type=button class=\"btn-custom btn-custom-primary\" ng-click=\"negosuppctrl.addNegoOpen = !negosuppctrl.addNegoOpen\" ng-disabled=\"(negosuppctrl.contrat.negoExt1 && negosuppctrl.contrat.negoExt2 && negosuppctrl.contrat.negoExt3\r\n			        && negosuppctrl.contrat.negoSupp1 && negosuppctrl.contrat.negoSupp2 && negosuppctrl.contrat.negoSupp3) || negosuppctrl.isDisabled\"><i class=\"fa fa-fw fa-plus\"></i> Ajouter n&eacute;gociateur</button></div><div class=col-xs-6><button type=button class=\"btn-custom btn-custom-primary\" ng-click=negosuppctrl.calculParts() ng-disabled=negosuppctrl.isDisabled><i class=\"fa fa-fw fa-calculator\"></i> Recalculer parts</button></div></div></div>");
$templateCache.put("app/components/utils/loader/loader.html","<div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div><div class=loader-bar></div>");
$templateCache.put("app/components/utils/personnalite/personnalite.html","<div class=\"col-xs-12 personalite-container\" ng-if=!personnalitectrl.loading><div class=\"form-group row\" ng-if=\"!(personnalitectrl.typeOnly==\'morale\' || personnalitectrl.typeOnly==\'physique\')\"><label class=\"col-xs-12 col-md-2 control-label no-padding-left\" ng-class=\"::{\r\n               \'col-sm-1\': personnalitectrl.template !== \'small\',\r\n               \'col-sm-3\': personnalitectrl.template === \'small\'\r\n           }\">Type</label><div class=\"col-xs-6 spacer-bottom\" ng-class=\"::{\r\n               \'col-sm-5 col-md-4\': personnalitectrl.template !== \'small\',\r\n               \'col-sm-4 col-md-5\': personnalitectrl.template === \'small\'\r\n           }\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" name=typePerso ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio)\" ng-class=\"{\'checked\': personnalitectrl.personnalite.physique}\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.type uib-btn-radio=\"\'PersoPhysique\'\" ng-change=::personnalitectrl.modifTypePerso()>Physique</button></div><div class=\"col-xs-6 spacer-bottom\" ng-class=\"::{\r\n               \'col-sm-5 col-md-4\': personnalitectrl.template !== \'small\',\r\n               \'col-sm-4 col-md-5\': personnalitectrl.template === \'small\'\r\n           }\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" name=typePerso ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio)\" ng-class=\"{\'checked\': personnalitectrl.personnalite.morale}\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.type uib-btn-radio=\"\'PersoMorale\'\" ng-change=::personnalitectrl.modifTypePerso()>Morale</button></div></div><div class=\"form-group row\"><div ng-if=\"personnalitectrl.personnalite.type === \'PersoPhysique\'\"><label class=\"col-xs-12 col-md-2 control-label no-padding-left\" ng-class=\"::{\r\n                       \'col-sm-1\': personnalitectrl.template !== \'small\',\r\n                       \'col-sm-3\': personnalitectrl.template === \'small\'\r\n                   }\">Civilit&eacute;</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                   \'col-sm-2\': personnalitectrl.template !== \'small\',\r\n                   \'col-sm-9 col-md-10\': personnalitectrl.template === \'small\'\r\n               }\"><ui-select ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.civilite theme=bootstrap><ui-select-match placeholder=Civilité>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"civilite in personnalitectrl.RefCivilite | filter: $select.search track by civilite.data\"><div ng-bind-html=\"civilite.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div ng-if=\"personnalitectrl.personnalite.type === \'PersoMorale\'\"><label class=\"hidden-xs col-sm-3 col-md-2 control-label no-padding-left\">Forme Juridique</label><label class=\"visible-xs col-xs-12 control-label\">For.Jur.</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                   \'col-sm-4 col-md-3\': personnalitectrl.template !== \'small\',\r\n                   \'col-sm-9 col-md-10\': personnalitectrl.template === \'small\'\r\n               }\"><ui-select ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.formeJuridique theme=bootstrap><ui-select-match placeholder=\"Forme Juridique\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"formeJuridique in personnalitectrl.RefFormeJuridique | filter: $select.search track by formeJuridique.data\"><div ng-bind-html=\"formeJuridique.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><div><label for=nom class=\"col-xs-12 control-label no-padding-left\" ng-class=\"{\r\n                            \'col-sm-1\': personnalitectrl.template !== \'small\',\r\n                            \'col-sm-3\': personnalitectrl.template === \'small\',\r\n                            \'col-md-2\': personnalitectrl.personnalite.type === \'PersoMorale\' || personnalitectrl.template === \'small\',\r\n                            \'col-md-1\': personnalitectrl.personnalite.type === \'PersoPhysique\' && personnalitectrl.template !== \'small\'\r\n                        }\">Nom</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"{\r\n                         \'col-sm-3\': personnalitectrl.template !== \'small\',\r\n                         \'col-sm-9 col-md-10\': personnalitectrl.template === \'small\',\r\n                         \'col-md-3\': personnalitectrl.personnalite.type === \'PersoMorale\' && personnalitectrl.template !== \'small\',\r\n                         \'col-md-2\': personnalitectrl.personnalite.type === \'PersoPhysique\' && personnalitectrl.template !== \'small\'\r\n                     }\"><input id=nom name=nom class=form-control placeholder=Nom ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.nom ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio)\"></div></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><div ng-if=\"personnalitectrl.personnalite.type === \'PersoPhysique\'\"><label for=prenom class=\"col-xs-12 control-label no-padding-left\" ng-class=\"::{\r\n                       \'col-sm-1\': personnalitectrl.template !== \'small\',\r\n                       \'col-sm-3 col-md-2\': personnalitectrl.template === \'small\'\r\n                   }\">Pr&eacute;nom</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                     \'col-sm-3 col-md-2\': personnalitectrl.template !== \'small\',\r\n                     \'col-sm-9 col-md-10\': personnalitectrl.template === \'small\'\r\n                 }\"><input id=prenom name=prenom class=form-control placeholder=Pr&eacute;nom ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.prenom ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio)\"></div></div></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><div class=\"form-group row\"><div class=\"col-xs-12 spacer-bottom-custom\" ng-class=\"::{\'col-md-6\': personnalitectrl.template !== \'small\'}\"><div ng-repeat=\"adresse in personnalitectrl.personnalite.adresses | limitTo:1\"><adresse adresse=adresse template=personnalitectrl.template></adresse></div></div><div class=col-xs-12 ng-class=\"::{\'col-md-4\': personnalitectrl.template !== \'small\'}\"><div class=row><div ng-repeat=\"contact in personnalitectrl.personnalite.contacts\"><div ng-if=\"!personnalitectrl.contacts.editing || personnalitectrl.contacts.current !== contact.id\"><div class=\"col-xs-4 col-sm-3\" ng-class=\"::{\r\n                             \'col-sm-offset-1 col-md-4 col-md-offset-0\': personnalitectrl.template !== \'small\',\r\n                             \'col-sm-offset-3 col-md-3 col-md-offset-2\': personnalitectrl.template === \'small\'\r\n                         }\">{{personnalitectrl.getTypeValue(contact.type) || contact.type}}</div><div class=\"col-xs-6 text-right\" ng-class=\"::{\r\n                             \'col-sm-5\': personnalitectrl.template === \'small\'\r\n                         }\">{{contact.value}}</div><div class=\"col-xs-2 col-sm-1 col-md-2 text-right\"><button type=button class=\"btn btn-xs btn-info\" ng-click=personnalitectrl.contacts.edit(contact.id)><i class=\"fa fa-pencil\"></i></button></div></div><div ng-if=\"personnalitectrl.contacts.editing && personnalitectrl.contacts.current === contact.id\"><div class=\"col-xs-4 col-sm-3 no-padding-right\" ng-class=\"::{\r\n                             \'col-sm-offset-1 col-md-4 col-md-offset-0\': personnalitectrl.template !== \'small\',\r\n                             \'col-sm-offset-3 col-md-3 col-md-offset-2\': personnalitectrl.template === \'small\'\r\n                         }\"><ui-select ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=contact.type theme=bootstrap><ui-select-match placeholder=Contact>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.value as item in personnalitectrl.contacts.types | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-6 text-right no-pediting-right\" ng-switch=contact.type ng-class=\"::{\'col-sm-5\': personnalitectrl.template === \'small\'}\"><div ng-switch-when=Email><label class=sr-only for=edit-contact-email></label><input type=email id=edit-contact-email class=form-control name=contactEmail ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=contact.value></div><div ng-switch-when=TelMobile><label class=sr-only for=edit-contact-tel></label><input type=tel id=edit-contact-tel class=form-control name=contactTelMobile ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=contact.value></div><div ng-switch-when=Telephone><label class=sr-only for=edit-contact-fixe></label><input type=tel id=edit-contact-fixe class=form-control name=contactTelephone ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=contact.value></div><div ng-switch-default><label class=sr-only for=edit-contact-default></label><input type=text id=edit-contact-default class=form-control name=contact disabled></div></div><div class=\"col-xs-2 col-sm-1 col-md-2 text-right\"><button type=button class=\"btn-custom btn-custom-sm btn-danger btn-delete-contact\" ng-click=personnalitectrl.contacts.delete(contact.id)><i class=\"fa fa-trash-o\"></i></button> <button type=button class=\"btn-custom btn-custom-sm btn-success btn-save-contact\" ng-disabled=!contact.value ng-click=personnalitectrl.contacts.save()><i class=\"fa fa-check\"></i></button></div></div></div><div class=\"col-xs-4 col-sm-3 no-padding-right\" ng-class=\"::{\r\n                             \'col-sm-offset-1 col-md-4 col-md-offset-0\': personnalitectrl.template !== \'small\',\r\n                             \'col-sm-offset-3 col-md-3 col-md-offset-2\': personnalitectrl.template === \'small\'\r\n                         }\"><ui-select ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio) && personnalitectrl.contacts.required\" ng-model=personnalitectrl.contacts.type name=contactType theme=bootstrap><ui-select-match placeholder=Contact>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item.value as item in personnalitectrl.contacts.types | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-6 text-right no-padding-right\" ng-switch=personnalitectrl.contacts.type ng-class=\"::{\'col-sm-5\': personnalitectrl.template === \'small\'}\"><div ng-switch-when=Email><label class=sr-only for=add-contact-email></label><input type=email id=add-contact-email class=form-control name=contactEmail ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.contacts.value></div><div ng-switch-when=TelMobile><label class=sr-only for=add-contact-tel></label><input type=tel id=add-contact-tel class=form-control name=contactTelMobile ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio) && personnalitectrl.contacts.required\" ng-model=personnalitectrl.contacts.value></div><div ng-switch-when=Telephone><label class=sr-only for=add-contact-fixe></label><input type=tel id=add-contact-fixe class=form-control name=contactTelephone ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-required=\"personnalitectrl.isRequired && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio) && personnalitectrl.contacts.required\" ng-model=personnalitectrl.contacts.value></div><div ng-switch-default><label class=sr-only for=add-contact-default></label><input type=text id=add-contact-default class=form-control name=contact disabled></div></div><div class=\"col-xs-2 col-sm-1 col-md-2 text-right\"><button type=button class=\"btn-custom btn-custom-sm btn-success btn-add-contact\" ng-disabled=!personnalitectrl.contacts.value ng-click=personnalitectrl.contacts.add()><i class=\"fa fa-plus\"></i></button></div></div></div></div><uib-accordion ng-if=personnalitectrl.etatCivilService.active><div uib-accordion-group is-open=personnalitectrl.etatCivilService.open><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\r\n                        \'fa-minus\': personnalitectrl.etatCivilService.open,\r\n                        \'fa-plus\': !personnalitectrl.etatCivilService.open\r\n                    }\"></i> &Eacute;tat Civil</uib-accordion-heading><div ng-if=\"personnalitectrl.personnalite.type == \'PersoPhysique\'\"><div class=row><label for=dateNaissance class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">N&eacute;-e le</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><div class=input-group><input id=dateNaissance custom-type=date ui-mask=99/99/9999 class=form-control ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.dateNaissance> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"personnalitectrl.datepicker.open = !personnalitectrl.datepicker.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=personnalitectrl.datepicker.open class=\"event-datepicker row\" ng-click=::personnalitectrl.datepicker.onClose()><datetime-picker click-prevent time-picker=false date-model=personnalitectrl.personnalite.dateNaissance on-close=::personnalitectrl.datepicker.onClose()></datetime-picker></div></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=lieuNaissance class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">&agrave;</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=lieuNaissance class=form-control placeholder=Ville ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.lieuNaissance></div></div><div class=row><label for=deptNaissance class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">D&eacute;partement Naissance</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=deptNaissance class=form-control placeholder=Departement ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.deptNaissance></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=paysNaissance class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Pays de Naissance</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=paysNaissance class=form-control placeholder=Pays ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.paysNaissance></div></div><div class=row><label for=profession class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Profession</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=profession class=form-control placeholder=Profession ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.profession></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=epouse class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Nationalit&eacute;</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=epouse class=form-control placeholder=Nationalite ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.nationalite></div></div><div class=row><label for=csp class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">CSP</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=csp class=form-control placeholder=CSP ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.csp></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=revenu class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Revenu</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><!--<input id=\"revenu\" name=\"revenu\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=\"personnalitectrl.personnalite.revenu\"\r\n               custom-type=\"number\" class=\"form-control\" placeholder=\"0\" min=\"0\" required>--><div class=input-group><input id=revenu custom-type=integer class=\"form-control border-rounded\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.revenu ng-required=\"!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.copieGestionContactProprio\"> <span class=input-group-addon><i class=\"fa fa-fw fa-euro\"></i></span></div></div></div><div class=row><label for=situationFamille class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Situation matrimoniale</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=situationFamille class=form-control placeholder=Situation ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.situationFamiliale></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=nomJF class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Nom de naissance</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=nomJF class=form-control placeholder=\"Nom de naissance\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.nomNaissance></div></div></div><div ng-if=\"personnalitectrl.personnalite.type==\'PersoMorale\'\"><div class=row><label for=siret class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">N&deg; SIRET</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=siret class=form-control placeholder=\"N° SIRET\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.siret></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=rcs class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">RCS</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=rcs class=form-control placeholder=RCS ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.rcs></div></div><div class=row><label for=capital class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Capital</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=capital class=form-control placeholder=Capital ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.capital></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=activite class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Activit&eacute;</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=activite class=form-control placeholder=Activite ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.activite></div></div><div class=row><label for=usage class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Usage</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=usage class=form-control placeholder=Usage ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.usageEntreprise></div><div class=clearfix ng-if=\"::personnalitectrl.template === \'small\'\"></div><label for=representant class=\"col-xs-12 col-sm-3 control-label no-padding-left\" ng-class=\"::{\'col-md-2\': personnalitectrl.template !== \'small\'}\">Repr&eacute;sentant</label><div class=\"col-xs-12 spacer-bottom\" ng-class=\"::{\r\n                           \'col-sm-8 col-md-3\': personnalitectrl.template !== \'small\',\r\n                           \'col-sm-9\': personnalitectrl.template === \'small\'\r\n                       }\"><input id=representant class=form-control placeholder=Representant ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.copieGestionContactProprio\" ng-model=personnalitectrl.personnalite.representant></div></div></div></div></uib-accordion><uib-accordion ng-if=personnalitectrl.commentairelService.active><div uib-accordion-group is-open=personnalitectrl.commentairelService.open><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\r\n                        \'fa-minus\': personnalitectrl.commentairelService.open,\r\n                        \'fa-plus\': !personnalitectrl.commentairelService.open\r\n                    }\"></i> Commentaire</uib-accordion-heading><div class=form-group><div class=\"col-xs-12 spacer-bottom\"><textarea class=form-control id=pub name=pub ng-model=personnalitectrl.personnalite.commentaire rows=5></textarea></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/utils/search-box/search-box.html","<div class=search-box ng-if=!searchboxctrl.initialisation><form class=col-xs-12 name=searchBoxForm ng-submit=::searchboxctrl.startSearch() novalidate><div class=row><!-- Templates --><div class=\"form-group template-list col-xs-3 col-sm-2 col-md-3 col-lg-2 col-xl-3\"><div ng-if=searchboxctrl.additionalControls.templates.active class=\"template-dropdown btn-group pull-left\" uib-dropdown><span uib-dropdown-toggle class=\"btn btn-simple-custom active\"><i class=\"fa fa-fw\" ng-class=searchboxctrl.additionalControls.templates.template.icon></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-repeat=\"template in searchboxctrl.additionalControls.templates.list\" role=menuitem ng-if=\"searchboxctrl.additionalControls.templates.template.nom !== template.nom\"><span class=\"btn btn-simple-custom\" tooltip-placement=\"auto top\" uib-tooltip={{::template.tooltip}} ng-click=::searchboxctrl.additionalControls.templates.setTemplate(template)><i class=\"fa fa-fw\" ng-class=::template.icon></i></span></li></ul></div><!-- Trier --><div ng-if=::searchboxctrl.additionalControls.tris class=\"sort-dropdown btn-group pull-left\" is-open=searchboxctrl.additionalControls.tris.open uib-dropdown auto-close=outsideClick><span uib-dropdown-toggle class=\"btn btn-simple-custom\"><i class=\"fa fa-fw fa-sort-amount-asc\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=\"custom-block spacer-bottom\"><div class=col-xs-12><div class=input-group><span class=\"input-group-addon bg-custom-light\">Tri</span><select class=\"form-control border-rounded\" title=Tri ng-model=searchboxctrl.additionalControls.tris.ordre><option ng-repeat=\"(valeur, nom) in ::searchboxctrl.additionalControls.tris.list\" value={{::valeur}}>{{::nom}}</option></select></div></div></li><li role=menuitem class=custom-block><div class=col-xs-12><div class=input-group><span class=\"input-group-addon bg-custom-light\">Ordre</span><select class=\"form-control border-rounded\" title=Ordre ng-model=searchboxctrl.additionalControls.tris.tri><option value=asc>Croissant</option><option value=desc>D&eacute;croissant</option></select></div></div></li><li class=divider></li><li role=menuitem><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-block btn-custom-primary\" ng-click=\"::searchboxctrl.additionalControls.tris.trier(); searchboxctrl.additionalControls.tris.open = false\">TRIER</button></div></li></ul></div></div><!-- Recherche --><div class=\"form-group col-xs-6 col-sm-7 col-md-6 col-lg-8 col-xl-6 no-padding\"><div class=col-xs-12 ng-if=searchboxctrl.cloud><div class=cloud-search-check>{{searchboxctrl.citya ? \'Stella\' : \'Gérance/Syndic\'}}<div class=\"material-switch pull-right\"><input type=checkbox id=cloudSearchActive class=\"checkbox form-control\" ng-model=searchboxctrl.search.cloud><label for=cloudSearchActive class=label-success></label></div></div></div><div class=col-xs-12><div class=\"search-input input-group\"><span class=\"input-group-addon current-prestataire border-custom-primary\" ng-if=searchboxctrl.prestataires.selected><a target=_blank ng-href={{searchboxctrl.prestataires.selected.urlBackOffice}}><img ng-if=searchboxctrl.prestataires.selected.hasImg ng-src={{searchboxctrl.prestataires.selected.imgSrc}} alt={{searchboxctrl.prestataires.selected.nom}} title={{searchboxctrl.prestataires.selected.nom}}> <span ng-if=!searchboxctrl.prestataires.selected.hasImg>{{searchboxctrl.prestataires.selected.nom}} </span></a></span><input type=text class=form-control ng-model=searchboxctrl.search.recherche placeholder={{searchboxctrl.sbConfig.placeholder}}> <span class=\"input-group-addon bg-custom-primary custom-search-submit-btn\"><button type=submit><i class=\"fa fa-fw fa-search\"></i></button></span></div><div class=reset-all-container><button type=button ng-if=searchboxctrl.additionalControls.searchToPanier.active class=reset-all ng-click=::searchboxctrl.raz() tooltip-placement=\"auto top\" uib-tooltip=\"Réinitialiser les critères, les filtres et vider le panier\"><i class=\"fa fa-fw fa-trash-o\"></i></button></div></div></div><!-- Additional controls --><div class=\"additional-controls form-group col-xs-3 col-sm-3 col-md-3 col-lg-2 col-xl-3\"><div class=\"btn-group controls-action text-right visible-xs\" uib-dropdown auto-close=outsideClick is-open=\"\" ng-if=searchboxctrl.additionalControls.active><span class=\"dropdown btn-custom\" uib-dropdown-toggle><i class=\"fa fa-fw fa-cog\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><!-- Ajouter nouvel element --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.newElem.active><!-- Type : bien --><div ng-if=\"::(searchboxctrl.additionalControls.newElem.typeElem === \'bien\')\"><div class=\"creer-bien-header col-xs-12\"><i class=\"fa fa-fw fa-plus\"></i> <span class=creer-bien-title>Cr&eacute;er un bien</span></div><div class=\"creer-bien-content col-xs-12 no-padding\"><div class=col-xs-12><ui-select ng-model=searchboxctrl.additionalControls.newElem.type theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Type de bien...\" allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.id as type in searchboxctrl.additionalControls.newElem.typesListe\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=::searchboxctrl.additionalControls.newElem.ajouterElem()>Cr&eacute;er un bien</button></div></div></div><!-- Type : prospect --><div ng-if=\"::(searchboxctrl.additionalControls.newElem.typeElem === \'prospect\')\" class=creer-prospect><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.newElem.ajouterElem()><i class=\"fa fa-fw fa-plus\"></i> Cr&eacute;er un prospect</button></div></li><li class=divider ng-if=\"searchboxctrl.additionalControls.newElem.active && searchboxctrl.additionalControls.searchToProspect.active\r\n                    && searchboxctrl.resetCriteres.active\"></li><!-- Associer la recherche à un (nouveau) prospect --><li role=menuitem class=custom-block ng-if=\"searchboxctrl.additionalControls.searchToProspect.active && searchboxctrl.resetCriteres.active\"><div class=\"associer-recherche-header col-xs-12\"><i class=\"fa fa-fw fa-user-plus\"></i> <span class=associer-recherche-title>Associer recherche &agrave; un prospect</span></div><div class=\"associer-recherche-content col-xs-12 no-padding\"><div class=col-xs-12><ui-select ng-model=searchboxctrl.additionalControls.searchToProspect.prospect theme=bootstrap close-on-select=true on-select=searchboxctrl.additionalControls.searchToProspect.changed() on-remove=searchboxctrl.additionalControls.searchToProspect.changed()><ui-select-match placeholder=\"Chercher un prospect...\" allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"prospect in searchboxctrl.additionalControls.searchToProspect.list\" refresh=searchboxctrl.additionalControls.searchToProspect.search($select.search) refresh-delay=500><div ng-bind-html=\"::prospect.perso.getNomComplet() | highlight: $select.search\"></div><small ng-bind-html=\"::prospect.perso.getEmail() | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=::searchboxctrl.additionalControls.searchToProspect.valider()>{{searchboxctrl.additionalControls.searchToProspect.textBtn}}</button></div></div></li><li class=divider ng-if=\"(searchboxctrl.additionalControls.newElem.active || (searchboxctrl.additionalControls.searchToProspect.active\r\n                    && searchboxctrl.resetCriteres.active)) && searchboxctrl.additionalControls.searchToPanier.active\r\n                    && searchboxctrl.resetCriteres.active\"></li><!-- Associer la recherche au prospect du panier --><li role=menuitem class=custom-block ng-if=\"searchboxctrl.additionalControls.searchToPanier.active && searchboxctrl.resetCriteres.active\"><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.searchToPanier.save()><i class=\"fa fa-fw fa-save\"></i> Associer recherche au prospect actif</button></li><li class=divider ng-if=\"(searchboxctrl.additionalControls.newElem.active || (searchboxctrl.additionalControls.searchToProspect.active\r\n                    && searchboxctrl.resetCriteres.active) || (searchboxctrl.additionalControls.searchToPanier.active\r\n                    && searchboxctrl.resetCriteres.active)) && searchboxctrl.additionalControls.edition.active\"></li><!-- Edition : Ajouter tout --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.edition.active><button type=button class=\"controls-action-btn controls-action-success-btn\" ng-click=\"::searchboxctrl.additionalControls.edition.editerTout(\'ajouterTout\')\"><i class=\"fa fa-fw fa-check-circle-o\"></i> Ajouter tout</button></li><!-- Edition : Supprimer tout --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.edition.active><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=\"::searchboxctrl.additionalControls.impression.editerTout(\'supprimerTout\')\"><i class=\"fa fa-fw fa-times-circle-o\"></i> Supprimer tout</button></li><li class=divider ng-if=\"(searchboxctrl.additionalControls.newElem.active || (searchboxctrl.additionalControls.searchToProspect.active\r\n                    && searchboxctrl.resetCriteres.active) || (searchboxctrl.additionalControls.searchToPanier.active\r\n                    && searchboxctrl.resetCriteres.active) || searchboxctrl.additionalControls.edition.active)\r\n                    && searchboxctrl.additionalControls.impression.active\"></li><!-- Imprimer --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.impression.active><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.impression.imprimer()><i class=\"fa fa-fw fa-print\"></i> Imprimer</button></li><li class=divider ng-if=\"(searchboxctrl.additionalControls.newElem.active\r\n                    || (searchboxctrl.additionalControls.searchToProspect.active && searchboxctrl.resetCriteres.active)\r\n                    || (searchboxctrl.additionalControls.searchToPanier.active && searchboxctrl.resetCriteres.active)\r\n                    || searchboxctrl.additionalControls.edition.active || searchboxctrl.additionalControls.impression.active)\r\n                    && searchboxctrl.additionalControls.envoyerEmail.active\"></li><!-- Email : Envoyer tout --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.envoyerEmail.active><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.envoyerEmail.envoyer()><i class=\"fa fa-fw fa-envelope\"></i> Envoyer tout</button></li><li class=divider ng-if=\"(searchboxctrl.additionalControls.newElem.active\r\n                    || (searchboxctrl.additionalControls.searchToProspect.active && searchboxctrl.resetCriteres.active)\r\n                    || (searchboxctrl.additionalControls.searchToPanier.active && searchboxctrl.resetCriteres.active)\r\n                    || searchboxctrl.additionalControls.edition.active || searchboxctrl.additionalControls.impression.active\r\n                    || searchboxctrl.additionalControls.envoyerEmail.active) && searchboxctrl.additionalControls.checkParutions.active\"></li><!-- Check parutions --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.checkParutions.active><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.checkParutions.showParutions()><i class=\"fa fa-fw fa-calendar-check-o\"></i> &Eacute;tat des parutions</button></li><!-- Selection --><li role=menuitem class=custom-block ng-if=searchboxctrl.additionalControls.selection.active><button type=button class=controls-action-btn ng-click=::searchboxctrl.additionalControls.selection.toggleSelection()><i class=\"fa fa-fw\" ng-class=\"{\r\n                    \'fa-window-close-o\': searchboxctrl.additionalControls.selection.selected,\r\n                    \'fa-check-square-o\': !searchboxctrl.additionalControls.selection.selected\r\n                   }\"></i> {{searchboxctrl.additionalControls.selection.selected ? \'Tout Désélectionner\' : \'Tout Sélectionner\'}}</button></li></ul></div><!-- Ajouter element type : bien --><div ng-if=\"searchboxctrl.additionalControls.newElem.active && searchboxctrl.additionalControls.newElem.typeElem === \'bien\'\" class=\"ajouter-bien-dropdown btn-group pull-right hidden-xs\" uib-dropdown auto-close=outsideClick><span uib-dropdown-toggle class=\"btn btn-simple-custom\" tooltip-placement=\"auto top\" uib-tooltip=\"Créer un bien\"><i class=\"fa fa-fw fa-plus\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><div class=col-xs-12><ui-select ng-model=searchboxctrl.additionalControls.newElem.type theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Type de bien...\" allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.id as type in searchboxctrl.additionalControls.newElem.typesListe\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></li><li class=divider></li><li role=menuitem><div class=col-xs-12><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=\"::searchboxctrl.additionalControls.newElem.ajouterElem(); searchboxctrl.additionalControls.newElem.open = !searchboxctrl.additionalControls.newElem.open\">Cr&eacute;er un bien</button></div></li></ul></div><!-- Ajouter element type : prospect --><div ng-if=\"searchboxctrl.additionalControls.newElem.active && searchboxctrl.additionalControls.newElem.typeElem === \'prospect\'\" class=\"ajouter-bien-dropdown btn-group pull-right\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.newElem.ajouterElem() tooltip-placement=\"auto top\" uib-tooltip=\"Créer un prospect\"><i class=\"fa fa-fw fa-plus\"></i></span></div><!-- Associer la recherche à un (nouveau) prospect --><div ng-if=\"searchboxctrl.additionalControls.searchToProspect.active && searchboxctrl.resetCriteres.active\" class=\"associer-recherche-dropdown btn-group pull-right hidden-xs\" uib-dropdown auto-close=outsideClick><span uib-dropdown-toggle class=\"btn btn-simple-custom\" tooltip-placement=\"auto top\" uib-tooltip=\"Associer recherche à un prospect\"><i class=\"fa fa-fw fa-user-plus\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><div class=\"col-xs-12 spacer-bottom\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=::searchboxctrl.additionalControls.searchToProspect.valider()>{{searchboxctrl.additionalControls.searchToProspect.textBtn}}</button></div></li><li class=divider></li><li role=menuitem class=custom-block><div class=\"col-xs-12 spacer-top\"><ui-select ng-model=searchboxctrl.additionalControls.searchToProspect.prospect theme=bootstrap close-on-select=true on-select=searchboxctrl.additionalControls.searchToProspect.changed() on-remove=searchboxctrl.additionalControls.searchToProspect.changed()><ui-select-match placeholder=\"Chercher un prospect...\" allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"prospect in searchboxctrl.additionalControls.searchToProspect.list\" refresh=searchboxctrl.additionalControls.searchToProspect.search($select.search) refresh-delay=350><div ng-bind-html=\"::prospect.perso.getNomComplet() | highlight: $select.search\"></div></ui-select-choices></ui-select></div></li></ul></div><!-- Associer la recherche au prospect du panier --><div ng-if=\"searchboxctrl.additionalControls.searchToPanier.active && searchboxctrl.resetCriteres.active\" class=\"associer-recherche-panier btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.searchToPanier.save() tooltip-placement=\"auto top\" uib-tooltip=\"Associer recherche au prospect actif\"><i class=\"fa fa-fw fa-save\"></i></span></div><!-- Imrpimer --><div ng-if=searchboxctrl.additionalControls.impression.active class=\"sb-imprimer btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.impression.imprimer() tooltip-placement=\"auto top\" uib-tooltip=Imprimer><i class=\"fa fa-fw fa-print\"></i></span></div><!-- Edition : Supprimer tout --><div ng-if=searchboxctrl.additionalControls.edition.active class=\"sb-edition sb-edition-danger btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-danger\" ng-click=\"::searchboxctrl.additionalControls.edition.editer(\'supprimerTout\')\" tooltip-placement=\"auto top\" uib-tooltip=\"Supprimer tous les biens\"><i class=\"fa fa-fw fa-times-circle-o\"></i></span></div><!-- Edition : Ajouter tout --><div ng-if=searchboxctrl.additionalControls.edition.active class=\"sb-edition sb-edition-success btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-success\" ng-click=\"::searchboxctrl.additionalControls.edition.editer(\'ajouterTout\')\" tooltip-placement=\"auto top\" uib-tooltip=\"Ajouter tous les biens\"><i class=\"fa fa-fw fa-check-circle-o\"></i></span></div><!-- Email : envoyer --><div ng-if=searchboxctrl.additionalControls.envoyerEmail.active class=\"sb-envoyer btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.envoyerEmail.envoyer() tooltip-placement=\"auto top\" uib-tooltip=\"Envoyer le bien aux prospects sélectionnés\"><i class=\"fa fa-fw fa-envelope\"></i></span></div><!-- Email : envoyer --><div ng-if=searchboxctrl.additionalControls.checkParutions.active class=\"sb-envoyer btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.checkParutions.showParutions() tooltip-placement=\"auto top\" uib-tooltip=\"Voir l\'état des parutions ICSBox\"><i class=\"fa fa-fw fa-calendar-check-o\"></i></span></div><!-- Selection --><div ng-if=searchboxctrl.additionalControls.selection.active class=\"sb-envoyer btn-group pull-right hidden-xs\"><span class=\"btn btn-simple-custom\" ng-click=::searchboxctrl.additionalControls.selection.toggleSelection() tooltip-placement=\"auto top\" uib-tooltip=\"{{searchboxctrl.additionalControls.selection.selected ? \'Tout Désélectionner\' : \'Tout Sélectionner\'}}\"><i class=\"fa fa-fw\" ng-class=\"{\r\n                    \'fa-window-close-o\': searchboxctrl.additionalControls.selection.selected,\r\n                    \'fa-check-square-o\': !searchboxctrl.additionalControls.selection.selected\r\n                   }\"></i></span></div></div></div><div class=row><div class=filters-box ng-if=\"searchboxctrl.criteres.active || searchboxctrl.prestataires.active || searchboxctrl.filtres.active\"><!-- + de critères --><div ng-if=searchboxctrl.criteres.active ng-show=searchboxctrl.criteres.open><sb-criteres is-loading=searchboxctrl.criteres.loading villes-model=searchboxctrl.criteres.list.villes.value types-model=searchboxctrl.criteres.list.types.value prix-min-model=searchboxctrl.criteres.list.prix.valueMin prix-max-model=searchboxctrl.criteres.list.prix.valueMax criteres-model=searchboxctrl.criteres.list.criteres.value></sb-criteres></div><!-- + de prestataires --><div ng-if=searchboxctrl.prestataires.active ng-show=searchboxctrl.prestataires.open><sb-prestataires prestataire-model=searchboxctrl.prestataires.value on-select-prestataire=\"searchboxctrl.prestataires.onSelectPrestataire(prestataire, firstLoad)\" is-loading=searchboxctrl.prestataires.loading></sb-prestataires></div><!-- + de filtres --><div ng-if=searchboxctrl.filtres.active ng-show=searchboxctrl.filtres.open><sb-filtres is-loading=searchboxctrl.filtres.loading geolocalisation-model=searchboxctrl.filtres.list.geolocalisation.value societes-model=searchboxctrl.filtres.list.societes.value nego-model=searchboxctrl.filtres.list.nego.value mandat-model=searchboxctrl.filtres.list.visibilite.valueMandat archive-model=searchboxctrl.filtres.list.visibilite.valueArchive attente-model=searchboxctrl.filtres.list.etat.valueAttente option-model=searchboxctrl.filtres.list.etat.valueOption type-contrat-model=searchboxctrl.filtres.list.typeContrat.value type-mandat-model=searchboxctrl.filtres.list.typeMandat.value datedeb-model=searchboxctrl.filtres.list.dateMandat.valueDatedeb datefin-model=searchboxctrl.filtres.list.dateMandat.valueDatefin datedeb-saisie-model=searchboxctrl.filtres.list.dateSaisie.valueDatedeb datefin-saisie-model=searchboxctrl.filtres.list.dateSaisie.valueDatefin datedeb-signature-model=searchboxctrl.filtres.list.dateSignature.valueDatedeb datefin-signature-model=searchboxctrl.filtres.list.dateSignature.valueDatefin gestion-agence-model=searchboxctrl.filtres.list.gestionAgence.value avancement-model=searchboxctrl.filtres.list.avancement.value duree-vacance-model=searchboxctrl.filtres.list.dureeVacance.value parution-model=searchboxctrl.filtres.list.parution.value panneaux-model=searchboxctrl.filtres.list.panneaux.value paru-model=searchboxctrl.filtres.list.paru.value qualification-model=searchboxctrl.filtres.list.qualification.value encaissement-model=searchboxctrl.filtres.list.encaissement.value intrabox-model=searchboxctrl.filtres.list.intrabox.value valider-model=searchboxctrl.filtres.list.valider.value expire-model=searchboxctrl.filtres.list.expire.value expirant-model=searchboxctrl.filtres.list.expirant.value sans-dpe-model=searchboxctrl.filtres.list.sansDpe.value></sb-filtres></div></div></div><div class=row><div class=\"search-input-actions col-xs-9 col-xs-offset-3 col-sm-10 col-sm-offset-2 col-md-9 col-md-offset-3 col-lg-10 col-lg-offset-2 col-xl-9 col-xl-offset-3\"><button type=button ng-if=::searchboxctrl.criteres.active class=\"sb-action-btn criteres-plus\" ng-click=\"::searchboxctrl.togglePanel(\'criteres\')\"><i class=\"fa fa-search-plus\"></i> <i class=\"fa fa-xs\" ng-class=\"{\'fa-minus\': searchboxctrl.criteres.open, \'fa-plus\': !searchboxctrl.criteres.open}\"></i> <span class=hidden-xs>Crit&egrave;res</span></button> <button type=button ng-if=searchboxctrl.resetCriteres.active class=\"sb-action-btn reset-criteres\" ng-click=::searchboxctrl.resetCriteres.reset(true) tooltip-placement=\"auto top\" uib-tooltip=\"Réinitialiser des critères\"><i class=\"fa fa-trash-o\"></i></button> <button type=button ng-if=::searchboxctrl.prestataires.active class=\"sb-action-btn prestataires-plus\" ng-click=\"::searchboxctrl.togglePanel(\'prestataires\')\"><i class=\"fa fa-user-circle-o\"></i> <i class=\"fa fa-xs\" ng-class=\"{\'fa-minus\': searchboxctrl.prestataires.open, \'fa-plus\': !searchboxctrl.prestataires.open}\"></i> <span class=hidden-xs>Prestataires</span></button> <button type=button ng-if=::searchboxctrl.filtres.active class=\"sb-action-btn filtres-plus\" ng-click=\"::searchboxctrl.togglePanel(\'filtres\')\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-xs\" ng-class=\"{\'fa-minus\': searchboxctrl.filtres.open,\'fa-plus\': !searchboxctrl.filtres.open}\"></i> <span class=hidden-xs>Filtres</span></button> <button type=button ng-if=searchboxctrl.resetFiltres.active class=\"sb-action-btn reset-criteres\" ng-click=::searchboxctrl.resetFiltres.reset(true) tooltip-placement=\"auto top\" uib-tooltip=\"Réinitialiser des filtres\"><i class=\"fa fa-trash-o\"></i></button></div></div><div class=row ng-if=searchboxctrl.resume.active><div class=\"search-resume col-xs-12 text-center\">Recherche : <span dynamic-html=searchboxctrl.resume.html title={{searchboxctrl.resume.tooltip}}></span></div></div></form></div>");
$templateCache.put("app/components/utils/r-select/r-select.html","<div uib-dropdown on-toggle=rsctrl.onToggleOptions(open) is-open=rsctrl.isOpen auto-close=disabled class=\"r-select rs-main-container {{rsctrl.rsClasses.main}}\" ng-class=\"{\'rs-multiple\': rsctrl.multiple, \'rs-disabled\': rsctrl.disabled}\"><div ng-if=\"rsctrl.multiple && rsctrl.ngModel.length\" class=rs-choices><div class=\"rs-choice btn btn-default btn-xs\" ng-repeat=\"choice in rsctrl.ngModel\" ng-class=\"{\'focused\': rsctrl.focused && $last}\"><span class=rs-choice-label ng-bind=::rsctrl.getLabel(choice)></span> <i class=\"rs-choice-remove fa fa-times\" ng-click=::rsctrl.removeChoice(choice)></i></div><i class=\"rs-choices-clear btn-xs btn-link fa fa-times\" ng-click=::rsctrl.clearModel()></i></div><div class=rs-search><input ng-if=\"rsctrl.multiple || (!rsctrl.ngModel || rsctrl.isOpen)\" ng-model=rsctrl.search class=\"form-control rs-input {{rsctrl.rsClasses.input}}\" ng-class=\"{\'rs-input-rounded\': rsctrl.multiple && !rsctrl.ngModel.length}\" uib-dropdown-toggle ng-change=::rsctrl.onSearch() ng-keydown=rsctrl.onInputKeyDown($event) placeholder={{rsctrl.placeholder}} tgn-focus=rsctrl.focusInputSearch ng-disabled=rsctrl.disabled><div ng-if=\"!rsctrl.multiple && rsctrl.ngModel && !rsctrl.isOpen\" class=rs-choice ng-click=::rsctrl.clearModel()>{{::rsctrl.getLabel(rsctrl.ngModel)}}</div><i class=\"caret pull-right\" ng-if=\"!rsctrl.isOpen && !rsctrl.multiple\"></i></div><div uib-dropdown-menu class=rs-options ng-class=rsctrl.rsClasses.options ng-style=rsctrl.dropdownStyle><r-select-option ng-repeat=\"option in rsctrl.options track by option.label\" rs-option=option rs-labelled-by=rsctrl.rsLabelledBy on-select-option=rsctrl.setModel(option)></r-select-option></div></div>");
$templateCache.put("app/components/utils/timeline-horizontal/timeline-horizontal.html","<div class=timeline-horizontal><h3 class=text-center ng-if=timelinehorizontalctrl.listeEtapes.titre>{{timelinehorizontalctrl.listeEtapes.titre}}</h3><h4 class=text-center ng-if=timelinehorizontalctrl.listeEtapes.titre2>{{timelinehorizontalctrl.listeEtapes.titre2}}</h4><ul class=\"list-unstyled th-steps flex-container-column\"><li ng-repeat=\"etape in timelinehorizontalctrl.listeEtapes.etapes | orderBy: \'id\'\" class=\"flex-item step\" ng-class=\"{\r\n			    \'step-first\': $first, \'step-last\': $last,\r\n			    \'step-active\': etape.id === timelinehorizontalctrl.etapeCourante,\r\n			    \'step-not-completed\': !etape.completed,\r\n			    \'step-completed\': etape.completed\r\n		    }\"><div class=\"step-content text-center\"><div class=step-img ng-click=timelinehorizontalctrl.changeEtapeCourante(etape.id)><i class=\"fa fa-fw fa-2x\" ng-class=etape.icone></i></div><div class=step-name ng-bind=etape.libelle></div></div></li></ul></div>");
$templateCache.put("app/components/utils/tree-view/tree-view.html","<ul class=\"tree-view list-unstyled\"><li ng-repeat=\"fichier in treeviewctrl.fichiers\" class=node-container ng-class=\"{\'selected\': fichier.selected, \'folder\': fichier.isFolder}\"><span class=node-elem ng-click=treeviewctrl.selectFichier(fichier)><i class=\"fa fa-fw\" ng-class=\"{\'fa-folder\': fichier.isFolder, \'fa-folder-open\': fichier.isOpen, \'fa-file\': !fichier.isFolder}\"></i> {{fichier.label}}</span><tree-view ng-if=\"fichier.isFolder && fichier.isOpen\" fichiers=fichier.fichiers on-select-fichier=treeviewctrl.selectFichier(fichier) is-first=false></tree-view></li></ul>");
$templateCache.put("app/components/utils/validation-viewer/validation-viewer.html","<div class=validation-viewer ng-class=\"{\r\n			 \'vv-success\': validationviewerctrl.vvTimeline.etapes.completed,\r\n			 \'vv-error\': !validationviewerctrl.vvTimeline.etapes.completed\r\n		 }\"><div class=validation-header ng-click=\"isOpen = !isOpen;\"><i class=\"fa fa-fw\" ng-class=\"{\r\n		     \'fa-check-circle\': validationviewerctrl.vvTimeline.etapes.completed,\r\n		     \'fa-times-circle\': !validationviewerctrl.vvTimeline.etapes.completed\r\n	     }\"></i> <span class=validation-title>Saisie <span ng-if=!validationviewerctrl.vvTimeline.etapes.completed>in</span>compl&egrave;te</span></div><div class=\"validation-content container-fluid\" ng-if=isOpen><ul class=\"list-unstyled row\"><li ng-repeat=\"etape in validationviewerctrl.vvTimeline.etapes.etapes | filter: {\'completed\': false}\" class=\"etape-viewer col-xs-12\"><h4 class=etape-title>{{etape.libelle}}</h4><div class=\"etape-field flex-container-column col-xs-12\" ng-repeat=\"field in etape.rFields | tgnFilterBy: [\'completed\']: \'false\'\" ng-click=validationviewerctrl.vvTimeline.onChange(etape.id)><span class=\"field-name flex-item\"><span class=name-text>{{field.label}}</span></span> <span class=field-value><i class=\"fa fa-fw fa-times\"></i></span></div></li></ul></div></div>");
$templateCache.put("app/components/main-content/accueil/accueil-perso/accueil-perso.html","<div class=\"accueil-perso row\"><div class=\"col-xs-6 col-sm-5 col-sm-offset-1 col-md-4 col-md-offset-2 col-lg-3 col-lg-offset-3 col-xl-2 col-xl-offset-4 no-padding-left spacer-bottom text-right\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary btn-accueil\" ng-click=\"accueilpersoctrl.search.toggle(\'acquereur\')\" ng-class=\"{\'active\': accueilpersoctrl.typeActive === \'acquereur\'}\">{{accueilpersoctrl.texts.btnAcceuilAcquereur}}</button></div><div class=\"col-xs-6 col-sm-5 col-md-4 col-lg-3 col-xl-2 no-padding-right spacer-bottom\"><button type=button class=\"btn-custom btn-custom-block btn-custom-primary btn-accueil\" ng-click=\"accueilpersoctrl.search.toggle(\'vendeur\')\" ng-class=\"{\'active\': accueilpersoctrl.typeActive === \'vendeur\'}\">{{accueilpersoctrl.texts.btnAcceuilVendeur}}</button></div><!-- <div class=\"col-xs-12 accueil-perso-titre\" ng-if=\"accueilpersoctrl.search.open || accueilpersoctrl.persos.open\">\r\n    <h3 class=\"titre-search\" ng-class=\"{\r\n				  \'transac\': accueilpersoctrl.globalService.getTypeApplication() === \'Transaction\',\r\n				  \'gesloc\': accueilpersoctrl.globalService.getTypeApplication() === \'Location\'\r\n				}\">\r\n      {{accueilpersoctrl.texts.titreSearch}}\r\n    </h3>\r\n  </div> --><div class=\"col-xs-12 no-padding accueil-perso-search\" ng-if=accueilpersoctrl.search.open><form class=\"form-horizontal perso-search-form\" name=accueilSearch ng-submit=accueilpersoctrl.search.search() novalidate><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=nom class=sr-only>Nom</label><input type=text id=nom name=nom class=\"form-control border-rounded\" placeholder=\"Nom *\" ng-model=accueilpersoctrl.query.nom tgn-focus=\"accueilpersoctrl.search.focus === \'nom\'\"></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=prenom class=sr-only>Prénom</label><input type=text id=prenom name=prenom class=\"form-control border-rounded\" placeholder=\"Prénom *\" ng-model=accueilpersoctrl.query.prenom tgn-focus=\"accueilpersoctrl.search.focus === \'prenom\'\"></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=dateNaissance class=sr-only>Date de naissance</label><div class=input-group><input id=dateNaissance custom-type=date ui-mask=99/99/9999 name=dateNaissance class=\"form-control border-left-rounded\" ng-model=accueilpersoctrl.query.dateNaissance tgn-focus=\"accueilpersoctrl.search.focus === \'dateNaissance\'\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker border-right-rounded\" ng-click=\"accueilpersoctrl.datepickers.dateNaissance.open = !accueilpersoctrl.datepickers.dateNaissance.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=accueilpersoctrl.datepickers.dateNaissance.open class=\"event-datepicker row\" ng-click=\"::accueilpersoctrl.datepickers.onClose(\'dateNaissance\')\"><datetime-picker click-prevent time-picker=false date-model=accueilpersoctrl.query.dateNaissance on-close=\"::accueilpersoctrl.datepickers.onClose(\'dateNaissance\')\"></datetime-picker></div></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=codePostal class=sr-only>Cp</label><input type=text id=codePostal name=codePostal class=\"form-control border-rounded\" placeholder=\"Code postal *\" ng-model=accueilpersoctrl.query.codePostal tgn-focus=\"accueilpersoctrl.search.focus === \'codePostal\'\"></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=email class=sr-only>Email</label><input type=email id=email name=email class=\"form-control border-rounded\" placeholder=\"Email *\" ng-model=accueilpersoctrl.query.email tgn-focus=\"accueilpersoctrl.search.focus === \'email\'\"></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><label for=tel class=sr-only>Tel</label><input type=tel id=tel name=tel class=\"form-control border-rounded\" placeholder=\"Tel *\" ng-model=accueilpersoctrl.query.tel tgn-focus=\"accueilpersoctrl.search.focus === \'tel\'\"></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><!-- <ui-select ng-model=\"accueilpersoctrl.societes.query\" theme=\"bootstrap\" close-on-select=\"true\"\r\n                   on-select=\"accueilpersoctrl.societes.setSocietes()\"\r\n                   on-remove=\"accueilpersoctrl.societes.setSocietes()\">\r\n          <ui-select-match placeholder=\"Société...\">{{$item.nom}}</ui-select-match>\r\n          <ui-select-choices repeat=\"societe.id as societe in accueilpersoctrl.societes.list | filter: $select.search\"\r\n            group-by=\"accueilpersoctrl.societes.groupChoices\">\r\n            <div ng-bind-html=\"::societe.nom | highlight: $select.search\"></div>\r\n          </ui-select-choices>\r\n        </ui-select> --><r-select ng-model=accueilpersoctrl.societes.query rs-options=accueilpersoctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé\'\" rs-on-change=accueilpersoctrl.societes.setSocietes()></r-select></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><div class=cloud-search-check>{{accueilpersoctrl.citya ? \'Stella\' : \'Gérance/Syndic\'}}<div class=\"material-switch pull-right\"><input type=checkbox id=cloudSearchActive class=\"checkbox form-control\" ng-model=accueilpersoctrl.query.icscloud><label for=cloudSearchActive class=label-success></label></div></div></div><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4 spacer-bottom\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-primary border-rounded\"><i class=\"fa fa-fw fa-search\"></i> Rechercher</button></div></form></div><div class=\"col-xs-12 no-padding accueil-perso-resultats\" ng-if=accueilpersoctrl.persos.open><div class=\"col-xs-12 col-md-6 col-md-offset-6 col-lg-4 col-lg-offset-8 col-xl-3 col-xl-offset-9\"><div class=input-group><ui-select ng-if=accueilpersoctrl.typesBien.active ng-model=accueilpersoctrl.typesBien.selected theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Type de bien...\" allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.id as type in accueilpersoctrl.typesBien.list\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"no-border no-padding\" ng-class=\"{\'input-group-addon\': accueilpersoctrl.typesBien.active}\"><button type=button class=\"btn-custom btn-custom-primary border-left-straight\" ng-click=accueilpersoctrl.persos.creation()>Cr&eacute;ation</button></span></div></div><div ng-if=accueilpersoctrl.persos.loading class=\"loader loader-sm\"></div><div ng-if=!accueilpersoctrl.persos.loading class=\"col-xs-12 text-center spacer-bottom\"><strong><span ng-if=accueilpersoctrl.persos.nb>{{accueilpersoctrl.persos.nb}}</span> <span ng-if=!accueilpersoctrl.persos.nb>Aucun</span> r&eacute;sultat <span ng-if=\"accueilpersoctrl.persos.nb > 1\">s</span> </strong>pour la recherche <span ng-if=accueilpersoctrl.query.nom><a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'nom\')\">{{accueilpersoctrl.query.nom}}</a> </span><span ng-if=accueilpersoctrl.query.prenom><a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'prenom\')\">{{accueilpersoctrl.query.prenom}}</a> </span><span ng-if=accueilpersoctrl.query.dateNaissance>n&eacute; le <a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'dateNaissance\')\">{{accueilpersoctrl.query.dateNaissance}}</a> </span><span ng-if=accueilpersoctrl.query.codePostal>domicili&eacute; au <a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'codePostal\')\">{{accueilpersoctrl.query.codePostal}}</a> </span><span ng-if=accueilpersoctrl.query.email>, email : <a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'email\')\">{{accueilpersoctrl.query.email}}</a> </span><span ng-if=accueilpersoctrl.query.tel>, tel : <a class=search-link ng-click=\"accueilpersoctrl.persos.backToSearch(\'tel\')\">{{accueilpersoctrl.query.tel}}</a></span></div><div ng-if=accueilpersoctrl.persos.nb class=\"persos-list col-xs-12 no-padding spacer-bottom responsive-table-line\"><table class=\"table table-bordered table-hover\"><thead><tr><th>Type</th><th>R&eacute;f&eacute;rence</th><th>Civilit&eacute;</th><th>Nom</th><th>Pr&eacute;nom</th><th>Email</th><th>Tel</th><th>Rue</th><th>Cp</th><th>Ville</th><th>Agence - n&eacute;gociateur</th><th class=hidden></th></tr></thead><tbody><tr class=perso-selectable ng-repeat-start=\"perso in accueilpersoctrl.persos.list\" ng-click=accueilpersoctrl.persos.chosePerso(perso) ng-class=\"{\'archive\': perso.archive}\"><td data-title=Type class=text-center><i class=\"fa fa-fw\" ng-class=\"{\r\n								   \'fa-user-o\': perso.physique,\r\n								   \'fa-building-o\': !perso.physique\r\n								 }\"></i></td><td data-title=Référence><span ng-if=perso.archive>(Archiv&eacute;) </span>{{::perso.ref}}</td><td data-title=Civilité>{{::perso.civilite.label}}</td><td data-title=Nom>{{::perso.nom}}</td><td data-title=Prénom>{{::perso.prenom}}</td><td data-title=Email ng-class=\"{\'text-center\': !perso.getEmail()}\">{{perso.getEmail() ? perso.getEmail() : \'-\'}}</td><td data-title=Tel ng-class=\"{\'text-center\': !perso.getTelMobile() && !perso.getTel()}\">{{(perso.getTelMobile() || perso.getTel()) ? perso.getTelMobile() || perso.getTel() : \'-\'}}</td><td data-title=Rue>{{::perso.adresses[0].rue}}</td><td data-title=Cp>{{::perso.adresses[0].cp}}</td><td data-title=Ville>{{::perso.adresses[0].ville}}</td><td data-title=Agence>{{::perso.societe}} <span ng-if=::perso.nego>- {{::perso.nego}}</span></td><td click-prevent ng-if=\"accueilpersoctrl.query.type === \'prospect\' || accueilpersoctrl.query.type === \'locataire\'\"><span ng-click=\"perso.showCriteres = !perso.showCriteres\" class=text-center><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': perso.showCriteres, \'fa-plus\': !perso.showCriteres}\"></i></span></td></tr><tr ng-repeat-end ng-if=\"perso.showCriteres && (accueilpersoctrl.query.type === \'prospect\' || accueilpersoctrl.query.type === \'locataire\')\"><td data-title=Critères colspan=10><div ng-if=perso.comRepertoire class=with-newlines>{{::perso.comRepertoire}}</div><i ng-if=!perso.comRepertoire>Crit&egrave;res non renseign&eacute;s.</i></td><td><button type=button class=\"btn-custom btn-custom-primary\" ng-click=accueilpersoctrl.persos.plusDeBiens(perso)><i class=\"fa fa-fw fa-search\"></i> Chercher des biens</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/main-content/accueil/actualites/actualites.html","<div class=\"accueilAlertes col-xs-12\"><div class=row><div masonry=\"{horizontalOrder: true}\" load-images=true preserve-order reload-on-resize><div ng-repeat=\"diffusion in actualitesctrl.actualites.diffusions\" class=\"col-xs-12 col-lg-6 col-xl-4 masonry-brick\"><bloc-alerte property=::diffusion on-view-diffusion=::actualitesctrl.onViewDiffusion(diffusion.alerte.id) on-show-fiche-bien=::actualitesctrl.showFicheBien(refLot) on-show-fiche-prospect=::actualitesctrl.showFicheProspect(refProspect)></bloc-alerte></div></div></div></div>");
$templateCache.put("app/components/main-content/accueil/statistiques/statistiques.html","<div class=accueilStatistiques><div class=\"col-xs-12 col-sm-8 chartLeft\"><highchart config=statsctrl.chartConfig></highchart><br class=visible-xs></div><div class=\"col-xs-12 col-sm-4 chartRight\"><highchart id=container-speed config=statsctrl.chartObjectifConfig></highchart></div></div>");
$templateCache.put("app/components/main-content/accueil/todoliste/todoliste.html","<div class=accueilToDo><div class=\"col-xs-12 no-padding\"><div class=newTaskBlock ng-if=todolistectrl.newTaskPanel.open><form name=newTaskForm class=form-horizontal ng-submit=todolistectrl.addNewTask(newTaskForm) novalidate><div class=col-xs-12><div class=form-group ng-class=\"{\'has-error\': newTaskForm.commentaire.$error.required && newTaskForm.$submitted}\"><label for=description class=\"col-xs-12 col-md-12 col-lg-12\">Description</label><div class=\"col-xs-12 col-md-12 col-lg-12\"><input type=text class=form-control id=description name=description required ng-model=todolistectrl.newTask.description></div></div><div class=form-group><div class=\"col-xxs-12 col-xs-6 col-sm-4 spacer-bottom\"><r-select rs-multiple ng-model=todolistectrl.societes.societes rs-options=todolistectrl.societes.currentList rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé(s)...\'\" rs-on-change=todolistectrl.societes.changed()></r-select></div><div class=\"col-xxs-12 col-xs-6 col-sm-4 spacer-bottom\"><ui-select ng-model=todolistectrl.negos.nego theme=bootstrap close-on-select=true on-select=todolistectrl.negos.changed() on-remove=todolistectrl.negos.changed()><ui-select-match placeholder=Négo... allow-clear=true>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in todolistectrl.negos.list | filter: $select.search track by nego.id\" refresh=todolistectrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-0\"><button type=submit class=\"btn-custom btn-custom-block btn-custom-primary\">Enregistrer</button></div></div></div></form></div><div class=todoBlock><div class=noTasks ng-if=\"todolistectrl.todoliste.length == 0\">Aucune tâche à accomplir.</div><ul><li ng-repeat=\"task in todolistectrl.todoliste\"><input id=checkBox{{$index}} ng-click=\"::todolistectrl.checkTask(task, $index)\" ng-checked=task.accompli class=green-background type=checkbox><label class=green-background for=checkBox{{$index}}></label><span class=task-desc ng-class=\"{\'textChecked\' : task.accompli}\">{{task.description}}</span> <span ng-if=\"::(task.lotref || task.prospectref || task.compromisId)\">-</span> <span ng-if=::task.lotref class=task-lot ng-click=::todolistectrl.showFiche(task.lotref)><i class=\"fa fa-fw fa-home\"></i> <span class=hidden-xs>Lot</span> </span><span ng-if=::task.prospectref class=task-prospect ng-click=::todolistectrl.showProspect(task.prospectref)><i class=\"fa fa-fw fa-user\"></i> <span class=hidden-xs>Prospect</span></span></li></ul></div></div></div>");
$templateCache.put("app/components/main-content/accueil/visites/visites.html","<div class=accueilVisites><div class=\"col-xs-12 no-padding\"><div class=visitesBlock><div class=noVisites ng-if=\"visitesctrl.visites.length == 0\">Aucune visite pr&eacute;vue pour ce jour.</div><uib-accordion class=visitesList close-others=true><div uib-accordion-group ng-repeat=\"visite in visitesctrl.visites\" is-open=visitesctrl.openAccordion[$index]><uib-accordion-heading><div ng-click=::visitesctrl.fillCR(visite) class=inline-block><span class=slotVisite><i class=\"fa fa-lg fa-clock-o\"></i> {{::visite.slot}}</span> {{::visite.description}}</div></uib-accordion-heading><div class=col-xs-12><div ng-repeat=\"action in visite.actions\" class=visite-item-action><div ng-bind-html=::action.label ng-click=::action.onClick()></div></div></div><form ng-if=\"visite.active || !visite.hasOwnProperty(\'active\')\" name=visiteForm class=form-horizontal novalidate><div class=col-xs-12><div class=form-group><label for=description class=\"col-xs-12 col-md-12 col-lg-12\">Compte-rendu</label><div class=\"col-xs-12 col-md-12 col-lg-12\"><textarea class=form-control id=description name=description required rows=5 ng-model=visitesctrl.newCompteRendu.description></textarea></div></div></div><div class=\"col-xs-12 text-right visite-controls\"><button multiple-submit=\"visitesctrl.envoyerEmail(visiteForm, visite, index)\" class=\"btn-custom btn-custom-sm btn-custom-primary\"><i class=\"fa fa-fw fa-envelope\"></i> Envoyer par email</button> <button multiple-submit=\"visitesctrl.addCompteRendu(visiteForm, visite, $index)\" class=\"btn-custom btn-custom-sm btn-custom-primary\"><i class=\"fa fa-fw fa-save\"></i> Enregistrer</button></div></form></div></uib-accordion></div></div></div>");
$templateCache.put("app/components/main-content/compromis/bloc-compromis/bloc-compromis.html","<div class=\"bloc-compromis-container col-xs-12\"><div class=archive ng-if=bloccompromisctrl.compromis.archive>Archiv&eacute;</div><div class=compromis><div ng-if=bloccompromisctrl.ribbon.date class=custom-ribbon ng-class=bloccompromisctrl.ribbon.classe><span class=custom-ribbon-content>{{::bloccompromisctrl.ribbon.text}}{{::bloccompromisctrl.ribbon.date}}</span></div><div class=\"compromis-header row\"><div class=\"compromis-title col-xs-12 col-sm-6\"><h4 class=\"title text-right\">{{::bloccompromisctrl.titre}} N&deg;{{::bloccompromisctrl.compromis.id}}</h4></div><div class=\"compromis-date col-xs-12 col-sm-6\"><span class=date>{{::bloccompromisctrl.compromis.date}}</span></div></div><div class=\"compromis-body row\"><div class=\"compromis-acheteur col-xs-12 col-sm-6\"><div class=vendeur><span class=\"vendeur-libelle col-xs-12 text-center\">Vendeur :</span> <span class=\"vendeur-nom col-xs-12 text-center\">{{::bloccompromisctrl.compromis.getVendeurNomComplet()}}</span> <small class=\"vendeur-nego col-xs-12 text-center\" ng-if=::bloccompromisctrl.compromis.affaire.mandatTransaction.nego>N&eacute;go : <span class=vendeur-nego-value>{{::(bloccompromisctrl.compromis.affaire.mandatTransaction.nego.perso ? bloccompromisctrl.compromis.affaire.mandatTransaction.nego.perso.nomComplet : bloccompromisctrl.compromis.affaire.mandatTransaction.nego.initiales)}}</span></small></div></div><div class=\"compromis-vendeur col-xs-12 col-sm-6\"><div class=acheteur><span class=\"acheteur-libelle col-xs-12 text-center\">Acheteur :</span> <span class=\"acheteur-nom col-xs-12 text-center\">{{::bloccompromisctrl.compromis.getAcheteurNomComplet()}}</span> <small class=\"acheteur-nego col-xs-12 text-center\" ng-if=::bloccompromisctrl.compromis.acheteur.nego>N&eacute;go : <span class=acheteur-nego-value>{{::(bloccompromisctrl.compromis.acheteur.nego.perso ? bloccompromisctrl.compromis.acheteur.nego.perso.nomComplet : bloccompromisctrl.compromis.acheteur.nego.initiales)}}</span></small></div></div><div class=btn-voir-container><button class=\"btn-custom btn-custom-primary btn-voir\" ng-click=::bloccompromisctrl.showFiche()><i class=\"fa fa-fw fa-eye\"></i></button></div></div><div class=\"compromis-footer row\"><div class=\"compromis-affaire col-xs-12\"><span class=affaire-libelle>Affaire :</span> <small class=\"affaire-ref pull-right\">Ref : {{bloccompromisctrl.compromis.affaire.referenceInterne}}</small></div><p class=\"col-xs-12 compromis-affaire-description\"><span class=affaire-desc>{{::bloccompromisctrl.compromis.affaire.getFormatedLibelle()}}</span></p></div></div></div>");
$templateCache.put("app/components/main-content/fiches/fiche-bien/fiche-bien.html","<div ng-if=!fichebienctrl.loading.loading class=fiche-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-4\"><button type=button class=\"btn-custom btn-danger\" ng-click=::fichebienctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xxs-4 col-xs-4\"><button type=button ng-if=fichebienctrl.hasChangeFiche ng-click=\"::fichebienctrl.changeFiche(\'previous\')\" class=\"btn-custom btn-custom-lighten-secondary pull-left\"><i class=\"fa fa-fw fa-chevron-left\"></i></button> <button type=button ng-if=fichebienctrl.hasChangeFiche ng-click=\"::fichebienctrl.changeFiche(\'next\')\" class=\"btn-custom btn-custom-lighten-secondary pull-right\"><i class=\"fa fa-fw fa-chevron-right\"></i></button></div><div class=\"controls col-xs-4 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.rapprochementProspect()><i class=\"fa fa-fw fa-search-plus\"></i> <u>R</u>approcher</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.ajouterFavoris()><i class=\"fa fa-fw\" ng-class=\"::{\r\n                     \'fa-shopping-cart\': fichebienctrl.panierProspect,\r\n                     \'fa-exclamation-triangle\': !fichebienctrl.panierProspect && fichebienctrl.coupCoeurAgence,\r\n                     \'fa-heart\': !fichebienctrl.panierProspect && !fichebienctrl.coupCoeurAgence\r\n                    }\"></i> <u>A</u>jouter <span ng-if=::fichebienctrl.panierProspect>au panier</span> <span ng-if=::(!fichebienctrl.panierProspect)>aux <span ng-if=::fichebienctrl.coupCoeurAgence>biens urgents</span> <span ng-if=::(!fichebienctrl.coupCoeurAgence)>favoris</span></span></button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.dupliquer()><i class=\"fa fa-fw fa-files-o\"></i> <u>C</u>r&eacute;er une copie</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichebienctrl.editer()><i class=\"fa fa-fw fa-pencil\"></i> <u>M</u>odifier</button></li></ul></div></div></div><hr class=fiche-hr></div><div class=\"fiche-bien col-xs-12\"><div class=fiche-display lazy-load><div class=col-xs-12><div class=\"fiche-titre row\"><span ng-if=::fichebienctrl.property.hasCategorie()>{{::fichebienctrl.property.categorie.label}} </span><span ng-if=::(!fichebienctrl.property.hasCategorie())>{{::fichebienctrl.property.type}} </span><span ng-if=::fichebienctrl.property.hasPiece()>{{::fichebienctrl.property.piece}} pi&egrave;ce{{::fichebienctrl.property.piece > 1 ? \'s\' : \'\'}} </span><span ng-if=::fichebienctrl.property.hasSurface()>de {{::fichebienctrl.property.surface}} <sup>m&sup2;</sup></span></div><div class=\"fiche-localisation row\" ng-if=\"::(fichebienctrl.property.hasAdresse() && (fichebienctrl.property.adresse.hasCp() || fichebienctrl.property.adresse.hasVille()))\"><p class=col-xs-12><i class=\"fa fa-fw fa-map-marker\"></i> {{::fichebienctrl.property.adresse.cp}} {{::fichebienctrl.property.adresse.ville}}</p></div><div class=row><div class=\"col-xs-12 flex-container-column\"><p class=fiche-prix ng-if=::fichebienctrl.property.hasPrix()>{{::fichebienctrl.property.libellePrix}} <span class=prix>{{::fichebienctrl.property.getPrix() | tgnFormat: \'number\'}} &euro; <sup ng-if=::fichebienctrl.property.hasMandatLocation()><small>TCC</small></sup></span><br ng-if=::fichebienctrl.property.hasMandatLocation()><small ng-if=::fichebienctrl.property.hasMandatLocation()>(Charges : {{::(fichebienctrl.property.mandatLocation.loyerTTC - fichebienctrl.property.mandatLocation.loyer) | tgnFormat: \'number\'}} &euro;)</small></p><p class=\"fiche-ref flex-item\">Ref : <span class=ref>{{::fichebienctrl.property.referenceInterne}}</span> <span ng-if=::fichebienctrl.property.getSociete()><br>Soci&eacute;t&eacute; : {{::fichebienctrl.property.getSociete().nom}}</span></p></div></div><div class=\"fiche-photos row\"><div uib-carousel active=::fichebienctrl.carousel.active template-url=template-custom-carousel.html><div uib-slide ng-repeat=\"slide in fichebienctrl.property.multimedia\" index=$index><img ng-src={{::fichebienctrl.imgSrc}}{{::fichebienctrl.property.id}}/{{::slide.fileName}} style=margin:auto><div ng-if=::slide.hasCommentaire() class=carousel-caption><p>{{::slide.commentaire}}</p></div></div><div uib-slide index=fichebienctrl.property.multimedia.length ng-if=::fichebienctrl.property.visiteVirtuelle><a target=_blank ng-href={{::fichebienctrl.property.visiteVirtuelle}}><img ng-src=assets/images/pictos/360-degrees.png style=margin:auto></a></div></div></div><div class=\"fiche-description row\"><p class=description ng-bind-html=\"::fichebienctrl.property.description | nl2br\"></p></div><div class=\"fiche-criteres row\" ng-if=::fichebienctrl.hasCriteres><h4 class=criteres-titre>D&eacute;tails</h4><hr class=fiche-titre-hr><ul class=list-unstyled><li ng-repeat=\"critere in ::fichebienctrl.criteres | orderBy: fichebienctrl.orderByArray\" class=\"col-xs-12 col-lg-6\" ng-if=::fichebienctrl.property[critere.nomChamp]><div ng-switch=::critere.type class=critere><div ng-switch-when=int class=flex-container-column><span class=critere-label>{{::critere.nom}} : </span><span class=critere-value>{{::fichebienctrl.property[critere.nomChamp] | tgnFormat: \'integer\'}}</span></div><div ng-switch-when=float class=flex-container-column><span class=critere-label>{{::critere.nom}} : </span><span class=critere-value>{{::fichebienctrl.property[critere.nomChamp] | tgnFormat: \'number\'}}</span></div><div ng-switch-when=boolean class=flex-container-column><span class=critere-label>{{::critere.nom}} : </span><span class=critere-value><i class=\"fa fa-fw fa-check\"></i></span></div><div ng-switch-when=date class=flex-container-column><span class=critere-label>{{::critere.nom}} : </span><span class=critere-value>{{::fichebienctrl.property[critere.nomChamp]}}</span></div><div ng-switch-when=combo class=flex-container-column ng-if=::fichebienctrl.property[critere.nomChamp].label><span class=critere-label>{{::critere.nom}} : </span><span class=critere-value>{{::fichebienctrl.property[critere.nomChamp].label}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-repeat=\"info in ::fichebienctrl.property.infoSupplementaires\" ng-if=\"::(info.commentaire && info.refInfoSupplementaire.afficher)\"><div class=critere><div class=flex-container-column><span class=critere-label>{{::info.refInfoSupplementaire.label}} :</span> <span class=critere-value>{{::info.commentaire}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=\"::(fichebienctrl.property.hasMandatTransaction() && fichebienctrl.property.mandatTransaction.honoChargeAquereur)\"><div class=critere><div class=flex-container-column><span class=critere-label>Hono. Acheteur :</span> <span class=critere-value>{{::fichebienctrl.property.mandatTransaction.honoChargeAquereur | tgnFormat: \'number\'}} &euro;</span></div></div></li></ul></div><div class=\"fiche-adresse row\" ng-if=::fichebienctrl.property.hasAdresse()><h4 class=adresse-titre>Localisation</h4><hr class=fiche-titre-hr><ul class=\"list-unstyled adresse\"><li ng-if=::fichebienctrl.property.adresse.hasImmeuble()><span class=adresse-immeuble>{{::fichebienctrl.property.adresse.immeuble}}</span></li><li ng-if=::fichebienctrl.property.adresse.hasRue()><span class=adresse-rue>{{::fichebienctrl.property.adresse.rue}}</span></li><li ng-if=\"::(fichebienctrl.property.adresse.hasCp() || fichebienctrl.property.adresse.hasVille())\"><span class=adresse-cp>{{::fichebienctrl.property.adresse.cp}} {{::fichebienctrl.property.adresse.ville}}</span></li><li ng-if=::fichebienctrl.property.adresse.hasPays()><span class=adresse-pays>{{::fichebienctrl.property.adresse.pays}}</span></li></ul></div><div class=\"fiche-criteres row\" ng-if=::fichebienctrl.property.hasMandatLocation()><h4 class=criteres-titre>Mandat</h4><hr class=fiche-titre-hr><ul class=list-unstyled><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatLocation.mrh><div class=critere><div class=flex-container-column><span class=critere-label>MRH :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.mrh | tgnFormat: \'number\'}} &euro;</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatLocation.depotGarantie><div class=critere><div class=flex-container-column><span class=critere-label>D&eacute;p&ocirc;t de garantie :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.depotGarantie | tgnFormat: \'number\'}} &euro;</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=fichebienctrl.honoraires><div class=critere><div class=flex-container-column><span class=critere-label>Honoraires :</span> <span class=critere-value>{{fichebienctrl.honoraires | tgnFormat: \'number\'}} &euro;</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=fichebienctrl.property.mandatLocation.vl><div class=critere><div class=flex-container-column><span class=critere-label>VL :</span> <span class=critere-value><i class=\"fa fa-fw fa-check\"></i></span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=fichebienctrl.property.mandatLocation.gl><div class=critere><div class=flex-container-column><span class=critere-label>GL :</span> <span class=critere-value><i class=\"fa fa-fw fa-check\"></i></span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=fichebienctrl.property.mandatLocation.refAssureurGli><div class=critere><div class=flex-container-column><span class=critere-label>Assureur GLI :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.refAssureurGli.label}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatLocation.noCle><div class=critere><div class=flex-container-column><span class=critere-label>Numero Cle :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.noCle}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=fichebienctrl.property.mandatLocation.fiscalite><div class=critere><div class=flex-container-column><span class=critere-label>Fiscalite :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.fiscalite}}</span></div></div></li></ul></div><div class=\"fiche-criteres row\" ng-if=::fichebienctrl.property.hasCommentaire()><h4 class=criteres-titre>Consigne de visite</h4><hr class=fiche-titre-hr><p class=fiche-commentaire ng-bind-html=\"::fichebienctrl.property[\'mandat\' + fichebienctrl.transac].commentaire | nl2br\"></p></div><div class=\"fiche-dpe-ges row\" ng-if=\"fichebienctrl.property.valeurDPE>0 || fichebienctrl.property.valeurGSE>0\"><h4 class=dpe-ges-titre>Diagnostics</h4><hr class=fiche-titre-hr><div class=row><div ng-if=\"fichebienctrl.property.valeurDPE>0\" class=\"dpe-ges col-xs-5 row\"><div class=\"dpe-ges-nom col-xs-6\" ng-class=\"\'dpe-\'+fichebienctrl.property.dpe.label\">{{::fichebienctrl.property.dpe.label}} :</div><div class=\"dpe-ges-valeur col-xs-6\">{{::fichebienctrl.property.valeurDPE}} kWh/m²</div></div><div ng-if=\"fichebienctrl.property.valeurGSE>0\" class=\"dpe-ges col-xs-5 row\"><div class=\"dpe-ges-nom col-xs-6\" ng-class=\"\'ges-\'+fichebienctrl.property.ges.label\">{{::fichebienctrl.property.ges.label}} :</div><div class=\"dpe-ges-valeur col-xs-6\">{{::fichebienctrl.property.valeurGSE}} kgCo²/m²</div></div></div></div><div class=\"fiche-criteres row\" ng-init=\"fichebienctrl.showLocataire = false\" ng-if=::fichebienctrl.property.hasLocataire()><h4 class=\"criteres-titre pointer\" ng-click=\"fichebienctrl.showLocataire = !fichebienctrl.showLocataire\"><i class=\"fa fa-fw fa-eye\"></i> Locataire</h4><hr class=fiche-titre-hr><ul class=list-unstyled ng-show=fichebienctrl.showLocataire><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatLocation.locataire.nom><div class=critere><div class=flex-container-column><span class=critere-label>Nom :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.locataire.nom}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatLocation.locataire.prenom><div class=critere><div class=flex-container-column><span class=critere-label>Prenom :</span> <span class=critere-value>{{::fichebienctrl.property.mandatLocation.locataire.prenom}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-repeat=\"contact in ::fichebienctrl.property.mandatLocation.locataire.contacts\"><div class=critere><div class=flex-container-column><span class=critere-label>{{::contact.type}} :</span> <span class=critere-value>{{::contact.value}}</span></div></div></li></ul></div><div class=\"fiche-criteres row\" ng-init=\"fichebienctrl.showProprietaire = false\" ng-if=::fichebienctrl.property.hasProprietaire()><h4 class=\"criteres-titre pointer\" ng-click=\"fichebienctrl.showProprietaire = !fichebienctrl.showProprietaire\"><i class=\"fa fa-fw fa-eye\"></i> Propri&eacute;taire</h4><hr class=fiche-titre-hr><ul class=list-unstyled ng-show=fichebienctrl.showProprietaire><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.proprietaire.nom><div class=critere><div class=flex-container-column><span class=critere-label>Nom :</span> <span class=critere-value>{{::fichebienctrl.property.proprietaire.nom}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.proprietaire.prenom><div class=critere><div class=flex-container-column><span class=critere-label>Prenom :</span> <span class=critere-value>{{::fichebienctrl.property.proprietaire.prenom}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.proprietaire.hasAdresses() ng-repeat=\"adresse in ::fichebienctrl.property.proprietaire.adresses\"><div class=critere><div class=flex-container-column><span class=critere-label>Adresse :</span> <span class=critere-value>{{::adresse.rue}}<br>{{::adresse.cp}}&nbsp;{{::adresse.ville}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-repeat=\"contact in ::fichebienctrl.property.proprietaire.contacts\"><div class=critere><div class=flex-container-column><span class=critere-label>{{::contact.type}} :</span> <span class=critere-value>{{::contact.value}}</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.proprietaire.representant><div class=critere><div class=flex-container-column><span class=critere-label>Repr&eacute;sentant :</span> <span class=critere-value>{{::fichebienctrl.property.proprietaire.representant}}</span></div></div></li></ul></div><div class=\"fiche-criteres row\" ng-init=\"fichebienctrl.showConfidentiel = false\" ng-if=\"::(fichebienctrl.commission || fichebienctrl.property.mandatTransaction.honoChargeVendeur || fichebienctrl.property[\'mandat\' + fichebienctrl.transac].commentaireConfidentiel)\"><h4 class=\"criteres-titre pointer\" ng-click=\"fichebienctrl.showConfidentiel = !fichebienctrl.showConfidentiel\"><i class=\"fa fa-fw fa-eye\"></i> Info. confidentielles</h4><hr class=fiche-titre-hr><div ng-show=fichebienctrl.showConfidentiel><ul class=list-unstyled><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.commission><div class=critere><div class=flex-container-column><span class=critere-label>Honoraires :</span> <span class=critere-value>{{::fichebienctrl.commission | tgnFormat: \'number\'}} &euro;</span></div></div></li><li class=\"col-xs-12 col-sm-6\" ng-if=::fichebienctrl.property.mandatTransaction.honoChargeVendeur><div class=critere><div class=flex-container-column><span class=critere-label>Hono. Vendeur :</span> <span class=critere-value>{{::fichebienctrl.property.mandatTransaction.honoChargeVendeur | tgnFormat: \'number\'}} &euro;</span></div></div></li><li class=col-xs-12 ng-if=\"::fichebienctrl.property[\'mandat\' + fichebienctrl.transac].commentaireConfidentiel\"><span class=commentaire-value>{{::fichebienctrl.property[\'mandat\' + fichebienctrl.transac].commentaireConfidentiel}}</span></li><!-- <li class=\"col-xs-12 col-sm-6\" ng-repeat=\"info in ::fichebienctrl.property.infoSupplementaires\" ng-if=\"::(info.commentaire && info.refInfoSupplementaire.afficher)\">\r\n                <div class=\"critere\">\r\n                  <div class=\"flex-container-column\">\r\n                    <span class=\"critere-label\">{{::info.refInfoSupplementaire.label}} :</span>\r\n                    <span class=\"critere-value\">{{::info.commentaire}}</span>\r\n                  </div>\r\n                </div>\r\n              </li> --></ul></div></div><div class=\"fiche-parutions row\" ng-if=\"(fichebienctrl.parutions.length && !fichebienctrl.citya)\"><h4 class=parutions-titre>Parutions</h4><hr class=fiche-titre-hr><ul class=list-unstyled><li ng-repeat=\"parution in fichebienctrl.parutions\" class=\"parution col-xs-6 col-md-4 col-lg-3\"><div ng-if=parution.hasImg class=parution-img><img ng-src={{parution.imgSrc}} alt={{::parution.prestataire.nom}} class=img-responsive></div><span ng-if=(!parution.hasImg) class=parution-nom>{{::parution.prestataire.nom}}</span></li></ul></div></div></div></div></div><div ng-show=fichebienctrl.loading.loading class=loader></div><script type=text/ng-template id=template-custom-carousel.html><div class=\"fiche-carousel\">\r\n    <div class=\"carousel-inner\" ng-transclude></div>\r\n    <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"::{\'disabled\': isPrevDisabled()}\" ng-if=\"::slides.length > 1\">\r\n      <i aria-hidden=\"true\" class=\"fa fa-fw fa-chevron-left glyphicon glyphicon-chevron-left\"></i>\r\n      <span class=\"sr-only\">Pr&eacute;c&eacute;dent</span>\r\n    </a>\r\n    <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"::{\'disabled\': isNextDisabled()}\" ng-if=\"::slides.length > 1\">\r\n      <i aria-hidden=\"true\" class=\"fa fa-fw fa-chevron-right glyphicon glyphicon-chevron-right\"></i>\r\n      <span class=\"sr-only\">Suivant</span>\r\n    </a>\r\n    <ol class=\"carousel-indicators\" ng-if=\"::slides.length > 1\">\r\n      <li sly-repeat=\"slide in slides | orderBy:indexOfSlide\" ng-class=\"{\'active\': isActive(slide)}\" ng-click=\"::select(slide)\"></li>\r\n    </ol>\r\n    <button type=\"button\" ng-repeat=\"slide in slides | orderBy:indexOfSlide\" ng-if=\"isActive(slide)\" class=\"btn-fullscreen\" ng-click=\"$parent.$parent.$parent.$parent.fichebienctrl.fullscreenMode($index)\">\r\n      <i class=\"fa fa-fw fa-2r fa-window-maximize\" tooltip-placement=\"auto top\" uib-tooltip=\"Voir en taille réelle\"></i>\r\n    </button>\r\n  </div></script>");
$templateCache.put("app/components/main-content/fiches/fiche-compromis/fiche-compromis.html","<div ng-if=!fichecompromisctrl.loading class=fiche-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-4\"><button type=button class=\"btn-custom btn-danger\" ng-click=::fichecompromisctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-4\"><button type=button class=\"btn-custom btn-custom-lighten-secondary pull-left\" ng-if=fichecompromisctrl.hasChangeFiche ng-click=\"::fichecompromisctrl.changeFiche(\'previous\')\"><i class=\"fa fa-fw fa-chevron-left\"></i></button> <button type=button class=\"btn-custom btn-custom-lighten-secondary pull-right\" ng-if=fichecompromisctrl.hasChangeFiche ng-click=\"::fichecompromisctrl.changeFiche(\'next\')\"><i class=\"fa fa-fw fa-chevron-right\"></i></button></div><div class=\"controls col-xs-4 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=fichecompromisctrl.editer()><i class=\"fa fa-fw fa-pencil\"></i> <u>M</u>odifier</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichecompromisctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=::fichecompromisctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <u>S</u>upprimer</button></li></ul></div></div></div><hr class=fiche-hr></div><div class=fiche-compromis><div class=\"fiche-display col-xs-12\" lazy-load><div class=col-xs-12><div class=row><div class=\"fiche-titre col-xs-12\"><div class=\"compromis-titre flex-container-column\"><h3 class=\"titre-num flex-item\">{{fichecompromisctrl.titre}} N&deg;{{::fichecompromisctrl.compromis.id}}</h3><span class=titre-date>{{::fichecompromisctrl.compromis.date}}</span> <span class=\"titre-label label hidden-xs\" ng-if=::fichecompromisctrl.titleLabel.active ng-class=::fichecompromisctrl.titleLabel.classe>{{::fichecompromisctrl.titleLabel.text}}{{::fichecompromisctrl.titleLabel.date}}</span></div><span class=\"titre-label label visible-xs\" ng-if=::fichecompromisctrl.titleLabel.active ng-class=::fichecompromisctrl.titleLabel.classe>{{::fichecompromisctrl.titleLabel.text}}{{::fichecompromisctrl.titleLabel.date}}</span></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichecompromisctrl.compromis.affaire.proprietaire titre-bloc=\"\'VENDEUR\'\"></bloc-perso><div class=nego-vendeur>N&eacute;go : {{fichecompromisctrl.compromis.affaire.mandatTransaction.nego.perso ? fichecompromisctrl.compromis.affaire.mandatTransaction.nego.perso.nomComplet : fichecompromisctrl.compromis.affaire.mandatTransaction.nego.initiales}}</div></div><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichecompromisctrl.compromis.acheteur.perso titre-bloc=\"\'ACHETEUR\'\" template-right=true></bloc-perso><div class=nego-acheteur>N&eacute;go : {{fichecompromisctrl.compromis.acheteur.nego.perso ? fichecompromisctrl.compromis.acheteur.nego.perso.nomComplet : fichecompromisctrl.compromis.acheteur.nego.initiales}}</div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichecompromisctrl.compromis.notaireVendeur titre-bloc=\"\'NOTAIRE (Vendeur)\'\"></bloc-perso></div><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichecompromisctrl.compromis.notaireAcheteur titre-bloc=\"\'NOTAIRE (Acheteur)\'\" template-right=true></bloc-perso></div></div><div class=\"compromis-affaire row\"><div class=\"affaire-title col-xs-12\"><h4>Affaire :</h4></div><div class=\"affaire-desc col-xs-12 text-center spacer-bottom\">{{::fichecompromisctrl.compromis.affaire.getFormatedLibelle()}}</div><div class=\"affaire-prix col-xs-12 spacer-top\"><dl><dt>{{::fichecompromisctrl.compromis.getPrixNetVendeur() | tgnFormat: \'number\'}} &euro;</dt><dd><em>Prix (net vendeur)</em></dd></dl><dl><dt>{{::fichecompromisctrl.compromis.getCommission() | tgnFormat: \'number\'}} &euro;</dt><dd><em>Commission</em></dd></dl><dl><dt>{{::fichecompromisctrl.compromis.tva}}%</dt><dd><em>TVA</em></dd></dl><dl><dt>{{::fichecompromisctrl.compromis.getCommissionHT() | tgnFormat: \'number\'}} &euro;</dt><dd><em>Commission HT</em></dd></dl></div></div></div></div></div></div><div ng-show=fichecompromisctrl.loading class=loader></div>");
$templateCache.put("app/components/main-content/fiches/fiche-prospect/fiche-prospect.html","<div ng-if=!ficheprospectctrl.loading class=fiche-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-4\"><button type=button class=\"btn-custom btn-danger\" ng-click=::ficheprospectctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-4\"><button type=button ng-if=ficheprospectctrl.hasChangeFiche class=\"btn-custom btn-custom-lighten-secondary pull-left\" ng-click=\"::ficheprospectctrl.changeFiche(\'previous\')\"><i class=\"fa fa-fw fa-chevron-left\"></i></button> <button type=button ng-if=ficheprospectctrl.hasChangeFiche class=\"btn-custom btn-custom-lighten-secondary pull-right\" ng-click=\"::ficheprospectctrl.changeFiche(\'next\')\"><i class=\"fa fa-fw fa-chevron-right\"></i></button></div><div class=\"controls col-xs-4 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::ficheprospectctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::ficheprospectctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=ficheprospectctrl.editer()><i class=\"fa fa-fw fa-pencil\"></i> <u>M</u>odifier</button></li></ul></div></div></div><hr class=fiche-hr></div><div class=\"fiche-prospect col-xs-12\"><div class=fiche-display lazy-load><div class=col-xs-12><div class=\"fiche-titre row\"><div class=\"col-xs-12 flex-container-column\"><span class=titre>{{::ficheprospectctrl.prospect.perso.getNomComplet()}}</span> <span class=\"fiche-qualification flex-item text-right\" ng-if=::ficheprospectctrl.prospect.hasQualification()><span class=qualification-value>{{::ficheprospectctrl.prospect.getQualification().type}}</span></span></div></div><div class=\"origine row\" ng-if=::ficheprospectctrl.prospect.hasOrigine()><span class=origine-label>Origine : </span><span class=origine-value>{{::ficheprospectctrl.prospect.getOrigine().type}}</span></div><div class=\"fiche-adresses row\" ng-if=::ficheprospectctrl.prospect.perso.hasAdresses()><h4 class=adresses-titre>Adresse <span ng-if=\"::ficheprospectctrl.prospect.perso.adresses.length > 1\">s</span></h4><hr class=fiche-titre-hr><ul class=\"list-unstyled col-xs-12\"><li sly-repeat=\"adresse in ficheprospectctrl.prospect.perso.adresses\" class=\"col-xs-12 col-sm-6\"><div class=\"adresse row\"><span class=\"adresse-rue col-xs-12\" ng-if=::adresse.hasRue()>{{::adresse.rue}}</span> <span class=\"adresse-cp col-xs-12\" ng-if=\"::(adresse.hasCp() && adresse.hasVille())\">{{::adresse.cp}} {{::adresse.ville}}</span> <span class=\"adresse-pays col-xs-12\" ng-if=::adresse.hasPays()>{{::adresse.pays}}</span></div></li></ul></div><div class=\"fiche-contacts row\" ng-if=::ficheprospectctrl.prospect.perso.hasContacts()><h4 class=contacts-titre>Contact <span ng-if=\"::ficheprospectctrl.prospect.perso.contacts.length > 1\">s</span></h4><hr class=fiche-titre-hr><ul class=\"list-unstyled col-xs-12\"><li sly-repeat=\"contact in ficheprospectctrl.prospect.perso.contacts\" class=\"col-xs-12 col-sm-6\" ng-if=::contact.value><div class=contact><div class=flex-container-column><span class=contact-label ng-switch=::contact.type><i ng-switch-when=Email class=\"fa fa-fw fa-envelope\"></i> <i ng-switch-when=Telephone class=\"fa fa-fw fa-phone\"></i> <i ng-switch-when=TelMobile class=\"fa fa-fw fa-mobile\"></i> </span><span class=contact-value>{{::contact.value}}</span></div></div></li></ul></div><div class=\"fiche-description row\" ng-if=::ficheprospectctrl.prospect.hasCommentaire()><h4 class=description-titre>Commentaire</h4><hr class=fiche-titre-hr><p class=description ng-bind-html=\"::ficheprospectctrl.prospect.commentaire | nl2br\"></p></div><div class=\"fiche-recherche row\" ng-if=\"::(ficheprospectctrl.prospect.hasTypesBien() || ficheprospectctrl.prospect.hasPrixMin() || ficheprospectctrl.prospect.hasPrixMax())\"><h4 class=recherche-titre>Recherche</h4><hr class=fiche-titre-hr><div class=\"recherche-type col-xs-12\" ng-if=::ficheprospectctrl.prospect.hasTypesBien()><span class=type-title>Type <span ng-if=\"::ficheprospectctrl.prospect.typesBien.length > 1\">s</span> de bien :</span><ul class=list-unstyled><li sly-repeat=\"type in ::ficheprospectctrl.prospect.typesBien\" class=\"col-xs-12 col-sm-6\"><div class=type>{{::type.label}}</div></li></ul></div><div class=\"recherche-prix col-xs-12\"><div class=\"prix col-xs-6\" ng-if=::ficheprospectctrl.prospect.hasPrixMin()><span class=prix-label>Prix min :</span> <span class=prix-value>{{::ficheprospectctrl.prospect.prixMin | tgnFormat: \'integer\'}} &euro;</span></div><div class=\"prix col-xs-6\" ng-if=::ficheprospectctrl.prospect.hasPrixMax()><span class=prix-label>Prix max :</span> <span class=prix-value>{{::ficheprospectctrl.prospect.prixMax | tgnFormat: \'integer\'}} &euro;</span></div></div><div class=\"recherche-localisation col-xs-12\" ng-if=::ficheprospectctrl.prospect.hasVilles()><span class=localisation-title>Localisation :</span><ul class=list-unstyled><li sly-repeat=\"ville in ::ficheprospectctrl.prospect.villes\" class=\"col-xs-12 col-sm-6\"><div class=localisation><span class=cp>{{::ville.codePostal}}</span> <span class=ville>{{::ville.nom}}</span></div></li></ul></div></div><div class=\"fiche-criteres row\" ng-if=::ficheprospectctrl.prospect.hasCriteres()><h4 class=criteres-titre>Crit&egrave;res</h4><hr class=fiche-titre-hr><ul class=\"list-unstyled col-xs-12\"><li ng-repeat=\"critere in ::ficheprospectctrl.prospect.criteres\" class=\"col-xs-12 col-sm-6\" ng-if=\"::(critere.valStr !== null && critere.valStr !== \'\')\"><div class=critere><div class=flex-container-column><span class=critere-label>{{::critere.critere.nom}} : </span><span class=critere-value>{{::critere.valStr}}</span></div></div></li></ul></div><div class=\"fiche-rapprochement row\"><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-block btn-rapprocher\" ng-click=ficheprospectctrl.rapprocher()><i class=\"fa fa-fw fa-search\"></i> Chercher des biens</button></div></div></div></div></div></div><div ng-show=ficheprospectctrl.loading class=loader></div>");
$templateCache.put("app/components/main-content/fiches/fiche-reservation/fiche-reservation.html","<div ng-if=!fichereservationctrl.loading class=fiche-main-container><div class=custom-controls-nav-container><div class=custom-controls-nav><div class=\"controls control-exit col-xs-4\"><button type=button class=\"btn-custom btn-danger\" ng-click=::fichereservationctrl.onClickBack()><i class=\"fa fa-fw fa-times\"></i></button></div><div class=\"controls col-xs-4\"><button type=button class=\"btn-custom btn-custom-lighten-secondary pull-left\" ng-if=fichereservationctrl.hasChangeFiche ng-click=\"::fichereservationctrl.changeFiche(\'previous\')\"><i class=\"fa fa-fw fa-chevron-left\"></i></button> <button type=button class=\"btn-custom btn-custom-lighten-secondary pull-right\" ng-if=fichereservationctrl.hasChangeFiche ng-click=\"::fichereservationctrl.changeFiche(\'next\')\"><i class=\"fa fa-fw fa-chevron-right\"></i></button></div><div class=\"controls col-xs-4 text-right\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=fichereservationctrl.editer()><i class=\"fa fa-fw fa-pencil\"></i> <u>M</u>odifier</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::fichereservationctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=::fichereservationctrl.supprimer()><i class=\"fa fa-fw fa-trash\"></i> <u>S</u>upprimer</button></li></ul></div></div></div><hr class=fiche-hr></div><div class=fiche-reservation><div class=fiche-display lazy-load><div class=col-xs-12><div class=row><div class=\"fiche-titre col-xs-12\"><div class=\"reservation-titre flex-container-column\"><h3 class=\"titre-num flex-item\">{{fichereservationctrl.titre}} N&deg;{{::fichereservationctrl.reservation.id}}</h3><span class=titre-date>{{::fichereservationctrl.reservation.date}}</span> <span class=\"titre-label label hidden-xs\" ng-if=::fichereservationctrl.titleLabel.active ng-class=::fichereservationctrl.titleLabel.classe>{{::fichereservationctrl.titleLabel.text}}{{::fichereservationctrl.titleLabel.date}}</span></div><span class=\"titre-label label visible-xs\" ng-if=::fichereservationctrl.titleLabel.active ng-class=::fichereservationctrl.titleLabel.classe>{{::fichereservationctrl.titleLabel.text}}{{::fichereservationctrl.titleLabel.date}}</span></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichereservationctrl.reservation.affaire.proprietaire titre-bloc=\"\'PROPRIETAIRE\'\"></bloc-perso><div class=nego-proprietaire>N&eacute;go : {{fichereservationctrl.reservation.affaire.mandatLocation.nego.perso ? fichereservationctrl.reservation.affaire.mandatLocation.nego.perso.nomComplet : fichereservationctrl.reservation.affaire.mandatLocation.nego.initiales}}</div></div><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichereservationctrl.reservation.locataire.perso titre-bloc=\"\'LOCATAIRE\'\" template-right=true></bloc-perso><div class=nego-locataire>N&eacute;go : {{fichereservationctrl.reservation.locataire.nego.perso ? fichereservationctrl.reservation.locataire.nego.perso.nomComplet : fichereservationctrl.reservation.locataire.nego.initiales}}</div></div></div><div class=row ng-if=fichereservationctrl.reservation.hasColocataire()><div class=\"col-xs-12 col-md-6\"><bloc-perso perso=fichereservationctrl.reservation.colocataire titre-bloc=\"\'COLOCATAIRE\'\"></bloc-perso></div></div><div class=row><div class=col-xs-12><div class=\"bloc-affaire col-xs-12\"><div class=affaire-titre><div class=\"affaire-titre-label col-xs-12 text-center\">AFFAIRE</div></div><div class=\"affaire-content col-xs-12 text-center\">{{::fichereservationctrl.reservation.affaire.getFormatedLibelle()}}</div></div></div></div><div class=\"reservation-details row\"><div class=\"affaire-prix col-xs-12 spacer-top\"><dl><dt>{{::fichereservationctrl.reservation.loyer | tgnFormat: \'number\'}} &euro;</dt><dd><em>Loyer</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.getHonoraires() | tgnFormat: \'number\'}} &euro;</dt><dd><em>Honoraires</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.honoVDB | tgnFormat: \'number\'}} &euro;</dt><dd><em>Honoraires VDB</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.honoEDL | tgnFormat: \'number\'}} &euro;</dt><dd><em>Honoraires EDL</em></dd></dl><hr class=separator><dl><dt>{{::fichereservationctrl.reservation.honoProprietaire | tgnFormat: \'number\'}} &euro;</dt><dd><em>Honoraires Propri&eacute;taire</em></dd></dl><div class=intended-list><dl><dt>{{::fichereservationctrl.reservation.honoPRVDB | tgnFormat: \'number\'}} &euro;</dt><dd><em>VDB</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.honoPREDL | tgnFormat: \'number\'}} &euro;</dt><dd><em>EDL</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.honoEntremise | tgnFormat: \'number\'}} &euro;</dt><dd><em>Entremise</em></dd></dl></div><hr class=separator><dl><dt>{{::fichereservationctrl.reservation.honoLocataire | tgnFormat: \'number\'}} &euro;</dt><dd><em>Honoraires Locataire</em></dd></dl><div class=intended-list><dl><dt>{{::fichereservationctrl.reservation.honoLRVDB | tgnFormat: \'number\'}} &euro;</dt><dd><em>VDB</em></dd></dl><dl><dt>{{::fichereservationctrl.reservation.honoLREDL | tgnFormat: \'number\'}} &euro;</dt><dd><em>EDL</em></dd></dl></div></div></div></div></div></div></div><div ng-show=fichereservationctrl.loading class=loader></div>");
$templateCache.put("app/components/main-content/liste-bien/bloc-bien/bloc-bien.html","<div class=\"bloc-bien col-xs-12\" ng-if=!blocbienctrl.loading ng-class=\"::(blocbienctrl.template + \'-template\')\"><div class=row><div class=archive ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].archive\">Archiv&eacute;</div><div class=en-compromis ng-if=\"::(!blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].archive && blocbienctrl.compromis.active)\" ng-class=\"::{\'en-attente\': blocbienctrl.compromis.enAttente}\" ng-click=::blocbienctrl.compromis.onClick()>{{::blocbienctrl.bien.enCompromis}}</div><div class=import-presta ng-if=\"::(!blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].archive && blocbienctrl.presta)\">{{::blocbienctrl.bien.importPresta}}</div><div class=blocbien-event-display-list ng-class=::blocbienctrl.transac ng-if=\"::(blocbienctrl.eventProspect.active && blocbienctrl.eventProspect.template === \'list\')\">{{::blocbienctrl.eventProspect.event.type.label}} - {{::blocbienctrl.eventProspect.event.date}}</div><div class=\"blocbien-img no-padding\" ng-class=::blocbienctrl.classes.img><div class=\"blocbien-img-value col-xs-12\" ng-style=blocbienctrl.styles.img ng-if=\"::blocbienctrl.template !== \'listNoPhotos\'\"></div><loader class=loader-sm ng-if=blocbienctrl.imgLoading></loader><span class=blocbien-prix ng-if=::blocbienctrl.bien.hasPrix()>{{::blocbienctrl.bien.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=\"::(blocbienctrl.transac === \'Location\')\"><small>TCC</small></sup></span><div ng-if=::blocbienctrl.selection.active class=blocbien-selection ng-click=::blocbienctrl.selection.onToggle()><span class=checkbox-square ng-class=\"{\'checked\': blocbienctrl.selection.selected}\"><i class=\"fa fa-2x fa-check\" ng-if=blocbienctrl.selection.selected></i></span></div><div class=\"map-window-close-btn btn-custom-primary\" ng-if=::blocbienctrl.fermer ng-click=::blocbienctrl.onFermer()><i class=\"fa fa-fw fa-2r fa-times\"></i></div><div class=blocbien-infos-img><div class=blocbien-vl ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].vl\" ng-class=::blocbienctrl.classes.infosImg>VL</div><div class=blocbien-gl ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].gl\" ng-class=::blocbienctrl.classes.infosImg>GL</div><div class=blocbien-no-mandat ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].noMandat\" ng-class=::blocbienctrl.classes.infosImg>{{::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].noMandat}}</div><div class=blocbien-type-mandat ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].type.data\" ng-class=::blocbienctrl.classes.infosImg>{{::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].type.data}}</div></div></div><div class=\"blocbien-infos no-padding\" ng-class=::blocbienctrl.classes.infos><a class=\"btn-hr btn-voir center-block\" ng-click=::blocbienctrl.toggleFiche() tooltip-placement=\"auto top\" uib-tooltip=\"Voir la fiche\"><i class=\"fa fa-fw fa-eye\"></i></a><div class=blocbien-event-display-grid ng-class=::blocbienctrl.transac ng-if=\"::(blocbienctrl.eventProspect.active && blocbienctrl.eventProspect.template === \'grid\')\"><span class=blocbien-event-type>{{::blocbienctrl.eventProspect.event.type.label}}</span> <span class=blocbien-event-date>{{::blocbienctrl.eventProspect.event.date}}</span></div><div class=\"blocbien-titre col-xs-12 flex-container-column\"><span class=\"blocbien-titre-valeur flex-item\">{{::blocbienctrl.bien.getTitle()}}</span><div class=blocbien-supprimer ng-if=::blocbienctrl.supprimer.active><button class=btn-supprimer ng-click=::blocbienctrl.supprimer.onClick()><i class=\"fa fa-fw fa-2r fa-times\"></i></button></div></div><div class=\"blocbien-description col-xs-12 hidden-xs\" ng-class=::blocbienctrl.classes.description><p class=blocbien-description-valeur ng-bind-html=::blocbienctrl.bien.description></p></div><div class=\"blocbien-adresse flex-container-column col-xs-12\" ng-class=::blocbienctrl.transac><div class=\"blocbien-adresse-icon flex-container-justify-center\"><i class=\"fa fa-fw fa-map-marker\" ng-if=::blocbienctrl.bien.hasAdresse()></i></div><div class=\"blocbien-adresse-valeur flex-item flex-container-justify-center\" ng-if=::blocbienctrl.bien.hasAdresse() ng-class=::blocbienctrl.transac><div class=\"blocbien-adresse-valeur-container col-xs-12 no-padding\" ng-if=\"::(blocbienctrl.transac === \'Location\' && blocbienctrl.bien.adresse.hasRue())\"><span class=blocbien-adresse-rue>{{::blocbienctrl.bien.adresse.rue}}</span></div><div class=\"blocbien-adresse-valeur-container col-xs-12 no-padding\"><span class=blocbien-adresse-cp>{{::blocbienctrl.bien.adresse.cp}}</span>&nbsp; <span class=blocbien-adresse-ville>{{::blocbienctrl.bien.adresse.ville}}</span></div></div><div class=\"blocbien-no-adresse flex-item\" ng-if=::(!blocbienctrl.bien.hasAdresse())><i>Adresse non renseign&eacute;e</i></div></div><div class=blocbien-proprietaire ng-if=\"::(blocbienctrl.bien.proprietaire || blocbienctrl.nbJoursMandat)\" ng-click=::blocbienctrl.proprietaire.toggle() ng-class=\"::{\'confidentiel\': blocbienctrl.proprietaire.confidentiel, \'col-xs-12\': !blocbienctrl.proprietaire.confidentiel}\"><div ng-if=blocbienctrl.proprietaire.confidentiel class=proprietaire-trigger tooltip-placement=\"auto top\" uib-tooltip=\"Infos proprietaire\"><i class=\"fa fa-2r fa-info\"></i></div><div class=proprietaire-value ng-if=\"blocbienctrl.proprietaire.isOpen || !blocbienctrl.proprietaire.confidentiel\"><span class=proprietaire-proprio ng-if=::blocbienctrl.bien.proprietaire><i class=\"fa fa-fw fa-user\" ng-if=::(!blocbienctrl.proprietaire.confidentiel)></i> {{::blocbienctrl.bien.proprietaire.getNomComplet()}}<br></span><span class=proprietaire-mandat ng-if=\"::(blocbienctrl.nbJoursMandat && blocbienctrl.proprietaire.confidentiel)\">{{::(blocbienctrl.transac === \'Transaction\' ? \'En vente\' : \'À louer\')}} depuis {{::blocbienctrl.nbJoursMandat}} jour{{::(blocbienctrl.nbJoursMandat > 1 ? \'s\' : \'\')}}</span></div></div></div><div class=\"blocbien-infos-supp col-xs-12 no-padding\"><div class=\"col-xs-12 no-padding\"><ul class=\"list-unstyled flex-container-column-justify-around\"><li class=blocbien-qualification ng-if=::blocbienctrl.qualification ng-bind-html=::blocbienctrl.qualification></li><li class=blocbien-libre ng-if=::blocbienctrl.libreLe>Libre le {{::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].libreLe}}</li><li class=blocbien-vl ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].vl\" ng-class=::blocbienctrl.classes.infosSupp>VL</li><li class=blocbien-gl ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].gl\" ng-class=::blocbienctrl.classes.infosSupp>GL</li><li class=blocbien-no-mandat ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].noMandat\" ng-class=::blocbienctrl.classes.infosSupp>{{::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].noMandat}}</li><li class=blocbien-type-mandat ng-if=\"::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].type.data\" ng-class=::blocbienctrl.classes.infosSupp>{{::blocbienctrl.bien[\'mandat\' + blocbienctrl.transac].type.data}}</li></ul></div></div><div class=\"blocbien-actions col-xs-12 no-padding-right\"><ul class=\"list-unstyled list-inline flex-container-column\"><li class=\"blocbien-action action-ref flex-item\"><small class=blocbien-ref>Ref : <span class=blocbien-ref-valeur title={{::blocbienctrl.bien.referenceInterne}}>{{::blocbienctrl.bien.referenceInterne}}</span></small></li><li class=\"blocbien-action flex-item-auto\" ng-repeat=\"action in blocbienctrl.actions.actives\" ng-class=\"::(\'action-\' + action.nom)\"><a class=btn-action ng-class=\"::(\'btn-\' + action.nom)\" ng-click=::action.onClick() tooltip-placement=\"auto top\" uib-tooltip={{::action.tooltip}}><i class=\"fa fa-fw fa-2r\" ng-class=::action.icon></i> <span class=action-event-date ng-if=::action.event>&nbsp;{{::action.event.date}}</span></a></li></ul></div></div></div><div class=\"col-xs-12 no-padding\"><small class=blocbien-nego>N&eacute;go : <span class=blocbien-nego-valeur>{{::blocbienctrl.nego}}</span></small></div>");
$templateCache.put("app/components/main-content/liste-prospects/bloc-prospect/bloc-prospect.html","<div class=bloc-prospect-container><div class=archive ng-if=blocprospectctrl.prospect.archive>Archiv&eacute;</div><div class=prospect><div class=\"prospect-title col-xs-12\"><span class=title>{{::blocprospectctrl.prospect.perso.getNomComplet()}}</span></div><div class=\"col-xs-12 prospect-contacts\"><div ng-if=blocprospectctrl.selection.active class=prospect-selection ng-click=::blocprospectctrl.selection.toggle()><span class=checkbox-square ng-class=\"{\'checked\': blocprospectctrl.prospect.selected}\"><i class=\"fa fa-2x fa-check\" ng-if=blocprospectctrl.prospect.selected></i></span></div><ul class=\"prospect-contacts-list list-unstyled\"><li ng-if=::blocprospectctrl.prospect.perso.getEmail()><span class=contact-label><i class=\"fa fa-fw fa-envelope\"></i> </span><span class=contact-value>{{::blocprospectctrl.prospect.perso.getEmail()}}</span></li><li ng-if=\"::(blocprospectctrl.prospect.perso.getTelMobile() || blocprospectctrl.prospect.perso.getTel())\"><span class=contact-label><i class=\"fa fa-fw fa-phone\"></i> </span><span class=contact-value>{{::(blocprospectctrl.prospect.perso.getTelMobile() ? blocprospectctrl.prospect.perso.getTelMobile() : blocprospectctrl.prospect.perso.getTel())}}</span></li></ul></div><div class=\"prospect-criteres col-xs-12\" ng-class=\"{\'with-selection\': blocprospectctrl.selection.active}\" ng-if=::blocprospectctrl.prospect.hasComRepertoire()><span class=criteres>{{::blocprospectctrl.prospect.comRepertoire}}</span></div><div class=btn-voir-container><button class=\"btn-custom btn-custom-primary btn-voir\" ng-click=::blocprospectctrl.showFiche() tooltip-placement=\"auto top\" uib-tooltip=\"Voir la fiche\"><i class=\"fa fa-fw fa-eye\"></i></button></div></div><div class=\"col-xs-12 no-padding\"><small class=prospect-nego>N&eacute;go : <span class=prospect-nego-valeur>{{::blocprospectctrl.nego}}</span></small></div></div>");
$templateCache.put("app/components/main-content/modif-bien/diffusion/diffusion.html","<div class=col-xs-12><div class=form-group ng-if=\"!diffusionctrl.citya || (diffusionctrl.citya && diffusionctrl.transac === \'Transaction\')\"><label for=accroche class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Accroche</label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><input type=text class=form-control id=accroche name=accroche ng-model=diffusionctrl.lot.accroche maxlength=255></div></div><div class=form-group><label for=description class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Description</label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><textarea class=form-control id=description name=description ng-model=diffusionctrl.lot.description rows=5 ng-required=\"!diffusionctrl.paramsGestion || (diffusionctrl.paramsGestion && !diffusionctrl.paramsGestion.descriptif)\" ng-disabled=\"diffusionctrl.paramsGestion && diffusionctrl.paramsGestion.descriptif\" ng-pattern=diffusionctrl.commentairePattern></textarea></div></div><div class=form-group><label for=pub class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Publicit&eacute;&nbsp; <i class=\"fa fa-files-o\" ng-click=\"diffusionctrl.lot.pub=diffusionctrl.lot.description\" aria-hidden=true></i></label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><textarea class=form-control id=pub name=pub ng-model=diffusionctrl.lot.pub rows=5></textarea></div></div><!--<div class=\"form-group\">\r\n      <label for=\"siteAgence\" class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Site Agence</label>\r\n      <div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\">\r\n          <textarea class=\"form-control\" id=\"siteAgence\" name=\"siteAgence\"\r\n                    ng-model=\"diffusionctrl.lot.pubSitePerso\" rows=\"5\"></textarea>\r\n      </div>\r\n  </div>--><div class=form-group><label for=vitrine class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Vitrine&nbsp; <i class=\"fa fa-files-o\" ng-click=\"diffusionctrl.lot.pubVitrine=diffusionctrl.lot.description.slice(0,270)\" aria-hidden=true></i></label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><textarea ng-init=\"diffusionctrl.nbreste = 270 - diffusionctrl.lot.pubVitrine.lenght\" id=vitrine name=vitrine limit-text nb-reste=diffusionctrl.nbreste limit-char=270 class=form-control rows=5 ng-model=diffusionctrl.lot.pubVitrine></textarea><div><i>Il reste {{diffusionctrl.nbreste}} caract&egrave;res</i></div></div></div><div class=form-group><label for=visiteVirtuelle class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Visite Virtuelle</label><div class=\"col-xs-12 col-sm-8 col-md-8\"><input type=text id=visiteVirtuelle class=form-control ng-model=diffusionctrl.lot.visiteVirtuelle placeholder=URL></div></div><div class=form-group><label for=coupcoeur class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left spacer-bottom\">Coup de c&oelig;ur site web</label><div class=\"col-xs-12 col-sm-8 col-md-8\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.coupcoeur></div></div><parution lot=diffusionctrl.lot is-loading=diffusionctrl.isLoading></parution><lot-panneaux lot=diffusionctrl.lot is-loading=diffusionctrl.isLoading></lot-panneaux></div>");
$templateCache.put("app/components/main-content/modif-bien/extranet/extranet.html","<div class=\"form-horizontal col-xs-12\"><div class=extranet><div class=row><div class=\"col-xs-12 text-center spacer-bottom\"><h4>Extranet proprietaire</h4></div></div><div class=row ng-if=extranetctrl.nego.profileTransaction.adminProfile><label for=login class=\"col-xs-12 col-sm-6 control-label no-padding-left\">Login :</label><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-2 col-xl-1 spacer-bottom\"><input type=text ng-model=extranetctrl.lot.proprietaire.login name=login id=login class=form-control></div></div><div class=row ng-if=extranetctrl.nego.profileTransaction.adminProfile><label for=mdp class=\"col-xs-12 col-sm-6 control-label no-padding-left\">Mot de passe :</label><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-2 col-xl-1 spacer-bottom\"><input type=text ng-model=extranetctrl.lot.proprietaire.mdp name=mdp id=mdp class=form-control></div></div><!-- <div class=\"row\" ng-if=\"extranetctrl.nego.profileTransaction.adminProfile\">\r\n      <div class=\"col-xs-12\">\r\n        <center>\r\n          <a class=\"liens-primary\" href=\"{{extranetctrl.urlSite}}\" target=\"_blank\">Allez sur l\'extranet du propri&eacute;taire</a>\r\n        </center>\r\n      </div>\r\n    </div> --><div class=row><div class=\"col-xs-12 text-center spacer-bottom\"><!-- <button type=\"button\" class=\"btn btn-success btn-s\" ng-click=\"extranetctrl.sendMail()\">\r\n          <span class=\"fa fa-envelope-o\"></span> Envoyer Mail\r\n        </button> --> <button type=button class=\"btn btn-success btn-s\" ng-click=extranetctrl.sendMail(true)><span class=\"fa fa-envelope-o\"></span> Envoyer le login</button> <button type=button class=\"btn btn-success btn-s\" ng-click=\"extranetctrl.sendMail(false, true)\"><span class=\"fa fa-envelope-o\"></span> Envoyer le mot de passe</button></div></div></div><div class=loader ng-if=extranetctrl.loading></div></div>");
$templateCache.put("app/components/main-content/modif-bien/ged/ged.html","<div class=\"form-horizontal col-xs-12 listeged spacer-top\"><div class=col-xs-12><uib-accordion close-others=true><div class=col-xs-12><div uib-accordion-group is-open=gedctrl.upload.open><uib-accordion-heading><i class=\"fa fa-fw\" ng-click=\"gedctrl.upload.open=!gedctrl.upload.open\" ng-class=\"{\'fa-minus\': gedctrl.upload.open, \'fa-plus\': !gedctrl.upload.open}\"></i> Ajouter des documents electroniques</uib-accordion-heading><div class=\"col-xs-12 spacer-bottom\"><input type=file nv-file-select multiple uploader=gedctrl.uploader><div nv-file-over uploader=gedctrl.uploader></div></div><table class=table><thead><tr><th width=50%>Nom</th><th ng-show=gedctrl.uploader.isHTML5>Taille</th><th ng-show=gedctrl.uploader.isHTML5>Progression</th><th>Statut</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in gedctrl.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=gedctrl.uploader.isHTML5 nowrap>{{ item.file.size/1024/1024|number:2 }} MO</td><td ng-show=gedctrl.uploader.isHTML5><div class=progress style=\"margin-bottom: 0\"><div class=progress-bar role=progressbar ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td class=text-center><span ng-show=item.isSuccess><i class=\"fa fa-check-circle\"></i></span> <span ng-show=item.isCancel><i class=\"fa fa-ban\"></i></span> <span ng-show=item.isError><i class=\"fa fa-remove\"></i></span></td><td nowrap><button type=button class=\"btn btn-danger btn-xs\" ng-click=item.remove()><span class=\"fa fa-trash\"></span> Supprimer</button></td></tr></tbody></table><div><div>Progression:<div class=progress><div class=progress-bar role=progressbar ng-style=\"{ \'width\': gedctrl.uploader.progress + \'%\' }\"></div></div></div><button type=button class=\"btn btn-success btn-s\" ng-click=gedctrl.uploader.uploadAll() ng-disabled=!gedctrl.uploader.getNotUploadedItems().length><span class=\"fa fa-upload\"></span> Envoyer</button> <button type=button class=\"btn btn-warning btn-s\" ng-click=gedctrl.uploader.cancelAll() ng-disabled=!gedctrl.uploader.isUploading><span class=\"fa fa-ban\"></span> Annuler</button> <button type=button class=\"btn btn-danger btn-s\" ng-click=gedctrl.uploader.clearQueue() ng-disabled=!gedctrl.uploader.queue.length><span class=\"fa fa-trash\"></span> Supprimer Tout</button></div></div></div></uib-accordion></div><div class=ged-list ui-sortable=gedctrl.sortableOptions ng-model=gedctrl.ged><div class=\"col-xs-12 spacer-bottom\" ng-if=gedctrl.ged.length><button type=button class=\"btn-custom btn-custom-primary btn-custom-sm\" ng-click=gedctrl.envoyerGedMail() ng-disabled=\"gedctrl.gedIds.length < 1\"><i class=\"fa fa-envelope\"></i> Envoyer par email</button></div><div class=col-xs-12 ng-repeat=\"ged in gedctrl.ged | orderBy: \'ordre\'\"><div class=row><div class=col-xs-6><input type=checkbox class=\"checkbox form-control ged-checkbox\" ng-model=ged.checked ng-change=gedctrl.checkGedIds() title={{get.fileName}}><label class=ged-filename>{{ged.fileName}}</label></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-success btn-xs\" ng-click=gedctrl.dlGed(ged)><span class=\"fa fa-download\"></span> {{ged.citya ? \'Ouvrir\' : \'T&eacute;lecharger\'}}</button> <button type=button class=\"btn btn-danger btn-xs\" ng-click=gedctrl.removeGed(ged)><span class=\"fa fa-trash\"></span> Supprimer</button></div></div></div></div></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/lot.html","<div class=\"col-xs-12 lot-component\"><div class=row><localisation lot=lotctrl.lot validation=lotctrl.validation params-gestion=lotctrl.paramsGestion visited=lotctrl.visited></localisation></div><div class=row><div class=\"col-xs-12 spacer-top\"><dpe-ges lot=lotctrl.lot is-open=lotctrl.accordions.dpeges is-loading=lotctrl.isLoading></dpe-ges></div></div><div class=row><div class=\"col-xs-12 spacer-top\"><criterelot lot=lotctrl.lot is-open=lotctrl.accordions.criterelot is-loading=lotctrl.isLoading></criterelot></div></div><div class=row ng-if=\"!lotctrl.citya || lotctrl.transac === \'Transaction\'\"><div class=\"col-xs-12 spacer-top\"><infolot lot=lotctrl.lot is-open=lotctrl.accordions.infolot is-loading=lotctrl.isLoading></infolot></div></div><div class=row><div class=\"col-xs-12 spacer-top\"><piece lot=lotctrl.lot pieces=lotctrl.lot.pieces is-open=lotctrl.accordions.piece></piece></div></div><div class=row ng-if=\"lotctrl.transac === \'Transaction\'\"><div class=\"col-xs-12 spacer-top\"><cadastre lot=lotctrl.lot cadastres=lotctrl.lot.cadastres is-open=lotctrl.accordions.cadastre></cadastre></div></div><div class=row ng-if=\"lotctrl.transac === \'Transaction\'\"><div class=\"col-xs-12 spacer-top\"><tantieme lot=lotctrl.lot tantiemes-lot=lotctrl.lot.tantiemesLot is-open=lotctrl.accordions.tantieme></tantieme></div></div><uib-accordion close-others=false><!-- Consignes de visite --><div uib-accordion-group is-open=lotctrl.accordions.consignes><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': lotctrl.accordions.consignes, \'fa-plus\': !lotctrl.accordions.consignes}\"></i> Consignes de visite</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=consigne class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Consignes de visite</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><!--suppress XmlDuplicatedId --><textarea ng-if=\"lotctrl.transac === \'Transaction\'\" id=consigne class=form-control rows=5 ng-model=lotctrl.lot.mandatTransaction.commentaire></textarea><!--suppress XmlDuplicatedId --><textarea ng-if=\"lotctrl.transac === \'Location\'\" id=consigne class=form-control rows=5 ng-model=lotctrl.lot.mandatLocation.commentaire></textarea></div></div></div></div></uib-accordion><uib-accordion close-others=false><div uib-accordion-group is-open=lotctrl.accordions.commentaire><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': lotctrl.accordions.commentaire, \'fa-plus\': !lotctrl.accordions.commentaire}\"></i> Commentaire</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=commentaire class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea id=commentaire class=form-control rows=5 ng-model=lotctrl.lot.commentaire></textarea></div></div></div></div></uib-accordion><uib-accordion close-others=false><div uib-accordion-group is-open=lotctrl.accordions.commentaireConfidentiel><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': lotctrl.accordions.commentaireConfidentiel, \'fa-plus\': !lotctrl.accordions.commentaireConfidentiel}\"></i> Commentaire confidentiel</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=commentaireConfidentiel class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire confidentiel</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea id=commentaireConfidentiel class=form-control rows=5 ng-model=lotctrl.lot.commentaireConfidentiel></textarea></div></div></div></div></uib-accordion><uib-accordion close-others=oneAtATime ng-if=\"lotctrl.transac === \'Location\'\"><div uib-accordion-group is-open=lotctrl.accordions.complement><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': lotctrl.accordions.complement, \'fa-plus\': !lotctrl.accordions.complement}\"></i> Compl&eacute;ment d&apos;informations</uib-accordion-heading><div class=row><complement-info lot=lotctrl.lot></complement-info></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/mandat-location/mandat-location.html","<div class=\"col-xs-12 mandat-container mandat-location\"><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=referenceInterne class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">R&eacute;f. Interne</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=text class=\"form-control input-sm\" placeholder=Référence id=referenceInterne ng-model=mandatlocationctrl.lot.referenceInterne name=referenceInterne ng-disabled=\"(mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat) || mandatlocationctrl.citya\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Qualification</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandatlocationctrl.lot.mandatLocation.qualification theme=bootstrap close-on-select=true><ui-select-match placeholder=Qualif... allow-clear>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"qualif in mandatlocationctrl.references.RefQualificationLocation | filter: $select.search track by qualif.id\"><span ng-bind-html=\"::qualif.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">&Eacute;tat</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandatlocationctrl.lot.mandatLocation.avancement theme=bootstrap close-on-select=true ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"><ui-select-match placeholder=État... allow-clear>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"motif in mandatlocationctrl.references.RefMotifSuppressionLocation | filter: $select.search\"><span ng-bind-html=\"::motif.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=libreLe class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Libre le</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=libreLe custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandatlocationctrl.lot.mandatLocation.libreLe ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"mandatlocationctrl.datepickers.libre.open = !mandatlocationctrl.datepickers.libre.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandatlocationctrl.datepickers.libre.open class=\"event-datepicker row\" ng-click=\"::mandatlocationctrl.datepickers.onClose(\'libre\')\"><datetime-picker click-prevent model=mandatlocationctrl.lot.mandatLocation.libreLe time-picker=false date-model=mandatlocationctrl.lot.mandatLocation.libreLe on-close=\"::mandatlocationctrl.datepickers.onClose(\'libre\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><!-- <ui-select id=\"societe\" ng-model=\"mandatlocationctrl.societes.societe\" theme=\"bootstrap\" close-on-select=\"true\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.nego\"\r\n          on-select=\"mandatlocationctrl.societes.changed()\" on-remove=\"mandatlocationctrl.societes.changed()\">\r\n          <ui-select-match placeholder=\"Société...\">\r\n            {{$select.selected.nom}}\r\n          </ui-select-match>\r\n          <ui-select-choices repeat=\"societe in mandatlocationctrl.societes.list | filter: $select.search track by societe.id\" refresh=\"mandatlocationctrl.societes.search($select.search)\"\r\n            refresh-delay=\"350\">\r\n            <span ng-bind-html=\"::societe.nom | highlight: $select.search\"></span>\r\n          </ui-select-choices>\r\n        </ui-select> --><r-select ng-model=mandatlocationctrl.societes.societe rs-options=mandatlocationctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.nego\" rs-on-change=mandatlocationctrl.societes.changed()></r-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=mandatlocationctrl.citya>Gestionnaire</label><label for=nego class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\" ng-if=!mandatlocationctrl.citya>N&eacute;go.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=nego ng-model=mandatlocationctrl.negos.nego theme=bootstrap close-on-select=true ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.nego\" on-select=mandatlocationctrl.negos.changed() on-remove=mandatlocationctrl.negos.changed() required><ui-select-match placeholder=Négo...>{{mandatlocationctrl.lot.mandatLocation.nego.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in mandatlocationctrl.negos.list | filter: $select.search track by nego.id\" refresh=mandatlocationctrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateCreation class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Entr&eacute;e</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateCreation custom-type=date ui-mask=99/99/9999 class=form-control name=dateCreation ng-model=mandatlocationctrl.lot.mandatLocation.dateCreation ng-required=\"!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" ng-class=\"{\'validation-error\': mandatlocationctrl.validation.dateCreation.$error.required && (mandatlocationctrl.validation.$submitted || mandatlocationctrl.visited)}\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" ng-click=\"mandatlocationctrl.datepickers.debut.open = !mandatlocationctrl.datepickers.debut.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandatlocationctrl.datepickers.debut.open class=\"event-datepicker row\" ng-click=\"::mandatlocationctrl.datepickers.onClose(\'debut\')\"><datetime-picker click-prevent model=mandatlocationctrl.lot.mandatLocation.dateCreation time-picker=false date-model=mandatlocationctrl.lot.mandatLocation.dateCreation on-close=\"::mandatlocationctrl.datepickers.onClose(\'debut\')\"></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateFin class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Ech&eacute;ance</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateFin custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandatlocationctrl.lot.mandatLocation.dateEcheance ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" ng-click=\"mandatlocationctrl.datepickers.fin.open = !mandatlocationctrl.datepickers.fin.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandatlocationctrl.datepickers.fin.open class=\"event-datepicker row\" ng-click=\"::mandatlocationctrl.datepickers.onClose(\'fin\')\"><datetime-picker click-prevent model=mandatlocationctrl.lot.mandatLocation.dateEcheance time-picker=false date-model=mandatlocationctrl.lot.mandatLocation.dateEcheance on-close=\"::mandatlocationctrl.datepickers.onClose(\'fin\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=noMandat class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Mandat Loc.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=text class=\"form-control input-sm\" placeholder=Numéro id=noMandat ng-model=mandatlocationctrl.lot.mandatLocation.noMandat name=noMandat ng-required=\"(!mandatlocationctrl.lot.mandatLocation.avancement || mandatlocationctrl.lot.mandatLocation.avancement.data !== 8) || (!mandatlocationctrl.lot.mandatLocation.noMandat && !mandatlocationctrl.lot.mandatLocation.noMandatGestion && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat))\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"><!--<div class=\"validation-tooltip\">Mandat Loc. ou Mandat Gestion requis</div>--></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=noMandatGestion class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Mandat Gestion</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=text class=\"form-control input-sm\" placeholder=Numéro id=noMandatGestion ng-model=mandatlocationctrl.lot.mandatLocation.noMandatGestion name=noMandatGestion ng-required=\"(!mandatlocationctrl.lot.mandatLocation.avancement || mandatlocationctrl.lot.mandatLocation.avancement.data !== 8) || (!mandatlocationctrl.lot.mandatLocation.noMandat && !mandatlocationctrl.lot.mandatLocation.noMandatGestion && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat))\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"><!--<div class=\"validation-tooltip\">Mandat Gestion ou Mandat Loc. requis</div>--></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=loyer class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Loyer</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=loyer name=loyer ng-blur=mandatlocationctrl.changeLoyer($event) custom-type=number class=form-control placeholder=0 ng-model=mandatlocationctrl.lot.mandatLocation.loyer min=0 ng-required=\"!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" ng-change=\"mandatlocationctrl.calculHonoraires(\'loyer\')\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=charges class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Charges</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=charges ng-model=mandatlocationctrl.lot.mandatLocation.charges min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0 ng-change=\"mandatlocationctrl.calculHonoraires(\'charges\')\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=autresCharges class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Autres Charges</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=autresCharges ng-model=mandatlocationctrl.lot.mandatLocation.autresCharges min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0 ng-change=\"mandatlocationctrl.calculHonoraires(\'autresCharges\')\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=autresFrais class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Autres frais</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=autresFrais ng-model=mandatlocationctrl.lot.mandatLocation.autresFrais min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=taxes class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Taxes</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=taxes ng-model=mandatlocationctrl.lot.mandatLocation.taxes min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=loyerTTC class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Loyer TCC</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=loyerTTC ng-model=mandatlocationctrl.lot.mandatLocation.loyerTTC min=0 disabled custom-type=number class=form-control placeholder=0 ng-change=\"mandatlocationctrl.calculHonoraires(\'loyerTTC\')\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=depotGarantie class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">D&eacute;p&ocirc;t Garantie</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=depotGarantie ng-model=mandatlocationctrl.lot.mandatLocation.depotGarantie min=0 ng-required=\"!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=hono class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=hono custom-type=number class=form-control placeholder=0 min=0 ng-model=mandatlocationctrl.honoraires ng-disabled=\"mandatlocationctrl.lot.mandatLocation.zoneAlur && mandatlocationctrl.paramsGestion && (mandatlocationctrl.paramsGestion.mandat || mandatlocationctrl.paramsGestion.honoraire)\" ng-change=\"mandatlocationctrl.calculHonoraires(\'honoraires\')\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=honoraireVDB class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Hono. V.D.B.</label><div class=\"col-xs-9 col-sm-5 col-md-5 spacer-bottom\"><input id=honoraireVDB custom-type=number class=form-control placeholder=0 min=0 ng-model=mandatlocationctrl.lot.mandatLocation.honoraireVDB ng-disabled=\"(mandatlocationctrl.lot.mandatLocation.zoneAlur && !mandatlocationctrl.employe.profileTrans.peutModifierHonoAlur) && !mandatlocationctrl.citya\" ng-change=\"mandatlocationctrl.calculHonoraires(\'honoraireVDB\')\" ng-blur=\"mandatlocationctrl.alertVdbEld(\'honoraireVDB\')\"></div><div class=col-xs-3><span class=max-honoraire-vdb>{{mandatlocationctrl.maxHonoraireVDB | tgnFormat: \'number\'}} &euro;</span></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=honoraireEDL class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. E.D.L.</label><div class=\"col-xs-9 col-sm-5 col-md-5 spacer-bottom\"><input id=honoraireEDL min=0 custom-type=number class=form-control placeholder=0 ng-model=mandatlocationctrl.lot.mandatLocation.honoraireEDL ng-disabled=\"(mandatlocationctrl.lot.mandatLocation.zoneAlur && !mandatlocationctrl.employe.profileTrans.peutModifierHonoAlur) && !mandatlocationctrl.citya\" ng-change=\"mandatlocationctrl.calculHonoraires(\'honoraireEDL\')\" ng-blur=\"mandatlocationctrl.alertVdbEld(\'honoraireEDL\')\"></div><div class=col-xs-3><span class=max-honoraire-edl>{{mandatlocationctrl.maxHonoraireEDL | tgnFormat: \'number\'}} &euro;</span></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=tvaHono class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">TVA/Hono</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=tvaHono ng-model=mandatlocationctrl.lot.mandatLocation.tvaHono min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\" custom-type=number class=form-control placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=zoneAlur class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Zone Alur</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><ui-select ng-model=mandatlocationctrl.lot.mandatLocation.zoneAlur id=zoneAlur theme=bootstrap ng-change=\"mandatlocationctrl.calculHonoraires(\'zoneAlur\')\"><ui-select-match placeholder=\"Zone Alur\" allow-clear={{mandatlocationctrl.employe.profileTrans.adminProfile}}>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"zone in mandatlocationctrl.references.RefZoneAlur | filter: $select.search track by zone.id\"><div ng-bind-html=\"zone.label | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-addon btn-custom-primary btn-zone-alur\" tooltip-placement=\"auto top\" uib-tooltip=\"Définir la zone Alur\" ng-click=mandatlocationctrl.calculZoneAlur()><i class=\"fa fa-fw fa-euro\"></i></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=chargesForfaitaire class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Charges Forfaitaires :</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=chargesForfaitaire ng-model=mandatlocationctrl.lot.mandatLocation.chargeForfait class=\"checkbox form-control\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=enCompromis class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">En attente</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=enCompromis ng-model=mandatlocationctrl.lot.enCompromis class=\"checkbox form-control\" placeholder=0 ng-true-value=\"\'en attente\'\" ng-false-value=null></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=archive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Archiv&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.archive ng-disabled=!mandatlocationctrl.employe.profileTrans.adminProfile></div></div></div><uib-accordion close-others=oneAtATime><!-- Infos supplémentaires --><div uib-accordion-group is-open=infosMandatOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': infosMandatOpen, \'fa-plus\': !infosMandatOpen}\"></i> Infos mandat</uib-accordion-heading><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=mandatVL class=\"col-xs-2 col-sm-3 col-md-4 control-label checkbox-label no-padding-left\">V.L.</label><div class=\"col-xs-4 col-sm-2 spacer-bottom\"><input id=mandatVL type=checkbox class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.vl ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div><label for=mandatGL class=\"col-xs-2 col-xs-offset-2 col-sm-1 col-sm-offset-0 control-label checkbox-label no-padding-left\">G.L.</label><div class=\"col-xs-2 col-sm-3 spacer-bottom\"><input id=mandatGL type=checkbox class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.gl ng-change=\"mandatlocationctrl.lot.mandatLocation.refAssureurGli = null\" ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=refAssureurGli class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Assureur GLI</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=refAssureurGli name=refAssureurGli theme=bootstrap ng-model=mandatlocationctrl.lot.mandatLocation.refAssureurGli ng-disabled=!mandatlocationctrl.lot.mandatLocation.gl><ui-select-match placeholder=Assureur... allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"assureur in mandatlocationctrl.references.RefAssureurGLI | filter: $select.search track by assureur.id\"><div ng-bind-html=\"assureur.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=noCle class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">N&deg; Cl&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=text id=noCle ng-model=mandatlocationctrl.lot.mandatLocation.noCle class=form-control></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=fiscalite class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Fiscalit&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=fiscalite ng-model=mandatlocationctrl.lot.mandatLocation.fiscalite type=text class=form-control ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=mrh class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">MRH</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=mrh type=text ng-model=mandatlocationctrl.lot.mandatLocation.mrh class=form-control ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=mrhInternet class=\"col-xs-5 col-sm-3 col-md-2 control-label checkbox-label no-padding-left\">Diffusion MRH</label><div class=\"col-xs-7 col-sm-6 col-md-6 spacer-bottom\"><input id=mrhInternet name=mrhInternet type=checkbox class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.mrhInternet></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=noPorte class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">N&deg; Porte</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=noPorte ng-model=mandatlocationctrl.lot.noPorte type=text class=form-control ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=noEtage class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">N&deg; &Eacute;tage</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=noEtage ng-model=mandatlocationctrl.lot.noEtage custom-type=number class=form-control ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=loyerAncienLocataire class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Ancien Loyer</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=loyerAncienLocataire ng-model=mandatlocationctrl.lot.mandatLocation.loyerAncienLocataire type=text class=form-control placeholder=0 min=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateDernierVersement class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date Versement</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateDernierVersement custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandatlocationctrl.lot.mandatLocation.dateDernierVersement ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-class=\"{\'disabled\': mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat}\" ng-click=\"mandatlocationctrl.datepickers.dateDernierVersement.open = !mandatlocationctrl.datepickers.dateDernierVersement.open && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat)\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandatlocationctrl.datepickers.dateDernierVersement.open class=\"event-datepicker row\" ng-click=\"::mandatlocationctrl.datepickers.onClose(\'dateDernierVersement\')\"><datetime-picker click-prevent model=mandatlocationctrl.lot.mandatLocation.dateDernierVersement time-picker=false date-model=mandatlocationctrl.lot.mandatLocation.dateDernierVersement on-close=\"::mandatlocationctrl.datepickers.onClose(\'dateDernierVersement\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=loyerPlafonner class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Loyer Plafonn&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=loyerPlafonner ng-model=mandatlocationctrl.lot.mandatLocation.loyerPlafonner min=0 custom-type=number class=form-control placeholder=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateRevisionLoyer class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">R&eacute;vision</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateRevisionLoyer custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandatlocationctrl.lot.mandatLocation.dateRevisionLoyer ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-class=\"{\'disabled\': mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat}\" ng-click=\"mandatlocationctrl.datepickers.dateRevisionLoyer.open = !mandatlocationctrl.datepickers.dateRevisionLoyer.open && (!mandatlocationctrl.paramsGestion || !mandatlocationctrl.paramsGestion.mandat)\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandatlocationctrl.datepickers.dateRevisionLoyer.open class=\"event-datepicker row\" ng-click=\"::mandatlocationctrl.datepickers.onClose(\'dateRevisionLoyer\')\"><datetime-picker click-prevent model=mandatlocationctrl.lot.mandatLocation.dateRevisionLoyer time-picker=false date-model=mandatlocationctrl.lot.mandatLocation.dateRevisionLoyer on-close=\"::mandatlocationctrl.datepickers.onClose(\'dateRevisionLoyer\')\"></datetime-picker></div></div></div></div></div><!-- Commentaire mandat --><div uib-accordion-group is-open=commentaireOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': commentaireOpen, \'fa-plus\': !commentaireOpen}\"></i> Commentaire Mandat</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=commentaireConfidentiel class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire confidentiel</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea id=commentaireConfidentiel ng-model=mandatlocationctrl.lot.mandatLocation.commentaireConfidentiel class=form-control rows=3></textarea></div></div></div></div><div uib-accordion-group is-open=infosBailOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': infosBailOpen, \'fa-plus\': !infosBailOpen}\"></i> Infos Bail</uib-accordion-heading><div class=row><div class=\"col-xs-12 no-padding\"><label for=sciFamilial class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">SCI Familiale</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><input type=checkbox id=sciFamilial name=sciFamilial class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.sciFamilial></div></div><div class=\"col-xs-6 no-padding\"><label for=tantiemeChauffage class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">R&eacute;partition Chauffage</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=tantiemeChauffage name=tantiemeChauffage theme=bootstrap ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeChauffage><ui-select-match placeholder=Répartition... allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"repartition.value as repartition in mandatlocationctrl.references.RefRepartition | filter: $select.search track by repartition.value\"><div ng-bind-html=\"repartition.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-xs-6 no-padding\"><label for=tantiemeLot class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Tanti&egrave;mes Chauffage</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input type=text id=tantiemeLot name=tantiemeLot class=\"form-control border-right-rounded\" ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeLot title=\"Tantièmes lot\"> <span class=input-group-addon>/ </span><input type=text id=tantiemeTotal name=tantiemeTotal title=\"Tantièmes total\" class=\"form-control border-left-rounded\" ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeTotal></div></div></div><div class=\"col-xs-6 no-padding\"><label for=tantiemeEauChaude class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">R&eacute;partition Eau Chaude</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=tantiemeEauChaude name=tantiemeEauChaude theme=bootstrap ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeEauChaude><ui-select-match placeholder=Répartition... allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"repartition.value as repartition in mandatlocationctrl.references.RefRepartition | filter: $select.search track by repartition.value\"><div ng-bind-html=\"repartition.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-xs-6 no-padding\"><label for=tantiemeEC class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Tanti&egrave;mes Eau Chaude</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input type=text id=tantiemeEC name=tantiemeEC class=\"form-control border-right-rounded\" ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeEC title=\"Tantièmes lot\"> <span class=input-group-addon>/ </span><input type=text id=tantiemesSurEauChaude name=tantiemesSurEauChaude title=\"Tantièmes total\" class=\"form-control border-left-rounded\" ng-model=mandatlocationctrl.lot.mandatLocation.tantiemeECTotal></div></div></div><div class=\"col-xs-6 no-padding\"><label for=tvHertz class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">Tv Hertzienne</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=tvHertz name=tvHertz class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.tvHertz></div></div><div class=\"col-xs-6 no-padding\"><label for=cable class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">R&eacute;seau c&acirc;bl&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=cable name=cable class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.cable></div></div><div class=\"col-xs-6 no-padding\"><label for=contratCable class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">Contrat c&acirc;ble &agrave; souscrire</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=contratCable name=contratCable class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.contratCable></div></div><div class=\"col-xs-6 no-padding\"><label for=loyerRelocation class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Loyer plafonn&eacute; relocation</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=loyerRelocation name=loyerRelocation class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.loyerRelocation></div></div><div class=\"col-xs-6 no-padding\"><label for=loyerEncadre class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">Encadrement des loyers</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=loyerEncadre name=loyerEncadre class=\"checkbox form-control\" ng-model=mandatlocationctrl.lot.mandatLocation.loyerEncadre ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></div></div><div class=\"col-xs-6 no-padding\"><label for=loyerReference class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Loyer de r&eacute;f&eacute;rence</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=number id=loyerReference name=loyerReference class=\"form-control border-rounded\" min=0 ng-model=mandatlocationctrl.lot.mandatLocation.loyerReference placeholder=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=input-group-addon>&euro; / m&sup2;</span></div></div></div><div class=\"col-xs-6 no-padding\"><label for=loyerMajore class=\"col-xs-12 col-sm-2 col-md-4 control-label no-padding-left\">Loyer de r&eacute;f&eacute;rence major&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=number id=loyerMajore name=loyerMajore class=\"form-control border-rounded\" min=0 ng-model=mandatlocationctrl.lot.mandatLocation.loyerMajore placeholder=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=input-group-addon>&euro; / m&sup2;</span></div></div></div><div class=\"col-xs-6 no-padding\"><label for=complementLoyer class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Compl&eacute;ment de loyer</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=number id=complementLoyer name=complementLoyer class=\"form-control border-rounded\" min=0 ng-model=mandatlocationctrl.lot.mandatLocation.complementLoyer placeholder=0 ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"> <span class=input-group-addon>&euro;</span></div></div></div><div class=\"col-xs-12 no-padding\"><label for=raisonNonPlafond class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Justificatif du compl&eacute;ment de loyer</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea id=raisonNonPlafond name=raisonNonPlafond class=form-control rows=5 ng-model=mandatlocationctrl.lot.mandatLocation.raisonNonPlafond ng-disabled=\"mandatlocationctrl.paramsGestion && mandatlocationctrl.paramsGestion.mandat\"></textarea></div></div></div></div><div uib-accordion-group is-open=locataireOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': locataireOpen, \'fa-plus\': !locataireOpen}\"></i> Infos Locataire</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">S&eacute;lectionner un locataire</label><div class=\"col-xs-9 col-sm-4 col-md-6 spacer-bottom\"><ui-select ng-model=mandatlocationctrl.lot.mandatLocation.locataire theme=bootstrap close-on-select=true><ui-select-match placeholder=\"Chercher un locataire...\">{{$select.selected.perso.nomComplet}}</ui-select-match><ui-select-choices repeat=\"locataire.perso as locataire in mandatlocationctrl.locataires.list | filter: $select.search track by locataire.id\" refresh=mandatlocationctrl.locataires.search($select.search) refresh-delay=500><div ng-bind-html=\"::locataire.perso.nomComplet | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-3 col-sm-2 spacer-bottom\"><button type=button class=\"btn-custom btn-custom-block btn-danger\" ng-click=mandatlocationctrl.locataires.reset()><i class=\"fa fa-fw fa-trash\"></i> <span class=hidden-xs>Vider</span></button></div></div></div><div class=\"row spacer-top\"><personnalite personnalite=mandatlocationctrl.lot.mandatLocation.locataire is-loading=mandatlocationctrl.isLoading></personnalite></div></div><!--<div uib-accordion-group is-open=\"suiviOpen\">\r\n      <uib-accordion-heading>\r\n        <i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': suiviOpen, \'fa-plus\': !suiviOpen}\"></i>\r\n        Suivi Mandat\r\n      </uib-accordion-heading>\r\n      &lt;!&ndash; TODO => Récupérer les données concernant le suivi du mandat &ndash;&gt;\r\n      <div class=\"form-group spacer-top\">\r\n        <div class=\"col-xs-4 col-sm-3 col-sm-offset-1 col-md-2 col-md-offset-2\">01/12/2016</div>\r\n        <div class=\"col-xs-6 col-md-5\">Appel Proprio baisse de prix</div>\r\n        <div class=\"col-xs-2 col-sm-1 text-right\">\r\n          <a class=\"pull-right btn btn-xs btn-info\"><i class=\"fa fa-pencil\"></i></a>\r\n        </div>\r\n      </div>\r\n\r\n      &lt;!&ndash; TODO => Enregistrer des données concernant le suivi du mandat &ndash;&gt;\r\n      <div class=\"form-group spacer-top\">\r\n        <div class=\"col-xs-10 col-sm-3 col-sm-offset-1 col-md-2 col-md-offset-2\">\r\n          <div class=\"input-group\">\r\n            <input id=\"dateSaisie\" custom-type=\"date\" ui-mask=\"99/99/9999\" class=\"form-control\"\r\n                   ng-model=\"dateSaisie\">\r\n            <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\"\r\n                  ng-click=\"mandatlocationctrl.datepickers.suivi.open = !mandatlocationctrl.datepickers.suivi.open\">\r\n									<i class=\"fa fa-fw fa-calendar\"></i>\r\n							</span>\r\n          </div>\r\n          <div ng-if=\"mandatlocationctrl.datepickers.suivi.open\" class=\"event-datepicker row\"\r\n               ng-click=\"::mandatlocationctrl.datepickers.onClose(\'suivi\')\">\r\n            <datetime-picker click-prevent model=\"dateSaisie\" time-picker=\"false\"\r\n                             date-model=\"dateSaisie\"\r\n                             on-close=\"::mandatlocationctrl.datepickers.onClose(\'suivi\')\"></datetime-picker>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-xs-2 col-sm-1 col-sm-push-6 col-md-push-5 text-right\">\r\n          <a class=\"pull-right btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i></a>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-pull-1 col-md-5\">\r\n          <input id=\"libelle\" value=\"\" class=\"form-control\" placeholder=\"Description\">\r\n        </div>\r\n      </div>\r\n    </div>--></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/mandat-transaction/mandat-transaction.html","<div class=\"col-xs-12 mandat-container\"><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=referenceInterne class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">R&eacute;f. Interne</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=text class=\"form-control input-sm\" placeholder=Référence id=referenceInterne ng-model=mandattransactionctrl.lot.referenceInterne name=referenceInterne ng-disabled=mandattransactionctrl.citya></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Origine</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandattransactionctrl.lot.mandatTransaction.origine theme=bootstrap close-on-select=true><ui-select-match placeholder=Origine... allow-clear>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"origine in mandattransactionctrl.references.RefOrigineMandat | filter: $select.search track by origine.id\"><span ng-bind-html=\"::origine.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">&Eacute;tat</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandattransactionctrl.lot.mandatTransaction.avancement theme=bootstrap close-on-select=true><ui-select-match placeholder=État... allow-clear>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"motif in mandattransactionctrl.references.RefMotifSuppression | filter: $select.search track by motif.label\"><span ng-bind-html=\"::motif.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Qualification</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandattransactionctrl.lot.mandatTransaction.qualification theme=bootstrap close-on-select=true><ui-select-match placeholder=Qualif... allow-clear>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"qualif in mandattransactionctrl.references.RefQualification | filter: $select.search track by qualif.id\"><span ng-bind-html=\"::qualif.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><!-- <ui-select id=\"societe\" ng-model=\"mandattransactionctrl.societes.societe\" theme=\"bootstrap\" close-on-select=\"true\" on-select=\"mandattransactionctrl.societes.changed()\"\r\n          on-remove=\"mandattransactionctrl.societes.changed()\">\r\n          <ui-select-match placeholder=\"Société...\">\r\n            {{$select.selected.nom}}\r\n          </ui-select-match>\r\n          <ui-select-choices repeat=\"societe in mandattransactionctrl.societes.list | filter: $select.search track by societe.id\" refresh=\"mandattransactionctrl.societes.search($select.search)\"\r\n            refresh-delay=\"500\">\r\n            <span ng-bind-html=\"::societe.nom | highlight: $select.search\"></span>\r\n          </ui-select-choices>\r\n        </ui-select> --><r-select ng-model=mandattransactionctrl.societes.societe rs-options=mandattransactionctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\" rs-on-change=mandattransactionctrl.societes.changed()></r-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">N&eacute;go.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=nego ng-model=mandattransactionctrl.negos.nego theme=bootstrap close-on-select=true on-select=mandattransactionctrl.negos.changed() on-remove=mandattransactionctrl.negos.changed() required><ui-select-match placeholder=Négo...>{{mandattransactionctrl.lot.mandatTransaction.nego.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in mandattransactionctrl.negos.list | filter: $select.search track by nego.id\" refresh=mandattransactionctrl.negos.search($select.search) refresh-delay=500><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Type</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=mandattransactionctrl.lot.mandatTransaction.type theme=bootstrap><ui-select-match placeholder=\"Type mandat\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"typemandat in mandattransactionctrl.references.RefTypeMandat | filter: $select.search track by typemandat.id\"><div ng-bind-html=\"typemandat.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=libelle class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Numero Mandat</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=libelle name=libelle type=text class=\"form-control input-sm\" placeholder=Numéro ng-model=mandattransactionctrl.lot.mandatTransaction.noMandat ng-required=\"(!mandattransactionctrl.lot.mandatTransaction.avancement || mandattransactionctrl.lot.mandatTransaction.avancement.data !== 8) || (!mandattransactionctrl.lot.mandatTransaction.avancement || mandattransactionctrl.lot.mandatTransaction.avancement.label != \'En Estimation\')\"></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateDebut class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Du</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateDebut name=dateDebut custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandattransactionctrl.lot.mandatTransaction.dateCreation ng-change=mandattransactionctrl.setDateEcheance()> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"mandattransactionctrl.datepickers.debut.open = !mandattransactionctrl.datepickers.debut.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandattransactionctrl.datepickers.debut.open class=\"event-datepicker row\" ng-click=\"::mandattransactionctrl.datepickers.debut.onClose(\'debut\')\"><datetime-picker click-prevent model=mandattransactionctrl.lot.mandatTransaction.dateCreation time-picker=false date-model=mandattransactionctrl.lot.mandatTransaction.dateCreation on-close=\"::mandattransactionctrl.datepickers.debut.onClose(\'debut\')\"></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateFin class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">au</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateFin name=dateFin custom-type=date ui-mask=99/99/9999 class=form-control ng-model=mandattransactionctrl.lot.mandatTransaction.dateEcheance> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"mandattransactionctrl.datepickers.fin.open = !mandattransactionctrl.datepickers.fin.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=mandattransactionctrl.datepickers.fin.open class=\"event-datepicker row\" ng-click=\"::mandattransactionctrl.datepickers.fin.onClose(\'fin\')\"><datetime-picker click-prevent model=mandattransactionctrl.lot.mandatTransaction.dateEcheance time-picker=false date-model=mandattransactionctrl.lot.mandatTransaction.dateEcheance on-close=\"::mandattransactionctrl.datepickers.fin.onClose(\'fin\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\" ng-if=!mandattransactionctrl.employe.societe.agence.surPrixVente><label for=prixVente class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Prix Vente</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=prixVente ng-blur=\"mandattransactionctrl.calculCommission(\'prixVente\')\" class=form-control ng-model=mandattransactionctrl.lot.mandatTransaction.prixVente custom-type=integer placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\" ng-if=mandattransactionctrl.employe.societe.agence.surPrixVente><label for=prixVendeur class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Prix Vendeur</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=prixVendeur ng-blur=\"mandattransactionctrl.calculCommission(\'prixVendeur\')\" ng-model=mandattransactionctrl.prixVendeur custom-type=integer class=form-control placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=tauxComm ng-if=!mandattransactionctrl.employe.societe.agence.surPrixVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Tx Hono</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\" ng-if=!mandattransactionctrl.employe.societe.agence.surPrixVente><input id=tauxComm name=tauxComm ng-model=mandattransactionctrl.lot.mandatTransaction.tauxComm ng-blur=\"mandattransactionctrl.calculCommission(\'tauxComm\')\" custom-type=number class=form-control placeholder=0></div><label for=tauxCommInv ng-if=mandattransactionctrl.employe.societe.agence.surPrixVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Tx Hono</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\" ng-if=mandattransactionctrl.employe.societe.agence.surPrixVente><input id=tauxCommInv name=tauxCommInv ng-model=mandattransactionctrl.tauxCommInv ng-blur=\"mandattransactionctrl.calculCommission(\'tauxCommInv\')\" custom-type=number class=form-control placeholder=0></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=commision class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Hono.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=commision ng-blur=\"mandattransactionctrl.calculCommission(\'commission\')\" ng-model=mandattransactionctrl.commission custom-type=integer class=form-control placeholder=0></div></div><div class=\"col-xs-12 col-md-6 no-padding\" ng-if=!mandattransactionctrl.employe.societe.agence.surPrixVente><label for=prixVendeur class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Prix Vendeur</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=prixVendeur name=prixVendeur ng-model=mandattransactionctrl.prixVendeur ng-blur=\"mandattransactionctrl.calculCommission(\'prixVendeur\')\" custom-type=integer class=form-control placeholder=0 min=0 required></div></div><div class=\"col-xs-12 col-md-6 no-padding\" ng-if=mandattransactionctrl.employe.societe.agence.surPrixVente><label for=prixVente class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Prix Vente</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=prixVente name=prixVente ng-model=mandattransactionctrl.lot.mandatTransaction.prixVente ng-blur=\"mandattransactionctrl.calculCommission(\'prixVente\')\" custom-type=integer class=form-control placeholder=0 min=0 required></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=honoChargeVendeur class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Hono. Vendeur</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=honoChargeVendeur name=honoChargeVendeur custom-type=number placeholder=0 class=form-control ng-model=mandattransactionctrl.lot.mandatTransaction.honoChargeVendeur></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=honoChargeAquereur class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Hono. Acheteur</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input id=honoChargeAquereur name=honoChargeAquereur custom-type=number placeholder=0 class=form-control ng-model=mandattransactionctrl.lot.mandatTransaction.honoChargeAquereur></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=bienLoue class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Lou&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=bienLoue name=bienLoue class=\"checkbox form-control\" ng-model=mandattransactionctrl.lot.mandatTransaction.bienLoue></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=archive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Archiv&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=mandattransactionctrl.lot.mandatTransaction.archive><!--<button type=\"button\" id=\"archive\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-checkbox-form\"\r\n                ng-class=\"{\'checked\': mandattransactionctrl.lot.mandatTransaction.archive}\"\r\n                ng-model=\"mandattransactionctrl.lot.mandatTransaction.archive\"\r\n                uib-btn-checkbox btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">\r\n          {{mandattransactionctrl.lot.mandatTransaction.archive ? \'OUI\' : \'NON\'}}\r\n        </button>--></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=delegation class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">D&eacute;l&eacute;gation</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=delegation name=delegation class=\"checkbox form-control\" ng-model=mandattransactionctrl.lot.mandatTransaction.delegation></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><div class=\"col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-2 spacer-bottom\"><button type=button id=avenant class=\"btn-custom btn-custom-primary\" ng-click=mandattransactionctrl.avenant()>Avenant</button></div></div></div><uib-accordion close-others=oneAtATime><!-- Commentaire mandat --><div uib-accordion-group is-open=commentaireOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': commentaireOpen, \'fa-plus\': !commentaireOpen}\"></i> Commentaire Mandat</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=commentaireConfidentiel class=\"col-xs-12 col-sm-1 col-md-2 control-label no-padding-left\">Commentaire confidentiel</label><div class=\"col-xs-12 col-sm-10 col-md-8 spacer-bottom\"><textarea id=commentaireConfidentiel ng-model=mandattransactionctrl.lot.mandatTransaction.commentaireConfidentiel class=form-control rows=3></textarea></div></div></div></div><!--<div uib-accordion-group is-open=\"mandattransactionctrl.suivi.open\">\r\n      <uib-accordion-heading>\r\n        <i class=\"fa fa-fw\"\r\n           ng-class=\"{\'fa-minus\': mandattransactionctrl.suivi.open, \'fa-plus\': !mandattransactionctrl.suivi.open}\"></i>\r\n        Suivi Mandat\r\n      </uib-accordion-heading>\r\n      &lt;!&ndash; TODO => Récupérer les données concernant le suivi du mandat &ndash;&gt;\r\n      <div class=\"form-group spacer-top\">\r\n        <div class=\"col-xs-4 col-sm-3 col-sm-offset-1 col-md-2 col-md-offset-2\">01/12/2016</div>\r\n        <div class=\"col-xs-6 col-md-5\">Appel Proprio baisse de prix</div>\r\n        <div class=\"col-xs-2 col-sm-1 text-right\">\r\n          <a class=\"pull-right btn btn-xs btn-info\"><i class=\"fa fa-pencil\"></i></a>\r\n        </div>\r\n      </div>\r\n\r\n      &lt;!&ndash; TODO => Enregistrer des données concernant le suivi du mandat &ndash;&gt;\r\n      <div class=\"form-group spacer-top\">\r\n        <div class=\"col-xs-10 col-sm-3 col-sm-offset-1 col-md-2 col-md-offset-2\">\r\n          <div class=\"input-group\">\r\n            <input id=\"dateSaisie\" custom-type=\"date\" ui-mask=\"99/99/9999\" class=\"form-control\"\r\n                   ng-model=\"dateSaisie\">\r\n            <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\"\r\n                  ng-click=\"mandattransactionctrl.datepickers.suivi.open = !mandattransactionctrl.datepickers.suivi.open\">\r\n									<i class=\"fa fa-fw fa-calendar\"></i>\r\n							</span>\r\n          </div>\r\n          <div ng-if=\"mandattransactionctrl.datepickers.suivi.open\" class=\"event-datepicker row\"\r\n               ng-click=\"::mandattransactionctrl.datepickers.suivi.onClose(\'suivi\')\">\r\n            <datetime-picker click-prevent model=\"dateSaisie\" time-picker=\"false\"\r\n                             date-model=\"dateSaisie\"\r\n                             on-close=\"::mandattransactionctrl.datepickers.suivi.onClose(\'suivi\')\"></datetime-picker>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-xs-2 col-sm-1 col-sm-push-6 col-md-push-5 text-right\">\r\n          <a class=\"pull-right btn btn-xs btn-success\"><i class=\"fa fa-plus\"></i></a>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-pull-1 col-md-5\">\r\n          <input id=\"libelle\" value=\"\" class=\"form-control\" placeholder=\"Description\">\r\n        </div>\r\n      </div>\r\n    </div>--></uib-accordion><uib-accordion close-others=oneAtATime ng-if=\"mandattransactionctrl.employe.societe.agence.backOffice && mandattransactionctrl.employe.profileTrans.backOfficeProfile\"><!-- Backoffice --><div uib-accordion-group is-open=backOfficeOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': backOfficeOpen, \'fa-plus\': !backOfficeOpen}\"></i> Back Office</uib-accordion-heading><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-8 spacer-bottom\"><r-select ng-model=mandattransactionctrl.lot.mandatTransaction.societeAaffecter rs-options=mandattransactionctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\"></r-select></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/panneaux/panneaux.html","<div class=\"lot-panneaux col-xs-12 no-padding\"><h4 class=text-center>Gestion des panneaux</h4><div class=form-group ng-repeat=\"type in lotpanneauxctrl.typesList\"><div class=\"col-xs-12 col-sm-8 col-sm-offset-2 no-padding\"><i class=\"panneau-actif fa fa-2x\" ng-class=\"{\r\n           \'fa-check\': lotpanneauxctrl.panneaux[type].actif.active,\r\n           \'fa-times\': !lotpanneauxctrl.panneaux[type].actif.active\r\n         }\"></i><div class=\"col-xs-12 panneau-controls text-right spacer-bottom\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-sm\" ng-click=lotpanneauxctrl.enregistrer(type)><i class=\"fa fa-fw fa-save\"></i> <span class=hidden-xs>Enregistrer</span></button> <button type=button class=\"btn-custom btn-danger btn-custom-sm\" ng-click=lotpanneauxctrl.supprimer(type)><i class=\"fa fa-fw fa-trash-o\"></i> <span class=hidden-xs>Supprimer</span></button></div><div class=\"col-xs-12 col-lg-4\"><div class=\"input-group spacer-bottom\"><input custom-type=number id=nb{{type}} name=nb{{type}} class=\"form-control border-rounded\" ng-model=lotpanneauxctrl.panneaux[type].actif.prix> <span class=\"input-group-addon no-border\"><label for=nb{{type}}>Panneau<span ng-if=lotpanneauxctrl.panneaux[type].pluriel>x</span> {{lotpanneauxctrl.panneaux[type].text}}</label></span></div></div><div class=\"col-xs-12 col-lg-4\"><div class=\"input-group spacer-bottom\"><span class=\"input-group-addon no-border\"><label for=date{{type}}>pos&eacute;<span ng-if=lotpanneauxctrl.panneaux[type].pluriel>s</span> le</label></span><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=date{{type}} name=date{{type}} class=\"form-control border-left-rounded\" ng-model=lotpanneauxctrl.panneaux[type].actif.date> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"lotpanneauxctrl.datepickers[\'date\'+type] = !lotpanneauxctrl.datepickers[\'date\'+type]\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=\"lotpanneauxctrl.datepickers[\'date\'+type]\" class=event-datepicker ng-click=\"::lotpanneauxctrl.datepickers.onClose(\'date\'+type)\"><datetime-picker click-prevent time-picker=true model=lotpanneauxctrl.panneaux[type].actif.date on-close=\"::lotpanneauxctrl.datepickers.onClose(\'date\'+type)\"></datetime-picker></div></div><div class=\"col-xs-12 col-lg-4\"><div class=\"input-group spacer-bottom\"><span class=\"input-group-addon no-border\"><label for=dateFin{{type}}><span ng-if=lotpanneauxctrl.panneaux[type].enleve>enlev&eacute; le</span> <span ng-if=!lotpanneauxctrl.panneaux[type].enleve>&agrave; enlever le</span></label></span><input custom-type=datetime ui-mask=\"99/99/9999 99h99\" id=dateFin{{type}} name=dateFin{{type}} class=\"form-control border-left-rounded\" ng-model=lotpanneauxctrl.panneaux[type].actif.dateFin> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"lotpanneauxctrl.datepickers[\'dateFin\'+type] = !lotpanneauxctrl.datepickers[\'dateFin\'+type]\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=\"lotpanneauxctrl.datepickers[\'dateFin\'+type]\" class=event-datepicker ng-click=\"::lotpanneauxctrl.datepickers.onClose(\'dateFin\'+type)\"><datetime-picker click-prevent time-picker=true model=lotpanneauxctrl.panneaux[type].actif.dateFin on-close=\"::lotpanneauxctrl.datepickers.onClose(\'dateFin\'+type)\"></datetime-picker></div></div><div class=col-xs-12><textarea id=commentaire{{type}} name=commentaire{{type}} class=form-control placeholder=Commentaire ng-model=lotpanneauxctrl.panneaux[type].actif.commentaire title=Commentaire></textarea></div></div><div class=\"col-xs-12 col-sm-8 col-sm-offset-2 no-padding\" ng-if=!$last><hr class=custom-hr></div></div></div>");
$templateCache.put("app/components/main-content/modif-bien/parution/parution.html","<div class=\"col-xs-12 parution-box spacer-bottom\"><h4 class=text-center>Gestion des parutions</h4><div class=\"col-xs-12 no-padding\" ng-if=parutionctrl.presta.vitrine><div class=\"col-xxs-12 col-xxs-offset-0 col-xs-6 col-xs-offset-3 col-sm-4 col-sm-offset-4 col-md-2 col-md-offset-5 col-lg-2 col-lg-offset-5\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: parutionctrl.presta.vitrine.checked}\" ng-model=parutionctrl.presta.vitrine.checked uib-btn-checkbox ng-change=parutionctrl.modifPrestataire(parutionctrl.presta.vitrine)><span ng-if=parutionctrl.presta.vitrine.hasImg class=parution-img><img ng-src={{parutionctrl.presta.vitrine.imgSrc}} alt={{parutionctrl.presta.vitrine.nom}} class=img-responsive> </span><span ng-if=(!parutionctrl.presta.vitrine.hasImg) class=parution-nom>{{parutionctrl.presta.vitrine.nom}}</span></button></div></div><hr class=custom-hr><div class=col-xs-12>Liste des prestataires</div><div class=\"col-xxs-12 col-xs-6 col-sm-4 col-md-2 col-lg-2\" ng-repeat=\"presta in parutionctrl.presta.listePrestataire | orderBy:[\'ordre\']\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: presta.checked}\" ng-model=presta.checked uib-btn-checkbox ng-change=parutionctrl.modifPrestataire(presta)><span ng-if=presta.hasImg class=parution-img><img ng-src={{::presta.imgSrc}} alt={{::presta.nom}} class=img-responsive> </span><span ng-if=(!presta.hasImg) class=parution-nom>{{::presta.nom}}</span></button></div></div>");
$templateCache.put("app/components/main-content/modif-bien/photo/photo.html","<div class=\"form-horizontal col-xs-12 listephoto spacer-bottom\"><div class=col-xs-12><uib-accordion close-others=true><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 text-center spacer-bottom\" ng-if=\"photoctrl.transac === \'Transaction\' && photoctrl.citya\"><a target=_blank ng-href={{photoctrl.rhinovURL}} class=\"btn-custom btn-custom-secondary btn-custom-sm\">Demander un projet de r&eacute;novation</a></div><div uib-accordion-group is-open=photoctrl.upload.open><uib-accordion-heading><i class=\"fa fa-fw\" ng-click=\"photoctrl.upload.open=!photoctrl.upload.open\" ng-class=\"{\'fa-minus\': photoctrl.upload.open, \'fa-plus\': !photoctrl.upload.open}\"></i> Ajouter des photos</uib-accordion-heading><div class=\"col-xs-12 spacer-bottom\"><input type=file nv-file-select multiple uploader=photoctrl.uploader><div nv-file-over uploader=photoctrl.uploader></div></div><table class=table><thead><tr><th width=50%>Nom</th><th ng-show=photoctrl.uploader.isHTML5>Taille</th><th ng-show=photoctrl.uploader.isHTML5>Progression</th><th>Statut</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in photoctrl.uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=photoctrl.uploader.isHTML5 nowrap>{{ item.file.size/1024/1024|number:2 }} MO</td><td ng-show=photoctrl.uploader.isHTML5><div class=progress style=\"margin-bottom: 0\"><div class=progress-bar role=progressbar ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td class=text-center><span ng-show=item.isSuccess><i class=\"fa fa-check-circle\"></i> </span><span ng-show=item.isCancel><i class=\"fa fa-ban\"></i> </span><span ng-show=item.isError><i class=\"fa fa-remove\"></i></span></td><td nowrap><button type=button class=\"btn btn-danger btn-xs\" ng-click=item.remove()><span class=\"fa fa-trash\"></span> Supprimer</button></td></tr></tbody></table><div><div>Progression:<div class=progress><div class=progress-bar role=progressbar ng-style=\"{ \'width\': photoctrl.uploader.progress + \'%\' }\"></div></div></div><button type=button class=\"btn btn-success btn-s\" ng-click=photoctrl.uploader.uploadAll() ng-disabled=!photoctrl.uploader.getNotUploadedItems().length><span class=\"fa fa-upload\"></span> Envoyer</button> <button type=button class=\"btn btn-warning btn-s\" ng-click=photoctrl.uploader.cancelAll() ng-disabled=!photoctrl.uploader.isUploading><span class=\"fa fa-ban\"></span> Annuler</button> <button type=button class=\"btn btn-danger btn-s\" ng-click=photoctrl.uploader.clearQueue() ng-disabled=!photoctrl.uploader.queue.length><span class=\"fa fa-trash\"></span> Supprimer Tout</button></div></div></div></uib-accordion></div><div class=photos-list ui-sortable=photoctrl.sortableOptions ng-model=photoctrl.lot.multimedia><div class=\"col-xs-12 col-sm-6 col-md-3 photo-container\" ng-repeat=\"photo in photoctrl.lot.multimedia | orderBy: \'ordre\'\"><div class=row><div class=photo><button type=button class=\"photo-control-btn btn-remove-photo\" ng-click=photoctrl.removePhoto(photo)><i class=\"fa fa-fw fa-2r fa-trash\" tooltip-placement=\"auto top\" uib-tooltip=\"Supprimer la photo\"></i></button> <button type=button class=\"photo-control-btn rotation-left\" ng-click=\"photoctrl.rotationPhoto(photo, false)\"><i class=\"fa fa-fw fa-2r fa-rotate-left\" tooltip-placement=\"auto top\" uib-tooltip=\"Rotation 90° à gauche\"></i></button> <button type=button class=\"photo-control-btn rotation-right\" ng-click=\"photoctrl.rotationPhoto(photo, true)\"><i class=\"fa fa-fw fa-2r fa-rotate-right\" tooltip-placement=\"auto top\" uib-tooltip=\"Rotation 90° à droite\"></i></button> <button ng-disabled=$first type=button class=\"photo-control-btn ordre-left\" ng-click=photoctrl.decOrdre(photo)><i class=\"fa fa-fw fa-2r fa-chevron-left\" tooltip-placement=\"auto top\" uib-tooltip=\"Décaler la photo\"></i></button> <button ng-disabled=$last type=button class=\"photo-control-btn ordre-right\" ng-click=photoctrl.incOrdre(photo)><i class=\"fa fa-fw fa-2r fa-chevron-right\" tooltip-placement=\"auto top\" uib-tooltip=\"Décaler la photo\"></i></button> <button type=button class=\"photo-control-btn btn-fullscreen\" ng-click=photoctrl.fullscreenMode($index)><i class=\"fa fa-fw fa-2r fa-window-maximize\" tooltip-placement=\"auto top\" uib-tooltip=\"Voir en taille réelle\"></i></button> <img ng-src=\"{{photoctrl.src}}/{{photoctrl.lot.id}}/{{photo.fileName}}{{photo.noCacheValue || \'\'}}\" class=\"img-responsive center-block\"></div></div><div class=row><div class=col-xs-8><ui-select ng-model=photo.bandeau theme=bootstrap close-on-select=true on-select=photoctrl.setBandeau(photo)><ui-select-match placeholder=Bandeau...>{{$select.selected.nom}}</ui-select-match><ui-select-choices repeat=\"bandeau in photoctrl.RefImage | filter: $select.search\"><span ng-bind-html=\"::bandeau.nom | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=col-xs-4><div class=input-group><span class=\"input-group-addon bg-custom-primary\"><i class=\"fa fa-sort-numeric-asc\"></i><label class=sr-only for=photo-ordre>Ordre</label></span><input custom-type=number id=photo-ordre class=form-control min=1 max={{photoctrl.lot.multimedia.length}} ng-model=photo.ordre ng-change=\"photoctrl.reOrderAll(photo, \'{{photo.ordre}}\')\"></div></div></div><div class=\"flex-container-column-multiple flex-justify-between\"><div class=\"flex-item checkbox\"><label for=panorama><input type=checkbox id=panorama ng-model=photo.panorama> Vitrine</label></div><div class=\"flex-item checkbox\"><label for=siteInternet><input type=checkbox id=siteInternet ng-model=photo.siteInternet> Site Perso</label></div><div class=\"flex-item checkbox\"><label for=photoPublicite><input type=checkbox id=photoPublicite ng-model=photo.publicite> Prestataire</label></div></div><div class=row><div class=col-xs-12><div class=input-group><span class=\"input-group-addon bg-custom-primary\"><i class=\"fa fa-comment\"></i><label class=sr-only for=photo-commentaire>Commentaire</label></span><input type=text id=photo-commentaire ng-model=photo.commentaire class=form-control></div></div></div></div></div></div>");
$templateCache.put("app/components/main-content/modif-prospect/criteres-prospect/criteres-prospect.html","<div class=criteres-prospect><uib-accordion close-others=false><!-- Ville(s) --><div class=\"col-xs-12 col-sm-6 col-md-4\"><div uib-accordion-group is-open=criteresprospectctrl.villes.open><uib-accordion-heading>Localisation <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': criteresprospectctrl.villes.open, \'fa-chevron-down\': !criteresprospectctrl.villes.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple ng-model=criteresprospectctrl.villes.selected theme=bootstrap close-on-select=false on-select=::criteresprospectctrl.villes.setVilles() on-remove=::criteresprospectctrl.villes.setVilles()><ui-select-match placeholder=Ville(s)...>{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"ville in criteresprospectctrl.villes.list\" refresh=criteresprospectctrl.villes.getVilles($select.search) refresh-delay=500><div ng-bind-html=\"::ville.nom | highlight: $select.search\"></div><small>{{::ville.codePostal}}</small></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=criteresprospectctrl.villes.selected.length ng-click=\"criteresprospectctrl.villes.selected = []; criteresprospectctrl.villes.setVilles()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div><!-- Type(s) de bien --><div class=\"col-xs-12 col-sm-6 col-md-4\"><div uib-accordion-group is-open=criteresprospectctrl.types.open><uib-accordion-heading>Type(s) de bien <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': criteresprospectctrl.types.open, \'fa-chevron-down\': !criteresprospectctrl.types.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=input-group><div class=\"col-xxs-12 col-xs-6 col-md-12 col-lg-6 col-xl-4\" sly-repeat=\"type in criteresprospectctrl.types.list\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=type.checked uib-btn-checkbox btn-checkbox-false=null ng-click=::criteresprospectctrl.types.toggleType() name=typesBien ng-required=criteresprospectctrl.types.required ng-class=\"{\'checked\': type.checked}\">{{::type.label}}</button></div></div></div></div></div><!-- Prix --><div class=\"col-xs-12 col-sm-6 col-md-4\"><div uib-accordion-group is-open=criteresprospectctrl.prix.open><uib-accordion-heading><span ng-bind-html=criteresprospectctrl.prix.getLabel()></span> <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': criteresprospectctrl.prix.open, \'fa-chevron-down\': !criteresprospectctrl.prix.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=number class=\"form-control border-rounded\" placeholder=\"Prix min\" name=prixMin ng-model=criteresprospectctrl.prospect.prixMin min=1 ng-change=::criteresprospectctrl.prix.onChange() ng-required=\"criteresprospectctrl.prix.required && !criteresprospectctrl.prospect.prixMax\"> <span class=input-group-addon>et </span><input custom-type=number class=\"form-control border-rounded\" placeholder=\"Prix max\" name=prixMax ng-model=criteresprospectctrl.prospect.prixMax min=1 ng-change=::criteresprospectctrl.prix.onChange() ng-required=\"criteresprospectctrl.prix.required && !criteresprospectctrl.prospect.prixMin\"> <span class=input-group-addon><i class=\"fa fa-fw fa-euro\"></i></span></div></div></div></div><!-- Critères supplémentaire --><div class=col-xs-12 ng-if=criteresprospectctrl.criteresSupp.show><div uib-accordion-group is-open=criteresprospectctrl.criteresSupp.open><uib-accordion-heading>Crit&egrave;res sp&eacute;cifiques <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': criteresprospectctrl.criteresSupp.open, \'fa-chevron-down\': !criteresprospectctrl.criteresSupp.open}\"></i></uib-accordion-heading><div class=\"criteres-supp-container row\"><uib-accordion close-others=false><div ng-repeat=\"critere in criteresprospectctrl.criteresSupp.list | orderBy: criteresprospectctrl.orderByArray\"><!--<div ng-if=\"$index % 3 === 0\" class=\"clearfix\"></div>--><div ng-switch=critere.type class=\"col-xs-12 col-sm-6 col-md-4\"><!-- Int --><div ng-switch-when=int class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.intMin || critere.intMax\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=integer class=\"form-control border-rounded\" title=min ng-model=critere.intMin ng-change=::criteresprospectctrl.criteresSupp.setCriteres()> <span class=input-group-addon>et </span><input custom-type=integer class=\"form-control border-rounded\" title=max ng-model=critere.intMax ng-change=::criteresprospectctrl.criteresSupp.setCriteres()> <span class=input-group-addon ng-if=\"::critere.unite !== \'\'\">{{::critere.unite}}</span></div></div></div></div><!-- Float --><div ng-switch-when=float class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.floatMin || critere.floatMax\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=number class=\"form-control border-rounded\" title=min ng-model=critere.floatMin ng-change=::criteresprospectctrl.criteresSupp.setCriteres()> <span class=input-group-addon>et </span><input custom-type=number class=\"form-control border-rounded\" title=max ng-model=critere.floatMax ng-change=::criteresprospectctrl.criteresSupp.setCriteres()> <span class=input-group-addon ng-if=\"::critere.unite !== \'\'\">{{::critere.unite}}</span></div></div></div></div><!-- Date --><div ng-switch-when=date class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=critere.date class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control ng-model=critere.dateMin> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"critere.datepickerMinOpen = !critere.datepickerMinOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=critere.datepickerMinOpen class=\"event-datepicker row\" ng-click=\"critere.datepickerMinOpen = false\"><datetime-picker click-prevent time-picker=false date-model=critere.dateMin on-close=\"critere.datepickerMinOpen = false\"></datetime-picker></div><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control ng-model=critere.dateMax> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"critere.datepickerMaxOpen = !critere.datepickerMaxOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=critere.datepickerMaxOpen class=\"event-datepicker row\" ng-click=\"critere.datepickerMaxOpen = false\"><datetime-picker click-prevent time-picker=false date-model=critere.dateMax on-close=\"critere.datepickerMaxOpen = false\"></datetime-picker></div></div></div></div><!-- Boolean --><div ng-switch-when=boolean class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.bool !== null && critere.bool !== \'undefined\'\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-class=\"{checked: critere.bool}\" ng-click=\"critere.bool = true; criteresprospectctrl.criteresSupp.setCriteres()\"><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-class=\"{checked: critere.bool === false}\" ng-click=\"critere.bool = false; criteresprospectctrl.criteresSupp.setCriteres()\"><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: critere.bool === null}\" ng-click=\"critere.bool = null; criteresprospectctrl.criteresSupp.setCriteres()\">Indiff&eacute;rent</button></div></div></div><!-- Combo (reference) --><div ng-switch-when=combo class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=sbcriteresctrl.references.checked[critere.classeValeursName].length class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple theme=bootstrap close-on-select=false ng-model=criteresprospectctrl.references.checked[critere.classeValeursName] on-select=criteresprospectctrl.criteresSupp.setCriteres() on-remove=criteresprospectctrl.criteresSupp.setCriteres()><ui-select-match placeholder={{critere.nom}}...>{{$item.label}}</ui-select-match><ui-select-choices repeat=\"reference in criteresprospectctrl.references.list[critere.classeValeursName]\">{{reference.label}}</ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=criteresprospectctrl.references.checked[critere.classeValeursName].length ng-click=\"criteresprospectctrl.references.checked[critere.classeValeursName] = []; criteresprospectctrl.criteresSupp.setCriteres()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div></div><div ng-if=\"($index + 1) % 2 === 0\" class=clearfix-sm></div><div ng-if=\"($index + 1) % 3 === 0\" class=\"clearfix-md clearfix-lg clearfix-xl\"></div></div></uib-accordion></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-prospect/etat-prospect/etat-prospect.html","<div ng-if=!etatprospectctrl.loading class=\"etat-prospect col-xs-12\"><div class=row><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=avancement class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Stade de recherche</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><ui-select id=avancement ng-model=etatprospectctrl.prospect.avancement theme=bootstrap close-on-select=true><ui-select-match placeholder=État...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"etat in etatprospectctrl.references.RefAvancementProspect | filter: $select.search track by etat.data\"><span ng-bind-html=\"::etat.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=qualification class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Qualification</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=qualification ng-model=etatprospectctrl.prospect.qualification theme=bootstrap close-on-select=true><ui-select-match placeholder=Qualification...>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"qualification in etatprospectctrl.references.RefQualification | filter: $select.search track by qualification.id\"><span ng-bind-html=\"::qualification.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><!-- <ui-select id=\"societe\" ng-model=\"etatprospectctrl.societes.societe\" theme=\"bootstrap\" close-on-select=\"true\" on-select=\"etatprospectctrl.societes.changed()\"\r\n          on-remove=\"etatprospectctrl.societes.changed()\">\r\n          <ui-select-match placeholder=\"Société...\">\r\n            {{$select.selected.nom}}\r\n          </ui-select-match>\r\n          <ui-select-choices repeat=\"societe in etatprospectctrl.societes.list | filter: $select.search track by societe.id\" refresh=\"etatprospectctrl.societes.search($select.search)\"\r\n            refresh-delay=\"350\">\r\n            <span ng-bind-html=\"::societe.nom | highlight: $select.search\"></span>\r\n          </ui-select-choices>\r\n        </ui-select> --><r-select ng-model=etatprospectctrl.societes.societe rs-options=etatprospectctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\" rs-on-change=etatprospectctrl.societes.changed()></r-select></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">N&eacute;go.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=nego ng-model=etatprospectctrl.negos.nego theme=bootstrap close-on-select=true on-select=etatprospectctrl.negos.changed() on-remove=etatprospectctrl.negos.changed() required><ui-select-match placeholder=Négo...>{{$select.selected.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in etatprospectctrl.negos.list | filter: $select.search track by nego.id\" refresh=etatprospectctrl.negos.search($select.search) refresh-delay=350><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=dateEntree class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&apos;entr&eacute;e</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><!-- <div class=\"input-group\"> --> <input id=dateEntree custom-type=date ui-mask=99/99/9999 class=form-control ng-model=etatprospectctrl.prospect.dateEntree disabled><!-- <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\"\r\n                ng-click=\"etatprospectctrl.datepickers.dateEntree.open = !etatprospectctrl.datepickers.dateEntree.open\">\r\n							<i class=\"fa fa-fw fa-calendar\"></i>\r\n					</span> --><!-- </div> --><!-- <div ng-if=\"etatprospectctrl.datepickers.dateEntree.open\" class=\"event-datepicker row\"\r\n             ng-click=\"::etatprospectctrl.datepickers.dateEntree.onClose(\'dateEntree\')\">\r\n          <datetime-picker click-prevent time-picker=\"false\"\r\n                           date-model=\"etatprospectctrl.prospect.dateEntree\"\r\n                           on-close=\"::etatprospectctrl.datepickers.dateEntree.onClose(\'dateEntree\')\"></datetime-picker>\r\n        </div> --></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=origine class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Origine</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=origine ng-model=etatprospectctrl.prospect.origine theme=bootstrap close-on-select=true ng-required=etatprospectctrl.citya><ui-select-match placeholder=Origine...>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"origine in etatprospectctrl.references.RefOrigineClient | filter: $select.search track by origine.id\"><span ng-bind-html=\"::origine.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=dateDernierContact class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date dernier contact</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateDernierContact custom-type=date ui-mask=99/99/9999 class=form-control ng-model=etatprospectctrl.prospect.dateDernierContact> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"etatprospectctrl.datepickers.dateDernierContact.open = !etatprospectctrl.datepickers.dateDernierContact.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=etatprospectctrl.datepickers.dateDernierContact.open class=\"event-datepicker row\" ng-click=\"::etatprospectctrl.datepickers.dateDernierContact.onClose(\'dateDernierContact\')\"><datetime-picker click-prevent time-picker=false date-model=etatprospectctrl.prospect.dateDernierContact on-close=\"::etatprospectctrl.datepickers.dateDernierContact.onClose(\'dateDernierContact\')\"></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=dateProchainContact class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Date de relance</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateProchainContact custom-type=date ui-mask=99/99/9999 class=form-control ng-model=etatprospectctrl.prospect.dateProchainContact> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"etatprospectctrl.datepickers.dateEcheance.open = !etatprospectctrl.datepickers.dateEcheance.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=etatprospectctrl.datepickers.dateEcheance.open class=\"event-datepicker row\" ng-click=\"::etatprospectctrl.datepickers.dateEcheance.onClose(\'fin\')\"><datetime-picker click-prevent model=etatprospectctrl.prospect.dateEcheance time-picker=false date-model=etatprospectctrl.prospect.dateProchainContact on-close=\"::etatprospectctrl.datepickers.dateEcheance.onClose(\'fin\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=dateFin class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&apos;&eacute;ch&eacute;ance</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateFin custom-type=date ui-mask=99/99/9999 class=form-control ng-model=etatprospectctrl.prospect.dateFin> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"etatprospectctrl.datepickers.dateFin.open = !etatprospectctrl.datepickers.dateFin.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=etatprospectctrl.datepickers.dateFin.open class=\"event-datepicker row\" ng-click=\"::etatprospectctrl.datepickers.dateFin.onClose(\'dateFin\')\"><datetime-picker click-prevent model=etatprospectctrl.prospect.dateFin time-picker=false date-model=etatprospectctrl.prospect.dateFin on-close=\"::etatprospectctrl.datepickers.dateFin.onClose(\'dateFin\')\"></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom no-padding\"><label for=archive class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Archiv&eacute;</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=archive name=archive class=\"checkbox form-control\" ng-model=etatprospectctrl.prospect.archive></div></div></div><div class=row ng-if=etatprospectctrl.citya><div class=\"col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-2 col-md-6\"><label class=no-padding-left>Accepte de recevoir des offres commerciales de la part de CITYA et des filiales de CITYA :</label></div><div class=\"col-xs-12 spacer-bottom no-padding\"><div class=\"col-xs-12 col-sm-offset-3 col-sm-6 col-md-offset-2 col-md-6 spacer-bottom\"><label for=demarchageCommercial class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercial name=demarchageCommercial class=\"checkbox form-control\" ng-model=etatprospectctrl.prospect.demarchageCommercial> <span class=checkbox-addon>Par email</span></label><label for=demarchageCommercialSms class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialSms name=demarchageCommercialSms class=\"checkbox form-control\" ng-model=etatprospectctrl.prospect.demarchageCommercialSms> <span class=checkbox-addon>Par sms</span></label><label for=demarchageCommercialCourrier class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialCourrier name=demarchageCommercialCourrier class=\"checkbox form-control\" ng-model=etatprospectctrl.prospect.demarchageCommercialCourrier> <span class=checkbox-addon>Par courrier</span></label><label for=demarchageCommercialTelephonique class=\"control-label no-padding-left checkbox-group\"><input type=checkbox id=demarchageCommercialTelephonique name=demarchageCommercialTelephonique class=\"checkbox form-control\" ng-model=etatprospectctrl.prospect.demarchageCommercialTelephonique> <span class=checkbox-addon>Par t&eactue;l&eactue;phone</span></label></div></div></div><div class=row><div class=\"col-xs-12 spacer-bottom no-padding\"><label for=commentaire class=\"col-xs-12 col-sm-3 col-md-2 control-label no-padding-left\">Commentaire</label><div class=\"col-xs-12 col-sm-6 col-md-8 spacer-bottom\"><textarea id=commentaire class=form-control ng-model=etatprospectctrl.prospect.commentaire rows=5></textarea></div></div></div></div>");
$templateCache.put("app/components/main-content/modif-prospect/prospect-panier/prospect-panier.html","<div ng-if=!prospectpanierctrl.loading class=prospect-panier><div class=\"panier-display flex-container\"><div class=\"panier-list row flex-item\"><div class=panier-controls><div class=\"col-xs-12 text-right\"><div class=\"btn-group controls-action\" uib-dropdown ng-if=prospectpanierctrl.panier.nb><span class=\"dropdown btn-custom btn-custom-lighten-secondary btn-custom-fa-stacked\" uib-dropdown-toggle><i class=\"fa fa-2r fa-file-text-o fa-flip-vertical\"></i> <i class=\"fa fa-custom-stacked fa-search\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::prospectpanierctrl.onEvent(null)><i class=\"fa fa-fw fa-calendar\"></i> <u>R</u>endez-vous</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::prospectpanierctrl.bonVisite.generer()><i class=\"fa fa-fw fa-file-o\"></i> <u>B</u>on de visite</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::prospectpanierctrl.selectAll()><i class=\"fa fa-fw\" ng-class=\"{\'fa-window-close-o\': prospectpanierctrl.allSelected, \'fa-check-square-o\': !prospectpanierctrl.allSelected}\"></i> <span ng-if=!prospectpanierctrl.allSelected><u>T</u>out s&eacute;lectionner</span> <span ng-if=prospectpanierctrl.allSelected><u>T</u>out d&eacute;s&eacute;lectionner</span></button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::prospectpanierctrl.envoyerEmail()><i class=\"fa fa-fw fa-envelope\"></i> <u>E</u>nvoyer tout</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=::prospectpanierctrl.imprimer()><i class=\"fa fa-fw fa-print\"></i> <u>I</u>mprimer</button></li><li class=divider></li><li role=menuitem class=custom-block><button type=button class=\"controls-action-btn controls-action-danger-btn\" ng-click=::prospectpanierctrl.panier.supprAllBien()><i class=\"fa fa-fw fa-trash-o\"></i> <u>V</u>ider le panier</button></li></ul></div></div></div><div class=\"col-xs-12 text-center\" ng-if=!prospectpanierctrl.panier.nb><div class=\"col-xs-12 text-center\"><span class=panier-no-result>Aucun bien dans le panier</span></div><button class=\"btn-custom btn-custom-primary\" ng-click=::prospectpanierctrl.ajouterDesBiens()><i class=\"fa fa-fw fa-search\"></i> Chercher plus de biens</button></div><div class=bien-container ng-if=prospectpanierctrl.panier.nb><div class=\"col-xs-12 text-center\"><span class=panier-nb>{{prospectpanierctrl.panier.nb}} bien{{prospectpanierctrl.panier.nb > 1 ? \'s\' : \'\'}}</span></div><bloc-bien ng-repeat=\"bien in prospectpanierctrl.panier.list\" bien=bien.lot class=\"col-xs-12 panier-bien\" template=\"\'panier\'\" on-supprimer=prospectpanierctrl.panier.supprBien(refLot) on-email=prospectpanierctrl.envoyerEmail(refLot) on-event=\"prospectpanierctrl.onEvent(refLot, event)\" event-actif=bien.evenement on-toggle-fiche=prospectpanierctrl.showFiche(refLot) on-contrat=::prospectpanierctrl.newContrat(refLot) on-selection=\"::prospectpanierctrl.toggleSelection(refLot, idLot, selected)\" on-retirer-selection=\"::prospectpanierctrl.retirerSelection(refLot, idLot)\"></bloc-bien></div></div></div><div ng-if=prospectpanierctrl.evenement.open class=event-datepicker ng-class=\"{\'full-screen\': prospectpanierctrl.evenement.fullScreen}\"><div class=event-panel-container><div class=\"container-fluid no-padding event-calendar-container\" lazy-load><div class=no-padding ng-class=\"{\r\n               \'col-lg-12\': !prospectpanierctrl.evenement.fullScreen,\r\n               \'col-lg-6 col-xl-5\': prospectpanierctrl.evenement.fullScreen\r\n             }\"><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><datetime-picker model=prospectpanierctrl.calendar.date model-fin=prospectpanierctrl.calendar.dateFin time-picker=true time-range=true is-supprimable=false ng-if=!prospectpanierctrl.calendar.reloading nouveau-active=prospectpanierctrl.evenement.nouveau on-nouveau=\"prospectpanierctrl.evenement.onNouveau(date, dateFin)\" on-annuler=prospectpanierctrl.evenement.onAnnuler() on-chose=\"prospectpanierctrl.evenement.onChose(date, dateFin)\" on-close=::prospectpanierctrl.evenement.onClose() on-full-screen=::prospectpanierctrl.evenement.onFullScreen(fullScreen) on-select-societes=::panierctrl.evenement.onSelectSocietes(societes) on-select-nego=::panierctrl.evenement.onSelectNego(nego)></datetime-picker></div><div class=\"col-xs-12 col-sm-6 spacer-top\"><mwl-calendar events=prospectpanierctrl.calendar.events view=prospectpanierctrl.calendar.view view-date=prospectpanierctrl.calendar.viewDate view-title=prospectpanierctrl.calendar.title day-view-start=06:00 day-view-end=23:00 day-view-split=60 day-view-event-width=225 on-timespan-click=prospectpanierctrl.calendar.onClick(calendarDate)></mwl-calendar></div></div><div class=\"col-xs-12 col-lg-6 col-xl-7 no-padding\" ng-if=prospectpanierctrl.evenement.fullScreen><div class=tgn-calendar-container><tgn-calendar read-only=true></tgn-calendar></div></div></div></div></div></div>");
$templateCache.put("app/components/main-content/panneaux/bloc-panneau/bloc-panneau.html","<div class=bloc-panneau><div ng-include=blocpanneauctrl.templateFile class=panneau></div></div>");
$templateCache.put("app/components/main-content/modif-reservation/info-bail/info-bail.html","<div class=\"info-bail row\" ng-if=!infobailctrl.isLoading><div class=\"elements-bail col-xs-12 col-md-6\"><div class=row><label for=idbail class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">N° Bail</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input type=text class=form-control id=idbail name=idbail ng-model=infobailctrl.reservation.infoBail.idbail ng-disabled=!infobailctrl.employe.profileTrans.adminProfile></div></div><div class=row><label for=datePriseEffet class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">A pris effet le</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 ng-change=infobailctrl.changeFinPrevu() class=form-control id=datePriseEffet name=datePriseEffet ng-model=infobailctrl.reservation.infoBail.datePriseEffet ng-disabled=infobailctrl.disabled> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"infobailctrl.datepickers.datePriseEffet = !infobailctrl.datepickers.datePriseEffet && !infobailctrl.disabled\" ng-class=\"{\'disabled\': infobailctrl.disabled}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=infobailctrl.datepickers.datePriseEffet class=\"event-datepicker row\" ng-click=\"infobailctrl.datepickers.datePriseEffet = false\"><datetime-picker click-prevent time-picker=false on-close=\"infobailctrl.datepickers.close(\'datePriseEffet\')\" on-chose=infobailctrl.setDefaultFinPrevu() date-model=infobailctrl.reservation.infoBail.datePriseEffet></datetime-picker></div></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Type de bail</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select ng-model=infobailctrl.reservation.infoBail.typeBaux ng-change=infobailctrl.changeFinPrevu() theme=bootstrap close-on-select=true ng-disabled=infobailctrl.disabled><ui-select-match placeholder=\"Type de bail...\">{{$select.selected.codeBail}} - {{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"type in infobailctrl.typeBaux | filter: $select.search track by type.id\"><span>{{::type.codeBail}} - </span><span ng-bind-html=\"type.type | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">P&eacute;riode</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><ui-select ng-model=infobailctrl.reservation.infoBail.periode theme=bootstrap close-on-select=true ng-disabled=infobailctrl.disabled><ui-select-match placeholder=Période...>{{$select.selected.code}} - {{$select.selected.libelle}}</ui-select-match><ui-select-choices repeat=\"periode in infobailctrl.periodicite | filter: $select.search track by periode.id\"><span>{{::periode.code}} - </span><span ng-bind-html=\"periode.libelle | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Dur&eacute;e particuli&egrave;re</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=number min=0 class=\"form-control border-rounded\" ng-change=infobailctrl.changeFinPrevu() placeholder=0 ng-model=infobailctrl.reservation.infoBail.dureeParticulierBail.mm ng-disabled=infobailctrl.disabled> <span class=input-group-addon>(Mois)</span> <input custom-type=number min=0 class=\"form-control border-rounded\" ng-change=infobailctrl.changeFinPrevu() placeholder=0 ng-model=infobailctrl.reservation.infoBail.dureeParticulierBail.aa ng-disabled=infobailctrl.disabled> <span class=input-group-addon>(Ans)</span></div></div></div><div class=row><label for=finPrevue class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Fin pr&eacute;vue</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control id=finPrevue name=finPrevue ng-model=infobailctrl.reservation.infoBail.finPrevue ng-disabled=infobailctrl.disabled> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"infobailctrl.datepickers.finPrevue = !infobailctrl.datepickers.finPrevue && !infobailctrl.disabled\" ng-class=\"{\'disabled\': infobailctrl.disabled}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=infobailctrl.datepickers.finPrevue class=\"event-datepicker row\" ng-click=\"infobailctrl.datepickers.finPrevue = false\"><datetime-picker click-prevent time-picker=false on-close=\"infobailctrl.datepickers.close(\'finPrevue\')\" date-model=infobailctrl.reservation.infoBail.finPrevue></datetime-picker></div></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Dur&eacute;e particuli&egrave;re de renouvellement</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=number min=0 class=\"form-control border-rounded\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.dureeParticulierBail2.mm ng-disabled=infobailctrl.disabled> <span class=input-group-addon>(Mois)</span> <input custom-type=number min=0 class=\"form-control border-rounded\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.dureeParticulierBail2.aa ng-disabled=infobailctrl.disabled> <span class=input-group-addon>(Ans)</span></div></div></div><div class=row ng-if=!infobailctrl.citya><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Type r&eacute;vision</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.typeRevision ng-disabled=infobailctrl.disabled></div></div><div class=row ng-if=!infobailctrl.citya><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Cycle part.</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.cycleParticulier ng-disabled=infobailctrl.disabled></div></div><div class=row ng-if=!infobailctrl.citya><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">% de r&eacute;vision</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.pourcentageRevison ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Indice de base</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><ui-select ng-model=infobailctrl.reservation.infoBail.indiceBase theme=bootstrap close-on-select=true class=border-right-rounded ng-disabled=infobailctrl.disabled><ui-select-match placeholder=Indice... allow-clear=true>{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"indice in infobailctrl.indice | filter: $select.search track by indice.id\"><div ng-bind-html=\"::indice.type | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=input-group-addon>Valeur ind. : {{infobailctrl.reservation.infoBail.indiceBase.indice2 || infobailctrl.reservation.infoBail.indiceBase.indice1}}</span></div></div></div><div class=row ng-if=!infobailctrl.citya><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Forfait</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.forfait ng-disabled=infobailctrl.disabled></div></div><div class=row ng-if=!infobailctrl.citya><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Jusqu&apos;en</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.jusquen ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Loyer principal HT</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.loyerPrinc ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Provision/Charges</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.provisionCharge ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Provision/Taxes OM</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.provisionAutre ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">D&eacute;pot de garantie</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><input custom-type=number min=0 class=form-control placeholder=0 ng-model=infobailctrl.reservation.infoBail.depotGarantie ng-disabled=infobailctrl.disabled></div></div><div class=row><label for=dateEntree class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date d&apos;entr&eacute;e</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control id=dateEntree name=dateEntree ng-model=infobailctrl.reservation.infoBail.dateEntree ng-disabled=infobailctrl.disabled> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"infobailctrl.datepickers.dateEntree = !infobailctrl.datepickers.dateEntree && !infobailctrl.disabled\" ng-class=\"{\'disabled\': infobailctrl.disabled}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=infobailctrl.datepickers.dateEntree class=\"event-datepicker row\" ng-click=\"infobailctrl.datepickers.dateEntree = false\"><datetime-picker click-prevent time-picker=false on-close=\"infobailctrl.datepickers.close(\'dateEntree\')\" date-model=infobailctrl.reservation.infoBail.dateEntree></datetime-picker></div></div></div><div class=row><label for=appelLoyer class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">D&eacute;but appel loyer</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control id=appelLoyer name=appelLoyer ng-model=infobailctrl.reservation.infoBail.appelLoyer ng-disabled=infobailctrl.disabled> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"infobailctrl.datepickers.appelLoyer = !infobailctrl.datepickers.appelLoyer && !infobailctrl.disabled\" ng-class=\"{\'disabled\': infobailctrl.disabled}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=infobailctrl.datepickers.appelLoyer class=\"event-datepicker row\" ng-click=\"infobailctrl.datepickers.appelLoyer = false\"><datetime-picker click-prevent time-picker=false on-close=\"infobailctrl.datepickers.close(\'appelLoyer\')\" date-model=infobailctrl.reservation.infoBail.appelLoyer></datetime-picker></div></div></div><div class=row><label for=appelProvision class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">D&eacute;but appel prov.</label><div class=\"col-xs-12 col-sm-9 col-md-6 spacer-bottom\"><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control id=appelProvision name=appelProvision ng-model=infobailctrl.reservation.infoBail.appelProvision ng-disabled=infobailctrl.disabled> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"infobailctrl.datepickers.appelProvision = !infobailctrl.datepickers.appelProvision && !infobailctrl.disabled\" ng-class=\"{\'disabled\': infobailctrl.disabled}\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=infobailctrl.datepickers.appelProvision class=\"event-datepicker row\" ng-click=\"infobailctrl.datepickers.appelProvision = false\"><datetime-picker click-prevent time-picker=false on-close=\"infobailctrl.datepickers.close(\'appelProvision\')\" date-model=infobailctrl.reservation.infoBail.appelProvision></datetime-picker></div></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">MRH</label><div class=\"col-xs-12 col-sm-9 col-md-6 col-lg-2 spacer-bottom\"><input type=checkbox class=\"checkbox form-control\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.prendMRH></div><label class=\"col-xs-12 col-sm-3 col-md-4 col-lg-2 control-label no-padding-left\">Hors place</label><div class=\"col-xs-12 col-sm-9 col-md-6 col-lg-2 spacer-bottom\"><input type=checkbox class=\"checkbox form-control\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.horsPlace ng-disabled=infobailctrl.disabled></div></div><div class=row><label class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">PrestaLoc carte</label><div class=\"col-xs-12 col-sm-9 col-md-6 col-lg-2 spacer-bottom\"><input type=checkbox class=\"checkbox form-control\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.prendEASYLocCarte ng-disabled=infobailctrl.disabled></div><label class=\"col-xs-12 col-sm-3 col-md-4 col-lg-2 control-label no-padding-left\">PrestaLoc forfait</label><div class=\"col-xs-12 col-sm-9 col-md-6 col-lg-2 spacer-bottom\"><input type=checkbox class=\"checkbox form-control\" placeholder=0 ng-model=infobailctrl.reservation.infoBail.prendEASYLocForfait ng-disabled=infobailctrl.disabled></div></div></div><div class=\"gravitants col-xs-12 col-md-4\"><liste-gravitants gravitants=infobailctrl.reservation.infoBail.listeGravitant is-disabled=infobailctrl.disabled></liste-gravitants></div></div>");
$templateCache.put("app/components/main-content/parutions-ics-box/bloc-parution/bloc-parution.html","<div class=bloc-parution><div ng-include=blocparutionctrl.templateFile class=parution></div></div>");
$templateCache.put("app/components/main-content/reservations/bloc-reservation/bloc-reservation.html","<div class=\"bloc-reservation-container col-xs-12\"><div class=archive ng-if=blocreservationctrl.reservation.archive>Archiv&eacute;</div><div class=reservation><div ng-if=blocreservationctrl.ribbon.date class=custom-ribbon ng-class=blocreservationctrl.ribbon.classe><span class=custom-ribbon-content>{{::blocreservationctrl.ribbon.text}}{{::blocreservationctrl.ribbon.date}}</span></div><div class=\"reservation-header row\"><div class=\"reservation-title col-xs-12 col-sm-6\"><h4 class=\"title text-right\">{{::blocreservationctrl.titre}} N&deg;{{::blocreservationctrl.reservation.id}}</h4></div><div class=\"reservation-date col-xs-12 col-sm-6\"><span class=date>{{::blocreservationctrl.reservation.date}}</span></div></div><div ng-if=blocreservationctrl.retourGestion.active class=retour-gestion><button class=\"btn-custom btn-custom-sm\" ng-click=blocreservationctrl.retourGestion.onRetourGestion() tooltip-placement=\"auto top\" uib-tooltip=\"Retour en gestion\" ng-class=\"{\r\n                \'btn-success\': blocreservationctrl.retourGestion.retourne,\r\n                \'btn-danger\': !blocreservationctrl.retourGestion.retourne\r\n              }\"><i class=\"fa fa-fw fa-cloud-upload\"></i></button></div><div class=\"reservation-body row\"><div class=\"reservation-acheteur col-xs-12 col-sm-6\"><div class=vendeur><span class=\"vendeur-libelle col-xs-12 text-center\">Propri&eacute;taire :</span> <span class=\"vendeur-nom col-xs-12 text-center\">{{::blocreservationctrl.reservation.getProprietaireNomComplet()}}</span> <small class=\"vendeur-nego col-xs-12 text-center\" ng-if=::blocreservationctrl.reservation.affaire.mandatLocation.nego>N&eacute;go : <span class=vendeur-nego-value>{{::(blocreservationctrl.reservation.affaire.mandatLocation.nego.perso ? blocreservationctrl.reservation.affaire.mandatLocation.nego.perso.nomComplet : blocreservationctrl.reservation.affaire.mandatLocation.nego.initiales)}}</span></small></div></div><div class=\"reservation-vendeur col-xs-12 col-sm-6\"><div class=acheteur><span class=\"acheteur-libelle col-xs-12 text-center\">Locataire :</span> <span class=\"acheteur-nom col-xs-12 text-center\">{{::blocreservationctrl.reservation.getLocataireNomComplet()}}</span> <small class=\"acheteur-nego col-xs-12 text-center\" ng-if=::blocreservationctrl.reservation.affaire.mandatLocation.nego>N&eacute;go : <span class=acheteur-nego-value>{{::(blocreservationctrl.reservation.locataire.nego.perso ? blocreservationctrl.reservation.locataire.nego.perso.nomComplet : blocreservationctrl.reservation.locataire.nego.initiales)}}</span></small></div></div><div class=btn-voir-container><button class=\"btn-custom btn-custom-primary btn-voir\" ng-click=::blocreservationctrl.showFiche() tooltip-placement=\"auto top\" uib-tooltip=\"Voir la fiche\"><i class=\"fa fa-fw fa-eye\"></i></button></div></div><div class=\"reservation-footer row\"><div class=\"reservation-affaire col-xs-12\"><span class=affaire-libelle>Affaire :</span> <small class=\"affaire-ref pull-right\">Ref : {{blocreservationctrl.reservation.affaire.referenceInterne}}</small></div><p class=\"col-xs-12 reservation-affaire-description\"><span class=affaire-desc>{{::blocreservationctrl.reservation.affaire.getFormatedLibelle()}}</span></p></div></div></div>");
$templateCache.put("app/components/main-content/statistique/statistiquemensuel/statistiquemensuel.html","<div class=\"form-horizontal col-xs-12\"><div class=mensuel><form name=mensuel ng-submit=statistiquemensuelctrl.envoyerStatistique()><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Nom de la statistique</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><ui-select ng-model=statistiquemensuelctrl.typeStatistique theme=bootstrap close-on-select=true required><ui-select-match placeholder=Statistique... allow-clear>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"motif in statistiquemensuelctrl.listeStatistiqueType | filter: $select.search track by motif.label\"><span ng-bind-html=\"::motif.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateDebut class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date debut exercice</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><div class=input-group><input id=dateDebut name=dateDebut custom-type=date ui-mask=99/99/9999 class=form-control ng-model=statistiquemensuelctrl.dateExercice required> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"statistiquemensuelctrl.datepickers.debut.open = !statistiquemensuelctrl.datepickers.debut.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=statistiquemensuelctrl.datepickers.debut.open class=\"event-datepicker row\" ng-click=\"::statistiquemensuelctrl.datepickers.debut.onClose(\'debut\')\"><datetime-picker click-prevent model=statistiquemensuelctrl.dateExercice time-picker=false date-model=statistiquemensuelctrl.dateExercice on-close=\"::statistiquemensuelctrl.datepickers.debut.onClose(\'debut\')\"></datetime-picker></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><r-select ng-model=statistiquemensuelctrl.societes.societe rs-options=statistiquemensuelctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-multiple rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\" rs-on-change=statistiquemensuelctrl.societes.changed()></r-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">N&eacute;go.</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select id=nego ng-model=statistiquemensuelctrl.negos.nego theme=bootstrap close-on-select=true on-select=statistiquemensuelctrl.negos.changed() on-remove=statistiquemensuelctrl.negos.changed()><ui-select-match placeholder=Négo...>{{statistiquemensuelctrl.negos.nego.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in statistiquemensuelctrl.negos.list | filter: $select.search track by nego.id\" refresh=statistiquemensuelctrl.negos.search($select.search) refresh-delay=500><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Envoyer par Mail</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox id=mail name=mail class=\"checkbox form-control\" ng-model=statistiquemensuelctrl.email></div></div></div><div class=row><div class=\"col-xs-12 col-md-6 no-padding\" ng-repeat=\"mois in statistiquemensuelctrl.listeMois\" ng-if=statistiquemensuelctrl.typeStatistique.listeMois><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">{{mois.libelleDate}}</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><input type=checkbox name=mois class=\"checkbox form-control\" ng-model=mois.cocher></div></div><div class=\"col-xs-12 col-md-6 no-padding\" ng-if=statistiquemensuelctrl.typeStatistique.moisFin><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Mois de fin</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=statistiquemensuelctrl.moisFin theme=bootstrap close-on-select=true required><ui-select-match placeholder=\"Mois Fin...\" allow-clear>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"motif in statistiquemensuelctrl.listeMois | filter: $select.search track by motif.label\"><span ng-bind-html=\"::motif.label | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-xs-12 col-md-6 no-padding control-label\"><button type=button class=\"btn-custom btn-custom-primary\" ng-if=statistiquemensuelctrl.typeStatistique.listeMois ng-click=statistiquemensuelctrl.toutSelectionner()><i class=\"fa fa-fw fa-plus\"></i> Tout Sélectionners</button> &nbsp;</div><div class=\"col-xs-12 col-md-6 no-padding\"><button type=submit class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-file-o fa-fw\"></i> Generer</button></div></form></div><div ng-if=statistiquemensuelctrl.loading class=loader></div></div>");
$templateCache.put("app/components/main-content/statistique/tableau-bord/tableau-bord.html","<div class=\"form-horizontal col-xs-12\"><div class=tableauBord><form name=mensuel ng-submit=tableaubordctrl.envoyerStatistique()><div class=\"col-xs-12 col-md-10\"><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dateDebut class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Date debut exercice</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><div class=input-group><input id=dateDebut name=dateDebut custom-type=date ui-mask=99/99/9999 class=form-control ng-model=tableaubordctrl.dateExercice required> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"tableaubordctrl.datepickers.debut.open = !tableaubordctrl.datepickers.debut.open\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=tableaubordctrl.datepickers.debut.open class=\"event-datepicker row\" ng-click=\"::tableaubordctrl.datepickers.debut.onClose(\'debut\')\"><datetime-picker click-prevent model=tableaubordctrl.dateExercice time-picker=false date-model=tableaubordctrl.dateExercice on-close=\"::tableaubordctrl.datepickers.debut.onClose(\'debut\')\"></datetime-picker></div></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Mois</label><div class=\"col-xs-12 col-sm-6 col-md-6 spacer-bottom\"><ui-select ng-model=tableaubordctrl.mois theme=bootstrap close-on-select=true required><ui-select-match placeholder=Mois... allow-clear>{{$select.selected.libelleDate}}</ui-select-match><ui-select-choices repeat=\"motif in tableaubordctrl.listeMois | filter: $select.search track by motif.mois\"><span ng-bind-html=\"::motif.libelleDate | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=societe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">Soci&eacute;t&eacute;</label><div class=\"col-xs-12 col-sm-6 spacer-bottom\"><r-select ng-model=tableaubordctrl.societes.societe rs-options=tableaubordctrl.societes.list rs-labelled-by=\"\'nom\'\" rs-multiple rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé...\'\" rs-on-change=tableaubordctrl.societes.changed()></r-select></div></div><div class=\"col-xs-12 col-md-6 no-padding\"><label for=nego class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">N&eacute;go.</label><div class=\"col-xs-12 col-md-6 spacer-bottom\"><ui-select id=nego ng-model=tableaubordctrl.negos.nego theme=bootstrap close-on-select=true on-select=tableaubordctrl.negos.changed() on-remove=tableaubordctrl.negos.changed()><ui-select-match placeholder=Négo...>{{tableaubordctrl.negos.nego.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in tableaubordctrl.negos.list | filter: $select.search track by nego.id\" refresh=tableaubordctrl.negos.search($select.search) refresh-delay=500><span ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-xs-12 col-md-2\"><div class=\"col-xs-12 col-md-12 no-padding\"><button type=submit class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-file-o fa-fw\"></i> Generer</button></div></div></form></div><div class=tableauResultat><div class=\"col-xs-12 col-md-6 general\"><table ng-if=!!tableaubordctrl.donnee class=\"table table-hover\" wt-responsive-table><tr><th></th><th>Du {{tableaubordctrl.mois.moisDebut}}<br>Au {{tableaubordctrl.mois.moisFin}}</th><th>Du {{tableaubordctrl.mois.moisDebutPrec}}<br>Au {{tableaubordctrl.mois.moisFinPrec}}</th><th>Du {{tableaubordctrl.mois.anneeDebut}}<br>Au {{tableaubordctrl.mois.anneeFin}}</th><th>Du {{tableaubordctrl.mois.anneeDebutPrec}}<br>Au {{tableaubordctrl.mois.anneeFinPrec}}</th></tr><tr><td>{{tableaubordctrl.donnee.caht.label}}</td><td class=text-right>{{tableaubordctrl.donnee.caht.mois | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.caht.moisprec | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.caht.annee | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.caht.anneeprec | number:2}} &euro;</td></tr><tr><td>{{tableaubordctrl.donnee.objectif.label}}</td><td class=text-right>{{tableaubordctrl.donnee.objectif.mois | number:2}} &euro;</td><td class=text-right></td><td class=text-right>{{tableaubordctrl.donnee.objectif.annee | number:2}} &euro;</td><td class=text-right></td></tr><tr><td>{{tableaubordctrl.donnee.casurobjectif.label}}</td><td class=text-right>{{tableaubordctrl.donnee.casurobjectif.mois | number:2}}%</td><td class=text-right></td><td class=text-right>{{tableaubordctrl.donnee.casurobjectif.annee | number:2}}%</td><td class=text-right></td></tr><tr><td>{{tableaubordctrl.donnee.nbtotal.label}}</td><td class=text-right>{{tableaubordctrl.donnee.nbtotal.mois | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbtotal.moisprec | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbtotal.annee | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbtotal.anneeprec | number:2}}</td></tr><tr><td>{{tableaubordctrl.donnee.nbsuppr.label}}</td><td class=text-right>{{tableaubordctrl.donnee.nbsuppr.mois | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbsuppr.moisprec | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbsuppr.annee | number:2}}</td><td class=text-right>{{tableaubordctrl.donnee.nbsuppr.anneeprec | number:2}}</td></tr><tr><td>{{tableaubordctrl.donnee.casuppr.label}}</td><td class=text-right>{{tableaubordctrl.donnee.casuppr.mois | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.casuppr.moisprec | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.casuppr.annee | number:2}} &euro;</td><td class=text-right>{{tableaubordctrl.donnee.casuppr.anneeprec | number:2}} &euro;</td></tr></table></div><div class=\"col-xs-12 col-md-6 graphique\" ng-if=!!tableaubordctrl.donnee><highchart config=tableaubordctrl.chartConfig></highchart></div><div class=\"col-xs-12 detail\"><div class=table-responsive ng-if=!!tableaubordctrl.donnee><div class=row><div class=\"col-xs-12 text-right\"><button type=button ng-csv=tableaubordctrl.getDonnee filename=listeNego.csv field-separator=; class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i>Export nego CSV</button> <button type=button ng-csv=tableaubordctrl.getDetail filename=listeDetail.csv field-separator=; class=\"btn-custom btn-custom-primary\"><i class=\"fa fa-file-excel-o fa-fw\"></i>Export detail CSV</button></div></div><table ng-repeat=\"(key,details) in tableaubordctrl.donnee.details | groupBy:\'groupId\'\" class=\"table table-hover\"><thead><tr><td colspan=13>{{details[0].label2}}</td></tr><tr><th>Négo</th><th>Entrée</th><th>Sortie</th><th>Ca ht Cial du mois</th><th>Ca ht Cial cumulé</th><th>Nbre comm du mois</th><th>Nbre comm cumulé</th><th>Objectif Mensuel</th><th>Objectif Cumulé</th><th>Objectif Annuel</th><th>Moyenne Mensuel</th><th>Ecart Réél/Objectif</th><th></th></tr></thead><tfoot><tr><th>{{details[0].label2}}</th><th></th><th></th><th class=text-right>{{details | sumOfValue:\'caMois\' | number:2}} &euro;</th><th class=text-right>{{details | sumOfValue:\'caAnnee\' | number:2}} &euro;</th><th class=text-right>{{details | sumOfValue:\'nbreCommission\' | number:2}}</th><th class=text-right>{{details | sumOfValue:\'nbreCommissionAnnee\' | number:2}}</th><th class=text-right>{{details | sumOfValue:\'objectif\' | number:2}} &euro;</th><th class=text-right>{{details | sumOfValue:\'objectifCummule\' | number:2}} &euro;</th><th class=text-right>{{details | sumOfValue:\'objectifAnnuel\' | number:2}} &euro;</th><th class=text-right></th><th class=text-right></th><th class=text-right></th></tr></tfoot><tbody><tr ng-repeat-start=\"detail in details\"><td>{{detail.label}}</td><td>{{detail.entree}}</td><td>{{detail.sortie}}</td><td class=text-right>{{detail.caMois | number:2}} &euro;</td><td class=text-right>{{detail.caAnnee | number:2}} &euro;</td><td class=text-right>{{detail.nbreCommission | number:2}}</td><td class=text-right>{{detail.nbreCommissionAnnee | number:2}}</td><td class=text-right>{{detail.objectif | number:2}} &euro;</td><td class=text-right>{{detail.objectifCummule | number:2}} &euro;</td><td class=text-right>{{detail.objectifAnnuel | number:2}} &euro;</td><td class=text-right>{{detail.moyenneMensuel | number:2}} &euro;</td><td class=text-right>{{detail.ecart | number:2}} %</td><td class=text-right><i class=\"fa fa-plus\" ng-click=\"detail.open=!detail.open\"></i></td></tr><tr ng-repeat-end ng-if=detail.open><td colspan=13><table class=\"table table-bordered\"><thead><tr><th>Date</th><th>Date Vente</th><th>Date Suppr</th><th>Lot</th><th>Vendeur</th><th>Acheteur</th><th>CA</th><th>Part</th></tr></thead><tfoot></tfoot><tbody><tr ng-repeat=\"comp in detail.detailCompromis\"><td>{{comp.date}}</td><td>{{comp.dateVente}}</td><td>{{comp.dateSuppression}}</td><td>{{comp.libelleLot}}</td><td>{{comp.libelleVendeur}}</td><td>{{comp.libelleProspect}}</td><td class=text-right>{{comp.caHt | number:2 }} &euro;</td><td class=text-right>{{comp.part | number:2 }}</td></tr></tbody></table></td></tr></tbody></table></div></div><div ng-if=tableaubordctrl.loading class=loader></div></div></div>");
$templateCache.put("app/components/utils/search-box/sb-criteres/sb-criteres.html","<div class=sb-criteres-biens><uib-accordion close-others=false><!-- Ville(s) --><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=sbcriteresctrl.villes.active><div uib-accordion-group is-open=sbcriteresctrl.villes.open><uib-accordion-heading><span ng-if=sbcriteresctrl.villes.selected.length class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Localisation <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': sbcriteresctrl.villes.open, \'fa-chevron-down\': !sbcriteresctrl.villes.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple ng-model=sbcriteresctrl.villes.selected theme=bootstrap close-on-select=false spinner-enabled=true class=\"form-control border-left-rounded\" on-select=::sbcriteresctrl.villes.setVilles() on-remove=::sbcriteresctrl.villes.setVilles() tgn-focus=\"sbcriteresctrl.focus.target === \'villes\'\"><ui-select-match placeholder=Ville(s)...>{{$item.nom}}</ui-select-match><ui-select-choices repeat=\"ville in sbcriteresctrl.villes.list\" refresh=sbcriteresctrl.villes.getVilles($select.search) refresh-delay=350><div ng-bind-html=\"::ville.nom | highlight: $select.search\"></div><small>{{::ville.codePostal}}</small></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=sbcriteresctrl.villes.selected.length ng-click=\"sbcriteresctrl.villes.selected = []; sbcriteresctrl.villes.setVilles()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div><!-- Type(s) de bien --><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=sbcriteresctrl.types.active><div uib-accordion-group is-open=sbcriteresctrl.types.open><uib-accordion-heading><span ng-if=\"sbcriteresctrl.typesModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Type(s) de bien <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': sbcriteresctrl.types.open, \'fa-chevron-down\': !sbcriteresctrl.types.open}\"></i></uib-accordion-heading><div class=\"col-xxs-12 col-xs-6 col-md-12 col-lg-6 col-xl-4\" ng-repeat=\"type in sbcriteresctrl.types.list track by type.id\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: type.checked}\" ng-click=::sbcriteresctrl.types.setTypes() ng-model=type.checked uib-btn-checkbox tgn-focus=\"sbcriteresctrl.focus.target === \'types\' && sbcriteresctrl.focus.value === type.label\">{{::type.label}}</button></div></div></div><!-- Prix --><div class=\"col-xs-12 col-sm-12 col-md-4\" ng-if=sbcriteresctrl.prix.active><div uib-accordion-group is-open=sbcriteresctrl.prix.open><uib-accordion-heading><span ng-if=\"sbcriteresctrl.prixMinModel || sbcriteresctrl.prixMaxModel\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span><span ng-bind-html=sbcriteresctrl.prix.getLabel()></span> <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': sbcriteresctrl.prix.open, \'fa-chevron-down\': !sbcriteresctrl.prix.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=number class=\"form-control border-rounded\" placeholder=\"{{sbcriteresctrl.transac === \'Transaction\' ? \'Prix\' : \'Loyer\'}} min\" ng-model=sbcriteresctrl.prixMinModel tgn-focus=\"sbcriteresctrl.focus.target === \'prix\' && sbcriteresctrl.focus.value === \'min\'\"> <span class=input-group-addon>et </span><input custom-type=number id=prixMax class=\"form-control border-rounded\" placeholder=\"{{sbcriteresctrl.transac === \'Transaction\' ? \'Prix\' : \'Loyer\'}} max\" ng-model=sbcriteresctrl.prixMaxModel tgn-focus=\"sbcriteresctrl.focus.target === \'prix\' && sbcriteresctrl.focus.value === \'max\'\"> <span class=input-group-addon><i class=\"fa fa-fw fa-euro\"></i></span></div></div></div></div><!-- Critères supplémentaire --><div class=col-xs-12 ng-if=\"sbcriteresctrl.criteres.active && sbcriteresctrl.criteres.show\"><div uib-accordion-group is-open=sbcriteresctrl.criteres.open><uib-accordion-heading>Crit&egrave;res sp&eacute;cifiques <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': sbcriteresctrl.criteres.open, \'fa-chevron-down\': !sbcriteresctrl.criteres.open}\"></i></uib-accordion-heading><div class=\"criteres-supp-container row\"><uib-accordion close-others=false><div ng-repeat=\"critere in sbcriteresctrl.criteres.list | orderBy: sbcriteresctrl.orderByArray\"><div ng-switch=critere.type class=\"col-xs-12 col-sm-6 col-md-4\"><!-- Int --><div ng-switch-when=int class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.intMin || critere.intMax\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=integer class=\"form-control border-rounded\" title=min ng-model=critere.intMin ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'min\'\"> <span class=input-group-addon>et </span><input custom-type=integer class=\"form-control border-rounded\" title=max ng-model=critere.intMax ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'max\'\"> <span class=input-group-addon ng-if=\"::critere.unite !== \'\'\">{{::critere.unite}}</span></div></div></div></div><!-- Float --><div ng-switch-when=float class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.floatMin || critere.floatMax\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Entre </span><input custom-type=number class=\"form-control border-rounded\" title=min ng-model=critere.floatMin ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'min\'\"> <span class=input-group-addon>et </span><input custom-type=number class=\"form-control border-rounded\" title=max ng-model=critere.floatMax ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'max\'\"> <span class=input-group-addon ng-if=\"::critere.unite !== \'\'\">{{::critere.unite}}</span></div></div></div></div><!-- Date --><div ng-switch-when=date class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.dateMin || critere.dateMax\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><div class=input-group><span class=input-group-addon>Du </span><input custom-type=date class=\"form-control border-rounded\" title=min ng-model=critere.dateMin ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'min\'\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"sbcriteresctrl.criteres[critere.nomChamp + \'Min\'] = !sbcriteresctrl.criteres[critere.nomChamp + \'Min\']\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=\"sbcriteresctrl.criteres[critere.nomChamp + \'Min\']\" class=\"event-datepicker row\" ng-click=\"sbcriteresctrl.criteres[critere.nomChamp + \'Min\'] = false\"><datetime-picker click-prevent time-picker=false date-model=critere.dateMin on-close=\"::sbcriteresctrl.criteres.closeDatepicker(critere.nomChamp + \'Min\')\"></datetime-picker></div><div class=input-group><span class=input-group-addon>au </span><input custom-type=date class=\"form-control border-rounded\" title=max ng-model=critere.dateMax ng-change=::sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === \'max\'\"> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"sbcriteresctrl.criteres[critere.nomChamp + \'Max\'] = !sbcriteresctrl.criteres[critere.nomChamp + \'Max\']\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=\"sbcriteresctrl.criteres[critere.nomChamp + \'Max\']\" class=\"event-datepicker row\" ng-click=\"sbcriteresctrl.criteres[critere.nomChamp + \'Max\'] = false\"><datetime-picker click-prevent time-picker=false date-model=critere.dateMax on-close=\"::sbcriteresctrl.criteres.closeDatepicker(critere.nomChamp + \'Max\')\"></datetime-picker></div></div></div></div><!-- Boolean --><div ng-switch-when=boolean class=\"text-center critere-boolean\"><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=\"critere.bool !== null && critere.bool !== \'undefined\'\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary critere-boolean-oui\" ng-class=\"{checked: critere.bool}\" ng-click=\"critere.bool = true; sbcriteresctrl.criteres.setCriteres()\" tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === true\"><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary critere-boolean-non\" ng-class=\"{checked: critere.bool === false}\" ng-click=\"critere.bool = false; sbcriteresctrl.criteres.setCriteres()\" tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === false\"><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{checked: critere.bool === null}\" ng-click=\"critere.bool = null; sbcriteresctrl.criteres.setCriteres()\" tgn-focus=\"sbcriteresctrl.focus.target === critere.nom && sbcriteresctrl.focus.value === null\">Indiff&eacute;rent</button></div></div></div><!-- Combo (reference) --><div ng-switch-when=combo class=text-center><div uib-accordion-group is-open=critere.open><uib-accordion-heading><span ng-if=sbcriteresctrl.references.checked[critere.classeValeursName].length class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>{{::critere.nom}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': critere.open, \'fa-chevron-down\': !critere.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple theme=bootstrap close-on-select=false ng-model=sbcriteresctrl.references.checked[critere.classeValeursName] on-select=sbcriteresctrl.criteres.setCriteres() on-remove=sbcriteresctrl.criteres.setCriteres() tgn-focus=\"sbcriteresctrl.focus.target === critere.nom\"><ui-select-match placeholder={{critere.nom}}...>{{$item.label}}</ui-select-match><ui-select-choices repeat=\"reference in sbcriteresctrl.references.list[critere.classeValeursName]\">{{reference.label}}</ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=sbcriteresctrl.references.checked[critere.classeValeursName].length ng-click=\"sbcriteresctrl.references.checked[critere.classeValeursName] = []; sbcriteresctrl.criteres.setCriteres()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div></div><div ng-if=\"($index + 1) % 2 === 0\" class=clearfix-sm></div><div ng-if=\"($index + 1) % 3 === 0\" class=\"clearfix-md clearfix-lg clearfix-xl\"></div></div></uib-accordion></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/utils/search-box/sb-filtres/sb-filtres.html","<div class=sb-filtres-biens><uib-accordion close-others=false><div ng-repeat=\"filtre in sbfiltresctrl.filtres | tgnFilterBy: [\'active\']: \'true\'\"><div ng-switch=filtre.nom class=\"col-xs-12 col-sm-6 col-lg-4\"><!-- Localisation --><div ng-switch-when=geolocalisation><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.geolocalisationModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>G&eacute;olocalisation <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.geolocalisationModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.geolocalisationModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.geolocalisationModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.geolocalisationModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.geolocalisationModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.geolocalisationModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!-- Société --><div ng-switch-when=societes><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.societesModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Soci&eacute;t&eacute;(s) <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><!-- <div class=\"col-xs-12\">\r\n              <ui-select multiple ng-model=\"filtre.query\" theme=\"bootstrap\" close-on-select=\"false\" on-select=\"::filtre.setSocietes()\"\r\n                on-remove=\"::filtre.setSocietes()\">\r\n                <ui-select-match placeholder=\"Société(s)...\">{{$item.nom}}</ui-select-match>\r\n                <ui-select-choices repeat=\"societe in filtre.currentList\" group-by=\"filtre.groupChoices\" refresh=\"filtre.searchInSocietes($select.search)\"\r\n                  refresh-delay=\"350\">\r\n                  <div ng-bind-html=\"::societe.nom | highlight: $select.search\"></div>\r\n                </ui-select-choices>\r\n              </ui-select>\r\n              <span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=\"filtre.query.length\" ng-click=\"filtre.query = []; filtre.setSocietes()\">\r\n                <i class=\"fa fa-fw fa-times\"></i>\r\n              </span>\r\n            </div> --><div class=col-xs-12><r-select ng-model=filtre.query rs-multiple rs-options=filtre.currentList rs-labelled-by=\"\'nom\'\" rs-group-by=\"[\'pool.nom\', \'adresse.ville\']\" rs-placeholder=\"\'Societé(s)...\'\" rs-on-change=filtre.setSocietes()></r-select></div></div></div><!-- Nego --><div ng-switch-when=nego><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.negoModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>N&eacute;gociateur <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple ng-model=filtre.query theme=bootstrap close-on-select=false on-select=::filtre.setNego() on-remove=::filtre.setNego()><ui-select-match placeholder=Negociateur...>{{$item.perso.getNomComplet()}}</ui-select-match><ui-select-choices repeat=\"nego in filtre.currentList\" refresh=filtre.getNegos($select.search) refresh-delay=350><div ng-bind-html=\"::nego.perso.getNomComplet() | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=filtre.query.length ng-click=\"filtre.query = []; filtre.setNego()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div><!--  Visibilité --><div ng-switch-when=visibilite><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"(filtre.mandatActive && sbfiltresctrl.mandatModel !== null) || (filtre.archiveActive && sbfiltresctrl.archiveModel !== null)\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Visibilit&eacute; <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\" ng-if=filtre.mandatActive><label class=col-xs-12>Mandat actif :</label><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.mandatModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.mandatModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.mandatModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.mandatModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.mandatModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.mandatModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div><div class=\"col-xs-12 no-padding\" ng-if=filtre.archiveActive><label class=col-xs-12>Archiv&eacute;(s) :</label><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.archiveModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.archiveModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.archiveModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.archiveModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.archiveModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.archiveModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!--  Etat des lots --><div ng-switch-when=etat><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"(filtre.attenteActive && sbfiltresctrl.attenteModel !== null) || (filtre.optionActive && sbfiltresctrl.optionModel !== null)\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>&Eacute;tat des lots <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\" ng-if=filtre.attenteActive><label class=col-xs-12>En attente :</label><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.attenteModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.attenteModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.attenteModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.attenteModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.attenteModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.attenteModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div><div class=\"col-xs-12 no-padding\" ng-if=filtre.optionActive><label class=col-xs-12>En option :</label><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.optionModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.optionModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.optionModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.optionModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.optionModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.optionModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!--  Type de contrat --><div ng-switch-when=typeContrat><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.typeContratModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Type de contrat <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=col-xs-6><button ng-if=\"sbfiltresctrl.typeApplication === \'Transaction\'\" type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': sbfiltresctrl.typeContratModel === \'vente\'}\" ng-model=sbfiltresctrl.typeContratModel uib-btn-checkbox btn-checkbox-true=\"\'vente\'\" btn-checkbox-false=null>Vente</button> <button ng-if=\"sbfiltresctrl.typeApplication === \'Location\'\" type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': sbfiltresctrl.typeContratModel === \'location\'}\" ng-model=sbfiltresctrl.typeContratModel uib-btn-checkbox btn-checkbox-true=\"\'location\'\" btn-checkbox-false=null>Location</button></div><div class=col-xs-6><button ng-if=\"sbfiltresctrl.typeApplication === \'Transaction\'\" type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': sbfiltresctrl.typeContratModel === \'compromis\'}\" ng-model=sbfiltresctrl.typeContratModel uib-btn-checkbox btn-checkbox-true=\"\'compromis\'\" btn-checkbox-false=null>Compromis</button> <button ng-if=\"sbfiltresctrl.typeApplication === \'Location\'\" type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': sbfiltresctrl.typeContratModel === \'reservation\'}\" ng-model=sbfiltresctrl.typeContratModel uib-btn-checkbox btn-checkbox-true=\"\'reservation\'\" btn-checkbox-false=null>R&eacute;servation</button></div></div></div><!-- Intrabox --><div ng-switch-when=intrabox><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.intraboxModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Intrabox <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.intraboxModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.intraboxModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.intraboxModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.intraboxModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div></div></div></div><!-- Type de mandat --><div ng-switch-when=typeMandat><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.typeMandatModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Type de Mandat <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select ng-model=sbfiltresctrl.typeMandatModel theme=bootstrap close-on-select=true on-select=filtre.isUndefined()><ui-select-match placeholder=\"Type de mandat...\" allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.data as type in filtre.list\"><div ng-bind-html=\"::type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><!-- Date mandat --><div ng-switch-when=dateMandat><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"(filtre.datedebActive && sbfiltresctrl.datedebModel) || (filtre.datefinActive && sbfiltresctrl.datefinModel)\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Date de Mandat <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div ng-if=!sbfiltresctrl.citya><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datedeb class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">Entre</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datedeb custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datedebModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datedebOpen = !filtre.datedebOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datedebOpen class=\"event-datepicker row\" ng-click=\"filtre.datedebOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datedebModel on-close=\"filtre.datedebOpen = false\"></datetime-picker></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datefin class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">et</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datefin custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datefinModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datefinOpen = !filtre.datefinOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datefinOpen class=\"event-datepicker row\" ng-click=\"filtre.datefinOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datefinModel on-close=\"filtre.datefinOpen = false\"></datetime-picker></div></div></div><div ng-if=sbfiltresctrl.citya><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': filtre.periode === 3}\" ng-model=filtre.periode uib-btn-radio=3 ng-click=filtre.setDates() uncheckable>3 mois</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': filtre.periode === 6}\" ng-model=filtre.periode uib-btn-radio=6 ng-click=filtre.setDates() uncheckable>6 mois</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-class=\"{\'checked\': filtre.periode === 9}\" ng-model=filtre.periode uib-btn-radio=9 ng-click=filtre.setDates() uncheckable>9 mois</button></div></div></div></div><!-- Expire --><div ng-switch-when=expire><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"filtre.active && sbfiltresctrl.expireModel\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Mandat expir&eacute; <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6\"><button type=button ng-class=\"{checked: filtre.expire === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=filtre.expire uib-btn-radio=true ng-click=filtre.setExpiration()><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6\"><button type=button ng-class=\"{checked: filtre.expire === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=filtre.expire uib-btn-radio=false ng-click=filtre.setExpiration()>Indiff&eacute;rent</button></div></div></div><!-- Expirant --><div ng-switch-when=expirant><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"filtre.expirantActive && sbfiltresctrl.expirantModel\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Mandat expirant <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><label for=expirant class=sr-only>Dans</label><div class=\"col-xs-12 input-group\"><span class=input-group-addon>Dans</span> <input custom-type=number id=expirant name=expirant min=0 placeholder=Durée... class=\"form-control border-rounded\" ng-model=filtre.expirant ng-change=filtre.setExpirant()> <span class=input-group-addon>Jour(s)</span></div></div></div><!-- Date saisie --><div ng-switch-when=dateSaisie><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"(filtre.datedebSaisieActive && sbfiltresctrl.datedebSaisieModel) || (filtre.datefinSaisieActive && sbfiltresctrl.datefinSaisieModel)\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Date de Saisie <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datedebSaisie class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">Entre</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datedebSaisie custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datedebSaisieModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datedebSaisieOpen = !filtre.datedebSaisieOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datedebSaisieOpen class=\"event-datepicker row\" ng-click=\"filtre.datedebSaisieOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datedebSaisieModel on-close=\"filtre.datedebSaisieOpen = false\"></datetime-picker></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datefinSaisie class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">et</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datefinSaisie custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datefinSaisieModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datefinSaisieOpen = !filtre.datefinSaisieOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datefinSaisieOpen class=\"event-datepicker row\" ng-click=\"filtre.datefinSaisieOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datefinSaisieModel on-close=\"filtre.datefinSaisieOpen = false\"></datetime-picker></div></div></div></div><!-- Date signature --><div ng-switch-when=dateSignature><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"(filtre.datedebSignatureActive && sbfiltresctrl.datedebSignatureModel !== null) || (filtre.datefinSignatureActive && sbfiltresctrl.datefinSignatureModel !== null)\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Date de {{filtre.text}} <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datedebSignature class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">Entre</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datedebSignature custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datedebSignatureModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datedebSignatureOpen = !filtre.datedebSignatureOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datedebSignatureOpen class=\"event-datepicker row\" ng-click=\"filtre.datedebSignatureOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datedebSignatureModel on-close=\"filtre.datedebSignatureOpen = false\"></datetime-picker></div></div><div class=\"col-xs-12 col-md-6 spacer-bottom\"><label for=datefinSignature class=\"col-xs-3 col-sm-3 col-md-2 control-label no-padding-left\">et</label><div class=\"col-xs-9 col-sm-9 col-md-10 spacer-bottom\"><div class=input-group><input id=datefinSignature custom-type=date ui-mask=99/99/9999 class=form-control ng-model=sbfiltresctrl.datefinSignatureModel> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"filtre.datefinSignatureOpen = !filtre.datefinSignatureOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div></div><div ng-if=filtre.datefinSignatureOpen class=\"event-datepicker row\" ng-click=\"filtre.datefinSignatureOpen = false\"><datetime-picker click-prevent time-picker=false date-model=sbfiltresctrl.datefinSignatureModel on-close=\"filtre.datefinSignatureOpen = false\"></datetime-picker></div></div></div></div><!-- Géré par l\'agence --><div ng-switch-when=gestionAgence><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.gestionAgenceModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>G&eacute;r&eacute; par l&apos;agence <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.gestionAgenceModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.gestionAgenceModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.gestionAgenceModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.gestionAgenceModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.gestionAgenceModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.gestionAgenceModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div><!-- Avancement (motif suppression) --><div ng-switch-when=avancement><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.avancementModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Avancement <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple ng-model=filtre.query theme=bootstrap close-on-select=false on-select=filtre.setAvancement() on-remove=filtre.setAvancement()><ui-select-match placeholder=Avancement(s)...>{{$item.label}}</ui-select-match><ui-select-choices repeat=\"motif in filtre.list\"><div ng-bind-html=\"::motif.label | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=filtre.query.length ng-click=\"filtre.query = []; filtre.setAvancement()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div><!-- Durée de vacance --><div ng-switch-when=dureeVacance><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.dureeVacanceModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Dur&eacute;e de vacance <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><label for=dureeVacance class=sr-only>Durée de vacance</label><div class=\"col-xs-12 input-group\"><input custom-type=number id=dureeVacance name=dureeVacance min=0 placeholder=Durée... class=\"form-control border-rounded\" ng-model=sbfiltresctrl.dureeVacanceModel> <span class=input-group-addon>Jour <span ng-if=\"sbfiltresctrl.dureeVacanceModel === null\">(s)</span> <span ng-if=\"sbfiltresctrl.dureeVacanceModel > 1\">s</span> <span ng-if=\"sbfiltresctrl.dureeVacanceModel <= 1\"></span></span></div></div></div><!-- Parution --><div ng-switch-when=parution><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.parutionModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Parution <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.parutionModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.parutionModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.parutionModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.parutionModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.parutionModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.parutionModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!-- Panneaux --><div ng-switch-when=panneaux><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.panneauxModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Panneaux <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.panneauxModel === 1}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.panneauxModel uib-btn-radio=1><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.panneauxModel === 2}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.panneauxModel uib-btn-radio=2><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.panneauxModel === 3}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.panneauxModel uib-btn-radio=3><i class=\"fa fa-fw fa-ban\"></i> Impossible</button></div><div class=\"col-xs-12 col-sm-6\"><button type=button ng-class=\"{checked: sbfiltresctrl.panneauxModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.panneauxModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!-- Internet (paru) --><div ng-switch-when=paru><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.paruModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Internet <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 no-padding\"><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.paruModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.paruModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.paruModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.paruModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.paruModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.paruModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><!-- Qualification --><div ng-switch-when=qualification><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.qualificationModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Qualification <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=col-xs-12><ui-select multiple ng-model=filtre.query theme=bootstrap close-on-select=false on-select=::filtre.setQualification() on-remove=::filtre.setQualification()><ui-select-match placeholder=Qualification(s)...>{{$item.type}}</ui-select-match><ui-select-choices repeat=\"qualification in filtre.list\"><div ng-bind-html=\"::qualification.type | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=filtre.query.length ng-click=\"filtre.query = []; filtre.setQualification()\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div><!-- Encaissement --><div ng-switch-when=encaissement><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.encaissementModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Encaissement <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.encaissementModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.encaissementModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.encaissementModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.encaissementModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.encaissementModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.encaissementModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div><!-- Valider --><div ng-switch-when=valider><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.validerModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Valid&eacute; <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.validerModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.validerModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.validerModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.validerModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.validerModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.validerModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div><!-- Sans DPE --><div ng-switch-when=sansDpe><div uib-accordion-group is-open=filtre.open><uib-accordion-heading><span ng-if=\"sbfiltresctrl.sansDpeModel !== null\" class=has-critere><i class=\"fa fa-fw fa-circle\"></i> </span>Sans DPE <i class=\"fa fa-fw\" ng-class=\"{\'fa-chevron-up\': filtre.open, \'fa-chevron-down\': !filtre.open}\"></i></uib-accordion-heading><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.sansDpeModel === true}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-oui\" ng-model=sbfiltresctrl.sansDpeModel uib-btn-radio=true><i class=\"fa fa-fw fa-check\"></i> Oui</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.sansDpeModel === false}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-check-boolean boolean-non\" ng-model=sbfiltresctrl.sansDpeModel uib-btn-radio=false><i class=\"fa fa-fw fa-times\"></i> Non</button></div><div class=\"col-xs-12 col-sm-4 col-md-12 col-lg-4\"><button type=button ng-class=\"{checked: sbfiltresctrl.sansDpeModel === null}\" class=\"btn-custom-checkbox btn-custom-checkbox-primary\" ng-model=sbfiltresctrl.sansDpeModel uib-btn-radio=null>Indiff&eacute;rent</button></div></div></div></div><div ng-if=\"($index + 1) % 2 === 0\" class=\"clearfix-sm clearfix-md\"></div><div ng-if=\"($index + 1) % 3 === 0\" class=\"clearfix-lg clearfix-xl\"></div></div></uib-accordion></div>");
$templateCache.put("app/components/utils/search-box/sb-prestataires/sb-prestataires.html","<div class=sb-prestataires><div class=\"col-xs-12 prestataires-container\"><div class=\"col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-1\" ng-repeat=\"prestataire in sbprestatairesctrl.prestataires.list | orderBy:[\'ordre\']\"><button type=button class=\"btn-custom-checkbox btn-custom-checkbox-primary btn-custom-block\" ng-model=sbprestatairesctrl.prestataireModel uib-btn-radio={{prestataire.id}} ng-change=sbprestatairesctrl.onChangePrestataire(prestataire)><span ng-if=prestataire.hasImg class=prestataire-img><img ng-src={{::prestataire.imgSrc}} alt={{::prestataire.nom}} title={{::prestataire.nom}} class=img-responsive> </span><span ng-if=(!prestataire.hasImg) class=prestataire-nom>{{::prestataire.nom}}</span></button></div></div></div>");
$templateCache.put("app/components/utils/r-select/r-select-option/r-select-option.html","<ul class=\"rs-list list-unstyled\" ng-class=\"{\'rs-option\': !rsoptionctrl.isGroup, \'rs-group\': rsoptionctrl.isGroup, \'rs-mouseover\': rsoptionctrl.mouseover}\"><li class=rs-label ng-click=rsoptionctrl.onClickOption() ng-mouseenter=\"rsoptionctrl.mouseover = true\" ng-mouseleave=\"rsoptionctrl.mouseover = false\">{{::rsoptionctrl.label}}</li><li ng-if=rsoptionctrl.isGroup><r-select-option ng-repeat=\"option in rsoptionctrl.rsOption.options\" rs-option=option rs-labelled-by=rsoptionctrl.rsLabelledBy on-select-option=rsoptionctrl.onClickOption(option)></r-select-option></li></ul>");
$templateCache.put("app/components/main-content/accueil/actualites/blocalerte/blocalerte.html","<div class=bloc-alerte><ul class=\"property-details alerte-details list-unstyled list-inline row\"><li class=\"property-detail flex-item\"><h4>{{blocalertectrl.property.alerte.titre}}</h4></li><li class=\"property-detail details-date\"><small>{{::blocalertectrl.getDayTitle(blocalertectrl.property.alerte.dateCreation)}}</small></li><li class=\"property-detail details-remove\"><a class=\"btn-action btn-remove\" uib-tooltip=\"Marquer vu\" tooltip-placement=\"auto top\" ng-click=::blocalertectrl.viewDiffusion()><i class=\"fa fa-fw fa-2r fa-times\"></i></a></li></ul><div class=alerteMsg><span ng-if=!blocalertectrl.citya>{{blocalertectrl.property.alerte.msg}}</span> <span ng-if=blocalertectrl.property.alerte.negoOrigine><br>Par : {{blocalertectrl.property.alerte.negoOrigine.perso ? blocalertectrl.property.alerte.negoOrigine.perso.nomComplet : blocalertectrl.property.alerte.negoOrigine.initiales}}</span></div><bloc-bien class=panier-bien ng-if=\"blocalertectrl.property.alerte.lot !== undefined\" bien=::blocalertectrl.property.alerte.lot template=\"\'actualites\'\" on-toggle-fiche=::blocalertectrl.showFicheBien(refLot) on-email=::blocalertectrl.envoyerEmail(refLot)></bloc-bien><div class=blockProspect ng-if=\"blocalertectrl.property.alerte.prospect !== undefined\"><div class=\"col-xs-12 prospectTitle\"><span>{{blocalertectrl.property.alerte.prospect.perso.getNomComplet()}}</span></div><div class=\"prospect-contact col-xs-12\" ng-if=::blocalertectrl.property.alerte.prospect.perso.hasContacts()><div sly-repeat=\"contact in blocalertectrl.property.alerte.prospect.perso.contacts\" ng-if=\"contact.type === \'Email\'\"><span class=contact-label><i class=\"fa fa-fw fa-envelope\"></i> </span><span class=contact-value>{{::contact.value}}</span></div></div><div class=viewFicheBtn><button class=\"btn-custom btn-custom-primary btn-custom-sm\" ng-click=::blocalertectrl.showFicheProspect()><i class=\"fa fa-fw fa-eye\"></i> <span class=hidden-xs>Voir fiche</span></button></div></div></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/criterelot/criterelot.html","<div class=criterelot><uib-accordion close-others=false><div uib-accordion-group is-open=criterelotctrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': criterelotctrl.isOpen, \'fa-plus\': !criterelotctrl.isOpen}\"></i> Crit&egrave;res</uib-accordion-heading><div class=row><div class=\"spacer-top criteres-lot-container col-xs-12 col-md-11 col-lg-9 col-lg-offset-1 no-padding\"><div ng-repeat=\"c in criterelotctrl.criteresAAfficher | orderBy:criterelotctrl.orderByArray\"><itemcritere critere=c valeur=criterelotctrl.lot[criterelotctrl.getNomChamp(c)] listereference=criterelotctrl.getListeReference(c) class=\"col-xs-12 col-sm-6 col-md-4 no-padding\"></itemcritere><div ng-class=\"{\'clearfix-md clearfix-lg clearfix-xl\': $index > 0 && ($index + 1) % 3 === 0}\"></div></div></div><div class=\"spacer-top criteres-lot-container col-xs-12 no-padding\"><label for=autresCriteres class=\"col-xs-12 col-sm-2 col-md-1 col-lg-2 control-label no-padding-left\">Autres Criteres</label><div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-8 spacer-bottom\"><ui-select multiple ng-model=criterelotctrl.lot.autresCriteres theme=bootstrap close-on-select=false spinner-enabled=true class=\"form-control border-left-rounded\"><ui-select-match placeholder=\"Autre critère(s)...\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"critere in criterelotctrl.listRef.RefAutreCritere\"><div ng-bind-html=\"::critere.label | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"ui-select-multiple-clear btn-xs btn-link\" ng-if=\"criterelotctrl.lot.autresCriteres && criterelotctrl.lot.autresCriteres.length\" ng-click=\"criterelotctrl.lot.autresCriteres = []\"><i class=\"fa fa-fw fa-times\"></i></span></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/cadastre/cadastre.html","<div class=cadastre><uib-accordion close-others=false><div uib-accordion-group is-open=cadastrectrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': cadastrectrl.isOpen, \'fa-plus\': !cadastrectrl.isOpen}\"></i> Cadastre</uib-accordion-heading><div class=\"col-xs-12 spacer-top\"><form class=form-horizontal name=ajoutcadastre ng-submit=cadastrectrl.addCadastre(ajoutcadastre) novalidate><div class=\"form-group row\"><label for=lieuDit class=\"col-xs-4 col-sm-2 col-md-1 control-label no-padding-left\">Lieu Dit</label><div class=\"col-xs-8 col-sm-10 col-md-3 spacer-bottom\"><input id=lieuDit class=form-control ng-model=cadastrectrl.ajout.lieuDit required></div><label for=nomSection class=\"col-xs-4 col-sm-2 col-md-1 control-label no-padding-left\">Nom Section</label><div class=\"col-xs-8 col-sm-10 col-md-3 spacer-bottom\"><input id=nomSection class=form-control ng-model=cadastrectrl.ajout.nomSection></div><label for=numeroSection class=\"col-xs-4 col-sm-2 col-md-1 control-label no-padding-left\">Num. Section</label><div class=\"col-xs-8 col-sm-10 col-md-3 spacer-bottom\"><input custom-type=number id=numeroSection class=form-control ng-model=cadastrectrl.ajout.numeroSection></div></div><div class=\"form-group row\"><label class=\"col-xs-12 col-sm-2 col-md-1 control-label no-padding-left\">Surface</label><div class=\"col-xs-12 col-sm-10 col-md-11 spacer-bottom\"><div class=input-group><input custom-type=number id=hectare placeholder=hectare class=\"form-control border-rounded\" ng-model=cadastrectrl.ajout.hectare><div class=\"input-group-addon no-border\">ha</div><input custom-type=number id=are placeholder=are class=\"form-control border-rounded\" ng-model=cadastrectrl.ajout.are><div class=\"input-group-addon no-border\">a</div><input custom-type=number id=centiare placeholder=centiare class=\"form-control border-rounded\" ng-model=cadastrectrl.ajout.centiare><div class=\"input-group-addon no-border\">ca</div></div></div></div><div class=\"form-group row\"><div class=col-xs-12><button class=\"btn-custom btn-custom-primary pull-right\" type=submit ng-bind=\"(cadastrectrl.modification)?\'Valider\':\'Ajouter\'\"></button></div></div></form></div><div class=\"col-xs-12 form-group spacer-top\"><div ng-repeat=\"cadastre in cadastrectrl.cadastres\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"row itemCadastre\"><div class=\"col-xs-12 titreCadastre\"><i class=\"fa fa-cube\"></i>Lieu dit &quot;{{cadastre.lieuDit}}&quot;, Cadastré Section &quot;{{cadastre.nomSection}}&quot;, Num&eacute;ro &quot;{{cadastre.numeroSection}}&quot;,</div><div class=\"col-xs-12 commentaireCadastre\">pour &quot;{{cadastre.hectare}}&quot; ha &quot;{{cadastre.are}}&quot; a &quot;{{cadastre.centiare}}&quot; ca</div><div class=\"col-xs-12 text-right btn-cadastre\"><i class=\"fa fa-pencil-square-o\" ng-click=cadastrectrl.modifierCadastre(cadastre)></i> <i class=\"fa fa-trash-o text-danger\" ng-click=cadastrectrl.deleteCadastre(cadastre)></i></div></div></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/complement-info/complement-info.html","<div class=\"col-xs-12 col-xs-offset-0 col-md-10 col-md-offset-1 spacer-bottom responsive-table-line\"><table class=\"table table-bordered table-condensed table-body-center\"><thead><tr><th>Type</th><th>Num Lot</th><th>Tantiemes</th><th>Emplacement</th><th>Loyer Annexe</th><th>Provision</th><th>Descriptif</th></tr></thead><tbody><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'app\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.app,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.app\r\n					   }\"></i> Appartement</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.app><label for=lotapp class=sr-only>Num Lot App</label><input type=text id=lotapp name=lotapp class=form-control ng-model=complementinfoctrl.lot.lotapp placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.app><label for=lottantapp class=sr-only>Tanti&egrave;mes App</label><input type=text id=lottantapp name=lottantapp class=form-control ng-model=complementinfoctrl.lot.lottantapp placeholder=Tantièmes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.app><label for=lotempapp class=sr-only>Emplacement App</label><input type=text id=lotempapp name=lotempapp class=form-control ng-model=complementinfoctrl.lot.lotempapp placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.app><label for=lotloyerapp class=sr-only>Loyer Annexe App</label><input type=text id=lotloyerapp name=lotloyerapp class=form-control ng-model=complementinfoctrl.lot.lotloyerapp placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.app><label for=lotprovapp class=sr-only>Provision App</label><input type=text id=lotprovapp name=lotprovapp class=form-control ng-model=complementinfoctrl.lot.lotprovapp placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.app><label for=lotdescapp class=sr-only>Descriptif App</label><textarea id=lotdescapp name=lotdescapp rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescapp placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'cave\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.cave,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.cave\r\n					   }\"></i> Cave</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.cave><label for=lotcave class=sr-only>Num Lot Cave</label><input type=text id=lotcave name=lotcave class=form-control ng-model=complementinfoctrl.lot.lotcave placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.cave><label for=lottantcave class=sr-only>Tantiemes Cave</label><input type=text id=lottantcave name=lottantcave class=form-control ng-model=complementinfoctrl.lot.lottantcave placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.cave><label for=lotempcave class=sr-only>Emplacement Cave</label><input type=text id=lotempcave name=lotempcave class=form-control ng-model=complementinfoctrl.lot.lotempcave placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.cave><label for=lotloyercave class=sr-only>Loyer Annexe Cave</label><input type=text id=lotloyercave name=lotloyercave class=form-control ng-model=complementinfoctrl.lot.lotloyercave placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.cave><label for=lotprovcave class=sr-only>Provision Cave</label><input type=text id=lotprovcave name=lotprovcave class=form-control ng-model=complementinfoctrl.lot.lotprovcave placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.cave><label for=lotdesccave class=sr-only>Descriptif Cave</label><textarea id=lotdesccave name=lotdesccave rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdesccave placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'parking\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.parking,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.parking\r\n					   }\"></i> Parking</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.parking><label for=lotparking class=sr-only>Num Lot Parking</label><input type=text id=lotparking name=lotparking class=form-control ng-model=complementinfoctrl.lot.lotparking placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.parking><label for=lottantparking class=sr-only>Tantiemes Parking</label><input type=text id=lottantparking name=lottantparking class=form-control ng-model=complementinfoctrl.lot.lottantparking placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.parking><label for=lotempparking class=sr-only>Emplacement Parking</label><input type=text id=lotempparking name=lotempparking class=form-control ng-model=complementinfoctrl.lot.lotempparking placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.parking><label for=lotloyerparking class=sr-only>Loyer Annexe Parking</label><input type=text id=lotloyerparking name=lotloyerparking class=form-control ng-model=complementinfoctrl.lot.lotloyerparking placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.parking><label for=lotprovparking class=sr-only>Provision Parking</label><input type=text id=lotprovparking name=lotprovparking class=form-control ng-model=complementinfoctrl.lot.lotprovparking placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.parking><label for=lotdescparking class=sr-only>Descriptif Parking</label><textarea id=lotdescparking name=lotdescparking rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescparking placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'garage\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.garage,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.garage\r\n					   }\"></i> Garage</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.garage><label for=lotgarage class=sr-only>Num Lot Garage</label><input type=text id=lotgarage name=lotgarage class=form-control ng-model=complementinfoctrl.lot.lotgarage placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.garage><label for=lottantgarage class=sr-only>Tantiemes Garage</label><input type=text id=lottantgarage name=lottantgarage class=form-control ng-model=complementinfoctrl.lot.lottantgarage placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.garage><label for=lotempgarage class=sr-only>Emplacement Garage</label><input type=text id=lotempgarage name=lotempgarage class=form-control ng-model=complementinfoctrl.lot.lotempgarage placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.garage><label for=lotloyergarage class=sr-only>Loyer Annexe Garage</label><input type=text id=lotloyergarage name=lotloyergarage class=form-control ng-model=complementinfoctrl.lot.lotloyergarage placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.garage><label for=lotprovgarage class=sr-only>Provision Garage</label><input type=text id=lotprovgarage name=lotprovgarage class=form-control ng-model=complementinfoctrl.lot.lotprovgarage placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.garage><label for=lotdescgarage class=sr-only>Descriptif Garage</label><textarea id=lotdescgarage name=lotdescgarage rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescgarage placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'box\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.box,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.box\r\n					   }\"></i> Box</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.box><label for=lotbox class=sr-only>Num Lot Box</label><input type=text id=lotbox name=lotbox class=form-control ng-model=complementinfoctrl.lot.lotbox placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.box><label for=lottantbox class=sr-only>Tantiemes Box</label><input type=text id=lottantbox name=lottantbox class=form-control ng-model=complementinfoctrl.lot.lottantbox placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.box><label for=lotempbox class=sr-only>Emplacement Box</label><input type=text id=lotempbox name=lotempbox class=form-control ng-model=complementinfoctrl.lot.lotempbox placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.box><label for=lotloyerbox class=sr-only>Loyer Annexe Box</label><input type=text id=lotloyerbox name=lotloyerbox class=form-control ng-model=complementinfoctrl.lot.lotloyerbox placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.box><label for=lotprovbox class=sr-only>Provision Box</label><input type=text id=lotprovbox name=lotprovbox class=form-control ng-model=complementinfoctrl.lot.lotprovbox placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.box><label for=lotdescbox class=sr-only>Descriptif Box</label><textarea id=lotdescbox name=lotdescbox rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescbox placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'jardin\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.jardin,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.jardin\r\n					   }\"></i> Jardin</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.jardin><label for=lotjardin class=sr-only>Num Lot Jardin</label><input type=text id=lotjardin name=lotjardin class=form-control ng-model=complementinfoctrl.lot.lotjardin placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.jardin><label for=lottantjardin class=sr-only>Tantiemes Jardin</label><input type=text id=lottantjardin name=lottantjardin class=form-control ng-model=complementinfoctrl.lot.lottantjardin placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.jardin><label for=lotempjardin class=sr-only>Emplacement Jardin</label><input type=text id=lotempjardin name=lotempjardin class=form-control ng-model=complementinfoctrl.lot.lotempjardin placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.jardin><label for=lotloyerjardin class=sr-only>Loyer Annexe Jardin</label><input type=text id=lotloyerjardin name=lotloyerjardin class=form-control ng-model=complementinfoctrl.lot.lotloyerjardin placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.jardin><label for=lotprovjardin class=sr-only>Provision Jardin</label><input type=text id=lotprovjardin name=lotprovjardin class=form-control ng-model=complementinfoctrl.lot.lotprovjardin placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.jardin><label for=lotdescjardin class=sr-only>Descriptif Jardin</label><textarea id=lotdescjardin name=lotdescjardin rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescjardin placeholder=Descriptif...></textarea></td></tr><tr><td class=table-trigger><label class=control-label ng-click=\"complementinfoctrl.table.trigger(\'terrasse\')\"><i class=\"visible-xs-inline-block fa\" ng-class=\"{\r\n					     \'fa-chevron-up\': complementinfoctrl.table.terrasse,\r\n					     \'fa-chevron-down\': !complementinfoctrl.table.terrasse\r\n					   }\"></i> Terrasse</label></td><td data-title=\"Num Lot\" ng-if=complementinfoctrl.table.terrasse><label for=lotterrasse class=sr-only>Num Lot Terrasse</label><input type=text id=lotterrasse name=lotterrasse class=form-control ng-model=complementinfoctrl.lot.lotterrasse placeholder=Numero...></td><td data-title=Tantiemes ng-if=complementinfoctrl.table.terrasse><label for=lottantterrasse class=sr-only>Tantiemes Terrasse</label><input type=text id=lottantterrasse name=lottantterrasse class=form-control ng-model=complementinfoctrl.lot.lottantterrasse placeholder=Tantiemes...></td><td data-title=Emplacement ng-if=complementinfoctrl.table.terrasse><label for=lotempterrasse class=sr-only>Emplacement Terrasse</label><input type=text id=lotempterrasse name=lotempterrasse class=form-control ng-model=complementinfoctrl.lot.lotempterrasse placeholder=Emplacement...></td><td data-title=\"Loyer Annexe\" ng-if=complementinfoctrl.table.terrasse><label for=lotloyerterrasse class=sr-only>Loyer Annexe Terrasse</label><input type=text id=lotloyerterrasse name=lotloyerterrasse class=form-control ng-model=complementinfoctrl.lot.lotloyerterrasse placeholder=Loyer...></td><td data-title=Provision ng-if=complementinfoctrl.table.terrasse><label for=lotprovterrasse class=sr-only>Provision Terrasse</label><input type=text id=lotprovterrasse name=lotprovterrasse class=form-control ng-model=complementinfoctrl.lot.lotprovterrasse placeholder=Provision...></td><td data-title=Descriptif ng-if=complementinfoctrl.table.terrasse><label for=lotdescterrasse class=sr-only>Descriptif Terrasse</label><textarea id=lotdescterrasse name=lotdescterrasse rows=1 cols=50 ng-model=complementinfoctrl.lot.lotdescterrasse placeholder=Descriptif...></textarea></td></tr></tbody></table></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/dpe-ges/dpe-ges.html","<div class=dpe-ges><uib-accordion close-others=false><div uib-accordion-group is-open=dpegesctrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': dpegesctrl.isOpen, \'fa-plus\': !dpegesctrl.isOpen}\"></i> DPE / GES</uib-accordion-heading><div class=row><!-- DPE --><div class=\"col-xs-12 col-md-6 no-padding\"><label for=dpe class=\"col-xs-12 col-sm-3 col-md-4 control-label no-padding-left\">DPE</label><div class=\"col-xs-5 col-sm-3 col-md-3 col-xl-4 spacer-bottom\"><ui-select ng-model=dpegesctrl.lot.dpe theme=bootstrap ng-change=\"dpegesctrl.verifier(\'dpe\')\"><ui-select-match placeholder=DPE>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"dpe in dpegesctrl.list | filter: $select.search track by dpe.data\"><div ng-bind-html=\"dpe.label | highlight: $select.search\" ng-class=\"\'dpe-option-\' + dpe.label\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-7 col-sm-3 col-md-4 col-xl-3 input-group\"><input id=dpe custom-type=number class=\"form-control border-right-rounded\" ng-model=dpegesctrl.lot.valeurDPE ng-model-options=\"{ debounce: 350 }\" ng-change=\"dpegesctrl.changed(\'dpe\')\"> <span class=\"input-group-addon no-border\"><small>kWh/m&sup2;</small></span></div></div><!-- GES --><div class=\"col-xs-12 col-md-6 no-padding\"><label for=ges class=\"col-xs-12 col-sm-3 col-md-1 control-label no-padding-left\">GES</label><div class=\"col-xs-5 col-sm-3 col-md-3 col-xl-4 spacer-bottom\"><ui-select ng-model=dpegesctrl.lot.ges theme=bootstrap ng-change=\"dpegesctrl.verifier(\'ges\')\"><ui-select-match placeholder=GES>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"ges in dpegesctrl.list | filter: $select.search track by ges.data\"><div ng-bind-html=\"ges.label | highlight: $select.search\" ng-class=\"\'ges-option-\' + ges.label\"></div></ui-select-choices></ui-select></div><div class=\"col-xs-7 col-sm-3 col-md-4 col-xl-3 input-group\"><input id=ges custom-type=number class=\"form-control border-right-rounded\" ng-model=dpegesctrl.lot.valeurGSE ng-model-options=\"{ debounce: 350 }\" ng-change=\"dpegesctrl.changed(\'ges\')\"> <span class=\"input-group-addon no-border\"><small>kgCo&sup2;/m&sup2;</small></span></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/itemcritere/itemcritere.html","<!--suppress HtmlFormInputWithoutLabel, HtmlFormInputWithoutLabel, HtmlFormInputWithoutLabel, HtmlFormInputWithoutLabel --><div ng-switch=itemcriterectrl.critere.type><label class=\"col-xs-12 col-sm-4 control-label no-padding-left\">{{itemcriterectrl.critere.nom}}</label><div class=\"col-xs-12 col-sm-8 spacer-bottom\" ng-switch-when=int><input custom-type=number class=form-control ng-model=itemcriterectrl.valeur></div><div class=\"col-xs-12 col-sm-8 spacer-bottom\" ng-switch-when=float><input custom-type=number class=form-control ng-model=itemcriterectrl.valeur></div><div class=\"col-xs-12 col-sm-8 spacer-bottom\" ng-switch-when=boolean><input type=checkbox class=\"checkbox form-control\" ng-model=itemcriterectrl.valeur></div><div class=\"col-xs-12 col-sm-8 spacer-bottom\" ng-switch-when=date><div class=input-group><input custom-type=date ui-mask=99/99/9999 class=form-control ng-model=itemcriterectrl.valeur> <span class=\"input-group-addon bg-custom-primary input-addon-datepicker\" ng-click=\"itemcriterectrl.isOpen = !itemcriterectrl.isOpen\"><i class=\"fa fa-fw fa-calendar\"></i></span></div><div ng-if=itemcriterectrl.isOpen class=\"event-datepicker row\" ng-click=\"itemcriterectrl.isOpen = false\"><datetime-picker click-prevent time-picker=false date-model=itemcriterectrl.valeur on-close=::itemcriterectrl.closeDatePicker()></datetime-picker></div></div><div class=\"col-xs-12 col-sm-8 spacer-bottom\" ng-switch-when=combo><ui-select ng-model=itemcriterectrl.valeur theme=bootstrap><ui-select-match placeholder={{itemcriterectrl.critere.nom}} allow-clear=true>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"reference in itemcriterectrl.listereference | filter: $select.search track by reference.id\"><div ng-bind-html=\"reference.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><!--<div class=\"visible-md col-md-2 spacer-bottom custom-column-completing completing-odd\"></div>\r\n  <div class=\"visible-sm col-sm-3 spacer-bottom custom-column-completing\"></div>--></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/infolot/infolot.html","<div class=infolot><uib-accordion close-others=false><div uib-accordion-group is-open=infolotctrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': infolotctrl.isOpen, \'fa-plus\': !infolotctrl.isOpen}\"></i> Info Supplementaire</uib-accordion-heading><div class=row><div class=\"spacer-top info-lot-container col-xs-12 col-md-11 col-lg-9 col-lg-offset-1 no-padding\"><div ng-repeat=\"info in infolotctrl.infos\"><iteminfo info=info lot=infolotctrl.lot class=\"col-xs-12 col-sm-6 col-md-4 no-padding\"></iteminfo><div ng-if=\"$index > 0 && ($index + 1) % 2 === 0\" class=clearfix-sm></div><div ng-if=\"$index > 0 && ($index + 1) % 3 === 0\" class=\"clearfix-md clearfix-lg clearfix-xl\"></div></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/iteminfo/iteminfo.html","<div><label for=commentaire class=\"col-xs-12 col-sm-4 control-label no-padding-left\">{{iteminfoctrl.info.label}}</label><div class=\"col-xs-12 col-sm-8 spacer-bottom\"><input class=form-control ng-model=iteminfoctrl.valeur.commentaire id=commentaire name=commentaire></div><!--<div class=\"visible-md col-md-2 spacer-bottom custom-column-completing completing-odd\"></div>\r\n  <div class=\"visible-sm col-sm-3 spacer-bottom custom-column-completing\"></div>--></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/localisation/localisation.html","<div class=localisation><div class=\"col-xs-12 col-md-6 spacer-top spacer-bottom\"><adresse adresse=localisationctrl.lot.adresse check-if-required=true validation=localisationctrl.validation params-gestion=localisationctrl.paramsGestion visited=localisationctrl.visited on-copy=localisationctrl.onCopy()></adresse><div class=\"col-xs-12 no-padding spacer-top\"><div class=row><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-4\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=localisationctrl.geolocaliser() ng-disabled=\"localisationctrl.paramsGestion && localisationctrl.paramsGestion.adresse\"><i class=\"fa fa-fw fa-map-marker\"></i> G&eacute;olocaliser</button></div></div></div><div class=\"col-xs-12 no-padding spacer-bottom localisation-controls\"><div class=row><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-4\"><hr class=custom-hr></div></div><div class=row><div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-4 no-padding\"><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6 no-padding\"><label class=\"col-xs-12 col-sm-5 col-md-12 col-lg-5 control-label no-padding-left\" for=latitude>Latitude</label><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-7\"><input type=number id=latitude class=form-control ng-model=localisationctrl.lot.adresse.latitude step=0.0001 ng-disabled=\"localisationctrl.paramsGestion && localisationctrl.paramsGestion.adresse\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-6 no-padding\"><label class=\"col-xs-12 col-sm-5 col-md-12 col-lg-5 control-label no-padding-left\" for=longitude>Longitude</label><div class=\"col-xs-12 col-sm-7 col-md-12 col-lg-7\"><input type=number id=longitude class=form-control ng-model=localisationctrl.lot.adresse.longitude step=0.0001 ng-disabled=\"localisationctrl.paramsGestion && localisationctrl.paramsGestion.adresse\"></div></div></div></div></div></div><div class=\"col-xs-12 col-md-6 spacer-top spacer-bottom\"><div class=\"localisation-map-container col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-0\"><ui-gmap-google-map center=localisationctrl.map.center zoom=::localisationctrl.map.zoom pan=true control=localisationctrl.map.controller events=::localisationctrl.map.events><ui-gmap-map-control template=map-control-localisation-btn-template.html position=top-right ng-if=\"!localisationctrl.paramsGestion || (localisationctrl.paramsGestion && !localisationctrl.paramsGestion.adresse)\"></ui-gmap-map-control><ui-gmap-marker ng-if=localisationctrl.lot.adresse.hasCoords() idkey=0 coords=localisationctrl.lot.adresse options=localisationctrl.map.marker.options></ui-gmap-marker></ui-gmap-google-map></div></div></div><script type=text/ng-template id=map-control-localisation-btn-template.html><button type=\"button\" class=\"btn-map-control\" ng-class=\"{\r\n		        \'btn-success\' : !$parent.$parent.$parent.localisationctrl.manualLocalisation.active,\r\n		        \'btn-danger\' : $parent.$parent.$parent.localisationctrl.manualLocalisation.active\r\n	        }\" ng-click=\"$parent.$parent.$parent.localisationctrl.manualLocalisation.toggle()\">\r\n    <i class=\"fa fa-fw fa-lg\" ng-class=\"{\r\n		        \'fa-hand-pointer-o\' : !$parent.$parent.$parent.localisationctrl.manualLocalisation.active,\r\n		        \'fa-ban\' : $parent.$parent.$parent.localisationctrl.manualLocalisation.active\r\n	        }\"></i>\r\n    <span class=\"hidden-xs\">G&eacute;olocaliser manuellement</span>\r\n  </button></script>");
$templateCache.put("app/components/main-content/modif-bien/lot/piece/piece.html","<div class=piece><uib-accordion close-others=false><div uib-accordion-group is-open=piecectrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': piecectrl.isOpen, \'fa-plus\': !piecectrl.isOpen}\"></i> Par pi&egrave;ce</uib-accordion-heading><div class=\"col-xs-12 form-group spacer-top\"><div ng-repeat=\"p in piecectrl.parEtage\" class=itemetage><div class=\"col-xs-12 titreEtage\" ng-if=\"piecectrl.parEtage.length > 1\"><i class=\"fa fa-building\"></i>&nbsp;{{p.libelleEtage}}</div><div ng-repeat=\"piece in p.pieces\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><div class=\"row itempiece\"><div class=\"col-xs-12 titrePiece\"><i class=\"fa fa-cube\"></i>&nbsp;{{piece.type.label}} de {{piece.surface}} m&sup2 <span class=titre-details>({{piece.longueur}}m x {{piece.largeur}}m)</span></div><div class=\"col-xs-12 commentairePiece\">{{piece.description}}</div><div class=\"col-xs-12 text-right btn-piece\"><i class=\"fa fa-pencil-square-o\" ng-click=piecectrl.modifierPiece(piece)></i> <i class=\"fa fa-trash-o text-danger\" ng-click=piecectrl.deletePiece(piece)></i></div></div></div></div></div></div><div class=\"col-xs-12 spacer-top\"><form class=form-horizontal name=ajoutpiece ng-submit=piecectrl.addPiece(ajoutpiece) novalidate><div class=\"form-group row\"><label for=typelab class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Type</label><div class=\"col-xs-12 col-sm-8 col-md-3 spacer-bottom\"><ui-select ng-model=piecectrl.ajout.type id=typelab theme=bootstrap required><ui-select-match placeholder=Type>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type in piecectrl.types.liste | filter: $select.search track by type.data\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"visible-sm clearfix\"></div><label for=etage class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Etage</label><div class=\"col-xs-12 col-sm-8 col-md-3 spacer-bottom\"><input custom-type=number id=etage class=form-control ng-model=piecectrl.ajout.etage required></div></div><div class=\"form-group row\"><label class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Surface</label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><div class=input-group><input custom-type=number id=surface placeholder=Surface class=\"form-control border-rounded\" ng-model=piecectrl.ajout.surface><div class=\"input-group-addon no-border\">=</div><input custom-type=number id=longueur placeholder=Longueur class=\"form-control border-rounded\" ng-model=piecectrl.ajout.longueur ng-blur=piecectrl.calculSurface()><div class=\"input-group-addon no-border\">*</div><input custom-type=number id=largeur placeholder=Largeur class=\"form-control border-rounded\" ng-model=piecectrl.ajout.largeur ng-blur=piecectrl.calculSurface()></div></div></div><div class=\"form-group row\"><label for=description class=\"col-xs-12 col-sm-2 col-md-2 control-label no-padding-left\">Descriptions</label><div class=\"col-xs-12 col-sm-8 col-md-8 spacer-bottom\"><textarea class=form-control id=description rows=5 ng-model=piecectrl.ajout.description></textarea></div><div class=col-xs-12><button class=\"btn-custom btn-custom-primary pull-right\" type=submit ng-bind=\"(piecectrl.modification)?\'Valider\':\'Ajouter\'\"></button></div></div></form></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/tantieme/tantieme.html","<div class=tantieme><uib-accordion close-others=false><div uib-accordion-group is-open=tantiemectrl.isOpen><uib-accordion-heading><i class=\"fa fa-fw\" ng-class=\"{\'fa-minus\': tantiemectrl.isOpen, \'fa-plus\': !tantiemectrl.isOpen}\"></i> Tantieme</uib-accordion-heading><div class=\"col-xs-12 form-group spacer-top\"><div class=row><div class=\"col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><button type=button class=\"btn-custom btn-custom-primary btn-custom-block\" ng-click=tantiemectrl.addTantieme()><i class=\"fa fa-fw fa-plus\"></i> Ajouter</button></div></div><div ng-repeat=\"t in tantiemectrl.tantiemesLot\"><div class=\"col-xs-12 col-md-6 col-xl-4\"><div class=\"row itemTantieme\"><div class=\"col-xs-12 text-Left titreTantieme\">Lot:</div><div class=\"col-xs-12 text-Left commentaireTantieme\"><tantieme-lot tantieme-lot=t></div><div class=\"col-xs-12 text-right btn-tantieme\"><i class=\"fa fa-2x fa-trash-o text-danger\" ng-click=tantiemectrl.deleteTantieme(t)></i></div></div></div></div></div></div></uib-accordion></div>");
$templateCache.put("app/components/main-content/panneaux/bloc-panneau/templates/grid-blocpanneau-template.html","<div class=panneau-grid ng-style=\"{\'height\': blocpanneauctrl.blocHeight + \'px\'}\"><div class=panneau-text ng-bind-html=blocpanneauctrl.texts.panneau ng-class=\"{\r\n         \'impossible\': blocpanneauctrl.hasPanneau === null,\r\n         \'aucun\': blocpanneauctrl.hasPanneau === false || blocpanneauctrl.hasPanneau === \'retire\'\r\n       }\"></div><div class=panneau-img on-ready=blocpanneauctrl.imgReady ng-style=\"::{\r\n		     \'background\': \'url(\' + blocpanneauctrl.imgSrc + \') center no-repeat\',\r\n		     \'background-size\': \'cover\'\r\n	     }\"><span class=panneau-prix ng-if=::blocpanneauctrl.panneau.hasPrix()>{{::blocpanneauctrl.panneau.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocpanneauctrl.panneau.mandatLocation><small>TCC</small></sup></span></div><div class=\"panneau-infos flex-container col-xs-12\"><div class=\"panneau-title row\"><h4>{{::blocpanneauctrl.panneau.getTitle()}}</h4><a class=\"btn-hr btn-voir center-block\" ng-click=::blocpanneauctrl.showFiche()><i class=\"fa fa-fw fa-eye\"></i></a></div><div class=\"panneau-additional-details flex-item row\"><div class=\"col-xs-12 panneau-localisation\" ng-if=\"::(blocpanneauctrl.panneau.adresse.hasCp() || blocpanneauctrl.panneau.adresse.hasVille())\"><span class=localisation><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocpanneauctrl.panneau.adresse.hasCp()>{{::blocpanneauctrl.panneau.adresse.cp}} </span><span class=localisation-ville ng-if=::blocpanneauctrl.panneau.adresse.hasVille()>{{::blocpanneauctrl.panneau.adresse.ville}}</span></span></div></div><ul class=\"panneau-details list-unstyled list-inline row\"><li class=\"panneau-detail detail-ref flex-item\"><small class=panneau-ref>Ref : <span class=ref title={{::blocpanneauctrl.panneau.referenceInterne}}>{{::blocpanneauctrl.panneau.referenceInterne}}</span></small></li><li class=\"panneau-detail set-panneau\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-action btn-panneau-success\" uib-dropdown-toggle><i class=\"fa fa-fw fa-check\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendre\')\">{{blocpanneauctrl.texts.vendre}}</button></li><li role=menuitem class=custom-block><button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendu\')\">{{blocpanneauctrl.texts.vendu}}</button></li></ul></div></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-warning\" ng-disabled=\"blocpanneauctrl.hasPanneau === false\" ng-click=\"::blocpanneauctrl.setPanneau(\'aucun\')\"><i class=\"fa fa-fw fa-times\"></i></button></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-danger\" ng-disabled=\"blocpanneauctrl.hasPanneau === null\" ng-click=\"::blocpanneauctrl.setPanneau(\'impossible\')\"><i class=\"fa fa-fw fa-ban\"></i></button></li></ul></div></div>");
$templateCache.put("app/components/main-content/panneaux/bloc-panneau/templates/list-blocpanneau-template.html","<div class=panneau-list ng-style=\"{\'height\': blocpanneauctrl.blocHeight + \'px\'}\"><div class=panneau-text ng-bind-html=blocpanneauctrl.texts.panneau ng-class=\"{\r\n         \'impossible\': blocpanneauctrl.hasPanneau === null,\r\n         \'aucun\': blocpanneauctrl.hasPanneau === false || blocpanneauctrl.hasPanneau === \'retire\'\r\n       }\"></div><div class=\"panneau-img col-xs-4 col-md-3 col-lg-4\" on-ready=blocpanneauctrl.imgReady ng-style=\"::{\r\n		     \'background\': \'url(\' + blocpanneauctrl.imgSrc + \') center no-repeat\',\r\n		     \'background-size\': \'cover\'\r\n	     }\"><span class=panneau-prix ng-if=::blocpanneauctrl.panneau.hasPrix()>{{::blocpanneauctrl.panneau.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocpanneauctrl.panneau.mandatLocation><small>TCC</small></sup></span></div><div class=\"panneau-infos flex-container col-xs-8 col-md-9 col-lg-8\"><a class=\"btn-hr btn-voir center-block\" ng-click=::blocpanneauctrl.showFiche()><i class=\"fa fa-fw fa-eye\"></i></a><div class=\"panneau-title row\"><h4>{{::blocpanneauctrl.panneau.getTitle()}}</h4></div><div class=\"panneau-additional-details flex-item row\"><div class=\"col-xs-12 panneau-localisation\"><p class=\"description hidden-xs\" ng-bind-html=::blocpanneauctrl.panneau.description></p><span class=localisation ng-if=\"::(blocpanneauctrl.panneau.adresse.hasCp() || blocpanneauctrl.panneau.adresse.hasVille())\"><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocpanneauctrl.panneau.adresse.hasCp()>{{::blocpanneauctrl.panneau.adresse.cp}} </span><span class=localisation-ville ng-if=::blocpanneauctrl.panneau.adresse.hasVille()>{{::blocpanneauctrl.panneau.adresse.ville}}</span></span></div></div><ul class=\"panneau-details list-unstyled list-inline row\"><li class=\"panneau-detail detail-ref flex-item\"><small class=panneau-ref>Ref : <span class=ref title={{::blocpanneauctrl.panneau.referenceInterne}}>{{::blocpanneauctrl.panneau.referenceInterne}}</span></small></li><li class=\"panneau-detail set-panneau\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-action btn-panneau-success\" uib-dropdown-toggle><i class=\"fa fa-fw fa-check\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendre\')\">{{blocpanneauctrl.texts.vendre}}</button></li><li role=menuitem class=custom-block><button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendu\')\">{{blocpanneauctrl.texts.vendu}}</button></li></ul></div></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-warning\" ng-disabled=\"blocpanneauctrl.hasPanneau === false\" ng-click=\"::blocpanneauctrl.setPanneau(\'aucun\')\"><i class=\"fa fa-fw fa-times\"></i></button></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-danger\" ng-disabled=\"blocpanneauctrl.hasPanneau === null\" ng-click=\"::blocpanneauctrl.setPanneau(\'impossible\')\"><i class=\"fa fa-fw fa-ban\"></i></button></li></ul></div></div>");
$templateCache.put("app/components/main-content/panneaux/bloc-panneau/templates/listNoPhotos-blocpanneau-template.html","<div class=panneau-list-no-photo><div class=panneau-text ng-bind-html=blocpanneauctrl.texts.panneau ng-class=\"{\r\n         \'impossible\': blocpanneauctrl.hasPanneau === null,\r\n         \'aucun\': blocpanneauctrl.hasPanneau === false || blocpanneauctrl.hasPanneau === \'retire\'\r\n       }\"></div><div class=\"panneau-infos flex-container col-xs-12\"><a class=\"btn-hr btn-voir center-block\" ng-click=::blocpanneauctrl.showFiche()><i class=\"fa fa-fw fa-eye\"></i></a><div class=\"panneau-title row\"><h4>{{::blocpanneauctrl.panneau.getTitle()}}</h4></div><div class=\"panneau-additional-details flex-item row\"><div class=\"col-xs-12 panneau-ref\"><small>Ref : <span class=ref>{{::blocpanneauctrl.panneau.referenceInterne}}</span></small></div><div class=\"col-xs-12 panneau-localisation\"><span ng-if=\"::(blocpanneauctrl.panneau.adresse.hasCp() || blocpanneauctrl.panneau.adresse.hasVille())\" class=\"localisation hidden-xxs\"><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocpanneauctrl.panneau.adresse.hasCp()>{{::blocpanneauctrl.panneau.adresse.cp}} </span><span class=localisation-ville ng-if=::blocpanneauctrl.panneau.adresse.hasVille()>{{::blocpanneauctrl.panneau.adresse.ville}}</span></span></div></div><ul class=\"panneau-details list-unstyled list-inline row\"><li class=\"panneau-detail detail-prix flex-item\"><span class=prix ng-if=::blocpanneauctrl.panneau.hasPrix()>{{::blocpanneauctrl.panneau.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocpanneauctrl.panneau.mandatLocation><small>TCC</small></sup></span></li><li class=\"panneau-detail set-panneau\"><div class=\"btn-group controls-action\" uib-dropdown><span class=\"dropdown btn-action btn-panneau-success\" uib-dropdown-toggle><i class=\"fa fa-fw fa-check\"></i></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendre\')\">{{blocpanneauctrl.texts.vendre}}</button></li><li role=menuitem class=custom-block><button type=button class=controls-action-btn ng-click=\"::blocpanneauctrl.setPanneau(\'vendu\')\">{{blocpanneauctrl.texts.vendu}}</button></li></ul></div></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-warning\" ng-disabled=\"blocpanneauctrl.hasPanneau === false\" ng-click=\"::blocpanneauctrl.setPanneau(\'aucun\')\"><i class=\"fa fa-fw fa-times\"></i></button></li><li class=\"panneau-detail set-panneau\"><button type=button class=\"btn-action btn-panneau-danger\" ng-disabled=\"blocpanneauctrl.hasPanneau === null\" ng-click=\"::blocpanneauctrl.setPanneau(\'impossible\')\"><i class=\"fa fa-fw fa-ban\"></i></button></li></ul></div></div>");
$templateCache.put("app/components/main-content/parutions-ics-box/bloc-parution/templates/grid-blocparution-template.html","<div class=parution-grid ng-style=\"{\'height\': blocparutionctrl.blocHeight + \'px\'}\"><div class=parution-img on-ready=blocparutionctrl.imgReady ng-style=\"::{\r\n		     \'background\': \'url(\' + blocparutionctrl.imgSrc + \') center no-repeat\',\r\n		     \'background-size\': \'cover\'\r\n	     }\"><span class=parution-prix ng-if=::blocparutionctrl.parution.lot.hasPrix()>{{::blocparutionctrl.parution.lot.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocparutionctrl.parution.lot.mandatLocation><small>TCC</small></sup></span></div><div class=\"parution-infos col-xs-12 no-padding\"><div class=\"col-xs-11 flex-container\"><div class=\"parution-title row\"><h4>{{::blocparutionctrl.parution.lot.getTitle()}}</h4><a class=\"btn-hr btn-voir center-block\" ng-click=::blocparutionctrl.showFiche() tooltip-placement=\"auto top\" uib-tooltip=\"Voir la fiche\"><i class=\"fa fa-fw fa-eye\"></i></a></div><div class=\"parution-additional-details flex-item row\"><div class=\"col-xs-12 parution-localisation\" ng-if=\"::(blocparutionctrl.parution.lot.adresse.hasCp() || blocparutionctrl.parution.lot.adresse.hasVille())\"><span class=localisation><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocparutionctrl.parution.lot.adresse.hasCp()>{{::blocparutionctrl.parution.lot.adresse.cp}} </span><span class=localisation-ville ng-if=::blocparutionctrl.parution.lot.adresse.hasVille()>{{::blocparutionctrl.parution.lot.adresse.ville}}</span></span></div></div><ul class=\"parution-details list-unstyled list-inline row\"><li class=\"parution-detail detail-ref flex-item\"><small class=parution-ref>Ref : <span class=ref title={{::blocparutionctrl.parution.lot.referenceInterne}}>{{::blocparutionctrl.parution.lot.referenceInterne}}</span></small></li></ul></div><div class=\"parution-status col-xs-1 no-padding\" ng-class=\"{\r\n      \'parution-active\': blocparutionctrl.parution.actif,\r\n      \'parution-inactive\': !blocparutionctrl.parution.actif\r\n    }\"><button type=button ng-if=blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'supprimer\')\"><i class=\"fa fa-2x fa-check-circle-o\"></i></button> <button type=button ng-if=!blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'ajouter\')\"><i class=\"fa fa-2x fa-times-circle-o\"></i></button></div></div></div>");
$templateCache.put("app/components/main-content/parutions-ics-box/bloc-parution/templates/list-blocparution-template.html","<div class=parution-list ng-style=\"{\'height\': blocparutionctrl.blocHeight + \'px\'}\"><div class=\"parution-img col-xs-4 col-md-3 col-lg-4\" on-ready=blocparutionctrl.imgReady ng-style=\"::{\r\n		     \'background\': \'url(\' + blocparutionctrl.imgSrc + \') center no-repeat\',\r\n		     \'background-size\': \'cover\'\r\n	     }\"><span class=parution-prix ng-if=::blocparutionctrl.parution.lot.hasPrix()>{{::blocparutionctrl.parution.lot.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocparutionctrl.parution.lot.mandatLocation><small>TCC</small></sup></span></div><div class=\"parution-infos flex-container col-xs-7 col-md-8 col-lg-7\"><a class=\"btn-hr btn-voir center-block\" ng-click=::blocparutionctrl.showFiche() tooltip-placement=\"auto top\" uib-tooltip=\"Voir la fiche\"><i class=\"fa fa-fw fa-eye\"></i></a><div class=\"parution-title row\"><h4>{{::blocparutionctrl.parution.lot.getTitle()}}</h4></div><div class=\"parution-additional-details flex-item row\"><div class=\"col-xs-12 parution-localisation\"><p class=\"description hidden-xs\" ng-bind-html=::blocparutionctrl.parution.lot.description></p><span class=localisation ng-if=\"::(blocparutionctrl.parution.lot.adresse.hasCp() || blocparutionctrl.parution.lot.adresse.hasVille())\"><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocparutionctrl.parution.lot.adresse.hasCp()>{{::blocparutionctrl.parution.lot.adresse.cp}} </span><span class=localisation-ville ng-if=::blocparutionctrl.parution.lot.adresse.hasVille()>{{::blocparutionctrl.parution.lot.adresse.ville}}</span></span></div></div><ul class=\"parution-details list-unstyled list-inline row\"><li class=\"parution-detail detail-ref flex-item\"><small class=parution-ref>Ref : <span class=ref title={{::blocparutionctrl.parution.lot.referenceInterne}}>{{::blocparutionctrl.parution.lot.referenceInterne}}</span></small></li></ul></div><div class=\"parution-status col-xs-1 no-padding\" ng-class=\"{\r\n    \'parution-active\': blocparutionctrl.parution.actif,\r\n    \'parution-inactive\': !blocparutionctrl.parution.actif\r\n  }\"><button type=button ng-if=blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'supprimer\')\"><i class=\"fa fa-2x fa-check-circle-o\"></i></button> <button type=button ng-if=!blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'ajouter\')\"><i class=\"fa fa-2x fa-times-circle-o\"></i></button></div></div>");
$templateCache.put("app/components/main-content/parutions-ics-box/bloc-parution/templates/listNoPhotos-blocparution-template.html","<div class=parution-list-no-photo><div class=\"parution-infos flex-container col-xs-11\"><a class=\"btn-hr btn-voir center-block\" ng-click=::blocparutionctrl.showFiche()><i class=\"fa fa-fw fa-eye\"></i></a><div class=\"parution-title row\"><h4>{{::blocparutionctrl.parution.lot.getTitle()}}</h4></div><div class=\"parution-additional-details flex-item row\"><div class=\"col-xs-12 parution-ref\"><small>Ref : <span class=ref>{{::blocparutionctrl.parution.lot.referenceInterne}}</span></small></div><div class=\"col-xs-12 parution-localisation\"><span ng-if=\"::(blocparutionctrl.parution.lot.adresse.hasCp() || blocparutionctrl.parution.lot.adresse.hasVille())\" class=\"localisation hidden-xxs\"><i class=\"fa fa-fw fa-2r fa-map-marker\"></i> <span class=localisation-cp ng-if=::blocparutionctrl.parution.lot.adresse.hasCp()>{{::blocparutionctrl.parution.lot.adresse.cp}} </span><span class=localisation-ville ng-if=::blocparutionctrl.parution.lot.adresse.hasVille()>{{::blocparutionctrl.parution.lot.adresse.ville}}</span></span></div></div><ul class=\"parution-details list-unstyled list-inline row\"><li class=\"parution-detail detail-prix flex-item\"><span class=prix ng-if=::blocparutionctrl.parution.lot.hasPrix()>{{::blocparutionctrl.parution.lot.getPrix() | tgnFormat: \'integer\'}} &euro; <sup ng-if=blocparutionctrl.parution.lot.mandatLocation><small>TCC</small></sup></span></li></ul></div><div class=\"parution-status col-xs-1 no-padding\" ng-class=\"{\r\n      \'parution-active\': blocparutionctrl.parution.actif,\r\n      \'parution-inactive\': !blocparutionctrl.parution.actif\r\n    }\"><button type=button ng-if=blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'supprimer\')\"><i class=\"fa fa-2x fa-check-circle-o\"></i></button> <button type=button ng-if=!blocparutionctrl.parution.actif class=btn-action ng-click=\"::blocparutionctrl.setParution(\'ajouter\')\"><i class=\"fa fa-2x fa-times-circle-o\"></i></button></div></div>");
$templateCache.put("app/components/main-content/modif-bien/lot/tantieme/tantiemeLot/tantiemeLot.html","<div class=\"tantiemeLot col-xs-12\"><form class=form-horizontal name=tantiemelot novalidate><div class=\"form-group row\"><label for=numeroLot class=\"col-xs-4 control-label no-padding-left\">Num. Lot</label><div class=\"col-xs-8 spacer-bottom\"><input id=numeroLot class=form-control ng-model=tantiemelotctrl.tantiemeLot.numeroLot required></div><label for=tantiemeCommun class=\"col-xs-4 control-label no-padding-left\">Tantieme</label><div class=\"col-xs-3 spacer-bottom\"><input custom-type=number id=tantiemeCommun class=form-control ng-model=tantiemelotctrl.tantiemeLot.tantiemeCommun></div><label for=tantiemeCommunTotal class=\"col-xs-1 control-label no-padding-left\">/</label><div class=\"col-xs-4 spacer-bottom\"><input id=tantiemeCommunTotal class=form-control ng-model=tantiemelotctrl.tantiemeLot.tantiemeCommunTotal></div><label for=designation class=col-xs-12>Description</label><div class=\"col-xs-12 spacer-bottom\"><textarea class=form-control id=pub name=pub ng-model=tantiemelotctrl.tantiemeLot.designation rows=5></textarea></div></div><div class=\"form-group row\"><label class=\"col-xs-4 col-sm-2 col-md-2 control-label no-padding-left\">Batiment</label><div class=\"col-xs-8 col-sm-10 col-md-10 spacer-bottom\"><input id=batiment placeholder=batiment class=form-control ng-model=tantiemelotctrl.ajout.batiment></div><label class=\"col-xs-4 col-sm-2 col-md-2 control-label no-padding-left\">Tantieme</label><div class=\"col-xs-4 col-sm-4 col-md-4 spacer-bottom\"><input custom-type=number id=tantiemeBatiment placeholder=Tantieme class=\"form-control border-rounded\" ng-model=tantiemelotctrl.ajout.tantiemeBatiment></div><label class=\"col-xs-1 col-sm-1 col-md-1 control-label no-padding-left\">/</label><div class=\"col-xs-4 col-sm-4 col-md-4 spacer-bottom\"><input custom-type=number id=tantiemeBatimentTotal placeholder=Total class=\"form-control border-rounded\" ng-model=tantiemelotctrl.ajout.tantiemeBatimentTotal></div><div class=\"col-xs-1 col-sm-1 col-md-1 spacer-bottom\"><button type=button class=\"btn-custom btn-custom-sm btn-success btn-add-contact\" ng-disabled=!tantiemelotctrl.ajout.batiment ng-click=tantiemelotctrl.addTantiemeBat()><i class=\"fa fa-plus\"></i></button></div></div><div class=\"row titreTantiemeBat\"><div class=col-xs-5><label>Batiment</label></div><div class=col-xs-6><label>Tantieme</label></div><div class=col-xs-1></div></div><div class=\"row ligneTantiemeBat\" ng-repeat=\"tantiemeBat in tantiemelotctrl.batiments\"><div class=col-xs-5><label>{{tantiemeBat.batiment}}</label></div><div class=col-xs-6><label>{{tantiemeBat.tantiemeBatiment}} / {{tantiemeBat.tantiemeBatimentTotal}}ieme</label></div><div class=col-xs-1><i class=\"fa fa-trash-o text-danger\" ng-click=tantiemelotctrl.deleteTantiemeBat(tantiemeBat)></i></div></div></form></div>");}]);